import { Tool } from "react-feather";
import { IconItem } from "./IconGrid";
import {
  faBug,
  faChartPie,
  faClipboardQuestion,
  faCloud,
  faCodeBranch,
  faCubes,
  faDatabase,
  faHandshakeAngle,
  faInfinity,
  faLaptopCode,
  faLaptopHouse,
  faLayerGroup,
  faMagnifyingGlassChart,
  faMailBulk,
  faMap,
  faNetworkWired,
  faOtter,
  faPenNib,
  faPeopleArrows,
  faPeopleGroup,
  faPersonCircleQuestion,
  faRainbow,
  faServer,
  faShieldHalved,
  faSitemap,
  faTree,
  faUsersViewfinder,
  faWandMagicSparkles,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import {
  faComments,
  faFileLines,
  faHandshake,
  faObjectUngroup,
  faRectangleList,
  faStickyNote,
} from "@fortawesome/free-regular-svg-icons";

export const JavaIcon = () => {
  return (
    <svg viewBox="0 0 128 128" aria-labelledby="java-icon-title">
      <title id="java-icon-title">Java Icon</title>
      <path
        fill="#0074BD"
        d="M47.617 98.12s-4.767 2.774 3.397 3.71c9.892 1.13 14.947.968 25.845-1.092 0 0 2.871 1.795 6.873 3.351-24.439 10.47-55.308-.607-36.115-5.969zm-2.988-13.665s-5.348 3.959 2.823 4.805c10.567 1.091 18.91 1.18 33.354-1.6 0 0 1.993 2.025 5.132 3.131-29.542 8.64-62.446.68-41.309-6.336z"
      />
      <path
        fill="#EA2D2E"
        d="M69.802 61.271c6.025 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.792 15.635-29.58 0 .001-42.731 10.67-22.324 34.187z"
      />
      <path
        fill="#0074BD"
        d="M102.123 108.229s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.094.171-4.451-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.953-3.487-32.013 6.85-13.743 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM49.912 70.294s-22.686 5.389-8.033 7.348c6.188.828 18.518.638 30.011-.326 9.39-.789 18.813-2.474 18.813-2.474s-3.308 1.419-5.704 3.053c-23.042 6.061-67.544 3.238-54.731-2.958 10.832-5.239 19.644-4.643 19.644-4.643zm40.697 22.747c23.421-12.167 12.591-23.86 5.032-22.285-1.848.385-2.677.72-2.677.72s.688-1.079 2-1.543c14.953-5.255 26.451 15.503-4.823 23.725 0-.002.359-.327.468-.617z"
      />
      <path
        fill="#EA2D2E"
        d="M76.491 1.587S89.459 14.563 64.188 34.51c-20.266 16.006-4.621 25.13-.007 35.559-11.831-10.673-20.509-20.07-14.688-28.815C58.041 28.42 81.722 22.195 76.491 1.587z"
      />
      <path
        fill="#0074BD"
        d="M52.214 126.021c22.476 1.437 57-.8 57.817-11.436 0 0-1.571 4.032-18.577 7.231-19.186 3.612-42.854 3.191-56.887.874 0 .001 2.875 2.381 17.647 3.331z"
      />
    </svg>
  );
};

export const DockerIcon = () => {
  return (
    <svg viewBox="0 0 128 128" aria-labelledby="docker-icon-title">
      <title id="docker-icon-title">Docker Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A4D54"
        d="M73.8 50.8h11.3v11.5h5.7c2.6 0 5.3-.5 7.8-1.3 1.2-.4 2.6-1 3.8-1.7-1.6-2.1-2.4-4.7-2.6-7.3-.3-3.5.4-8.1 2.8-10.8l1.2-1.4 1.4 1.1c3.6 2.9 6.5 6.8 7.1 11.4 4.3-1.3 9.3-1 13.1 1.2l1.5.9-.8 1.6c-3.2 6.2-9.9 8.2-16.4 7.8-9.8 24.3-31 35.8-56.8 35.8-13.3 0-25.5-5-32.5-16.8l-.1-.2-1-2.1c-2.4-5.2-3.1-10.9-2.6-16.6l.2-1.7h9.6V50.8h11.3V39.6h22.5V28.3h13.5v22.5z"
      ></path>
      <path
        fill="#00AADA"
        d="M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7H18.6c-.6 6.2.5 11.9 3 16.8l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5 1.1-8.3 1.3h-.6c-1.3.1-2.7.1-4.2.1-1.6 0-3.1 0-4.9-.1 6 6.8 15.4 10.8 27.2 10.8 25 0 46.2-11.1 55.5-35.9 6.7.7 13.1-1 16-6.7-4.5-2.7-10.5-1.8-13.9-.1z"
      ></path>
      <path
        fill="#28B8EB"
        d="M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7h-68c-.3 9.5 3.2 16.7 9.5 21 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4l-.1-.1c8.5 4.4 20.8 4.3 35-1.1 15.8-6.1 30.6-17.7 40.9-30.9-.2.1-.4.1-.5.2z"
      ></path>
      <path
        fill="#028BB8"
        d="M18.7 71.8c.4 3.3 1.4 6.4 2.9 9.3l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4h-.4c-1.3.1-2.7.1-4.1.1-1.6 0-3.2 0-4.9-.1 6 6.8 15.5 10.8 27.3 10.8 21.4 0 40-8.1 50.8-26H18.7v-.1z"
      ></path>
      <path
        fill="#019BC6"
        d="M23.5 71.8c1.3 5.8 4.3 10.4 8.8 13.5 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.6 1.4 8.5 4.4 20.8 4.3 34.9-1.1 8.5-3.3 16.8-8.2 24.2-14.1H23.5z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00ACD3"
        d="M28.4 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3-12h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#23C2EE"
        d="M39.6 52.7h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00ACD3"
        d="M50.9 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#23C2EE"
        d="M50.9 41.5h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3.1 10.4H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00ACD3"
        d="M62.2 41.5H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#23C2EE"
        d="M62.2 30.2H72V40h-9.8v-9.8zm.8.8h.8v8.1H63V31zm1.5 0h.8v8.1h-.8V31zm1.4 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00ACD3"
        d="M73.5 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#D4EEF1"
        d="M48.8 78.3c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3A4D54"
        d="M48.8 79.1c.2 0 .5 0 .7.1-.2.1-.4.4-.4.7 0 .4.4.8.8.8.3 0 .6-.2.7-.4.1.2.1.5.1.7 0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1 .8-1.9 1.9-1.9M1.1 72.8h125.4c-2.7-.7-8.6-1.6-7.7-5.2-5 5.7-16.9 4-20 1.2-3.4 4.9-23 3-24.3-.8-4.2 5-17.3 5-21.5 0-1.4 3.8-21 5.7-24.3.8-3 2.8-15 4.5-20-1.2 1.1 3.5-4.9 4.5-7.6 5.2"
      ></path>
      <path
        fill="#BFDBE0"
        d="M56 97.8c-6.7-3.2-10.3-7.5-12.4-12.2-2.5.7-5.5 1.2-8.9 1.4-1.3.1-2.7.1-4.1.1-1.7 0-3.4 0-5.2-.1 6 6 13.6 10.7 27.5 10.8H56z"
      ></path>
      <path
        fill="#D4EEF1"
        d="M46.1 89.9c-.9-1.3-1.8-2.8-2.5-4.3-2.5.7-5.5 1.2-8.9 1.4 2.3 1.2 5.7 2.4 11.4 2.9z"
      ></path>
    </svg>
  );
};

export const JSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path fill="#F0DB4F" d="M1.408 1.408h125.184v125.185H1.408z"></path>
      <path
        fill="#323330"
        d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
      ></path>
    </svg>
  );
};

export const TSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path fill="#fff" d="M22.67 47h99.67v73.67H22.67z"></path>
      <path
        data-name="original"
        fill="#007acc"
        d="M1.5 63.91v62.5h125v-125H1.5zm100.73-5a15.56 15.56 0 017.82 4.5 20.58 20.58 0 013 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a7.09 7.09 0 00-5.87-3.53c-3.79-.26-6.23 1.73-6.21 5a4.58 4.58 0 00.54 2.34c.83 1.73 2.38 2.76 7.24 4.86 8.95 3.85 12.78 6.39 15.16 10 2.66 4 3.25 10.46 1.45 15.24-2 5.2-6.9 8.73-13.83 9.9a38.32 38.32 0 01-9.52-.1 23 23 0 01-12.72-6.63c-1.15-1.27-3.39-4.58-3.25-4.82a9.34 9.34 0 011.15-.73L82 101l3.59-2.08.75 1.11a16.78 16.78 0 004.74 4.54c4 2.1 9.46 1.81 12.16-.62a5.43 5.43 0 00.69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48 16.48 0 01-3.43-6.25 25 25 0 01-.22-8c1.33-6.23 6-10.58 12.82-11.87a31.66 31.66 0 019.49.26zm-29.34 5.24v5.12H56.66v46.23H45.15V69.26H28.88v-5a49.19 49.19 0 01.12-5.17C29.08 59 39 59 51 59h21.83z"
      ></path>
    </svg>
  );
};

const SwiftIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#f05138"
        d="M126.33 34.06a39.32 39.32 0 00-.79-7.83 28.78 28.78 0 00-2.65-7.58 28.84 28.84 0 00-4.76-6.32 23.42 23.42 0 00-6.62-4.55 27.27 27.27 0 00-7.68-2.53c-2.65-.51-5.56-.51-8.21-.76H30.25a45.46 45.46 0 00-6.09.51 21.82 21.82 0 00-5.82 1.52c-.53.25-1.32.51-1.85.76a33.82 33.82 0 00-5 3.28c-.53.51-1.06.76-1.59 1.26a22.41 22.41 0 00-4.76 6.32 23.61 23.61 0 00-2.65 7.58 78.5 78.5 0 00-.79 7.83v60.39a39.32 39.32 0 00.79 7.83 28.78 28.78 0 002.65 7.58 28.84 28.84 0 004.76 6.32 23.42 23.42 0 006.62 4.55 27.27 27.27 0 007.68 2.53c2.65.51 5.56.51 8.21.76h63.22a45.08 45.08 0 008.21-.76 27.27 27.27 0 007.68-2.53 30.13 30.13 0 006.62-4.55 22.41 22.41 0 004.76-6.32 23.61 23.61 0 002.65-7.58 78.49 78.49 0 00.79-7.83V34.06z"
      ></path>
      <path
        fill="#fefefe"
        d="M85 96.5c-11.11 6.13-26.38 6.76-41.75.47A64.53 64.53 0 0113.84 73a50 50 0 0010.85 6.32c15.87 7.1 31.73 6.61 42.9 0-15.9-11.66-29.4-26.82-39.46-39.2a43.47 43.47 0 01-5.29-6.82c12.16 10.61 31.5 24 38.38 27.79a271.77 271.77 0 01-27-32.34 266.8 266.8 0 0044.47 34.87c.71.38 1.26.7 1.7 1a32.7 32.7 0 001.21-3.51c3.71-12.89-.53-27.54-9.79-39.67C93.25 33.81 106 57.05 100.66 76.51c-.14.53-.29 1-.45 1.55l.19.22c10.59 12.63 7.68 26 6.35 23.5C101 91 90.37 94.33 85 96.5z"
      ></path>
    </svg>
  );
};

const ObjCIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#0b5a9d">
        <path d="M63.877 125.392c-32.671 0-60.37-27.594-60.627-60.469a59.94 59.94 0 0117.506-42.759 60.939 60.939 0 0143.279-18.36 60.081 60.081 0 0142.647 17.71 60.145 60.145 0 0118.157 42.522c.151 33.604-26.864 61.021-60.469 61.363h-.493zm.19-118.406a57.774 57.774 0 00-41.01 17.427 56.775 56.775 0 00-16.63 40.484c.236 31.159 26.495 57.286 57.43 57.286h.414c31.863-.29 57.504-26.266 57.385-58.128a56.97 56.97 0 00-17.217-40.273A56.7 56.7 0 0064.068 6.986z"></path>
        <path d="M16.89 82.383V46.865h8.64v3.183h-4.583v29.218h4.584v3.183l-8.642-.066zM46.213 64.272c0 6.478-3.933 10.167-9.26 10.167s-8.877-4.156-8.877-9.831c0-5.939 3.722-10.121 9.167-10.121s8.97 4.36 8.97 9.785zm-14.415.29c0 3.932 1.973 7.05 5.36 7.05s5.333-3.183 5.333-7.195c0-3.643-1.796-7.083-5.334-7.083s-5.392 3.328-5.392 7.307l.033-.08zM49.205 55.158c1.69-.29 3.407-.434 5.123-.428a9.17 9.17 0 015.537 1.223 4.062 4.062 0 012.006 3.61 4.48 4.48 0 01-3.183 4.183c2.269.46 3.9 2.46 3.9 4.775a5.016 5.016 0 01-1.861 3.978c-1.368 1.21-3.643 1.796-7.162 1.796a33.966 33.966 0 01-4.327-.257l-.033-18.88zm3.499 7.622h1.795c2.433 0 3.801-1.145 3.801-2.782 0-1.638-1.368-2.644-3.61-2.644a9.779 9.779 0 00-2.006.145l.02 5.28zm0 8.878c.618.065 1.243.092 1.86.078 2.263 0 4.262-.861 4.262-3.182s-1.94-3.183-4.373-3.183h-1.75v6.287zM69.54 54.901h3.517v12.554c0 5.334-2.577 7.116-6.365 7.116a9.313 9.313 0 01-2.973-.507l.428-2.834c.703.224 1.44.335 2.183.349 2.006 0 3.183-.921 3.183-4.262l.026-12.416zM83.067 65.357v2.434h-7.32v-2.434h7.32zM100.158 73.63c-1.585.632-3.281.921-4.978.862-6.129 0-9.851-3.834-9.851-9.707-.283-5.353 3.827-9.923 9.18-10.206.375-.02.757-.02 1.131.006a11.112 11.112 0 014.775.862l-.783 2.801a9.476 9.476 0 00-3.788-.75c-3.932 0-6.76 2.467-6.76 7.116 0 4.235 2.499 6.971 6.734 6.971a9.806 9.806 0 003.834-.717l.506 2.762zM111.2 46.766v35.61h-8.641v-3.182h4.583V49.949h-4.583v-3.183h8.64z"></path>
      </g>
    </svg>
  );
};

const AngularIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#B3B3B3"
        d="M63.81 1.026L4.553 21.88l9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635z"
      ></path>
      <path
        fill="#A6120D"
        d="M117.536 25.998L63.672 7.629v112.785l45.141-24.983z"
      ></path>
      <path
        fill="#DD1B16"
        d="M11.201 26.329l8.026 69.434 44.444 24.651V7.627z"
      ></path>
      <path
        fill="#F2F2F2"
        d="M78.499 67.67l-14.827 6.934H48.044l-7.347 18.374-13.663.254 36.638-81.508L78.499 67.67zm-1.434-3.491L63.77 37.858 52.864 63.726h10.807l13.394.453z"
      ></path>
      <path
        fill="#B3B3B3"
        d="M63.671 11.724l.098 26.134 12.375 25.888H63.698l-.027 10.841 17.209.017 8.042 18.63 13.074.242z"
      ></path>
    </svg>
  );
};

const AndroidIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#fff"
        d="M21.012 91.125c-5.538.003-10.038-4.503-10.039-10.04l-.002-30.739c-.002-5.532 4.497-10.037 10.028-10.038 2.689-.002 5.207 1.041 7.105 2.937s2.942 4.418 2.944 7.099l-.003 30.74a9.924 9.924 0 01-2.931 7.094 9.962 9.962 0 01-7.102 2.947m-.008-48.12c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736a7.347 7.347 0 007.341 7.348 7.338 7.338 0 007.339-7.347V50.342a7.345 7.345 0 00-7.346-7.337"
      ></path>
      <path
        fill="#fff"
        d="M99.742 44.527l-2.698-.001-66.119.009-2.699.001-.002-2.699c-.006-11.08 6.03-21.385 15.917-27.473l-3.844-7.017c-.47-.822-.588-1.863-.314-2.815a3.732 3.732 0 011.814-2.239 3.605 3.605 0 011.759-.447c1.362 0 2.609.739 3.267 1.933l4.023 7.329a37.842 37.842 0 0113.099-2.305c4.606-.002 9.023.777 13.204 2.311l4.017-7.341a3.711 3.711 0 013.263-1.932 3.712 3.712 0 011.761.438A3.706 3.706 0 0188 4.524a3.69 3.69 0 01-.318 2.832l-3.842 7.013c9.871 6.101 15.9 16.398 15.899 27.459l.003 2.699zM80.196 15.403l5.123-9.355a1.019 1.019 0 10-1.783-.981l-5.176 9.45c-4.354-1.934-9.229-3.021-14.382-3.016-5.142-.005-10.008 1.078-14.349 3.005l-5.181-9.429a1.009 1.009 0 00-1.379-.405c-.497.266-.68.891-.403 1.379l5.125 9.348c-10.07 5.194-16.874 15.084-16.868 26.439l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427M48.94 29.86a2.772 2.772 0 01.003-5.545 2.78 2.78 0 012.775 2.774 2.775 2.775 0 01-2.778 2.771m30.107-.006a2.767 2.767 0 01-2.772-2.771 2.788 2.788 0 012.773-2.778 2.79 2.79 0 012.767 2.779 2.769 2.769 0 01-2.768 2.77m-27.336 96.305c-5.533-.001-10.036-4.501-10.037-10.038l-.002-13.567-2.638.003a10.453 10.453 0 01-7.448-3.082 10.437 10.437 0 01-3.083-7.452l-.01-47.627v-2.701h2.699l65.623-.01 2.7-.002v2.699l.007 47.633c.001 5.809-4.725 10.536-10.532 10.535l-2.654.002.003 13.562c0 5.534-4.502 10.039-10.033 10.039a9.933 9.933 0 01-7.098-2.937 9.952 9.952 0 01-2.947-7.096v-13.568H61.75v13.565c-.002 5.535-4.503 10.043-10.039 10.042"
      ></path>
      <path
        fill="#fff"
        d="M31.205 92.022a7.82 7.82 0 007.831 7.837h5.333l.006 16.264c-.001 4.05 3.289 7.341 7.335 7.342a7.342 7.342 0 007.338-7.348l.001-16.259 9.909-.003-.001 16.263c.004 4.051 3.298 7.346 7.343 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.353-.001c4.319.001 7.832-3.508 7.832-7.837l-.009-47.635-65.621.012.012 47.63zm75.791-.91c-5.536.001-10.039-4.498-10.038-10.036l-.008-30.738c.002-5.537 4.498-10.041 10.031-10.041 5.54-.001 10.046 4.502 10.045 10.038l.003 30.736c.001 5.534-4.498 10.042-10.033 10.041m-.01-48.116c-4.053-.004-7.337 3.287-7.337 7.342l.003 30.737a7.336 7.336 0 007.342 7.34 7.338 7.338 0 007.338-7.343l-.008-30.736a7.335 7.335 0 00-7.338-7.34"
      ></path>
      <path
        fill="#A4C439"
        d="M21.004 43.005c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736a7.338 7.338 0 007.342 7.343 7.33 7.33 0 007.338-7.342V50.342a7.345 7.345 0 00-7.346-7.337m59.192-27.602l5.123-9.355a1.023 1.023 0 00-.401-1.388 1.022 1.022 0 00-1.382.407l-5.175 9.453c-4.354-1.938-9.227-3.024-14.383-3.019-5.142-.005-10.013 1.078-14.349 3.005l-5.181-9.429a1.01 1.01 0 00-1.378-.406 1.007 1.007 0 00-.404 1.38l5.125 9.349c-10.07 5.193-16.874 15.083-16.868 26.438l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427M48.94 29.86a2.772 2.772 0 01.003-5.545 2.78 2.78 0 012.775 2.774 2.775 2.775 0 01-2.778 2.771m30.107-.006a2.77 2.77 0 01-2.772-2.771 2.793 2.793 0 012.773-2.778 2.79 2.79 0 012.767 2.779 2.767 2.767 0 01-2.768 2.77M31.193 44.392l.011 47.635a7.822 7.822 0 007.832 7.831l5.333.002.006 16.264c-.001 4.05 3.291 7.342 7.335 7.342 4.056 0 7.342-3.295 7.343-7.347l-.004-16.26 9.909-.003.004 16.263c0 4.047 3.293 7.346 7.338 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.352-.004a7.835 7.835 0 007.836-7.834l-.009-47.635-65.624.011zm83.134 5.943a7.338 7.338 0 00-7.341-7.339c-4.053-.004-7.337 3.287-7.337 7.342l.006 30.738a7.334 7.334 0 007.339 7.339 7.337 7.337 0 007.338-7.343l-.005-30.737z"
      ></path>
    </svg>
  );
};

const IOSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path d="M97.905 67.885c.174 18.8 16.494 25.057 16.674 25.137-.138.44-2.607 8.916-8.597 17.669-5.178 7.568-10.553 15.108-19.018 15.266-8.318.152-10.993-4.934-20.504-4.934-9.508 0-12.479 4.776-20.354 5.086-8.172.31-14.395-8.185-19.616-15.724C15.822 94.961 7.669 66.8 18.616 47.791c5.438-9.44 15.158-15.417 25.707-15.571 8.024-.153 15.598 5.398 20.503 5.398 4.902 0 14.106-6.676 23.782-5.696 4.051.169 15.421 1.636 22.722 12.324-.587.365-13.566 7.921-13.425 23.639M82.272 21.719c4.338-5.251 7.258-12.563 6.462-19.836-6.254.251-13.816 4.167-18.301 9.416-4.02 4.647-7.54 12.087-6.591 19.216 6.971.54 14.091-3.542 18.43-8.796"></path>
    </svg>
  );
};

const IOSIconLight = () => {
  return (
    <svg viewBox="0 0 128 128" fill="#fff">
      <path d="M97.905 67.885c.174 18.8 16.494 25.057 16.674 25.137-.138.44-2.607 8.916-8.597 17.669-5.178 7.568-10.553 15.108-19.018 15.266-8.318.152-10.993-4.934-20.504-4.934-9.508 0-12.479 4.776-20.354 5.086-8.172.31-14.395-8.185-19.616-15.724C15.822 94.961 7.669 66.8 18.616 47.791c5.438-9.44 15.158-15.417 25.707-15.571 8.024-.153 15.598 5.398 20.503 5.398 4.902 0 14.106-6.676 23.782-5.696 4.051.169 15.421 1.636 22.722 12.324-.587.365-13.566 7.921-13.425 23.639M82.272 21.719c4.338-5.251 7.258-12.563 6.462-19.836-6.254.251-13.816 4.167-18.301 9.416-4.02 4.647-7.54 12.087-6.591 19.216 6.971.54 14.091-3.542 18.43-8.796"></path>
    </svg>
  );
};

const ScalaIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M25 110.437V94.874h5.616c3.113 0 8.052-.203 11.03-.474l5.278-.406-7.038-1.894c-3.924-1.015-8.864-2.504-10.961-3.316L25 87.364V55.627h6.293c3.383 0 8.323-.203 10.894-.473l4.737-.406-8.323-2.233C34 51.366 29.128 49.809 27.639 49.2L25 47.982v-30.72l2.098-.473c1.15-.203 3.992-.406 6.293-.406 11.367 0 38.366-3.722 51.628-7.105 9.27-2.436 15.698-4.872 17.931-6.902 1.15-1.015 1.218-.406 1.218 14.548v15.63l-1.624 1.219-1.624 1.285 3.248 2.842v33.9l-1.624 1.218-1.624 1.286 3.248 2.842v33.9l-1.76 1.353c-1.894 1.489-9.202 3.993-17.524 6.09C71.892 121.737 40.157 126 29.33 126H25z"
        fill="#390d09"
      ></path>
      <g fill="#de3423">
        <path d="M25 110.572V95.077l11.842-.474c12.315-.473 21.45-1.488 34.847-3.789 15.225-2.639 30.246-7.375 31.803-10.082.406-.677.676 4.534.676 14.616v15.698l-1.76 1.353c-1.894 1.489-9.202 3.993-17.524 6.09C71.892 121.737 40.157 126 29.33 126H25zM25 71.327V55.83l11.842-.406c13.127-.541 23.344-1.691 36.877-4.195 15.157-2.842 28.96-7.443 29.976-9.947.203-.473.406 6.09.406 14.616.067 13.533-.068 15.698-1.083 16.78-2.368 2.64-20.638 7.376-39.449 10.286-11.435 1.76-30.381 3.79-35.66 3.79H25zM25 32.352V17.195l2.098-.406c1.15-.203 3.992-.406 6.293-.406 11.367 0 38.366-3.722 51.628-7.105 9.27-2.436 15.698-4.872 17.931-6.902 1.15-1.015 1.218-.406 1.218 14.48 0 14.548-.067 15.63-1.285 16.714-1.827 1.691-14.345 5.548-24.09 7.51-15.765 3.113-41.951 6.429-50.883 6.429H25z"></path>
      </g>
    </svg>
  );
};

const CSharpIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#9B4F96"
        d="M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z"
      ></path>
      <path
        fill="#68217A"
        d="M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z"
      ></path>
      <path
        fill="#fff"
        d="M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6zM97 66.2l.9-4.3h-4.2v-4.7h5.1L100 51h4.9l-1.2 6.1h3.8l1.2-6.1h4.8l-1.2 6.1h2.4v4.7h-3.3l-.9 4.3h4.2v4.7h-5.1l-1.2 6h-4.9l1.2-6h-3.8l-1.2 6h-4.8l1.2-6h-2.4v-4.7H97zm4.8 0h3.8l.9-4.3h-3.8l-.9 4.3z"
      ></path>
    </svg>
  );
};

const FSharpIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#378BBA"
        d="M0 64.5L60.7 3.8v30.4L30.4 64.5l30.4 30.4v30.4L0 64.5z"
      ></path>
      <path fill="#378BBA" d="M39.1 64.5l21.7-21.7v43.4L39.1 64.5z"></path>
      <path
        fill="#30B9DB"
        d="M128 64.5L65.1 3.8v30.4l30.4 30.4-30.4 30.3v30.4L128 64.5z"
      ></path>
    </svg>
  );
};

const DartIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#00c4b3"
        d="M35.2 34.9l-8.3-8.3v59.7l.1 2.8c0 1.3.2 2.8.7 4.3l65.6 23.1 16.3-7.2-74.4-74.4z"
      ></path>
      <path
        d="M27.7 93.4zm81.9 15.9l-16.3 7.2-65.4-23.1c1.3 4.8 4 10.1 7 13.2l21.3 21.2 47.6.1 5.8-18.6z"
        fill="#22d3c5"
      ></path>
      <path
        fill="#0075c9"
        d="M1.7 65.1C-.4 67.3.7 72 4 75.5l14.7 14.8 9.2 3.3c-.3-1.5-.7-3-.7-4.3l-.1-2.8-.2-59.8m82.7 82.6l7.2-16.4-23-65.6c-1.5-.3-3-.6-4.3-.7l-2.9-.1-59.6.1"
      ></path>
      <path
        d="M93.6 27.3c.2 0 .2 0 0 0 .2 0 .2 0 0 0zm16 82l17.7-5.8V54.8l-20.4-20.5c-3-3-8.3-5.8-13.2-7l23.1 65.6"
        fill="#00a8e1"
      ></path>
      <path
        fill="#00c4b3"
        d="M90.5 18.2L75.7 3.5c-3.4-3.4-8-4.4-10.4-2.3L26.9 26.6h59.5l2.9.1c1.3 0 2.8.2 4.3.7l-3.1-9.2z"
      ></path>
    </svg>
  );
};

const CPlusPlusIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#D26383"
        d="M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z"
      ></path>
      <path
        fill="#9C033A"
        d="M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z"
      ></path>
      <path
        fill="#fff"
        d="M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6z"
      ></path>
      <path
        d="M82.1 61.8h5.2v-5.3h4.4v5.3H97v4.4h-5.3v5.2h-4.4v-5.2h-5.2v-4.4zm18.5 0h5.2v-5.3h4.4v5.3h5.3v4.4h-5.3v5.2h-4.4v-5.2h-5.2v-4.4z"
        fill="#fff"
      ></path>
    </svg>
  );
};

const CIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#659AD3"
        d="M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z"
      ></path>
      <path
        fill="#03599C"
        d="M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z"
      ></path>
      <path
        fill="#fff"
        d="M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6z"
      ></path>
    </svg>
  );
};

const GoIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <path id="go-original-a" d="M18.8 1h90.5v126H18.8z"></path>
      </defs>
      <clipPath id="go-original-b">
        <use xlinkHref="#go-original-a" overflow="visible"></use>
      </clipPath>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D2A2"
        d="M21.1 68.7c.2 3.5 3.7 1.9 5.3.8 1.5-1.1 2-.2 2.1-2.3.1-1.4.2-2.7.2-4.1-2.3-.2-4.8.3-6.7 1.7-.9.7-2.8 3-.9 3.9"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M23 71.2c-.7 0-2-.3-2.2-2.3-.6-.4-.8-.9-.8-1.2-.1-1.2 1.2-2.6 1.9-3.1 1.6-1.2 3.7-1.8 5.9-1.8h1.3v.3c.1 1.1 0 2.2-.1 3.2 0 .3 0 .6-.1.9-.1 1.5-.4 1.7-1.1 2-.3.1-.6.2-1.1.6-.5.3-2.2 1.4-3.7 1.4zm4.8-7.8c-2.1 0-4 .6-5.5 1.7-.7.5-1.7 1.7-1.6 2.5 0 .3.2.6.6.8l.2.1v.2c.1 1.6.9 1.8 1.5 1.8 1 0 2.4-.7 3.3-1.3.6-.4 1-.5 1.3-.6.5-.2.6-.2.7-1.4 0-.3 0-.6.1-.9.1-.9.1-1.9.1-2.8-.3-.1-.5-.1-.7-.1z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6B198"
        d="M21.1 68.7c.5-.2 1.1-.3 1.4-.8"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M21.1 69c-.1 0-.3-.1-.3-.2-.1-.2 0-.4.2-.4.1 0 .2-.1.2-.1.4-.2.8-.3 1-.6.1-.1.3-.2.5-.1.1.1.2.3.1.5-.4.5-.9.7-1.3.8l-.2.1h-.2z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AD7E5"
        d="M29.3 26.4c-13.6-3.8-3.5-21.1 7.4-14l-7.4 14z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M29.5 26.8l-.3-.1c-7-2-6.9-7-6.7-8.5.5-3.8 4.1-7.8 8.9-7.8 1.9 0 3.7.6 5.5 1.8l.3.2-7.7 14.4zm1.9-15.7c-4.5 0-7.8 3.7-8.3 7.2-.5 3.6 1.7 6.4 6 7.7l7.1-13.5c-1.5-.9-3.1-1.4-4.8-1.4z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AD7E5"
        d="M89.6 11.1c10.7-7.5 20.5 9.5 8 13.8l-8-13.8z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M97.5 25.3L89.2 11l.3-.2c1.9-1.3 3.8-2 5.7-2 4.6 0 7.9 3.8 8.6 7.5.3 1.5.6 6.6-6 8.8l-.3.2zm-7.4-14l7.7 13.3c3.9-1.4 5.9-4.4 5.3-8-.6-3.4-3.7-6.9-7.9-6.9-1.7-.1-3.4.4-5.1 1.6z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D2A2"
        d="M92 112.3c2.7 1.7 7.7 6.8 3.6 9.3-3.9 3.6-6.1-4-9.6-5 1.5-2 3.4-3.9 6-4.3"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M93.5 122.9c-1.6 0-3-1.6-4.2-3.1-1.1-1.2-2.2-2.5-3.4-2.9l-.5-.1.3-.4c1.2-1.7 3.2-3.9 6.2-4.4h.1l.1.1c1.7 1.1 5.4 4.2 5.3 7.1 0 1.1-.6 2-1.7 2.7-.7.7-1.4 1-2.2 1zm-7-6.5c1.2.5 2.2 1.8 3.2 2.9 1.2 1.5 2.4 2.8 3.7 2.8.6 0 1.2-.3 1.8-.9h.1c.9-.6 1.4-1.3 1.4-2.2 0-2.3-2.9-5.2-4.9-6.5-1.8.5-3.6 1.7-5.3 3.9zm9.1 5.5c-.1 0-.2-.1-.3-.2-.2-.4-.4-.9-.5-1.3-.3-.8-.6-1.6-1.2-2.2-.1-.1-.1-.3 0-.5.1-.1.3-.1.5 0 .7.7 1.1 1.6 1.4 2.5l.5 1.2c.1.2 0 .4-.1.5h-.3z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D2A2"
        d="M43.2 118.1c-3.2.5-5 3.4-7.7 4.9-2.5 1.5-3.5-.5-3.7-.9-.4-.2-.4.2-1-.4-2.3-3.7 2.4-6.4 4.9-8.2 3.5-.8 5.7 2.2 7.5 4.6"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M33.8 123.8c-1.3 0-2-1.1-2.2-1.5h-.1c-.3 0-.5-.1-.9-.5v-.1c-2.2-3.5 1.6-6.2 4.1-8l.9-.6h.2c.4-.1.7-.1 1.1-.1 3 0 4.9 2.6 6.5 4.7l.5.7-.6.1c-1.9.3-3.3 1.5-4.7 2.7-.9.8-1.8 1.5-2.8 2.1-.8.3-1.4.5-2 .5zm-2.2-2.1c.1 0 .2 0 .4.1h.1l.1.1c.2.3.7 1.2 1.7 1.2.5 0 1-.2 1.5-.5 1-.5 1.9-1.3 2.7-2 1.3-1.1 2.7-2.3 4.5-2.8-1.5-2-3.3-4.2-5.8-4.2-.3 0-.6 0-.9.1l-.8.6c-2.6 1.8-5.8 4.1-3.9 7.1.1.2.2.3.4.3zm.2.7c-.2 0-.4-.2-.3-.4.1-1 .6-1.7 1.1-2.5.3-.4.5-.8.7-1.2.1-.2.3-.2.4-.2.2.1.2.3.2.4-.2.5-.5.9-.8 1.3-.5.7-.9 1.3-1 2.1 0 .4-.1.5-.3.5z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9 21.7c-1.8-.9-3.1-2.2-2-4.3 1-1.9 2.9-1.7 4.7-.8l-2.7 5.1zm64.9-1.8c1.8-.9 3.1-2.2 2-4.3-1-1.9-2.9-1.7-4.7-.8l2.7 5.1z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D2A2"
        d="M107.1 68.2c-.2 3.5-3.7 1.9-5.3.8-1.5-1.1-2-.2-2.1-2.3-.1-1.4-.2-2.7-.2-4.1 2.3-.2 4.8.3 6.7 1.7 1 .8 2.8 3 .9 3.9"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M105.3 70.7c-1.5 0-3.2-1.1-3.7-1.4-.5-.3-.8-.5-1.1-.6-.8-.3-1-.5-1.1-2 0-.3 0-.6-.1-.9-.1-1-.2-2.1-.1-3.2v-.3h1.3c2.2 0 4.3.6 5.9 1.8.7.5 2 1.9 1.9 3.1 0 .4-.2.9-.8 1.2-.2 2-1.5 2.3-2.2 2.3zM99.8 63c0 .9 0 1.9.1 2.8 0 .3 0 .6.1.9.1 1.2.2 1.2.7 1.4.3.1.7.3 1.3.6.9.6 2.3 1.3 3.3 1.3.6 0 1.4-.2 1.5-1.8V68l.2-.1c.4-.2.6-.4.6-.8.1-.8-.9-2-1.6-2.5-1.5-1.1-3.5-1.7-5.5-1.7-.2.1-.4.1-.7.1z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6B198"
        d="M107.1 68.2c-.5-.2-1.1-.3-1.4-.8"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M107.1 68.6h-.1l-.2-.1c-.5-.2-1-.3-1.3-.8-.1-.1-.1-.4.1-.5.1-.1.4-.1.5.1.2.3.6.4 1 .6.1 0 .2.1.2.1.2.1.3.3.2.4-.1.1-.3.2-.4.2z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AD7E5"
        d="M62.8 4c13.6 0 26.3 1.9 33 15 6 14.6 3.8 30.4 4.8 45.9.8 13.3 2.5 28.6-3.6 40.9-6.5 12.9-22.7 16.2-36 15.7-10.5-.4-23.1-3.8-29.1-13.4-6.9-11.2-3.7-27.9-3.2-40.4.6-14.8-4-29.7.9-44.1C34.5 8.5 48.1 5.1 62.8 4"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M63.3 121.9h-2.5c-4.1-.1-10.3-.8-16.4-3.3-5.9-2.4-10.2-5.8-13-10.3-5.6-9.1-4.6-21.6-3.7-32.7.2-2.8.4-5.4.5-7.9.2-5.2-.2-10.6-.7-15.7-.8-9.4-1.6-19.1 1.5-28.5 2.4-7 6.7-12 13.2-15.2 5.1-2.5 11.4-3.9 20.4-4.6C76 3.6 89.3 5.5 96 18.8c4.4 10.7 4.4 22.2 4.5 33.3 0 4.2 0 8.5.3 12.7.1 1.3.2 2.6.2 3.9.8 12.2 1.7 26-3.9 37.2-2.8 5.7-7.7 9.9-14.4 12.6-5.4 2.2-12.2 3.4-19.4 3.4zM62.8 4.3c-14.1 1.1-27.9 4.2-33 19.4-3.1 9.3-2.3 18.9-1.5 28.2.4 5.2.9 10.5.7 15.8-.1 2.5-.3 5.1-.5 7.9-.9 11-1.9 23.4 3.6 32.3 2.3 3.7 9.7 12.5 28.8 13.2h2.5c22.1 0 30.3-9.8 33.3-15.6 5.5-11 4.6-24.8 3.9-36.9-.1-1.3-.2-2.6-.2-3.9-.2-4.2-.3-8.5-.3-12.7-.1-11-.1-22.5-4.4-33.1C92.7 13 88.2 9 82 6.7c-6.4-2.1-13.6-2.4-19.2-2.4z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M65.2 22.2c2.4 14.2 25.6 10.4 22.3-3.9-3-12.8-23.1-9.2-22.3 3.9"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M76.2 31.5c-4.5 0-10.2-2.4-11.4-9.2-.2-3.2.8-6.1 2.9-8.3 2.3-2.5 5.8-3.9 9.4-3.9 4.2 0 9.2 2.2 10.6 8.3.8 3.4.2 6.4-1.7 8.8-2.1 2.6-5.8 4.3-9.8 4.3zm-10.7-9.3c.5 2.8 1.8 5 3.9 6.6 1.8 1.4 4.3 2.1 6.8 2.1 3.7 0 7.3-1.6 9.3-4.1 1.8-2.2 2.3-5.1 1.6-8.3-1.3-5.7-6-7.7-10-7.7-3.4 0-6.7 1.4-8.9 3.7-1.9 2-2.9 4.7-2.7 7.7z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M37.5 24.5c3.2 12.3 22.9 9.2 22.2-3.2-.9-14.8-25.3-12-22.2 3.2"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M48 32.7c-4.3 0-9.3-2.1-10.9-8.1-.7-3.5 0-6.7 2-9.1 2.2-2.7 5.8-4.3 9.7-4.3 5.2 0 10.7 3.1 11.1 10.1.2 2.9-.7 5.5-2.7 7.6-2.1 2.3-5.6 3.8-9.2 3.8zm.8-20.8c-3.7 0-7.1 1.5-9.2 4-1.9 2.3-2.5 5.2-1.8 8.5C39.2 30 44 32 48 32c3.4 0 6.7-1.3 8.8-3.6 1.8-1.9 2.7-4.4 2.5-7.1-.2-4.3-3.1-9.4-10.5-9.4z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M68 39.2c0 1.8.4 3.9.1 5.9-.5.9-1.4 1-2.2 1.3-1.1-.2-2-.9-2.5-1.9-.3-2.2.1-4.4.2-6.6l4.4 1.3z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M65.9 46.8c-1.3-.2-2.3-1-2.8-2.1-.2-1.6-.1-3.1 0-4.6.1-.7.1-1.4.1-2.1v-.4l5.1 1.6v.2c0 .6.1 1.2.1 1.9.1 1.3.2 2.7 0 4v.1c-.4.8-1.1 1-1.8 1.3-.2-.1-.4 0-.7.1zm-2.2-2.4c.4.9 1.2 1.5 2.1 1.7.2-.1.4-.1.5-.2.6-.2 1.1-.4 1.4-.9.2-1.2.1-2.5 0-3.8 0-.6-.1-1.2-.1-1.7l-3.8-1.2c0 .6-.1 1.2-.1 1.7-.1 1.6-.2 3 0 4.4z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.3 22.5c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M45.2 23.3c0 .5-.4.9-.8.9s-.8-.4-.8-.9.4-.9.8-.9c.5 0 .8.4.8.9"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.2 21.6c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M73.2 22.4c0 .5-.3.9-.8.9-.4 0-.8-.4-.8-.9s.3-.9.8-.9c.4 0 .8.4.8.9M58.4 39c-1.5 3.5.8 10.6 4.8 5.4-.3-2.2.1-4.4.2-6.6l-5 1.2z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        d="M60.5 46.6c-.7 0-1.4-.4-1.9-1.2-1.1-1.6-1.3-4.6-.5-6.5l.1-.2 5.5-1.4v.4l-.1 2.2c-.1 1.5-.2 2.9 0 4.4v.1l-.1.1c-1 1.4-2 2.1-3 2.1zm-1.8-7.3c-.6 1.7-.4 4.4.5 5.7.4.6.8.9 1.3.9.7 0 1.5-.6 2.3-1.6-.2-1.5-.1-3 .1-4.4l.1-1.7-4.3 1.1z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6D2A2"
        d="M58.9 32.2c-2.7.2-4.9 3.5-3.5 6 1.9 3.4 6-.3 8.6 0 3 .1 5.4 3.2 7.8.6 2.7-2.9-1.2-5.7-4.1-7l-8.8.4z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fill="#231F20"
        d="M69.7 40.2c-.9 0-1.8-.4-2.7-.8-.9-.4-1.9-.8-3-.8h-.3c-.8 0-1.7.3-2.7.7-1.1.4-2.2.7-3.2.7-1.2 0-2.1-.5-2.7-1.6-.7-1.2-.6-2.6.1-3.9.8-1.5 2.2-2.4 3.7-2.6l8.9-.4h.1c2.2.9 4.7 2.6 5.2 4.6.2 1-.1 2-.9 2.9-.8.9-1.6 1.2-2.5 1.2zM64.1 38c1.1 0 2.2.5 3.2.9.9.4 1.7.7 2.5.7.7 0 1.3-.3 1.9-.9.7-.7.9-1.5.8-2.3-.4-1.7-2.8-3.3-4.7-4.1l-8.7.4c-1.3.1-2.5 1-3.2 2.2-.6 1.1-.6 2.3-.1 3.3.5.9 1.1 1.3 2.1 1.3.9 0 1.9-.4 2.9-.7 1.1-.4 2-.7 3-.7 0-.2.1-.2.3-.1z"
        clipPath="url(#go-original-b)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.6 32.1c-.2-4.7 8.8-5.3 9.8-1.4 1.1 4-9.4 4.9-9.8 1.4"
        clipPath="url(#go-original-b)"
      ></path>
    </svg>
  );
};

const RustIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M62.271 10.88c-.189.11-.982 1.248-1.763 2.529-1.96 3.217-1.982 3.219-4.615.448-1.713-1.802-2.127-2.132-2.679-2.128-.359.002-.812.124-1.008.271-.195.147-.748 1.317-1.228 2.6-1.099 2.939-1.152 3.034-1.761 3.151-.375.071-1.097-.331-2.828-1.574-1.278-.919-2.532-1.67-2.786-1.67-1.054 0-1.351.576-1.853 3.593-.638 3.836-.616 3.823-4.074 2.252-1.396-.633-2.72-1.152-2.943-1.152-.223 0-.646.24-.939.533-.532.533-.533.535-.388 3.468l.146 2.936-.555.297c-.492.263-.831.231-3.009-.284-2.843-.671-3.443-.653-4.019.122l-.421.566.565 2.421c.31 1.331.609 2.613.665 2.848.055.234-.04.609-.212.832-.284.367-.586.4-3.217.36-4.453-.07-4.706.312-2.866 4.328.585 1.275 1.064 2.433 1.064 2.572 0 .734-.585 1.001-3.098 1.411-1.406.229-2.628.417-2.716.417-.088 0-.352.192-.586.426-.765.765-.548 1.483 1.187 3.932 2.161 3.05 2.157 3.061-1.413 4.427-4.06 1.553-4.142 1.936-1.051 4.868 2.879 2.73 2.882 2.69-.377 4.739-2.469 1.551-2.507 1.588-2.57 2.429-.076 1.023-.058 1.041 2.89 2.842 2.915 1.78 2.915 1.834.054 4.541-3.077 2.91-2.982 3.335 1.081 4.868 3.55 1.339 3.555 1.355 1.39 4.405-1.227 1.729-1.618 2.449-1.618 2.983 0 .999.52 1.254 3.627 1.776 2.617.441 3.2.7 3.2 1.422 0 .148-.48 1.316-1.067 2.594-1.826 3.977-1.618 4.308 2.704 4.308 4.025 0 3.918-.123 3.051 3.507-.654 2.736-.664 3.26-.072 3.851.453.454 1.307.403 3.978-.236 2.04-.487 2.398-.521 2.871-.268l.54.289-.146 2.935c-.145 2.934-.144 2.936.388 3.469.293.293.722.533.952.533.23 0 1.554-.516 2.943-1.147 3.447-1.565 3.425-1.578 4.061 2.246.504 3.031.798 3.594 1.874 3.594.267 0 1.494-.72 2.728-1.6 2.167-1.546 2.729-1.788 3.306-1.421.149.094.727 1.364 1.284 2.822.819 2.144 1.119 2.702 1.575 2.92.868.416 1.405.082 3.445-2.14 2.463-2.683 2.564-2.67 4.575.589 2.221 3.598 2.796 3.59 5.073-.073 1.962-3.156 1.939-3.154 4.591-.384 1.761 1.838 2.136 2.131 2.73 2.131.379 0 .832-.142 1.005-.316.174-.174.75-1.459 1.28-2.855.53-1.397 1.079-2.613 1.221-2.703.561-.357 1.142-.106 3.306 1.43 1.274.905 2.473 1.6 2.758 1.6 1.058 0 1.44-.751 1.88-3.703.376-2.517.452-2.758.947-3.009.487-.247.779-.164 3.063.873 1.389.63 2.713 1.146 2.943 1.146.23 0 .666-.247.967-.549l.549-.548-.151-2.815c-.144-2.688-.131-2.832.298-3.22.441-.399.486-.397 2.952.166 2.986.682 3.543.7 4.104.139.548-.548.542-.668-.208-3.831-.841-3.548-.954-3.422 3.088-3.422 2.755 0 3.062-.039 3.413-.426.586-.648.447-1.39-.732-3.903-.595-1.266-1.078-2.418-1.074-2.56.02-.747.607-1.002 3.32-1.443 1.66-.269 2.902-.581 3.127-.784.754-.681.477-1.567-1.244-3.98-2.157-3.024-2.148-3.053 1.306-4.326 4.136-1.524 4.254-2.032 1.159-4.973-2.867-2.724-2.868-2.709.272-4.637 3.796-2.33 3.802-2.855.067-5.173-3.212-1.993-3.21-1.965-.331-4.699 3.088-2.934 3.004-3.318-1.057-4.871-3.584-1.371-3.595-1.405-1.417-4.394 1.297-1.78 1.618-2.371 1.618-2.981 0-1.066-.478-1.305-3.622-1.813-2.627-.424-3.205-.682-3.205-1.429 0-.142.48-1.285 1.067-2.542 1.149-2.461 1.31-3.446.66-4.035-.349-.316-.817-.361-3.321-.32-2.62.044-2.955.007-3.318-.358-.397-.399-.393-.455.227-3.042.76-3.17.763-3.247.138-3.834-.634-.596-1.03-.586-3.941.099-2.121.5-2.472.533-2.954.275l-.547-.293.151-2.926.152-2.925-.547-.547c-.301-.301-.728-.547-.95-.547-.221 0-1.538.523-2.926 1.161-2.318 1.067-2.567 1.138-3.068.876-.5-.262-.583-.52-1.01-3.127-.493-3.016-.798-3.603-1.869-3.603-.254 0-1.513.755-2.798 1.678-2.11 1.516-2.393 1.659-2.919 1.476-.435-.152-.688-.483-.997-1.306-.229-.606-.667-1.774-.975-2.595-.622-1.656-.969-2.027-1.901-2.027-.52 0-.991.374-2.679 2.127-2.653 2.756-2.663 2.755-4.614-.445-.78-1.279-1.595-2.421-1.812-2.537-.488-.262-1.062-.261-1.511.002m2.418 9.635c2.311 1.645 1.082 5.512-1.752 5.512-2.75 0-4.135-3.313-2.171-5.194 1.108-1.062 2.697-1.191 3.923-.318m-2.906 10.214c1.515.576 2.137.23 5.596-3.104l2.599-2.506 1.1.146c3.45.458 10.312 3.472 14.255 6.261 3.623 2.564 8.438 7.786 10.49 11.377l.439.769-1.944 4.38c-1.07 2.409-1.945 4.633-1.945 4.944 0 .717.47 1.851.923 2.226.191.159 2.006 1.033 4.033 1.942l3.684 1.654.145.937c.187 1.221.212 4.22.042 5.072l-.133.666h-2.103c-2.439 0-2.251-.218-2.383 2.774-.096 2.169-.62 3.368-1.812 4.144-1.942 1.267-5.149 1.037-6.509-.466-.209-.231-.615-1.392-.903-2.581-.841-3.473-1.971-5.423-4.241-7.32-.717-.599-1.303-1.158-1.303-1.243 0-.084.788-.748 1.752-1.473 3.51-2.646 5.528-5.726 5.75-8.777.423-5.819-4.213-11.243-11.109-13.001-1.635-.417-2.333-.43-22.56-.43-11.48 0-20.873-.075-20.873-.166 0-.215 2.551-2.691 4.054-3.933 4.127-3.412 9.488-6.097 15.04-7.531l1.92-.497 2.728 2.766c1.501 1.521 2.972 2.857 3.268 2.97M27.432 48.526c1.257.823 1.772 2.891 1.03 4.134-1.148 1.924-4.056 2.005-5.205.145-1.671-2.702 1.547-6.001 4.175-4.279m74.05.105c3.288 2.005.74 6.937-2.78 5.38-2.35-1.04-2.425-4.252-.127-5.424.959-.489 2.061-.472 2.907.044M37.12 60.907v12.266H26.276l-.43-1.866c-.846-3.675-1.202-7.477-.989-10.591l.149-2.188 3.728-1.672c2.339-1.048 3.843-1.847 4.037-2.144.848-1.293.767-2.217-.423-4.845l-.556-1.227h5.328v12.267m31.22-11.733c2.322.604 3.549 1.833 3.552 3.556.002 1.265-.625 2.059-2.18 2.761-1.101.498-1.276.51-8.219.578l-7.093.068v-7.284h6.355c4.964 0 6.625.07 7.585.321m-2.396 17.602c1.151.32 2.512 1.32 3.21 2.359.733 1.092 1.162 2.512 2.178 7.216.858 3.976 1.41 5.276 2.956 6.968 1.915 2.095 1.471 2.014 11.037 2.014 4.581 0 8.328.073 8.328.163 0 .161-3.155 3.891-3.291 3.891-.039 0-1.687-.345-3.662-.767-5.577-1.191-5.778-1.051-7.058 4.926l-.823 3.84-.743.366c-1.24.612-5.27 1.872-7.359 2.302-3.452.71-7.209.95-10.511.671-5.629-.477-13.083-2.661-13.374-3.92-.062-.267-.437-1.995-.832-3.841-.396-1.846-.877-3.597-1.069-3.891-.923-1.408-1.894-1.495-6.164-.55-1.617.358-3.028.65-3.136.65-.203 0-3.204-3.47-3.204-3.704 0-.073 7.128-.158 15.84-.188l15.84-.054.057-5.627c.04-3.973-.015-5.714-.187-5.92-.192-.232-1.214-.293-4.91-.293H54.4V66.56l5.387.001c2.962.001 5.733.098 6.157.215M41.536 92.365c2.519 1.535 1.311 5.557-1.668 5.554-3.055-.002-4.187-3.987-1.584-5.575.861-.525 2.374-.515 3.252.021m46.126.168c1.235.905 1.646 2.788.881 4.042-2.009 3.295-7.033.676-5.355-2.791.825-1.703 3.018-2.317 4.474-1.251"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

const WindowsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#00ADEF"
        d="M126 1.637l-67 9.834v49.831l67-.534zM1.647 66.709l.003 42.404 50.791 6.983-.04-49.057zm56.82.68l.094 49.465 67.376 9.509.016-58.863zM1.61 19.297l.047 42.383 50.791-.289-.023-49.016z"
      ></path>
    </svg>
  );
};

const ReactIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#61DAFB">
        <circle cx="64" cy="64" r="11.4"></circle>
        <path d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3C8.2 50 1.4 56.6 1.4 64s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zM92.5 14.7c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zM81.3 74c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zM64 97.8c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zM64 30.2c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zM31.7 35c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zM7 64c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5C15.3 75.6 7 69.6 7 64zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zM96.3 93c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z"></path>
      </g>
    </svg>
  );
};

const AWSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#F7A80D"
        d="M38.089 77.466l-11.4 4.896 10.559 4.514 12.241-4.514-11.4-4.896zm-17.138 6.12l-.382 22.034 16.679 7.345V90.089l-16.297-6.503zm34.276 0l-15.073 5.739V110.9l15.073-6.121V83.586zm17.979-68.551L61.73 19.931l10.635 4.515 12.241-4.515-11.4-4.896zm-15.914 6.503v22.034l14.231 4.132.459-20.046-14.69-6.12zm31.828 1.224L75.654 28.5v21.652l13.466-6.121V22.762zM19.306 46.047L7.907 50.944l10.558 4.514 12.241-4.514-11.4-4.897zM2.168 52.168l-.382 22.034 16.679 7.345V58.671L2.168 52.168zm34.275 0l-15.071 5.738V79.48l15.071-6.12V52.168zm19.587-6.937l-11.4 4.897 10.558 4.514 12.241-4.514-11.399-4.897zm-17.137 6.121l-.383 22.035 16.679 7.345V57.855l-16.296-6.503zm34.275 0L58.096 57.09v21.576l15.072-6.121V51.352zm35.908-36.317l-11.399 4.896 10.559 4.515 12.241-4.515-11.401-4.896zm-17.137 6.121l-.382 22.034 16.679 7.344V27.658l-16.297-6.502zm34.275 0l-15.071 5.738v21.575l15.071-6.12V21.156z"
      ></path>
    </svg>
  );
};

const DotNetIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <linearGradient
        id="dot-net-original-a"
        gradientUnits="userSpaceOnUse"
        x1="61.631"
        y1="563.347"
        x2="62.022"
        y2="563.347"
        gradientTransform="matrix(0 149.735 149.735 0 -84296.266 -9188.014)"
      >
        <stop offset="0" stopColor="#0994DC"></stop>
        <stop offset=".35" stopColor="#66CEF5"></stop>
        <stop offset=".35" stopColor="#66CEF5"></stop>
        <stop offset=".846" stopColor="#127BCA"></stop>
        <stop offset=".846" stopColor="#127BCA"></stop>
        <stop offset="1" stopColor="#127BCA"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-a)"
        d="M45.288 49.559c4.417 13.507 6.09 37.601 19.006 37.601.982 0 1.977-.096 2.974-.286-11.74-2.737-13.132-26.569-20.297-38.912a61.601 61.601 0 00-1.683 1.597"
      ></path>
      <linearGradient
        id="dot-net-original-b"
        gradientUnits="userSpaceOnUse"
        x1="61.705"
        y1="563.34"
        x2="62.095"
        y2="563.34"
        gradientTransform="matrix(0 153.551 153.551 0 -86442.719 -9435.969)"
      >
        <stop offset="0" stopColor="#0E76BC"></stop>
        <stop offset=".36" stopColor="#36AEE8"></stop>
        <stop offset=".36" stopColor="#36AEE8"></stop>
        <stop offset=".846" stopColor="#00ADEF"></stop>
        <stop offset=".846" stopColor="#00ADEF"></stop>
        <stop offset="1" stopColor="#00ADEF"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-b)"
        d="M46.971 47.962c7.165 12.342 8.557 36.174 20.297 38.912a18.621 18.621 0 002.773-.749C59.502 80.961 56.59 57.819 48.453 46.678c-.492.41-.987.839-1.482 1.284"
      ></path>
      <path
        fill="#14559A"
        d="M57.294 40.623c-.98 0-1.977.096-2.977.286-2.612.493-5.268 1.618-7.944 3.321.73.722 1.427 1.547 2.081 2.448 2.723-2.259 5.427-3.928 8.12-4.932a18.177 18.177 0 013.029-.842 9.393 9.393 0 00-2.309-.281"
      ></path>
      <linearGradient
        id="dot-net-original-c"
        gradientUnits="userSpaceOnUse"
        x1="67.486"
        y1="564.985"
        x2="67.876"
        y2="564.985"
        gradientTransform="matrix(0 -122.178 -122.178 0 69099.289 8331.043)"
      >
        <stop offset="0" stopColor="#1C63B7"></stop>
        <stop offset=".5" stopColor="#33BDF2"></stop>
        <stop offset="1" stopColor="#33BDF2" stopOpacity=".42"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-c)"
        d="M78.268 81.366a47.16 47.16 0 003.24-2.84c-4.488-13.443-6.095-37.883-19.101-37.883-.93 0-1.868.087-2.804.26C71.45 43.85 72.968 69.625 78.268 81.366"
      ></path>
      <path
        fill="#3092C4"
        d="M59.604 40.904a9.355 9.355 0 00-2.311-.282l5.114.019c-.929 0-1.867.086-2.803.263"
      ></path>
      <path
        fill="#1969BC"
        d="M78.04 84.221a19.441 19.441 0 01-1.466-1.584c-2.188 1.549-4.368 2.724-6.533 3.489.771.376 1.578.656 2.436.829.664.136 1.353.206 2.075.206 2.431 0 4.353-.288 5.987-1.072-.9-.488-1.726-1.118-2.499-1.868"
      ></path>
      <linearGradient
        id="dot-net-original-d"
        gradientUnits="userSpaceOnUse"
        x1="61.852"
        y1="563.281"
        x2="62.243"
        y2="563.281"
        gradientTransform="matrix(0 159.425 159.425 0 -89733.742 -9828.116)"
      >
        <stop offset="0" stopColor="#166AB8"></stop>
        <stop offset=".4" stopColor="#36AEE8"></stop>
        <stop offset=".4" stopColor="#36AEE8"></stop>
        <stop offset=".846" stopColor="#0798DD"></stop>
        <stop offset=".846" stopColor="#0798DD"></stop>
        <stop offset="1" stopColor="#0798DD"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-d)"
        d="M56.573 41.748c10.611 5.55 11.534 30.684 20.001 40.889.568-.4 1.13-.824 1.691-1.271-5.3-11.741-6.815-37.519-18.66-40.463-1.011.189-2.02.469-3.032.845"
      ></path>
      <linearGradient
        id="dot-net-original-e"
        gradientUnits="userSpaceOnUse"
        x1="61.975"
        y1="563.367"
        x2="62.366"
        y2="563.367"
        gradientTransform="matrix(0 169.528 169.528 0 -95443.742 -10473.372)"
      >
        <stop offset="0" stopColor="#124379"></stop>
        <stop offset=".39" stopColor="#1487CB"></stop>
        <stop offset=".39" stopColor="#1487CB"></stop>
        <stop offset=".78" stopColor="#165197"></stop>
        <stop offset=".78" stopColor="#165197"></stop>
        <stop offset="1" stopColor="#165197"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-e)"
        d="M48.453 46.678c8.137 11.141 11.049 34.284 21.588 39.448 2.166-.765 4.346-1.939 6.533-3.489-8.467-10.205-9.39-35.338-20.001-40.889-2.693 1.002-5.397 2.671-8.12 4.93"
      ></path>
      <linearGradient
        id="dot-net-original-f"
        gradientUnits="userSpaceOnUse"
        x1="1006.454"
        y1="-1412.08"
        x2="1008.771"
        y2="-1412.08"
        gradientTransform="matrix(4.038 0 0 -4.038 -4028.633 -5649.283)"
      >
        <stop offset="0" stopColor="#33BDF2" stopOpacity=".698"></stop>
        <stop offset="1" stopColor="#1DACD8"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-f)"
        d="M40.083 49.234c-1.275 2.883-2.578 6.674-4.152 11.621 3.131-4.413 6.253-8.214 9.357-11.295a33.873 33.873 0 00-1.382-3.606 46.113 46.113 0 00-3.823 3.28"
      ></path>
      <path
        fill="#2B74B1"
        d="M45.037 45.121c-.374.268-.751.542-1.13.832.495 1.08.953 2.292 1.38 3.607a66.502 66.502 0 011.684-1.597 22.346 22.346 0 00-1.934-2.842"
      ></path>
      <path
        fill="#125A9E"
        d="M46.373 44.229c-.445.282-.888.58-1.337.891.695.855 1.333 1.81 1.936 2.844.495-.448.989-.879 1.482-1.287-.654-.9-1.35-1.726-2.081-2.448"
      ></path>
      <linearGradient
        id="dot-net-original-g"
        gradientUnits="userSpaceOnUse"
        x1="67.564"
        y1="565.48"
        x2="67.954"
        y2="565.48"
        gradientTransform="matrix(0 -119.018 -119.018 0 67408.578 8125.832)"
      >
        <stop offset="0" stopColor="#136AB4"></stop>
        <stop offset=".6" stopColor="#59CAF5" stopOpacity=".549"></stop>
        <stop offset="1" stopColor="#59CAF5" stopOpacity=".235"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-g)"
        d="M118.751 39.594c-6.001 23.144-18.536 41.734-29.044 46.42h-.021l-.567.243-.069.027-.161.062-.072.03-.263.093-.108.038-.131.043-.126.044-.112.038-.224.068-.096.025-.151.041-.103.028-.165.043-.201.044c.475.175.97.264 1.503.264 9.965 0 20.013-17.858 36.638-47.556h-6.528l.001.005z"
      ></path>
      <linearGradient
        id="dot-net-original-h"
        gradientUnits="userSpaceOnUse"
        x1="998.231"
        y1="-1414.829"
        x2="1006.826"
        y2="-1414.829"
        gradientTransform="matrix(4.038 0 0 -4.038 -4028.633 -5649.283)"
      >
        <stop offset="0" stopColor="#05A1E6" stopOpacity=".247"></stop>
        <stop offset="1" stopColor="#05A1E6"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-h)"
        d="M33.766 41.563l.019-.016.023-.015h.013l.161-.062.032-.016.042-.017.173-.062h.009l.383-.134.057-.015.164-.049.075-.024.165-.049.063-.017.548-.142.075-.017.16-.031.078-.024.161-.03h.038l.333-.062h.066l.154-.027.087-.015.147-.022.081-.016.358-.032a11.467 11.467 0 00-1.061-.054c-11.223 0-26.685 20.822-33.649 47.788h1.343a390.312 390.312 0 006.062-11.266c4.879-19.1 14.814-32.126 23.64-35.577"
      ></path>
      <path
        fill="#0D82CA"
        d="M40.083 49.234a46.488 46.488 0 013.823-3.281 17.961 17.961 0 00-.911-1.761c-1.026 1.246-1.964 2.89-2.912 5.042"
      ></path>
      <path
        fill="#0D82CA"
        d="M41.005 41.72c.733.614 1.39 1.46 1.99 2.473.189-.232.381-.447.58-.649a11.263 11.263 0 00-2.712-1.897l.12.057.022.016"
      ></path>
      <linearGradient
        id="dot-net-original-i"
        gradientUnits="userSpaceOnUse"
        x1="67.491"
        y1="564.359"
        x2="67.881"
        y2="564.359"
        gradientTransform="matrix(0 -121.865 -121.865 0 68797.742 8310.488)"
      >
        <stop offset="0" stopColor="#318ED5"></stop>
        <stop offset="1" stopColor="#38A7E4"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-i)"
        d="M10.127 77.138c10.233-19.719 15.081-32.199 23.64-35.577-8.825 3.454-18.762 16.479-23.64 35.577"
      ></path>
      <path
        fill="#127BCA"
        d="M43.574 43.544c-.199.204-.389.417-.58.649.322.538.621 1.124.913 1.76.378-.29.756-.563 1.129-.832a15.351 15.351 0 00-1.462-1.577"
      ></path>
      <linearGradient
        id="dot-net-original-j"
        gradientUnits="userSpaceOnUse"
        x1="67.593"
        y1="564.41"
        x2="67.984"
        y2="564.41"
        gradientTransform="matrix(0 -118.46 -118.46 0 66884.703 8093.017)"
      >
        <stop offset="0" stopColor="#05A1E6"></stop>
        <stop offset="1" stopColor="#05A1E6" stopOpacity=".549"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-j)"
        d="M14.773 88.315l-.186.022h-.035l-.158.016h-.026l-.376.025h-.039c10.356-.29 15.091-5.475 17.44-12.997 1.785-5.701 3.252-10.505 4.537-14.535-4.338 6.106-8.696 13.384-13.077 21.539-2.112 3.93-5.325 5.572-8.08 5.922"
      ></path>
      <linearGradient
        id="dot-net-original-k"
        gradientUnits="userSpaceOnUse"
        x1="68.291"
        y1="564.525"
        x2="68.682"
        y2="564.525"
        gradientTransform="matrix(0 -100.1 -100.1 0 56536.551 6924.301)"
      >
        <stop offset="0" stopColor="#1959A6"></stop>
        <stop offset=".5" stopColor="#05A1E6"></stop>
        <stop offset=".5" stopColor="#05A1E6"></stop>
        <stop offset=".918" stopColor="#7EC5EA"></stop>
        <stop offset="1" stopColor="#7EC5EA"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-k)"
        d="M14.773 88.311c2.755-.351 5.968-1.991 8.08-5.923 4.381-8.151 8.741-15.431 13.075-21.538 1.577-4.949 2.878-8.737 4.154-11.621-8.639 8.223-17.311 21.896-25.31 39.077"
      ></path>
      <path
        fill="#05A1E6"
        d="M10.127 77.139a388.004 388.004 0 01-6.063 11.266h3.904a95.502 95.502 0 012.158-11.264"
      ></path>
      <linearGradient
        id="dot-net-original-l"
        gradientUnits="userSpaceOnUse"
        x1="67.892"
        y1="563.82"
        x2="68.282"
        y2="563.82"
        gradientTransform="scale(-110.211 110.211) rotate(-80 -301.688 322.91)"
      >
        <stop offset="0" stopColor="#165096"></stop>
        <stop offset="1" stopColor="#0D82CA"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-l)"
        d="M37.073 40.709l-.083.016-.146.021-.086.015-.154.027-.066.016-.333.058h-.038l-.162.032-.081.022-.157.031-.074.018-.549.142-.063.018-.166.049-.075.021-.163.049-.06.016-.381.134-.173.06-.072.03-.161.06-.054.026c-8.558 3.377-13.406 15.857-23.639 35.576A94.655 94.655 0 007.979 88.41h.547l3.755-.016h1.723l.375-.025h.024l.158-.016h.037l.186-.022c8-17.182 16.672-30.854 25.31-39.077.95-2.152 1.887-3.796 2.911-5.04-.6-1.013-1.256-1.861-1.988-2.476l-.021-.016-.122-.059-.121-.061-.117-.057-.139-.058-.108-.047-.227-.095-.097-.036-.169-.068-.091-.03-.235-.081h-.019l-.272-.077-.061-.019-.229-.064-.053-.015a7.851 7.851 0 00-.569-.125l-.059-.016-.247-.04-.049-.015-.292-.039h-.051l-.226-.025-.358.033"
      ></path>
      <linearGradient
        id="dot-net-original-m"
        gradientUnits="userSpaceOnUse"
        x1="70.847"
        y1="566.882"
        x2="71.237"
        y2="566.882"
        gradientTransform="matrix(0 -56.721 -56.721 0 32252.127 4080.282)"
      >
        <stop offset="0" stopColor="#05A1E6"></stop>
        <stop offset=".874" stopColor="#0495D6"></stop>
        <stop offset="1" stopColor="#0495D6"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-m)"
        d="M95.311 52.407c-1.97 6.307-3.563 11.51-4.952 15.791 5.403-7.435 10.725-16.787 15.792-27.579-5.913 1.857-9.065 6.107-10.84 11.788"
      ></path>
      <linearGradient
        id="dot-net-original-n"
        gradientUnits="userSpaceOnUse"
        x1="61.634"
        y1="562.213"
        x2="62.024"
        y2="562.213"
        gradientTransform="scale(-132.813 132.813) rotate(80 365.248 244.034)"
      >
        <stop offset="0" stopColor="#38A7E4" stopOpacity=".329"></stop>
        <stop offset=".962" stopColor="#0E88D3"></stop>
        <stop offset=".962" stopColor="#0E88D3"></stop>
        <stop offset="1" stopColor="#0E88D3"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-n)"
        d="M90.53 85.621c-.275.14-.552.273-.823.394 10.508-4.687 23.044-23.277 29.044-46.421h-1.216c-13.788 24.631-18.222 41.12-27.005 46.027"
      ></path>
      <path
        fill="#079AE1"
        d="M83.668 83.552c2.287-2.791 4.148-7.535 6.691-15.354-2.933 4.029-5.885 7.492-8.84 10.316l-.015.025c.645 1.931 1.352 3.636 2.158 5.012"
      ></path>
      <path
        fill="#1969BC"
        d="M83.668 83.552c-.778.95-1.603 1.673-2.519 2.209-.2.117-.404.227-.61.327a8.839 8.839 0 003.206 1.011l.524.046h.031l.252.016h.855l.097-.016.189-.016h.092l.205-.022h.017l.063-.015.219-.034h.064l.246-.041h.04l.491-.104c-1.357-.496-2.492-1.667-3.469-3.334"
      ></path>
      <path
        fill="#1E5CB3"
        d="M64.295 87.161c.982 0 1.976-.096 2.973-.288a18.309 18.309 0 002.773-.747c.771.376 1.579.656 2.435.831.664.135 1.354.205 2.077.205H64.295zM74.553 87.161c2.429 0 4.353-.288 5.986-1.073a8.84 8.84 0 003.206 1.012l.524.045h.031l.252.016h.302-10.301z"
      ></path>
      <path
        fill="#1D60B5"
        d="M84.854 87.161h.561l.097-.016.191-.016h.092l.204-.022h.017l.062-.016.219-.033.067-.015.247-.04h.039l.491-.104c.475.175.97.264 1.503.264l-3.788.016-.002-.018z"
      ></path>
      <path
        fill="#175FAB"
        d="M81.511 78.54v-.016a47.16 47.16 0 01-3.24 2.84 36.81 36.81 0 01-1.693 1.271c.476.568.959 1.1 1.468 1.585.772.749 1.597 1.38 2.498 1.867.205-.101.41-.211.609-.327.918-.536 1.741-1.26 2.52-2.209-.806-1.376-1.513-3.082-2.157-5.012"
      ></path>
      <linearGradient
        id="dot-net-original-o"
        gradientUnits="userSpaceOnUse"
        x1="61.149"
        y1="562.654"
        x2="61.539"
        y2="562.654"
        gradientTransform="matrix(0 123.742 123.742 0 -69523.625 -7527.189)"
      >
        <stop offset="0" stopColor="#168CD4"></stop>
        <stop offset=".5" stopColor="#1C87CC"></stop>
        <stop offset="1" stopColor="#154B8D"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-o)"
        d="M113.685 39.594h-6.121l-.97.047-.451.966c-5.068 10.793-10.388 20.145-15.791 27.58-2.54 7.818-4.404 12.563-6.69 15.353.977 1.668 2.114 2.84 3.466 3.337l.106-.023h.022l.075-.016.17-.042.101-.029.151-.039.094-.027.226-.068.112-.038.126-.046.13-.041.106-.04.264-.093.073-.027.162-.063.068-.025.568-.243h.02c.271-.119.547-.254.821-.394 8.785-4.908 13.22-21.396 27.008-46.026h-3.851l.005-.003z"
      ></path>
      <path
        fill="#7DCBEC"
        d="M37.433 40.677l.063.016.16.017h.054l.292.038.049.016.246.041.062.015.567.126.052.016.228.064.063.019.271.077.021.016.237.081.09.029.17.069.096.034.226.094.11.047.136.059.12.057.119.062c.979.48 1.879 1.121 2.713 1.898.308-.323.628-.613.962-.874-1.823-1.293-3.89-2.03-6.271-2.03-.276 0-.552.016-.832.037"
      ></path>
      <path
        fill="#5EC5ED"
        d="M43.574 43.544c.511.475 1 1.005 1.462 1.577.448-.311.892-.611 1.337-.891a14.13 14.13 0 00-1.839-1.56c-.333.26-.652.552-.96.874"
      ></path>
      <g transform="matrix(5.048 0 0 -5.048 -9064.26 2270.61)">
        <linearGradient
          id="dot-net-original-p"
          gradientUnits="userSpaceOnUse"
          x1="1806.96"
          y1="336.158"
          x2="1807.35"
          y2="336.158"
          gradientTransform="scale(30.857 -30.857) rotate(22.527 1812.675 -4228.953)"
        >
          <stop offset="0" stopColor="#97D6EE"></stop>
          <stop offset=".703" stopColor="#55C1EA"></stop>
          <stop offset="1" stopColor="#55C1EA"></stop>
        </linearGradient>
        <path
          fill="url(#dot-net-original-p)"
          d="M1802.977 441.733l.165.007c.472 0 .881-.146 1.242-.402.381.301.842.406 1.482.406h-3.099l.21-.011"
        ></path>
      </g>
      <g transform="matrix(5.048 0 0 -5.048 -9064.26 2270.61)">
        <linearGradient
          id="dot-net-original-q"
          gradientUnits="userSpaceOnUse"
          x1="1808.848"
          y1="335.171"
          x2="1809.238"
          y2="335.171"
          gradientTransform="scale(24.717 -24.717) rotate(-24.385 124.122 4175.416)"
        >
          <stop offset="0" stopColor="#7ACCEC"></stop>
          <stop offset="1" stopColor="#3FB7ED"></stop>
        </linearGradient>
        <path
          fill="url(#dot-net-original-q)"
          d="M1805.866 441.744c-.64 0-1.1-.105-1.482-.406.126-.089.248-.193.364-.309.531.337 1.056.561 1.574.658.198.037.395.056.589.056h-1.045v.001z"
        ></path>
      </g>
      <linearGradient
        id="dot-net-original-r"
        gradientUnits="userSpaceOnUse"
        x1="61.049"
        y1="562.706"
        x2="61.439"
        y2="562.706"
        gradientTransform="matrix(0 121.032 121.032 0 -68011.711 -7346.748)"
      >
        <stop offset="0" stopColor="#1DA7E7"></stop>
        <stop offset="1" stopColor="#37ABE7" stopOpacity="0"></stop>
      </linearGradient>
      <path
        fill="url(#dot-net-original-r)"
        d="M90.359 68.202c1.391-4.284 2.98-9.485 4.954-15.794 1.777-5.684 4.925-9.934 10.835-11.788l.456-.966c-9.636.577-14.14 5.479-16.405 12.738-3.964 12.673-6.365 20.888-8.677 26.123 2.952-2.823 5.904-6.288 8.837-10.313"
      ></path>
    </svg>
  );
};

const DotNetCoreIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#623697">
        <path d="M61.195 0h4.953c12.918.535 25.688 4.89 36.043 12.676 9.809 7.289 17.473 17.437 21.727 28.906 2.441 6.387 3.664 13.18 4.082 19.992v4.211c-.414 11.293-3.664 22.52-9.73 32.082-6.801 10.895-16.922 19.73-28.727 24.828A64.399 64.399 0 0165.082 128h-2.144c-11.735-.191-23.41-3.66-33.297-9.992-11.196-7.113-20.114-17.785-25.028-30.117C1.891 81.19.441 74.02 0 66.812v-4.957c.504-14.39 5.953-28.609 15.41-39.496C23.168 13.31 33.5 6.48 44.887 2.937 50.172 1.27 55.676.41 61.195 0M25.191 37.523c-.03 12.153-.011 24.305-.011 36.454 1.43.011 2.86.011 4.293.011-.075-10.433.101-20.863-.106-31.293.48.907.918 1.84 1.465 2.707C37.035 54.91 43.105 64.5 49.309 74c1.738-.023 3.476-.023 5.214.004-.003-12.16-.007-24.32.004-36.48a308.076 308.076 0 00-4.25-.012c.075 10.32-.136 20.64.125 30.949-6.507-10.352-13.101-20.645-19.695-30.945a370.85 370.85 0 00-5.516.007m38.844-.011c-.129 12.16-.004 24.32-.047 36.476 6.469-.015 12.938.024 19.41-.02a83.36 83.36 0 01.024-3.952c-5.012-.016-10.027.007-15.043-.02-.074-4.21-.004-8.426-.04-12.637 4.395-.078 8.79.012 13.18-.047-.011-1.277-.011-2.554-.019-3.832-4.387.141-8.773-.054-13.164.012.012-4.023.02-8.05.02-12.078 4.699 0 9.398-.02 14.093.012-.008-1.301 0-2.606.016-3.906-6.145-.016-12.29-.008-18.43-.008m22.602.054c.004 1.266.004 2.528.008 3.79 3.488-.04 6.972.109 10.46.035-.023 10.863.004 21.718-.011 32.574 1.46.043 2.93.035 4.39-.09-.12-5.992.118-11.988-.156-17.977.067-2.699-.07-5.394.117-8.09.106-2.14-.277-4.277-.035-6.417 3.516.047 7.035.015 10.55.015a59.774 59.774 0 01.075-3.832c-8.469-.105-16.937-.094-25.398-.008M13.55 69.094c-1.977.91-2.106 4.023-.149 5.027 1.72 1.18 4.305-.371 4.227-2.41.133-2.004-2.29-3.688-4.078-2.617m29.23 15.289c-4.277 3.469-4.226 11.195.5 14.25 2.668 1.695 6.102 1.344 8.922.215.012-.621.027-1.239.05-1.86-2.671 1.395-6.41 1.68-8.675-.61-2.965-3.237-2.297-9.269 1.613-11.476 2.211-1.164 4.907-.824 7.086.239-.007-.66-.004-1.32 0-1.98-3.097-1.099-6.922-1.04-9.496 1.222m17.207 2.71c-1.89.22-3.758 1.22-4.633 2.966-1.253 2.496-1.109 5.867.864 7.96 2.035 2.297 5.945 2.32 8.18.297 2.425-2.308 2.699-6.468.757-9.164-1.148-1.629-3.273-2.183-5.168-2.058m17.887 2.722c-1.66 2.883-1.332 7.25 1.598 9.211 2.183 1.22 4.933.832 7.074-.308-.004-.617.004-1.235.031-1.848-1.687 1.07-3.937 1.856-5.812.777-1.309-.722-1.704-2.257-1.914-3.625 2.875-.039 5.746-.082 8.625-.074-.075-1.828-.118-3.894-1.45-5.308-2.199-2.43-6.644-1.657-8.152 1.175m-8.414-2.336v12.008c.652 0 1.312 0 1.973.004.023-2.195-.04-4.394.023-6.594.016-1.27.527-2.558 1.484-3.414.801-.605 1.883-.27 2.801-.246-.012-.636-.02-1.27-.023-1.902-1.793-.398-3.336.652-4.242 2.117-.02-.633-.04-1.266-.051-1.894-.656-.024-1.313-.051-1.965-.079zm0 0"></path>
        <path d="M58.758 89.223c1.652-.805 4.023-.41 4.945 1.3 1.05 1.887 1.027 4.383-.137 6.211-1.52 2.286-5.527 1.786-6.523-.742-1.008-2.258-.617-5.484 1.715-6.77zm0 0M79.04 92.414c.046-1.574 1.144-3.137 2.726-3.48.976-.164 2.097.007 2.773.793.672.714.813 1.714.98 2.64-2.16.012-4.32-.031-6.48.047zm0 0"></path>
      </g>
    </svg>
  );
};

const GrailsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M64 12.067c-28.682 0-51.934 23.249-51.934 51.932 0 28.682 23.253 51.934 51.934 51.934 28.683 0 51.934-23.251 51.934-51.934S92.683 12.067 64 12.067zm27.533 25.032c-.283-.218-.646-.402-1.078-.552-.424-.15-.886-.302-1.379-.45a6.116 6.116 0 01-1.36-.596 3.26 3.26 0 01-1.038-.977c-.272-.4-.41-.936-.41-1.596 0-.64.127-1.21.379-1.687a3.672 3.672 0 011.016-1.216 4.484 4.484 0 011.464-.74 6.092 6.092 0 011.718-.247c.682 0 1.347.1 1.978.29a4.595 4.595 0 011.66.92l-1.74 1.904a1.988 1.988 0 00-.867-.57 3.252 3.252 0 00-1.081-.201c-.199 0-.407.02-.617.068-.211.048-.413.121-.602.222-.192.103-.353.24-.472.407a1.05 1.05 0 00-.185.624c0 .396.144.689.442.901.278.198.634.371 1.06.507.418.139.873.28 1.352.414.474.137.922.331 1.334.578.41.247.753.583 1.019.995.269.412.403.97.403 1.668 0 .66-.125 1.248-.372 1.743a3.52 3.52 0 01-1.005 1.231c-.42.322-.918.57-1.472.726-.562.16-1.16.239-1.781.239a6.487 6.487 0 01-2.18-.356 5.448 5.448 0 01-1.819-1.111l1.808-1.988c.272.344.617.617 1.016.81a3.034 3.034 0 002.008.227c.228-.053.435-.137.62-.239.187-.109.338-.25.455-.417.116-.172.175-.379.175-.608.001-.396-.147-.697-.449-.923zm-14.314-7.75h2.547v9.703h4.974v2.343h-7.52V29.349zm-5.543 0h2.545v12.046h-2.545zm-8.94 0h2.13l5.241 12.046h-2.878l-1.05-2.584h-4.827l-1.015 2.584h-2.808zm-15.79 0h4.646c.612 0 1.2.059 1.75.18a4.096 4.096 0 011.438.59c.408.276.736.649.976 1.112s.363 1.054.363 1.75c0 .84-.221 1.564-.658 2.153-.418.564-1.033.93-1.825 1.097l-.187.04 3.081 5.124h-3.054l-2.546-4.869h-1.435v4.869h-2.547V29.349zm-13.385 3.396c.32-.778.775-1.45 1.353-1.996a6.033 6.033 0 012.057-1.27 7.489 7.489 0 012.61-.442c.964 0 1.863.119 2.675.35a5.233 5.233 0 012.082 1.154L42.54 32.5a3.904 3.904 0 00-1.213-.824c-.466-.2-1.053-.296-1.747-.296-.58 0-1.113.096-1.583.296-.473.199-.883.478-1.22.832-.339.357-.6.784-.78 1.272a4.583 4.583 0 00-.268 1.59c0 .58.088 1.117.268 1.6.18.482.443.906.78 1.262.338.353.748.634 1.22.832a4.07 4.07 0 001.583.297c.59 0 1.105-.066 1.535-.2.405-.126.738-.256.989-.389l.017-.01.028-.026.028-.05v-2.045h-2.184v-2.338h4.628v6.257c-.776.4-1.592.692-2.424.868a12.41 12.41 0 01-2.617.274c-.94 0-1.817-.148-2.61-.442a5.95 5.95 0 01-2.057-1.268 5.723 5.723 0 01-1.353-2c-.322-.777-.486-1.659-.486-2.621 0-.961.164-1.844.486-2.627zm16.626 41.336c-.779.343-1.772.732-2.16.938-.716.382-1.824 1.217-2.447 2.175-.46.713-.89 1.682-1.028 2.317-.085.4-.128.986-.119 1.674.017 1.604.294 3.739.845 5.203.627 1.662.969 2.216 1.692 3.9.307.713.595 1.392.734 1.723a.417.417 0 01-.037.4 3.763 3.763 0 01-1.338 1.231c-1.244.672-3.864.915-5.164.923h-.005c-1.298-.01-3.918-.25-5.164-.923a3.755 3.755 0 01-1.336-1.231.42.42 0 01-.039-.4c.141-.331.43-1.011.736-1.723.723-1.684 1.065-2.238 1.692-3.9.551-1.464.828-3.599.844-5.203.008-.688-.033-1.274-.12-1.674-.139-.636-.567-1.605-1.028-2.317-.62-.957-1.731-1.793-2.445-2.175-.538-.286-2.247-.926-2.919-1.297a23.059 23.059 0 01-2.72-1.797c-.835-.65-2.473-2.26-3.114-3.056-1.228-1.523-2.36-3.31-2.907-5.236-.68-2.388-.655-3.41-.744-4.182a.23.23 0 01.216-.255c.656-.022 3.022-.076 11.286-.089.163-.002.308.1.367.251 2.324 6.157 8.386 11.25 16.386 14.02.327.11.355.564.036.703zm20.345 17.522c1.017 2.7 1.572 3.596 2.747 6.333.497 1.156.966 2.261 1.194 2.794a.694.694 0 01-.061.654 6.152 6.152 0 01-2.172 1.999c-2.02 1.092-6.275 1.487-8.387 1.495h-.008c-2.11-.008-6.364-.403-8.385-1.495a6.136 6.136 0 01-2.169-1.999.694.694 0 01-.06-.654c.227-.533.693-1.638 1.19-2.794 1.176-2.737 1.73-3.633 2.748-6.333.896-2.378 1.347-5.842 1.374-8.452.011-1.11-.055-2.066-.195-2.717-.225-1.03-.922-2.599-1.67-3.758-1.009-1.56-2.812-2.911-3.971-3.53-.877-.467-3.649-1.506-4.74-2.109a37.281 37.281 0 01-4.418-2.914c-1.355-1.06-4.016-3.67-5.054-4.964-1.995-2.476-3.834-5.376-4.722-8.502-1.103-3.88-1.06-5.538-1.208-6.791a.369.369 0 01.35-.415c1.346-.048 7.094-.173 30.938-.15 23.842-.023 29.59.102 30.934.15a.366.366 0 01.351.415c-.147 1.253-.105 2.912-1.206 6.791-.89 3.126-2.728 6.026-4.724 8.502-1.039 1.293-3.698 3.904-5.052 4.964a37.442 37.442 0 01-4.42 2.914c-1.09.603-3.864 1.642-4.738 2.11-1.16.618-2.962 1.968-3.974 3.53-.747 1.158-1.444 2.727-1.667 3.757-.142.651-.206 1.608-.195 2.717.023 2.61.475 6.074 1.37 8.452zm31.922-22.734c-.64.796-2.277 2.405-3.111 3.056a23.089 23.089 0 01-2.724 1.797c-.672.37-2.38 1.011-2.916 1.297-.716.382-1.826 1.217-2.448 2.175-.46.713-.89 1.682-1.027 2.317-.089.4-.126.986-.121 1.674.016 1.604.295 3.739.845 5.203.628 1.662.969 2.216 1.692 3.9.307.713.594 1.392.736 1.723a.42.42 0 01-.039.4 3.77 3.77 0 01-1.336 1.231c-1.247.672-3.864.915-5.164.923h-.005c-1.3-.01-3.92-.25-5.164-.923a3.763 3.763 0 01-1.337-1.231.42.42 0 01-.04-.4c.141-.331.428-1.011.736-1.723.724-1.684 1.064-2.238 1.69-3.9.552-1.464.83-3.599.848-5.203.005-.688-.034-1.274-.12-1.674-.14-.636-.569-1.605-1.028-2.317-.622-.957-1.731-1.793-2.447-2.175-.387-.206-1.384-.595-2.16-.938-.32-.139-.291-.592.037-.704 8.001-2.77 14.062-7.863 16.386-14.02a.392.392 0 01.367-.25c8.264.013 10.63.067 11.286.088a.23.23 0 01.216.255c-.087.772-.064 1.793-.744 4.183-.547 1.927-1.679 3.713-2.907 5.237zM53.469 32.961c0 .35-.08.624-.23.818a1.336 1.336 0 01-.573.426 2.498 2.498 0 01-.75.161c-.273.016-.531.026-.77.026h-1.652v-2.909h1.824c.24 0 .492.016.748.054.26.03.492.103.692.2.205.104.379.254.508.447.134.193.203.459.203.777zm10.254-.324l1.597 4.044h-3.179z"
        fill="#feb672"
      ></path>
    </svg>
  );
};

const JenkinsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#1f1f1f">
        <path d="M65.125 127.8c-2.413-.225-5.338-.725-6.787-1.175l-.813-.25-.775-2.163c-.425-1.174-1.25-3.75-1.837-5.712-.588-1.962-1.188-3.987-1.338-4.5l-.287-.938-.925.038c-1.713.075-4.2-.362-6.175-1.087-1.463-.538-2.738-1.1-5.188-2.313-1.2-.588-2.85-1.338-3.65-1.65-2.862-1.125-2.95-1.263-3.112-5.275-.05-1.563-.138-3.3-.188-3.863l-.087-1.037-1.213-1.125c-1.462-1.35-3.625-3.725-5.025-5.513-6.037-7.75-9.575-17.412-9.95-27.137-.262-6.813.625-12.613 2.925-18.925 2.463-6.813 6.988-13.563 12.35-18.425l1.538-1.388.075-1.087c.162-2.25.8-4.625 1.6-5.988.537-.912 1.637-2.012 2.4-2.412.512-.275.612-.388.775-.938.275-.95 1.087-2.537 1.737-3.4 1.038-1.375 3.075-3.025 5.388-4.375 2.262-1.312 5.362-3.012 6.375-3.487 1.887-.9 6.762-2.65 6.912-2.488.038.038.125.013.2-.05C60.463.8 64.275.275 67 .175c6.113-.225 12.175 1.212 15.95 3.762 2.663 1.825 6.513 5.725 8.488 8.625 2 2.925 3.287 7.55 3.887 13.875l.075.875 1.463 1.513c1.437 1.475 3.212 3.612 4.475 5.387.862 1.2 2.412 3.675 2.412 3.863 0 .087.05.175.1.2.25.087 2.688 5.062 2.825 5.725.025.1.15.45.288.762.15.313.487 1.275.762 2.125 2.813 8.638 3.15 17.913.963 26.638-.825 3.3-1.85 6.112-3.338 9.225-.462.987-.9 1.837-.95 1.875-.05.037-.237.362-.425.712l-.35.663.513.25c1.287.662 2.137 2.075 3.325 5.562.987 2.888 1.3 4.188 1.375 5.625.15 3.025-.888 6.263-2.513 7.888-.65.637-.887.787-1.637 1.012-.475.15-1.263.338-1.75.413-1.263.212-4.075.175-5.65-.063-1.475-.237-1.788-.412-2.238-1.275l-.237-.437-1.75.075c-1.738.062-2.613.225-3.95.712l-.713.263-.075.625c-.112.787-.512 1.225-1.425 1.55-.575.2-.662.287-.725.65-.175.912.05 2.962.55 5.213.65 2.837.75 3.9.475 4.85-.362 1.237-1.337 1.9-3.575 2.4l-1.187.262-.038.438c-.025.237.013.95.088 1.6.137 1.15.137 1.174-.175 1.712-1.113 1.9-3.638 2.425-12 2.487-2.538.013-4.875.013-5.188-.012zm7.287-2.438c.325-.074.85-.112 1.15-.074.313.024.563.012.563-.05 0-.063.237-.113.537-.113 1.288 0 5.563-.912 5.675-1.212.038-.088-.025-.75-.137-1.45-.313-1.976-.438-3.638-.638-8.9-.1-2.676-.275-5.826-.375-7-.1-1.163-.3-4.238-.437-6.813-.288-5.413-.438-6.838-.738-6.925-.112-.038-.762-.15-1.45-.25-5.287-.8-13.3-.475-21.375.862-2.587.425-2.4.363-2.462.888-.025.237-.013.462.025.487.112.075.412 2.888.325 3.038-.038.075-.025.15.05.175.062.012.15.4.175.85.025.45.1.912.137 1.037.05.113.063.35.038.525-.038.163-.025.325.012.338.125.05.663 3.712.575 3.85-.037.075-.012.125.05.125.075 0 .138.125.138.275 0 .337.637 3.712 1.137 6.012.2.95.338 1.775.3 1.85-.05.063-.025.113.038.113.062 0 .237.575.4 1.287.35 1.575 1.475 5.613 2.137 7.738l.5 1.6.65.187c1.075.313 3.338.8 4.438.963.562.087 1.025.175 1.025.225 0 .037.412.075.9.087.5.025 1 .075 1.1.113.1.05.625.075 1.15.062.525-.025 1.038.013 1.125.063.087.062.563.087 1.038.075.487-.013.962.025 1.062.087.1.075.275.113.375.075.1-.025.463-.112.787-.2zm9.913-6.237c.55-.075 1.4-.263 1.875-.425l.862-.287-.012-1.3c-.013-1.288-.15-2.288-.738-5.113-.162-.787-.35-1.85-.437-2.337l-.15-.913h-.463c-.25 0-.787.088-1.175.188-.4.1-.9.187-1.112.187h-.388l.075 2.475c.125 4.175.363 7.65.513 7.65.087 0 .6-.062 1.15-.125zm-28.7-8.988c0-.187-.225-1.962-.5-3.95-.675-4.837-1.113-8.5-1.213-9.912-.037-.637-.125-1.188-.187-1.225-.05-.037-.1-.275-.1-.55 0-.475-.013-.475-.65-.625-.475-.125-1.275-.137-2.938-.075-2.162.075-2.287.075-2.287-.137 0-.4.375-.775.912-.925 1.188-.313 1.6-.513 1.725-.825.15-.4.025-.9-.325-1.288-.15-.175-.35-.437-.425-.587-.162-.313-.187-.788-.037-.788.062 0 .625.325 1.25.738 1.387.887 1.862 1.1 2.05.912.2-.2.462-1.475.55-2.65.05-.625-.013-2-.125-3.313-.325-3.662-.238-5.262.312-5.762.288-.263.613-.15.613.237 0 .163.062.35.137.425.125.125-.037 3.75-.212 4.538-.038.162-.063 1.412-.063 2.775.013 2.362.1 3.237.413 4.012l.137.35 1.013-.075c.562-.037 1.937-.187 3.075-.312 1.137-.138 2.425-.275 2.875-.3.45-.038 1.625-.15 2.625-.25s1.9-.175 2-.175c.1 0 1.038-.063 2.063-.138 1.487-.112 6.674-.387 7.412-.387.338 0 .125-.338-.313-.488-1.825-.65-8.25-3.762-9.35-4.512-1.112-.763-1.15-1.6-.137-2.975.675-.9.95-1.425.95-1.775 0-.313-.075-.313-.813.012-1.25.55-2.137.075-2.937-1.55-.537-1.112-1.988-5.987-2.263-7.6l-.15-.95-2.975-1.475c-4.7-2.324-5.887-3.162-8.025-5.624-.537-.613-1.175-1.276-1.412-1.463l-.438-.325-1.1.475C41.1 63.212 37.35 65.5 32.537 69.1L30 70.987l.375.826c.2.45.337.812.3.812-.025 0 .025.125.125.287.775 1.2 2.675 7.288 3.637 11.663.425 1.937 1.088 5.562 1.05 5.762-.012.05.013.2.075.325.05.113.063.35.038.525-.038.163-.025.326.012.338.2.087.838 6.7.95 9.787.113 2.776.126 2.888.576 3.076.212.074.45.212.525.3.225.212 4.737 2.562 6.475 3.374 2.712 1.25 5.912 2.213 8.05 2.4.412.038.762.076.787.1.013.013.175 0 .338-.037.237-.037.312-.138.312-.388zM83 106.688c2.537-.45 2.3-.287 2.212-1.424-.05-.526-.162-2.05-.275-3.388-.287-3.688-.562-6.412-.687-6.688a8.629 8.629 0 01-.238-1c-.075-.412-.2-.974-.275-1.237l-.137-.487-1.2.075c-.675.037-1.55.15-1.95.237l-.738.163.088 3.25c.075 2.974.35 8.124.525 10.037.075.775.075.775.475.775.212 0 1.212-.138 2.2-.313zm17.75-1.462c0-.063.187-.1.412-.1.588 0 2.013-.325 2.538-.575 1.687-.8 2.925-3.063 2.925-5.35 0-1.913-1.563-8.025-2.425-9.5-.625-1.075-2.013-1.938-3.113-1.95-.462 0-.85.138-1.812.613-.663.324-2.138.924-3.275 1.312-2.388.838-3.938 1.55-4.438 2.075l-.35.362.263 1.163c.387 1.675.625 3.262.962 6.662.175 1.65.313 3.05.313 3.113 0 .075 1.037.075 2.6 0 1.425-.063 3.175-.113 3.9-.1 1.4 0 2.925.25 2.612.425-.1.05-1.075.275-2.175.5-1.1.212-2.25.512-2.562.65l-.563.25.375.175c.213.087.5.162.65.175.15 0 .3.037.325.1.038.05.688.087 1.45.087.763 0 1.388-.037 1.388-.087zm-11.938-.975c.275-.037.913-.212 1.413-.375l.9-.3v-1.438c0-1.387-.35-4.724-.638-5.987-.237-1.125-.637-2.337-1.012-3.175l-.388-.85h-2.712v.35c0 .413.237 2.213.7 5.188.175 1.162.287 2.137.25 2.175-.038.05-.013.15.062.237s.163.575.2 1.075c.025.5.125 1.462.2 2.138.113 1.037.163 1.212.325 1.137.113-.05.426-.125.7-.175zM33.45 92.162c-.588-4.625-1.275-7.462-2.638-10.975-.812-2.1-2.45-6.637-2.937-8.124-.275-.838-.425-1.6-.463-2.313-.112-1.775.3-2.3 2.763-3.575a28.486 28.486 0 002.7-1.613c1.437-.987 3.312-2.124 6.562-4 3.85-2.224 4.5-2.612 4.925-3.012.388-.35.425-.45.413-1-.013-.75-.2-1.212-1.025-2.538-.988-1.587-1.625-3.35-1.85-5.062l-.088-.725-.937-.288c-1.738-.512-2.775-1.125-3.988-2.325-3.5-3.487-4.762-11.312-2.387-14.787.425-.625.5-.825.5-1.375 0-.85-.125-1.575-.275-1.575-.063 0-.7.587-1.413 1.3a44.745 44.745 0 00-11.937 22.187c-.738 3.475-.925 5.338-.925 9.388-.013 3.75.062 4.725.562 7.812 1.175 7.1 4.3 14.238 8.763 19.975 1.125 1.45 3.725 4.375 3.812 4.288.038-.025-.025-.775-.137-1.663zm49.237-2.437c.213-.063 1.363-.163 2.563-.225 2.612-.138 3.612-.362 4.075-.9.45-.55.637-.95 1.925-4.162 2.6-6.513 4.75-14 4.75-16.576 0-1.5-.275-1.912-2.5-3.7-.513-.412-2.025-1.8-3.363-3.087-1.325-1.275-2.462-2.325-2.512-2.325-.05 0-.338.237-.638.537-.3.288-1 .888-1.537 1.338-.55.45-1.013.875-1.038.962-.05.15.263.15.413 0 .05-.05.387-.087.737-.087.525 0 .75.075 1.15.362.513.375 1.113 1.1 1 1.213-.037.037.1.425.288.85 1.025 2.25 1.112 7.037.175 9.275-.1.225-.175.537-.175.7 0 .325.55 1.162 1.025 1.575.187.15.375.4.412.537.1.3-.675 1.688-4.062 7.238-3.1 5.087-4 6.612-4 6.825 0 .15.075.15.475-.025.25-.113.637-.25.837-.325zM78 88.513c0-.188-2.363-5.65-3.125-7.2-1.213-2.5-3.05-5.35-3.363-5.238-.087.025-.875.55-1.737 1.15-2.55 1.762-3.875 3.25-4.463 5.013-.112.362-.187.674-.175.687.213.175 3.538 1.913 4.95 2.575.975.463 1.738.887 1.688.938-.05.062-.025.062.05.024.087-.05.7.15 1.375.438 1.137.475 4.487 1.7 4.712 1.712.05.013.088-.037.088-.1zm3.9-1.388c1.262-1.775 2.175-3.225 4.437-7.05 1.488-2.538 1.875-3.288 1.788-3.463-.263-.475-1.35-1.425-2-1.725-.575-.275-.863-.325-1.75-.325-.7 0-1.188.063-1.438.188l-.375.187-.15 2.313c-.262 4.212-.712 7.6-1.35 10.05-.175.662-.312 1.237-.312 1.287 0 .125.112-.025 1.15-1.462zm11.487.612c2.65-1.2 4.925-1.925 6.888-2.175l.587-.075.638-1.112c7.275-12.713 7.9-28.688 1.625-41.825-1.925-4.038-4.088-7.3-7.175-10.85l-.425-.5-.063.812c-.037.438-.124 1.763-.2 2.925-.287 4.6-1.2 9.338-2.662 13.875-.5 1.538-.725 2.038-2.4 5.225-.863 1.65-.887 1.963-.212 2.8.512.65.862.975 4.762 4.375 3.388 2.963 3.75 3.45 3.75 5.038a10.689 10.689 0 01-.237 1.875c-.6 2.437-4.9 15.8-6.238 19.35-.212.562-.362 1.025-.35 1.025.025 0 .788-.338 1.713-.763zm-13.15-.825c.513-2.112.763-4.462.95-8.6.038-.887.1-2.05.138-2.575l.075-.937-.7-.163c-.438-.1-1.075-.4-1.75-.837-1.363-.888-1.65-.938-2.838-.425-.7.287-1.075.387-1.537.362-.588-.037-.638-.012-1.075.5l-.463.538.663.937c.375.525.987 1.5 1.375 2.163.687 1.225 2.5 5.137 2.575 5.575.025.137.075.262.112.3.113.1 1.638 3.412 1.65 3.6 0 .075.063.15.125.15.075 0 .1.037.05.075-.075.075.163.412.3.425.05 0 .2-.488.35-1.088zm-15.05-8.975c2.263-.775 3.588-1.55 5.813-3.4a52.04 52.04 0 011.65-1.35c.287-.225.337-.35.375-1.125l.037-.875-.75-.3a9.093 9.093 0 00-1.625-.437c-.475-.088-.812-.188-.737-.225.062-.05.587-.2 1.175-.35 1.425-.362 1.75-.55 1.75-.975 0-.325-.05-.362-.738-.5-.45-.1-1.112-.388-1.762-.775-2.95-1.775-7.438-3.325-8.65-2.987-1.2.324-1.625 1.624-1.613 4.924.013 2.513.188 3.376 1.325 6.463.975 2.612.8 2.388 1.863 2.313.487-.025 1.337-.213 1.887-.4zM86.9 72.975c.412-.788.512-1.55.437-3.325-.125-2.85-.737-5.088-1.55-5.613-.512-.337-1.55-.275-2.6.175-.487.2-1.662.875-2.625 1.488-.962.625-1.887 1.212-2.062 1.3-.175.087-.325.175-.35.187-.013.013.087.4.237.838l.263.825.775-.063c.463-.037.988.013 1.325.125l.563.175-.75.1c-.413.05-.95.175-1.213.275-.525.213-.6.45-.55 1.9.037 1.1-.188.963 2.45 1.45 1.563.288 3.5.5 4.875.55.525.013.588-.025.775-.387zm-10.475-1.338c1.162-.65 1.062-2.887-.15-3.462-.513-.238-1.288-.175-1.875.162-.288.163-.388.325-.438.663-.05.462.325 2.6.5 2.762.275.263 1.4.2 1.963-.125zm-17.888-4.862c.288-1.338.275-1.625-.062-1.713a70.165 70.165 0 00-2.3-.237c-1.35-.125-2.25-.275-2.75-.45-1.125-.4-1.225-.4-1.275.137-.025.375.037.525.35.85.75.75 2.637 1.638 4.562 2.138 1.3.35 1.238.387 1.475-.725zm19.375-1.35c.838-.663 1.6-1.238 1.675-1.263.088-.037.163-.1.163-.162 0-.125-1.113.062-3.063.5-2.425.562-3.625.687-4.712.5-1.725-.288-1.9-.175-.85.525 1.15.762 2.325 1.087 3.912 1.1h1.338l1.537-1.2zM59.85 63.312c.75-.762 2.075-1 4.275-.775.637.063.85.05.65-.037-2.375-1.025-7.688-6.438-9.125-9.325-.413-.813-.825-2.1-.75-2.325.025-.075.575.587 1.225 1.475 4.15 5.687 7.512 8.462 12.187 10.025 2.75.912 5.888.787 9.426-.413 2.7-.9 6.15-2.912 7.387-4.287.863-.95 3.475-4.85 4.325-6.45 1.925-3.65 3.237-7.95 3.938-12.888.324-2.337.45-7.412.25-10.812-.326-5.613-.776-7.288-2.45-8.95-1.888-1.875-4.45-2.525-6.288-1.6-.325.162-.6.3-.613.3-.124 0 0-.85.163-1.2.637-1.35 2.362-1.988 4.338-1.625l.612.112-.175-.325c-.325-.625-3.387-4.35-4.387-5.35-1.338-1.325-2.175-1.95-3.675-2.712-3.075-1.575-6.838-2.738-10.2-3.15-1.55-.2-5.325-.088-6.488.175-1.95.45-4.875 1.912-8.037 4.012-3.513 2.338-5.713 4.5-7 6.85l-.463.838.313 1.162c.625 2.238.575 3.325-.363 7.925-.512 2.513-.587 3.05-.6 4.538 0 1.587.025 1.825.525 3.825.638 2.612.725 3.175.525 3.537-.262.5-1.362.9-2.675.975l-1.162.075-.288-1.162c-.712-2.888-2.05-4.25-4.137-4.25-2.5 0-4.588 1.587-5.438 4.125-.287.85-.312 2.6-.062 3.75.25 1.125.987 2.925 1.575 3.812 1.087 1.663 2.687 2.825 4.125 3 1.175.15 1.687 0 2.812-.812.9-.65 1.663-1 1.825-.838.138.138.163 1 .025 1.25-.075.15-.462.638-.862 1.075-.85.925-.95 1.25-.738 2.538.5 2.987 2.463 7.962 4.138 10.425 1.05 1.562 2.4 2.487 4.525 3.1 1.362.4 3.9.762 5.65.8.7.025.775 0 1.162-.413zm-13.975-31.85c0-.025-.238-.262-.525-.525l-.538-.5.5.538c.45.487.563.587.563.487zm-4.588-2.3a2.611 2.611 0 00-.625 0c-.2.025-.062.05.275.05.35 0 .5-.025.35-.05z"></path>
        <path d="M96.438 98.875l-1.25-.063.5-.25a3.142 3.142 0 011.1-.237c.324-.013.587-.05.587-.1 0-.137 1.1-.125 1.175.013.037.062.338.075.65.037.45-.05.563-.025.487.1-.062.113-.024.125.163.075.237-.075 2.525.375 2.525.5 0 .075-4.388.013-5.938-.075zM95.55 95.638c.275-.3 1.5-.688 1.887-.588.163.037.338.025.376-.05.087-.138.724-.175.837-.05.037.037.425.087.863.113.437.024 1.112.112 1.487.2l.688.162-.626.087c-1.187.188-3.5.363-4.612.363-1.087 0-1.113-.013-.9-.237zM94.213 93.963c.975-1.25 3.012-2.2 5.1-2.4l.75-.063-.5.237c-.276.126-1.163.626-1.976 1.113-1.462.875-2.174 1.175-3.137 1.35l-.5.087.263-.325zM78.487 81.775c-.574-.475-.212-1.525.538-1.525.762 0 1.137.975.575 1.5-.338.313-.738.325-1.113.025zM77.525 77.375a.922.922 0 01-.275-.613c0-.412.463-.887.863-.887.35 0 .887.525.887.875s-.537.875-.912.875c-.163 0-.413-.113-.563-.25zM73.725 55.45c-2.087-.475-3-1.175-4.713-3.575-.375-.512-.975-1.262-1.337-1.65-.375-.388-.675-.762-.675-.85 0-.15.512-.375.85-.375.137 0 .35.275.587.725.988 1.9 3.038 3.038 6.275 3.462.95.126 2.513.188 4.738.188h3.312l-.4.575c-.45.662-1.175 1.05-2.55 1.363-1.187.274-5.1.362-6.087.137zM78.375 50.55c-3.6-.25-6.912-1.363-8.387-2.837-.376-.376-.776-.863-.9-1.076l-.226-.387.55.237c1.663.713 4.475 1.125 8.475 1.225l2.963.075.075.45c.037.25.075.888.075 1.425v.963l-1.025-.025c-.575-.013-1.288-.038-1.6-.05zM82.275 49l.037-1.413 1.163-.237c1.462-.287 2.612-.75 4.838-1.925.974-.512 1.812-.925 1.85-.925.112 0-.576 1.15-1.238 2.075-.662.95-2.112 2.3-2.975 2.788-.825.475-2 .85-2.962.962l-.75.088.037-1.413zM75.65 45.438c-.5-.613-.775-1.426-.775-2.276 0-.637.3-1.662.5-1.662.05 0 .212.475.362 1.05.213.775.376 1.137.65 1.4.376.362.388.362 1.963.362 1.45-.012 1.688-.037 2.713-.4.625-.225 2.05-.825 3.187-1.337 2.275-1.05 2.438-1.188 2.588-2.438.1-.862-.25-1.537-1.563-3.05-3.087-3.562-4.387-5.425-5.337-7.687-.738-1.762-1.063-3.938-.613-4.112.263-.1.513.237.675.9.538 2.137 3.963 6.974 7.475 10.562.838.863 1.563 1.7 1.613 1.85.037.163-.05.7-.213 1.188-.15.5-.338 1.175-.412 1.5-.138.587-.163.612-1.538 1.462-3.525 2.163-5.812 2.95-9.062 3.087l-1.813.075-.4-.474zM39.95 40.975c-.6-1.262-.713-3.212-.25-4.537.287-.838.25-.938-.35-.938-.425 0-.613.075-.95.412-.412.388-.425.388-.338.088.176-.625.713-1.387 1.188-1.7.637-.425 1.313-.5 2.1-.25 1.775.588 3.025 2.462 3.025 4.525 0 .6-.037.812-.15.775-.087-.025-.463-.613-.813-1.3-.774-1.462-1-1.675-1.724-1.675-.438 0-.6.063-.788.313-.4.5-.575 1.5-.575 3.274-.013.913-.025 1.663-.038 1.663-.012 0-.162-.3-.337-.65zM67.688 33.175c-1.976-.487-2.726-1.188-2.313-2.188.188-.425.338-.45 1.875-.175 1.55.275 2.8.25 3.462-.075.3-.137.538-.325.538-.4 0-.087-.188-.462-.412-.837-1.038-1.738-1.788-3.663-1.925-4.875-.088-.938.075-.963.462-.087 1.263 2.837 1.463 3.187 2.488 4.262 1.062 1.137 1.25 1.538 1.087 2.4-.112.55-.912 1.363-1.7 1.712-.437.2-.875.263-1.937.288-.75.025-1.488.013-1.625-.025zM87.537 31.863c-.537-.163-1.137-.788-1.237-1.3-.125-.7-.1-.713 2.275-.938 1.45-.138 2.175-.313 2.175-.525 0-.075-.225-.725-.5-1.462-.65-1.738-.875-2.663-.875-3.513l.013-.687 1.174 2.4c.638 1.325 1.376 2.75 1.626 3.15.362.6.424.8.324 1-.337.625-1.8 1.475-3.1 1.812-.837.225-1.274.237-1.874.063zM57.7 22.6c-.438-.613-.063-2.275.762-3.513 1.476-2.187 3.9-3.75 5.8-3.737 1.388.013 2.738 1.213 2.388 2.138-.1.287-.138.287-1.85.312-1.662.013-1.775.025-2.55.4-1.487.713-2.6 1.85-3.65 3.763-.275.5-.55.912-.6.912-.062 0-.2-.125-.3-.275z"></path>
      </g>
    </svg>
  );
};

const DjangoIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#003A2B"
        d="M126.5 83.8c0 3.8-3.1 6.9-6.9 6.9H8.4c-3.8 0-6.9-3.1-6.9-6.9V44.2c0-3.8 3.1-6.9 6.9-6.9h111.2c3.8 0 6.9 3.1 6.9 6.9v39.6z"
      ></path>
      <path
        fill="#fff"
        d="M23 45.6h6V73c-3 .6-5.3.8-7.7.8-7.2 0-11-3.3-11-9.5 0-6 4-10 10.2-10 1 0 1.7.1 2.6.3v-9H23zm0 13.8c-.7-.2-1.3-.3-2-.3-3 0-4.7 1.8-4.7 5.1 0 3.2 1.7 4.9 4.7 4.9.7 0 1.2 0 2-.2v-9.5zm15.4-4.6v13.7c0 4.7-.3 7-1.4 9-1 1.9-2.2 3.1-4.8 4.4l-5.5-2.6c2.6-1.2 3.9-2.3 4.7-4 .8-1.7 1.1-3.7 1.1-8.8V54.8h5.9zm-5.9-9.1h5.9v6.1h-5.9v-6.1zM42 56.1c2.6-1.2 5.1-1.8 7.8-1.8 3 0 5 .8 5.9 2.4.5.9.7 2 .7 4.5v12c-2.7.4-6 .7-8.5.7-5 0-7.2-1.7-7.2-5.6 0-4.2 3-6.1 10.2-6.7v-1.3c0-1.1-.5-1.5-2-1.5-2.2 0-4.7.6-7 1.8v-4.5h.1zm9.2 9.4c-3.9.4-5.2 1-5.2 2.5 0 1.2.7 1.7 2.3 1.7.9 0 1.7-.1 2.8-.3v-3.9h.1zm8.1-9.8c3.5-.9 6.4-1.3 9.3-1.3 3 0 5.2.7 6.5 2 1.2 1.3 1.6 2.7 1.6 5.6v11.6h-5.9V62.2c0-2.3-.8-3.1-2.9-3.1-.8 0-1.5.1-2.7.4v14.1h-5.9V55.7zM79 76.8c2.1 1.1 4.2 1.6 6.3 1.6 3.9 0 5.5-1.6 5.5-5.3V73c-1.2.6-2.3.8-3.8.8-5.2 0-8.5-3.4-8.5-8.8 0-6.7 4.9-10.5 13.5-10.5 2.5 0 4.9.3 7.7.8l-2 4.3c-1.6-.3-.1 0-1.3-.2v.6l.1 2.5v3.2c0 .8 0 1.6.1 2.4v1.6c0 5.1-.4 7.5-1.7 9.4-1.8 2.9-5 4.3-9.6 4.3-2.3 0-4.3-.3-6.4-1.2v-5.4h.1zm11.8-17.6h-.6c-1.2 0-2.5.3-3.4.8-1.4.8-2.2 2.3-2.2 4.3 0 3 1.5 4.7 4.1 4.7.8 0 1.5-.2 2.2-.4v-9.4h-.1zm18.2-4.9c5.9 0 9.5 3.7 9.5 9.8 0 6.2-3.8 10.1-9.8 10.1-5.9 0-9.6-3.7-9.6-9.7.1-6.3 3.9-10.2 9.9-10.2zm-.1 15c2.3 0 3.6-1.9 3.6-5.2 0-3.2-1.3-5.2-3.6-5.2s-3.7 1.9-3.7 5.2c.1 3.4 1.4 5.2 3.7 5.2z"
      ></path>
    </svg>
  );
};

const GroovyIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path d="M103.555 95.851L64 80.52 24.446 95.847l15.618-24.436L0 56.447l49.208.23L63.999 32.1l14.794 24.578L128 56.453l-40.065 14.96 15.62 24.438"></path>
      <path
        d="M98.204 91.48l-34.17-13.244-34.168 13.242 13.491-21.11-34.61-12.926 42.506.198L64.03 36.41l12.78 21.23 42.509-.194L84.71 70.37l13.493 21.11"
        fill="#619cbc"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-11.091 5.262-13.686 5.262-.315 0-.655-.09-.805-.295 1.094-.696 1.78-1.41 2.27-2.446.585-1.242.577-2.406.5-3.477.207.12 7.842-.068 8.118-.068 1.123 0 2.086-1.085 2.536-2.04.827-1.751.686-3.539.543-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.125 0 .013.22.018.331.077 1.806.044 4.328-.926 6.384-.451.955-1.189 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.353 2.842 2.477 10.677 5.94 10.677.84 0 1.71-.788 2.067-1.545 1.539-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-11.091 5.262-13.686 5.262-.315 0-.655-.09-.805-.295 1.094-.696 1.78-1.41 2.27-2.446.585-1.242.577-2.406.5-3.477.207.12 7.842-.068 8.118-.068 1.123 0 2.086-1.085 2.536-2.04.827-1.751.686-3.539.543-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.125 0 .013.22.018.331.077 1.806.044 4.328-.926 6.384-.451.955-1.189 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.353 2.842 2.477 10.677 5.94 10.677.84 0 1.71-.788 2.067-1.545 1.539-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <g fill="#fff">
        <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
        <path
          d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
          fillRule="evenodd"
        ></path>
        <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
        <path
          d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-3.87 7.432-12.151 5.43-14.745 5.43-.315 0-.656-.09-.806-.295 1.094-.696 1.78-1.41 2.27-2.446.586-1.243.577-2.406.5-3.478.207.121.872.422 1.148.422 1.123 0 7.378 3.214 10.567-2.696.827-1.752.685-3.54.542-5.032a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.113c.126 0 .013.22.018.33.077 1.807.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.787 2.068-1.545 1.538-3.26-1.018-7.056-2.132-9.197"
          fillRule="evenodd"
        ></path>
      </g>
      <path d="M103.493 95.913l-39.525-15.35-39.525 15.346 15.606-24.464L.013 56.463l49.172.23 14.781-24.605L78.75 56.694l49.172-.225-40.036 14.978 15.609 24.466"></path>
      <path
        d="M98.204 91.48l-34.17-13.244-34.168 13.242 13.491-21.11-34.61-12.926 42.506.198L64.03 36.41l12.78 21.23 42.509-.194L84.71 70.37l13.493 21.11"
        fill="#619cbc"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-11.091 5.262-13.686 5.262-.315 0-.655-.09-.805-.295 1.094-.696 1.78-1.41 2.27-2.446.585-1.242.577-2.406.5-3.477.207.12 7.842-.068 8.118-.068 1.123 0 2.086-1.085 2.536-2.04.827-1.751.686-3.539.543-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.125 0 .013.22.018.331.077 1.806.044 4.328-.926 6.384-.451.955-1.189 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.353 2.842 2.477 10.677 5.94 10.677.84 0 1.71-.788 2.067-1.545 1.539-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-11.091 5.262-13.686 5.262-.315 0-.655-.09-.805-.295 1.094-.696 1.78-1.41 2.27-2.446.585-1.242.577-2.406.5-3.477.207.12 7.842-.068 8.118-.068 1.123 0 2.086-1.085 2.536-2.04.827-1.751.686-3.539.543-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.125 0 .013.22.018.331.077 1.806.044 4.328-.926 6.384-.451.955-1.189 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.353 2.842 2.477 10.677 5.94 10.677.84 0 1.71-.788 2.067-1.545 1.539-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        stroke-miterlimit="3.864"
        stroke-width=".47650595999999995"
      ></path>
      <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455"></path>
      <path
        d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
      <path
        d="M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665"
        fillRule="evenodd"
      ></path>
      <path
        d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M64.101 56.733c-.542 0-1.02.268-1.271.802-.528 1.119 2.106 2.25 1.728 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.54-1.402 1.363-1.762 2.127-1.339 2.835-.277 6.735 2.778 6.735 1.687 0 3.631-1.517 4.387-3.117.93-1.968-1.448-5.666-3.356-5.666z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
        fillRule="evenodd"
      ></path>
      <path
        d="M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M75.089 56.294c-.442 0-.83.16-1.043.61-.466.988 2.072 1.87 2.076 2.892-.265.313-1.008.665-1.331.665-1.828 0-3.208-2.478-1.647-4.32-.633.402-1.01 1.004-1.277 1.57-1.582 3.352.674 6.74 3.96 6.74 1.368 0 3.131-.76 3.842-2.266 1.005-2.13-2.576-5.89-4.58-5.89z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
      <path
        d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197"
        fillRule="evenodd"
      ></path>
      <path
        d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-1.154 2.445-4.12 4.772-6.716 4.772-.315 0-.655-.09-.806-.294 1.096-.696 1.78-1.41 2.27-2.446.587-1.243.578-2.407.5-3.478.208.12.873.422 1.15.422 1.122 0 2.085-1.085 2.536-2.04.827-1.751.685-3.539.542-5.031a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.114c.126 0 .013.22.018.331.077 1.806.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.788 2.067-1.545 1.54-3.26-1.017-7.057-2.13-9.197z"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        stroke-miterlimit="3.864"
        stroke-width="5.7179996"
      ></path>
      <g fill="#fff">
        <path d="M37.804 44.66c3.413 0 1.424 8.528.21 11.1-1.04 2.201-3.38 5.377-6.153 5.377-3.327 0-3.228-3.727-1.904-6.532.717-1.52 1.82-3.222 3.338-4.474-.39 1.307.925 2.2.393 3.325-.363.769-1.114 1.609-1.504 2.436-.631 1.337-.39 3.71 1.135 3.71 1.365 0 2.578-1.692 3.075-2.745 1.019-2.158 3.566-11.366.719-11.366-3.28 0-8.93 7.99-10.113 10.497-2.112 4.474-.58 9.984 4.231 9.984 3.252 0 5.926-3.126 7.218-5.862a14.931 14.931 0 001.353-4.781l.632-.116c.139 4.21 4.592 11.18 2.697 15.196-2.427 5.14-9.681 5.094-13.824 6.918-.87-2.037-2.05-3.93-3.711-5.376 3.695-1.243 12.775-3.33 14.75-7.512.83-1.758.264-4.671-.694-5.659a10.916 10.916 0 01-.689 1.89c-1.69 3.58-5.31 6.357-9.041 6.357-5.196 0-7.398-3.733-4.953-8.913 1.467-3.109 8.96-13.455 12.835-13.455M46.681 57.002c.206.508.803 3.38 1.256 3.38.979 0 2.748-2.663 3.222-3.355.87.57.388 1.767 2 1.767.73 0 1.098-1.573 1.858-1.599.026.636.067 1.211-.28 1.946-.534 1.132-1.886 2.666-3.215 2.666-.953 0-2.279-1.146-2.54-1.146-.282 0-.802.132-.967.483-.693 1.467 1.158 6.363 3.014 6.363.992 0 2.175-.728 3.213-1.176-.27 1.764-.308 3.251.05 4.77a5.674 5.674 0 01-2.942.85c-4.56 0-2.045-10.605-6.25-12.865l1.58-2.084"></path>
        <path
          d="M64.209 56.154c3.447 0 4.808 6.2 3.261 9.476-1.2 2.542-3.327 4.384-6.052 4.384-4.812 0-4.21-6.56-2.332-10.538.518-1.096 2.287-3.484 3.67-3.484.51 0 .93.162 1.453.162zm-.107.579c-.542 0-1.02.268-1.27.802-.53 1.118 2.105 2.25 1.727 3.051-.238.504-1.144.976-1.601.976-2.284 0-2.265-2.972-.903-4.908-.847.539-1.402 1.363-1.762 2.127-1.338 2.835-.276 6.734 2.778 6.734 1.688 0 3.631-1.516 4.387-3.117.93-1.968-1.448-5.665-3.356-5.665M79.875 66.36c-.901 1.908-2.58 2.955-4.47 2.955-5.997 0-7.187-5.469-4.587-10.975.613-1.3 1.62-2.737 3.159-2.737 4.818 0 8.174 5.933 5.897 10.757zM75.09 56.293c-.443 0-.83.16-1.043.61-.466.989 2.072 1.87 2.075 2.892-.265.314-1.007.665-1.33.665-1.828 0-3.208-2.478-1.647-4.32-.634.403-1.01 1.005-1.277 1.57-1.582 3.352.673 6.74 3.96 6.74 1.368 0 3.13-.76 3.841-2.266 1.006-2.13-2.576-5.89-4.58-5.89"
          fillRule="evenodd"
        ></path>
        <path d="M86.077 56.262c5.168 0 7.795 9.484 5.485 14.376-.441.935-1.264 1.87-2.35 1.87-5.904 0-4.397-11.737-7.72-15.072.303-.323.594-.66.861-1 2.246 2.635 1.13 9.572 5.927 9.572 1.105 0 1.941-.967 2.387-1.912 1.191-2.523-1.013-6.906-3.426-6.906-.024 0-.37.014-.363.154.09 1.611 1.356.607.08 3.348-1.303-.26-2.684-2.353-1.971-3.863.21-.444.734-.567 1.09-.567"></path>
        <path
          d="M98.927 56.154c.487.046 1.218.002 1.636.13.078.023.019.121.032.199.127.716.327 1.396.5 2.089.673 2.698 1.078 5.468 1.85 8.142.841 2.912 1.718 6.194.7 9.848-.1.357-.233.72-.405 1.085-3.87 7.432-12.151 5.43-14.745 5.43-.315 0-.656-.09-.806-.295 1.094-.696 1.78-1.41 2.27-2.446.586-1.243.577-2.406.5-3.478.207.121.872.422 1.148.422 1.123 0 7.378 3.214 10.567-2.696.827-1.752.685-3.54.542-5.032a23.224 23.224 0 00-.312-2.2l-.21-1.036-.027-.113-.026-.113c.126 0 .013.22.018.33.077 1.807.045 4.328-.926 6.384-.45.955-1.188 1.94-2.32 1.94-4.963 0-2.467-14.074-6.444-17.42.22-.363.417-.738.582-1.105 2.354 2.842 2.477 10.677 5.94 10.677.841 0 1.71-.787 2.068-1.545 1.538-3.26-1.018-7.056-2.132-9.197"
          fillRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

const GraphQLIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#E434AA">
        <path d="M18.39 96.852l-4.6-2.657L65.04 5.434l4.597 2.656zm0 0"></path>
        <path d="M12.734 87.105H115.23v5.31H12.734zm0 0"></path>
        <path d="M66.031 119.688L14.766 90.09l2.656-4.602 51.266 29.602zm0 0M110.566 42.543L59.301 12.941l2.656-4.597 51.266 29.597zm0 0"></path>
        <path d="M17.434 42.523l-2.657-4.601 51.27-29.598 2.656 4.598zm0 0"></path>
        <path d="M109.621 96.852L58.375 8.09l4.598-2.656 51.25 88.761zm0 0M16.8 34.398h5.313v59.204h-5.312zm0 0"></path>
        <path d="M105.887 34.398h5.312v59.204h-5.312zm0 0"></path>
        <path d="M65.129 117.441l-2.32-4.02 44.586-25.745 2.32 4.02zm0 0"></path>
        <path d="M118.238 95.328c-3.07 5.344-9.918 7.168-15.261 4.098-5.344-3.074-7.168-9.922-4.098-15.266 3.074-5.344 9.922-7.168 15.266-4.097 5.375 3.105 7.199 9.921 4.093 15.265M29.09 43.84c-3.074 5.344-9.922 7.168-15.266 4.097-5.344-3.074-7.168-9.921-4.097-15.265 3.074-5.344 9.921-7.168 15.265-4.098 5.344 3.106 7.168 9.922 4.098 15.266M9.762 95.328c-3.075-5.344-1.25-12.16 4.093-15.266 5.344-3.07 12.16-1.246 15.266 4.098 3.07 5.344 1.246 12.16-4.098 15.266-5.375 3.07-12.191 1.246-15.261-4.098M98.91 43.84c-3.07-5.344-1.246-12.16 4.098-15.266 5.344-3.07 12.16-1.246 15.265 4.098 3.07 5.344 1.247 12.16-4.097 15.266-5.344 3.07-12.192 1.246-15.266-4.098M64 126.656a11.158 11.158 0 01-11.168-11.168A11.158 11.158 0 0164 104.32a11.158 11.158 0 0111.168 11.168c0 6.145-4.992 11.168-11.168 11.168M64 23.68a11.158 11.158 0 01-11.168-11.168A11.158 11.158 0 0164 1.344a11.158 11.158 0 0111.168 11.168A11.158 11.158 0 0164 23.68"></path>
      </g>
    </svg>
  );
};

const AzureIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="azure-original-a"
          x1="60.919"
          y1="9.602"
          x2="18.667"
          y2="134.423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B"></stop>
          <stop offset="1" stopColor="#0669BC"></stop>
        </linearGradient>
        <linearGradient
          id="azure-original-b"
          x1="74.117"
          y1="67.772"
          x2="64.344"
          y2="71.076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity=".3"></stop>
          <stop offset=".071" stopOpacity=".2"></stop>
          <stop offset=".321" stopOpacity=".1"></stop>
          <stop offset=".623" stopOpacity=".05"></stop>
          <stop offset="1" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="azure-original-c"
          x1="68.742"
          y1="5.961"
          x2="115.122"
          y2="129.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4"></stop>
          <stop offset="1" stopColor="#2892DF"></stop>
        </linearGradient>
      </defs>
      <path
        d="M46.09.002h40.685L44.541 125.137a6.485 6.485 0 01-6.146 4.413H6.733a6.482 6.482 0 01-5.262-2.699 6.474 6.474 0 01-.876-5.848L39.944 4.414A6.488 6.488 0 0146.09 0z"
        fill="url(#azure-original-a)"
        transform="translate(.587 4.468) scale(.91904)"
      ></path>
      <path
        d="M97.28 81.607H37.987a2.743 2.743 0 00-1.874 4.751l38.1 35.562a5.991 5.991 0 004.087 1.61h33.574z"
        fill="#0078d4"
      ></path>
      <path
        d="M46.09.002A6.434 6.434 0 0039.93 4.5L.644 120.897a6.469 6.469 0 006.106 8.653h32.48a6.942 6.942 0 005.328-4.531l7.834-23.089 27.985 26.101a6.618 6.618 0 004.165 1.519h36.396l-15.963-45.616-46.533.011L86.922.002z"
        fill="url(#azure-original-b)"
        transform="translate(.587 4.468) scale(.91904)"
      ></path>
      <path
        d="M98.055 4.408A6.476 6.476 0 0091.917.002H46.575a6.478 6.478 0 016.137 4.406l39.35 116.594a6.476 6.476 0 01-6.137 8.55h45.344a6.48 6.48 0 006.136-8.55z"
        fill="url(#azure-original-c)"
        transform="translate(.587 4.468) scale(.91904)"
      ></path>
    </svg>
  );
};

const HerokuIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M114 13.9C114 7.3 108.7 2 102.1 2H25.9C19.3 2 14 7.3 14 13.9v100.3c0 6.6 5.3 11.9 11.9 11.9h76.3c6.6 0 11.9-5.3 11.9-11.9V13.9zm-4 .1v99.3c0 4.7-3.5 8.7-8.2 8.7H26.5c-4.7 0-8.5-4-8.5-8.7V14c0-4.7 3.9-8 8.5-8h75.2c4.7 0 8.4 3.6 8.4 8.3l-.1-.3zm-73 94.7l14.1-14.1L37 80.5zm14-60.9V18.4l-13.9.1s.1 45.9.2 45.7C80.1 47.5 77 59.4 77 59.4v49.4l-.1.2H90V59.5c0-27.1-39-11.7-39-11.7zM70 36h14.8c8-10 10.7-17 10.7-17H80.2S75.3 30 70 36z"
        fill="#6762A6"
      ></path>
    </svg>
  );
};

const PostgresIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path d="M93.809 92.112c.785-6.533.55-7.492 5.416-6.433l1.235.108c3.742.17 8.637-.602 11.513-1.938 6.191-2.873 9.861-7.668 3.758-6.409-13.924 2.873-14.881-1.842-14.881-1.842 14.703-21.815 20.849-49.508 15.543-56.287-14.47-18.489-39.517-9.746-39.936-9.52l-.134.025c-2.751-.571-5.83-.912-9.289-.968-6.301-.104-11.082 1.652-14.709 4.402 0 0-44.683-18.409-42.604 23.151.442 8.841 12.672 66.898 27.26 49.362 5.332-6.412 10.484-11.834 10.484-11.834 2.558 1.699 5.622 2.567 8.834 2.255l.249-.212c-.078.796-.044 1.575.099 2.497-3.757 4.199-2.653 4.936-10.166 6.482-7.602 1.566-3.136 4.355-.221 5.084 3.535.884 11.712 2.136 17.238-5.598l-.22.882c1.474 1.18 1.375 8.477 1.583 13.69.209 5.214.558 10.079 1.621 12.948 1.063 2.868 2.317 10.256 12.191 8.14 8.252-1.764 14.561-4.309 15.136-27.985"></path>
      <path d="M75.458 125.256c-4.367 0-7.211-1.689-8.938-3.32-2.607-2.46-3.641-5.629-4.259-7.522l-.267-.79c-1.244-3.358-1.666-8.193-1.916-14.419-.038-.935-.064-1.898-.093-2.919-.021-.747-.047-1.684-.085-2.664a18.8 18.8 0 01-4.962 1.568c-3.079.526-6.389.356-9.84-.507-2.435-.609-4.965-1.871-6.407-3.82-4.203 3.681-8.212 3.182-10.396 2.453-3.853-1.285-7.301-4.896-10.542-11.037-2.309-4.375-4.542-10.075-6.638-16.943-3.65-11.96-5.969-24.557-6.175-28.693C4.292 23.698 7.777 14.44 15.296 9.129 27.157.751 45.128 5.678 51.68 7.915c4.402-2.653 9.581-3.944 15.433-3.851 3.143.051 6.136.327 8.916.823 2.9-.912 8.628-2.221 15.185-2.139 12.081.144 22.092 4.852 28.949 13.615 4.894 6.252 2.474 19.381.597 26.651-2.642 10.226-7.271 21.102-12.957 30.57 1.544.011 3.781-.174 6.961-.831 6.274-1.295 8.109 2.069 8.607 3.575 1.995 6.042-6.677 10.608-9.382 11.864-3.466 1.609-9.117 2.589-13.745 2.377l-.202-.013-1.216-.107-.12 1.014-.116.991c-.311 11.999-2.025 19.598-5.552 24.619-3.697 5.264-8.835 6.739-13.361 7.709-1.544.33-2.947.474-4.219.474zm-9.19-43.671c2.819 2.256 3.066 6.501 3.287 14.434.028.99.054 1.927.089 2.802.106 2.65.355 8.855 1.327 11.477.137.371.26.747.39 1.146 1.083 3.316 1.626 4.979 6.309 3.978 3.931-.843 5.952-1.599 7.534-3.851 2.299-3.274 3.585-9.86 3.821-19.575l4.783.116-4.75-.57.14-1.186c.455-3.91.783-6.734 3.396-8.602 2.097-1.498 4.486-1.353 6.389-1.01-2.091-1.58-2.669-3.433-2.823-4.193l-.399-1.965 1.121-1.663c6.457-9.58 11.781-21.354 14.609-32.304 2.906-11.251 2.02-17.226 1.134-18.356-11.729-14.987-32.068-8.799-34.192-8.097l-.359.194-1.8.335-.922-.191c-2.542-.528-5.366-.82-8.393-.869-4.756-.08-8.593 1.044-11.739 3.431l-2.183 1.655-2.533-1.043c-5.412-2.213-21.308-6.662-29.696-.721-4.656 3.298-6.777 9.76-6.305 19.207.156 3.119 2.275 14.926 5.771 26.377 4.831 15.825 9.221 21.082 11.054 21.693.32.108 1.15-.537 1.976-1.529a270.708 270.708 0 0110.694-12.07l2.77-2.915 3.349 2.225c1.35.897 2.839 1.406 4.368 1.502l7.987-6.812-1.157 11.808c-.026.265-.039.626.065 1.296l.348 2.238-1.51 1.688-.174.196 4.388 2.025 1.836-2.301z"></path>
      <path
        fill="#336791"
        d="M115.731 77.44c-13.925 2.873-14.882-1.842-14.882-1.842 14.703-21.816 20.849-49.51 15.545-56.287C101.924.823 76.875 9.566 76.457 9.793l-.135.024c-2.751-.571-5.83-.911-9.291-.967-6.301-.103-11.08 1.652-14.707 4.402 0 0-44.684-18.408-42.606 23.151.442 8.842 12.672 66.899 27.26 49.363 5.332-6.412 10.483-11.834 10.483-11.834 2.559 1.699 5.622 2.567 8.833 2.255l.25-.212c-.078.796-.042 1.575.1 2.497-3.758 4.199-2.654 4.936-10.167 6.482-7.602 1.566-3.136 4.355-.22 5.084 3.534.884 11.712 2.136 17.237-5.598l-.221.882c1.473 1.18 2.507 7.672 2.334 13.557-.174 5.885-.29 9.926.871 13.082 1.16 3.156 2.316 10.256 12.192 8.14 8.252-1.768 12.528-6.351 13.124-13.995.422-5.435 1.377-4.631 1.438-9.49l.767-2.3c.884-7.367.14-9.743 5.225-8.638l1.235.108c3.742.17 8.639-.602 11.514-1.938 6.19-2.871 9.861-7.667 3.758-6.408z"
      ></path>
      <path
        fill="#fff"
        d="M75.957 122.307c-8.232 0-10.84-6.519-11.907-9.185-1.562-3.907-1.899-19.069-1.551-31.503a1.59 1.59 0 011.64-1.55 1.594 1.594 0 011.55 1.639c-.401 14.341.168 27.337 1.324 30.229 1.804 4.509 4.54 8.453 12.275 6.796 7.343-1.575 10.093-4.359 11.318-11.46.94-5.449 2.799-20.951 3.028-24.01a1.593 1.593 0 011.71-1.472 1.597 1.597 0 011.472 1.71c-.239 3.185-2.089 18.657-3.065 24.315-1.446 8.387-5.185 12.191-13.794 14.037-1.463.313-2.792.453-4 .454zM31.321 90.466a6.71 6.71 0 01-2.116-.35c-5.347-1.784-10.44-10.492-15.138-25.885-3.576-11.717-5.842-23.947-6.041-27.922-.589-11.784 2.445-20.121 9.02-24.778 13.007-9.216 34.888-.44 35.813-.062a1.596 1.596 0 01-1.207 2.955c-.211-.086-21.193-8.492-32.768-.285-5.622 3.986-8.203 11.392-7.672 22.011.167 3.349 2.284 15.285 5.906 27.149 4.194 13.742 8.967 22.413 13.096 23.79.648.216 2.62.873 5.439-2.517A245.272 245.272 0 0145.88 73.046a1.596 1.596 0 012.304 2.208c-.048.05-4.847 5.067-10.077 11.359-2.477 2.979-4.851 3.853-6.786 3.853zm69.429-13.445a1.596 1.596 0 01-1.322-2.487c14.863-22.055 20.08-48.704 15.612-54.414-5.624-7.186-13.565-10.939-23.604-11.156-7.433-.16-13.341 1.738-14.307 2.069l-.243.099c-.971.305-1.716-.227-1.997-.849a1.6 1.6 0 01.631-2.025c.046-.027.192-.089.429-.176l-.021.006.021-.007c1.641-.601 7.639-2.4 15.068-2.315 11.108.118 20.284 4.401 26.534 12.388 2.957 3.779 2.964 12.485.019 23.887-3.002 11.625-8.651 24.118-15.497 34.277-.306.457-.81.703-1.323.703zm.76 10.21c-2.538 0-4.813-.358-6.175-1.174-1.4-.839-1.667-1.979-1.702-2.584-.382-6.71 3.32-7.878 5.208-8.411-.263-.398-.637-.866-1.024-1.349-1.101-1.376-2.609-3.26-3.771-6.078-.182-.44-.752-1.463-1.412-2.648-3.579-6.418-11.026-19.773-6.242-26.612 2.214-3.165 6.623-4.411 13.119-3.716C97.6 28.837 88.5 10.625 66.907 10.271c-6.494-.108-11.82 1.889-15.822 5.93-8.96 9.049-8.636 25.422-8.631 25.586a1.595 1.595 0 11-3.19.084c-.02-.727-.354-17.909 9.554-27.916C53.455 9.272 59.559 6.96 66.96 7.081c13.814.227 22.706 7.25 27.732 13.101 5.479 6.377 8.165 13.411 8.386 15.759.165 1.746-1.088 2.095-1.341 2.147l-.576.013c-6.375-1.021-10.465-.312-12.156 2.104-3.639 5.201 3.406 17.834 6.414 23.229.768 1.376 1.322 2.371 1.576 2.985.988 2.396 2.277 4.006 3.312 5.3.911 1.138 1.7 2.125 1.982 3.283.131.23 1.99 2.98 13.021.703 2.765-.57 4.423-.083 4.93 1.45.997 3.015-4.597 6.532-7.694 7.97-2.775 1.29-7.204 2.106-11.036 2.106zm-4.696-4.021c.35.353 2.101.962 5.727.806 3.224-.138 6.624-.839 8.664-1.786 2.609-1.212 4.351-2.567 5.253-3.492l-.5.092c-7.053 1.456-12.042 1.262-14.828-.577a6.162 6.162 0 01-.54-.401c-.302.119-.581.197-.78.253-1.58.443-3.214.902-2.996 5.105zm-45.562 8.915c-1.752 0-3.596-.239-5.479-.71-1.951-.488-5.24-1.957-5.19-4.37.057-2.707 3.994-3.519 5.476-3.824 5.354-1.103 5.703-1.545 7.376-3.67.488-.619 1.095-1.39 1.923-2.314 1.229-1.376 2.572-2.073 3.992-2.073.989 0 1.8.335 2.336.558 1.708.708 3.133 2.42 3.719 4.467.529 1.847.276 3.625-.71 5.006-3.237 4.533-7.886 6.93-13.443 6.93zm-7.222-4.943c.481.372 1.445.869 2.518 1.137 1.631.408 3.213.615 4.705.615 4.546 0 8.196-1.882 10.847-5.594.553-.774.387-1.757.239-2.274-.31-1.083-1.08-2.068-1.873-2.397-.43-.178-.787-.314-1.115-.314-.176 0-.712 0-1.614 1.009a41.146 41.146 0 00-1.794 2.162c-2.084 2.646-3.039 3.544-9.239 4.821-1.513.31-2.289.626-2.674.835zm12.269-7.36a1.596 1.596 0 01-1.575-1.354 8.218 8.218 0 01-.08-.799c-4.064-.076-7.985-1.82-10.962-4.926-3.764-3.927-5.477-9.368-4.699-14.927.845-6.037.529-11.366.359-14.229-.047-.796-.081-1.371-.079-1.769.003-.505.013-1.844 4.489-4.113 1.592-.807 4.784-2.215 8.271-2.576 5.777-.597 9.585 1.976 10.725 7.246 3.077 14.228.244 20.521-1.825 25.117-.385.856-.749 1.664-1.04 2.447l-.257.69c-1.093 2.931-2.038 5.463-1.748 7.354a1.595 1.595 0 01-1.335 1.819l-.244.02zM42.464 42.26l.062 1.139c.176 2.974.504 8.508-.384 14.86-.641 4.585.759 9.06 3.843 12.276 2.437 2.542 5.644 3.945 8.94 3.945h.068c.369-1.555.982-3.197 1.642-4.966l.255-.686c.329-.884.714-1.74 1.122-2.646 1.991-4.424 4.47-9.931 1.615-23.132-.565-2.615-1.936-4.128-4.189-4.627-4.628-1.022-11.525 2.459-12.974 3.837zm9.63-.677c-.08.564 1.033 2.07 2.485 2.271 1.449.203 2.689-.975 2.768-1.539.079-.564-1.033-1.186-2.485-1.388-1.451-.202-2.691.092-2.768.656zm2.818 2.826l-.407-.028c-.9-.125-1.81-.692-2.433-1.518-.219-.29-.576-.852-.505-1.354.101-.736.999-1.177 2.4-1.177.313 0 .639.023.967.069.766.106 1.477.327 2.002.62.91.508.977 1.075.936 1.368-.112.813-1.405 2.02-2.96 2.02zm-2.289-2.732c.045.348.907 1.496 2.029 1.651l.261.018c1.036 0 1.81-.815 1.901-1.082-.096-.182-.762-.634-2.025-.81a5.823 5.823 0 00-.821-.059c-.812 0-1.243.183-1.345.282zm43.605-1.245c.079.564-1.033 2.07-2.484 2.272-1.45.202-2.691-.975-2.771-1.539-.076-.564 1.036-1.187 2.486-1.388 1.45-.203 2.689.092 2.769.655zm-2.819 2.56c-1.396 0-2.601-1.086-2.7-1.791-.115-.846 1.278-1.489 2.712-1.688.316-.044.629-.066.93-.066 1.238 0 2.058.363 2.14.949.053.379-.238.964-.739 1.492-.331.347-1.026.948-1.973 1.079l-.37.025zm.943-3.013c-.276 0-.564.021-.856.061-1.441.201-2.301.779-2.259 1.089.048.341.968 1.332 2.173 1.332l.297-.021c.787-.109 1.378-.623 1.66-.919.443-.465.619-.903.598-1.052-.028-.198-.56-.49-1.613-.49zm3.965 32.843a1.594 1.594 0 01-1.324-2.483c3.398-5.075 2.776-10.25 2.175-15.255-.257-2.132-.521-4.337-.453-6.453.07-2.177.347-3.973.614-5.71.317-2.058.617-4.002.493-6.31a1.595 1.595 0 113.186-.172c.142 2.638-.197 4.838-.525 6.967-.253 1.643-.515 3.342-.578 5.327-.061 1.874.178 3.864.431 5.97.64 5.322 1.365 11.354-2.691 17.411a1.596 1.596 0 01-1.328.708z"
      ></path>
    </svg>
  );
};

const MySQLIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#00618A"
        d="M116.948 97.807c-6.863-.187-12.104.452-16.585 2.341-1.273.537-3.305.552-3.513 2.147.7.733.809 1.829 1.365 2.731 1.07 1.73 2.876 4.052 4.488 5.268 1.762 1.33 3.577 2.751 5.465 3.902 3.358 2.047 7.107 3.217 10.34 5.268 1.906 1.21 3.799 2.733 5.658 4.097.92.675 1.537 1.724 2.732 2.147v-.194c-.628-.8-.79-1.898-1.366-2.733l-2.537-2.537c-2.48-3.292-5.629-6.184-8.976-8.585-2.669-1.916-8.642-4.504-9.755-7.609l-.195-.195c1.892-.214 4.107-.898 5.854-1.367 2.934-.786 5.556-.583 8.585-1.365l4.097-1.171v-.78c-1.531-1.571-2.623-3.651-4.292-5.073-4.37-3.72-9.138-7.437-14.048-10.537-2.724-1.718-6.089-2.835-8.976-4.292-.971-.491-2.677-.746-3.318-1.562-1.517-1.932-2.342-4.382-3.511-6.633-2.449-4.717-4.854-9.868-7.024-14.831-1.48-3.384-2.447-6.72-4.293-9.756-8.86-14.567-18.396-23.358-33.169-32-3.144-1.838-6.929-2.563-10.929-3.513-2.145-.129-4.292-.26-6.438-.391-1.311-.546-2.673-2.149-3.902-2.927C17.811 4.565 5.257-2.16 1.633 6.682c-2.289 5.581 3.421 11.025 5.462 13.854 1.434 1.982 3.269 4.207 4.293 6.438.674 1.467.79 2.938 1.367 4.489 1.417 3.822 2.652 7.98 4.487 11.511.927 1.788 1.949 3.67 3.122 5.268.718.981 1.951 1.413 2.145 2.927-1.204 1.686-1.273 4.304-1.95 6.44-3.05 9.615-1.899 21.567 2.537 28.683 1.36 2.186 4.567 6.871 8.975 5.073 3.856-1.57 2.995-6.438 4.098-10.732.249-.973.096-1.689.585-2.341v.195l3.513 7.024c2.6 4.187 7.212 8.562 11.122 11.514 2.027 1.531 3.623 4.177 6.244 5.073v-.196h-.195c-.508-.791-1.303-1.119-1.951-1.755-1.527-1.497-3.225-3.358-4.487-5.073-3.556-4.827-6.698-10.11-9.561-15.609-1.368-2.627-2.557-5.523-3.709-8.196-.444-1.03-.438-2.589-1.364-3.122-1.263 1.958-3.122 3.542-4.098 5.854-1.561 3.696-1.762 8.204-2.341 12.878-.342.122-.19.038-.391.194-2.718-.655-3.672-3.452-4.683-5.853-2.554-6.07-3.029-15.842-.781-22.829.582-1.809 3.21-7.501 2.146-9.172-.508-1.666-2.184-2.63-3.121-3.903-1.161-1.574-2.319-3.646-3.124-5.464-2.09-4.731-3.066-10.044-5.267-14.828-1.053-2.287-2.832-4.602-4.293-6.634-1.617-2.253-3.429-3.912-4.683-6.635-.446-.968-1.051-2.518-.391-3.513.21-.671.508-.951 1.171-1.17 1.132-.873 4.284.29 5.462.779 3.129 1.3 5.741 2.538 8.392 4.294 1.271.844 2.559 2.475 4.097 2.927h1.756c2.747.631 5.824.195 8.391.975 4.536 1.378 8.601 3.523 12.292 5.854 11.246 7.102 20.442 17.21 26.732 29.269 1.012 1.942 1.45 3.794 2.341 5.854 1.798 4.153 4.063 8.426 5.852 12.488 1.786 4.052 3.526 8.141 6.05 11.513 1.327 1.772 6.451 2.723 8.781 3.708 1.632.689 4.307 1.409 5.854 2.34 2.953 1.782 5.815 3.903 8.586 5.855 1.383.975 5.64 3.116 5.852 4.879zM29.729 23.466c-1.431-.027-2.443.156-3.513.389v.195h.195c.683 1.402 1.888 2.306 2.731 3.513.65 1.367 1.301 2.732 1.952 4.097l.194-.193c1.209-.853 1.762-2.214 1.755-4.294-.484-.509-.555-1.147-.975-1.755-.556-.811-1.635-1.272-2.339-1.952z"
      ></path>
    </svg>
  );
};

const PSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#80B5E2"
        d="M50.246 41.616c-3.682-.925-7.369-.628-11.26-.022 0 6.805-.014 13.427.037 20.05.002.339.511.929.841.974 4.243.573 8.463.619 12.431-1.315 4.105-2 6.196-6.182 5.654-11.092-.492-4.471-3.139-7.448-7.703-8.595zM127 63.963V3.285c0-2.096.023-2.285-2.012-2.285H3.479C1.5 1 1 1.19 1 3.186v121.509c0 2.018.252 2.021 2.209 2.021 40.555.001 81.231-.009 121.786.037 1.573.002 1.995-.417 1.991-1.959-.054-20.277.014-40.556.014-60.831zm-70.648 5.84C50.795 71.785 45 71.896 39 71.431V94H28v-1.402c0-18.895-.087-37.788-.14-56.682-.006-1.569.243-2.327 2.011-2.507 8.332-.852 16.617-1.81 24.902.133 8.906 2.087 14.041 7.975 14.431 16.11.483 10.074-3.944 16.974-12.852 20.151zm44.31 12.754c-.424 5.771-3.678 9.56-9.015 11.392-7.142 2.452-14.245 1.883-21.225-.891-1.143-.455-1.364-1.031-.987-2.196.687-2.126 1.19-4.312 1.72-6.286 2.951.866 5.757 1.947 8.664 2.458 2.053.361 4.272.149 6.359-.178 1.871-.294 3.217-1.564 3.524-3.572.312-2.041-.303-3.809-2.105-4.895-1.432-.862-3.01-1.479-4.523-2.202-2.433-1.163-5.026-2.075-7.27-3.53-8.831-5.727-5.956-16.383-.063-20.396 3.153-2.146 6.642-3.098 10.377-3.229 4.393-.154 8.623.604 12.778 2.623l-2.195 7.789c-1.74-.616-3.36-1.416-5.07-1.734-2.029-.378-4.157-.589-6.205-.422-2.746.225-4.354 2.12-4.354 4.47 0 1.392.528 2.57 1.689 3.245 1.666.969 3.434 1.768 5.186 2.579 1.896.877 3.898 1.551 5.723 2.552 4.87 2.67 7.405 6.8 6.992 12.423z"
      ></path>
    </svg>
  );
};

const SketchIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#fdb300"
        d="M29.62 12.85L64 9.24l34.38 3.61L125 48.29l-61 70.47L3 48.29z"
      ></path>
      <path
        fill="#ea6c00"
        d="M27.71 48.29L64 118.76 3 48.29h24.71zM100.29 48.29L64 118.76l61-70.47h-24.71z"
      ></path>
      <path fill="#fdad00" d="M27.71 48.29h72.58L64 118.76 27.71 48.29z"></path>
      <path
        fill="#fdd231"
        d="M64 9.24l-34.38 3.61-1.91 35.44L64 9.24zM64 9.24l34.38 3.61 1.91 35.44L64 9.24z"
      ></path>
      <path fill="#fdad00" d="M125 48.29L98.38 12.85l1.91 35.44H125z"></path>
      <path fill="#feeeb7" d="M64 9.24L27.71 48.29h72.58L64 9.24z"></path>
      <path fill="#fdad00" d="M3 48.29l26.62-35.44-1.91 35.44H3z"></path>
    </svg>
  );
};

const FigmaIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#0acf83"
        d="M45.5 129c11.9 0 21.5-9.6 21.5-21.5V86H45.5C33.6 86 24 95.6 24 107.5S33.6 129 45.5 129zm0 0"
      ></path>
      <path
        fill="#a259ff"
        d="M24 64.5C24 52.6 33.6 43 45.5 43H67v43H45.5C33.6 86 24 76.4 24 64.5zm0 0"
      ></path>
      <path
        fill="#f24e1e"
        d="M24 21.5C24 9.6 33.6 0 45.5 0H67v43H45.5C33.6 43 24 33.4 24 21.5zm0 0"
      ></path>
      <path
        fill="#ff7262"
        d="M67 0h21.5C100.4 0 110 9.6 110 21.5S100.4 43 88.5 43H67zm0 0"
      ></path>
      <path
        fill="#1abcfe"
        d="M110 64.5c0 11.9-9.6 21.5-21.5 21.5S67 76.4 67 64.5 76.6 43 88.5 43 110 52.6 110 64.5zm0 0"
      ></path>
    </svg>
  );
};

const IllustratorIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAA625"
        d="M47.955 69h15.371c-2.646-9-5.252-17.32-7.816-25.776C53.022 51.71 50.498 60 47.955 69zm76.157-68H2.873C.687 1 1 1.476 1 3.585v121.394C1 127.086.687 127 2.719 127h121.547c2.031 0 2.734.086 2.734-2.022V3.739C127 1.476 126.298 1 124.112 1zM77.298 96c-1.637 0-3.28-.133-4.909-.016-1.175.088-1.568-.406-1.881-1.426-1.514-4.931-3.123-9.86-4.638-14.79-.305-.992-.741-1.354-1.816-1.341-5.523.064-11.049.058-16.573-.007-1.163-.014-1.698.296-2.03 1.45-1.406 4.904-2.944 9.768-4.365 14.667-.308 1.062-.776 1.433-1.904 1.404-3.318-.083-6.641-.032-10.274-.032.959-3.045 1.829-5.861 2.729-8.665 5.514-17.2 11.047-34.4 16.521-51.611.382-1.198.913-1.567 2.143-1.54 3.886.086 7.775.022 11.663 0 .727-.005 1.223.038 1.489.864 6.505 20.116 13.033 40.356 19.555 60.47.028.091.01.573.025.573h-5.735zM98 96H86V51h12v45zm-6.35-51.071c-3.665-.005-6.289-2.528-6.314-6.07-.024-3.532 2.707-6.159 6.406-6.163 3.728-.004 6.355 2.537 6.384 6.171.026 3.545-2.667 6.068-6.476 6.062z"
      ></path>
    </svg>
  );
};

const AfterEffectsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path fill="#1F0740" d="M6.5 6.5h115v115H6.5z"></path>
      <path
        fill="#D490C5"
        d="M0 0v128h128V0H0zm121.5 121.5H6.5V6.5h115v115z"
      ></path>
      <path
        fill="#D490C5"
        d="M103.5 59.2s-.6-14.6-16.5-14.6c-16 0-17.3 22-17.3 22v4.7S72.5 89.6 86 89.6s14.8-2.6 14.8-2.6v-8.1s-19.3 9.2-21.2-10h24v-9.7zm-9 2.4h-15s0-8.3 7.5-9.2c8.2 0 7.5 9.2 7.5 9.2zM50.5 29.9H38.4v3.8l-16 54.9h9.4l4.4-16.1H53l4.5 16.1h10.3L50.5 29.9zM38.2 63.1l6.4-24.5L51 63.1H38.2z"
      ></path>
    </svg>
  );
};

export const PythonIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <linearGradient
        id="python-original-a"
        gradientUnits="userSpaceOnUse"
        x1="70.252"
        y1="1237.476"
        x2="170.659"
        y2="1151.089"
        gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
      >
        <stop offset="0" stopColor="#5A9FD4"></stop>
        <stop offset="1" stopColor="#306998"></stop>
      </linearGradient>
      <linearGradient
        id="python-original-b"
        gradientUnits="userSpaceOnUse"
        x1="209.474"
        y1="1098.811"
        x2="173.62"
        y2="1149.537"
        gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
      >
        <stop offset="0" stopColor="#FFD43B"></stop>
        <stop offset="1" stopColor="#FFE873"></stop>
      </linearGradient>
      <path
        fill="url(#python-original-a)"
        d="M63.391 1.988c-4.222.02-8.252.379-11.8 1.007-10.45 1.846-12.346 5.71-12.346 12.837v9.411h24.693v3.137H29.977c-7.176 0-13.46 4.313-15.426 12.521-2.268 9.405-2.368 15.275 0 25.096 1.755 7.311 5.947 12.519 13.124 12.519h8.491V67.234c0-8.151 7.051-15.34 15.426-15.34h24.665c6.866 0 12.346-5.654 12.346-12.548V15.833c0-6.693-5.646-11.72-12.346-12.837-4.244-.706-8.645-1.027-12.866-1.008zM50.037 9.557c2.55 0 4.634 2.117 4.634 4.721 0 2.593-2.083 4.69-4.634 4.69-2.56 0-4.633-2.097-4.633-4.69-.001-2.604 2.073-4.721 4.633-4.721z"
        transform="translate(0 10.26)"
      ></path>
      <path
        fill="url(#python-original-b)"
        d="M91.682 28.38v10.966c0 8.5-7.208 15.655-15.426 15.655H51.591c-6.756 0-12.346 5.783-12.346 12.549v23.515c0 6.691 5.818 10.628 12.346 12.547 7.816 2.297 15.312 2.713 24.665 0 6.216-1.801 12.346-5.423 12.346-12.547v-9.412H63.938v-3.138h37.012c7.176 0 9.852-5.005 12.348-12.519 2.578-7.735 2.467-15.174 0-25.096-1.774-7.145-5.161-12.521-12.348-12.521h-9.268zM77.809 87.927c2.561 0 4.634 2.097 4.634 4.692 0 2.602-2.074 4.719-4.634 4.719-2.55 0-4.633-2.117-4.633-4.719 0-2.595 2.083-4.692 4.633-4.692z"
        transform="translate(0 10.26)"
      ></path>
      <radialGradient
        id="python-original-c"
        cx="1825.678"
        cy="444.45"
        r="26.743"
        gradientTransform="matrix(0 -.24 -1.055 0 532.979 557.576)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#B8B8B8" stopOpacity=".498"></stop>
        <stop offset="1" stopColor="#7F7F7F" stopOpacity="0"></stop>
      </radialGradient>
      <path
        opacity=".444"
        fill="url(#python-original-c)"
        d="M97.309 119.597c0 3.543-14.816 6.416-33.091 6.416-18.276 0-33.092-2.873-33.092-6.416 0-3.544 14.815-6.417 33.092-6.417 18.275 0 33.091 2.872 33.091 6.417z"
      ></path>
    </svg>
  );
};

const D3Icon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <linearGradient
        id="d3js-plain-a"
        gradientUnits="userSpaceOnUse"
        x1="85.24"
        y1="97.604"
        x2="91.053"
        y2="-49.515"
      >
        <stop offset="0" stopColor="#f9a03c"></stop>
        <stop offset="1" stopColor="#f7974e"></stop>
      </linearGradient>
      <path
        fill="url(#d3js-plain-a)"
        d="M118.16 63.966c5.223-6.256 8.368-14.217 8.368-22.98C126.528 21.097 110.352 5 90.464 5H47.986c10.375 7 18.966 16 24.82 26h17.658c5.55 0 10.064 4.45 10.064 10s-4.515 10-10.064 10H80.047c.82 5 1.26 8.62 1.26 13.098 0 4.41-.433 8.902-1.224 12.902h10.382c5.55 0 10.064 4.95 10.064 10.5S96.013 98 90.464 98H72.92c-1.315 2-2.79 4.74-4.38 6.98C63.137 112.59 56.253 119 48.29 124h42.173c19.335 0 35.16-15.746 36.024-34.876-.017.31-.043.39-.066.698.062-.848.107-1.813.107-2.678-.002-8.766-3.148-16.92-8.37-23.178z"
      ></path>
      <linearGradient
        id="d3js-plain-b"
        gradientUnits="userSpaceOnUse"
        x1="33.627"
        y1="97.714"
        x2="39.382"
        y2="-47.925"
      >
        <stop offset="0" stopColor="#f9a03c"></stop>
        <stop offset="1" stopColor="#f7974e"></stop>
      </linearGradient>
      <path
        fill="url(#d3js-plain-b)"
        d="M61.03 97.543l.003-.18c.07-.1.138-.292.207-.39.077-.118.152-.275.228-.392.002-.002 0-.03.003-.034 6.14-9.33 9.727-20.41 9.727-32.39C71.197 31.5 44.624 5 11.962 5H1v26h10.962c18.32 0 33.23 14.823 33.23 33.144 0 4.984-1.113 9.675-3.088 13.924-.006.013-.013.36-.02.374C36.79 89.782 25.283 98 11.963 98H1v26h10.962c20.396 0 38.41-10.722 49.068-26.457z"
      ></path>
    </svg>
  );
};

const NodeIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#83CD29"
        d="M112.771 30.334L68.674 4.729c-2.781-1.584-6.402-1.584-9.205 0L14.901 30.334C12.031 31.985 10 35.088 10 38.407v51.142c0 3.319 2.084 6.423 4.954 8.083l11.775 6.688c5.628 2.772 7.617 2.772 10.178 2.772 8.333 0 13.093-5.039 13.093-13.828v-50.49c0-.713-.371-1.774-1.071-1.774h-5.623C42.594 41 41 42.061 41 42.773v50.49c0 3.896-3.524 7.773-10.11 4.48L18.723 90.73c-.424-.23-.723-.693-.723-1.181V38.407c0-.482.555-.966.982-1.213l44.424-25.561c.415-.235 1.025-.235 1.439 0l43.882 25.555c.42.253.272.722.272 1.219v51.142c0 .488.183.963-.232 1.198l-44.086 25.576c-.378.227-.847.227-1.261 0l-11.307-6.749c-.341-.198-.746-.269-1.073-.086-3.146 1.783-3.726 2.02-6.677 3.043-.726.253-1.797.692.41 1.929l14.798 8.754a9.294 9.294 0 004.647 1.246c1.642 0 3.25-.426 4.667-1.246l43.885-25.582c2.87-1.672 4.23-4.764 4.23-8.083V38.407c0-3.319-1.36-6.414-4.229-8.073zM77.91 81.445c-11.726 0-14.309-3.235-15.17-9.066-.1-.628-.633-1.379-1.272-1.379h-5.731c-.709 0-1.279.86-1.279 1.566 0 7.466 4.059 16.512 23.453 16.512 14.039 0 22.088-5.455 22.088-15.109 0-9.572-6.467-12.084-20.082-13.886-13.762-1.819-15.16-2.738-15.16-5.962 0-2.658 1.184-6.203 11.374-6.203 9.105 0 12.461 1.954 13.842 8.091.118.577.645.991 1.24.991h5.754c.354 0 .692-.143.94-.396.24-.272.367-.613.335-.979-.891-10.568-7.912-15.493-22.112-15.493-12.631 0-20.166 5.334-20.166 14.275 0 9.698 7.497 12.378 19.622 13.577 14.505 1.422 15.633 3.542 15.633 6.395 0 4.955-3.978 7.066-13.309 7.066z"
      ></path>
    </svg>
  );
};

const RabbitMQIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M245.44 108.308h-85.09a7.738 7.738 0 0 1-7.735-7.734v-88.68C152.615 5.327 147.29 0 140.726 0h-30.375c-6.568 0-11.89 5.327-11.89 11.894v88.143c0 4.573-3.697 8.29-8.27 8.31l-27.885.133c-4.612.025-8.359-3.717-8.35-8.325l.173-88.241C54.144 5.337 48.817 0 42.24 0H11.89C5.321 0 0 5.327 0 11.894V260.21c0 5.834 4.726 10.56 10.555 10.56H245.44c5.834 0 10.56-4.726 10.56-10.56V118.868c0-5.834-4.726-10.56-10.56-10.56zm-39.902 93.233c0 7.645-6.198 13.844-13.843 13.844H167.69c-7.646 0-13.844-6.199-13.844-13.844v-24.005c0-7.646 6.198-13.844 13.844-13.844h24.005c7.645 0 13.843 6.198 13.843 13.844v24.005z"
        fill="#F60"
      />
    </svg>
  );
};

const PHPIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <path
          id="php-original-a"
          d="M64.026 96.076c33.676 0 60.976-14.361 60.976-32.076s-27.3-32.075-60.976-32.075S3.051 46.285 3.051 64s27.3 32.076 60.975 32.076"
        ></path>
      </defs>
      <defs>
        <path id="php-original-c" d="M2.998 31.924h122.004v64.1H2.998z"></path>
      </defs>
      <clipPath id="php-original-b">
        <use xlinkHref="#php-original-a" overflow="visible"></use>
      </clipPath>
      <clipPath id="php-original-d" clipPath="url(#php-original-b)">
        <use xlinkHref="#php-original-c" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#php-original-d)">
        <defs>
          <path
            id="php-original-e"
            d="M2.998 31.924h122.004v64.1H2.998z"
          ></path>
        </defs>
        <clipPath id="php-original-f">
          <use xlinkHref="#php-original-e" overflow="visible"></use>
        </clipPath>
        <g clipPath="url(#php-original-f)">
          <image
            overflow="visible"
            width="1160"
            height="609"
            xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgECqAKoAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAABe6AAAnEwAALd7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAmYEkwMBIgACEQEDEQH/ xAClAAEBAQADAQEAAAAAAAAAAAAAAQIEBgcFAwEBAQEBAAAAAAAAAAAAAAAAAAEDAhABAQEAAQAJ BQEBAQADAAAAAAERECBgAzM0BRUmBzBAUCUWBgInEhMEEQAAAwUIAgICAgMBAAAAAAAAAQIQkaFD NHCx0XKyA3MEQkQRohITITFBYXEVEgABBQEBAAIDAQAAAAAAAAAAYAExQUKBQzACQJAygv/aAAwD AQACEQMRAAAA775/6B5h1PoOA6nPcCnPcAc9wKc68BXPcCnOcEnOcEc9wRznBVznBHOcEc68Ac9w RznBHOcEc5wRznBWc5wRznBHOcEc5wRznBHOcEc5wRznBLznBRznBHOcEc5wYc5wRznBHOcEc5wU c6cEc5wRznBLznAHOcFHOcAc+cEc5wBznBkc+cEvOcAc5wBznAkc9wIc9wIc+cCHPfPh9CfPkv0J 8+H0J8/J9HPz4fQz8/MfRz87K/SfLh9V8ofVfKH1Xyh9V8ofVfKH1Xyh9V8ofVfKH1Xyh9V8ofVf KH1Xyh9V8ofV7n5v387iEx5j6d5j1FOoFKAqSgFFAAAWFEoAABQAAAAAAAAAAAAAQABFEWAKEJRF gBFRARYqURZEWCUSVElLJRlZEmoZmoZmoZmpLmahiahjP6ZPzz+mY/PP6ZXIAAAAAAAAAAAAHf8A oHfzuITHmXpvmXUF7gIUBQoAALZKAAAUAACCkURVSgAAAABFEVEUQAKAAAEJRFEChCUQCURZCUsB FkJRJRJqRJSyUZWRJqGZqGZqGZqS5zuGM7hjO4flN5jGd5WAAAAAAAAAAAAd/wCgd/O4hMeZ+meZ 9wXrmUoUlAAWyUAAoAAEKJSgAAAAAAAAAAAAAAIoiyAUAAIAiiBQiLACKiSiLFSokogJNSJNRZKM rIk1DM1DM1DM1JcTUMTeTGf0yfnneYxNZUAAAAAAAAAAB3/oHfzuITHmfpnmncDvkUACikACgABU lKAAABAoAAAAAAAAAAAAJQAAIqIAFACEoiwCVKIBKiAixUqJKICLIkpZKMrIk1DM1DOd5MzUlzne TOd5MZ/TBjO8y4WAAAAAAAAAADv/AEDv53EJjzT0vzTvlTuAC2SgAFACoFAABYAAAAFCIBUFQVBU FgLBQohRAAAASgARRBAKAERRAoRFglEWRFipRJUQEmpElLJYSakZmoZmoZmoZzuS4zvJnO8mMfpm Pzz+mVyAAAAAAAAAB3/oHfzuITHmvpXmvfIdwWwAKAFSUoAALAACWkEqAAAAKBAAAAAlAAWCwKlC WUAAIBQIqIFACEogAliwAiyIsVKJKiAkqJKXKwk1IzNQzNQznUjM1FxNZM4/TJ+ef0xGJrKgAAAA AAAAO/8AQO/ncQmPNfSvNe+VNOQAoApAoALABCkssAAALAAAAAQAAAFAAAAACVYKgpFogAJQEoiy AUIAiwCWLACLIixUqJKJKJKiSxZNQmdSMzUMzUMzUlxNQxneTGf0wYx+mZcLAAAAAAAAB3/oHfzu ITHm3pPm2nId8hQIpQAIFAJZZYAAWAABYAURRFsuWhFEUSaGWhlRFWQAASgAAoRYFEoAASgRZAKA ERYBLFgBBEWKlRJYJRlZLJqElhJqRmWEzqGZqS4zvJnO8n55/TEYzvKwAAAAAAADv/QO/ncQmPNv SfNtOQ05FQKACwAKQQALAAQKKJali0iiLSKIoiiKIoiiTQyok0MqMtQiywAJQAUIqUCUAJQIqIFA CIsAliwSiCIsWLIiwiwk1JZLCTUjM1DM1DE1Jc53kzneTGP0yfnneZcLAAAAAAAB3/oHfzuITHm3 pPm2nIunAUAFgCFgAWAAgtSrLFpFBRLSxRLRFEURpGWhlqEVUUZahFGWoSaiSaGZoZVZABKAEoFE oAQCpRBKAERYBLFglRJRAsWRASVEliyahM6kZmoZmskzqS4moYzvJjH6YjGd5WAAAAAAAd/6B387 iEx5t6T5vpyGvAAWCAWABYAFhbLKpKpKqyqRQVEtEURaRRFLFEUkmhlRFGVEmoRVZUZUmVGZqEWW BAKChFQtEBAKlEEoCVECpUQEWQlipUSUSUZWSyahJZEzqGZqGZrJmazLnO8mM7yfnneZcLAAAAAA B3/oHfzuITHm/pHm+vAachYIBYAFgILRUqqSqsqkqxKpKpFqxRLRFEURoZaGWoRRFGWoSaGVGVJl RlVZUZUmZqEmoQWBKAEqwtEBALFkAoQlEEqUQEERYqWRFhFkSUuVhJZGZqGZqGc6kuc6hjO8n55/ TEYzvKwAAAAADv8A0Dv53EJjzf0jzfXgNeBALAAsCwqFVShVWVYlUKUoKJaiLSKI0IoiiKIok0Mt Qk0MqMtSpNQk1DLUTKjKqzNQk1EzNQgsCUBYlWFogIBYsgFCIsAliwSokogWSokokslk1CSyJnUM zUMywzneZc51DGP0wYx+mZcAAAAAAd/6B387iEx5v6R5vrwGvEFgAWBYqyyqKqiirEqhSlBbEWkU FLLRFEWmWhloZaGVEUZUSahJomZoZmoSalZahlSZmoZVWZqJlRlZYEoAS1KoQEoEEAoRABLARZEW KlkRYRZElLlYSWRmahmayZmpLjO8mcbyYzvEYmsqAAAAA7/0Dv53EJjzf0jzfXhDbMALAsVZVBVV VJVhVWVQqFUlVZVJVItIqJaIoiiKIoijLUJNDKqyoyoypMzUJNSsqMzUTKwk1KzNRJKMrLAlAWJa llACVKIJQhKIJUsEogiBZKiSiSyWTUJLImdQzNQxNSXOdQxneTGP0xGM7wsAAAAA7/0Dv53EJjzb 0nzbbgNcwsBFlFVVVVUKhVVVJVhVWVSWgqCgoloi0y0WKIok0MtEyoy1CTUJNQk1Ky1DKjM1Eyoz NSszUJKTM1KzNRMrCCwJQlFAlACWLIBQiLAJYBLISxUsiLCLIksWTUJnUjM1kmdQznUlxNZM4/TB jG8y4WAAAADv/QO/ncQmPNvSfNtsw2zAFsVZVVVUWWFVVUVYlVVUlqFBVJaWWiLSKiLTNoijLQyo k0rKjLUMzRMzUJNQyqszUMqTM1DM1KzNQksSTUrM1EzNQgsCUJahaICUCCAVKiCVLBKJKiBZKiSj KyWSwk1IzLCZ1DOdSXOdZM53k/PO8x+c1lQAAAHf+gd/O4hMebek+bbZhtmFlsstspbKqrCqqqKs KqyqKsFCqpQVBaRaZtEWmWhloZaGVGWoSahJqEmpWWoZmokmoZmpWVGZqJmahmalZmomZqGVlSWJ JZYEoCxLUsoASpZAKERYBLARZEWKlkQElRJYslhJZGZqGc6kuc6hjO8mMfpiMY/TCwAAADv/AEDv 53EJjzb0nzbbMN8lWVVFVVWFVVUVYVVFFWFUVVKgtJaJaJaJaItjLQy0MtDKjLUrLUMtQzNDM1DL UrM1EzNQzNSpKMzUTM1DM1KzNRMzUrM1DM1EyssCUJagolCUCCUBLICWLBLISxUqJLBLCSpcrCZ1 IzNZJnUM51JcTWTGd4MZ3iXIAAAHf+gd/O4hMebek+bbZi75KsqqqrCqUqqsUq0oqwqiqqrCqS0F pLUS0stEWmWhloZaGVGWoZahmaJmalZmhmahmalZmoZmomZqVmahmaiZmoZmpWZqJmalZmomZqEF gSrEtSygBLFkAoRAqVEBBECyVElElkslhJqRmWEzrJM6kuM7yZxvJ+ed5jEsUAAB3/oHfzuITHm3 pPm2+SrrwqjUq2yxbKts1CqqqKsKoqqqwqiqKsS2rKpLRLRGkZtEUZaGWoZalZm4ZmoZahmalmZq GZqGZqVmahmaiZmpWZqGZrKSWVJYZmomZqVmaiZWWBKEtSgShKlEEoQlgEsBFkRYqWRASWRFiyWR M6hmWGZrMuc7yZxvJjG8xjOsqAAA7/0Dv53EJjzb0nzfbNV2zVVtli2VbVFWFVWpYtlLVVVhVFUV qWVRVC2JaJaJaIoiiTQy1DLUMzcMzUrM1DM1DM1EzNSszUMzUrM1lJLDM1KzNQzNRMyypLEmdSsz UTM1kBAVZZQlCAWCAVKiCVLBLISxUshLCLIksWSwk1mJLDMsjOdRcTWTGP0xGMbysAAA7/0Dv53E Jjzf0jzfbO1ds1VbZYtlW1YVVtlLVhVW2WLVFUVqVVFUVYLSWiWpZaI0MtDLUMtQy1KzNEzNQzNQ zNSs53kzNSzM1DM1kmdSszUTM1kmdSszUTM1mpLDM1EzNSszWUgsCUJVJQAlSyAUIgVLIAkqIFks hLCSpZLCSyMywmdZJnWZc51DGN5MY3mXIAAHf+gd/O4hMecej+cbZ2y7Z2rK1KWyrasNSrbNQqls 0qrDUpasNSraoqwrRLbLKpLaRoZtEahloZmhhqGZqGZvNmZqGZqGc7zWZqGZrNmZqGZrJM6lZmom ZZWZqGZrKSWVmaiZms1JYkllgShLUoEoSpYBKERYBLAQRAsESWEWSyWElkTOoZlhmWS5zrJnG8mM bxLkAADv/QO/ncQmPOfRvOds7ZduLZYupVtli1ValLZYupVtmoalLVLZqVVLVhWhVlVRaFWItItM tDM0MzQzNQzNSszUM53KxNRM53kzNSsTUMzWbMzUMyyszWUksMzUrMsSSyszWUksqSxMzWQABZZQ lCUCCUISwCWAiyIFiyICSyWSwk1IzLCZ1kmdZlzneTON4MZ1mXCwAAd/6B387iEx5z6N5ztnau3F ssWzStSxbKt1KWyxdSrbNRbNDUstqlqxao1NSqpasKoWktqxURRJoYm5ZhqGZqGJvNZmoYmpZnOo ZzvNZmsmZqWZzqGZYZms2SWGZrNSWJmalZlhM6iZllSWJBYEqyyhKEAsEAqWQEsAlkJYqWRASWRF iyWRmaySWGZZLnOsmc6yYzrMYligAO/9A7+dxCY869F862ztl24tmotlW2ai2VbZqGpS6lW2ai2a LZZbqUupqGpoallupoVYaUVZS0jQy0MzcMNQzNQxN5szNQxNZrM1kzNZszNZMzWazNRM51KzLDM1 mszUTMsrM1DMsSZ1KzLEksqZ1lILAlCWpZQAlggFSoglSwSyEsVLIiwkshLFksiZ1DMsMyyXOdZM 53k/PO8RiWKAA7/0Dv53EJjzr0XzrbO2a24tli2VbqWLZpbZYus6LZZdWU1ZY1ZVupqLZotmpbZo tWLWhVlaUW2ItMtDM0MTeaxN5M53DGd5szneaznUM51LM51DE1mpnWSZ1myZ1kksrMsSZ1KzLDM1 lJLKmdRMyypLEyssCUJaFCAlSyAUIglSwSyEsVLISwgiSxZLCSyMzWSZ1mXM1kznWTGN4jOdZUAB 3/oHfzuITHnXovnW2d1LrxbKt1KWyxdSrbLGrKt1LF1KXWdRdZ0t1LGrKas1LdZ0XUsas1LapdTU K0GiybkYm5ZiahjO81nOoZzrNmZrJnOpWc6zUzrKZms1mWGZZZmayZms1M6yklhmazUliZms1JYk zrNSWJJZYEoS0KEBKlkAoRAqWQlRJYqWQlglkSWLJYSWRM6yTOsyzOsmc6yYzrMYzrKgAO/9A7+d xCY869F862z1ZdeLZpbZYtlXVlLrOotmltljVlNWWXVlNazqLrOi6zqXWs6i6zo1ZqW6mi6ljWpq VWiTcMTUMZ3izOd5MZ3ms51msyxM51mszWTMssznWamdZJnWbJnWSZ1KzLEzLCZ1mpLEmdZqSxJn UrMsSSywJQloUICVLIBQiBUsgIksVLISwSyJLFksJLIksM51Jc51kznWTGd4jGdZUAB3/oHfzuIT Hnfonne2dsuvF1nS2yxbKurKXWdRdZ0tssaspqyy6sprWdRdZ0assutZ1F1nRrWdS61nRrWdRrWd S63jZrNkYzrNZzrNmc6yZzrNZzrNZliZzrNTOsmZZZnOskzrNTOs2TOskllZliZlhJZWZYkllZli SWVmWJJZYEoS0KEBKlkAoRAqWQESWKlkJYJZEliyWElkSWGZZGc6yuc6yZxvEYzrKgAO/wDQO/nc QmPOvRfOts9WXXi6zV1ZYtlXVlLrOous1dWWNWU1ZZdWU1rNjWs6LrOpdazTWs6jWs2XesaNazY/ S40u7mxqSFzcjFzZJckzc1M6zWZcpM6zWZYZlzZM6zUzrJM6zZM6ySXNSWJmWEzrNSWJM6zUliTO s1JYkllgShLQoQEqWQChECpZARJYqWQlglkSWLJYSWRJcklzLM6yZzrJjOsxjOsqAA7/ANA7+dxC Y869F862z1c614tlW6zotljVzpbZY1ZV1c6i6zous6i6zpdXOo1c6NazZdazo1c6jWsal1rGjdzY 3rFN3FXTIuURlBm5qRCZubGbDMuamdZqZsSZsrMsMyyzMsJmypnWUksJmypLEmbKksSZsqSxJLLA lCWhQgJUsgFCIFSyBISxUshLBLIksWSwksiZ1kmdZlmdZM51kxnWIznWVAAd/wCgd/O4hMedei+d bZ2y7caudRbKurnUWyrqyxdZ0Wyy6spq51GrnS6udRq50a1jUutY0bubGtY0bubLrWKbuKbZsVBZ IWSUiDNzUiJJc1IhM2WTNhM2VM2EzZZM6ySWVmWJM6zUlhM2JJZUzYkllSWJIWBKEtChASpZAKEQ SpYJZCWKlkJYQRJYslhJZEzYTOsyzNhnOsmMbxGc6yoADv8A0Dv53EJjzr0XzrbO2Xbi2WNWVbZY 1c6W6zY1c6NXNXWs2NXOjVzqXVzo1c6jVzTdzZd3NN3NjWsU3cpds01cU0zDUgskLJKREkQZuaZu RmyyZsJmypmxJEqS5GbKkRJLKmbCSxJnWaksSSypmxILAlCVSUAJYIBUsgJUsEshLFSyECSyEsWS yJnWSSwzLJc51kmNZM41mMSxQAHf+gd/O4hMec+jec7Z3Wbtxq51Fsq6ubGrKurmmrLGrnS3WbGr nRq5sbuautZsa1jRq5q7ubG7im7ixu4ptku2UaZGpJWpIiIWSCJTKDNlkiEiVJcjNlkiElhM2WSX JJZUlyjNlSWEiJJZZJYQWBKssoShALBASpYBLAJZCWKlkQElkILJZEzYSXJJZLnOsmc6yYzrEZli gAO/9A7+dxCY859G842z1ZduLZYus1dWWLrNXVzTVljVzpbZY1c01rNNXOpdXNN3Go1c01rFl3cU 3cU2zY0g0yNMjUgsgskqyQuUESxEJEpmwkRJLmmbCS5pmxJLkZsqSxJEqSxJLKkuUZsAAFiWiUJQ IJQhLAJYBCIFgiAkslksESJLCZ1kmdZlzLkmNZMZ1mXAAAHf+gd/O4hJ8Q65U6igoqgBQUFEUCiq CgoKQoAUFABQAAAIAEAgAQEFQEBAQIgICFICABAkBBSAAEAoCkQAAKAEQAAEAEQALAQEBBEgIEgQ AAD64fTB/9oACAECAAEFAP8AljGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGR kZGMYxjPu/8AnqV/z1K/46lf8dSv+OpX/HUr/jqV2fUrs+pXZ9Suz6ldl1K7LqV2XUrsupXZdSux 6ldj1K7HqV2PUrsepXY9Sux6ldj1K7HqV2PUrsepXY9Sux6ldj1K7HqV2PUrsepXY9Sux6ldj1K7 HqV/z1K//9oACAEDAAEFAL9HWta1rWta1rWta1rWta1rW/iL1KvUq9Sr1KvUr/rqV/11K/66lf8A XUr/AK6lf9dSv++pX/fUr/vqV/31K/76ldp1K7TqV2nUrtOpXadSu06ldp1K7TqV2nUrtOpXadSu 06ldp1K7TqV2nUrtOpXadSu06ldp1K7TqV2nUr/rqV//2gAIAQEAAQUA7S2dn675u9d83eu+bvXf N3rvm713zd655u9d83euebvXPN3rnm71zzd655u9c82euebPXPNnrnmz1zzZ655s9c82et+bPXPN nrnmz1zzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nn rfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnr fmz1vzZ635s9b82et+bPXPNnrnmz1zzZ635s9c82euebPXPNnrnmz1zzZ655s9c82euebvXPN3rn m71zzd655u9d83euebvXfN3rvm713zd675u9d83eu+bvXfOHr3nD17zh695w9e84evecPXvOXr/n L1/zl6/5y9f85f0HnT+g86f0HnT+g86f0Pnb+h87f0Xnb+i88f0Xnj+j88f0fnq/6Tz1f9J58v8A pfPn9N5+v+n8/X/T/wCgf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf 1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1 H+gf1H+gf1H+gf4bzH/93mH/AOR2vddZs6FixeLFixYsWfe/HHgna911ns6FixZxYsWKs+9+OPBO 17rrRZ0KsWcWLFixZ958ceCdr3XWm81VWKsWLFiz7v448E7XuutVnNVVirFixYs+6+OPBO17rrXY vFWKqxYsVYs+5+OPBO17rrZV4sWKqxYsVZ9z8ceCdr3XW2rxVi8WLFixZ9x8ceCdr3XW68VVVVix YsWfb/HHgna911svFXiqqqsWKs+3+OPBO17rrfV4qqqxYsVZ9t8ceCdr3XXCrxVVVixViz7X448E 7XuuuFXiqqqsWKs+1+OPBO17rrfeKvFVVWLFirPtPjjwTte665VeKqqsWKsX7P448E7XuvxOMYxn UWrxVVVWLFWfZ/HHgna91+CzjGMYxjGMYxnGM4z87eKvFVVWLFWL9l8ceCdr3X32cYxnGMYxnSxj GM4xjOM/OVeKqqsWKs+y+OPBO17v73GMYzpYxjGMYxnSxjGc5+XvFXiqqqsVYv2Pxx4J2vd/d4xn RzoYxjGMYxjGdDOjnGfmLxV4qqqxYqz7H448E7Xu/uM4zoZzjGfYYxnOdDPzNXiqqqsVV+w+OPBO 17v7bPoYzoYxn1MYzoYz85eKvFVVVYqz7D448E7Xu/u8ZzjOc5xjGMYxjGM5znGc4z83VVVVVWKq /X+OPBO17v7nOlnGMYz62MYzjOM6GfmLxV4qqqrFWfX+OPBO17v7fOc6GM6OM+pjOjjOhnOfmaqq qqqqv1vjjwTte7+1zp50MZzjGMYxjGMYxjGc4zoZ0M/MXirxVVVVV+t8ceCdr3f3OM5znGMYxjGM 6WMYxjGMZ0s6WflLxVVVVVVV+t8ceCdr3f3Gc5zjGMZzjGM6OMYxnOMYxnOc5+ZvFXiqqqqr9X44 8E7Xu/ts5zjGM6GM6GMYxjGMYxnQxnOMYzjOc/LXmrxVVVVV+r8ceCdr3f2udHOhjOcYxjGMYxjG MYxjGM5xnOM/OXiqqqqqqr9T448E7Xu/s8+jnOMYxjPrYxjGM5z6Ofl6vFVVVVX6nxx4J2vd/ZZ9 DOcYxnRxjGMYxjGMYzo4xjOc+hn5Oqqqqqqqqr9T448E7Xu/u84zo4xjGMYxjGMYxjGMZ0c4z89e KvFVVVVX6fxx4J2vd/d50MYxjGMYxjGMYxjGMYxjGM6GM5z8zV4q8VVVVVfp/HHgna9391nOMZxj GcYxjGMYxjGMZxjGcYxnOfnavFVVVVVV+n8ceCdr3f3GdDGcYznGMYxjGMYxjGMYxnOcYzoZ+cvF Xiqqqqr9L448E7Xu/qz6uM6OMYxjOMYxjGMYxjGMYxnRxnOfSv5CrxV4qqqqq/S+OPBO17v6k+rn RxjGMYxjGMYxjGMYxjOMYxnSz6t/H1VVVVVVVVfpfHHgna939xnRxjOMYxjGMYxjGMYxjOMYzjGd LPzt4qqqqqqv0vjjwTte76c+wzo4znGMYxjGMYxjGMYxjGMYznGdHPsL+Lq8VeKqqqqv0fjjwTte 75nTn1JOjjOM4xjGMYxjGMYxjGMYxjGMYzjGdGz6l6dX8NVVV4qqqqq/R+OPBO17vpT6k5n0M4xn OMYxjGMYxjGMYxnGMZxnOdGz69/GXiqqqqqq/R+OPBO17ridOczozmdPOMZzjGMYxjGMYxjGMYxj GcYxn0bPp3i9G/h6vFVVVVVV+j8ceCdr3XRnM4nRnQnTk4xnGMYxjGMYxjGMYxjGMYxjOcZ9G9C9 O838VV4q8VVVVX6Pxx4J2vdp0ZxOZxOjOjOJOMZxnGM4xnGMYxjGMYxjGMYxnGcZ9K9G8Xm8XoVf w1XirxVVVVV+h8ceCdr3fQnM5nQicROhOJ0cYzjGcYxjGMYxjGMYxjGMYs4s6N4vQvNXo3i838TV VVVVVVVV+h8ceCdr3adCcTmcTozoToToSJOM4xjGMYxjGMYxjGMYzjOLFnNnRvQvRvF5vF6F/D1e Kqqqqqr9D448E7Xu5zOZxETmJxOhE4iJxIkSc4xjGMYxjGMYxjGMYxjOhZxeLxeKvNXir0KvRvNX 8LV4qqqqqqv0PjjwTte75nM5nE6M6E4iJxESc4xjGMYxjGMYxjGMYxjGM6F4vF4vF6F6N4vN5v4m rxV4qqqqv0PjjwTte7nQnE5nMTiJzETicTiToSM4xjGMYxjGMYxjGMYzjFnQs4qrxVXmrxV5vN4v Qv4arxV4qqqqv0PjjwTte74nM4icTiczmJxETiJxOInGJGMYxjGMYxjGMYxixZxYs4vFXiqvFXm8 Veaq8Xm8VfwtVVXiqqqqr0/jjwTte7ROZzEROYicRE4nERE4icSJEnGMYxjGMYxjGMZxixZxV4qq vF4qrxVXiqqrzeavFX8JVVV4qqqqq9P448E7Xu+IiJzOYnE4iJxEREROIiIk6GJGMYxjGMYxixjO KsXirzV4qrxVXi8VebzVVeb+Gq8VVVVVVXp/HHgna93zOYicxOInERERERERERE5kScYxjGMYxjG cWLOaqqqqqqqqqrxV4q81V5vQq/havFVVVVVV6fxx4J2vd9CcRETicRE4iIiIiJxEREREScYxjGM YxjGMZxYqqqqqqqqqqqqqqvF4qqvTq/havFVVVVVV6fxx4J2vdxOZzERE4iIiIiIiIiIiIiIk4kS JGMYxjGMYsWc2Kqqqqqqqqqqqqq8VVVebzVVfwtXiqqqqqq9P448E7Xu4nM5iIicRERERERERERE REREiRIxjGMYxjFixVVVVVVVVVVVXiqqrxVVV5vNXir+Eq8VVVVVVXp/HHgnad3E5nM5icRERERE RERERERERESJxIxjGMWcVViqqqqqqqqqqqqqqrxV5vN5q8Vfwt4q8VVVVXp/HHgnad2iInM5icRO IiIiIiIiIiIiIiIiRIxjGMWLFVVVVVVVVVVVVVVXirxV5vNVV5q/hKvFVVVVVV6fxx4J2ndoiJxE 5icROIiIiIiIiIiIiIiIiREjGMWLFiqqqqqqqqqqqqqqrxV4q81eKqr0L+EvNVVVVVV6fxx4J2nd oiIiJzE4icREREREREREREREREREjFiqqqqqqqqqqqqqqqqrxV4q81VVVXoX8JeavFVVVV6fxx4J 2ndoiIiJzE4iIiIiIiIiIiIiIiIiIiIxVVVVVVVVVVVVVVVVVVVXirxVVV4q81fwlXirxVVVVen8 ceCdp3aIiIicxOIiIiIiIiIiIiIiIiIiIiVq1VVVVVVVVVVVVVVVVVVV4q8VVVVVeav4SrxV4qqq qvT+OPBO07tEROInMTiJxEREREREREREREREREStWrVVVVVVVVVVVVVVVVV4q8Veaqqqr0L+EvNV VVVVV6fxx4J2ndoiJzOYnETiIiIiIiIiIiIiIiIlRK1rVqrVVVVVVVVVVVVVVVXirxV5q8VVXmr+ EvNVVVVVV6fxx4J2ndxOInM5icROIiIiIiIiIiIiIiIiVK1rWtWrVVVVVVVVVVVVVVVXirxV5vNX i81fwlXiqqqqqq9P448E7Tu4nM5nMTiIiIiIiIiIiIiIiIiVLxrWta1rVq1VVVVVVVVVVVVVVVXi rzebzV4q/hKvFXiqqqq9P448E7Xu4nM5iIicRERERERERERERERESpWta1rWta1aqqqqqqqqqqqq qqqrxVVV5vNVVX8JV4qqqqqqvT+OPBO17tOZzEROYiIiIiJxEREREREvMrWta1rWtatbzaqqqqvF VVVVVeKq8VVVebzeKv4WrxVVVVVVen8ceCdr3fM5iInE5icRERERERERETiJeda1rWta1rW8W81V VVVVXiqqrxV5vFVV5vQv4arxVVVVVVen8ceCdr3fETmInMTiIiJxEREROIiIl6ErWta1rWta1rVq 3m1VVeKqqqrxVVV4q81eLxV5q/havFVVVVVV6fxx4J2vd8TmcziInETiIiInETiIiIlS861rWta1 rWta1vNq1VVVVV4qqqqqrxVXi81eL+JqqqqqqqqvT+OPBO17tE5nMRE6ETiJxE4iInE5iVK3jWta 1rWta1rebWreKvFVVVVVV4q9GqvN5q8VfwlVVXiqqqqr0/jjwTte7nTiJzE4nMTiInERE4nMrWta 1rWta1rWta1a1vN4qqvFVeKvN4q81V6dX8LV4q8VVVVVen8ceCdr3c6E4nM5iczmJxETmcTjW8a1 rWta1rWta1rWta3i3i8W81V4q8VV4qrxebxV5v4arxV4qqqqv0PjjwT/AKz/AOPtV7We1ntd7Ye2 Htl7ae2ntt7ce3Ht17ee3nt9+gfoX6F+ifo36N+kfpX6Z+mfp36h+ofqX6p+qfq36x+sfrX61+uf rn65+vfr369+vfr369+vfrn65+ufrX61+sfrH6t+qfqn6l+ofqH6d+mfpn6V+kfo36N+ifoX6F+g e33t57ee3Xtx7ce23tp7ae2Xth7Ye13tZ7We1XtR7Ue03tR7Ue1HtR7Ue1HtR7Ue1HtR7Ue1HtR7 Ue1HtN7Te03tN7Te0ntJ7Se0ntF7Re0XtB7Qe0Hs97Pezns57NezHst7Leynsl7Iex3sZ7Few3sJ 7Af+fv8Az9/5+/8AP3/n7/z9/wCfvJfQ/wD6n//aAAgBAgIGPwD4YIIIIIIIIIIIIIIIIIIIIIII IIIWLop0U6KdFOinRTop0U6KdFOinRTop0U6KdFPxFPxFPxFfbiK+3EU/EU/EU/EU/EU/EU/EU/E U/EU/EU/EU/EU/EU/EU/EU/EU/8AX+T0PQ2bNmzZs2bNGjRo0aNGjRZZZZZo0aNGjRo0bNmzZs2b Nnoeh6Hoeh6GzZs2bNGjRo0WWWWWX8n/2gAIAQMCBj8A/ZcyKZFMimRTIpkUyKZFMimRTIpkUyKZ FMimRTIpkUyKZFMimRTIpkUyKZFMiq6ZMmTJkyZKKKKKKKKKKK+CiiiiiiiiijJkyZMmTJkwYMmT JkyUUUUUUV+D/9oACAEBAQY/AFGX9kRmThV7jyFXuPIVe48hV7jyFUt5CqW8hVLeQqlvIVS3kKpb yFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLgKpcBVLeQqlvIV S3kKpbyFUt5CqW8hVLeQqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuA qlwFUuAqlwFUuAqlwFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqXAVS4CqW8hVLeQqlvIVS3kKpbyFU t5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQq9x5Cq3HkKvceQq 9x5Cr3HkKvceQq9x5Cr3HkKvceWAq9x5YCr3HlgKvceWAq9x5YCr3HlgKvceWArNx5YCs3HlgKzc eWArNx5YCs3HlgKzceWArNx5YCs3HlgK3ceWArdx5YCt3HlgK3ceWArd15YCu3XlgK7deWArt15Y Cu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7 deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15 YCu3XlgK7deWArt15YDtL7u8rfUjcSSTV/gjSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7r Ee5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sX lO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucq dLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR 7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU 7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0 sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHu cqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5Tu sR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSx eU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5y p0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6x HucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSw/wAv6+P5/wCCTESYiTESYiTE SYiTESYiTESoiVESoiVESoiVESoiVESoiVES4iXES4iXES4iXES4iXES4jwiPCI8IjwiPCI8B4Dw HgPAeA8B4jxHiPEeI8R4jwHgPAeA8B4DwHgPCI8IjwiPCIlxEuIlxEuIlxEuIlxEuIlxEqIlREqI lREqIlREqIlREqIlREmIkxEmIkxEmIkxEmIkxEmIkxEiIkREiIkREiIkREiIkREiIkREiIkREiIk REiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiI9eI9eI9eI9eI9eI9eI9eI9 eI9eI9aI9aI9b7D1vsPW+w9X7D1fsPV+w9X7D1fsPV+w9X7Dd/8AF/X+v8i/b+r5+Py+P4+fn/TP /9k="
            transform="matrix(.106 0 0 -.106 2.825 96.168)"
          ></image>
        </g>
      </g>
      <path
        fill="#6181B6"
        d="M64.026 93.694c32.36 0 58.594-13.295 58.594-29.694S96.387 34.306 64.026 34.306 5.433 47.601 5.433 64s26.233 29.694 58.593 29.694z"
      ></path>
      <path
        fill="#fff"
        d="M75.896 73.598l2.906-14.958c.656-3.377.11-5.896-1.62-7.486-1.677-1.54-4.523-2.288-8.703-2.288h-5.033l1.44-7.412a.955.955 0 00-.935-1.135h-6.947a.954.954 0 00-.936.771l-3.086 15.881c-.28-1.787-.973-3.323-2.079-4.591-2.038-2.332-5.261-3.515-9.58-3.515H27.856a.951.951 0 00-.935.771L20.674 81.78a.953.953 0 00.935 1.134h7.002a.953.953 0 00.936-.771l1.511-7.775h5.213c2.735 0 5.032-.296 6.827-.881 1.834-.596 3.522-1.607 5.011-3.001a15.364 15.364 0 002.96-3.676l-1.248 6.424a.95.95 0 00.935 1.134h6.947a.954.954 0 00.936-.771l3.429-17.645h4.767c2.031 0 2.626.404 2.787.578.147.159.452.718.11 2.48l-2.764 14.223a.95.95 0 00.935 1.134h7.058a.951.951 0 00.935-.769zm-32.208-12.36c-.437 2.242-1.259 3.842-2.444 4.755-1.205.927-3.132 1.397-5.727 1.397h-3.104l2.244-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.802 2.199.407 4.238zm61.916-8.858c-2.038-2.332-5.261-3.515-9.581-3.515H82.559a.952.952 0 00-.936.771L75.375 81.78a.953.953 0 00.935 1.134h7.003a.953.953 0 00.935-.771l1.512-7.775h5.212c2.735 0 5.033-.296 6.827-.881 1.835-.596 3.522-1.607 5.011-3.001 1.241-1.141 2.264-2.421 3.037-3.806a15.404 15.404 0 001.65-4.588c.797-4.094.16-7.363-1.893-9.712zm-7.262 8.858c-.437 2.242-1.259 3.842-2.444 4.755-1.204.927-3.131 1.397-5.727 1.397h-3.104l2.245-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.801 2.199.406 4.238z"
      ></path>
      <path
        fill="#000004"
        d="M38.67 54.89c2.66 0 4.434.491 5.32 1.474.885.982 1.097 2.668.633 5.057-.484 2.488-1.416 4.264-2.798 5.328-1.382 1.063-3.485 1.595-6.308 1.595h-4.26l2.614-13.453h4.799v-.001zM21.609 81.962h7.002l1.661-8.546h5.998c2.646 0 4.823-.277 6.532-.834 1.709-.556 3.263-1.488 4.661-2.797a14.369 14.369 0 002.85-3.569c.727-1.3 1.242-2.734 1.547-4.305.741-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.862-3.189H27.856l-6.247 32.144zm35.394-40.691h6.947l-1.661 8.546h6.189c3.894 0 6.58.68 8.059 2.037 1.479 1.359 1.921 3.561 1.33 6.603l-2.906 14.959h-7.058l2.763-14.223c.314-1.618.199-2.722-.347-3.311-.546-.587-1.708-.882-3.485-.882h-5.553l-3.578 18.416h-6.947l6.247-32.145zM93.324 54.89c2.66 0 4.434.491 5.319 1.474.887.982 1.097 2.668.634 5.057-.484 2.488-1.417 4.264-2.799 5.328-1.382 1.063-3.484 1.595-6.308 1.595h-4.259l2.614-13.453h4.799v-.001zm-17.06 27.072h7.002l1.661-8.546h5.997c2.646 0 4.823-.277 6.532-.834 1.71-.556 3.264-1.488 4.661-2.797a14.35 14.35 0 002.851-3.569c.726-1.3 1.242-2.734 1.547-4.305.74-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.863-3.189H82.511l-6.247 32.144z"
      ></path>
    </svg>
  );
};

const LinuxIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <radialGradient
        id="linux-original-a"
        cx="-992.915"
        cy="-952.952"
        r="43.267"
        gradientTransform="matrix(.7 0 0 .35 782.303 444.575)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-opacity=".502"></stop>
        <stop offset="1" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#linux-original-a)"
        d="M117.641 111.137c0 8.362-13.557 15.14-30.28 15.14-16.722 0-30.279-6.778-30.279-15.14s13.556-15.14 30.278-15.14c16.723.001 30.281 6.779 30.281 15.14z"
      ></path>
      <radialGradient
        id="linux-original-b"
        cx="-770.661"
        cy="-951.636"
        r="43.267"
        gradientTransform="matrix(.719 0 0 .35 595.327 443.952)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-opacity=".502"></stop>
        <stop offset="1" stop-opacity="0"></stop>
      </radialGradient>
      <path
        fill="url(#linux-original-b)"
        d="M72.546 110.974c0 8.362-13.921 15.14-31.094 15.14s-31.093-6.778-31.093-15.14c0-8.361 13.921-15.14 31.093-15.14 17.173 0 31.094 6.779 31.094 15.14z"
      ></path>
      <path d="M108.095 81.343c-1.534 6.324-9.322 19.527-13.459 25.338-4.138 5.835-3.626 11.089-11.275 9.043-7.625-2.045-9.763-1.673-17.644-1.208-7.833.464-6.137-.233-11.042 1.976-4.882 2.208-21.27-26.78-22.595-32.173-1.301-5.393-1.93-4.743 1.464-10.577 3.395-5.834 3.883-11.6 8.368-18.667 4.487-7.09 9.671-10.693 9.299-16.109-1.464-20.108-2.626-30.15 6.301-34.8 8.507-4.417 15.621-1.79 18.434-.279 1.208.651 3.673 1.906 5.509 4.115 1.836 2.162 3.487 5.44 4.417 9.577 1.906 8.299-.791 5.556 1.371 15.064 2.139 9.484 6.485 14.133 11.787 21.642 5.299 7.508 10.832 19.898 9.065 27.058z"></path>
      <path
        fill="#666"
        d="M57.644 32.088c1.394-.558 1.16-.632 2.089-2.655.744-1.557 1.398-2.227 1.375-4.598 0-2.325-.722-3.115-1.814-4.626-1.045-1.441-2.719-1.511-3.765-1.325-.604.093-1.395.86-1.93 2-.348.767-.628 1.744-.651 2.766-.07 2.743.163 3.79.791 5.649.743 2.185 2.556 3.325 3.905 2.789z"
      ></path>
      <path
        fill="#6D6D6D"
        d="M57.644 32.08c1.385-.554 1.15-.631 2.074-2.641.739-1.547 1.392-2.215 1.379-4.573.009-2.309-.698-3.133-1.771-4.585-1.065-1.403-2.705-1.456-3.743-1.276-.619.091-1.406.829-1.95 1.927a6.637 6.637 0 00-.673 2.755c-.068 2.724.176 3.775.794 5.624.732 2.173 2.55 3.3 3.89 2.769z"
      ></path>
      <path
        fill="#757575"
        d="M57.644 32.071c1.376-.551 1.141-.629 2.059-2.626.735-1.537 1.387-2.202 1.384-4.547.017-2.294-.676-3.15-1.731-4.544-1.082-1.364-2.688-1.401-3.719-1.227-.633.089-1.417.798-1.969 1.854-.401.725-.675 1.713-.698 2.745-.067 2.706.191 3.761.798 5.598.721 2.16 2.545 3.275 3.876 2.747z"
      ></path>
      <path
        fill="#7C7C7C"
        d="M57.644 32.063c1.367-.547 1.132-.628 2.044-2.611.729-1.528 1.381-2.191 1.389-4.522.026-2.278-.653-3.167-1.69-4.503-1.099-1.325-2.673-1.345-3.695-1.178-.648.088-1.429.769-1.989 1.783-.427.703-.697 1.697-.72 2.733-.066 2.687.205 3.747.802 5.573.707 2.147 2.537 3.248 3.859 2.725z"
      ></path>
      <path
        fill="#848484"
        d="M57.644 32.054c1.359-.544 1.123-.627 2.028-2.598.726-1.518 1.378-2.179 1.395-4.497.034-2.263-.629-3.185-1.649-4.462-1.117-1.287-2.658-1.29-3.672-1.129-.662.086-1.44.737-2.01 1.709-.453.683-.721 1.682-.744 2.723-.064 2.668.22 3.732.808 5.548.694 2.137 2.531 3.227 3.844 2.706z"
      ></path>
      <path
        fill="#8C8C8C"
        d="M57.644 32.046c1.35-.54 1.113-.626 2.013-2.583.721-1.507 1.373-2.167 1.4-4.472.043-2.248-.608-3.202-1.609-4.422-1.134-1.248-2.643-1.235-3.649-1.08-.676.085-1.45.707-2.029 1.637-.479.662-.744 1.667-.766 2.712-.063 2.65.233 3.718.81 5.522.683 2.125 2.526 3.203 3.83 2.686z"
      ></path>
      <path
        fill="#939393"
        d="M57.644 32.037c1.34-.536 1.104-.624 1.998-2.569.715-1.497 1.367-2.154 1.405-4.446.052-2.232-.584-3.22-1.567-4.381-1.152-1.209-2.625-1.18-3.625-1.032-.691.084-1.462.676-2.049 1.565-.505.641-.768 1.651-.791 2.702-.06 2.631.249 3.704.815 5.497.67 2.112 2.517 3.178 3.814 2.664z"
      ></path>
      <path
        fill="#9B9B9B"
        d="M57.644 32.028c1.333-.533 1.095-.624 1.983-2.554.71-1.488 1.361-2.143 1.41-4.421.061-2.217-.562-3.237-1.528-4.339-1.168-1.171-2.609-1.125-3.602-.983-.705.082-1.473.646-2.069 1.492-.531.619-.79 1.636-.813 2.691-.06 2.613.261 3.689.818 5.472.66 2.099 2.514 3.153 3.801 2.642z"
      ></path>
      <path
        fill="#A3A3A3"
        d="M57.644 32.02c1.323-.529 1.086-.622 1.968-2.54.706-1.478 1.356-2.13 1.415-4.396.069-2.202-.54-3.254-1.487-4.299-1.187-1.132-2.594-1.07-3.579-.934-.719.081-1.484.615-2.088 1.42-.557.598-.814 1.621-.836 2.681-.059 2.593.275 3.674.822 5.446.649 2.087 2.507 3.129 3.785 2.622z"
      ></path>
      <path
        fill="#aaa"
        d="M57.644 32.011c1.314-.525 1.077-.62 1.953-2.526.7-1.467 1.351-2.119 1.419-4.37.078-2.187-.516-3.272-1.445-4.258-1.205-1.094-2.58-1.015-3.556-.885-.733.079-1.496.584-2.109 1.347-.583.578-.837 1.606-.859 2.669-.057 2.576.289 3.661.826 5.422.638 2.075 2.5 3.105 3.771 2.601z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M57.644 32.002c1.305-.522 1.067-.62 1.937-2.512.696-1.457 1.346-2.106 1.425-4.345.086-2.171-.493-3.29-1.404-4.217-1.223-1.055-2.563-.959-3.532-.836-.749.077-1.507.554-2.128 1.275-.61.556-.861 1.591-.883 2.659-.055 2.556.304 3.646.831 5.396.624 2.064 2.493 3.081 3.754 2.58z"
      ></path>
      <path
        fill="#BABABA"
        d="M57.644 31.994c1.296-.518 1.058-.618 1.922-2.497.692-1.448 1.341-2.095 1.43-4.32.096-2.156-.47-3.307-1.363-4.176-1.239-1.016-2.547-.903-3.508-.787-.763.075-1.518.522-2.148 1.202-.637.535-.885 1.576-.906 2.648-.054 2.538.317 3.632.834 5.371.611 2.051 2.486 3.055 3.739 2.559z"
      ></path>
      <path
        fill="#C1C1C1"
        d="M57.644 31.985c1.288-.515 1.049-.616 1.907-2.483.686-1.437 1.336-2.082 1.435-4.294.104-2.141-.448-3.324-1.322-4.135-1.257-.978-2.533-.849-3.486-.738-.776.074-1.529.492-2.168 1.13-.662.513-.907 1.56-.929 2.636-.052 2.519.333 3.618.839 5.346.599 2.039 2.481 3.031 3.724 2.538z"
      ></path>
      <path
        fill="#C9C9C9"
        d="M57.644 31.976c1.278-.511 1.04-.615 1.892-2.468.681-1.427 1.33-2.071 1.439-4.269.114-2.125-.424-3.342-1.281-4.094-1.274-.939-2.516-.794-3.462-.69-.79.072-1.54.462-2.188 1.058-.688.492-.931 1.544-.953 2.626-.05 2.5.346 3.603.843 5.32.588 2.027 2.475 3.007 3.71 2.517z"
      ></path>
      <path
        fill="#D1D1D1"
        d="M57.645 31.968c1.269-.508 1.029-.614 1.875-2.454.678-1.417 1.327-2.059 1.446-4.244.121-2.11-.402-3.359-1.241-4.053-1.292-.901-2.501-.739-3.438-.641-.806.07-1.552.431-2.208.985-.714.471-.955 1.529-.976 2.616-.049 2.481.36 3.588.847 5.295.575 2.014 2.467 2.983 3.695 2.496z"
      ></path>
      <path
        fill="#D8D8D8"
        d="M57.645 31.96c1.259-.504 1.02-.613 1.86-2.44.672-1.407 1.321-2.046 1.451-4.218.129-2.095-.38-3.376-1.199-4.013-1.311-.862-2.486-.683-3.416-.591-.819.069-1.563.399-2.228.913-.74.45-.978 1.514-.999 2.604-.048 2.463.374 3.575.851 5.27.565 2.001 2.462 2.957 3.68 2.475z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M57.645 31.95c1.251-.5 1.011-.611 1.845-2.425.667-1.397 1.315-2.034 1.455-4.193.139-2.079-.356-3.395-1.159-3.972-1.327-.823-2.47-.628-3.392-.542-.833.067-1.573.369-2.247.841-.766.429-1.001 1.499-1.022 2.594-.047 2.445.389 3.561.855 5.245.553 1.988 2.455 2.932 3.665 2.452z"
      ></path>
      <path
        fill="#E8E8E8"
        d="M57.645 31.942c1.242-.497 1.002-.61 1.83-2.411.662-1.387 1.311-2.022 1.46-4.167.147-2.064-.334-3.412-1.118-3.931-1.345-.784-2.454-.573-3.369-.494a4.872 4.872 0 00-2.268.768c-.791.408-1.024 1.483-1.044 2.583-.045 2.426.403 3.546.858 5.219.541 1.978 2.45 2.909 3.651 2.433z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M57.645 31.934c1.232-.494.992-.609 1.814-2.397.658-1.376 1.305-2.01 1.466-4.142.156-2.048-.312-3.429-1.077-3.89-1.362-.746-2.439-.518-3.345-.444a5.373 5.373 0 00-2.287.695c-.818.386-1.048 1.468-1.069 2.572-.044 2.408.417 3.532.863 5.194.528 1.965 2.442 2.884 3.635 2.412z"
      ></path>
      <path
        fill="#F7F7F7"
        d="M57.645 31.925c1.225-.49.984-.607 1.799-2.383.653-1.367 1.3-1.998 1.471-4.117.165-2.033-.289-3.447-1.036-3.849-1.38-.707-2.423-.462-3.322-.396a6.03 6.03 0 00-2.308.623c-.844.366-1.071 1.453-1.092 2.562-.042 2.388.431 3.518.868 5.168.516 1.954 2.436 2.861 3.62 2.392z"
      ></path>
      <path
        fill="#fff"
        d="M57.645 31.916c1.215-.486.974-.606 1.784-2.368.648-1.356 1.295-1.986 1.475-4.091.174-2.018-.266-3.464-.995-3.808-1.397-.669-2.407-.408-3.298-.348a6.878 6.878 0 00-2.326.551c-.871.344-1.095 1.438-1.116 2.551-.04 2.37.446 3.503.871 5.144.504 1.94 2.431 2.835 3.605 2.369z"
      ></path>
      <path d="M56.342 22.627c.698 0 1.581.465 1.999 1.092.442.628.767 1.511.767 2.511 0 1.488-.163 3.138-1.046 3.649-.279.163-.884.302-1.232.302-.79 0-.86-.512-1.604-1.279-.255-.279-1.023-1.627-1.023-2.743 0-.697-.163-1.697.441-2.581.42-.649.954-.951 1.698-.951zm-.186 1.247c.272-.421 1.363-.223 1.759.645.397.868.322 2.752.049 2.851-.718.223-.495-.818-1.115-1.76-.619-.892-.966-1.314-.693-1.736z"></path>
      <path
        fill="#070707"
        d="M56.173 23.893c.269-.416 1.346-.22 1.737.636.392.856.318 2.717.049 2.814-.709.22-.489-.808-1.101-1.738-.611-.88-.954-1.296-.685-1.712z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M56.191 23.91c.266-.411 1.329-.217 1.715.628.387.845.314 2.682.049 2.778-.701.217-.484-.797-1.088-1.715-.604-.869-.942-1.28-.676-1.691z"
      ></path>
      <path
        fill="#161616"
        d="M56.208 23.928c.263-.406 1.312-.215 1.692.62.382.834.311 2.647.048 2.742-.692.214-.477-.788-1.073-1.693-.595-.858-.929-1.263-.667-1.669z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M56.226 23.945c.258-.399 1.293-.211 1.67.612.376.824.306 2.613.047 2.707-.683.211-.471-.776-1.059-1.67-.587-.848-.917-1.248-.658-1.649z"
      ></path>
      <path
        fill="#262626"
        d="M56.243 23.963c.255-.395 1.277-.208 1.648.604.371.812.301 2.577.046 2.67-.672.209-.464-.767-1.044-1.648-.58-.836-.905-1.231-.65-1.626z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M56.26 23.981c.253-.39 1.26-.206 1.627.595.366.802.297 2.542.046 2.634-.665.206-.458-.756-1.031-1.627-.572-.823-.894-1.212-.642-1.602z"
      ></path>
      <path
        fill="#353535"
        d="M56.278 23.999c.249-.384 1.243-.203 1.604.587.361.791.293 2.507.046 2.598-.656.204-.452-.745-1.017-1.604-.565-.813-.882-1.197-.633-1.581z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M56.295 24.017c.246-.378 1.226-.2 1.582.579.356.78.29 2.472.045 2.562-.646.201-.446-.735-1.002-1.581-.558-.802-.87-1.181-.625-1.56z"
      ></path>
      <path
        fill="#444"
        d="M56.313 24.034c.241-.373 1.208-.197 1.559.571.352.769.286 2.438.044 2.526-.637.198-.439-.725-.988-1.559-.549-.791-.857-1.164-.615-1.538z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M56.33 24.052c.238-.368 1.19-.194 1.537.563.347.758.281 2.403.044 2.489-.628.195-.433-.714-.974-1.537-.543-.779-.845-1.147-.607-1.515z"
      ></path>
      <path
        fill="#545454"
        d="M56.347 24.07c.235-.362 1.174-.192 1.515.554.341.747.276 2.368.042 2.454-.619.191-.426-.705-.96-1.515-.533-.767-.831-1.13-.597-1.493z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M56.365 24.088c.231-.357 1.157-.189 1.493.546.336.735.273 2.333.042 2.417-.609.189-.42-.694-.946-1.492-.526-.756-.82-1.114-.589-1.471z"
      ></path>
      <path
        fill="#636363"
        d="M56.383 24.106c.228-.352 1.139-.186 1.47.539.332.725.269 2.298.041 2.381-.6.187-.413-.684-.931-1.47-.518-.746-.808-1.098-.58-1.45z"
      ></path>
      <path
        fill="#6B6B6B"
        d="M56.4 24.124c.224-.347 1.122-.183 1.448.53.326.714.265 2.263.041 2.345-.591.184-.408-.673-.918-1.447-.51-.735-.795-1.082-.571-1.428z"
      ></path>
      <path
        fill="#727272"
        d="M56.417 24.141c.221-.341 1.104-.181 1.425.522.321.703.261 2.229.04 2.308-.582.181-.401-.663-.903-1.425-.502-.722-.783-1.064-.562-1.405z"
      ></path>
      <path
        fill="#7A7A7A"
        d="M56.434 24.159c.218-.336 1.087-.178 1.403.514.316.692.256 2.193.04 2.272-.574.178-.395-.653-.889-1.403-.494-.711-.771-1.047-.554-1.383z"
      ></path>
      <path
        fill="#828282"
        d="M56.452 24.177c.213-.331 1.07-.175 1.38.505.312.681.252 2.158.039 2.236-.564.175-.388-.642-.875-1.38-.486-.699-.758-1.031-.544-1.361z"
      ></path>
      <path
        fill="#898989"
        d="M56.47 24.194c.21-.325 1.053-.172 1.358.498.307.669.25 2.124.039 2.201-.555.172-.383-.632-.861-1.358-.479-.69-.746-1.015-.536-1.341z"
      ></path>
      <path
        fill="#919191"
        d="M56.487 24.212c.207-.32 1.035-.169 1.335.49.301.658.246 2.088.038 2.164-.546.17-.376-.621-.846-1.335-.471-.678-.734-.999-.527-1.319z"
      ></path>
      <path
        fill="#999"
        d="M56.504 24.23c.204-.314 1.018-.167 1.314.481.295.647.239 2.054.036 2.128-.536.167-.369-.611-.832-1.314-.462-.666-.721-.98-.518-1.295z"
      ></path>
      <path
        fill="#666"
        d="M72.056 32.391c3.487-.372 4.719-1.72 5.347-4.068.558-2.092.582-4.417-.976-7.137-1.465-2.603-2.301-3.022-4.417-3.185-3.254-.278-4.789 1.999-5.51 3.626-.767 1.767-.604 1.511-.558 3.743.047 2.348 1.37 3.002 2.185 4.467.813 1.442 3.534 2.577 3.929 2.554z"
      ></path>
      <path
        fill="#6D6D6D"
        d="M72.058 32.377c3.474-.365 4.719-1.729 5.332-4.058.549-2.106.576-4.419-.969-7.075-1.432-2.517-2.272-2.932-4.363-3.094-3.244-.278-4.824 1.896-5.547 3.511-.744 1.705-.606 1.523-.557 3.726.052 2.346 1.378 2.978 2.191 4.442.813 1.446 3.518 2.572 3.913 2.548z"
      ></path>
      <path
        fill="#757575"
        d="M72.059 32.364c3.461-.358 4.721-1.737 5.318-4.048.541-2.121.572-4.42-.962-7.013-1.398-2.431-2.243-2.842-4.308-3.002-3.235-.277-4.86 1.792-5.585 3.395-.719 1.643-.608 1.536-.556 3.708.057 2.346 1.385 2.953 2.196 4.419.813 1.449 3.503 2.565 3.897 2.541z"
      ></path>
      <path
        fill="#7C7C7C"
        d="M72.061 32.351c3.447-.352 4.721-1.745 5.303-4.038.532-2.136.567-4.423-.955-6.951-1.365-2.345-2.213-2.751-4.254-2.911-3.224-.275-4.894 1.69-5.622 3.28-.697 1.581-.611 1.548-.555 3.691.062 2.344 1.391 2.929 2.202 4.395.813 1.451 3.486 2.558 3.881 2.534z"
      ></path>
      <path
        fill="#848484"
        d="M72.063 32.337c3.434-.345 4.721-1.753 5.287-4.027.524-2.151.563-4.425-.947-6.889-1.333-2.259-2.186-2.661-4.201-2.819-3.214-.275-4.929 1.587-5.66 3.164-.672 1.518-.612 1.56-.554 3.674.068 2.343 1.399 2.904 2.209 4.37.815 1.455 3.471 2.552 3.866 2.527z"
      ></path>
      <path
        fill="#8C8C8C"
        d="M72.065 32.324c3.42-.338 4.721-1.762 5.272-4.018.516-2.165.558-4.426-.94-6.827-1.299-2.172-2.156-2.571-4.146-2.727-3.205-.273-4.964 1.484-5.697 3.048-.649 1.457-.615 1.573-.553 3.658.073 2.341 1.406 2.879 2.214 4.346.813 1.458 3.455 2.545 3.85 2.52z"
      ></path>
      <path
        fill="#939393"
        d="M72.066 32.311c3.407-.332 4.724-1.77 5.258-4.008.507-2.179.553-4.428-.934-6.765-1.266-2.086-2.125-2.48-4.09-2.636-3.194-.273-5 1.381-5.736 2.933-.625 1.394-.616 1.585-.552 3.64.078 2.34 1.413 2.855 2.221 4.322.813 1.461 3.439 2.538 3.833 2.514z"
      ></path>
      <path
        fill="#9B9B9B"
        d="M72.068 32.297c3.393-.326 4.723-1.778 5.243-3.998.498-2.194.547-4.43-.926-6.704-1.233-2-2.098-2.39-4.038-2.544-3.184-.271-5.034 1.277-5.773 2.817-.602 1.333-.619 1.598-.551 3.624.083 2.339 1.42 2.831 2.226 4.299.815 1.464 3.424 2.532 3.819 2.506z"
      ></path>
      <path
        fill="#A3A3A3"
        d="M72.069 32.284c3.381-.318 4.724-1.787 5.23-3.988.489-2.209.542-4.432-.921-6.641-1.2-1.914-2.068-2.301-3.982-2.453-3.174-.271-5.069 1.174-5.811 2.702-.579 1.269-.621 1.61-.551 3.606.089 2.337 1.427 2.805 2.233 4.274.815 1.468 3.408 2.525 3.802 2.5z"
      ></path>
      <path
        fill="#aaa"
        d="M72.072 32.27c3.366-.312 4.724-1.795 5.213-3.978.481-2.224.538-4.434-.912-6.58-1.167-1.828-2.04-2.209-3.929-2.361-3.164-.27-5.104 1.071-5.848 2.586-.555 1.208-.623 1.622-.549 3.589.093 2.336 1.433 2.781 2.239 4.25.814 1.473 3.39 2.52 3.786 2.494z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M72.073 32.257c3.353-.305 4.725-1.803 5.199-3.967.472-2.238.533-4.436-.906-6.519-1.134-1.741-2.01-2.12-3.874-2.269-3.153-.269-5.138.968-5.886 2.47-.531 1.146-.625 1.635-.548 3.572.099 2.335 1.441 2.756 2.246 4.226.813 1.475 3.374 2.513 3.769 2.487z"
      ></path>
      <path
        fill="#BABABA"
        d="M72.075 32.243c3.34-.298 4.726-1.811 5.184-3.958.464-2.252.529-4.438-.898-6.456-1.101-1.656-1.981-2.03-3.82-2.178-3.144-.268-5.173.865-5.923 2.354-.507 1.084-.627 1.648-.547 3.555.104 2.334 1.448 2.732 2.251 4.202.813 1.48 3.358 2.508 3.753 2.481z"
      ></path>
      <path
        fill="#C1C1C1"
        d="M72.076 32.231c3.327-.292 4.727-1.82 5.17-3.948.455-2.268.524-4.439-.891-6.395-1.068-1.569-1.952-1.939-3.766-2.086-3.133-.267-5.21.761-5.962 2.239-.483 1.021-.627 1.66-.545 3.538.109 2.332 1.455 2.708 2.257 4.177.814 1.482 3.343 2.501 3.737 2.475z"
      ></path>
      <path
        fill="#C9C9C9"
        d="M72.078 32.217c3.313-.285 4.727-1.829 5.155-3.938.446-2.282.518-4.441-.884-6.332-1.035-1.483-1.922-1.849-3.711-1.995-3.124-.266-5.244.659-6 2.124-.46.959-.631 1.672-.545 3.521.115 2.331 1.461 2.682 2.263 4.153.814 1.485 3.327 2.494 3.722 2.467z"
      ></path>
      <path
        fill="#D1D1D1"
        d="M72.079 32.203c3.3-.278 4.728-1.836 5.141-3.928.438-2.296.513-4.443-.877-6.27-1.002-1.396-1.893-1.759-3.657-1.903-3.114-.265-5.279.555-6.037 2.008-.437.897-.633 1.685-.544 3.504.119 2.329 1.469 2.658 2.27 4.129.813 1.489 3.31 2.488 3.704 2.46z"
      ></path>
      <path
        fill="#D8D8D8"
        d="M72.081 32.19c3.286-.272 4.728-1.845 5.126-3.918.429-2.311.509-4.445-.87-6.208-.969-1.311-1.864-1.668-3.604-1.812-3.103-.263-5.314.453-6.074 1.893-.413.835-.634 1.697-.543 3.487.125 2.328 1.476 2.633 2.276 4.105.814 1.492 3.295 2.481 3.689 2.453z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M72.083 32.176c3.273-.264 4.729-1.853 5.111-3.907.42-2.326.504-4.447-.863-6.147-.936-1.224-1.835-1.578-3.548-1.72-3.094-.262-5.349.349-6.112 1.776-.389.773-.637 1.709-.542 3.47.13 2.327 1.482 2.609 2.281 4.082.814 1.495 3.279 2.475 3.673 2.446z"
      ></path>
      <path
        fill="#E8E8E8"
        d="M72.085 32.164c3.259-.259 4.729-1.862 5.097-3.897.411-2.341.498-4.449-.856-6.084-.903-1.138-1.805-1.488-3.495-1.628-3.083-.262-5.384.246-6.149 1.661-.366.711-.639 1.722-.541 3.453.135 2.325 1.489 2.583 2.287 4.057.814 1.495 3.262 2.465 3.657 2.438z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M72.086 32.149c3.247-.251 4.73-1.87 5.082-3.887.404-2.355.495-4.451-.848-6.022-.87-1.052-1.776-1.398-3.441-1.538-3.072-.26-5.418.143-6.187 1.545-.342.649-.641 1.734-.54 3.436.141 2.324 1.497 2.56 2.294 4.033.813 1.502 3.246 2.463 3.64 2.433z"
      ></path>
      <path
        fill="#F7F7F7"
        d="M72.088 32.136c3.233-.244 4.731-1.878 5.067-3.877.395-2.369.49-4.453-.841-5.96-.837-.965-1.748-1.308-3.386-1.445-3.062-.26-5.455.04-6.225 1.429-.318.587-.642 1.748-.539 3.419.146 2.323 1.504 2.535 2.3 4.009.813 1.504 3.23 2.455 3.624 2.425z"
      ></path>
      <path
        fill="#fff"
        d="M72.089 32.123c3.221-.238 4.732-1.887 5.053-3.868.386-2.384.485-4.455-.834-5.898-.803-.879-1.718-1.218-3.332-1.354-3.053-.258-5.488-.062-6.262 1.314-.295.524-.645 1.759-.538 3.402.151 2.321 1.511 2.51 2.306 3.985.813 1.507 3.213 2.448 3.607 2.419z"
      ></path>
      <path d="M71.778 22.534c1.743 0 2.766 1.558 3.114 3.557.14.907-.07 1.953-.627 2.674-.628.836-1.744 1.348-2.649 1.348-.86 0-1.837.14-2.348-.558-.511-.72-.628-2.325-.628-3.464 0-1.278.373-2.185 1.023-2.906.487-.535 1.37-.651 2.115-.651zm.111.718c.316-.211.843 0 1.45.685.658.738.948 1.317.158 1.739-.606.316-.79-.633-1.16-1.028-.579-.632-1.08-.975-.448-1.396z"></path>
      <path
        fill="#070707"
        d="M71.901 23.271c.311-.209.832 0 1.428.675.648.727.925 1.298.156 1.712-.593.316-.776-.623-1.139-1.012-.57-.622-1.063-.957-.445-1.375z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M71.914 23.29c.303-.209.818 0 1.407.665.637.715.901 1.278.152 1.687-.581.314-.761-.614-1.118-.997-.56-.612-1.047-.941-.441-1.355z"
      ></path>
      <path
        fill="#161616"
        d="M71.927 23.308c.296-.207.806 0 1.385.655.629.705.878 1.258.151 1.661-.568.314-.748-.604-1.097-.981-.554-.601-1.032-.924-.439-1.335z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M71.94 23.327c.291-.206.793 0 1.363.645.62.693.855 1.239.148 1.635-.555.313-.732-.595-1.076-.966-.544-.591-1.014-.906-.435-1.314z"
      ></path>
      <path
        fill="#262626"
        d="M71.953 23.346c.283-.204.78 0 1.341.634.61.684.833 1.219.147 1.609-.543.312-.719-.584-1.055-.951-.536-.579-.999-.887-.433-1.292z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M71.966 23.365c.277-.203.769 0 1.32.624.6.672.808 1.2.144 1.584-.53.31-.704-.576-1.034-.936-.528-.57-.984-.871-.43-1.272z"
      ></path>
      <path
        fill="#353535"
        d="M71.979 23.384c.271-.202.755 0 1.298.614.589.661.785 1.18.142 1.558-.517.309-.688-.567-1.013-.921-.518-.56-.968-.854-.427-1.251z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M71.992 23.403c.264-.201.743 0 1.276.603.581.651.763 1.162.14 1.533-.504.309-.674-.557-.992-.905-.511-.55-.952-.837-.424-1.231z"
      ></path>
      <path
        fill="#444"
        d="M72.004 23.422c.258-.199.731 0 1.256.594.571.639.738 1.141.137 1.506-.492.308-.66-.548-.971-.89-.502-.539-.936-.819-.422-1.21z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M72.017 23.441c.251-.198.719 0 1.234.583.561.628.716 1.122.135 1.481-.479.306-.646-.539-.95-.875-.494-.529-.92-.802-.419-1.189z"
      ></path>
      <path
        fill="#545454"
        d="M72.03 23.46c.245-.197.706 0 1.213.573.55.617.691 1.103.132 1.455-.466.305-.631-.529-.929-.86-.485-.518-.904-.785-.416-1.168z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M72.043 23.479c.238-.196.694 0 1.192.563.541.606.667 1.083.129 1.429-.454.305-.617-.52-.908-.844-.477-.509-.888-.768-.413-1.148z"
      ></path>
      <path
        fill="#636363"
        d="M72.056 23.498c.231-.195.681 0 1.169.553.532.595.646 1.063.128 1.404-.44.303-.602-.511-.887-.83-.468-.498-.872-.751-.41-1.127z"
      ></path>
      <path
        fill="#6B6B6B"
        d="M72.069 23.517c.224-.193.668 0 1.148.542.521.585.622 1.044.125 1.378-.428.303-.586-.501-.866-.814-.46-.488-.856-.733-.407-1.106z"
      ></path>
      <path
        fill="#727272"
        d="M72.082 23.535c.218-.191.656 0 1.127.533.512.574.599 1.024.123 1.352-.416.302-.573-.492-.846-.798-.451-.478-.84-.717-.404-1.087z"
      ></path>
      <path
        fill="#7A7A7A"
        d="M72.095 23.555c.211-.19.643 0 1.104.522.502.563.576 1.004.121 1.326-.403.301-.559-.482-.825-.783-.441-.468-.823-.7-.4-1.065z"
      ></path>
      <path
        fill="#828282"
        d="M72.108 23.574c.205-.189.63 0 1.083.512.493.551.552.985.119 1.299-.39.3-.544-.472-.804-.767-.434-.457-.808-.682-.398-1.044z"
      ></path>
      <path
        fill="#898989"
        d="M72.121 23.592c.198-.188.618 0 1.062.502.482.541.528.965.116 1.274-.378.299-.53-.463-.784-.752-.425-.447-.792-.664-.394-1.024z"
      ></path>
      <path
        fill="#919191"
        d="M72.133 23.611c.193-.187.606 0 1.041.492.473.53.505.946.114 1.249-.364.298-.515-.454-.761-.737-.418-.437-.777-.648-.394-1.004z"
      ></path>
      <path
        fill="#999"
        d="M72.147 23.631c.185-.186.592 0 1.018.481.464.519.482.926.112 1.223-.353.297-.501-.444-.742-.722-.407-.426-.759-.631-.388-.982z"
      ></path>
      <path d="M63.141 24.293c.546-.211.972-.223 1.817.334 1.022.674.551 1.694-.251 1.485-.693-.179-.78-.22-1.417-.351-1.002-.207-1.175-1.071-.149-1.468z"></path>
      <path
        fill="#050505"
        d="M63.162 24.335c.536-.204.96-.212 1.793.331.99.648.534 1.618-.26 1.415-.688-.177-.757-.212-1.383-.34-.986-.205-1.157-1.025-.15-1.406z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M63.184 24.376c.524-.195.947-.201 1.77.328.957.623.517 1.543-.269 1.343-.684-.174-.733-.203-1.349-.329-.971-.2-1.14-.977-.152-1.342z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M63.205 24.417c.512-.187.934-.189 1.746.324.924.598.5 1.468-.277 1.271-.679-.171-.71-.195-1.315-.317-.956-.194-1.122-.928-.154-1.278z"
      ></path>
      <path
        fill="#141414"
        d="M63.226 24.457c.501-.178.922-.178 1.721.321.893.572.484 1.393-.284 1.2-.676-.168-.688-.187-1.281-.306-.941-.19-1.106-.879-.156-1.215z"
      ></path>
      <path
        fill="#191919"
        d="M63.247 24.499c.491-.171.91-.168 1.697.317.86.546.468 1.317-.292 1.129-.671-.166-.666-.179-1.247-.295-.926-.186-1.088-.831-.158-1.151z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M63.269 24.539c.478-.163.896-.156 1.672.314.828.521.451 1.242-.299 1.058-.667-.163-.643-.171-1.213-.285-.912-.179-1.072-.782-.16-1.087z"
      ></path>
      <path
        fill="#232323"
        d="M63.29 24.58c.467-.154.884-.145 1.649.312.795.496.434 1.167-.308.986-.664-.16-.62-.163-1.18-.273-.896-.176-1.053-.735-.161-1.025z"
      ></path>
      <path
        fill="#282828"
        d="M63.311 24.621c.456-.146.872-.135 1.625.308.762.47.417 1.091-.316.916-.659-.157-.596-.155-1.145-.263-.882-.171-1.036-.686-.164-.961z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M63.332 24.662c.445-.139.86-.124 1.602.304.731.445.401 1.016-.325.843-.654-.154-.572-.146-1.11-.25-.867-.165-1.02-.638-.167-.897z"
      ></path>
      <path
        fill="#333"
        d="M63.354 24.703c.433-.13.847-.112 1.577.301.698.418.384.94-.333.772-.65-.152-.55-.138-1.077-.24-.852-.16-1.001-.589-.167-.833z"
      ></path>
      <path
        fill="#383838"
        d="M63.375 24.743c.422-.122.834-.101 1.553.298.667.394.368.865-.34.701-.646-.148-.527-.13-1.043-.229-.838-.156-.984-.54-.17-.77z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M63.396 24.784c.411-.113.822-.09 1.53.295.633.368.352.791-.349.63-.642-.146-.504-.122-1.008-.218-.824-.152-.967-.492-.173-.707z"
      ></path>
      <path
        fill="#424242"
        d="M63.418 24.826c.399-.106.81-.08 1.505.291.601.343.334.715-.357.558-.638-.143-.481-.114-.974-.207-.809-.146-.951-.444-.174-.642z"
      ></path>
      <path
        fill="#474747"
        d="M63.439 24.866c.388-.098.796-.068 1.481.288.569.317.318.64-.365.487-.634-.14-.457-.105-.94-.196-.794-.141-.933-.395-.176-.579z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M63.46 24.908c.377-.089.785-.057 1.457.284.536.292.302.564-.373.416-.629-.138-.434-.097-.905-.185-.78-.136-.916-.347-.179-.515z"
      ></path>
      <path
        fill="#515151"
        d="M63.482 24.948c.365-.081.771-.046 1.432.281.504.266.285.489-.381.345-.625-.135-.411-.089-.871-.174-.764-.131-.898-.298-.18-.452z"
      ></path>
      <path
        fill="#565656"
        d="M63.503 24.989c.354-.073.758-.035 1.408.278.472.241.269.414-.389.273-.621-.132-.388-.081-.837-.162-.749-.127-.881-.251-.182-.389z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M63.524 25.03c.343-.065.747-.023 1.385.275.438.215.25.338-.398.202-.617-.129-.364-.073-.803-.151-.734-.123-.863-.203-.184-.326z"
      ></path>
      <path
        fill="#606060"
        d="M63.545 25.071c.332-.057.734-.013 1.361.271.407.189.235.263-.406.13-.612-.126-.341-.064-.769-.14-.719-.117-.846-.153-.186-.261z"
      ></path>
      <path
        fill="#666"
        d="M63.567 25.111c.32-.049.72-.001 1.336.268.375.164.219.188-.414.059-.607-.124-.318-.056-.734-.129-.705-.111-.829-.104-.188-.198zM61.363 43.13c-3.022.117-7.811-8.345-7.927-4.834-.093 2.975.07 2.929.07 5.811 0 1.93-.883 2.069-2.79 4.975-.977 1.535-1.743 3.185-2.348 4.858-.372 1-.72 2.046-1 3.069l-.441 1.557c-.953 3.51-4.347 7.835-5.137 11.345-.792 3.487-1.72 5.718-1.604 10.391.117 4.673.163 3.324 1.581 4.487 1.395 1.163 2.836 2.255 5.044 4.208 2.325 2.022 7.16 5.556 7.811 6.648.697 1.116.674 3.627.255 4.44-.418.79-4.068 1.232-4.045 1.232-.023 0 3.185 4.416 3.813 5.043.604.604 3.208 3.511 13.808 1.535 5.975-1.116 10.6-4.463 13.948-7.695 4.323-4.208 2.138-5.416 2.696-7.532.814-3.045 3.464-4.184 4.068-7.625.07-.488.232-.86.674-1.58.674-1.023.512-3.046.512-4.905 0-4.835-.559-9.763-1.674-13.389-1.023-3.395-2.649-5.765-4.045-8.834-2.789-6.114-2.649-8.857-5.137-12.762-2.836-4.51-1.441-7.508-5.207-7.323-4.696.255-8.485 6.694-12.925 6.88z"
      ></path>
      <path
        fill="#6D6D6D"
        d="M61.357 43.481c-2.996.114-7.666-8.237-7.827-4.901-.102 2.827.032 2.802.01 5.568-.049 1.895-.954 2.143-2.818 4.998-.972 1.538-1.703 3.168-2.257 4.804-.313 1.05-.504 2.073-.785 3.075-.135.53-.484 1.029-.706 1.628-1.051 3.481-4.374 7.807-5.153 11.261-.796 3.49-1.734 5.713-1.602 10.377.118 4.52.127 3.286 1.541 4.46 1.383 1.168 2.854 2.282 5.056 4.23 2.319 2.017 7.18 5.559 7.827 6.647.694 1.112.688 3.654.273 4.463-.416.787-4.062 1.251-4.039 1.251-.023 0 3.168 4.38 3.796 5.007.604.604 3.196 3.49 13.779 1.519 5.98-1.115 10.694-4.44 13.908-7.702 4.128-4.12 1.972-5.415 2.527-7.519.811-3.041 3.64-4.186 4.243-7.621.07-.487.243-.857.683-1.575.676-1.034.504-3.05.511-4.903.021-4.852-.551-9.762-1.667-13.377-1.023-3.384-2.648-5.752-4.04-8.816-2.785-6.104-2.654-8.852-5.146-12.745-2.771-4.395-1.485-7.291-5.169-7.1-4.637.269-8.512 6.787-12.945 6.971z"
      ></path>
      <path
        fill="#757575"
        d="M61.351 43.831c-2.971.111-7.522-8.128-7.726-4.967-.112 2.678-.006 2.675-.051 5.325-.097 1.861-1.023 2.217-2.845 5.022-.969 1.542-1.662 3.151-2.167 4.748-.253 1.101-.288 2.101-.57 3.083-.152.549-.641 1.012-.969 1.698-1.147 3.451-4.398 7.781-5.169 11.178-.801 3.493-1.747 5.708-1.599 10.362.12 4.368.092 3.248 1.501 4.437 1.37 1.172 2.871 2.31 5.069 4.252 2.313 2.012 7.199 5.561 7.844 6.646.691 1.108.701 3.681.288 4.486-.41.784-4.054 1.27-4.03 1.27-.023 0 3.153 4.343 3.779 4.97.603.603 3.186 3.469 13.75 1.502 5.988-1.115 10.789-4.417 13.869-7.709 3.935-4.034 1.805-5.415 2.357-7.509.809-3.034 3.818-4.185 4.419-7.615.069-.484.254-.854.69-1.567.679-1.044.497-3.055.51-4.9.043-4.868-.543-9.76-1.658-13.365-1.025-3.375-2.647-5.74-4.037-8.798-2.779-6.095-2.657-8.846-5.15-12.728-2.708-4.28-1.53-7.074-5.131-6.877-4.588.277-8.548 6.875-12.974 7.056z"
      ></path>
      <path
        fill="#7C7C7C"
        d="M61.346 44.182c-2.946.108-7.378-8.02-7.627-5.033-.119 2.529-.042 2.548-.11 5.083-.146 1.827-1.094 2.291-2.873 5.045a18.713 18.713 0 00-2.078 4.693c-.193 1.15-.07 2.128-.354 3.089-.17.567-.799.995-1.233 1.769-1.245 3.421-4.424 7.754-5.185 11.094-.807 3.496-1.76 5.702-1.598 10.349.123 4.216.057 3.209 1.462 4.41 1.359 1.178 2.89 2.338 5.083 4.276 2.307 2.007 7.218 5.563 7.86 6.645.688 1.104.715 3.71.305 4.51-.406.78-4.047 1.288-4.024 1.288-.023 0 3.137 4.307 3.762 4.931.603.603 3.174 3.449 13.721 1.488 5.994-1.115 10.882-4.394 13.83-7.717 3.74-3.946 1.638-5.415 2.188-7.498.806-3.029 3.996-4.184 4.594-7.61.069-.483.265-.85.698-1.561.681-1.057.489-3.061.509-4.899.065-4.883-.535-9.757-1.649-13.352-1.025-3.366-2.646-5.728-4.032-8.78-2.774-6.085-2.663-8.841-5.156-12.71-2.646-4.166-1.575-6.857-5.095-6.655-4.534.289-8.58 6.966-12.998 7.145z"
      ></path>
      <path
        fill="#848484"
        d="M61.34 44.532c-2.919.107-7.234-7.911-7.526-5.099-.128 2.381-.08 2.421-.17 4.84-.194 1.792-1.163 2.365-2.9 5.069a17.056 17.056 0 00-1.987 4.638c-.134 1.202.147 2.156-.14 3.097-.188.586-.957.977-1.498 1.839-1.341 3.391-4.45 7.728-5.199 11.011-.813 3.5-1.774 5.696-1.596 10.334.125 4.064.022 3.17 1.423 4.385 1.347 1.184 2.907 2.365 5.095 4.298 2.302 2.002 7.238 5.566 7.876 6.643.685 1.101.729 3.738.322 4.534-.403.777-4.042 1.307-4.019 1.307-.023 0 3.122 4.271 3.746 4.895.601.601 3.164 3.427 13.692 1.472 6-1.114 10.977-4.372 13.791-7.725 3.544-3.859 1.471-5.414 2.017-7.486.805-3.025 4.173-4.185 4.77-7.606.07-.481.276-.847.707-1.554.683-1.067.481-3.065.509-4.897.086-4.898-.529-9.755-1.643-13.339-1.027-3.357-2.645-5.715-4.028-8.763-2.769-6.076-2.667-8.835-5.163-12.692-2.581-4.051-1.619-6.64-5.057-6.432-4.479.298-8.61 7.055-13.022 7.231z"
      ></path>
      <path
        fill="#8C8C8C"
        d="M61.335 44.882c-2.894.104-7.091-7.802-7.427-5.164-.138 2.232-.118 2.293-.23 4.596-.242 1.758-1.233 2.439-2.929 5.094a15.58 15.58 0 00-1.896 4.583c-.076 1.252.363 2.184.075 3.104-.206.604-1.114.959-1.761 1.909-1.438 3.362-4.476 7.702-5.215 10.928-.818 3.502-1.787 5.69-1.593 10.319.127 3.912-.014 3.132 1.383 4.36 1.334 1.188 2.924 2.392 5.105 4.32 2.298 1.998 7.259 5.569 7.894 6.643.681 1.097.742 3.765.338 4.557-.398.773-4.035 1.325-4.012 1.325-.023 0 3.106 4.234 3.73 4.857.601.6 3.153 3.407 13.664 1.456 6.007-1.113 11.07-4.348 13.75-7.732 3.35-3.772 1.305-5.413 1.847-7.475.802-3.019 4.35-4.184 4.945-7.601.069-.479.288-.843.714-1.547.687-1.078.474-3.069.508-4.894.107-4.915-.52-9.753-1.635-13.327-1.027-3.349-2.643-5.703-4.022-8.745-2.765-6.066-2.671-8.831-5.17-12.675-2.517-3.937-1.663-6.423-5.019-6.21-4.425.31-8.64 7.146-13.044 7.319z"
      ></path>
      <path
        fill="#939393"
        d="M61.329 45.232c-2.869.102-6.947-7.694-7.326-5.23-.147 2.083-.155 2.166-.291 4.353-.292 1.724-1.304 2.513-2.957 5.117a14.206 14.206 0 00-1.806 4.527c-.016 1.303.581 2.212.291 3.111-.224.623-1.272.942-2.025 1.979-1.536 3.332-4.501 7.675-5.231 10.844-.825 3.505-1.801 5.685-1.591 10.306.128 3.759-.049 3.094 1.343 4.334 1.322 1.193 2.942 2.419 5.119 4.343 2.292 1.992 7.277 5.571 7.91 6.641.678 1.094.756 3.793.355 4.581-.396.771-4.029 1.344-4.005 1.344-.023 0 3.09 4.197 3.712 4.82.6.599 3.141 3.386 13.635 1.44 6.013-1.113 11.164-4.325 13.711-7.74 3.155-3.685 1.137-5.413 1.676-7.463.8-3.013 4.528-4.184 5.121-7.596.069-.478.298-.84.722-1.542.689-1.089.467-3.074.507-4.892.128-4.931-.512-9.751-1.626-13.314-1.028-3.339-2.643-5.69-4.019-8.727-2.759-6.057-2.675-8.825-5.176-12.658-2.454-3.821-1.708-6.206-4.981-5.987-4.371.323-8.671 7.239-13.068 7.409z"
      ></path>
      <path
        fill="#9B9B9B"
        d="M61.323 45.583c-2.842.1-6.802-7.585-7.226-5.295-.156 1.935-.192 2.039-.351 4.11-.34 1.689-1.373 2.587-2.984 5.14a12.977 12.977 0 00-1.716 4.473c.044 1.354.798 2.239.506 3.118-.242.641-1.43.925-2.289 2.049-1.633 3.303-4.527 7.648-5.247 10.761-.83 3.509-1.814 5.679-1.589 10.292.131 3.607-.083 3.056 1.305 4.309 1.31 1.199 2.959 2.447 5.131 4.365 2.287 1.988 7.297 5.575 7.926 6.642.676 1.088.771 3.82.372 4.602-.391.768-4.021 1.363-3.999 1.363-.023 0 3.076 4.161 3.697 4.783.599.598 3.129 3.365 13.605 1.424 6.019-1.113 11.258-4.302 13.671-7.748 2.962-3.598.971-5.412 1.508-7.452.798-3.008 4.705-4.185 5.295-7.592.07-.475.31-.835.731-1.533.692-1.101.459-3.08.507-4.89.149-4.948-.506-9.749-1.619-13.302-1.029-3.33-2.641-5.678-4.015-8.709-2.754-6.047-2.68-8.819-5.184-12.64-2.389-3.707-1.751-5.988-4.943-5.765-4.316.331-8.702 7.327-13.092 7.495z"
      ></path>
      <path
        fill="#A3A3A3"
        d="M61.318 45.933c-2.818.098-6.658-7.476-7.126-5.361-.165 1.786-.229 1.911-.41 3.867-.388 1.654-1.443 2.661-3.012 5.164-.948 1.563-1.418 3.051-1.625 4.417.102 1.405 1.014 2.267.719 3.125-.259.66-1.588.908-2.553 2.119-1.729 3.273-4.552 7.622-5.262 10.678-.836 3.512-1.828 5.674-1.586 10.278.134 3.454-.119 3.016 1.265 4.283 1.298 1.205 2.977 2.475 5.144 4.389 2.28 1.982 7.316 5.576 7.941 6.639.673 1.086.785 3.849.389 4.627-.387.763-4.015 1.381-3.992 1.381-.022 0 3.06 4.124 3.68 4.745.598.598 3.119 3.345 13.576 1.409 6.026-1.113 11.352-4.279 13.632-7.755 2.767-3.511.804-5.412 1.338-7.441.795-3.003 4.882-4.184 5.47-7.586.07-.474.32-.833.739-1.527.694-1.111.451-3.084.506-4.888.172-4.963-.498-9.747-1.61-13.289-1.029-3.32-2.639-5.666-4.01-8.691-2.75-6.038-2.684-8.814-5.189-12.623-2.326-3.592-1.796-5.771-4.906-5.542-4.264.342-8.736 7.416-13.118 7.582z"
      ></path>
      <path
        fill="#aaa"
        d="M61.312 46.283c-2.791.095-6.514-7.367-7.025-5.427l-.471 3.624c-.437 1.621-1.513 2.735-3.04 5.188-.944 1.566-1.376 3.034-1.536 4.361.162 1.456 1.231 2.295.936 3.133-.277.677-1.746.89-2.817 2.189-1.827 3.244-4.579 7.595-5.278 10.594-.841 3.515-1.841 5.668-1.585 10.263.136 3.303-.153 2.979 1.226 4.258 1.286 1.209 2.995 2.502 5.156 4.41 2.275 1.978 7.336 5.579 7.958 6.638.668 1.083.798 3.877.405 4.65-.383.76-4.008 1.4-3.985 1.4-.023 0 3.044 4.087 3.664 4.708.598.596 3.107 3.324 13.547 1.393 6.033-1.112 11.446-4.256 13.594-7.763 2.571-3.423.637-5.411 1.167-7.43.792-2.998 5.059-4.183 5.645-7.581.07-.472.332-.83.748-1.521.697-1.123.444-3.09.505-4.885.194-4.98-.49-9.746-1.603-13.276-1.03-3.312-2.638-5.654-4.005-8.674-2.745-6.028-2.689-8.809-5.197-12.605-2.262-3.478-1.84-5.555-4.868-5.32-4.209.356-8.765 7.511-13.141 7.673z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M61.306 46.633c-2.766.092-6.37-7.259-6.925-5.493l-.531 3.381c-.486 1.586-1.584 2.809-3.068 5.211-.941 1.57-1.336 3.017-1.446 4.306.222 1.506 1.449 2.323 1.15 3.139-.295.697-1.904.874-3.081 2.26-1.924 3.213-4.604 7.569-5.294 10.51-.847 3.52-1.855 5.664-1.582 10.25.137 3.15-.189 2.94 1.186 4.233 1.274 1.215 3.013 2.529 5.168 4.433 2.271 1.972 7.356 5.581 7.976 6.637.665 1.077.812 3.904.421 4.672-.378.757-4.001 1.419-3.978 1.419-.023 0 3.029 4.052 3.647 4.67.596.597 3.097 3.304 13.518 1.378 6.04-1.112 11.54-4.233 13.554-7.77 2.376-3.336.47-5.411.997-7.418.791-2.992 5.237-4.184 5.822-7.578.069-.47.342-.825.755-1.514.699-1.132.436-3.094.504-4.883.216-4.996-.482-9.743-1.594-13.263-1.032-3.302-2.636-5.641-4.001-8.657-2.739-6.019-2.692-8.803-5.202-12.587-2.199-3.363-1.885-5.337-4.831-5.097-4.154.368-8.796 7.601-13.165 7.761z"
      ></path>
      <path
        fill="#BABABA"
        d="M61.302 46.983c-2.741.09-6.226-7.15-6.826-5.558l-.59 3.137c-.535 1.553-1.653 2.884-3.096 5.236-.936 1.573-1.294 3-1.354 4.25.279 1.558 1.665 2.351 1.365 3.147-.313.715-2.061.856-3.345 2.33-2.021 3.184-4.629 7.542-5.309 10.427-.854 3.521-1.868 5.657-1.58 10.234.14 2.998-.224 2.901 1.147 4.208 1.262 1.219 3.03 2.557 5.18 4.455 2.265 1.967 7.375 5.584 7.991 6.636.663 1.074.826 3.932.439 4.696-.375.753-3.995 1.438-3.972 1.438-.023 0 3.012 4.015 3.63 4.633.596.596 3.085 3.283 13.488 1.362 6.046-1.112 11.635-4.21 13.515-7.778 2.182-3.25.304-5.41.829-7.406.788-2.986 5.414-4.184 5.996-7.572.069-.469.353-.823.763-1.508.702-1.144.429-3.099.504-4.881.237-5.011-.475-9.741-1.585-13.25-1.033-3.293-2.636-5.628-3.997-8.639-2.735-6.009-2.697-8.797-5.21-12.57-2.134-3.248-1.929-5.12-4.793-4.875-4.103.378-8.831 7.691-13.19 7.848z"
      ></path>
      <path
        fill="#C1C1C1"
        d="M61.295 47.334c-2.714.088-6.081-7.042-6.725-5.624-.199 1.19-.379 1.403-.65 2.895-.584 1.518-1.724 2.958-3.124 5.26-.933 1.577-1.254 2.983-1.265 4.195.339 1.607 1.882 2.378 1.581 3.154-.332.733-2.22.839-3.609 2.4-2.118 3.154-4.656 7.516-5.324 10.344-.859 3.524-1.882 5.651-1.578 10.221.141 2.845-.26 2.862 1.106 4.182 1.25 1.225 3.048 2.584 5.193 4.479 2.258 1.962 7.395 5.586 8.007 6.634.659 1.07.84 3.96.455 4.719-.371.75-3.988 1.457-3.965 1.457-.023 0 2.997 3.979 3.615 4.596.594.595 3.074 3.263 13.459 1.346 6.052-1.111 11.729-4.187 13.475-7.786 1.987-3.161.137-5.409.658-7.395.787-2.982 5.591-4.183 6.172-7.567.069-.466.364-.818.772-1.5.704-1.155.421-3.104.503-4.878.257-5.028-.468-9.74-1.579-13.239-1.033-3.284-2.634-5.616-3.992-8.621-2.73-6-2.702-8.793-5.216-12.553-2.071-3.133-1.974-4.903-4.756-4.652-4.047.386-8.859 7.777-13.213 7.933z"
      ></path>
      <path
        fill="#C9C9C9"
        d="M61.29 47.684c-2.689.085-5.938-6.933-6.626-5.689-.209 1.041-.417 1.275-.71 2.651-.632 1.483-1.794 3.032-3.152 5.284-.929 1.58-1.212 2.966-1.174 4.14.399 1.658 2.1 2.406 1.796 3.162-.349.751-2.377.821-3.873 2.47-2.214 3.124-4.682 7.489-5.34 10.261-.864 3.528-1.896 5.646-1.576 10.206.144 2.693-.295 2.825 1.068 4.158 1.239 1.229 3.065 2.611 5.205 4.5 2.253 1.957 7.415 5.589 8.024 6.633.656 1.067.854 3.989.472 4.743-.367.747-3.981 1.475-3.959 1.475-.022 0 2.981 3.942 3.598 4.558.595.594 3.063 3.243 13.431 1.331 6.06-1.111 11.822-4.164 13.435-7.793 1.793-3.074-.03-5.408.489-7.384.785-2.976 5.768-4.183 6.347-7.562.069-.465.375-.816.779-1.495.707-1.166.414-3.108.503-4.876.279-5.043-.46-9.737-1.571-13.225-1.034-3.275-2.631-5.604-3.988-8.604-2.725-5.99-2.705-8.787-5.222-12.535-2.007-3.019-2.019-4.686-4.718-4.43-3.994.397-8.891 7.868-13.238 8.021z"
      ></path>
      <path
        fill="#D1D1D1"
        d="M61.285 48.035c-2.664.083-5.793-6.825-6.525-5.755-.218.893-.453 1.148-.771 2.408-.681 1.449-1.863 3.106-3.178 5.307-.927 1.584-1.173 2.95-1.085 4.085.458 1.708 2.316 2.434 2.011 3.167-.367.771-2.535.805-4.136 2.541-2.312 3.095-4.708 7.462-5.356 10.177-.87 3.532-1.909 5.641-1.574 10.192.146 2.541-.332 2.786 1.029 4.131 1.226 1.234 3.083 2.64 5.216 4.522 2.249 1.953 7.435 5.593 8.041 6.632.653 1.063.867 4.017.489 4.767-.364.744-3.975 1.493-3.952 1.493-.023 0 2.966 3.905 3.582 4.521.591.593 3.05 3.222 13.401 1.315 6.065-1.11 11.917-4.14 13.396-7.801 1.598-2.987-.197-5.408.317-7.372.783-2.972 5.946-4.183 6.523-7.558.069-.463.386-.812.788-1.487.708-1.177.406-3.114.502-4.875.3-5.059-.452-9.734-1.563-13.211-1.035-3.267-2.63-5.592-3.982-8.586-2.722-5.98-2.711-8.782-5.23-12.518-1.943-2.904-2.062-4.469-4.679-4.207-3.943.411-8.926 7.961-13.264 8.112z"
      ></path>
      <path
        fill="#D8D8D8"
        d="M61.279 48.385c-2.638.081-5.649-6.715-6.425-5.821-.227.743-.491 1.021-.831 2.165-.729 1.415-1.933 3.18-3.207 5.331-.922 1.588-1.131 2.933-.994 4.029.518 1.76 2.534 2.462 2.227 3.175-.385.789-2.693.788-4.401 2.611-2.409 3.065-4.733 7.436-5.372 10.093-.875 3.534-1.922 5.636-1.571 10.178.148 2.389-.366 2.748.989 4.106 1.213 1.241 3.1 2.667 5.229 4.546 2.243 1.947 7.455 5.594 8.057 6.631.65 1.059.881 4.043.505 4.789-.359.741-3.968 1.513-3.945 1.513-.023 0 2.95 3.868 3.564 4.483.592.593 3.041 3.201 13.372 1.299 6.072-1.109 12.011-4.117 13.357-7.808 1.403-2.9-.364-5.407.147-7.361.78-2.966 6.124-4.183 6.698-7.553.069-.462.397-.808.796-1.48.711-1.189.399-3.119.501-4.873.322-5.075-.445-9.733-1.555-13.2-1.036-3.257-2.63-5.58-3.979-8.568-2.715-5.972-2.714-8.777-5.235-12.5-1.879-2.79-2.108-4.251-4.644-3.985-3.883.422-8.951 8.052-13.283 8.2z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M61.273 48.735c-2.612.078-5.505-6.606-6.325-5.886-.235.595-.529.893-.89 1.922-.778 1.381-2.004 3.253-3.235 5.354-.919 1.591-1.091 2.916-.904 3.974.577 1.811 2.75 2.49 2.441 3.183-.403.808-2.85.77-4.664 2.681-2.506 3.036-4.758 7.41-5.387 10.011-.882 3.537-1.936 5.63-1.569 10.164.15 2.237-.402 2.708.949 4.081 1.201 1.245 3.117 2.694 5.241 4.567 2.239 1.941 7.474 5.598 8.074 6.629.646 1.055.895 4.071.521 4.813-.354.737-3.96 1.531-3.938 1.531-.022 0 2.935 3.832 3.547 4.446.592.591 3.03 3.18 13.344 1.284 6.079-1.109 12.105-4.095 13.316-7.815 1.208-2.814-.531-5.407-.021-7.35.777-2.96 6.3-4.183 6.874-7.549.068-.459.408-.805.804-1.473.713-1.2.391-3.124.5-4.871.343-5.091-.437-9.73-1.548-13.187-1.036-3.247-2.627-5.566-3.974-8.55-2.71-5.962-2.719-8.771-5.242-12.483-1.815-2.674-2.152-4.034-4.604-3.762-3.831.432-8.986 8.14-13.31 8.286z"
      ></path>
      <path
        fill="#E8E8E8"
        d="M61.267 49.086c-2.586.075-5.361-6.499-6.224-5.953-.245.446-.567.766-.951 1.679-.826 1.346-2.073 3.328-3.262 5.378-.915 1.595-1.05 2.899-.813 3.919.636 1.861 2.967 2.517 2.655 3.19-.42.826-3.009.752-4.929 2.751-2.603 3.006-4.784 7.383-5.402 9.927-.888 3.542-1.95 5.624-1.567 10.15.152 2.084-.437 2.67.91 4.055 1.19 1.25 3.136 2.722 5.254 4.592 2.232 1.937 7.492 5.599 8.09 6.627.643 1.052.909 4.1.538 4.837-.35.733-3.954 1.549-3.931 1.549-.023 0 2.918 3.796 3.531 4.409.59.59 3.019 3.159 13.315 1.267 6.084-1.109 12.199-4.07 13.277-7.822 1.014-2.727-.697-5.406-.191-7.338.775-2.955 6.478-4.182 7.048-7.543.069-.457.419-.802.812-1.467.716-1.21.384-3.128.5-4.868.365-5.108-.43-9.729-1.539-13.175-1.038-3.238-2.626-5.554-3.97-8.532-2.706-5.953-2.723-8.766-5.249-12.465-1.751-2.561-2.196-3.817-4.567-3.539-3.778.44-9.017 8.228-13.335 8.372z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M61.262 49.436c-2.562.073-5.217-6.39-6.125-6.019-.253.297-.604.639-1.011 1.436-.874 1.312-2.144 3.401-3.29 5.402-.911 1.598-1.009 2.882-.723 3.863.694 1.911 3.184 2.545 2.87 3.197-.438.844-3.167.735-5.192 2.821-2.7 2.977-4.809 7.356-5.417 9.844-.894 3.544-1.963 5.618-1.565 10.136.155 1.932-.472 2.633.87 4.03 1.178 1.255 3.153 2.749 5.266 4.613 2.228 1.932 7.513 5.603 8.107 6.627.64 1.047.922 4.127.555 4.86-.347.729-3.948 1.567-3.925 1.567-.023 0 2.903 3.758 3.515 4.371.59.59 3.008 3.139 13.285 1.252 6.092-1.108 12.293-4.047 13.239-7.831.819-2.639-.864-5.405-.361-7.326.773-2.95 6.655-4.183 7.224-7.539.069-.456.43-.798.82-1.461.719-1.221.376-3.133.499-4.865.386-5.124-.422-9.727-1.531-13.163-1.038-3.229-2.625-5.541-3.964-8.514-2.702-5.943-2.729-8.761-5.256-12.449-1.688-2.445-2.24-3.599-4.529-3.316-3.728.456-9.05 8.323-13.361 8.464z"
      ></path>
      <path
        fill="#F7F7F7"
        d="M61.257 49.786c-2.536.07-5.074-6.281-6.025-6.083-.262.148-.641.511-1.069 1.192-.924 1.278-2.215 3.476-3.319 5.426-.908 1.602-.968 2.865-.633 3.809.754 1.961 3.401 2.573 3.087 3.204-.457.863-3.325.718-5.457 2.891-2.797 2.947-4.836 7.33-5.434 9.761-.899 3.546-1.976 5.613-1.562 10.122.156 1.781-.507 2.593.831 4.004 1.165 1.262 3.17 2.777 5.279 4.635 2.222 1.927 7.532 5.605 8.124 6.626.635 1.044.935 4.155.571 4.883-.343.728-3.941 1.587-3.918 1.587-.023 0 2.887 3.722 3.498 4.333.59.588 2.997 3.118 13.257 1.237 6.099-1.109 12.387-4.025 13.199-7.839.625-2.551-1.032-5.404-.531-7.314.771-2.944 6.832-4.183 7.398-7.534.069-.453.441-.794.83-1.454.72-1.232.369-3.137.498-4.863.408-5.14-.415-9.725-1.523-13.149-1.039-3.22-2.624-5.53-3.961-8.497-2.695-5.934-2.732-8.756-5.262-12.431-1.624-2.331-2.284-3.383-4.492-3.095-3.675.464-9.084 8.411-13.386 8.549z"
      ></path>
      <path
        fill="#fff"
        d="M61.25 50.137c-2.51.068-4.93-6.173-5.924-6.15-.271 0-.678.385-1.131.95-.972 1.244-2.282 3.55-3.345 5.45-.905 1.605-.927 2.849-.543 3.753.813 2.012 3.618 2.601 3.301 3.211-.475.882-3.482.701-5.721 2.962-2.894 2.917-4.861 7.303-5.449 9.677-.905 3.55-1.99 5.607-1.561 10.107.159 1.628-.543 2.555.792 3.98 1.153 1.266 3.188 2.804 5.291 4.657 2.216 1.922 7.552 5.608 8.14 6.626.633 1.04.949 4.182.587 4.906-.339.723-3.934 1.605-3.912 1.605-.022 0 2.872 3.685 3.482 4.296.587.588 2.984 3.098 13.229 1.221 6.104-1.108 12.48-4.002 13.158-7.846.43-2.464-1.198-5.403-.7-7.303.768-2.939 7.009-4.183 7.574-7.53.068-.451.452-.791.837-1.446.723-1.244.361-3.143.497-4.862a33.816 33.816 0 00-1.515-13.137c-1.04-3.211-2.623-5.517-3.957-8.479-2.691-5.924-2.736-8.75-5.269-12.413-1.56-2.216-2.328-3.166-4.454-2.872-3.616.474-9.11 8.501-13.407 8.637z"
      ></path>
      <path
        fill="#995900"
        d="M62.967 27.183c1.697-.209 4.021.209 5.091 1 .999.745 1.696 1.14 2.603 1.441 3.045 1 7.044 1.465 6.858 4.208-.209 3.277-1.162 4.742-3.882 5.602-2.185.674-6.09 4.463-9.112 4.463-1.348 0-3.231.07-4.324-.325-1.046-.372-2.511-2.139-4.231-3.557-1.721-1.395-3.324-2.882-3.37-4.835-.07-2.068 1.278-2.743 3.185-4.394 1-.883 2.813-2.348 4.068-2.999 1.161-.581 1.906-.465 3.114-.604z"
      ></path>
      <path
        fill="#9E5F00"
        d="M63.003 27.214c1.687-.208 3.998.208 5.062.994.993.74 1.688 1.134 2.589 1.433 3.026.994 7.015 1.462 6.832 4.188-.208 3.258-1.186 4.708-3.888 5.561-2.171.669-6.06 4.387-9.063 4.404-1.359.01-3.204.076-4.29-.315-1.038-.369-2.498-2.134-4.207-3.542-1.708-1.385-3.312-2.833-3.331-4.767-.049-2.018 1.263-2.715 3.155-4.354.992-.875 2.775-2.358 4.024-3.014 1.149-.582 1.914-.449 3.117-.588z"
      ></path>
      <path
        fill="#A36400"
        d="M63.038 27.244c1.677-.207 3.975.207 5.032.988.988.736 1.677 1.128 2.574 1.425 3.008.988 6.986 1.46 6.805 4.169-.204 3.237-1.206 4.673-3.893 5.519-2.157.664-6.029 4.311-9.014 4.344-1.369.021-3.178.082-4.255-.305-1.03-.366-2.486-2.129-4.184-3.526-1.697-1.376-3.3-2.784-3.292-4.699-.03-1.969 1.248-2.689 3.126-4.316.984-.867 2.737-2.368 3.98-3.028 1.139-.584 1.926-.433 3.121-.571z"
      ></path>
      <path
        fill="#A86A00"
        d="M63.073 27.274c1.668-.206 3.953.206 5.004.982.982.731 1.667 1.123 2.559 1.417 2.99.982 6.959 1.458 6.779 4.15-.203 3.219-1.229 4.639-3.898 5.479-2.142.659-5.998 4.235-8.964 4.284-1.381.031-3.151.087-4.222-.295-1.022-.362-2.473-2.124-4.161-3.511-1.684-1.368-3.289-2.734-3.251-4.631-.01-1.919 1.232-2.662 3.097-4.278.976-.859 2.699-2.378 3.936-3.042 1.125-.585 1.933-.418 3.121-.555z"
      ></path>
      <path
        fill="#AD7000"
        d="M63.109 27.304c1.657-.204 3.929.205 4.974.977.976.727 1.659 1.117 2.543 1.408 2.971.977 6.931 1.456 6.753 4.131-.199 3.198-1.25 4.604-3.904 5.437-2.126.654-5.966 4.159-8.915 4.225-1.392.041-3.125.093-4.188-.285-1.014-.359-2.461-2.118-4.138-3.495-1.672-1.358-3.276-2.685-3.21-4.564.01-1.869 1.216-2.634 3.065-4.239.969-.851 2.663-2.389 3.893-3.058 1.116-.584 1.945-.401 3.127-.537z"
      ></path>
      <path
        fill="#B27600"
        d="M63.143 27.335c1.649-.204 3.907.203 4.945.971.971.722 1.647 1.111 2.529 1.399 2.953.97 6.903 1.453 6.727 4.112-.198 3.178-1.272 4.57-3.909 5.395-2.113.649-5.936 4.083-8.867 4.165-1.401.052-3.097.099-4.152-.275-1.006-.356-2.449-2.113-4.115-3.48-1.66-1.349-3.264-2.635-3.17-4.496.03-1.819 1.201-2.607 3.037-4.201.96-.842 2.624-2.398 3.848-3.071 1.103-.584 1.954-.384 3.127-.519z"
      ></path>
      <path
        fill="#B77B00"
        d="M63.18 27.364c1.639-.203 3.882.202 4.915.965.965.718 1.639 1.105 2.514 1.391 2.934.965 6.875 1.451 6.702 4.093-.196 3.158-1.296 4.535-3.916 5.354-2.097.645-5.905 4.007-8.816 4.105-1.413.062-3.07.104-4.119-.265-.998-.353-2.437-2.108-4.092-3.465-1.648-1.34-3.252-2.585-3.13-4.427.05-1.769 1.185-2.58 3.007-4.161.953-.835 2.586-2.409 3.804-3.087 1.09-.585 1.963-.368 3.131-.503z"
      ></path>
      <path
        fill="#BC8100"
        d="M63.214 27.395c1.629-.201 3.86.201 4.886.96.96.713 1.629 1.1 2.499 1.383 2.915.959 6.847 1.449 6.675 4.074-.194 3.138-1.316 4.5-3.92 5.312-2.083.64-5.874 3.931-8.768 4.046-1.423.072-3.044.11-4.085-.255-.99-.35-2.424-2.103-4.067-3.449-1.637-1.332-3.241-2.536-3.091-4.36.071-1.719 1.169-2.553 2.978-4.123.945-.826 2.549-2.419 3.76-3.101 1.079-.588 1.974-.354 3.133-.487z"
      ></path>
      <path
        fill="#C18700"
        d="M63.249 27.425c1.62-.2 3.837.2 4.857.954.954.709 1.62 1.095 2.484 1.375 2.897.954 6.819 1.446 6.649 4.055-.191 3.119-1.339 4.467-3.926 5.271-2.067.635-5.843 3.855-8.718 3.987-1.433.082-3.017.116-4.051-.245-.982-.347-2.411-2.098-4.043-3.435-1.625-1.322-3.229-2.486-3.052-4.292.09-1.668 1.155-2.526 2.948-4.083.937-.818 2.511-2.429 3.716-3.116 1.068-.589 1.984-.338 3.136-.471z"
      ></path>
      <path
        fill="#C68D00"
        d="M63.285 27.455c1.609-.198 3.813.198 4.828.948.947.706 1.609 1.09 2.468 1.367 2.879.947 6.79 1.444 6.625 4.036-.19 3.098-1.362 4.432-3.932 5.229-2.054.63-5.812 3.778-8.669 3.926-1.445.093-2.99.122-4.017-.234-.973-.344-2.399-2.093-4.021-3.419-1.613-1.314-3.217-2.438-3.011-4.224.11-1.619 1.138-2.5 2.918-4.046.929-.81 2.473-2.439 3.672-3.13 1.055-.589 1.993-.321 3.139-.453z"
      ></path>
      <path
        fill="#CC9200"
        d="M63.32 27.485c1.6-.197 3.79.197 4.798.942.943.701 1.6 1.083 2.455 1.358 2.859.942 6.761 1.442 6.596 4.018-.187 3.079-1.383 4.397-3.936 5.187-2.039.625-5.782 3.703-8.62 3.868-1.455.103-2.963.127-3.982-.225-.966-.34-2.387-2.088-3.999-3.404-1.601-1.304-3.206-2.387-2.971-4.156.129-1.569 1.123-2.471 2.888-4.006.922-.802 2.435-2.45 3.629-3.146 1.044-.589 2.003-.305 3.142-.436z"
      ></path>
      <path
        fill="#D19800"
        d="M63.356 27.515c1.589-.196 3.767.196 4.769.937.936.696 1.589 1.078 2.439 1.35 2.841.936 6.733 1.439 6.57 3.998-.184 3.06-1.405 4.363-3.942 5.146-2.024.62-5.75 3.626-8.57 3.807-1.466.114-2.936.134-3.948-.214-.957-.337-2.374-2.083-3.975-3.389-1.589-1.295-3.193-2.338-2.932-4.088.151-1.52 1.108-2.444 2.859-3.968.914-.793 2.398-2.459 3.584-3.16 1.034-.59 2.013-.288 3.146-.419z"
      ></path>
      <path
        fill="#D69E00"
        d="M63.391 27.545c1.581-.194 3.744.195 4.74.931.93.692 1.58 1.073 2.423 1.342 2.823.931 6.706 1.438 6.545 3.979-.183 3.04-1.427 4.329-3.948 5.105-2.01.615-5.719 3.55-8.52 3.748-1.478.124-2.91.14-3.915-.205-.949-.333-2.362-2.077-3.951-3.372-1.577-1.287-3.182-2.289-2.891-4.021.169-1.469 1.092-2.418 2.829-3.929.906-.785 2.36-2.47 3.541-3.174 1.02-.592 2.022-.274 3.147-.404z"
      ></path>
      <path
        fill="#DBA300"
        d="M63.427 27.575c1.57-.193 3.72.194 4.71.925.925.688 1.57 1.067 2.409 1.333 2.804.925 6.678 1.436 6.519 3.96-.181 3.02-1.45 4.294-3.953 5.063-1.995.61-5.689 3.474-8.471 3.688-1.488.134-2.883.145-3.88-.194-.941-.331-2.349-2.072-3.928-3.358-1.565-1.277-3.169-2.239-2.851-3.952.189-1.419 1.076-2.391 2.799-3.891.898-.777 2.322-2.48 3.497-3.189 1.007-.591 2.03-.256 3.149-.385z"
      ></path>
      <path
        fill="#E0A900"
        d="M63.462 27.606c1.561-.192 3.698.192 4.681.919.919.684 1.561 1.062 2.394 1.325 2.786.919 6.649 1.433 6.493 3.94-.179 3-1.472 4.26-3.958 5.021-1.981.606-5.657 3.399-8.422 3.629-1.499.145-2.856.151-3.846-.184-.933-.328-2.337-2.067-3.905-3.342-1.553-1.269-3.157-2.189-2.811-3.885.209-1.369 1.061-2.363 2.771-3.852.89-.769 2.283-2.49 3.452-3.204.995-.591 2.039-.24 3.151-.367z"
      ></path>
      <path
        fill="#E5AF00"
        d="M63.498 27.635c1.551-.191 3.674.191 4.651.914.913.68 1.551 1.056 2.379 1.317 2.767.913 6.62 1.431 6.467 3.921-.176 2.979-1.494 4.225-3.964 4.979-1.966.601-5.627 3.323-8.373 3.57-1.51.154-2.83.156-3.812-.174-.925-.324-2.325-2.062-3.882-3.327-1.54-1.259-3.145-2.14-2.77-3.816.229-1.319 1.044-2.336 2.739-3.813.882-.761 2.246-2.5 3.409-3.218.985-.593 2.051-.225 3.156-.353z"
      ></path>
      <path
        fill="#EAB500"
        d="M63.533 27.666c1.541-.189 3.651.19 4.623.908.908.675 1.541 1.05 2.364 1.309 2.748.907 6.592 1.428 6.44 3.903-.174 2.958-1.516 4.19-3.97 4.938-1.951.596-5.595 3.247-8.323 3.509-1.521.165-2.802.163-3.778-.164-.916-.321-2.312-2.057-3.857-3.312-1.53-1.25-3.134-2.091-2.732-3.749.249-1.269 1.03-2.309 2.711-3.775.875-.752 2.208-2.51 3.364-3.232.973-.594 2.06-.208 3.158-.335z"
      ></path>
      <path
        fill="#EFBA00"
        d="M63.569 27.695c1.531-.188 3.627.189 4.592.902.902.671 1.532 1.045 2.349 1.3 2.73.902 6.564 1.426 6.415 3.884-.172 2.939-1.539 4.156-3.976 4.896-1.936.591-5.563 3.17-8.273 3.45-1.532.175-2.776.168-3.744-.154-.909-.318-2.3-2.052-3.835-3.296-1.517-1.241-3.121-2.041-2.691-3.681.271-1.22 1.014-2.282 2.682-3.736.867-.745 2.171-2.521 3.321-3.248.96-.593 2.069-.191 3.16-.317z"
      ></path>
      <path
        fill="#F4C000"
        d="M63.603 27.726c1.521-.187 3.606.188 4.564.896.896.667 1.521 1.04 2.334 1.292 2.711.896 6.536 1.424 6.389 3.864-.168 2.919-1.56 4.122-3.981 4.855-1.921.586-5.533 3.095-8.224 3.391-1.542.186-2.75.174-3.71-.144-.9-.315-2.287-2.047-3.811-3.281-1.505-1.232-3.109-1.992-2.651-3.613.29-1.17.999-2.255 2.651-3.698.859-.736 2.133-2.531 3.276-3.262.95-.594 2.08-.175 3.163-.3z"
      ></path>
      <path
        fill="#F9C600"
        d="M63.639 27.755c1.512-.186 3.583.187 4.535.891.891.663 1.512 1.035 2.32 1.284 2.692.89 6.507 1.421 6.361 3.845-.167 2.9-1.582 4.088-3.985 4.814-1.907.581-5.503 3.018-8.175 3.331-1.553.196-2.722.18-3.675-.133-.893-.312-2.276-2.042-3.788-3.266-1.493-1.223-3.098-1.942-2.611-3.545.309-1.119.983-2.228 2.621-3.659.853-.729 2.095-2.542 3.233-3.277.936-.595 2.088-.16 3.164-.285z"
      ></path>
      <path
        fill="#fc0"
        d="M63.675 27.786c1.5-.185 3.559.186 4.504.885.885.658 1.502 1.029 2.304 1.275 2.674.884 6.48 1.42 6.337 3.826-.165 2.879-1.604 4.053-3.992 4.772-1.892.576-5.472 2.942-8.125 3.271-1.564.206-2.696.185-3.642-.124-.884-.309-2.263-2.037-3.764-3.25-1.482-1.214-3.086-1.893-2.572-3.477.33-1.07.967-2.201 2.592-3.621.843-.72 2.057-2.551 3.188-3.292.927-.594 2.1-.142 3.17-.265zm.268.932c.327.674 1.163.767 1.721 1.069.535.303.837.372 1.046.256.465-.256.117-1.093-.349-1.395-.441-.302-2.604-.372-2.418.07z"
      ></path>
      <path
        fill="#F9C600"
        d="M63.99 28.725c.316.657 1.133.748 1.677 1.043.521.294.815.362 1.02.249.452-.249.113-1.065-.34-1.359-.432-.296-2.539-.364-2.357.067z"
      ></path>
      <path
        fill="#F4C000"
        d="M64.035 28.731c.309.64 1.103.729 1.633 1.016.508.287.794.353.993.243.442-.243.11-1.037-.331-1.324-.419-.287-2.471-.353-2.295.065z"
      ></path>
      <path
        fill="#EFBA00"
        d="M64.081 28.739c.301.623 1.074.708 1.59.988.494.279.773.344.966.236.429-.236.108-1.01-.322-1.289-.408-.279-2.406-.343-2.234.065z"
      ></path>
      <path
        fill="#EAB500"
        d="M64.127 28.746c.292.605 1.044.689 1.545.961.481.271.752.334.941.229.417-.229.104-.982-.314-1.253-.396-.271-2.339-.335-2.172.063z"
      ></path>
      <path
        fill="#E5AF00"
        d="M64.173 28.752c.285.589 1.015.67 1.502.934.467.264.731.325.914.224.406-.224.101-.955-.304-1.219-.386-.263-2.274-.324-2.112.061z"
      ></path>
      <path
        fill="#E0A900"
        d="M64.219 28.759c.277.572.986.651 1.459.907.453.256.71.315.887.217.395-.217.099-.927-.296-1.183-.374-.256-2.207-.315-2.05.059z"
      ></path>
      <path
        fill="#DBA300"
        d="M64.265 28.767c.268.555.956.631 1.416.88.44.249.688.306.861.21.382-.21.095-.899-.287-1.148-.364-.249-2.142-.306-1.99.058z"
      ></path>
      <path
        fill="#D69E00"
        d="M64.311 28.773c.26.538.927.612 1.372.853.427.241.667.296.834.204.371-.204.093-.871-.277-1.111-.353-.242-2.078-.298-1.929.054z"
      ></path>
      <path
        fill="#D19800"
        d="M64.357 28.78c.25.521.897.592 1.329.826.412.233.646.287.807.197.358-.197.09-.843-.27-1.077-.34-.232-2.01-.287-1.866.054z"
      ></path>
      <path
        fill="#CC9200"
        d="M64.403 28.788c.244.503.869.573 1.286.799.398.226.625.277.78.19.347-.19.087-.816-.26-1.042-.33-.226-1.945-.277-1.806.053z"
      ></path>
      <path
        fill="#C68C00"
        d="M64.449 28.794c.235.486.839.553 1.241.771.385.218.604.269.754.184.335-.184.084-.788-.251-1.006-.319-.217-1.878-.267-1.744.051z"
      ></path>
      <path
        fill="#C18700"
        d="M64.495 28.801c.226.469.809.535 1.197.745.372.21.583.259.729.178.323-.178.081-.761-.243-.971-.308-.21-1.812-.259-1.683.048z"
      ></path>
      <path
        fill="#BC8100"
        d="M64.541 28.809c.218.452.779.514 1.153.717.359.203.562.249.703.171.312-.171.078-.733-.234-.935-.297-.203-1.747-.25-1.622.047z"
      ></path>
      <path
        fill="#B77B00"
        d="M64.587 28.815c.21.435.75.495 1.11.69.345.195.54.24.675.165.3-.165.076-.706-.225-.9-.285-.194-1.68-.24-1.56.045z"
      ></path>
      <path
        fill="#B27500"
        d="M64.634 28.822c.201.418.719.476 1.065.663.333.188.519.23.649.159.288-.159.073-.677-.216-.865-.274-.187-1.614-.231-1.498.043z"
      ></path>
      <path
        fill="#AD7000"
        d="M64.68 28.829c.193.401.69.456 1.022.636.317.18.497.221.622.152.276-.152.069-.649-.208-.83-.262-.178-1.547-.22-1.436.042z"
      ></path>
      <path
        fill="#A86A00"
        d="M64.725 28.836c.185.384.662.437.979.608.304.173.476.212.596.146.264-.146.066-.622-.199-.794-.251-.171-1.483-.211-1.376.04z"
      ></path>
      <path
        fill="#A36400"
        d="M64.771 28.843c.176.367.631.417.936.582.29.164.455.202.569.139.252-.139.062-.594-.19-.759-.24-.164-1.417-.202-1.315.038z"
      ></path>
      <path
        fill="#9E5E00"
        d="M64.817 28.85c.168.35.603.398.892.555.277.157.434.192.543.132.24-.132.061-.566-.182-.724-.228-.155-1.35-.192-1.253.037z"
      ></path>
      <path
        fill="#995900"
        d="M64.863 28.857c.161.333.573.378.848.528.264.148.413.183.517.125.229-.125.057-.539-.173-.688-.217-.148-1.284-.182-1.192.035z"
      ></path>
      <path
        fill="#fc0"
        d="M59.066 29.584c-.105.262.629.761.998.42a10.91 10.91 0 011.025-.762c.708-.473.447-.814-.735-.604-1.183.21-1.183.682-1.288.946z"
      ></path>
      <path
        fill="#F9C600"
        d="M59.085 29.58c-.103.257.615.744.975.41.384-.333.846-.641 1.001-.744.692-.462.436-.795-.719-.59-1.155.205-1.155.667-1.257.924z"
      ></path>
      <path
        fill="#F4C000"
        d="M59.104 29.576c-.1.25.601.727.952.401.375-.325.826-.626.977-.727.676-.451.426-.776-.702-.576-1.127.201-1.127.652-1.227.902z"
      ></path>
      <path
        fill="#EFBA00"
        d="M59.123 29.573c-.098.245.586.708.929.391.366-.318.806-.611.953-.709.659-.439.415-.757-.684-.562-1.1.196-1.1.635-1.198.88z"
      ></path>
      <path
        fill="#EAB500"
        d="M59.142 29.57c-.096.238.572.691.905.381.358-.31.787-.596.93-.692.644-.428.405-.739-.667-.548-1.073.191-1.073.62-1.168.859z"
      ></path>
      <path
        fill="#E5AF00"
        d="M59.161 29.566c-.093.232.558.673.882.372.349-.302.767-.58.906-.673.628-.418.395-.72-.65-.535-1.046.186-1.045.604-1.138.836z"
      ></path>
      <path
        fill="#E0A900"
        d="M59.18 29.564c-.09.226.543.656.859.362.339-.294.747-.565.882-.656.611-.407.384-.702-.634-.52-1.017.18-1.017.587-1.107.814z"
      ></path>
      <path
        fill="#DBA300"
        d="M59.199 29.56c-.088.219.528.638.836.352.33-.286.727-.55.858-.638.594-.396.374-.683-.616-.506-.991.175-.991.571-1.078.792z"
      ></path>
      <path
        fill="#D69E00"
        d="M59.218 29.556c-.086.214.513.621.813.343.321-.278.707-.535.834-.621.578-.386.364-.664-.599-.492-.962.171-.962.556-1.048.77z"
      ></path>
      <path
        fill="#D19800"
        d="M59.237 29.553c-.083.208.499.604.791.333.311-.27.686-.52.81-.604.562-.374.354-.645-.582-.478-.936.167-.936.541-1.019.749z"
      ></path>
      <path
        fill="#CC9200"
        d="M59.256 29.55c-.081.202.484.586.766.323.304-.263.667-.505.789-.585.545-.363.342-.626-.566-.464-.909.16-.909.524-.989.726z"
      ></path>
      <path
        fill="#C68C00"
        d="M59.275 29.546c-.079.196.47.568.743.313.294-.254.647-.49.765-.568.528-.353.332-.607-.549-.45-.882.158-.882.509-.959.705z"
      ></path>
      <path
        fill="#C18700"
        d="M59.293 29.543c-.076.189.455.55.721.303.286-.247.626-.474.741-.55.512-.342.322-.588-.532-.437-.854.153-.854.494-.93.684z"
      ></path>
      <path
        fill="#BC8100"
        d="M59.312 29.54c-.074.184.44.532.698.294.275-.239.605-.459.716-.533.496-.33.312-.57-.515-.422-.825.147-.825.477-.899.661z"
      ></path>
      <path
        fill="#B77B00"
        d="M59.331 29.537c-.071.177.426.514.675.283.266-.23.585-.444.692-.515.479-.319.302-.55-.497-.408s-.799.462-.87.64z"
      ></path>
      <path
        fill="#B27500"
        d="M59.35 29.533c-.069.171.411.497.652.274.257-.222.565-.428.668-.497.463-.309.292-.532-.48-.395s-.771.447-.84.618z"
      ></path>
      <path
        fill="#AD7000"
        d="M59.369 29.53c-.066.166.397.48.627.265.249-.215.546-.414.646-.48.447-.297.28-.513-.463-.38-.744.132-.744.429-.81.595z"
      ></path>
      <path
        fill="#A86A00"
        d="M59.389 29.526c-.063.159.382.462.605.255.239-.207.525-.398.621-.462.43-.287.271-.494-.446-.366-.717.128-.717.414-.78.573z"
      ></path>
      <path
        fill="#A36400"
        d="M59.407 29.523c-.061.153.368.444.582.246.23-.2.506-.383.598-.445.414-.276.262-.475-.429-.352-.689.122-.689.398-.751.551z"
      ></path>
      <path
        fill="#9E5E00"
        d="M59.426 29.52c-.059.146.354.427.559.235.22-.191.486-.368.574-.427.397-.265.25-.457-.412-.338-.662.118-.662.383-.721.53z"
      ></path>
      <path
        fill="#995900"
        d="M59.445 29.517c-.056.141.339.409.536.226a5.48 5.48 0 01.55-.409c.381-.255.24-.438-.396-.325-.633.113-.633.366-.69.508z"
      ></path>
      <path
        fill="#fc0"
        d="M60.381 36.556c-.074.923 2.049-1.384 2.178-1.587.276-.498 1.199-1.9 1.347-2.491.276-1.033.775-1.79.461-2.878-.111-.35-.885-.442-1.236-.221-.996.59-.848 1.31-.959 1.974-.37 1.882-1.661 3.782-1.791 5.203z"
      ></path>
      <path
        fill="#FFCC02"
        d="M60.469 36.412c-.072.899 1.994-1.352 2.12-1.55.269-.486 1.167-1.855 1.309-2.431.269-1.008.753-1.746.446-2.807-.109-.342-.864-.431-1.206-.214-.971.577-.825 1.278-.933 1.926-.356 1.835-1.613 3.69-1.736 5.076z"
      ></path>
      <path
        fill="#FFCC05"
        d="M60.555 36.268c-.068.877 1.942-1.32 2.063-1.514.263-.475 1.135-1.809 1.272-2.371.259-.982.731-1.702.43-2.736-.107-.333-.843-.418-1.176-.207-.945.564-.802 1.247-.906 1.878-.343 1.79-1.564 3.6-1.683 4.95z"
      ></path>
      <path
        fill="#FFCC07"
        d="M60.642 36.124c-.064.854 1.889-1.289 2.008-1.477.253-.462 1.101-1.764 1.234-2.311.251-.957.708-1.659.414-2.665-.105-.324-.821-.405-1.145-.199-.92.551-.779 1.216-.879 1.831-.333 1.742-1.519 3.506-1.632 4.821z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M60.728 35.98c-.061.831 1.835-1.258 1.95-1.441.247-.45 1.069-1.718 1.198-2.25.243-.932.687-1.616.397-2.594-.101-.314-.799-.394-1.114-.192-.894.538-.756 1.184-.852 1.783-.319 1.696-1.471 3.414-1.579 4.694z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M60.815 35.836c-.058.808 1.782-1.227 1.894-1.405.238-.438 1.035-1.672 1.16-2.19.234-.907.666-1.572.383-2.523-.1-.306-.778-.38-1.084-.185-.867.524-.733 1.153-.825 1.735-.309 1.65-1.425 3.323-1.528 4.568z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M60.902 35.691c-.055.785 1.729-1.195 1.836-1.369.23-.426 1.002-1.626 1.124-2.129.226-.881.643-1.529.366-2.451-.097-.297-.756-.369-1.053-.177-.842.511-.709 1.122-.798 1.688-.296 1.602-1.378 3.229-1.475 4.438z"
      ></path>
      <path
        fill="#FFCD11"
        d="M60.989 35.547c-.052.762 1.675-1.163 1.78-1.332.223-.415.97-1.581 1.085-2.069.217-.855.621-1.485.351-2.38-.095-.289-.734-.356-1.022-.17-.816.498-.688 1.09-.771 1.639-.285 1.557-1.331 3.139-1.423 4.312z"
      ></path>
      <path
        fill="#FFCE14"
        d="M61.076 35.403c-.048.739 1.622-1.132 1.723-1.296.216-.402.936-1.535 1.048-2.009.208-.83.599-1.441.335-2.309-.093-.28-.715-.345-.992-.163-.79.484-.664 1.059-.744 1.591-.272 1.512-1.284 3.048-1.37 4.186z"
      ></path>
      <path
        fill="#FFCE16"
        d="M61.162 35.259c-.045.717 1.569-1.1 1.667-1.259.208-.39.904-1.489 1.011-1.949.201-.805.577-1.398.318-2.237-.09-.271-.693-.332-.961-.156-.765.471-.64 1.027-.718 1.543-.259 1.464-1.236 2.955-1.317 4.058z"
      ></path>
      <path
        fill="#FFCE19"
        d="M61.249 35.115c-.043.693 1.515-1.068 1.61-1.223.2-.377.871-1.443.974-1.888.191-.78.555-1.355.302-2.167-.088-.262-.671-.319-.93-.148-.739.458-.618.996-.691 1.496-.249 1.417-1.188 2.862-1.265 3.93z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M61.336 34.971c-.039.67 1.462-1.037 1.553-1.187.193-.366.839-1.398.936-1.829.184-.754.533-1.311.288-2.095-.086-.252-.65-.308-.9-.141-.713.444-.595.964-.664 1.448-.237 1.372-1.143 2.771-1.213 3.804z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M61.422 34.826c-.035.648 1.41-1.005 1.498-1.15.184-.354.806-1.353.898-1.769.176-.728.511-1.267.271-2.023-.084-.244-.628-.295-.869-.133-.688.432-.572.933-.637 1.4-.225 1.324-1.096 2.678-1.161 3.675z"
      ></path>
      <path
        fill="#FFCF21"
        d="M61.509 34.683c-.032.624 1.356-.975 1.44-1.114.176-.342.773-1.306.861-1.708.167-.703.489-1.224.256-1.953-.082-.235-.607-.282-.839-.126-.663.418-.548.902-.611 1.353-.212 1.277-1.047 2.585-1.107 3.548z"
      ></path>
      <path
        fill="#FFCF23"
        d="M61.596 34.539c-.028.601 1.304-.943 1.383-1.078.169-.33.741-1.261.824-1.648.159-.677.467-1.18.241-1.882-.08-.226-.586-.27-.81-.118-.636.404-.525.87-.583 1.304-.2 1.232-1 2.494-1.055 3.422z"
      ></path>
      <path
        fill="#FFCF26"
        d="M61.682 34.394c-.026.579 1.25-.911 1.326-1.041.162-.317.708-1.215.788-1.588.149-.652.444-1.137.224-1.81-.077-.217-.564-.257-.778-.111-.61.392-.502.839-.556 1.256-.189 1.185-.955 2.402-1.004 3.294z"
      ></path>
      <path
        fill="#FFD028"
        d="M61.769 34.25c-.022.556 1.196-.879 1.27-1.005.154-.306.675-1.169.75-1.527.142-.627.424-1.093.208-1.739-.075-.208-.542-.245-.748-.104-.584.378-.478.808-.529 1.208-.177 1.139-.907 2.311-.951 3.167z"
      ></path>
      <path
        fill="#FFD02B"
        d="M61.856 34.106c-.02.533 1.144-.848 1.212-.969.146-.293.643-1.124.712-1.467.134-.602.401-1.05.193-1.668-.073-.199-.521-.232-.718-.096-.558.364-.455.775-.502 1.161-.163 1.091-.859 2.218-.897 3.039z"
      ></path>
      <path
        fill="#FFD02D"
        d="M61.943 33.962c-.016.51 1.089-.816 1.155-.932.14-.282.61-1.079.676-1.407.125-.576.378-1.006.177-1.597-.07-.19-.499-.22-.687-.088-.533.351-.432.744-.475 1.112-.153 1.046-.813 2.126-.846 2.912z"
      ></path>
      <path
        fill="#FFD030"
        d="M62.03 33.817c-.013.487 1.037-.785 1.099-.895.131-.27.577-1.033.638-1.347.117-.55.357-.962.162-1.526-.068-.181-.478-.208-.657-.082-.507.338-.409.713-.448 1.065-.142 1-.766 2.035-.794 2.785z"
      ></path>
      <path
        fill="#FFD133"
        d="M62.116 33.673c-.009.464.985-.753 1.043-.859.124-.257.544-.987.601-1.287.108-.525.334-.919.145-1.455-.066-.173-.456-.196-.626-.074-.481.325-.385.681-.421 1.017-.13.954-.719 1.944-.742 2.658z"
      ></path>
      <path
        fill="#fc0"
        d="M67.709 32.716c-1.022 1.116-1.743 2.185-2.324 2.906-.605.744-2.093 1.627-1.349 2.487.627.767 3.208-.627 5.208-2.115 1.975-1.488 5.067-2.813 3.557-4.509-.791-.86-2.651-.675-3.371-.209-.559.348-.884.534-1.721 1.44z"
      ></path>
      <path
        fill="#FFCC02"
        d="M67.753 32.766c-1.007 1.091-1.715 2.14-2.287 2.844-.595.726-2.059 1.597-1.334 2.432.611.746 3.139-.627 5.1-2.088 1.937-1.461 4.966-2.769 3.493-4.417-.77-.835-2.589-.645-3.296-.188-.546.341-.861.538-1.676 1.417z"
      ></path>
      <path
        fill="#FFCC05"
        d="M67.797 32.815c-.99 1.066-1.688 2.095-2.25 2.783-.585.708-2.026 1.566-1.319 2.377.595.725 3.071-.627 4.993-2.062 1.899-1.434 4.863-2.724 3.43-4.325-.75-.811-2.53-.616-3.222-.168-.536.338-.839.544-1.632 1.395z"
      ></path>
      <path
        fill="#FFCC07"
        d="M67.841 32.865c-.975 1.04-1.66 2.049-2.214 2.721-.575.69-1.991 1.535-1.304 2.323.579.703 3.004-.627 4.886-2.035 1.86-1.407 4.761-2.679 3.366-4.232-.729-.787-2.469-.587-3.146-.147-.524.33-.816.547-1.588 1.37z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M67.885 32.915c-.958 1.014-1.63 2.003-2.177 2.659-.565.672-1.957 1.504-1.29 2.268.563.681 2.935-.627 4.778-2.008 1.822-1.381 4.659-2.635 3.303-4.141-.71-.762-2.41-.557-3.073-.127-.511.326-.791.554-1.541 1.349z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M67.929 32.964c-.942.99-1.603 1.959-2.141 2.598-.555.654-1.923 1.473-1.275 2.213.547.66 2.867-.627 4.671-1.981 1.783-1.354 4.558-2.591 3.239-4.048-.689-.738-2.349-.528-2.998-.105-.498.318-.768.556-1.496 1.323z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M67.973 33.014c-.927.964-1.576 1.913-2.104 2.537-.545.636-1.89 1.442-1.26 2.158.531.639 2.798-.627 4.563-1.955 1.744-1.327 4.456-2.546 3.176-3.955-.67-.714-2.29-.5-2.924-.085-.487.312-.745.56-1.451 1.3z"
      ></path>
      <path
        fill="#FFCD11"
        d="M68.017 33.063c-.911.939-1.548 1.868-2.068 2.476-.535.618-1.856 1.412-1.245 2.102.514.617 2.729-.626 4.456-1.927 1.707-1.301 4.354-2.502 3.113-3.863-.65-.689-2.229-.47-2.848-.064-.476.306-.723.565-1.408 1.276z"
      ></path>
      <path
        fill="#FFCE14"
        d="M68.061 33.112c-.895.914-1.519 1.823-2.031 2.414-.525.6-1.822 1.381-1.231 2.047.498.596 2.662-.626 4.349-1.9 1.668-1.273 4.252-2.458 3.048-3.771-.628-.665-2.167-.44-2.773-.043-.464.301-.699.57-1.362 1.253z"
      ></path>
      <path
        fill="#FFCE16"
        d="M68.105 33.162c-.879.888-1.491 1.777-1.994 2.353-.515.583-1.788 1.35-1.216 1.993.481.574 2.593-.625 4.241-1.874 1.628-1.247 4.149-2.414 2.986-3.679-.61-.641-2.109-.412-2.699-.023-.452.295-.677.575-1.318 1.23z"
      ></path>
      <path
        fill="#FFCE19"
        d="M68.149 33.212c-.863.863-1.462 1.732-1.958 2.291-.504.564-1.754 1.319-1.202 1.938.465.553 2.525-.625 4.134-1.847 1.591-1.22 4.048-2.369 2.922-3.586-.589-.616-2.048-.382-2.625-.002-.439.288-.652.578-1.271 1.206z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M68.193 33.261c-.846.838-1.435 1.687-1.921 2.229-.495.546-1.72 1.289-1.187 1.882.449.531 2.457-.625 4.027-1.82 1.552-1.193 3.946-2.325 2.859-3.494-.57-.591-1.988-.353-2.551.019-.427.284-.629.584-1.227 1.184z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M68.237 33.311c-.831.813-1.407 1.642-1.884 2.168-.485.529-1.687 1.258-1.172 1.828.433.51 2.388-.625 3.919-1.792 1.514-1.167 3.843-2.28 2.795-3.402-.549-.566-1.927-.324-2.476.039-.416.276-.606.587-1.182 1.159z"
      ></path>
      <path
        fill="#FFCF21"
        d="M68.281 33.36c-.814.788-1.378 1.597-1.847 2.106-.475.511-1.654 1.227-1.158 1.773.416.489 2.32-.624 3.812-1.766 1.475-1.14 3.741-2.236 2.732-3.31-.529-.542-1.867-.295-2.402.06-.404.272-.583.593-1.137 1.137z"
      ></path>
      <path
        fill="#FFCF23"
        d="M68.326 33.41c-.8.763-1.352 1.551-1.811 2.045-.465.493-1.62 1.196-1.143 1.717.4.468 2.251-.624 3.704-1.739 1.437-1.113 3.64-2.191 2.669-3.217-.509-.519-1.808-.266-2.327.081-.394.266-.561.597-1.092 1.113z"
      ></path>
      <path
        fill="#FFCF26"
        d="M68.369 33.459c-.783.737-1.324 1.505-1.774 1.983-.456.475-1.586 1.166-1.129 1.663.384.446 2.184-.624 3.598-1.712 1.398-1.086 3.538-2.147 2.605-3.125-.489-.493-1.748-.236-2.252.101-.382.26-.537.602-1.048 1.09z"
      ></path>
      <path
        fill="#FFD028"
        d="M68.412 33.509c-.766.711-1.294 1.46-1.736 1.921-.446.457-1.553 1.135-1.114 1.607.368.425 2.115-.624 3.49-1.685 1.36-1.061 3.436-2.104 2.543-3.033-.469-.47-1.688-.208-2.178.122-.371.255-.515.607-1.005 1.068z"
      ></path>
      <path
        fill="#FFD02B"
        d="M68.456 33.559c-.75.687-1.265 1.415-1.699 1.86-.436.439-1.519 1.104-1.1 1.553.353.403 2.047-.623 3.383-1.658 1.321-1.033 3.334-2.058 2.479-2.94-.448-.445-1.627-.178-2.103.143-.359.247-.492.609-.96 1.042z"
      ></path>
      <path
        fill="#FFD02D"
        d="M68.501 33.608c-.735.661-1.238 1.37-1.664 1.799-.426.421-1.485 1.073-1.084 1.498.335.381 1.978-.624 3.275-1.632 1.284-1.006 3.232-2.014 2.416-2.848-.429-.42-1.566-.149-2.029.163-.347.242-.468.615-.914 1.02z"
      ></path>
      <path
        fill="#FFD030"
        d="M68.545 33.657c-.719.636-1.21 1.324-1.627 1.737-.415.403-1.451 1.043-1.069 1.443.318.36 1.91-.623 3.168-1.605 1.243-.979 3.129-1.97 2.352-2.756-.41-.396-1.507-.12-1.955.184-.335.238-.445.621-.869.997z"
      ></path>
      <path
        fill="#FFD133"
        d="M68.589 33.707c-.704.611-1.183 1.278-1.591 1.676-.405.385-1.417 1.012-1.055 1.388.302.338 1.841-.623 3.061-1.578 1.206-.953 3.028-1.926 2.289-2.664-.388-.372-1.446-.091-1.879.205l-.825.973z"
      ></path>
      <path
        fill="#fff"
        d="M69.894 56.148c.278-.907 9.322-3.045 10.81-2.348 1.464.697 8.484 10.903 7.23 11.461-1.255.535-3.953-3.395-7.881-5.208-3.929-1.813-10.438-2.975-10.159-3.905z"
      ></path>
      <path
        fill="#F9F9F9"
        d="M70.161 56.167c.273-.892 9.087-2.931 10.554-2.26 1.445.671 8.319 10.622 7.084 11.168-1.234.525-3.863-3.34-7.729-5.125-3.867-1.783-10.183-2.869-9.909-3.783z"
      ></path>
      <path
        fill="#F4F4F4"
        d="M70.427 56.186c.268-.876 8.853-2.816 10.299-2.17 1.426.645 8.155 10.339 6.94 10.875-1.214.515-3.774-3.287-7.579-5.043-3.804-1.756-9.929-2.765-9.66-3.662z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M70.693 56.204c.264-.861 8.618-2.701 10.044-2.082 1.407.619 7.989 10.059 6.796 10.583-1.193.505-3.686-3.233-7.428-4.96-3.742-1.727-9.675-2.66-9.412-3.541z"
      ></path>
      <path
        fill="#EAEAEA"
        d="M70.959 56.222c.258-.847 8.382-2.585 9.79-1.993 1.387.593 7.824 9.778 6.651 10.291-1.173.495-3.597-3.179-7.277-4.878-3.681-1.699-9.422-2.556-9.164-3.42z"
      ></path>
      <path
        fill="#E5E5E5"
        d="M71.226 56.24c.252-.831 8.148-2.47 9.534-1.903 1.368.566 7.659 9.497 6.507 9.998-1.153.484-3.509-3.125-7.127-4.796-3.618-1.67-9.168-2.451-8.914-3.299z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M71.491 56.258c.249-.816 7.914-2.355 9.28-1.815 1.349.541 7.495 9.216 6.363 9.707-1.132.474-3.42-3.073-6.977-4.714-3.556-1.642-8.914-2.345-8.666-3.178z"
      ></path>
      <path
        fill="#DBDBDB"
        d="M71.758 56.277c.243-.801 7.678-2.241 9.024-1.727 1.33.515 7.33 8.934 6.218 9.414-1.11.464-3.331-3.019-6.825-4.631s-8.66-2.24-8.417-3.056z"
      ></path>
      <path
        fill="#D6D6D6"
        d="M72.024 56.295c.237-.786 7.444-2.126 8.769-1.638 1.312.489 7.164 8.653 6.074 9.122-1.09.454-3.242-2.965-6.675-4.549-3.432-1.584-8.406-2.135-8.168-2.935z"
      ></path>
      <path
        fill="#D1D1D1"
        d="M72.29 56.313c.233-.77 7.209-2.011 8.514-1.548 1.292.462 6.999 8.372 5.93 8.829-1.07.445-3.154-2.911-6.523-4.466-3.371-1.556-8.153-2.031-7.921-2.815z"
      ></path>
      <path
        fill="#ccc"
        d="M72.556 56.331c.228-.755 6.976-1.896 8.259-1.459 1.273.436 6.835 8.091 5.786 8.537-1.05.434-3.066-2.858-6.374-4.385-3.307-1.527-7.898-1.925-7.671-2.693z"
      ></path>
      <path
        fill="#C6C6C6"
        d="M72.823 56.35c.222-.74 6.74-1.781 8.004-1.371 1.253.41 6.669 7.809 5.64 8.244-1.028.424-2.977-2.805-6.222-4.302-3.246-1.498-7.644-1.82-7.422-2.571z"
      ></path>
      <path
        fill="#C1C1C1"
        d="M73.089 56.369c.217-.726 6.505-1.667 7.749-1.283 1.233.384 6.503 7.528 5.496 7.952-1.008.415-2.887-2.75-6.071-4.221-3.185-1.469-7.391-1.714-7.174-2.448z"
      ></path>
      <path
        fill="#BCBCBC"
        d="M73.355 56.387c.21-.71 6.27-1.552 7.494-1.194 1.215.358 6.338 7.248 5.352 7.66-.987.404-2.799-2.697-5.92-4.137-3.122-1.442-7.137-1.61-6.926-2.329z"
      ></path>
      <path
        fill="#B7B7B7"
        d="M73.621 56.406c.208-.695 6.035-1.437 7.239-1.105 1.196.332 6.174 6.965 5.208 7.367-.967.394-2.711-2.643-5.771-4.056-3.06-1.412-6.882-1.505-6.676-2.206z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M73.887 56.423c.202-.679 5.801-1.321 6.984-1.016 1.177.305 6.008 6.685 5.063 7.075-.946.385-2.622-2.589-5.62-3.973-2.997-1.383-6.627-1.4-6.427-2.086z"
      ></path>
      <path
        fill="#ADADAD"
        d="M74.154 56.442c.196-.665 5.565-1.207 6.728-.928 1.159.28 5.844 6.404 4.919 6.783-.925.373-2.533-2.536-5.469-3.892-2.935-1.354-6.374-1.294-6.178-1.963z"
      ></path>
      <path
        fill="#A8A8A8"
        d="M74.42 56.46c.19-.649 5.331-1.092 6.474-.839 1.137.253 5.678 6.123 4.774 6.491-.905.364-2.445-2.482-5.319-3.809-2.873-1.326-6.12-1.19-5.929-1.843z"
      ></path>
      <path
        fill="#A3A3A3"
        d="M74.685 56.479c.186-.634 5.097-.977 6.219-.75 1.12.228 5.514 5.842 4.629 6.198-.883.354-2.355-2.429-5.167-3.727-2.81-1.298-5.865-1.084-5.681-1.721z"
      ></path>
      <path
        fill="#9E9E9E"
        d="M74.952 56.497c.181-.62 4.862-.862 5.963-.661 1.1.201 5.348 5.56 4.486 5.905-.863.344-2.267-2.375-5.017-3.644-2.748-1.269-5.612-.979-5.432-1.6z"
      ></path>
      <path
        fill="#999"
        d="M75.219 56.515c.174-.604 4.627-.747 5.708-.572 1.082.175 5.184 5.279 4.341 5.613s-2.178-2.321-4.866-3.562c-2.687-1.241-5.358-.874-5.183-1.479z"
      ></path>
      <path
        fill="#fff"
        d="M58.503 70.05c.93.046.047 5.253.047 10.624 0 5.37.72 7.252.047 7.926-.674.675-1.836-1.743-1.836-7.113-.001-5.37.813-11.484 1.742-11.437z"
      ></path>
      <path
        fill="#F9F9F9"
        d="M58.494 70.176c.898.052.035 5.182.031 10.467-.003 5.284.707 7.17.054 7.825-.652.656-1.796-1.738-1.791-7.023.004-5.284.808-11.321 1.706-11.269z"
      ></path>
      <path
        fill="#F4F4F4"
        d="M58.484 70.302c.868.058.025 5.111.017 10.31-.008 5.199.691 7.087.06 7.725-.63.635-1.755-1.732-1.745-6.933.008-5.199.802-11.16 1.668-11.102z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M58.475 70.428c.835.064.013 5.042.001 10.154-.011 5.112.677 7.004.066 7.622-.609.616-1.714-1.728-1.699-6.843.012-5.112.797-10.996 1.632-10.933z"
      ></path>
      <path
        fill="#EAEAEA"
        d="M58.465 70.555c.804.069.003 4.97-.013 9.996-.016 5.028.663 6.923.072 7.522-.587.597-1.673-1.723-1.654-6.753.017-5.027.792-10.835 1.595-10.765z"
      ></path>
      <path
        fill="#E5E5E5"
        d="M58.456 70.681c.772.074-.009 4.898-.029 9.84-.02 4.942.648 6.839.079 7.42-.565.577-1.632-1.718-1.608-6.663.02-4.942.785-10.672 1.558-10.597z"
      ></path>
      <path
        fill="#E0E0E0"
        d="M58.447 70.807c.742.08-.02 4.827-.045 9.682-.024 4.856.634 6.757.086 7.319-.544.558-1.591-1.711-1.562-6.572.024-4.856.779-10.509 1.521-10.429z"
      ></path>
      <path
        fill="#DBDBDB"
        d="M58.437 70.933c.709.086-.031 4.756-.059 9.527-.028 4.77.618 6.673.091 7.217-.521.538-1.55-1.707-1.516-6.483.028-4.77.774-10.347 1.484-10.261z"
      ></path>
      <path
        fill="#D6D6D6"
        d="M58.428 71.059c.679.091-.042 4.685-.074 9.37-.032 4.685.604 6.591.098 7.116-.5.519-1.509-1.702-1.471-6.393.033-4.684.768-10.184 1.447-10.093z"
      ></path>
      <path
        fill="#D1D1D1"
        d="M58.418 71.186c.648.097-.053 4.614-.089 9.212-.036 4.6.59 6.507.104 7.014-.477.5-1.468-1.695-1.425-6.302.036-4.598.763-10.022 1.41-9.924z"
      ></path>
      <path
        fill="#ccc"
        d="M58.409 71.312c.617.103-.063 4.542-.103 9.056s.574 6.425.111 6.914c-.457.479-1.428-1.691-1.38-6.213.039-4.513.756-9.86 1.372-9.757z"
      ></path>
      <path
        fill="#C6C6C6"
        d="M58.399 71.439c.585.107-.075 4.472-.119 8.899-.044 4.427.56 6.342.117 6.811-.434.462-1.386-1.684-1.333-6.122.044-4.427.751-9.697 1.335-9.588z"
      ></path>
      <path
        fill="#C1C1C1"
        d="M58.389 71.564c.554.114-.086 4.4-.134 8.743-.047 4.342.546 6.259.124 6.71-.412.441-1.345-1.68-1.288-6.033.048-4.341.746-9.534 1.298-9.42z"
      ></path>
      <path
        fill="#BCBCBC"
        d="M58.38 71.691c.522.119-.098 4.33-.148 8.586-.052 4.257.531 6.177.13 6.609-.392.422-1.305-1.675-1.243-5.942.052-4.257.74-9.374 1.261-9.253z"
      ></path>
      <path
        fill="#B7B7B7"
        d="M58.37 71.817c.491.125-.108 4.258-.164 8.429-.056 4.171.517 6.094.137 6.507-.37.403-1.264-1.669-1.197-5.851.056-4.171.735-9.211 1.224-9.085z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M58.362 71.944c.459.13-.12 4.187-.179 8.271-.061 4.085.502 6.011.142 6.407-.347.383-1.223-1.665-1.15-5.762.059-4.085.727-9.047 1.187-8.916z"
      ></path>
      <path
        fill="#ADADAD"
        d="M58.351 72.069c.428.136-.13 4.116-.193 8.116-.064 4 .487 5.928.148 6.305-.325.363-1.182-1.66-1.104-5.672.064-3.999.722-8.885 1.149-8.749z"
      ></path>
      <path
        fill="#A8A8A8"
        d="M58.343 72.196c.396.142-.142 4.044-.208 7.959-.068 3.914.472 5.845.154 6.203-.303.344-1.14-1.654-1.059-5.582.068-3.914.716-8.722 1.113-8.58z"
      ></path>
      <path
        fill="#A3A3A3"
        d="M58.332 72.322c.365.148-.152 3.974-.223 7.802-.072 3.829.458 5.763.162 6.102-.282.325-1.1-1.648-1.014-5.492.071-3.827.711-8.561 1.075-8.412z"
      ></path>
      <path
        fill="#9E9E9E"
        d="M58.324 72.448c.333.154-.164 3.903-.24 7.646-.076 3.743.444 5.679.169 6-.261.306-1.059-1.644-.968-5.401.075-3.743.705-8.399 1.039-8.245z"
      ></path>
      <path
        fill="#999"
        d="M58.314 72.574c.302.159-.175 3.831-.254 7.489-.08 3.657.429 5.597.175 5.899-.238.286-1.018-1.638-.922-5.311.078-3.657.699-8.236 1.001-8.077z"
      ></path>
      <path
        fill="#fff"
        d="M60.538 55.693c.56.062 4.015-.716 4.14-.405.125.249-2.148.935-2.895 1.712-.249.25-.902.84-1.308.778-.311-.031-.498-.685-.965-1.183-1.121-1.121-1.836-1.027-1.619-1.463.188-.341 1.682.468 2.647.561z"
      ></path>
      <path
        fill="#FBFBFB"
        d="M60.552 55.707c.549.061 3.932-.701 4.053-.396.122.244-2.103.914-2.834 1.676-.244.244-.883.823-1.279.762-.304-.03-.488-.67-.945-1.157-1.098-1.097-1.798-1.006-1.585-1.433.183-.336 1.646.456 2.59.548z"
      ></path>
      <path
        fill="#F8F8F8"
        d="M60.567 55.719c.537.06 3.847-.686 3.966-.388.12.239-2.057.896-2.773 1.641-.239.239-.864.806-1.252.746-.298-.029-.477-.656-.924-1.133-1.074-1.073-1.759-.984-1.551-1.401.179-.329 1.61.446 2.534.535z"
      ></path>
      <path
        fill="#F5F5F5"
        d="M60.582 55.732c.525.058 3.762-.67 3.879-.379.116.234-2.012.875-2.712 1.604-.233.233-.845.787-1.225.729-.291-.029-.467-.642-.905-1.108-1.05-1.05-1.721-.962-1.516-1.371.175-.32 1.575.438 2.479.525z"
      ></path>
      <path
        fill="#F2F2F2"
        d="M60.596 55.746c.514.057 3.678-.656 3.792-.371.114.228-1.967.855-2.651 1.567-.228.229-.828.77-1.198.713-.284-.028-.456-.627-.884-1.083-1.026-1.026-1.681-.941-1.482-1.34.171-.314 1.54.428 2.423.514z"
      ></path>
      <path
        fill="#EFEFEF"
        d="M60.611 55.758c.502.056 3.594-.641 3.705-.362.112.223-1.921.836-2.59 1.532-.223.223-.808.752-1.169.697-.279-.028-.446-.613-.864-1.059-1.003-1.002-1.644-.919-1.448-1.31.165-.306 1.502.418 2.366.502z"
      ></path>
      <path
        fill="#EBEBEB"
        d="M60.625 55.772c.49.054 3.51-.626 3.618-.354.109.218-1.877.816-2.529 1.497-.218.217-.79.734-1.143.68-.271-.027-.435-.599-.843-1.034-.979-.979-1.605-.897-1.414-1.278.162-.301 1.469.406 2.311.489z"
      ></path>
      <path
        fill="#E8E8E8"
        d="M60.64 55.784c.478.053 3.425-.611 3.53-.345.107.211-1.831.796-2.468 1.46-.212.212-.771.717-1.115.663-.265-.026-.425-.583-.823-1.008-.956-.956-1.567-.876-1.38-1.248.159-.292 1.433.398 2.256.478z"
      ></path>
      <path
        fill="#E5E5E5"
        d="M60.655 55.797c.466.052 3.34-.596 3.444-.337.103.207-1.786.777-2.408 1.424-.208.207-.75.699-1.088.647-.258-.026-.414-.57-.802-.984-.932-.932-1.528-.854-1.346-1.217.154-.284 1.397.389 2.2.467z"
      ></path>
      <path
        fill="#E2E2E2"
        d="M60.669 55.81c.455.051 3.256-.58 3.357-.328.101.202-1.741.757-2.347 1.388-.202.202-.732.682-1.06.631-.252-.025-.404-.555-.783-.959-.908-.908-1.489-.833-1.312-1.186.152-.278 1.362.377 2.145.454z"
      ></path>
      <path
        fill="#DFDFDF"
        d="M60.683 55.822c.442.049 3.171-.565 3.27-.319.099.197-1.696.737-2.286 1.352-.196.197-.713.664-1.032.614-.245-.024-.393-.541-.762-.934-.885-.885-1.45-.811-1.278-1.155.147-.27 1.326.369 2.088.442z"
      ></path>
      <path
        fill="#DBDBDB"
        d="M60.698 55.835c.432.048 3.087-.551 3.184-.311.095.19-1.652.717-2.227 1.315-.19.191-.693.646-1.005.599-.239-.024-.382-.526-.742-.91-.861-.861-1.412-.79-1.244-1.125.143-.261 1.292.36 2.034.432z"
      ></path>
      <path
        fill="#D8D8D8"
        d="M60.713 55.849c.419.046 3.002-.535 3.095-.303.093.186-1.605.698-2.164 1.28-.186.186-.675.629-.977.582-.233-.023-.373-.512-.722-.885-.838-.837-1.373-.768-1.209-1.094.138-.255 1.255.349 1.977.42z"
      ></path>
      <path
        fill="#D5D5D5"
        d="M60.727 55.861c.407.045 2.918-.52 3.008-.294.091.181-1.561.679-2.104 1.244-.181.181-.656.611-.95.566-.226-.023-.361-.498-.7-.86-.814-.813-1.335-.746-1.177-1.062.136-.249 1.222.338 1.923.406z"
      ></path>
      <path
        fill="#D2D2D2"
        d="M60.742 55.874c.396.044 2.833-.505 2.922-.285.088.175-1.516.659-2.042 1.208-.176.175-.637.593-.922.549-.221-.022-.352-.483-.682-.834-.79-.791-1.295-.725-1.142-1.032.13-.243 1.185.328 1.866.394z"
      ></path>
      <path
        fill="#CFCFCF"
        d="M60.757 55.887c.384.043 2.749-.49 2.834-.277.086.17-1.47.64-1.982 1.172-.169.171-.618.575-.895.533-.213-.021-.34-.469-.66-.81-.768-.768-1.258-.704-1.109-1.002.128-.233 1.151.32 1.812.384z"
      ></path>
      <path
        fill="#ccc"
        d="M60.771 55.9c.372.042 2.665-.475 2.748-.268.082.165-1.426.62-1.921 1.135-.166.166-.599.558-.869.517-.207-.021-.33-.454-.64-.785-.743-.744-1.218-.682-1.074-.971.125-.227 1.116.31 1.756.372z"
      ></path>
      <path
        fill="#C8C8C8"
        d="M60.785 55.913c.36.04 2.581-.46 2.661-.26.08.16-1.38.6-1.86 1.1-.16.16-.58.54-.84.5-.2-.02-.32-.44-.621-.76-.72-.72-1.18-.66-1.039-.94.12-.221 1.08.3 1.699.36z"
      ></path>
      <path
        fill="#C5C5C5"
        d="M60.801 55.926c.348.038 2.496-.445 2.573-.252.077.154-1.335.581-1.799 1.064-.155.155-.562.522-.813.483-.194-.02-.31-.425-.599-.735-.698-.696-1.142-.639-1.007-.91.116-.211 1.045.292 1.645.35z"
      ></path>
      <path
        fill="#C2C2C2"
        d="M60.815 55.939c.336.038 2.411-.43 2.486-.243.075.15-1.289.561-1.738 1.028-.15.149-.543.505-.785.467-.187-.019-.3-.411-.58-.71-.672-.673-1.103-.618-.972-.879.112-.205 1.01.28 1.589.337z"
      ></path>
      <path
        fill="#BFBFBF"
        d="M60.829 55.951c.325.036 2.327-.415 2.4-.235.072.145-1.245.542-1.678.993-.145.144-.523.487-.758.451-.181-.018-.288-.396-.559-.685-.65-.649-1.064-.596-.938-.849.108-.198.974.271 1.533.325z"
      ></path>
      <path d="M72.425 5.573c-.394.849-1.23 7.494-.08 6.745 1.161-.756 4.381-1.715 6.42-2.265 2.261-.608-5.548-6.283-6.34-4.48z"></path>
      <path
        fill="#060606"
        d="M72.5 5.696c-.391.838-1.196 7.186-.076 6.459 1.128-.73 4.222-1.646 6.147-2.189 2.128-.614-5.306-6.008-6.071-4.27z"
      ></path>
      <path
        fill="#0C0C0C"
        d="M72.575 5.821c-.386.826-1.161 6.875-.071 6.174 1.095-.706 4.063-1.578 5.874-2.115 1.994-.621-5.064-5.733-5.803-4.059z"
      ></path>
      <path
        fill="#131313"
        d="M72.65 5.945c-.383.814-1.125 6.566-.067 5.889 1.062-.679 3.905-1.51 5.602-2.041 1.86-.627-4.822-5.458-5.535-3.848z"
      ></path>
      <path
        fill="#191919"
        d="M72.724 6.069c-.38.802-1.09 6.257-.062 5.603s3.745-1.441 5.328-1.966c1.727-.633-4.579-5.182-5.266-3.637z"
      ></path>
      <path
        fill="#1F1F1F"
        d="M72.8 6.193c-.375.79-1.056 5.947-.058 5.318.996-.629 3.585-1.373 5.056-1.892 1.592-.638-4.337-4.907-4.998-3.426z"
      ></path>
      <path
        fill="#262626"
        d="M72.874 6.317c-.372.778-1.021 5.638-.053 5.033.963-.604 3.427-1.305 4.782-1.817 1.459-.645-4.093-4.632-4.729-3.216z"
      ></path>
      <path
        fill="#2C2C2C"
        d="M72.95 6.441c-.369.766-.987 5.328-.05 4.747.931-.578 3.269-1.235 4.51-1.742 1.326-.651-3.852-4.356-4.46-3.005z"
      ></path>
      <path
        fill="#333"
        d="M73.025 6.565c-.365.754-.951 5.018-.045 4.461.897-.553 3.108-1.167 4.235-1.668 1.193-.655-3.607-4.08-4.19-2.793z"
      ></path>
      <path
        fill="#393939"
        d="M73.1 6.69c-.361.742-.916 4.708-.041 4.176.865-.528 2.951-1.099 3.963-1.594C78.08 8.61 73.656 5.467 73.1 6.69z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M73.175 6.814c-.357.73-.881 4.399-.036 3.89.831-.502 2.791-1.03 3.689-1.52.925-.667-3.124-3.529-3.653-2.37z"
      ></path>
      <path
        fill="#464646"
        d="M73.249 6.938c-.354.718-.846 4.089-.032 3.605.799-.478 2.632-.962 3.417-1.445.792-.673-2.881-3.254-3.385-2.16z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M73.325 7.063c-.351.706-.812 3.779-.027 3.319.767-.452 2.473-.895 3.144-1.37.657-.68-2.639-2.979-3.117-1.949z"
      ></path>
      <path
        fill="#525252"
        d="M73.399 7.187c-.346.694-.776 3.47-.023 3.034.733-.427 2.314-.826 2.871-1.295.524-.687-2.396-2.704-2.848-1.739z"
      ></path>
      <path
        fill="#595959"
        d="M73.474 7.311c-.342.682-.741 3.161-.018 2.749.701-.402 2.156-.757 2.598-1.222.39-.691-2.154-2.428-2.58-1.527z"
      ></path>
      <path
        fill="#5F5F5F"
        d="M73.549 7.435c-.338.671-.706 2.851-.014 2.462.667-.376 1.997-.688 2.324-1.147.258-.696-1.91-2.151-2.31-1.315z"
      ></path>
      <path
        fill="#666"
        d="M73.624 7.559c-.334.659-.671 2.541-.009 2.177.636-.351 1.837-.62 2.052-1.072.122-.703-1.669-1.877-2.043-1.105z"
      ></path>
      <path
        fill="#6C6C6C"
        d="M73.699 7.683c-.331.647-.637 2.231-.005 1.892.603-.325 1.678-.551 1.778-.997-.009-.71-1.425-1.602-1.773-.895z"
      ></path>
      <path
        fill="#727272"
        d="M73.773 7.807c-.328.635-.601 1.922-.001 1.606.571-.3 1.52-.483 1.506-.923-.143-.714-1.182-1.325-1.505-.683z"
      ></path>
      <path
        fill="#797979"
        d="M73.849 7.931c-.325.623-.567 1.612.003 1.321.537-.275 1.361-.415 1.232-.849-.277-.72-.939-1.05-1.235-.472z"
      ></path>
      <path
        fill="#7F7F7F"
        d="M73.924 8.055c-.321.611-.532 1.303.007 1.035.505-.25 1.202-.346.96-.774-.411-.726-.697-.774-.967-.261z"
      ></path>
      <path d="M56.039 16.7c-.232.697 2.813 1.65 3.488 2.255.906.813.976 2.417 2.045 1.767.697-.418.163-1.348-1.117-2.766-1.882-2.094-4.206-1.838-4.416-1.256z"></path>
      <path
        fill="#050505"
        d="M56.197 16.763c-.23.669 2.672 1.583 3.338 2.177.886.793.956 2.34 1.984 1.715.677-.405.145-1.315-1.08-2.673-1.799-2.003-4.032-1.778-4.242-1.219z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M56.355 16.826c-.229.642 2.532 1.514 3.188 2.098.865.773.935 2.263 1.923 1.664.654-.391.126-1.281-1.043-2.581-1.717-1.912-3.859-1.717-4.068-1.181z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M56.513 16.89c-.227.613 2.39 1.445 3.039 2.02.845.752.915 2.185 1.861 1.612.635-.378.111-1.248-1.005-2.488-1.635-1.824-3.686-1.659-3.895-1.144z"
      ></path>
      <path
        fill="#141414"
        d="M56.67 16.954c-.226.585 2.25 1.376 2.889 1.94.825.731.895 2.108 1.799 1.561.613-.365.093-1.214-.968-2.395-1.551-1.733-3.51-1.599-3.72-1.106z"
      ></path>
      <path
        fill="#191919"
        d="M56.827 17.017c-.224.557 2.109 1.308 2.739 1.862.805.711.875 2.031 1.739 1.51.592-.351.075-1.18-.931-2.302-1.469-1.645-3.337-1.54-3.547-1.07z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M56.985 17.08c-.222.53 1.968 1.24 2.59 1.784.784.691.854 1.954 1.676 1.458.571-.338.058-1.147-.894-2.209-1.386-1.554-3.162-1.48-3.372-1.033z"
      ></path>
      <path
        fill="#232323"
        d="M57.143 17.144c-.222.501 1.827 1.172 2.441 1.706.764.67.833 1.877 1.615 1.407.55-.324.04-1.114-.856-2.117-1.305-1.465-2.99-1.421-3.2-.996z"
      ></path>
      <path
        fill="#282828"
        d="M57.301 17.208c-.22.473 1.686 1.103 2.291 1.627.744.65.814 1.799 1.555 1.355.528-.311.022-1.08-.82-2.024-1.223-1.375-2.816-1.362-3.026-.958z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M57.459 17.272c-.22.445 1.544 1.034 2.141 1.548.724.629.792 1.722 1.492 1.304.508-.297.005-1.046-.783-1.931-1.138-1.286-2.64-1.303-2.85-.921z"
      ></path>
      <path
        fill="#333"
        d="M57.616 17.335c-.217.417 1.404.965 1.992 1.469.704.609.772 1.645 1.431 1.253.486-.284-.013-1.013-.747-1.838-1.055-1.196-2.466-1.243-2.676-.884z"
      ></path>
      <path
        fill="#383838"
        d="M57.774 17.398c-.216.389 1.263.897 1.842 1.391.683.589.752 1.568 1.369 1.202.465-.27-.03-.979-.709-1.746-.972-1.106-2.292-1.183-2.502-.847z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M57.931 17.461c-.214.361 1.123.829 1.692 1.313.663.568.732 1.49 1.308 1.149.444-.256-.048-.945-.672-1.652-.89-1.017-2.117-1.124-2.328-.81z"
      ></path>
      <path
        fill="#424242"
        d="M58.089 17.525c-.212.333.982.76 1.542 1.234.642.547.712 1.413 1.247 1.098.423-.243-.065-.912-.636-1.56-.807-.926-1.942-1.064-2.153-.772z"
      ></path>
      <path
        fill="#474747"
        d="M58.248 17.589c-.211.305.84.691 1.392 1.155.622.527.691 1.336 1.186 1.047.401-.229-.083-.878-.599-1.466-.725-.838-1.77-1.006-1.979-.736z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M58.406 17.652c-.21.278.698.624 1.242 1.078.602.506.671 1.258 1.124.995.381-.216-.1-.845-.561-1.374-.643-.748-1.596-.946-1.805-.699z"
      ></path>
      <path
        fill="#515151"
        d="M58.563 17.715c-.208.25.558.555 1.093.999.582.486.652 1.181 1.063.944.359-.202-.118-.811-.525-1.281-.559-.658-1.42-.887-1.631-.662z"
      ></path>
      <path
        fill="#565656"
        d="M58.72 17.779c-.206.221.418.486.944.92.562.465.63 1.104 1.001.893.338-.189-.135-.777-.487-1.188-.477-.569-1.247-.828-1.458-.625z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M58.877 17.843c-.204.193.277.417.794.841.542.445.611 1.027.94.841.317-.176-.152-.744-.45-1.095-.394-.479-1.072-.768-1.284-.587z"
      ></path>
      <path
        fill="#606060"
        d="M59.036 17.906c-.204.166.136.349.644.763.521.425.591.95.878.791.296-.162-.17-.71-.413-1.002-.312-.391-.899-.71-1.109-.552z"
      ></path>
      <path
        fill="#666"
        d="M59.194 17.969c-.202.137-.006.281.494.685.501.404.571.872.816.739.275-.149-.188-.677-.376-.91-.228-.3-.724-.65-.934-.514z"
      ></path>
      <path d="M72.173 16.444c-.024.349.953.558 1.581.791.628.209 1.859 1.046 2.441 1.697.581.627 1.836 2.487 2.116 1.999.278-.441-.651-1.72-.907-2.255-.255-.535-1.045-1.697-2.301-2.092-1.094-.326-2.907-.419-2.93-.14z"></path>
      <path
        fill="#060606"
        d="M72.273 16.469c-.023.338.926.543 1.536.771.611.204 1.807 1.021 2.372 1.654.564.611 1.786 2.419 2.058 1.946.271-.429-.625-1.67-.884-2.194-.257-.524-1.025-1.644-2.244-2.034-1.061-.322-2.815-.415-2.838-.143z"
      ></path>
      <path
        fill="#0C0C0C"
        d="M72.372 16.494c-.023.33.899.529 1.491.751.593.199 1.755.995 2.302 1.61.547.595 1.738 2.351 2.002 1.893.262-.416-.599-1.62-.862-2.133-.26-.513-1.004-1.59-2.188-1.977-1.026-.318-2.723-.408-2.745-.144z"
      ></path>
      <path
        fill="#131313"
        d="M72.472 16.518c-.023.32.873.516 1.446.732.576.194 1.702.968 2.233 1.567.53.578 1.688 2.283 1.944 1.839.254-.403-.573-1.571-.84-2.072-.264-.502-.983-1.537-2.13-1.918-.992-.314-2.631-.404-2.653-.148z"
      ></path>
      <path
        fill="#191919"
        d="M72.572 16.543c-.023.31.845.502 1.402.712.558.19 1.649.943 2.164 1.524.512.562 1.639 2.215 1.887 1.786.248-.39-.547-1.521-.817-2.011-.266-.491-.961-1.483-2.074-1.861-.96-.31-2.54-.399-2.562-.15z"
      ></path>
      <path
        fill="#1F1F1F"
        d="M72.672 16.568c-.023.3.817.487 1.358.692.54.185 1.596.918 2.093 1.481.494.545 1.589 2.146 1.831 1.732.237-.376-.522-1.471-.796-1.95-.269-.479-.94-1.43-2.017-1.803-.926-.305-2.447-.393-2.469-.152z"
      ></path>
      <path
        fill="#262626"
        d="M72.77 16.592c-.022.291.792.474 1.314.673.523.18 1.545.893 2.025 1.438.477.529 1.54 2.079 1.772 1.679.231-.364-.495-1.421-.773-1.89-.271-.468-.919-1.376-1.96-1.745-.891-.301-2.356-.387-2.378-.155z"
      ></path>
      <path
        fill="#2C2C2C"
        d="M72.87 16.617c-.021.282.765.46 1.27.654.504.175 1.492.867 1.955 1.394.46.512 1.49 2.011 1.716 1.626.222-.351-.47-1.372-.751-1.829-.273-.457-.898-1.323-1.904-1.687-.859-.298-2.264-.383-2.286-.158z"
      ></path>
      <path
        fill="#333"
        d="M72.97 16.642c-.022.272.737.446 1.226.634.487.17 1.439.841 1.886 1.351.442.496 1.44 1.942 1.658 1.573.214-.338-.445-1.322-.729-1.768-.276-.446-.878-1.27-1.846-1.629-.827-.294-2.173-.378-2.195-.161z"
      ></path>
      <path
        fill="#393939"
        d="M73.07 16.667c-.021.263.712.432 1.181.615.47.166 1.387.815 1.817 1.308.425.479 1.39 1.875 1.601 1.519.207-.324-.418-1.271-.706-1.707-.279-.436-.856-1.216-1.789-1.571-.794-.291-2.083-.374-2.104-.164z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M73.17 16.691c-.022.253.684.418 1.136.595.453.161 1.335.79 1.747 1.265.408.463 1.342 1.806 1.545 1.466.197-.312-.393-1.222-.685-1.646-.281-.424-.834-1.162-1.731-1.513-.761-.287-1.991-.369-2.012-.167z"
      ></path>
      <path
        fill="#464646"
        d="M73.269 16.716c-.021.243.658.404 1.092.576.435.155 1.282.764 1.678 1.221.391.447 1.292 1.738 1.488 1.413.189-.299-.367-1.172-.663-1.585-.284-.414-.814-1.109-1.676-1.455-.726-.283-1.899-.364-1.919-.17z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M73.369 16.741c-.021.234.629.39 1.047.557.417.15 1.229.738 1.608 1.178.373.43 1.243 1.67 1.43 1.359.182-.286-.341-1.122-.64-1.525-.287-.402-.792-1.055-1.619-1.397-.691-.279-1.806-.359-1.826-.172z"
      ></path>
      <path
        fill="#525252"
        d="M73.469 16.766c-.021.223.604.375 1.002.536.4.146 1.178.713 1.54 1.135.356.414 1.194 1.602 1.375 1.306.172-.273-.315-1.072-.618-1.464-.29-.391-.772-1.002-1.563-1.339-.66-.274-1.716-.353-1.736-.174z"
      ></path>
      <path
        fill="#595959"
        d="M73.569 16.791c-.021.214.576.362.958.517.382.141 1.125.687 1.47 1.091.338.397 1.144 1.534 1.316 1.253.166-.26-.29-1.022-.596-1.403-.291-.38-.75-.949-1.504-1.282-.627-.27-1.624-.348-1.644-.176z"
      ></path>
      <path
        fill="#5F5F5F"
        d="M73.669 16.815c-.021.205.549.348.913.498.365.135 1.072.662 1.401 1.049.32.38 1.094 1.465 1.258 1.199.158-.247-.262-.973-.573-1.342-.294-.368-.73-.895-1.448-1.223-.592-.267-1.532-.344-1.551-.181z"
      ></path>
      <path
        fill="#666"
        d="M73.768 16.84c-.02.194.522.333.869.478.347.131 1.019.636 1.332 1.005.303.364 1.043 1.397 1.201 1.146.15-.234-.237-.922-.551-1.281-.296-.358-.708-.841-1.391-1.166-.559-.263-1.441-.338-1.46-.182z"
      ></path>
      <path
        fill="#6C6C6C"
        d="M73.868 16.865c-.021.185.495.32.825.458.329.126.967.61 1.261.961.286.348.995 1.329 1.146 1.093.141-.221-.211-.873-.529-1.22-.299-.347-.688-.788-1.334-1.108-.528-.258-1.35-.333-1.369-.184z"
      ></path>
      <path
        fill="#727272"
        d="M73.968 16.889c-.021.176.468.306.779.439.312.122.914.584 1.192.919.27.331.946 1.261 1.088 1.039.133-.208-.186-.823-.506-1.16-.302-.335-.667-.734-1.277-1.05-.494-.254-1.258-.327-1.276-.187z"
      ></path>
      <path
        fill="#797979"
        d="M74.068 16.914c-.021.167.441.292.735.419.294.117.861.559 1.123.876.251.315.896 1.193 1.031.986.124-.194-.161-.773-.484-1.098-.305-.324-.646-.681-1.221-.992-.46-.251-1.166-.324-1.184-.191z"
      ></path>
      <path
        fill="#7F7F7F"
        d="M74.167 16.939c-.02.157.415.278.691.4.277.111.809.533 1.054.832.234.298.846 1.125.974.933.117-.182-.135-.724-.462-1.038-.308-.313-.625-.628-1.164-.934-.427-.247-1.075-.318-1.093-.193z"
      ></path>
      <path
        fill="#995900"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.462 3.742-10.042 6.183-4.511 3.091-6.067 4.464-7.532 5.927-2.278 2.279-4.44 3.045-7.904 3.045s-5.021-.72-6.09-1.674c-1.07-.93-2.254-3.301-2.139-6.834.093-3.511 1.208-6.719 1.744-12.182.232-2.348.208-5.253.208-7.833 0-3.255.047-6.021.745-6.439 1.255-.79 1.534-.836 3.021-.836s2.162.092 2.65.581c.464.464.279 1.534.116 3.045-.14 1.511.582 1.999 1.302 2.627.721.604 1.372 1.372 3.65 1.558 2.278.162 3.114-.209 4.184-.884 1.07-.674 2.58-1.882 3.139-2.58.534-.674 1.859-2.999 2.115-2.999.232 0 1.767-.534 2.627.721z"
      ></path>
      <path
        fill="#9E5E00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.496 3.73-10.093 6.136-4.483 3.025-6.104 4.372-7.594 5.78-2.231 2.176-4.331 2.933-7.721 2.912-3.361-.016-4.881-.704-5.945-1.653-1.064-.925-2.237-3.218-2.135-6.644.066-3.503 1.194-6.678 1.696-12.036.216-2.382.132-5.263.109-7.87-.025-3.25-.024-6.014.673-6.432 1.255-.789 1.534-.837 3.021-.837s2.164.094 2.65.581c.481.481.248 1.578.066 3.037-.204 1.504.471 2.094 1.226 2.779.755.665 1.449 1.443 3.723 1.621 2.335.156 3.234-.269 4.315-1.002 1.066-.713 2.509-1.905 3.071-2.637.53-.689 1.849-3.031 2.105-3.031.232.001 1.767-.533 2.627.722z"
      ></path>
      <path
        fill="#A36400"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.53 3.719-10.143 6.09-4.456 2.958-6.14 4.279-7.657 5.632-2.186 2.074-4.221 2.82-7.54 2.778-3.258-.03-4.74-.688-5.8-1.632-1.06-.92-2.219-3.134-2.131-6.453.04-3.496 1.18-6.637 1.65-11.891.198-2.417.053-5.275.007-7.906-.049-3.248-.093-6.007.602-6.425 1.255-.788 1.535-.837 3.021-.837 1.488 0 2.165.095 2.65.581.498.498.217 1.621.017 3.029-.268 1.497.36 2.189 1.147 2.931.791.726 1.528 1.516 3.799 1.686 2.392.149 3.352-.328 4.445-1.123 1.062-.75 2.438-1.929 3.003-2.694.526-.703 1.839-3.062 2.094-3.062.235.001 1.77-.533 2.63.722z"
      ></path>
      <path
        fill="#A86A00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.563 3.707-10.193 6.043-4.43 2.894-6.175 4.188-7.72 5.485-2.139 1.971-4.112 2.707-7.356 2.644-3.157-.045-4.599-.671-5.655-1.611-1.056-.916-2.203-3.049-2.128-6.262.012-3.489 1.167-6.596 1.604-11.745.18-2.453-.024-5.285-.094-7.942-.074-3.244-.163-6 .531-6.418 1.255-.787 1.534-.836 3.021-.836s2.166.096 2.65.581c.513.515.185 1.664-.034 3.021-.332 1.49.25 2.285 1.072 3.083.825.786 1.604 1.588 3.873 1.75 2.449.142 3.471-.388 4.574-1.243 1.059-.79 2.368-1.953 2.936-2.751.521-.716 1.828-3.092 2.084-3.092.234-.002 1.769-.536 2.629.719z"
      ></path>
      <path
        fill="#AD7000"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.597 3.695-10.243 5.997-4.403 2.827-6.211 4.096-7.783 5.337-2.092 1.869-4.002 2.594-7.174 2.511-3.054-.061-4.458-.656-5.508-1.59-1.051-.912-2.186-2.966-2.125-6.072-.013-3.483 1.153-6.556 1.558-11.601.163-2.487-.102-5.295-.194-7.979-.098-3.24-.233-5.993.46-6.411 1.255-.786 1.534-.836 3.021-.836s2.167.097 2.65.58c.53.531.154 1.707-.083 3.013-.396 1.483.14 2.38.995 3.235.86.847 1.683 1.661 3.947 1.813 2.507.135 3.59-.446 4.706-1.362 1.056-.827 2.296-1.976 2.869-2.808.516-.729 1.817-3.124 2.074-3.124.229.002 1.764-.532 2.624.723z"
      ></path>
      <path
        fill="#B27500"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.631 3.684-10.292 5.951-4.376 2.761-6.247 4.004-7.846 5.19-2.046 1.767-3.894 2.481-6.991 2.376-2.952-.075-4.318-.639-5.364-1.568-1.045-.907-2.167-2.883-2.121-5.881-.041-3.477 1.139-6.516 1.511-11.456.145-2.522-.181-5.306-.296-8.014-.123-3.238-.303-5.986.389-6.405 1.255-.784 1.534-.836 3.021-.836s2.167.099 2.65.581c.546.547.122 1.75-.133 3.005-.459 1.476.029 2.476.918 3.388.895.907 1.76 1.731 4.021 1.877 2.562.128 3.708-.505 4.835-1.482 1.053-.866 2.227-1.999 2.801-2.865.512-.744 1.808-3.155 2.063-3.155.233-.001 1.768-.535 2.628.72z"
      ></path>
      <path
        fill="#B77B00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.665 3.673-10.342 5.904-4.35 2.695-6.283 3.913-7.909 5.042-1.999 1.665-3.785 2.369-6.809 2.243-2.849-.091-4.178-.623-5.218-1.548-1.042-.902-2.15-2.799-2.119-5.69-.067-3.468 1.125-6.475 1.465-11.31.128-2.557-.258-5.316-.397-8.05-.147-3.233-.373-5.979.317-6.397 1.256-.783 1.535-.836 3.022-.836 1.487 0 2.168.1 2.649.581.563.563.091 1.793-.184 2.997-.523 1.469-.081 2.571.842 3.541.929.967 1.838 1.803 4.096 1.941 2.621.121 3.827-.565 4.966-1.602 1.049-.904 2.155-2.022 2.734-2.922.506-.758 1.796-3.187 2.052-3.187.234-.002 1.769-.536 2.629.719z"
      ></path>
      <path
        fill="#BC8100"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.699 3.661-10.392 5.858-4.323 2.628-6.32 3.821-7.972 4.895-1.953 1.562-3.675 2.256-6.626 2.11-2.748-.106-4.037-.607-5.074-1.528-1.037-.897-2.132-2.715-2.114-5.5-.094-3.461 1.111-6.434 1.419-11.165.11-2.592-.336-5.326-.499-8.086-.171-3.23-.442-5.972.248-6.391 1.255-.782 1.534-.837 3.021-.837s2.17.102 2.65.581c.579.579.059 1.836-.233 2.988-.587 1.462-.192 2.667.765 3.693.964 1.028 1.917 1.876 4.17 2.005 2.676.114 3.944-.625 5.095-1.722 1.045-.942 2.083-2.045 2.667-2.979.502-.772 1.786-3.218 2.042-3.218.232.001 1.767-.533 2.627.722z"
      ></path>
      <path
        fill="#C18700"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.733 3.649-10.442 5.811-4.296 2.563-6.356 3.729-8.035 4.748-1.906 1.46-3.565 2.144-6.443 1.976-2.646-.121-3.896-.59-4.929-1.507-1.032-.892-2.116-2.63-2.111-5.309-.121-3.454 1.097-6.393 1.372-11.018.093-2.627-.414-5.338-.6-8.123-.196-3.227-.512-5.965.176-6.383 1.256-.781 1.535-.837 3.022-.837 1.487 0 2.171.103 2.649.581.596.596.029 1.878-.283 2.98-.651 1.455-.302 2.761.688 3.845.999 1.088 1.994 1.948 4.244 2.069 2.734.107 4.063-.684 5.226-1.841 1.042-.981 2.013-2.069 2.599-3.036.498-.786 1.776-3.25 2.032-3.25.234-.001 1.769-.535 2.629.72z"
      ></path>
      <path
        fill="#C68C00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.766 3.637-10.492 5.764-4.269 2.496-6.392 3.638-8.097 4.6-1.86 1.357-3.457 2.03-6.261 1.843-2.544-.137-3.756-.575-4.783-1.486-1.028-.888-2.098-2.548-2.107-5.12-.147-3.447 1.083-6.352 1.325-10.873.076-2.662-.491-5.347-.701-8.158-.22-3.223-.581-5.958.106-6.376 1.255-.78 1.534-.836 3.021-.836s2.172.103 2.65.58c.612.612-.004 1.921-.333 2.972-.716 1.448-.413 2.857.612 3.998 1.034 1.148 2.071 2.02 4.319 2.132 2.79.1 4.181-.742 5.356-1.961 1.038-1.019 1.942-2.092 2.532-3.093.492-.8 1.765-3.281 2.021-3.281.231 0 1.766-.534 2.626.721z"
      ></path>
      <path
        fill="#CC9200"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.8 3.626-10.542 5.718-4.243 2.43-6.428 3.545-8.16 4.452-1.813 1.255-3.347 1.917-6.078 1.708-2.441-.151-3.615-.558-4.637-1.464-1.023-.883-2.081-2.465-2.105-4.929-.173-3.44 1.07-6.312 1.278-10.728.059-2.697-.569-5.358-.801-8.194-.245-3.22-.65-5.952.035-6.37 1.255-.779 1.534-.836 3.021-.836s2.173.104 2.65.58c.628.628-.035 1.964-.384 2.964-.779 1.441-.523 2.952.535 4.15 1.07 1.209 2.15 2.092 4.394 2.197 2.847.093 4.3-.802 5.485-2.081 1.035-1.057 1.871-2.116 2.465-3.149.488-.814 1.754-3.313 2.011-3.313.232 0 1.767-.534 2.627.721z"
      ></path>
      <path
        fill="#D19800"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.833 3.614-10.593 5.671-4.215 2.363-6.463 3.454-8.222 4.305-1.767 1.153-3.238 1.805-5.896 1.575-2.338-.167-3.474-.542-4.492-1.444-1.019-.879-2.064-2.381-2.101-4.738-.202-3.433 1.056-6.271 1.231-10.583.041-2.731-.647-5.368-.902-8.229-.27-3.216-.721-5.944-.037-6.363 1.255-.777 1.535-.836 3.021-.836 1.488 0 2.176.105 2.65.581.645.644-.066 2.008-.434 2.957-.842 1.434-.632 3.047.459 4.301 1.104 1.27 2.228 2.164 4.468 2.26 2.905.086 4.419-.861 5.617-2.2 1.031-1.096 1.8-2.138 2.397-3.207.483-.828 1.744-3.344 2-3.344.233-.001 1.768-.535 2.628.72z"
      ></path>
      <path
        fill="#D69E00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.868 3.603-10.642 5.625-4.189 2.297-6.5 3.362-8.286 4.157-1.719 1.051-3.128 1.692-5.713 1.441-2.236-.181-3.334-.525-4.348-1.422-1.013-.874-2.045-2.296-2.097-4.547-.228-3.426 1.042-6.229 1.187-10.438.023-2.766-.725-5.379-1.005-8.267-.292-3.212-.79-5.937-.106-6.355 1.255-.776 1.534-.836 3.021-.836s2.177.106 2.65.581c.66.66-.098 2.051-.484 2.948-.906 1.428-.743 3.143.381 4.454 1.14 1.33 2.306 2.236 4.542 2.325 2.962.079 4.538-.921 5.747-2.32a16.361 16.361 0 002.329-3.263c.478-.842 1.733-3.376 1.99-3.376.233-.002 1.768-.536 2.628.719z"
      ></path>
      <path
        fill="#DBA300"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.9 3.591-10.691 5.578-4.164 2.231-6.537 3.27-8.348 4.01-1.675.948-3.02 1.579-5.533 1.307-2.134-.196-3.192-.509-4.201-1.402-1.009-.869-2.028-2.213-2.093-4.356-.255-3.42 1.027-6.189 1.139-10.293.006-2.801-.803-5.39-1.105-8.302-.317-3.209-.86-5.93-.179-6.349 1.256-.775 1.535-.836 3.022-.836 1.487 0 2.177.107 2.649.581.677.677-.128 2.094-.533 2.94-.971 1.42-.854 3.238.304 4.606 1.174 1.39 2.384 2.308 4.617 2.388 3.019.072 4.656-.979 5.876-2.44 1.024-1.173 1.659-2.186 2.263-3.321.474-.855 1.723-3.406 1.979-3.406.233 0 1.768-.534 2.628.721z"
      ></path>
      <path
        fill="#E0A900"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.935 3.58-10.743 5.532-4.135 2.165-6.571 3.178-8.41 3.862-1.627.846-2.91 1.467-5.349 1.174-2.032-.211-3.052-.493-4.056-1.381-1.005-.865-2.011-2.129-2.09-4.166-.282-3.413 1.015-6.149 1.093-10.147-.011-2.835-.881-5.4-1.206-8.338-.342-3.205-.93-5.923-.25-6.342 1.255-.774 1.535-.837 3.021-.837 1.488 0 2.179.109 2.65.581.693.693-.161 2.136-.583 2.932-1.034 1.413-.964 3.333.229 4.758 1.208 1.451 2.461 2.381 4.69 2.453 3.076.066 4.775-1.039 6.008-2.559 1.02-1.211 1.587-2.209 2.194-3.379.469-.869 1.712-3.437 1.969-3.437.232-.001 1.767-.535 2.627.72z"
      ></path>
      <path
        fill="#E5AF00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.968 3.568-10.792 5.485-4.108 2.098-6.607 3.086-8.473 3.714-1.581.744-2.801 1.353-5.167 1.04-1.93-.227-2.912-.477-3.911-1.36-1-.86-1.994-2.046-2.087-3.976-.307-3.405 1-6.107 1.046-10.001-.029-2.871-.959-5.411-1.307-8.375-.366-3.202-1-5.916-.32-6.334 1.256-.773 1.535-.836 3.022-.836 1.487 0 2.18.11 2.649.581.709.709-.191 2.18-.632 2.924-1.099 1.406-1.076 3.428.15 4.911 1.244 1.511 2.54 2.453 4.765 2.516 3.133.058 4.894-1.098 6.137-2.679 1.017-1.25 1.517-2.232 2.128-3.435.465-.883 1.702-3.47 1.958-3.47.233 0 1.768-.534 2.628.721z"
      ></path>
      <path
        fill="#EAB500"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.002 3.557-10.842 5.439-4.083 2.032-6.643 2.994-8.536 3.566-1.534.642-2.691 1.241-4.985.907-1.826-.242-2.77-.46-3.765-1.339-.995-.855-1.976-1.962-2.083-3.785-.335-3.398.986-6.067.999-9.856-.046-2.906-1.036-5.422-1.408-8.411-.391-3.199-1.07-5.91-.391-6.328 1.256-.772 1.535-.837 3.022-.837 1.487 0 2.181.112 2.649.581.726.726-.222 2.223-.684 2.915-1.162 1.399-1.185 3.524.075 5.063 1.278 1.572 2.617 2.525 4.84 2.581 3.189.051 5.012-1.158 6.267-2.798 1.014-1.289 1.446-2.255 2.06-3.492.46-.898 1.692-3.501 1.948-3.501.233 0 1.768-.534 2.628.721z"
      ></path>
      <path
        fill="#EFBA00"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.035 3.544-10.892 5.393-4.056 1.965-6.68 2.902-8.598 3.418-1.488.54-2.583 1.129-4.802.773-1.725-.256-2.63-.444-3.622-1.318-.989-.85-1.958-1.878-2.079-3.593-.361-3.392.972-6.027.953-9.711-.064-2.941-1.115-5.432-1.51-8.447-.414-3.195-1.139-5.902-.462-6.32 1.256-.77 1.535-.837 3.022-.837 1.487 0 2.182.113 2.649.581.743.742-.254 2.266-.732 2.907-1.227 1.394-1.296 3.62-.003 5.216 1.313 1.632 2.696 2.597 4.915 2.644 3.246.045 5.13-1.216 6.397-2.918 1.01-1.326 1.374-2.278 1.992-3.548.455-.912 1.682-3.533 1.937-3.533.234-.002 1.769-.536 2.629.719z"
      ></path>
      <path
        fill="#F4C000"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.069 3.533-10.942 5.347-4.029 1.899-6.716 2.81-8.662 3.271-1.441.437-2.473 1.016-4.619.639-1.623-.272-2.49-.428-3.476-1.297-.986-.847-1.941-1.794-2.076-3.404-.389-3.384.957-5.985.907-9.565-.082-2.976-1.194-5.442-1.612-8.482-.439-3.192-1.208-5.896-.533-6.314 1.256-.769 1.535-.836 3.022-.836 1.487 0 2.183.114 2.649.581.759.758-.285 2.308-.782 2.899-1.291 1.386-1.407 3.714-.08 5.368 1.348 1.692 2.773 2.669 4.988 2.708 3.303.037 5.249-1.276 6.527-3.039 1.007-1.364 1.305-2.301 1.925-3.605.451-.925 1.671-3.563 1.927-3.563.236-.003 1.771-.537 2.631.718z"
      ></path>
      <path
        fill="#F9C600"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.103 3.521-10.992 5.299-4.001 1.833-6.752 2.719-8.725 3.124-1.394.335-2.364.904-4.436.505-1.521-.287-2.349-.411-3.33-1.276-.981-.842-1.924-1.711-2.072-3.213-.415-3.377.944-5.945.86-9.42-.099-3.011-1.27-5.453-1.711-8.519-.464-3.188-1.279-5.888-.604-6.307 1.255-.768 1.534-.836 3.021-.836s2.185.115 2.65.581c.773.774-.317 2.351-.833 2.891-1.354 1.378-1.517 3.81-.156 5.52 1.383 1.753 2.851 2.741 5.062 2.771 3.361.031 5.368-1.335 6.658-3.157 1.003-1.403 1.233-2.324 1.857-3.663.447-.939 1.662-3.595 1.917-3.595.233 0 1.768-.534 2.628.721z"
      ></path>
      <path
        fill="#fc0"
        d="M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.137 3.51-11.042 5.253-3.976 1.767-6.788 2.627-8.788 2.976-1.348.233-2.254.79-4.254.372-1.418-.302-2.208-.396-3.184-1.255-.976-.836-1.906-1.627-2.069-3.022-.442-3.371.93-5.905.813-9.275-.116-3.045-1.348-5.463-1.813-8.554-.488-3.185-1.348-5.882-.673-6.3 1.255-.767 1.534-.836 3.021-.836s2.186.116 2.65.58c.791.791-.349 2.395-.883 2.883-1.418 1.372-1.628 3.905-.233 5.671 1.418 1.814 2.929 2.813 5.138 2.837 3.417.023 5.485-1.395 6.787-3.278 1-1.442 1.164-2.348 1.791-3.72.442-.953 1.65-3.625 1.906-3.625.232-.002 1.767-.536 2.627.719zm-21.751 4.273c-.229-.084-1.27-4.911-.708-5.244 1.082-.645 1.373-.749 2.704-.749 1.333 0 1.956.104 2.372.52.687.687-.374 2.164-.79 2.581-1.206 1.185-3.349 2.974-3.578 2.892z"
      ></path>
      <path
        fill="#FFCC02"
        d="M86.063 90.604c-.249-.106-1.324-4.752-.764-5.083 1.08-.643 1.381-.713 2.686-.713 1.333 0 1.93.087 2.352.518.679.689-.361 2.121-.774 2.535-1.204 1.181-3.256 2.843-3.5 2.743z"
      ></path>
      <path
        fill="#FFCC05"
        d="M86.137 90.449c-.268-.126-1.379-4.593-.822-4.922 1.078-.64 1.39-.678 2.669-.678 1.333 0 1.904.069 2.331.514.673.693-.348 2.08-.758 2.491-1.201 1.178-3.16 2.714-3.42 2.595z"
      ></path>
      <path
        fill="#FFCC07"
        d="M86.211 90.296c-.289-.149-1.435-4.436-.879-4.762 1.076-.639 1.398-.644 2.651-.644 1.333 0 1.877.052 2.31.511.667.696-.333 2.039-.741 2.445-1.197 1.177-3.066 2.586-3.341 2.45z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M86.285 90.142c-.309-.171-1.49-4.278-.936-4.603 1.074-.637 1.406-.608 2.633-.608 1.332 0 1.851.034 2.29.507.661.7-.321 1.998-.725 2.402-1.195 1.173-2.971 2.456-3.262 2.302z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M86.358 89.987c-.327-.193-1.545-4.119-.993-4.442 1.071-.635 1.414-.572 2.615-.572 1.333 0 1.825.016 2.268.504.655.703-.307 1.956-.707 2.357-1.191 1.17-2.876 2.326-3.183 2.153z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M86.432 89.834c-.347-.214-1.6-3.962-1.051-4.282 1.07-.632 1.423-.537 2.599-.537 1.332 0 1.799-.002 2.247.501.649.706-.292 1.915-.691 2.311-1.188 1.167-2.782 2.196-3.104 2.007z"
      ></path>
      <path
        fill="#FFCD11"
        d="M86.506 89.679c-.368-.236-1.656-3.802-1.108-4.122 1.067-.63 1.431-.501 2.581-.501 1.332 0 1.773-.02 2.227.498.643.708-.281 1.873-.675 2.267-1.185 1.164-2.687 2.065-3.025 1.858z"
      ></path>
      <path
        fill="#FFCE14"
        d="M86.58 89.526c-.386-.259-1.71-3.646-1.165-3.962 1.064-.629 1.44-.466 2.562-.466 1.331 0 1.748-.037 2.206.495.637.711-.267 1.831-.658 2.223-1.181 1.161-2.591 1.935-2.945 1.71z"
      ></path>
      <path
        fill="#FFCE16"
        d="M86.654 89.372c-.407-.279-1.765-3.487-1.223-3.801 1.064-.626 1.448-.431 2.546-.431 1.331 0 1.722-.055 2.185.492.631.714-.252 1.789-.641 2.177-1.179 1.158-2.498 1.806-2.867 1.563z"
      ></path>
      <path
        fill="#FFCE19"
        d="M86.727 89.218c-.426-.302-1.82-3.329-1.279-3.641 1.061-.625 1.456-.396 2.528-.396 1.331 0 1.695-.073 2.164.489.625.718-.239 1.748-.624 2.133-1.176 1.155-2.403 1.675-2.789 1.415z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M86.802 89.064c-.446-.323-1.876-3.171-1.337-3.48 1.059-.622 1.465-.36 2.511-.36 1.331 0 1.669-.09 2.143.486.618.721-.226 1.707-.608 2.088-1.173 1.15-2.31 1.544-2.709 1.266z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M86.875 88.91c-.466-.344-1.931-3.012-1.393-3.32 1.056-.621 1.473-.325 2.492-.325 1.332 0 1.644-.108 2.123.482.612.725-.212 1.665-.591 2.043-1.17 1.149-2.215 1.416-2.631 1.12z"
      ></path>
      <path
        fill="#FFCF21"
        d="M86.949 88.756c-.486-.367-1.986-2.854-1.451-3.161 1.055-.618 1.481-.289 2.475-.289 1.331 0 1.618-.126 2.102.48.605.727-.2 1.622-.575 1.998-1.167 1.146-2.119 1.285-2.551.972z"
      ></path>
      <path
        fill="#FFCF23"
        d="M87.023 88.602c-.505-.389-2.041-2.697-1.508-3 1.053-.616 1.489-.254 2.457-.254 1.331 0 1.592-.144 2.081.477.599.73-.186 1.582-.558 1.955-1.164 1.14-2.025 1.153-2.472.822z"
      ></path>
      <path
        fill="#FFCF26"
        d="M87.097 88.448c-.525-.411-2.096-2.538-1.565-2.839 1.051-.614 1.498-.219 2.44-.219 1.331 0 1.565-.161 2.06.473.593.733-.171 1.54-.541 1.909-1.162 1.139-1.931 1.025-2.394.676z"
      ></path>
      <path
        fill="#FFD028"
        d="M87.171 88.294c-.545-.433-2.152-2.381-1.623-2.681 1.049-.612 1.506-.182 2.422-.182 1.331 0 1.54-.18 2.039.47.587.735-.158 1.498-.524 1.863-1.158 1.137-1.836.896-2.314.53z"
      ></path>
      <path
        fill="#FFD02B"
        d="M87.244 88.14c-.565-.455-2.207-2.222-1.68-2.52 1.046-.609 1.514-.147 2.404-.147 1.331 0 1.513-.197 2.018.468.58.739-.145 1.455-.508 1.818-1.153 1.134-1.739.764-2.234.381z"
      ></path>
      <path
        fill="#FFD02D"
        d="M87.318 87.985c-.584-.476-2.261-2.062-1.737-2.359 1.045-.607 1.523-.112 2.387-.112 1.331 0 1.487-.215 1.997.464.575.743-.131 1.414-.491 1.774-1.151 1.132-1.646.635-2.156.233z"
      ></path>
      <path
        fill="#FFD030"
        d="M87.392 87.832c-.604-.498-2.317-1.905-1.794-2.199 1.042-.606 1.531-.077 2.368-.077 1.332 0 1.462-.232 1.977.461.568.746-.117 1.372-.475 1.729-1.147 1.128-1.551.506-2.076.086z"
      ></path>
      <path
        fill="#FFD133"
        d="M87.466 87.678c-.624-.52-2.372-1.748-1.851-2.039 1.04-.603 1.54-.042 2.351-.042 1.331 0 1.435-.25 1.956.458.561.749-.104 1.331-.458 1.685-1.145 1.125-1.457.375-1.998-.062z"
      ></path>
      <path
        fill="#fc0"
        d="M107.461 86.758c1.208 1.763-.02 4.12.853 5.526-2.199-2.021-3.209-2.852-6.24.119.833-1.208 1.011-2.021 1.526-3.169.356-.792 1.406-3.09 1.624-3.09.198 0 1.525-.436 2.237.614z"
      ></path>
      <path
        fill="#FFCC02"
        d="M107.449 86.77c1.181 1.722.012 4.068.833 5.4-2.153-1.969-3.141-2.798-6.105.104.781-1.139.977-1.968 1.487-3.097.362-.795 1.37-3.003 1.599-3.006.202-.003 1.49-.426 2.186.599z"
      ></path>
      <path
        fill="#FFCC05"
        d="M107.436 86.782c1.152 1.682.042 4.016.812 5.273-2.106-1.917-3.074-2.745-5.971.089.732-1.069.944-1.916 1.449-3.025.368-.797 1.334-2.917 1.574-2.923.208-.005 1.456-.415 2.136.586z"
      ></path>
      <path
        fill="#FFCC07"
        d="M107.424 86.794c1.124 1.643.074 3.966.793 5.146-2.062-1.865-3.005-2.69-5.835.075.681-1.001.91-1.863 1.41-2.954.375-.799 1.298-2.829 1.549-2.839.211-.006 1.419-.404 2.083.572z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M107.411 86.806c1.096 1.602.104 3.915.773 5.021-2.016-1.814-2.939-2.636-5.702.061.632-.933.877-1.812 1.373-2.883.379-.801 1.263-2.743 1.523-2.755.216-.01 1.386-.395 2.033.556z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M107.399 86.818c1.067 1.562.136 3.863.754 4.894-1.971-1.763-2.871-2.583-5.567.046.581-.863.843-1.76 1.334-2.812.385-.803 1.227-2.655 1.497-2.671.221-.011 1.35-.384 1.982.543z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M107.386 86.83c1.04 1.521.167 3.812.735 4.767-1.926-1.711-2.804-2.528-5.434.032.531-.794.811-1.708 1.296-2.74.391-.806 1.19-2.569 1.472-2.588.226-.013 1.317-.373 1.931.529z"
      ></path>
      <path
        fill="#FFCD11"
        d="M107.374 86.843c1.011 1.48.197 3.759.715 4.639-1.88-1.658-2.736-2.473-5.299.017.481-.725.776-1.654 1.257-2.668.397-.808 1.154-2.482 1.446-2.504.231-.015 1.282-.362 1.881.516z"
      ></path>
      <path
        fill="#FFCE14"
        d="M107.361 86.855c.983 1.44.229 3.708.695 4.513-1.834-1.607-2.667-2.419-5.164.003.431-.656.744-1.603 1.221-2.597.402-.811 1.118-2.395 1.42-2.421.235-.017 1.246-.351 1.828.502z"
      ></path>
      <path
        fill="#FFCE16"
        d="M107.348 86.867c.955 1.399.26 3.657.676 4.387-1.788-1.555-2.601-2.365-5.029-.012.38-.587.709-1.551 1.181-2.526.409-.812 1.083-2.308 1.395-2.336.24-.02 1.212-.341 1.777.487z"
      ></path>
      <path
        fill="#FFCE19"
        d="M107.336 86.879c.926 1.359.292 3.605.657 4.26-1.743-1.503-2.533-2.311-4.896-.026.33-.518.678-1.498 1.144-2.454.414-.815 1.047-2.222 1.37-2.253.244-.022 1.175-.332 1.725.473z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M107.324 86.891c.897 1.319.321 3.554.637 4.133-1.697-1.452-2.465-2.257-4.761-.041.28-.449.644-1.446 1.105-2.383.421-.817 1.011-2.134 1.345-2.168.248-.024 1.14-.32 1.674.459z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M107.311 86.904c.869 1.277.352 3.502.618 4.006-1.653-1.4-2.398-2.204-4.627-.056.229-.379.61-1.393 1.068-2.31.425-.819.974-2.048 1.319-2.087.252-.024 1.105-.309 1.622.447z"
      ></path>
      <path
        fill="#FFCF21"
        d="M107.298 86.915c.841 1.238.384 3.451.599 3.88-1.606-1.349-2.33-2.148-4.494-.07.18-.31.577-1.342 1.03-2.239.432-.821.938-1.96 1.294-2.002.258-.027 1.071-.299 1.571.431z"
      ></path>
      <path
        fill="#FFCF23"
        d="M107.286 86.927c.813 1.198.415 3.401.578 3.754-1.561-1.298-2.262-2.095-4.358-.084.129-.243.544-1.29.99-2.168.438-.824.903-1.875 1.27-1.919.261-.029 1.035-.289 1.52.417z"
      ></path>
      <path
        fill="#FFCF26"
        d="M107.273 86.939c.786 1.157.446 3.349.559 3.628-1.515-1.245-2.195-2.042-4.225-.099.079-.173.51-1.237.953-2.096.443-.826.867-1.787 1.244-1.835.267-.034 1.001-.279 1.469.402z"
      ></path>
      <path
        fill="#FFD028"
        d="M107.261 86.952c.756 1.117.476 3.297.539 3.501-1.47-1.194-2.127-1.987-4.089-.114.029-.104.477-1.185.914-2.024.449-.828.831-1.701 1.217-1.751.272-.035.967-.269 1.419.388z"
      ></path>
      <path
        fill="#FFD02B"
        d="M107.248 86.963c.729 1.077.508 3.246.52 3.375-1.425-1.142-2.06-1.933-3.956-.127-.021-.036.443-1.133.876-1.954.455-.83.795-1.613 1.192-1.668.277-.037.933-.257 1.368.374z"
      ></path>
      <path
        fill="#FFD02D"
        d="M107.235 86.976c.702 1.036.54 3.194.501 3.248-1.379-1.091-1.992-1.879-3.821-.142-.072.033.41-1.082.838-1.883.46-.833.758-1.526 1.167-1.583.281-.04.897-.248 1.315.36z"
      ></path>
      <path
        fill="#FFD030"
        d="M107.223 86.987c.671.996.571 3.144.481 3.122-1.334-1.039-1.925-1.825-3.688-.157-.122.103.377-1.03.8-1.81.466-.835.723-1.44 1.142-1.501.286-.041.862-.236 1.265.346z"
      ></path>
      <path
        fill="#FFD133"
        d="M107.21 87c.645.956.602 3.092.462 2.996-1.289-.988-1.857-1.771-3.554-.171-.172.171.344-.978.762-1.74.472-.837.688-1.352 1.117-1.417.291-.044.827-.227 1.213.332z"
      ></path>
      <path
        fill="#fc0"
        d="M108.46 93.25c1.93 2.534 5.51 5.253 6.788 5.998.929.535 2.278 1.162 2.254 2.836-.047 1.906-1.023 2.44-1.557 2.976-1.07 1.069-7.161 3.533-11.042 5.253-3.952 1.743-6.812 2.65-8.788 2.976-1.325.209-2.278.767-4.254.372-1.395-.279-2.231-.418-3.184-1.255-.953-.813-1.93-1.674-2.069-3.022-.396-3.348 1.186-5.462 2.719-8.369 1.255-2.325 3.789-2.79 5.37-2.58 5.672.767 5.3-2.79 6.857-4.347 1.443-1.443 5.558-2.606 6.906-.838z"
      ></path>
      <path
        fill="#FFCC02"
        d="M108.443 93.272c1.925 2.529 5.497 5.242 6.772 5.983.928.534 2.272 1.16 2.25 2.83-.047 1.902-1.021 2.435-1.555 2.969-1.066 1.066-7.212 3.549-11.054 5.194-3.958 1.671-6.666 2.542-8.654 2.893-1.316.221-2.311.773-4.28.38-1.39-.276-2.186-.398-3.134-1.231-.949-.811-1.858-1.602-1.997-2.944-.391-3.338 1.087-5.378 2.598-8.282 1.255-2.381 3.806-2.723 5.38-2.51 5.655.779 5.233-2.893 6.787-4.447 1.437-1.436 5.542-2.597 6.887-.835z"
      ></path>
      <path
        fill="#FFCC05"
        d="M108.428 93.297c1.92 2.522 5.482 5.229 6.756 5.969.925.532 2.267 1.157 2.244 2.823-.047 1.897-1.019 2.43-1.551 2.962-1.064 1.064-7.266 3.565-11.068 5.135-3.964 1.599-6.521 2.435-8.519 2.809-1.309.233-2.343.779-4.308.388-1.383-.273-2.137-.377-3.083-1.206-.944-.807-1.788-1.53-1.924-2.866-.387-3.329.987-5.293 2.474-8.194 1.256-2.438 3.825-2.657 5.392-2.442 5.636.792 5.164-2.996 6.714-4.545 1.435-1.435 5.529-2.592 6.873-.833z"
      ></path>
      <path
        fill="#FFCC07"
        d="M108.41 93.321c1.916 2.515 5.47 5.216 6.74 5.955.923.531 2.263 1.154 2.239 2.816-.046 1.893-1.015 2.424-1.546 2.954-1.062 1.062-7.319 3.582-11.081 5.078-3.971 1.525-6.378 2.325-8.386 2.725-1.299.244-2.376.785-4.334.396-1.379-.27-2.089-.355-3.033-1.18-.94-.804-1.717-1.459-1.852-2.787-.382-3.321.888-5.209 2.352-8.107 1.256-2.495 3.842-2.59 5.402-2.373 5.618.805 5.097-3.1 6.643-4.646 1.432-1.431 5.517-2.586 6.856-.831z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M108.393 93.344c1.911 2.51 5.458 5.205 6.724 5.941.921.53 2.256 1.151 2.233 2.81-.046 1.887-1.013 2.417-1.543 2.947-1.059 1.06-7.372 3.598-11.093 5.018-3.977 1.453-6.234 2.218-8.253 2.642-1.29.256-2.408.791-4.361.404-1.372-.268-2.042-.334-2.982-1.155-.935-.801-1.646-1.388-1.779-2.71-.378-3.312.79-5.124 2.229-8.02 1.256-2.551 3.86-2.524 5.413-2.304 5.602.817 5.029-3.202 6.571-4.745 1.43-1.427 5.505-2.578 6.841-.828z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M108.376 93.368c1.907 2.504 5.445 5.192 6.708 5.927.919.528 2.251 1.148 2.228 2.802-.046 1.884-1.011 2.413-1.54 2.941-1.057 1.056-7.425 3.613-11.106 4.959-3.983 1.379-6.088 2.109-8.119 2.558-1.281.268-2.44.797-4.387.412-1.367-.264-1.995-.313-2.931-1.13-.931-.798-1.575-1.315-1.707-2.632-.374-3.302.689-5.038 2.106-7.932 1.257-2.607 3.878-2.458 5.423-2.234 5.583.83 4.961-3.304 6.5-4.844 1.427-1.424 5.493-2.573 6.825-.827z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M108.36 93.391c1.903 2.498 5.432 5.179 6.693 5.913.916.527 2.247 1.146 2.223 2.796-.045 1.879-1.008 2.406-1.535 2.934-1.055 1.054-7.479 3.63-11.119 4.9-3.99 1.308-5.945 2.002-7.985 2.476-1.273.278-2.472.802-4.414.42-1.362-.262-1.947-.293-2.881-1.105-.926-.795-1.503-1.245-1.635-2.554-.369-3.294.591-4.954 1.984-7.845 1.258-2.664 3.896-2.392 5.435-2.166 5.564.843 4.892-3.408 6.429-4.944 1.419-1.421 5.475-2.566 6.805-.825z"
      ></path>
      <path
        fill="#FFCD11"
        d="M108.344 93.415c1.897 2.492 5.418 5.167 6.676 5.899.914.525 2.24 1.143 2.217 2.789-.046 1.875-1.006 2.4-1.532 2.926-1.052 1.053-7.53 3.646-11.132 4.842-3.996 1.234-5.8 1.893-7.852 2.392-1.264.29-2.504.808-4.44.427-1.355-.259-1.9-.272-2.829-1.08-.922-.792-1.433-1.173-1.562-2.476-.366-3.285.491-4.869 1.86-7.758 1.258-2.72 3.913-2.325 5.445-2.096 5.547.855 4.825-3.511 6.356-5.043 1.419-1.417 5.466-2.56 6.793-.822z"
      ></path>
      <path
        fill="#FFCE14"
        d="M108.326 93.438c1.893 2.486 5.406 5.155 6.66 5.885.912.524 2.235 1.14 2.212 2.783-.046 1.87-1.003 2.395-1.528 2.92-1.05 1.049-7.584 3.662-11.145 4.783-4.003 1.161-5.656 1.784-7.718 2.307-1.256.303-2.537.815-4.467.436-1.351-.255-1.853-.25-2.779-1.054-.917-.79-1.362-1.102-1.49-2.398-.36-3.276.394-4.784 1.738-7.671 1.259-2.778 3.931-2.259 5.456-2.026 5.529.867 4.757-3.615 6.285-5.144 1.416-1.414 5.453-2.554 6.776-.821z"
      ></path>
      <path
        fill="#FFCE16"
        d="M108.31 93.462c1.889 2.48 5.393 5.143 6.644 5.871.91.523 2.23 1.138 2.208 2.776-.046 1.866-1.001 2.389-1.525 2.912-1.047 1.047-7.636 3.679-11.158 4.724-4.008 1.089-5.511 1.677-7.584 2.225-1.247.315-2.57.821-4.494.444-1.345-.253-1.805-.23-2.729-1.029-.912-.786-1.29-1.03-1.417-2.32-.356-3.267.293-4.699 1.616-7.583 1.258-2.833 3.949-2.192 5.466-1.958 5.512.881 4.689-3.717 6.214-5.242 1.411-1.412 5.439-2.55 6.759-.82z"
      ></path>
      <path
        fill="#FFCE19"
        d="M108.293 93.485c1.884 2.475 5.38 5.13 6.628 5.857.908.522 2.226 1.135 2.202 2.77-.045 1.861-.998 2.383-1.52 2.905-1.045 1.044-7.69 3.694-11.17 4.665-4.015 1.016-5.367 1.568-7.451 2.141-1.239.327-2.603.828-4.521.453-1.339-.25-1.758-.209-2.678-1.005-.909-.783-1.219-.958-1.345-2.242-.352-3.258.195-4.615 1.494-7.497 1.258-2.89 3.965-2.125 5.476-1.888 5.495.893 4.621-3.821 6.142-5.342 1.408-1.407 5.426-2.541 6.743-.817z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M108.276 93.509c1.88 2.469 5.367 5.118 6.613 5.842.905.521 2.219 1.133 2.196 2.764-.046 1.856-.997 2.377-1.517 2.898-1.042 1.042-7.743 3.71-11.184 4.607-4.021.942-5.222 1.46-7.316 2.057-1.23.338-2.635.833-4.547.46-1.334-.248-1.711-.188-2.627-.979-.904-.78-1.148-.888-1.272-2.165-.348-3.249.095-4.529 1.37-7.409 1.26-2.947 3.984-2.059 5.488-1.819 5.477.905 4.554-3.923 6.071-5.441 1.403-1.404 5.411-2.535 6.725-.815z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M108.26 93.532c1.875 2.462 5.354 5.106 6.597 5.829.904.52 2.213 1.129 2.191 2.756-.045 1.853-.994 2.372-1.514 2.892-1.039 1.039-7.794 3.726-11.196 4.547-4.026.87-5.077 1.352-7.184 1.974-1.221.351-2.665.839-4.572.468-1.328-.245-1.664-.167-2.577-.954-.899-.777-1.078-.816-1.2-2.086-.344-3.239-.005-4.445 1.248-7.322 1.259-3.004 4-1.993 5.498-1.75 5.458.918 4.487-4.028 6-5.541 1.4-1.399 5.398-2.529 6.709-.813z"
      ></path>
      <path
        fill="#FFCF21"
        d="M108.243 93.556c1.87 2.457 5.341 5.094 6.58 5.814.902.518 2.208 1.127 2.187 2.75-.045 1.849-.992 2.367-1.51 2.885-1.037 1.037-7.849 3.742-11.209 4.488-4.033.797-4.934 1.245-7.05 1.891-1.213.361-2.698.844-4.599.476-1.323-.241-1.617-.146-2.526-.929-.895-.774-1.007-.744-1.128-2.008-.34-3.231-.103-4.36 1.125-7.234 1.26-3.061 4.019-1.927 5.508-1.682 5.442.931 4.418-4.129 5.928-5.64 1.398-1.397 5.386-2.524 6.694-.811z"
      ></path>
      <path
        fill="#FFCF23"
        d="M108.226 93.58c1.866 2.451 5.328 5.081 6.564 5.8.9.517 2.203 1.125 2.181 2.743-.045 1.843-.99 2.361-1.507 2.877-1.034 1.034-7.901 3.759-11.222 4.431-4.04.725-4.788 1.136-6.917 1.808-1.204.373-2.73.85-4.625.484-1.318-.239-1.57-.126-2.476-.904-.891-.771-.935-.672-1.055-1.93-.335-3.222-.202-4.275 1.002-7.148 1.261-3.116 4.038-1.86 5.519-1.611 5.424.943 4.351-4.233 5.858-5.74 1.395-1.395 5.374-2.519 6.678-.81z"
      ></path>
      <path
        fill="#FFCF26"
        d="M108.21 93.604c1.861 2.445 5.315 5.069 6.548 5.786.897.516 2.198 1.122 2.175 2.736-.044 1.839-.986 2.354-1.502 2.871-1.032 1.031-7.955 3.774-11.235 4.37-4.045.652-4.644 1.029-6.783 1.724-1.196.385-2.763.857-4.652.493-1.312-.236-1.522-.105-2.425-.88-.886-.767-.865-.601-.982-1.851-.332-3.213-.302-4.19.879-7.06 1.26-3.174 4.055-1.794 5.529-1.543 5.406.956 4.283-4.336 5.785-5.838 1.392-1.391 5.362-2.514 6.663-.808z"
      ></path>
      <path
        fill="#FFD028"
        d="M108.192 93.628c1.858 2.438 5.303 5.055 6.534 5.772.894.514 2.192 1.118 2.17 2.729-.045 1.835-.985 2.349-1.499 2.863-1.03 1.03-8.007 3.791-11.249 4.312-4.052.579-4.499.92-6.648 1.641-1.188.396-2.796.862-4.68.499-1.307-.232-1.474-.083-2.374-.854-.882-.765-.793-.529-.91-1.774-.327-3.204-.401-4.105.758-6.973 1.26-3.23 4.071-1.728 5.54-1.473 5.388.968 4.215-4.44 5.714-5.938 1.387-1.387 5.347-2.506 6.644-.804z"
      ></path>
      <path
        fill="#FFD02B"
        d="M108.176 93.651c1.852 2.433 5.289 5.043 6.516 5.758.894.513 2.188 1.116 2.165 2.723-.044 1.831-.981 2.344-1.495 2.857-1.027 1.026-8.061 3.807-11.261 4.253-4.058.506-4.354.812-6.515 1.557-1.178.408-2.828.868-4.706.508-1.301-.23-1.427-.063-2.323-.829-.877-.762-.722-.458-.837-1.696-.324-3.195-.5-4.02.633-6.886 1.262-3.286 4.09-1.661 5.551-1.404 5.371.982 4.147-4.542 5.642-6.038 1.385-1.384 5.336-2.5 6.63-.803z"
      ></path>
      <path
        fill="#FFD02D"
        d="M108.159 93.675c1.848 2.426 5.276 5.031 6.501 5.743.89.513 2.182 1.114 2.159 2.717-.044 1.826-.979 2.338-1.491 2.85-1.025 1.024-8.114 3.823-11.273 4.194-4.064.434-4.21.704-6.382 1.474-1.169.42-2.86.875-4.732.517-1.296-.228-1.38-.042-2.273-.805-.872-.759-.652-.386-.764-1.618-.319-3.186-.599-3.936.511-6.799 1.262-3.343 4.107-1.595 5.562-1.335 5.353.994 4.08-4.646 5.571-6.137 1.379-1.38 5.32-2.494 6.611-.801z"
      ></path>
      <path
        fill="#FFD030"
        d="M108.143 93.698c1.843 2.421 5.263 5.02 6.485 5.73.888.511 2.176 1.11 2.154 2.709-.045 1.822-.978 2.332-1.488 2.843-1.022 1.022-8.167 3.839-11.287 4.136-4.069.361-4.065.596-6.248 1.391-1.161.431-2.892.88-4.759.524-1.29-.225-1.332-.021-2.221-.779-.868-.756-.581-.314-.693-1.54-.314-3.177-.698-3.851.389-6.711 1.262-3.399 4.125-1.529 5.572-1.266 5.335 1.006 4.011-4.749 5.5-6.236 1.376-1.378 5.307-2.489 6.596-.801z"
      ></path>
      <path
        fill="#FFD133"
        d="M108.125 93.722c1.839 2.414 5.251 5.007 6.47 5.715.886.51 2.171 1.108 2.148 2.703-.044 1.817-.975 2.326-1.484 2.836-1.019 1.019-8.22 3.855-11.299 4.076-4.077.288-3.921.487-6.114 1.308-1.153.443-2.925.886-4.785.531-1.285-.221-1.285 0-2.171-.753-.864-.754-.51-.244-.621-1.462-.311-3.168-.797-3.766.266-6.624 1.263-3.457 4.143-1.462 5.583-1.197 5.317 1.019 3.944-4.852 5.429-6.336 1.372-1.373 5.294-2.481 6.578-.797z"
      ></path>
      <path
        fill="#995900"
        d="M26.657 90.065c-2.093 1.511-7.393 1.371-8.741 3.138-1.325 1.767.047 4.324.023 9.066 0 2.023-.348 3.558-.581 4.789-.325 1.558-.535 2.651.116 3.766 1.187 1.977 3.091 2.465 13.995 4.743 5.834 1.208 11.344 4.347 15.04 4.649 3.696.279 4.487-.953 6.742-2.952 2.231-1.999 2.952-1.372 2.882-5.765-.069-4.37-2.882-5.672-6.067-10.717-3.185-5.044-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.186 1.208-2.651 4.276-4.742 5.787z"
      ></path>
      <path
        fill="#9E5E00"
        d="M26.689 90.158c-2.065 1.518-7.256 1.223-8.737 3.071-1.341 1.749.074 4.287.032 9.026-.008 2.011-.372 3.513-.625 4.803-.335 1.573-.542 2.647.113 3.751 1.222 1.99 3.129 2.3 14.03 4.574 5.832 1.207 11.153 4.296 14.963 4.557 3.611.255 4.379-.913 6.607-2.893 2.226-2 2.913-1.381 2.859-5.62-.024-4.365-2.682-5.602-5.866-10.646-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.209-2.631 4.351-4.708 5.881z"
      ></path>
      <path
        fill="#A36400"
        d="M26.723 90.251c-2.038 1.525-7.12 1.075-8.733 3.004-1.357 1.729.101 4.249.04 8.985-.016 2.001-.395 3.47-.669 4.818-.343 1.588-.549 2.646.11 3.736 1.259 2.003 3.168 2.136 14.065 4.407 5.828 1.205 10.961 4.245 14.885 4.464 3.527.232 4.272-.874 6.472-2.834 2.223-2.001 2.876-1.39 2.839-5.475.02-4.361-2.48-5.531-5.666-10.575-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186s-2.616 4.426-4.676 5.974z"
      ></path>
      <path
        fill="#A86A00"
        d="M26.757 90.344c-2.012 1.532-6.984.925-8.73 2.936-1.374 1.711.127 4.212.048 8.944-.025 1.991-.419 3.428-.714 4.834-.354 1.603-.556 2.644.106 3.721 1.297 2.018 3.207 1.972 14.103 4.24 5.824 1.202 10.769 4.193 14.807 4.371 3.441.209 4.166-.835 6.337-2.775 2.217-2.002 2.837-1.399 2.816-5.329.066-4.356-2.28-5.46-5.464-10.504-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.185 1.208-2.597 4.499-4.641 6.066z"
      ></path>
      <path
        fill="#AD7000"
        d="M26.791 90.437c-1.985 1.539-6.849.777-8.727 2.869-1.39 1.693.154 4.175.056 8.904-.033 1.981-.441 3.384-.757 4.849-.362 1.618-.563 2.642.102 3.707 1.334 2.031 3.245 1.808 14.138 4.072 5.821 1.2 10.577 4.142 14.729 4.277 3.357.186 4.059-.795 6.203-2.715 2.212-2.003 2.798-1.409 2.793-5.183.112-4.353-2.079-5.389-5.263-10.434-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.184 1.208-2.579 4.573-4.606 6.159z"
      ></path>
      <path
        fill="#B27500"
        d="M26.825 90.53c-1.959 1.545-6.713.627-8.724 2.802-1.406 1.673.181 4.137.064 8.861-.041 1.971-.465 3.342-.802 4.864-.371 1.634-.569 2.639.1 3.691 1.372 2.046 3.283 1.645 14.174 3.905 5.818 1.197 10.385 4.092 14.651 4.185 3.272.162 3.952-.756 6.067-2.657 2.208-2.005 2.76-1.418 2.772-5.039.157-4.347-1.877-5.318-5.062-10.362-3.186-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.21-2.561 4.649-4.572 6.254z"
      ></path>
      <path
        fill="#B77B00"
        d="M26.859 90.622c-1.932 1.554-6.577.479-8.72 2.734-1.423 1.655.207 4.1.072 8.822-.049 1.959-.488 3.299-.846 4.879-.381 1.648-.576 2.637.095 3.676 1.409 2.06 3.322 1.481 14.211 3.737 5.814 1.196 10.193 4.042 14.573 4.092 3.188.14 3.845-.716 5.933-2.596 2.204-2.007 2.723-1.428 2.75-4.894.203-4.342-1.676-5.247-4.861-10.292-3.186-5.043-3.696-5.974-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.046-2.976.977-4.162 2.186-1.185 1.21-2.545 4.725-4.539 6.346z"
      ></path>
      <path
        fill="#BC8100"
        d="M26.892 90.716c-1.905 1.56-6.441.33-8.716 2.667-1.439 1.636.233 4.063.08 8.782-.057 1.948-.511 3.254-.89 4.893-.39 1.664-.583 2.634.092 3.661 1.446 2.074 3.36 1.317 14.247 3.57 5.811 1.193 10.002 3.989 14.495 3.998 3.103.117 3.738-.676 5.798-2.537 2.199-2.007 2.684-1.436 2.728-4.748.248-4.338-1.475-5.175-4.66-10.22s-3.696-5.975-5.812-9.322c-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.185 1.209-2.527 4.797-4.506 6.439z"
      ></path>
      <path
        fill="#C18700"
        d="M26.926 90.808c-1.878 1.567-6.304.182-8.713 2.6-1.455 1.618.261 4.026.089 8.74-.065 1.939-.535 3.212-.935 4.909-.399 1.679-.59 2.632.089 3.646 1.483 2.087 3.398 1.153 14.282 3.403 5.806 1.19 9.81 3.938 14.417 3.905 3.018.093 3.631-.636 5.664-2.478 2.194-2.008 2.645-1.446 2.705-4.603.292-4.333-1.274-5.105-4.458-10.149-3.186-5.044-3.696-5.975-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.047-2.976.976-4.162 2.186-1.186 1.208-2.51 4.872-4.472 6.531z"
      ></path>
      <path
        fill="#C68C00"
        d="M26.959 90.901c-1.85 1.574-6.167.033-8.709 2.531-1.471 1.6.288 3.989.097 8.7-.074 1.929-.558 3.169-.979 4.924-.409 1.694-.598 2.63.085 3.63 1.521 2.102 3.438.99 14.319 3.236 5.804 1.188 9.618 3.887 14.339 3.813 2.933.07 3.524-.599 5.528-2.419 2.189-2.009 2.606-1.455 2.684-4.458.338-4.328-1.073-5.034-4.258-10.079-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.186-1.185 1.21-2.493 4.948-4.439 6.626z"
      ></path>
      <path
        fill="#CC9200"
        d="M26.993 90.994c-1.825 1.581-6.032-.116-8.706 2.465-1.488 1.581.313 3.952.104 8.659-.082 1.917-.582 3.127-1.023 4.939-.419 1.708-.604 2.628.081 3.615 1.558 2.115 3.476.825 14.355 3.068 5.8 1.186 9.426 3.836 14.262 3.719 2.847.046 3.417-.558 5.393-2.359 2.186-2.011 2.569-1.464 2.662-4.312.384-4.324-.871-4.963-4.057-10.007-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.185s-2.474 5.022-4.404 6.718z"
      ></path>
      <path
        fill="#D19800"
        d="M27.027 91.088c-1.798 1.588-5.896-.264-8.702 2.397-1.504 1.562.34 3.914.113 8.618-.089 1.907-.604 3.083-1.067 4.955-.428 1.724-.611 2.625.078 3.6 1.595 2.131 3.514.662 14.39 2.901 5.797 1.184 9.235 3.785 14.184 3.626 2.763.023 3.311-.518 5.259-2.299 2.181-2.013 2.53-1.475 2.64-4.167.429-4.32-.67-4.893-3.856-9.938-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186s-2.458 5.096-4.372 6.811z"
      ></path>
      <path
        fill="#D69E00"
        d="M27.06 91.181c-1.771 1.595-5.76-.414-8.698 2.329-1.521 1.544.367 3.877.12 8.578-.097 1.897-.626 3.04-1.111 4.97-.437 1.74-.618 2.623.075 3.585 1.631 2.145 3.551.498 14.426 2.734 5.793 1.181 9.043 3.733 14.106 3.533 2.678 0 3.204-.479 5.123-2.241 2.177-2.013 2.493-1.483 2.618-4.021.475-4.314-.469-4.821-3.654-9.866-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.185s-2.441 5.169-4.338 6.904z"
      ></path>
      <path
        fill="#DBA300"
        d="M27.095 91.273c-1.745 1.603-5.625-.562-8.696 2.262-1.536 1.525.395 3.84.129 8.537-.104 1.886-.65 2.997-1.154 4.984-.447 1.755-.626 2.62.071 3.57 1.668 2.157 3.59.333 14.463 2.566 5.789 1.178 8.851 3.682 14.028 3.44 2.592-.023 3.097-.439 4.988-2.182 2.172-2.015 2.454-1.493 2.596-3.876.519-4.311-.27-4.751-3.454-9.796-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.186-1.185 1.211-2.423 5.247-4.303 6.999z"
      ></path>
      <path
        fill="#E0A900"
        d="M27.128 91.366c-1.718 1.609-5.488-.711-8.692 2.195-1.553 1.507.42 3.803.137 8.496-.114 1.876-.673 2.955-1.199 5-.455 1.77-.632 2.618.068 3.555 1.706 2.171 3.628.17 14.499 2.399 5.786 1.177 8.659 3.632 13.95 3.348 2.509-.047 2.99-.399 4.854-2.122 2.167-2.016 2.415-1.502 2.573-3.732.565-4.305-.067-4.68-3.253-9.724-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.185 1.209-2.405 5.318-4.27 7.089z"
      ></path>
      <path
        fill="#E5AF00"
        d="M27.162 91.459c-1.691 1.616-5.353-.859-8.689 2.128-1.569 1.488.447 3.766.146 8.455-.123 1.865-.697 2.912-1.244 5.015-.465 1.785-.639 2.616.063 3.541 1.744 2.184 3.667.005 14.535 2.231 5.783 1.174 8.468 3.58 13.873 3.254 2.423-.07 2.882-.361 4.718-2.063 2.162-2.017 2.377-1.512 2.552-3.586.609-4.3.132-4.609-3.052-9.653-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.183 1.209-2.386 5.393-4.234 7.182z"
      ></path>
      <path
        fill="#EAB500"
        d="M27.196 91.553c-1.665 1.622-5.217-1.009-8.685 2.06-1.585 1.469.474 3.728.154 8.415-.131 1.855-.72 2.868-1.288 5.03-.474 1.8-.647 2.614.061 3.524 1.78 2.2 3.706-.158 14.571 2.064 5.779 1.172 8.276 3.529 13.794 3.162 2.338-.093 2.775-.32 4.584-2.004 2.157-2.018 2.338-1.52 2.529-3.44.656-4.296.334-4.539-2.85-9.583-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.161 2.186-1.186 1.209-2.372 5.467-4.203 7.276z"
      ></path>
      <path
        fill="#EFBA00"
        d="M27.229 91.646c-1.638 1.63-5.081-1.157-8.682 1.992-1.602 1.451.502 3.692.162 8.375-.138 1.845-.744 2.826-1.331 5.045-.484 1.815-.654 2.611.057 3.509 1.817 2.213 3.743-.321 14.607 1.896 5.775 1.17 8.083 3.478 13.715 3.069 2.254-.116 2.669-.281 4.45-1.944 2.153-2.02 2.301-1.53 2.508-3.296.701-4.291.535-4.466-2.649-9.511-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.185 1.21-2.354 5.543-4.169 7.37z"
      ></path>
      <path
        fill="#F4C000"
        d="M27.263 91.739c-1.61 1.635-4.944-1.307-8.678 1.924-1.618 1.433.528 3.654.169 8.334-.146 1.834-.768 2.782-1.376 5.061-.493 1.83-.661 2.609.053 3.494 1.855 2.227 3.782-.486 14.644 1.729 5.772 1.167 7.892 3.427 13.639 2.976 2.168-.14 2.562-.242 4.314-1.885 2.147-2.02 2.262-1.54 2.485-3.15.747-4.287.736-4.396-2.448-9.441-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.209-2.335 5.616-4.134 7.462z"
      ></path>
      <path
        fill="#F9C600"
        d="M27.296 91.831c-1.584 1.644-4.808-1.455-8.674 1.857-1.633 1.413.555 3.618.179 8.294-.156 1.823-.791 2.739-1.421 5.075-.502 1.845-.667 2.606.05 3.479 1.892 2.241 3.821-.65 14.68 1.562 5.768 1.165 7.7 3.375 13.56 2.884 2.085-.163 2.456-.203 4.18-1.826 2.144-2.022 2.224-1.548 2.463-3.006.792-4.281.938-4.325-2.247-9.37-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.186 1.21-2.32 5.691-4.103 7.555z"
      ></path>
      <path
        fill="#fc0"
        d="M27.33 91.924c-1.557 1.65-4.672-1.604-8.67 1.79-1.65 1.394.581 3.58.186 8.252-.163 1.813-.813 2.697-1.464 5.091-.512 1.86-.675 2.604.046 3.464 1.93 2.255 3.859-.813 14.715 1.395 5.765 1.162 7.508 3.324 13.483 2.79 1.999-.186 2.347-.162 4.045-1.767 2.138-2.022 2.184-1.558 2.441-2.859.836-4.277 1.139-4.254-2.046-9.298-3.186-5.044-3.696-5.975-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.047-2.976.976-4.162 2.185-1.185 1.209-2.301 5.765-4.068 7.647zm1.007 1.816c-1.381 1.466-5.902-.439-8.036 1.173-1.528 1.13.774 2.553.46 6.739-.125 1.59-1.234 1.883-.774 4.081.356 1.653.733 1.611 1.361 2.365 1.715 2.009 1.318.544 11.092 2.511 5.169 1.047 6.76 2.993 12.139 2.512 1.799-.167 2.135-.146 3.642-1.59 1.925-1.8.942-1.424 1.15-2.574.733-3.83.147-4.5-2.721-9.042-2.867-4.542-2.616-4.793-4.499-7.785-1.884-2.952-4.479-8.33-6.635-8.372-1.694-.042-2.679.879-3.746 1.967-1.068 1.089-1.863 6.342-3.433 8.015z"
      ></path>
      <path
        fill="#FFCC02"
        d="M28.432 93.771c-1.441 1.518-6.006-.386-8.091 1.196-1.518 1.134.832 2.599.519 6.677-.129 1.58-1.205 1.897-.793 4.079.318 1.644.76 1.594 1.399 2.324 1.836 1.98 1.509.59 11.016 2.5 5.139 1.037 6.72 2.976 12.066 2.497 1.789-.166 2.092-.149 3.602-1.565 1.893-1.746.923-1.384 1.102-2.602.667-3.805.143-4.514-2.644-8.926-2.851-4.515-2.629-4.745-4.501-7.721-1.872-2.933-4.423-8.332-6.566-8.373-1.685-.042-2.663.873-3.723 1.955-1.063 1.082-1.824 6.297-3.386 7.959z"
      ></path>
      <path
        fill="#FFCC05"
        d="M28.528 93.799c-1.5 1.571-6.112-.333-8.146 1.221-1.507 1.138.891 2.645.579 6.615-.134 1.57-1.176 1.91-.813 4.076.281 1.636.791 1.578 1.438 2.286 1.956 1.949 1.7.635 10.94 2.488 5.109 1.027 6.681 2.957 11.993 2.481 1.778-.164 2.048-.152 3.562-1.54 1.862-1.691.905-1.346 1.053-2.628.602-3.783.14-4.529-2.567-8.814-2.835-4.488-2.642-4.699-4.503-7.656-1.86-2.916-4.368-8.334-6.498-8.375-1.675-.041-2.647.868-3.702 1.944-1.055 1.077-1.782 6.254-3.336 7.902z"
      ></path>
      <path
        fill="#FFCC07"
        d="M28.622 93.829c-1.559 1.624-6.216-.279-8.2 1.245-1.498 1.143.949 2.69.638 6.552-.137 1.562-1.146 1.925-.832 4.075.244 1.626.819 1.561 1.477 2.245 2.076 1.92 1.89.681 10.864 2.478 5.079 1.016 6.641 2.939 11.922 2.466 1.768-.162 2.005-.155 3.521-1.515 1.83-1.638.886-1.307 1.003-2.656.537-3.758.136-4.543-2.49-8.7-2.818-4.46-2.655-4.651-4.505-7.591-1.849-2.898-4.313-8.335-6.43-8.376-1.665-.041-2.63.863-3.679 1.932s-1.742 6.209-3.289 7.845z"
      ></path>
      <path
        fill="#FFCD0A"
        d="M28.717 93.859c-1.618 1.676-6.321-.226-8.254 1.269-1.488 1.148 1.007 2.736.697 6.491-.142 1.553-1.117 1.938-.853 4.072.208 1.618.848 1.543 1.516 2.205 2.195 1.891 2.08.727 10.788 2.467 5.049 1.007 6.602 2.921 11.849 2.452 1.756-.16 1.962-.158 3.481-1.491 1.798-1.583.868-1.267.954-2.681.472-3.736.131-4.559-2.413-8.586-2.802-4.434-2.667-4.605-4.507-7.526-1.838-2.881-4.258-8.337-6.362-8.379-1.654-.041-2.615.859-3.656 1.92-1.042 1.061-1.7 6.162-3.24 7.787z"
      ></path>
      <path
        fill="#FFCD0C"
        d="M28.813 93.888c-1.676 1.729-6.427-.173-8.309 1.293-1.478 1.151 1.063 2.781.755 6.427-.145 1.543-1.088 1.952-.871 4.07.169 1.609.876 1.527 1.555 2.166 2.315 1.861 2.269.772 10.71 2.455 5.021.997 6.563 2.904 11.778 2.437 1.745-.158 1.919-.161 3.441-1.465 1.766-1.529.849-1.229.904-2.71.407-3.711.129-4.572-2.334-8.472-2.787-4.406-2.682-4.558-4.509-7.461-1.828-2.863-4.203-8.34-6.294-8.381-1.646-.04-2.6.854-3.635 1.909s-1.659 6.121-3.191 7.732z"
      ></path>
      <path
        fill="#FFCD0F"
        d="M28.908 93.917c-1.736 1.783-6.531-.119-8.363 1.319-1.467 1.156 1.123 2.827.814 6.365-.148 1.533-1.058 1.965-.89 4.067.133 1.6.905 1.51 1.594 2.126 2.435 1.833 2.461.817 10.635 2.443 4.99.987 6.523 2.886 11.705 2.422 1.735-.156 1.876-.164 3.401-1.44 1.735-1.475.83-1.189.855-2.737.341-3.687.125-4.587-2.258-8.358-2.77-4.379-2.694-4.51-4.511-7.396-1.816-2.845-4.147-8.341-6.226-8.381-1.633-.041-2.583.847-3.611 1.897-1.032 1.049-1.622 6.075-3.145 7.673z"
      ></path>
      <path
        fill="#FFCD11"
        d="M29.002 93.946c-1.795 1.836-6.637-.066-8.417 1.342-1.458 1.161 1.181 2.873.874 6.303-.153 1.524-1.029 1.979-.91 4.066.096 1.59.935 1.492 1.633 2.085 2.554 1.802 2.651.863 10.558 2.432 4.96.977 6.485 2.868 11.632 2.407 1.725-.155 1.833-.167 3.361-1.415 1.703-1.421.812-1.151.806-2.764.276-3.664.121-4.603-2.182-8.245-2.754-4.352-2.707-4.464-4.513-7.332-1.804-2.828-4.091-8.343-6.157-8.383-1.625-.041-2.566.842-3.589 1.885-1.023 1.046-1.579 6.034-3.096 7.619z"
      ></path>
      <path
        fill="#FFCE14"
        d="M29.097 93.975c-1.854 1.89-6.741-.013-8.473 1.367-1.447 1.165 1.239 2.918.933 6.241-.157 1.515-.999 1.993-.929 4.063.059 1.582.963 1.476 1.672 2.046 2.673 1.773 2.841.908 10.482 2.421 4.931.967 6.446 2.85 11.56 2.392 1.714-.152 1.79-.168 3.321-1.389 1.671-1.368.793-1.112.756-2.792.211-3.64.118-4.616-2.105-8.131-2.737-4.324-2.72-4.416-4.513-7.266-1.793-2.81-4.037-8.346-6.089-8.386-1.614-.04-2.551.837-3.568 1.873-1.016 1.038-1.537 5.989-3.047 7.561z"
      ></path>
      <path
        fill="#FFCE16"
        d="M29.192 94.005c-1.913 1.943-6.846.041-8.526 1.391-1.438 1.169 1.297 2.964.991 6.179-.16 1.505-.969 2.006-.948 4.061.021 1.574.992 1.459 1.71 2.006 2.793 1.744 3.032.955 10.406 2.411 4.9.957 6.405 2.832 11.487 2.376 1.703-.15 1.746-.172 3.28-1.364 1.64-1.313.775-1.073.708-2.818.146-3.616.115-4.632-2.026-8.017-2.723-4.298-2.733-4.37-4.516-7.202-1.782-2.792-3.982-8.348-6.021-8.388-1.604-.039-2.535.832-3.545 1.862-1.011 1.03-1.498 5.944-3 7.503z"
      ></path>
      <path
        fill="#FFCE19"
        d="M29.287 94.034c-1.972 1.996-6.951.094-8.58 1.416-1.428 1.174 1.354 3.01 1.051 6.117-.165 1.496-.94 2.02-.968 4.059-.016 1.564 1.021 1.441 1.75 1.966 2.913 1.713 3.221 1 10.33 2.398 4.87.947 6.367 2.814 11.415 2.361 1.693-.148 1.704-.174 3.24-1.339 1.608-1.258.757-1.035.658-2.845.081-3.593.111-4.646-1.95-7.904-2.706-4.271-2.747-4.322-4.517-7.136-1.771-2.776-3.927-8.349-5.954-8.389-1.594-.04-2.519.827-3.523 1.85-1.004 1.024-1.457 5.9-2.952 7.446z"
      ></path>
      <path
        fill="#FFCE1C"
        d="M29.383 94.064c-2.032 2.048-7.056.147-8.636 1.439-1.417 1.178 1.414 3.056 1.11 6.055-.167 1.485-.91 2.033-.987 4.056-.053 1.556 1.05 1.425 1.788 1.926 3.034 1.685 3.412 1.046 10.254 2.388 4.841.937 6.327 2.796 11.342 2.347 1.683-.146 1.661-.177 3.2-1.314 1.577-1.205.739-.995.61-2.872.016-3.569.106-4.662-1.873-7.79-2.689-4.243-2.759-4.275-4.52-7.072-1.759-2.757-3.87-8.351-5.885-8.391-1.584-.039-2.503.822-3.501 1.839-.996 1.017-1.416 5.854-2.902 7.389z"
      ></path>
      <path
        fill="#FFCF1E"
        d="M29.477 94.092c-2.089 2.102-7.161.201-8.69 1.464-1.407 1.183 1.472 3.101 1.168 5.992-.171 1.478-.881 2.048-1.006 4.056-.09 1.545 1.078 1.407 1.827 1.886 3.153 1.655 3.602 1.092 10.177 2.375 4.81.928 6.287 2.779 11.271 2.333 1.67-.145 1.617-.181 3.159-1.29 1.545-1.151.72-.957.561-2.899-.051-3.544.102-4.675-1.797-7.675-2.672-4.217-2.771-4.229-4.521-7.009-1.749-2.739-3.815-8.353-5.817-8.392-1.574-.039-2.488.816-3.478 1.827-.989 1.012-1.375 5.811-2.854 7.332z"
      ></path>
      <path
        fill="#FFCF21"
        d="M29.572 94.122c-2.148 2.155-7.266.253-8.744 1.489-1.397 1.187 1.529 3.146 1.228 5.93-.176 1.467-.851 2.062-1.026 4.053-.128 1.537 1.106 1.39 1.866 1.846 3.272 1.626 3.792 1.137 10.101 2.365 4.781.917 6.248 2.761 11.199 2.317 1.659-.142 1.574-.183 3.119-1.264 1.513-1.097.701-.918.511-2.926-.116-3.521.099-4.69-1.72-7.562-2.657-4.19-2.785-4.181-4.522-6.942-1.737-2.723-3.76-8.356-5.749-8.395-1.564-.038-2.471.811-3.456 1.815-.985 1.003-1.335 5.765-2.807 7.274z"
      ></path>
      <path
        fill="#FFCF23"
        d="M29.667 94.151c-2.208 2.208-7.371.307-8.798 1.514-1.388 1.19 1.586 3.192 1.286 5.867-.181 1.458-.822 2.074-1.046 4.05-.164 1.527 1.137 1.374 1.905 1.806 3.393 1.597 3.983 1.183 10.025 2.354 4.751.908 6.209 2.743 11.126 2.301 1.65-.14 1.531-.186 3.08-1.238 1.481-1.042.683-.879.462-2.954-.181-3.498.096-4.704-1.643-7.447-2.64-4.163-2.797-4.135-4.524-6.878-1.727-2.704-3.705-8.357-5.68-8.396-1.555-.039-2.456.806-3.434 1.803-.977.998-1.294 5.723-2.759 7.218z"
      ></path>
      <path
        fill="#FFCF26"
        d="M29.763 94.181c-2.268 2.261-7.477.36-8.854 1.538-1.377 1.195 1.646 3.237 1.346 5.805-.184 1.448-.793 2.088-1.065 4.047-.202 1.52 1.165 1.357 1.944 1.768 3.512 1.566 4.173 1.227 9.948 2.342 4.721.897 6.169 2.726 11.054 2.288 1.639-.139 1.487-.189 3.039-1.214 1.45-.988.665-.839.412-2.979-.246-3.475.092-4.72-1.564-7.334-2.625-4.136-2.812-4.087-4.527-6.813-1.715-2.687-3.649-8.359-5.612-8.398-1.544-.038-2.44.801-3.412 1.792-.971.988-1.252 5.675-2.709 7.158z"
      ></path>
      <path
        fill="#FFD028"
        d="M29.858 94.21c-2.326 2.314-7.582.414-8.908 1.562-1.367 1.2 1.704 3.283 1.405 5.743-.188 1.438-.764 2.102-1.085 4.046-.237 1.511 1.195 1.339 1.984 1.726 3.632 1.538 4.363 1.274 9.872 2.332 4.691.886 6.13 2.707 10.981 2.271 1.628-.136 1.445-.191 3-1.188 1.418-.936.646-.801.363-3.008-.312-3.45.088-4.734-1.488-7.22-2.609-4.109-2.824-4.042-4.528-6.749-1.704-2.67-3.594-8.361-5.544-8.399-1.534-.038-2.424.795-3.389 1.78-.967.984-1.215 5.634-2.663 7.104z"
      ></path>
      <path
        fill="#FFD02B"
        d="M29.952 94.239c-2.385 2.367-7.686.467-8.961 1.586-1.358 1.204 1.761 3.329 1.463 5.68-.191 1.43-.733 2.116-1.103 4.043-.275 1.502 1.223 1.323 2.022 1.688 3.751 1.508 4.553 1.319 9.795 2.319 4.661.878 6.09 2.69 10.909 2.257 1.618-.135 1.401-.195 2.959-1.164 1.386-.881.627-.762.313-3.034-.375-3.427.086-4.749-1.41-7.107-2.593-4.081-2.837-3.994-4.53-6.683-1.693-2.652-3.54-8.363-5.477-8.401-1.524-.038-2.408.79-3.367 1.768-.957.979-1.171 5.591-2.613 7.048z"
      ></path>
      <path
        fill="#FFD02D"
        d="M30.047 94.269c-2.444 2.419-7.791.52-9.015 1.61-1.348 1.208 1.819 3.374 1.522 5.618-.195 1.419-.705 2.129-1.123 4.042-.312 1.492 1.251 1.306 2.061 1.646 3.871 1.479 4.744 1.366 9.72 2.309 4.631.867 6.051 2.671 10.836 2.242 1.607-.133 1.358-.197 2.919-1.138 1.354-.828.609-.723.265-3.061-.441-3.402.081-4.764-1.334-6.993-2.576-4.054-2.849-3.946-4.532-6.617-1.681-2.636-3.483-8.366-5.408-8.404-1.514-.037-2.392.786-3.344 1.756-.953.972-1.132 5.544-2.567 6.99z"
      ></path>
      <path
        fill="#FFD030"
        d="M30.142 94.298c-2.502 2.472-7.895.573-9.07 1.635-1.337 1.212 1.877 3.421 1.582 5.556-.199 1.41-.675 2.143-1.142 4.039-.35 1.484 1.279 1.289 2.099 1.607 3.992 1.449 4.935 1.411 9.644 2.296 4.602.858 6.012 2.655 10.765 2.228 1.596-.131 1.314-.201 2.879-1.113 1.322-.773.59-.684.214-3.088-.506-3.379.078-4.778-1.256-6.879-2.561-4.027-2.863-3.899-4.533-6.553-1.671-2.617-3.429-8.368-5.34-8.404-1.503-.038-2.375.78-3.322 1.744-.948.965-1.093 5.5-2.52 6.932z"
      ></path>
      <path
        fill="#FFD133"
        d="M30.238 94.327c-2.563 2.526-8 .627-9.125 1.659-1.327 1.217 1.935 3.466 1.64 5.494-.201 1.4-.645 2.156-1.161 4.037-.387 1.474 1.309 1.272 2.139 1.567 4.11 1.419 5.125 1.456 9.567 2.286 4.571.848 5.973 2.636 10.691 2.212 1.585-.129 1.272-.203 2.839-1.088 1.291-.718.572-.645.166-3.115-.572-3.356.074-4.793-1.179-6.766-2.544-4.001-2.876-3.853-4.535-6.489-1.66-2.6-3.374-8.37-5.272-8.406-1.494-.037-2.36.774-3.3 1.733-.94.961-1.051 5.456-2.47 6.876z"
      ></path>
      <path d="M38.372 72.328c-.302.673-.558 6.462.953 8.717 1.511 2.231 1.07 3.51-.604 1.813-1.744-1.65-2.883-4.138-2.906-5.858 0-.999.768-5.114 1.07-5.556.324-.465 1.719.372 1.487.884z"></path>
      <path
        fill="#030303"
        d="M38.343 72.441c-.292.755-.535 6.359.972 8.609 1.506 2.229 1.029 3.387-.594 1.73-1.689-1.614-2.779-4.026-2.822-5.743-.014-1.005.721-4.978 1.011-5.421.311-.449 1.656.32 1.433.825z"
      ></path>
      <path
        fill="#070707"
        d="M38.314 72.554c-.282.836-.511 6.258.99 8.503 1.502 2.225.988 3.264-.584 1.646-1.633-1.576-2.675-3.914-2.738-5.627-.028-1.011.677-4.843.954-5.287.294-.435 1.59.267 1.378.765z"
      ></path>
      <path
        fill="#0B0B0B"
        d="M38.285 72.666c-.271.918-.488 6.156 1.009 8.396 1.497 2.222.947 3.141-.573 1.563-1.58-1.54-2.573-3.803-2.656-5.514-.042-1.017.632-4.706.895-5.151.282-.419 1.526.215 1.325.706z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M38.256 72.779c-.26 1-.465 6.053 1.028 8.29 1.492 2.217.907 3.017-.562 1.479-1.525-1.501-2.469-3.692-2.571-5.398-.056-1.023.585-4.569.836-5.016.264-.405 1.46.161 1.269.645z"
      ></path>
      <path
        fill="#131313"
        d="M38.227 72.891c-.25 1.082-.442 5.952 1.046 8.183 1.488 2.214.866 2.895-.552 1.395-1.471-1.463-2.366-3.58-2.488-5.282-.07-1.029.541-4.435.78-4.882.25-.39 1.394.11 1.214.586z"
      ></path>
      <path
        fill="#161616"
        d="M38.198 73.004c-.239 1.163-.418 5.849 1.065 8.076 1.483 2.211.825 2.771-.542 1.311-1.417-1.427-2.263-3.468-2.404-5.167-.084-1.034.495-4.298.721-4.747.235-.374 1.329.058 1.16.527z"
      ></path>
      <path
        fill="#1A1A1A"
        d="M38.169 73.117c-.229 1.244-.396 5.747 1.083 7.969 1.478 2.207.784 2.647-.532 1.227-1.361-1.39-2.158-3.357-2.32-5.052-.098-1.04.451-4.163.663-4.612.22-.359 1.265.005 1.106.468z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M38.139 73.23c-.219 1.326-.371 5.645 1.102 7.862 1.474 2.204.745 2.525-.52 1.144-1.307-1.353-2.056-3.245-2.238-4.938-.11-1.046.405-4.026.605-4.477.205-.344 1.201-.047 1.051.409z"
      ></path>
      <path
        fill="#222"
        d="M38.111 73.343c-.208 1.406-.349 5.542 1.121 7.755 1.469 2.201.704 2.401-.51 1.06-1.252-1.315-1.952-3.134-2.153-4.823-.125-1.052.358-3.89.546-4.342.189-.329 1.134-.099.996.35z"
      ></path>
      <path
        fill="#262626"
        d="M38.081 73.455c-.197 1.488-.325 5.44 1.139 7.647 1.465 2.197.664 2.278-.499.977-1.198-1.279-1.849-3.021-2.07-4.707-.139-1.058.314-3.755.489-4.208.175-.313 1.069-.15.941.291z"
      ></path>
      <path
        fill="#2A2A2A"
        d="M38.053 73.568c-.187 1.569-.302 5.337 1.158 7.541 1.46 2.193.622 2.155-.489.893-1.143-1.242-1.745-2.911-1.985-4.593-.153-1.063.268-3.618.429-4.073.159-.298 1.004-.203.887.232z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M38.024 73.681c-.177 1.65-.279 5.234 1.177 7.434 1.455 2.19.581 2.032-.479.809-1.088-1.204-1.642-2.799-1.902-4.477-.167-1.069.224-3.482.372-3.938.143-.284.939-.256.832.172z"
      ></path>
      <path
        fill="#313131"
        d="M37.995 73.794c-.167 1.731-.257 5.133 1.194 7.326 1.451 2.187.541 1.909-.468.726-1.034-1.167-1.538-2.688-1.818-4.362-.182-1.075.178-3.346.314-3.804.129-.268.874-.307.778.114z"
      ></path>
      <path
        fill="#353535"
        d="M37.966 73.906c-.155 1.813-.232 5.03 1.213 7.22 1.447 2.183.501 1.786-.457.643-.979-1.131-1.434-2.576-1.735-4.248-.194-1.081.133-3.21.256-3.668.113-.254.809-.36.723.053z"
      ></path>
      <path
        fill="#393939"
        d="M37.937 74.019c-.146 1.895-.209 4.929 1.231 7.114 1.441 2.179.459 1.662-.448.558-.923-1.093-1.33-2.464-1.65-4.132-.208-1.087.088-3.074.199-3.534.098-.238.743-.413.668-.006z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M37.908 74.132c-.136 1.976-.187 4.825 1.25 7.005 1.436 2.176.418 1.54-.437.475-.87-1.056-1.228-2.353-1.567-4.017-.224-1.092.041-2.938.139-3.398.084-.223.68-.465.615-.065z"
      ></path>
      <path
        fill="#414141"
        d="M37.878 74.245c-.124 2.057-.163 4.724 1.27 6.899 1.432 2.172.377 1.416-.427.391-.814-1.018-1.124-2.241-1.483-3.902-.237-1.099-.004-2.802.081-3.264.069-.208.614-.517.559-.124z"
      ></path>
      <path
        fill="#444"
        d="M37.849 74.357c-.114 2.138-.14 4.621 1.289 6.792 1.427 2.17.336 1.293-.416.307-.761-.981-1.021-2.128-1.4-3.786-.25-1.104-.048-2.667.023-3.129.053-.193.549-.569.504-.184z"
      ></path>
      <path
        fill="#484848"
        d="M37.82 74.47c-.104 2.22-.116 4.52 1.306 6.686 1.423 2.166.296 1.169-.405.223-.707-.944-.918-2.018-1.316-3.672-.265-1.11-.094-2.53-.035-2.994.039-.178.484-.622.45-.243z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M37.791 74.583c-.093 2.301-.093 4.416 1.325 6.579 1.418 2.162.255 1.046-.395.14-.652-.907-.814-1.906-1.233-3.557-.278-1.116-.14-2.394-.093-2.859.024-.164.419-.676.396-.303z"
      ></path>
      <path d="M38.372 72.328c1.395-3.046 2.163-6.324 4.162-9.508 1.976-3.161 1.186-4.394-.279-2.79-1.465 1.604-3.068 4.999-3.068 4.999s-1.883 2.975-2.301 6.416c-.072.58 1.253 1.371 1.486.883z"></path>
      <path
        fill="#020202"
        d="M38.432 72.13c1.382-3.066 2.136-6.213 4.063-9.299 1.906-3.063 1.166-4.287-.247-2.735-1.421 1.565-3.002 4.919-3.024 4.966 0 0-1.819 2.904-2.221 6.211-.066.572 1.202 1.339 1.429.857z"
      ></path>
      <path
        fill="#050505"
        d="M38.492 71.933c1.368-3.088 2.11-6.104 3.966-9.09 1.835-2.965 1.146-4.181-.213-2.681-1.379 1.525-2.938 4.84-2.981 4.934 0 0-1.757 2.831-2.14 6.007-.065.563 1.147 1.305 1.368.83z"
      ></path>
      <path
        fill="#070707"
        d="M38.552 71.736c1.356-3.111 2.083-5.997 3.868-8.882 1.765-2.866 1.125-4.075-.182-2.626-1.335 1.486-2.872 4.761-2.937 4.902 0 0-1.693 2.757-2.058 5.802-.062.554 1.093 1.272 1.309.804z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M38.612 71.54c1.342-3.132 2.058-5.888 3.771-8.674 1.693-2.768 1.104-3.968-.15-2.571-1.292 1.447-2.806 4.682-2.892 4.87 0 0-1.632 2.685-1.978 5.597-.061.543 1.039 1.239 1.249.778z"
      ></path>
      <path
        fill="#0C0C0C"
        d="M38.671 71.342c1.33-3.154 2.032-5.778 3.672-8.465 1.624-2.67 1.086-3.862-.116-2.517-1.25 1.408-2.741 4.604-2.848 4.838 0 0-1.568 2.613-1.897 5.393-.057.534.986 1.205 1.189.751z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M38.731 71.145c1.316-3.175 2.006-5.669 3.575-8.256 1.554-2.571 1.064-3.756-.084-2.463-1.207 1.369-2.675 4.524-2.804 4.807 0 0-1.506 2.54-1.816 5.188-.055.524.931 1.171 1.129.724z"
      ></path>
      <path
        fill="#111"
        d="M38.791 70.948c1.303-3.197 1.979-5.561 3.478-8.048 1.483-2.472 1.044-3.649-.052-2.408-1.164 1.33-2.61 4.446-2.76 4.774 0 0-1.443 2.468-1.735 4.985-.054.514.876 1.137 1.069.697z"
      ></path>
      <path
        fill="#141414"
        d="M38.851 70.75c1.291-3.219 1.953-5.452 3.38-7.839 1.412-2.374 1.024-3.543-.019-2.354-1.122 1.291-2.545 4.367-2.718 4.742 0 0-1.379 2.395-1.653 4.78-.05.506.823 1.105 1.01.671z"
      ></path>
      <path
        fill="#161616"
        d="M38.911 70.553c1.276-3.24 1.928-5.343 3.282-7.631 1.342-2.276 1.004-3.437.014-2.3-1.079 1.252-2.479 4.289-2.673 4.711 0 0-1.317 2.323-1.574 4.576-.047.495.769 1.071.951.644z"
      ></path>
      <path
        fill="#191919"
        d="M38.971 70.356c1.265-3.262 1.902-5.233 3.185-7.422 1.271-2.178.984-3.331.047-2.246-1.036 1.212-2.414 4.21-2.629 4.679 0 0-1.254 2.25-1.493 4.372-.046.485.714 1.037.89.617z"
      ></path>
      <path
        fill="#1C1C1C"
        d="M39.03 70.159c1.251-3.285 1.876-5.125 3.087-7.215 1.202-2.079.964-3.224.079-2.19-.992 1.173-2.348 4.13-2.584 4.646 0 0-1.192 2.178-1.412 4.167-.043.476.661 1.005.83.592z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M39.09 69.961c1.238-3.306 1.85-5.016 2.991-7.006 1.129-1.98.943-3.118.111-2.136-.949 1.134-2.283 4.052-2.541 4.615 0 0-1.128 2.106-1.331 3.962-.041.468.607.972.77.565z"
      ></path>
      <path
        fill="#212121"
        d="M39.149 69.764c1.226-3.328 1.824-4.907 2.892-6.797 1.061-1.881.923-3.011.144-2.082-.906 1.095-2.217 3.973-2.497 4.583 0 0-1.066 2.032-1.25 3.758-.037.459.554.938.711.538z"
      ></path>
      <path
        fill="#232323"
        d="M39.209 69.567c1.212-3.349 1.798-4.798 2.794-6.588.99-1.783.903-2.906.177-2.027-.863 1.055-2.151 3.894-2.453 4.551 0 0-1.003 1.96-1.17 3.553-.034.447.5.904.652.511z"
      ></path>
      <path
        fill="#262626"
        d="M39.269 69.37c1.198-3.371 1.772-4.689 2.696-6.38.92-1.685.883-2.799.209-1.973-.82 1.017-2.087 3.815-2.409 4.52 0 0-.941 1.888-1.088 3.349-.032.437.445.87.592.484z"
      ></path>
      <path
        fill="#282828"
        d="M39.329 69.173c1.187-3.393 1.747-4.581 2.6-6.171.848-1.587.862-2.693.242-1.918-.778.977-2.022 3.736-2.366 4.487 0 0-.876 1.815-1.007 3.144-.031.428.39.837.531.458z"
      ></path>
      <path
        fill="#2B2B2B"
        d="M39.388 68.975c1.173-3.414 1.72-4.471 2.502-5.963.779-1.488.842-2.586.273-1.864-.734.938-1.956 3.657-2.321 4.456 0 0-.814 1.742-.927 2.94-.026.419.339.804.473.431z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M39.449 68.778c1.16-3.437 1.694-4.363 2.404-5.754.708-1.39.822-2.48.306-1.81-.692.9-1.89 3.579-2.278 4.424 0 0-.75 1.67-.845 2.735-.025.41.284.771.413.405z"
      ></path>
      <path
        fill="#303030"
        d="M39.509 68.581c1.146-3.458 1.667-4.253 2.306-5.546.638-1.29.802-2.374.339-1.755-.648.86-1.824 3.5-2.233 4.392 0 0-.688 1.597-.765 2.531-.023.4.23.736.353.378z"
      ></path>
      <path
        fill="#333"
        d="M39.568 68.383c1.134-3.479 1.643-4.144 2.209-5.337.567-1.193.783-2.268.372-1.701-.606.821-1.759 3.421-2.188 4.359 0 0-.627 1.526-.686 2.327-.02.392.176.704.293.352z"
      ></path>
      <path d="M97.859 74.559c.675-1.906.605-6.764-1.116-9.902-.604-1.14-1.186-2.464-1.534-2.535-.372-.069-1.047.675-.977.791.094.186 3.232 4.604 2.581 10.601-.046.488.884 1.488 1.046 1.045z"></path>
      <path
        fill="#030303"
        d="M97.829 74.314c.654-1.847.566-6.58-1.08-9.577-.586-1.1-1.142-2.381-1.484-2.451-.362-.069-1.009.653-.944.764.084.181 3.101 4.449 2.496 10.252-.041.48.855 1.438 1.012 1.012z"
      ></path>
      <path
        fill="#070707"
        d="M97.799 74.067c.635-1.786.529-6.396-1.042-9.252-.569-1.061-1.098-2.297-1.434-2.367-.352-.067-.971.632-.911.739.073.177 2.971 4.293 2.41 9.903-.038.472.825 1.39.977.977z"
      ></path>
      <path
        fill="#0B0B0B"
        d="M97.768 73.821c.615-1.727.49-6.21-1.006-8.925-.551-1.022-1.054-2.214-1.382-2.284-.343-.068-.935.61-.881.712.064.172 2.841 4.139 2.326 9.554-.033.465.797 1.341.943.943z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M97.738 73.574c.595-1.667.451-6.025-.969-8.599-.533-.983-1.011-2.13-1.333-2.201-.332-.067-.897.589-.848.687.054.167 2.711 3.984 2.241 9.205-.029.458.767 1.292.909.908z"
      ></path>
      <path
        fill="#131313"
        d="M97.708 73.328c.574-1.606.412-5.841-.933-8.273-.515-.944-.967-2.047-1.282-2.117-.323-.066-.86.566-.815.66.044.163 2.581 3.83 2.156 8.856-.026.45.737 1.243.874.874z"
      ></path>
      <path
        fill="#161616"
        d="M97.677 73.082c.556-1.547.375-5.656-.895-7.948-.497-.905-.923-1.963-1.231-2.034-.313-.066-.823.546-.783.634.034.159 2.45 3.675 2.071 8.508-.022.442.707 1.194.838.84z"
      ></path>
      <path
        fill="#1A1A1A"
        d="M97.646 72.836c.536-1.487.337-5.472-.858-7.623-.479-.866-.879-1.88-1.181-1.951-.303-.065-.786.525-.75.609.024.154 2.319 3.52 1.986 8.159-.018.434.678 1.145.803.806z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M97.616 72.589c.516-1.427.298-5.287-.822-7.297-.462-.826-.835-1.796-1.131-1.866-.292-.063-.749.502-.719.583.014.149 2.189 3.365 1.901 7.81-.013.426.651 1.096.771.77z"
      ></path>
      <path
        fill="#222"
        d="M97.585 72.343c.496-1.367.261-5.102-.785-6.97-.443-.788-.792-1.713-1.081-1.784-.283-.063-.711.482-.687.557.005.145 2.06 3.211 1.816 7.462-.006.417.622 1.045.737.735z"
      ></path>
      <path
        fill="#262626"
        d="M97.555 72.096c.476-1.307.223-4.917-.75-6.645-.424-.748-.748-1.629-1.029-1.7-.273-.062-.673.46-.655.53-.005.141 1.93 3.057 1.731 7.113-.003.412.593.998.703.702z"
      ></path>
      <path
        fill="#2A2A2A"
        d="M97.524 71.85c.456-1.247.185-4.732-.713-6.319-.407-.709-.703-1.546-.979-1.617-.263-.062-.637.439-.623.504-.015.136 1.8 2.902 1.646 6.764.002.404.565.95.669.668z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M97.493 71.604c.437-1.188.147-4.547-.674-5.994-.39-.67-.661-1.462-.929-1.533-.253-.061-.6.417-.591.479-.024.132 1.669 2.747 1.562 6.415.005.396.534.9.632.633z"
      ></path>
      <path
        fill="#313131"
        d="M97.463 71.357c.416-1.127.108-4.362-.639-5.667-.372-.631-.617-1.38-.878-1.451-.243-.061-.562.396-.559.452-.034.127 1.54 2.593 1.477 6.067.01.39.505.852.599.599z"
      ></path>
      <path
        fill="#353535"
        d="M97.432 71.112c.397-1.068.07-4.178-.602-5.342-.353-.592-.572-1.296-.827-1.367-.234-.06-.525.375-.527.426-.044.123 1.409 2.438 1.392 5.718.015.38.477.803.564.565z"
      ></path>
      <path
        fill="#393939"
        d="M97.402 70.865c.377-1.007.031-3.993-.565-5.016-.335-.554-.529-1.213-.778-1.284-.223-.059-.487.354-.494.401-.054.118 1.279 2.284 1.307 5.369.018.373.448.753.53.53z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M97.371 70.619c.357-.948-.007-3.808-.529-4.69-.317-.514-.485-1.128-.727-1.2-.214-.058-.451.333-.462.375-.064.114 1.148 2.128 1.221 5.02.024.364.421.704.497.495z"
      ></path>
      <path
        fill="#414141"
        d="M97.342 70.373c.338-.888-.045-3.624-.492-4.364-.3-.475-.441-1.045-.676-1.117-.206-.058-.414.31-.43.348-.074.109 1.018 1.974 1.136 4.672.028.356.39.654.462.461z"
      ></path>
      <path
        fill="#444"
        d="M97.31 70.127c.318-.828-.083-3.439-.455-4.039-.282-.436-.397-.962-.625-1.033-.195-.058-.376.289-.398.322-.083.104.888 1.82 1.053 4.324.03.348.358.605.425.426z"
      ></path>
      <path
        fill="#484848"
        d="M97.281 69.88c.297-.767-.122-3.253-.419-3.713-.264-.396-.354-.878-.575-.95-.185-.057-.339.268-.366.296-.093.1.759 1.665.967 3.974.035.342.331.558.393.393z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M97.25 69.633c.277-.708-.16-3.068-.382-3.386-.247-.357-.311-.795-.525-.866-.175-.056-.301.246-.333.27-.103.096.628 1.511.882 3.625.039.333.302.508.358.357z"
      ></path>
      <path d="M95.21 62.122c-3.301-4.509-7.578-5.974-7.137-4.556 0 0 3.278 1.86 6.16 5.346.558.675 1.488-.092.977-.79z"></path>
      <path
        fill="#030303"
        d="M95.064 61.998c-3.205-4.356-7.392-5.783-6.954-4.423.005.004 3.196 1.812 6.007 5.189.543.651 1.443-.093.947-.766z"
      ></path>
      <path
        fill="#070707"
        d="M94.919 61.873c-3.107-4.205-7.206-5.592-6.772-4.29.012.007 3.116 1.765 5.856 5.031.526.627 1.397-.091.916-.741z"
      ></path>
      <path
        fill="#0B0B0B"
        d="M94.774 61.748c-3.011-4.052-7.019-5.4-6.59-4.156.018.011 3.036 1.717 5.705 4.873.509.604 1.35-.091.885-.717z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M94.628 61.623c-2.913-3.899-6.832-5.209-6.408-4.023.023.015 2.955 1.67 5.552 4.715.495.581 1.306-.09.856-.692z"
      ></path>
      <path
        fill="#131313"
        d="M94.482 61.499c-2.816-3.746-6.645-5.018-6.224-3.89.028.018 2.873 1.623 5.401 4.557.477.556 1.258-.09.823-.667z"
      ></path>
      <path
        fill="#161616"
        d="M94.338 61.373c-2.719-3.593-6.459-4.825-6.042-3.756.034.022 2.792 1.576 5.248 4.398.46.534 1.213-.087.794-.642z"
      ></path>
      <path
        fill="#1A1A1A"
        d="M94.192 61.249c-2.623-3.441-6.272-4.635-5.86-3.624.04.025 2.711 1.528 5.096 4.242a.491.491 0 00.764-.618z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M94.047 61.124c-2.527-3.289-6.086-4.443-5.679-3.491.047.029 2.632 1.481 4.945 4.083.43.488 1.122-.086.734-.592z"
      ></path>
      <path
        fill="#222"
        d="M93.902 60.999c-2.429-3.135-5.9-4.252-5.496-3.357.051.032 2.551 1.433 4.793 3.925.412.464 1.076-.086.703-.568z"
      ></path>
      <path
        fill="#262626"
        d="M93.756 60.874c-2.332-2.982-5.713-4.061-5.312-3.224.057.036 2.47 1.386 4.64 3.767.396.441 1.03-.084.672-.543z"
      ></path>
      <path
        fill="#2A2A2A"
        d="M93.611 60.75c-2.235-2.83-5.526-3.87-5.131-3.091.062.04 2.389 1.339 4.489 3.609.381.417.985-.084.642-.518z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M93.466 60.625c-2.139-2.678-5.34-3.679-4.949-2.958.069.043 2.308 1.292 4.337 3.451.364.394.939-.082.612-.493z"
      ></path>
      <path
        fill="#313131"
        d="M93.32 60.5c-2.041-2.524-5.153-3.487-4.766-2.824.074.046 2.228 1.244 4.185 3.294.348.369.893-.083.581-.47z"
      ></path>
      <path
        fill="#353535"
        d="M93.175 60.375c-1.945-2.372-4.967-3.296-4.584-2.691.08.05 2.146 1.196 4.034 3.135.33.347.847-.081.55-.444z"
      ></path>
      <path
        fill="#393939"
        d="M93.03 60.25c-1.847-2.219-4.78-3.104-4.402-2.558.085.054 2.065 1.149 3.881 2.978.316.324.802-.081.521-.42z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M92.885 60.126c-1.751-2.067-4.594-2.913-4.22-2.425.091.058 1.985 1.102 3.729 2.819.299.3.757-.08.491-.394z"
      ></path>
      <path
        fill="#414141"
        d="M92.739 60.001c-1.655-1.914-4.407-2.722-4.038-2.292.098.061 1.904 1.055 3.578 2.662.283.277.711-.079.46-.37z"
      ></path>
      <path
        fill="#444"
        d="M92.593 59.876c-1.557-1.762-4.221-2.53-3.855-2.158.103.064 1.824 1.007 3.425 2.504.268.253.666-.079.43-.346z"
      ></path>
      <path
        fill="#484848"
        d="M92.449 59.751c-1.461-1.608-4.035-2.339-3.673-2.025.109.068 1.742.96 3.273 2.346.251.229.62-.077.4-.321z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M92.303 59.626c-1.363-1.456-3.848-2.147-3.491-1.892.114.072 1.662.913 3.122 2.188.235.206.574-.076.369-.296z"
      ></path>
      <path d="M97.859 74.559c.047 2.023-1.859 7.183-2.58 6.998-.814-.187.163-1.697.906-4.254.302-1.07.535-3.696.628-3.789.303-.303 1.046.557 1.046 1.045z"></path>
      <path
        fill="#050505"
        d="M97.801 74.728c.033 1.964-1.82 6.972-2.518 6.786-.781-.183.177-1.661.909-4.174.29-1.026.515-3.534.609-3.632.295-.299 1.015.493 1 1.02z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M97.741 74.897c.021 1.906-1.78 6.761-2.454 6.575-.75-.18.191-1.626.91-4.095.279-.981.496-3.372.592-3.474.286-.297.985.428.952.994z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M97.682 75.065c.006 1.847-1.742 6.549-2.391 6.364-.719-.178.205-1.591.913-4.015.265-.938.475-3.211.572-3.317.279-.294.955.364.906.968z"
      ></path>
      <path
        fill="#141414"
        d="M97.622 75.233c-.006 1.788-1.701 6.338-2.328 6.153-.686-.175.22-1.555.916-3.935.253-.894.455-3.049.554-3.159.271-.29.924.298.858.941z"
      ></path>
      <path
        fill="#191919"
        d="M97.563 75.401c-.021 1.73-1.661 6.127-2.265 5.942-.655-.172.233-1.52.918-3.854.242-.851.436-2.887.535-3.002.264-.288.894.233.812.914z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M97.503 75.57c-.033 1.672-1.621 5.916-2.202 5.731-.622-.169.248-1.485.92-3.775.229-.808.416-2.726.517-2.845.256-.285.864.169.765.889z"
      ></path>
      <path
        fill="#232323"
        d="M97.443 75.738c-.046 1.614-1.582 5.705-2.138 5.52-.591-.167.262-1.448.921-3.694.217-.764.397-2.565.499-2.688.249-.283.835.104.718.862z"
      ></path>
      <path
        fill="#282828"
        d="M97.385 75.907c-.06 1.555-1.542 5.493-2.076 5.309-.559-.164.276-1.413.924-3.614.205-.721.377-2.403.48-2.53.241-.281.804.037.672.835z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M97.325 76.075c-.073 1.497-1.502 5.282-2.011 5.097-.527-.16.288-1.376.925-3.534l.463-2.373c.232-.277.772-.026.623.81z"
      ></path>
      <path
        fill="#333"
        d="M97.265 76.243c-.086 1.438-1.463 5.071-1.949 4.888-.495-.158.303-1.342.928-3.455.18-.634.337-2.081.443-2.216.227-.274.744-.091.578.783z"
      ></path>
      <path
        fill="#383838"
        d="M97.206 76.412c-.099 1.38-1.422 4.859-1.885 4.676-.464-.155.317-1.307.929-3.375.169-.59.318-1.918.426-2.059.218-.271.713-.155.53.758z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M97.147 76.58c-.113 1.322-1.383 4.648-1.822 4.465-.432-.152.332-1.271.931-3.295.157-.546.298-1.756.407-1.9.211-.269.683-.222.484.73z"
      ></path>
      <path
        fill="#424242"
        d="M97.087 76.749c-.125 1.264-1.343 4.437-1.759 4.254-.399-.15.347-1.235.934-3.216.145-.501.279-1.594.389-1.743.202-.266.652-.286.436.705z"
      ></path>
      <path
        fill="#474747"
        d="M97.028 76.918c-.14 1.205-1.304 4.225-1.696 4.042-.369-.146.36-1.199.936-3.135.132-.458.259-1.433.37-1.586.195-.263.622-.351.39.679z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M96.968 77.085c-.152 1.147-1.264 4.015-1.633 3.833-.335-.145.374-1.165.939-3.056.121-.416.239-1.272.351-1.429.189-.26.592-.416.343.652z"
      ></path>
      <path
        fill="#515151"
        d="M96.91 77.254c-.166 1.088-1.225 3.803-1.57 3.621-.304-.142.387-1.129.94-2.976.109-.372.22-1.111.333-1.272.181-.256.561-.48.297.627z"
      ></path>
      <path
        fill="#565656"
        d="M96.849 77.422c-.179 1.03-1.185 3.591-1.507 3.41-.272-.139.403-1.093.943-2.896.096-.328.2-.949.315-1.114.174-.254.531-.545.249.6z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M96.791 77.59c-.193.972-1.146 3.381-1.444 3.199-.24-.136.416-1.058.945-2.816.083-.284.18-.787.296-.957.165-.251.5-.61.203.574z"
      ></path>
      <path
        fill="#606060"
        d="M96.731 77.759c-.206.913-1.106 3.169-1.38 2.987-.208-.132.43-1.022.947-2.735.072-.242.161-.626.278-.8.157-.248.469-.675.155.548z"
      ></path>
      <path
        fill="#666"
        d="M96.672 77.928c-.219.854-1.066 2.958-1.318 2.776-.176-.129.445-.986.949-2.656.06-.197.141-.464.261-.642.149-.246.438-.739.108.522z"
      ></path>
      <path d="M90.769 62.378c-.496.523-.938 3.226.303 4.163 1.24.91 3.419-.772 3.419-1.736-.028-2.179-3.225-2.978-3.722-2.427z"></path>
      <path
        fill="#010101"
        d="M90.814 62.424c-.504.52-.929 3.171.277 4.09 1.204.893 3.341-.734 3.353-1.705-.016-2.123-3.126-2.932-3.63-2.385z"
      ></path>
      <path
        fill="#030303"
        d="M90.858 62.469c-.511.517-.92 3.117.25 4.016 1.17.875 3.264-.695 3.286-1.671-.003-2.068-3.025-2.888-3.536-2.345z"
      ></path>
      <path
        fill="#050505"
        d="M90.902 62.515c-.518.513-.911 3.062.224 3.942 1.134.856 3.187-.658 3.22-1.64.01-2.011-2.925-2.841-3.444-2.302z"
      ></path>
      <path
        fill="#070707"
        d="M90.946 62.56c-.525.51-.902 3.008.198 3.87 1.097.839 3.109-.619 3.153-1.607.023-1.958-2.825-2.798-3.351-2.263z"
      ></path>
      <path
        fill="#090909"
        d="M90.991 62.605c-.532.507-.894 2.954.171 3.797 1.061.821 3.032-.582 3.087-1.574.035-1.903-2.725-2.753-3.258-2.223z"
      ></path>
      <path
        fill="#0B0B0B"
        d="M91.035 62.65c-.539.502-.885 2.898.144 3.723 1.026.804 2.954-.543 3.022-1.542.047-1.846-2.626-2.707-3.166-2.181z"
      ></path>
      <path
        fill="#0D0D0D"
        d="M91.078 62.696c-.547.499-.876 2.844.118 3.649.989.787 2.876-.505 2.955-1.509.061-1.792-2.525-2.662-3.073-2.14z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M91.123 62.741c-.554.496-.868 2.791.091 3.576.953.769 2.799-.467 2.889-1.476.073-1.737-2.425-2.617-2.98-2.1z"
      ></path>
      <path
        fill="#111"
        d="M91.167 62.787c-.561.492-.859 2.734.064 3.502.919.75 2.722-.43 2.823-1.443.086-1.682-2.325-2.573-2.887-2.059z"
      ></path>
      <path
        fill="#131313"
        d="M91.211 62.832c-.568.489-.85 2.681.038 3.429.881.733 2.644-.392 2.756-1.411.099-1.627-2.224-2.527-2.794-2.018z"
      ></path>
      <path
        fill="#151515"
        d="M91.255 62.877c-.575.486-.841 2.625.012 3.354.846.716 2.567-.353 2.69-1.377.111-1.571-2.125-2.482-2.702-1.977z"
      ></path>
      <path
        fill="#161616"
        d="M91.3 62.922c-.583.481-.833 2.572-.015 3.281.81.699 2.489-.314 2.624-1.345.124-1.515-2.025-2.437-2.609-1.936z"
      ></path>
      <path
        fill="#181818"
        d="M91.344 62.968c-.59.479-.824 2.518-.042 3.208.774.68 2.412-.277 2.558-1.313.136-1.461-1.924-2.392-2.516-1.895z"
      ></path>
      <path
        fill="#1A1A1A"
        d="M91.388 63.013c-.598.475-.815 2.462-.068 3.135.738.663 2.334-.24 2.492-1.28.148-1.406-1.825-2.347-2.424-1.855z"
      ></path>
      <path
        fill="#1C1C1C"
        d="M91.432 63.058c-.604.471-.807 2.408-.094 3.061.703.646 2.256-.2 2.425-1.248.162-1.348-1.725-2.301-2.331-1.813z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M91.477 63.104c-.613.467-.798 2.353-.122 2.987.667.627 2.18-.163 2.36-1.214.174-1.295-1.626-2.257-2.238-1.773z"
      ></path>
      <path
        fill="#202020"
        d="M91.52 63.149c-.619.464-.789 2.3-.147 2.914.631.61 2.102-.124 2.293-1.182.187-1.239-1.525-2.212-2.146-1.732z"
      ></path>
      <path
        fill="#222"
        d="M91.564 63.194c-.625.46-.78 2.245-.173 2.841.595.592 2.025-.086 2.226-1.15.2-1.184-1.424-2.166-2.053-1.691z"
      ></path>
      <path
        fill="#242424"
        d="M91.608 63.24c-.632.457-.771 2.19-.2 2.768.559.573 1.947-.049 2.16-1.117.213-1.13-1.324-2.122-1.96-1.651z"
      ></path>
      <path
        fill="#262626"
        d="M91.653 63.285c-.641.454-.763 2.136-.228 2.694.523.557 1.87-.01 2.094-1.084.226-1.074-1.223-2.077-1.866-1.61z"
      ></path>
      <path d="M90.653 84.603c.488.488.907-.721 1.396-1.117.488-.395 1.278-1.255 2.859-1.255s1.464-.046 1.394-.651c-.046-.581-.511-.535-1.906-.326a4.533 4.533 0 00-2.882 1.557c-.535.628-1.14 1.512-.861 1.792z"></path>
      <path
        fill="#050505"
        d="M90.761 84.484c.471.468.872-.685 1.357-1.068s1.269-1.205 2.789-1.205c1.521 0 1.426-.042 1.359-.626-.045-.562-.498-.515-1.856-.316a4.417 4.417 0 00-2.812 1.5c-.522.607-1.11 1.445-.837 1.715z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M90.869 84.364c.453.449.839-.648 1.319-1.019.482-.371 1.26-1.155 2.72-1.155 1.46 0 1.386-.036 1.322-.601-.042-.545-.484-.495-1.805-.307a4.302 4.302 0 00-2.743 1.443c-.509.585-1.081 1.38-.813 1.639z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M90.976 84.245c.437.429.805-.611 1.283-.97.478-.359 1.25-1.105 2.649-1.105 1.4 0 1.347-.03 1.286-.576-.04-.526-.471-.474-1.755-.298a4.2 4.2 0 00-2.673 1.388c-.495.562-1.052 1.311-.79 1.561z"
      ></path>
      <path
        fill="#141414"
        d="M91.083 84.127c.42.409.771-.576 1.246-.922.475-.348 1.24-1.055 2.58-1.056 1.34 0 1.308-.025 1.251-.552-.039-.508-.458-.453-1.707-.29a4.08 4.08 0 00-2.604 1.332c-.48.543-1.021 1.247-.766 1.488z"
      ></path>
      <path
        fill="#191919"
        d="M91.19 84.009c.403.387.738-.54 1.209-.875.47-.335 1.23-1.004 2.51-1.005 1.279-.001 1.269-.02 1.214-.527-.037-.491-.445-.433-1.655-.28a3.976 3.976 0 00-2.534 1.274c-.467.521-.992 1.18-.744 1.413z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M91.298 83.89c.386.368.705-.504 1.171-.826.467-.323 1.222-.954 2.441-.955 1.218-.001 1.229-.014 1.178-.502-.034-.472-.431-.412-1.606-.27a3.858 3.858 0 00-2.464 1.217c-.454.499-.962 1.114-.72 1.336z"
      ></path>
      <path
        fill="#232323"
        d="M91.406 83.771c.37.349.67-.467 1.135-.778.464-.311 1.211-.903 2.37-.903 1.159-.002 1.189-.009 1.143-.478-.033-.454-.418-.393-1.556-.263a3.755 3.755 0 00-2.394 1.161c-.443.478-.936 1.048-.698 1.261z"
      ></path>
      <path
        fill="#282828"
        d="M91.514 83.652c.352.329.637-.431 1.097-.729.46-.299 1.202-.853 2.3-.854 1.099-.002 1.151-.004 1.106-.454-.03-.436-.404-.372-1.505-.252a3.638 3.638 0 00-2.324 1.104c-.429.457-.906.981-.674 1.185z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M91.62 83.533c.335.308.603-.395 1.06-.681.457-.286 1.193-.802 2.23-.803 1.039-.002 1.112.002 1.07-.428-.028-.418-.391-.352-1.455-.244a3.539 3.539 0 00-2.254 1.047c-.414.434-.875.915-.651 1.109z"
      ></path>
      <path
        fill="#333"
        d="M91.728 83.415c.318.288.568-.358 1.022-.633.453-.275 1.183-.752 2.161-.754s1.072.007 1.034-.403c-.026-.399-.378-.331-1.406-.234a3.434 3.434 0 00-2.184.99c-.401.413-.846.85-.627 1.034z"
      ></path>
      <path
        fill="#383838"
        d="M91.836 83.296c.301.268.535-.322.985-.584.45-.263 1.174-.702 2.092-.704s1.033.013.997-.379c-.024-.38-.364-.31-1.355-.224-.99.07-1.715.531-2.114.934-.389.391-.819.782-.605.957z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M91.943 83.177c.284.249.502-.286.949-.536.446-.25 1.164-.653 2.021-.654.857-.003.994.018.962-.354-.022-.363-.351-.29-1.306-.217-.953.06-1.661.497-2.045.877-.375.372-.788.719-.581.884z"
      ></path>
      <path
        fill="#424242"
        d="M92.051 83.059c.267.229.467-.25.911-.487.443-.239 1.154-.603 1.951-.604.797-.002.954.024.926-.329-.021-.345-.338-.27-1.255-.207-.918.049-1.606.462-1.975.82-.362.349-.76.651-.558.807z"
      ></path>
      <path
        fill="#474747"
        d="M92.158 82.94c.25.208.434-.213.874-.44.44-.226 1.145-.551 1.882-.553.737-.003.915.029.889-.304-.019-.327-.324-.25-1.206-.198-.88.039-1.55.429-1.905.764-.347.327-.729.584-.534.731z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M92.265 82.821c.233.188.4-.178.836-.391.437-.215 1.136-.501 1.812-.504.677-.003.876.035.854-.279-.016-.308-.312-.229-1.155-.188-.844.028-1.495.395-1.836.707-.333.305-.7.518-.511.655z"
      ></path>
      <path
        fill="#515151"
        d="M92.373 82.702c.215.168.366-.14.799-.343.433-.201 1.125-.45 1.742-.452.617-.004.836.039.817-.255-.015-.29-.298-.208-1.105-.179-.807.017-1.439.36-1.766.65-.321.284-.67.452-.487.579z"
      ></path>
      <path
        fill="#565656"
        d="M92.481 82.584c.198.148.332-.104.761-.294.43-.19 1.117-.4 1.672-.403.556-.003.797.045.782-.23-.013-.272-.285-.188-1.056-.17-.771.007-1.384.326-1.695.593-.308.262-.642.386-.464.504z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M92.587 82.465c.183.128.299-.068.726-.247.425-.178 1.106-.35 1.602-.353.496-.003.758.05.746-.206-.01-.253-.271-.168-1.005-.161-.733-.003-1.329.292-1.625.536-.297.244-.614.322-.444.431z"
      ></path>
      <path
        fill="#606060"
        d="M92.695 82.346c.165.108.266-.033.688-.198.423-.166 1.097-.3 1.533-.303s.719.057.708-.181c-.008-.234-.257-.146-.955-.152-.696-.014-1.273.258-1.556.479-.281.221-.582.256-.418.355z"
      ></path>
      <path
        fill="#666"
        d="M92.803 82.228c.147.088.23.003.649-.15.42-.154 1.088-.249 1.463-.252.375-.003.68.062.673-.155-.006-.217-.245-.127-.905-.143-.66-.024-1.217.224-1.486.423-.267.197-.554.187-.394.277z"
      ></path>
      <path d="M96.953 81.557c0 .744 1.511 1 2.952 1.208 1.418.209 2.558.489 2.626 1.977.07 1.464-.301 2.51.35 2.395 1.395-.256 1.906-1.768 1.883-2.465 0-.698-1.023-1.953-2.859-2.65-1.348-.512-2.325-.744-3.511-.791-1.58-.069-1.441.326-1.441.326z"></path>
      <path
        fill="#030303"
        d="M96.994 81.569c.003.723 1.499.959 2.921 1.174 1.405.218 2.503.488 2.619 1.938.112 1.426-.275 2.427.367 2.321 1.338-.238 1.836-1.679 1.811-2.367-.005-.694-1.007-1.908-2.82-2.595-1.333-.504-2.295-.742-3.468-.792-1.535-.069-1.433.308-1.43.321z"
      ></path>
      <path
        fill="#070707"
        d="M97.034 81.582c.008.702 1.487.918 2.891 1.14 1.392.226 2.447.487 2.61 1.901.153 1.386-.249 2.341.384 2.248 1.281-.222 1.768-1.592 1.738-2.271-.009-.693-.991-1.864-2.78-2.541-1.317-.498-2.268-.74-3.425-.793-1.488-.071-1.424.289-1.418.316z"
      ></path>
      <path
        fill="#0B0B0B"
        d="M97.075 81.593c.012.681 1.475.878 2.86 1.107 1.379.235 2.392.487 2.603 1.862.194 1.348-.222 2.256.402 2.174 1.226-.206 1.698-1.504 1.666-2.173-.014-.69-.974-1.82-2.74-2.486-1.302-.491-2.238-.738-3.383-.794-1.444-.071-1.416.27-1.408.31z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M97.116 81.606c.015.66 1.463.838 2.829 1.073 1.366.244 2.338.486 2.596 1.824.233 1.309-.197 2.173.419 2.102 1.168-.189 1.627-1.417 1.594-2.078-.019-.687-.959-1.774-2.702-2.431-1.287-.485-2.208-.736-3.34-.795-1.398-.072-1.407.252-1.396.305z"
      ></path>
      <path
        fill="#131313"
        d="M97.157 81.619c.019.639 1.451.797 2.798 1.04 1.353.252 2.283.485 2.587 1.786.276 1.27-.17 2.087.438 2.029 1.112-.173 1.557-1.33 1.521-1.981-.024-.684-.943-1.73-2.662-2.376-1.272-.479-2.181-.733-3.298-.797-1.351-.074-1.399.232-1.384.299z"
      ></path>
      <path
        fill="#161616"
        d="M97.197 81.631c.023.618 1.44.757 2.768 1.006 1.34.26 2.229.484 2.58 1.747.316 1.231-.143 2.002.455 1.956 1.056-.155 1.488-1.242 1.449-1.885-.028-.682-.927-1.686-2.623-2.322-1.257-.471-2.151-.731-3.255-.797-1.307-.073-1.391.215-1.374.295z"
      ></path>
      <path
        fill="#1A1A1A"
        d="M97.238 81.644c.027.597 1.428.716 2.736.972 1.328.269 2.174.484 2.573 1.71.357 1.191-.117 1.918.472 1.882 1-.14 1.419-1.156 1.377-1.788-.034-.679-.911-1.641-2.583-2.268-1.243-.465-2.124-.729-3.212-.799-1.26-.073-1.383.197-1.363.291z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M97.279 81.656c.03.575 1.416.675 2.707.938 1.313.277 2.118.483 2.562 1.671.399 1.152-.09 1.833.491 1.809.943-.123 1.349-1.067 1.305-1.691-.038-.676-.896-1.597-2.544-2.213-1.227-.458-2.094-.727-3.169-.8-1.216-.073-1.375.179-1.352.286z"
      ></path>
      <path
        fill="#222"
        d="M97.32 81.668c.034.555 1.404.636 2.674.905 1.301.286 2.064.482 2.556 1.633.44 1.113-.063 1.749.508 1.736.887-.106 1.279-.98 1.232-1.595-.043-.674-.879-1.552-2.505-2.158-1.211-.452-2.064-.726-3.126-.802-1.169-.073-1.365.161-1.339.281z"
      ></path>
      <path
        fill="#262626"
        d="M97.36 81.68c.038.533 1.391.595 2.644.87 1.289.295 2.01.481 2.548 1.596.482 1.074-.037 1.664.526 1.663.831-.09 1.209-.893 1.161-1.499-.048-.671-.863-1.508-2.465-2.104-1.196-.446-2.037-.723-3.084-.803-1.124-.073-1.359.144-1.33.277z"
      ></path>
      <path
        fill="#2A2A2A"
        d="M97.4 81.692c.042.513 1.38.555 2.614.836 1.275.303 1.955.481 2.54 1.558.523 1.036-.011 1.58.544 1.59.773-.074 1.14-.805 1.088-1.402-.053-.669-.847-1.463-2.426-2.049-1.18-.439-2.007-.721-3.042-.805-1.077-.073-1.349.127-1.318.272z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M97.441 81.706c.046.491 1.368.513 2.583.801 1.263.312 1.9.481 2.532 1.52.564.996.016 1.495.562 1.517.716-.057 1.07-.718 1.015-1.305-.057-.666-.83-1.419-2.386-1.995-1.166-.432-1.978-.718-2.999-.805-1.032-.075-1.34.107-1.307.267z"
      ></path>
      <path
        fill="#313131"
        d="M97.482 81.717c.049.47 1.356.473 2.552.769 1.248.32 1.845.48 2.523 1.482.605.957.043 1.41.579 1.443.661-.04 1.001-.63.943-1.208-.062-.664-.814-1.375-2.346-1.94-1.151-.425-1.95-.716-2.957-.807-.985-.074-1.332.089-1.294.261z"
      ></path>
      <path
        fill="#353535"
        d="M97.523 81.73c.053.449 1.343.433 2.521.734 1.236.329 1.791.479 2.516 1.444.647.918.069 1.325.597 1.37.604-.024.931-.543.871-1.111-.067-.661-.799-1.331-2.307-1.885-1.136-.419-1.92-.715-2.914-.809-.94-.075-1.325.071-1.284.257z"
      ></path>
      <path
        fill="#393939"
        d="M97.563 81.742c.057.428 1.333.393 2.491.701 1.222.337 1.735.478 2.509 1.406.687.879.095 1.241.613 1.297.548-.007.861-.456.798-1.016-.072-.658-.783-1.285-2.267-1.83-1.121-.413-1.892-.713-2.872-.811-.894-.074-1.315.054-1.272.253z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M97.604 81.754c.061.407 1.32.352 2.459.667 1.21.346 1.682.478 2.501 1.368.729.84.122 1.155.631 1.223.492.01.792-.368.727-.918-.076-.655-.766-1.241-2.229-1.775-1.104-.406-1.862-.712-2.828-.812-.848-.075-1.307.035-1.261.247z"
      ></path>
      <path
        fill="#414141"
        d="M97.645 81.767c.064.386 1.308.312 2.428.633 1.198.354 1.627.477 2.493 1.331.769.8.148 1.069.649 1.149.435.026.722-.28.654-.821-.081-.653-.75-1.198-2.188-1.722-1.09-.399-1.834-.708-2.786-.812-.803-.076-1.299.016-1.25.242z"
      ></path>
      <path
        fill="#444"
        d="M97.686 81.78c.068.364 1.296.27 2.397.599 1.185.363 1.572.477 2.485 1.292.81.761.174.986.667 1.077.378.043.652-.193.582-.726-.086-.65-.736-1.151-2.15-1.666-1.075-.393-1.805-.707-2.744-.814-.756-.076-1.289-.002-1.237.238z"
      ></path>
      <path
        fill="#484848"
        d="M97.725 81.792c.073.344 1.286.231 2.367.565 1.172.372 1.518.476 2.477 1.254.852.723.202.901.686 1.003.322.06.582-.106.509-.628-.091-.648-.719-1.108-2.109-1.611-1.06-.387-1.776-.705-2.702-.816-.71-.076-1.281-.02-1.228.233z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M97.766 81.804c.076.323 1.272.189 2.336.531 1.159.381 1.462.475 2.469 1.216.893.684.228.817.703.931.265.075.513-.019.437-.532-.095-.645-.703-1.063-2.07-1.557-1.045-.38-1.747-.703-2.659-.816-.665-.078-1.272-.039-1.216.227zm4.787 1.557c.531.324.437.665.778.894.171.114.456.114.286-.323-.229-.513-.418-.798-1.596-1.273-.759-.304-.608.018.532.702z"
      ></path>
      <path
        fill="#505050"
        d="M102.567 83.366c.518.314.426.648.759.87.167.111.445.111.278-.315-.223-.5-.408-.778-1.557-1.242-.74-.296-.592.019.52.687z"
      ></path>
      <path
        fill="#545454"
        d="M102.58 83.369c.506.307.416.631.741.849.163.108.434.108.271-.308-.217-.487-.397-.758-1.518-1.21-.722-.288-.577.019.506.669z"
      ></path>
      <path
        fill="#575757"
        d="M102.595 83.373c.493.298.405.616.722.827.159.105.423.105.263-.299-.21-.475-.387-.739-1.478-1.179-.704-.282-.563.017.493.651z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M102.61 83.377c.479.292.393.599.701.805.155.103.411.103.258-.291-.206-.462-.377-.72-1.439-1.148-.686-.275-.548.017.48.634z"
      ></path>
      <path
        fill="#5F5F5F"
        d="M102.622 83.38c.467.284.384.584.684.784.15.1.4.1.25-.283-.201-.45-.367-.701-1.4-1.117-.666-.266-.533.017.466.616z"
      ></path>
      <path
        fill="#636363"
        d="M102.638 83.384c.453.276.372.568.664.762.146.097.389.097.244-.275-.195-.438-.356-.681-1.361-1.086-.649-.259-.52.017.453.599z"
      ></path>
      <path
        fill="#676767"
        d="M102.651 83.389c.44.267.362.551.645.739.142.094.378.094.236-.267-.188-.425-.346-.661-1.322-1.055-.628-.252-.503.016.441.583z"
      ></path>
      <path
        fill="#6B6B6B"
        d="M102.665 83.393c.428.259.351.534.627.717.137.091.366.091.229-.259-.184-.412-.336-.642-1.284-1.023-.61-.244-.488.015.428.565z"
      ></path>
      <path
        fill="#6E6E6E"
        d="M102.68 83.397c.414.251.341.518.606.696.134.088.356.088.223-.251-.178-.399-.325-.622-1.245-.992-.591-.238-.473.013.416.547z"
      ></path>
      <path
        fill="#727272"
        d="M102.693 83.4c.401.244.331.501.589.674.129.085.343.085.215-.244-.172-.387-.315-.602-1.205-.961-.573-.229-.459.015.401.531z"
      ></path>
      <path
        fill="#767676"
        d="M102.707 83.404c.388.236.319.486.57.653.125.083.332.083.208-.236-.167-.375-.305-.583-1.166-.93-.555-.222-.444.014.388.513z"
      ></path>
      <path
        fill="#7A7A7A"
        d="M102.722 83.408c.376.228.308.469.55.63.121.081.322.081.201-.228-.161-.362-.295-.563-1.126-.898-.537-.215-.43.013.375.496z"
      ></path>
      <path
        fill="#7E7E7E"
        d="M102.736 83.412c.362.22.297.453.53.608.117.078.312.078.195-.22-.155-.35-.285-.543-1.087-.867-.518-.206-.415.013.362.479z"
      ></path>
      <path
        fill="#828282"
        d="M102.75 83.416c.349.212.287.437.512.586.112.075.299.075.187-.212-.149-.336-.274-.524-1.048-.835-.5-.201-.399.012.349.461z"
      ></path>
      <path
        fill="#858585"
        d="M102.764 83.42c.336.204.275.419.492.564.108.072.289.072.181-.204-.145-.325-.265-.505-1.009-.805-.481-.192-.384.013.336.445z"
      ></path>
      <path
        fill="#898989"
        d="M102.778 83.424c.323.197.266.404.473.543.104.069.277.069.173-.197-.139-.311-.254-.485-.97-.773-.461-.185-.368.011.324.427z"
      ></path>
      <path
        fill="#8D8D8D"
        d="M102.792 83.428c.31.189.255.388.454.521.1.066.265.066.167-.188-.133-.299-.245-.466-.931-.743-.443-.177-.354.011.31.41z"
      ></path>
      <path
        fill="#919191"
        d="M102.806 83.432c.297.181.245.372.435.5.096.063.256.063.16-.181-.127-.286-.233-.446-.892-.711-.424-.171-.34.01.297.392z"
      ></path>
      <path
        fill="#959595"
        d="M102.821 83.435c.283.172.232.356.416.478.091.061.243.061.152-.173-.122-.274-.224-.426-.854-.68-.404-.163-.324.011.286.375z"
      ></path>
      <path
        fill="#999"
        d="M102.834 83.439c.271.165.223.339.397.455.088.058.232.058.146-.164-.117-.262-.213-.407-.814-.65-.387-.154-.31.011.271.359z"
      ></path>
      <path d="M81.472 36.408c-.239.292.186 2.701 1.748 4.289 1.562 1.562 2.516 1.562 3.151.874 1.217-1.297.237-2.515-.503-3.362-.743-.847-1.695-.556-2.569-1.403s-1.482-.796-1.827-.398z"></path>
      <path
        fill="#050505"
        d="M81.495 36.429c-.236.289.184 2.68 1.733 4.256 1.551 1.55 2.496 1.55 3.126.867 1.208-1.287.236-2.495-.499-3.336s-1.682-.552-2.549-1.392c-.865-.841-1.469-.789-1.811-.395z"
      ></path>
      <path
        fill="#0A0A0A"
        d="M81.518 36.451c-.234.286.183 2.659 1.72 4.223 1.538 1.538 2.476 1.538 3.102.86 1.199-1.277.235-2.477-.495-3.311-.73-.834-1.669-.547-2.529-1.381-.86-.834-1.459-.782-1.798-.391z"
      ></path>
      <path
        fill="#0F0F0F"
        d="M81.54 36.473c-.232.284.182 2.638 1.708 4.189 1.526 1.525 2.456 1.525 3.078.853 1.189-1.267.232-2.457-.492-3.284-.724-.828-1.654-.543-2.509-1.37-.853-.828-1.448-.776-1.785-.388z"
      ></path>
      <path
        fill="#141414"
        d="M81.563 36.495c-.23.282.18 2.616 1.693 4.155 1.514 1.514 2.437 1.514 3.053.847 1.18-1.257.23-2.438-.488-3.258-.718-.821-1.642-.539-2.488-1.36-.846-.821-1.437-.77-1.77-.384z"
      ></path>
      <path
        fill="#191919"
        d="M81.586 36.516c-.229.28.179 2.596 1.68 4.123 1.5 1.501 2.418 1.501 3.028.84 1.171-1.247.229-2.418-.484-3.232-.712-.813-1.628-.534-2.468-1.348-.84-.815-1.426-.765-1.756-.383z"
      ></path>
      <path
        fill="#1E1E1E"
        d="M81.609 36.537c-.228.278.177 2.575 1.666 4.09 1.49 1.489 2.399 1.489 3.004.833 1.162-1.237.228-2.398-.48-3.206-.706-.808-1.615-.53-2.448-1.338-.834-.808-1.414-.757-1.742-.379z"
      ></path>
      <path
        fill="#232323"
        d="M81.631 36.559c-.225.275.176 2.554 1.652 4.056 1.477 1.477 2.379 1.477 2.98.826 1.151-1.227.226-2.378-.476-3.179-.701-.801-1.602-.526-2.428-1.327-.826-.801-1.403-.751-1.728-.376z"
      ></path>
      <path
        fill="#282828"
        d="M81.654 36.581c-.223.273.173 2.533 1.64 4.023 1.465 1.464 2.359 1.464 2.955.819 1.142-1.217.223-2.359-.472-3.154-.696-.794-1.589-.521-2.409-1.315-.82-.795-1.391-.746-1.714-.373z"
      ></path>
      <path
        fill="#2D2D2D"
        d="M81.677 36.602c-.222.271.172 2.512 1.625 3.989 1.453 1.453 2.339 1.453 2.93.812 1.132-1.207.221-2.34-.468-3.127-.689-.788-1.576-.517-2.388-1.305-.813-.787-1.379-.738-1.699-.369z"
      ></path>
      <path
        fill="#333"
        d="M81.7 36.624c-.221.269.17 2.491 1.612 3.957 1.441 1.44 2.32 1.44 2.906.806 1.123-1.196.22-2.32-.464-3.101-.685-.781-1.564-.513-2.369-1.294-.807-.783-1.368-.735-1.685-.368z"
      ></path>
      <path
        fill="#383838"
        d="M81.722 36.645c-.218.267.169 2.47 1.599 3.923 1.429 1.429 2.3 1.429 2.881.799 1.115-1.187.219-2.3-.46-3.076-.678-.774-1.55-.508-2.348-1.283-.8-.774-1.357-.726-1.672-.363z"
      ></path>
      <path
        fill="#3D3D3D"
        d="M81.745 36.667c-.216.264.168 2.449 1.584 3.89 1.417 1.417 2.28 1.417 2.857.792 1.104-1.176.216-2.281-.456-3.048-.673-.769-1.537-.504-2.33-1.272-.791-.77-1.343-.722-1.655-.362z"
      ></path>
      <path
        fill="#424242"
        d="M81.768 36.689c-.214.262.167 2.428 1.571 3.856 1.405 1.404 2.261 1.404 2.832.785 1.096-1.167.214-2.262-.452-3.023-.666-.762-1.523-.5-2.308-1.261-.786-.762-1.334-.715-1.643-.357z"
      ></path>
      <path
        fill="#474747"
        d="M81.791 36.71c-.212.26.165 2.407 1.557 3.823 1.393 1.392 2.242 1.392 2.808.778 1.086-1.157.213-2.242-.448-2.997s-1.511-.495-2.29-1.25c-.778-.755-1.321-.708-1.627-.354z"
      ></path>
      <path
        fill="#4C4C4C"
        d="M81.814 36.732c-.21.257.164 2.386 1.544 3.789 1.38 1.38 2.221 1.38 2.783.772 1.076-1.146.209-2.222-.445-2.971s-1.497-.491-2.268-1.24c-.773-.747-1.311-.701-1.614-.35z"
      ></path>
      <path
        fill="#515151"
        d="M81.836 36.753c-.208.255.163 2.365 1.531 3.756 1.367 1.368 2.203 1.368 2.758.765 1.067-1.136.208-2.202-.44-2.944-.649-.742-1.484-.487-2.25-1.229-.764-.742-1.298-.695-1.599-.348z"
      ></path>
      <path
        fill="#565656"
        d="M81.859 36.775c-.207.253.161 2.344 1.517 3.723 1.355 1.356 2.184 1.356 2.734.758 1.057-1.126.207-2.183-.436-2.918-.644-.735-1.472-.482-2.23-1.218-.758-.735-1.287-.689-1.585-.345z"
      ></path>
      <path
        fill="#5B5B5B"
        d="M81.882 36.797c-.206.25.159 2.323 1.503 3.689 1.343 1.343 2.164 1.343 2.71.751 1.047-1.116.205-2.164-.433-2.893s-1.457-.478-2.209-1.207c-.752-.727-1.276-.682-1.571-.34z"
      ></path>
      <path
        fill="#606060"
        d="M81.905 36.818c-.204.249.158 2.302 1.489 3.656 1.333 1.331 2.145 1.331 2.686.745 1.038-1.106.203-2.144-.429-2.866-.632-.723-1.444-.474-2.188-1.196s-1.266-.677-1.558-.339z"
      ></path>
      <path
        fill="#666"
        d="M81.927 36.84c-.201.246.157 2.281 1.476 3.623 1.319 1.318 2.125 1.318 2.661.737 1.029-1.096.201-2.124-.425-2.84-.626-.716-1.431-.47-2.17-1.186-.737-.714-1.252-.67-1.542-.334z"
      ></path>
      <g transform="translate(-3.405 19.001)">
        <path
          fill="#fc0"
          d="M57.6 18.004c.639.441.656.519 1.598 1.135 1.498 1.216 4.16 1.49 5.464 1.533 2.98.474 8.31-2.312 10.419-3.587 1.063-.795 3.029-2.438 3.765-2.466.453.479-.213.579-1.158 1.219-1.262.897-2.341 1.665-4.253 2.75-2.046 1.07-5.19 2.839-9.217 2.601-2.113-.31-2.12-.331-3.424-.997-.776-.56-2.552-1.488-3.194-2.188z"
        ></path>
        <linearGradient
          id="linux-original-c"
          gradientUnits="userSpaceOnUse"
          x1="-257.579"
          y1="-130.856"
          x2="-240.246"
          y2="-130.856"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#FAC700"></stop>
          <stop offset=".415" stop-color="#F7C400"></stop>
          <stop offset="1" stop-color="#F7C400"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-c)"
          d="M57.585 17.999c.622.411.699.53 1.641 1.147 1.491 1.206 4.105 1.49 5.423 1.538 3.024.469 8.411-2.354 10.447-3.603 1.084-.809 3.017-2.42 3.743-2.455.441.476-.235.571-1.19 1.231-1.255.889-2.298 1.636-4.188 2.707-2.031 1.062-5.191 2.84-9.213 2.616-2.119-.305-2.212-.345-3.474-.994-.798-.567-2.543-1.481-3.189-2.187z"
        ></path>
        <linearGradient
          id="linux-original-d"
          gradientUnits="userSpaceOnUse"
          x1="-257.591"
          y1="-130.857"
          x2="-240.258"
          y2="-130.857"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#F6C200"></stop>
          <stop offset=".415" stop-color="#EFBC00"></stop>
          <stop offset="1" stop-color="#EFBC00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-d)"
          d="M57.569 17.992c.605.382.742.542 1.684 1.161 1.483 1.195 4.052 1.491 5.382 1.542 3.067.464 8.513-2.398 10.475-3.619 1.105-.823 3.004-2.403 3.722-2.444.428.47-.257.563-1.224 1.245-1.25.879-2.256 1.605-4.124 2.663-2.016 1.055-5.191 2.84-9.209 2.633-2.124-.3-2.303-.361-3.522-.992-.818-.575-2.534-1.474-3.184-2.189z"
        ></path>
        <linearGradient
          id="linux-original-e"
          gradientUnits="userSpaceOnUse"
          x1="-257.604"
          y1="-130.859"
          x2="-240.269"
          y2="-130.859"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#F1BD00"></stop>
          <stop offset=".415" stop-color="#E8B500"></stop>
          <stop offset="1" stop-color="#E8B500"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-e)"
          d="M57.553 17.986c.59.353.786.553 1.729 1.174 1.475 1.183 3.997 1.49 5.341 1.545 3.109.46 8.613-2.441 10.501-3.633 1.128-.838 2.994-2.387 3.702-2.434.415.466-.279.555-1.256 1.257-1.244.872-2.215 1.577-4.058 2.622-2.001 1.046-5.191 2.84-9.206 2.649-2.132-.296-2.395-.376-3.572-.99-.841-.582-2.527-1.468-3.181-2.19z"
        ></path>
        <linearGradient
          id="linux-original-f"
          gradientUnits="userSpaceOnUse"
          x1="-257.618"
          y1="-130.86"
          x2="-240.282"
          y2="-130.86"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#EDB800"></stop>
          <stop offset=".415" stop-color="#E0AD00"></stop>
          <stop offset="1" stop-color="#E0AD00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-f)"
          d="M57.537 17.98c.573.323.83.566 1.772 1.187 1.467 1.172 3.942 1.49 5.301 1.55 3.153.455 8.713-2.484 10.527-3.648 1.148-.852 2.983-2.37 3.679-2.423.403.46-.299.546-1.288 1.269-1.238.863-2.173 1.547-3.993 2.579-1.985 1.039-5.191 2.841-9.202 2.665-2.138-.292-2.487-.391-3.62-.988-.861-.59-2.518-1.462-3.176-2.191z"
        ></path>
        <linearGradient
          id="linux-original-g"
          gradientUnits="userSpaceOnUse"
          x1="-257.629"
          y1="-130.862"
          x2="-240.292"
          y2="-130.862"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#E9B300"></stop>
          <stop offset=".415" stop-color="#D8A500"></stop>
          <stop offset="1" stop-color="#D8A500"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-g)"
          d="M57.523 17.974c.557.293.872.577 1.815 1.2 1.46 1.162 3.888 1.49 5.26 1.554 3.195.45 8.814-2.527 10.555-3.664 1.169-.866 2.97-2.353 3.658-2.413.39.456-.321.539-1.321 1.282-1.231.854-2.13 1.517-3.929 2.536-1.97 1.031-5.19 2.841-9.198 2.681-2.144-.287-2.579-.405-3.668-.985-.884-.597-2.512-1.455-3.172-2.191z"
        ></path>
        <linearGradient
          id="linux-original-h"
          gradientUnits="userSpaceOnUse"
          x1="-257.642"
          y1="-130.863"
          x2="-240.304"
          y2="-130.863"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#E4AE00"></stop>
          <stop offset=".415" stop-color="#D19E00"></stop>
          <stop offset="1" stop-color="#D19E00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-h)"
          d="M57.506 17.968c.54.264.916.589 1.859 1.213 1.452 1.15 3.834 1.49 5.219 1.559 3.238.445 8.916-2.571 10.582-3.68 1.191-.88 2.959-2.335 3.638-2.402.377.451-.342.531-1.354 1.295-1.225.845-2.088 1.488-3.864 2.493-1.955 1.023-5.191 2.842-9.195 2.697-2.15-.282-2.67-.421-3.716-.984-.906-.604-2.503-1.447-3.169-2.191z"
        ></path>
        <linearGradient
          id="linux-original-i"
          gradientUnits="userSpaceOnUse"
          x1="-257.655"
          y1="-130.864"
          x2="-240.315"
          y2="-130.864"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#E0A900"></stop>
          <stop offset=".415" stop-color="#C99600"></stop>
          <stop offset="1" stop-color="#C99600"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-i)"
          d="M57.491 17.962c.523.234.959.601 1.902 1.226 1.445 1.14 3.779 1.49 5.178 1.562 3.281.44 9.017-2.614 10.609-3.696 1.213-.893 2.948-2.317 3.616-2.39.365.446-.364.522-1.386 1.307-1.22.837-2.047 1.458-3.799 2.45-1.939 1.015-5.191 2.843-9.191 2.713-2.156-.277-2.761-.436-3.766-.981-.927-.611-2.494-1.44-3.163-2.191z"
        ></path>
        <linearGradient
          id="linux-original-j"
          gradientUnits="userSpaceOnUse"
          x1="-257.667"
          y1="-130.866"
          x2="-240.325"
          y2="-130.866"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#DCA400"></stop>
          <stop offset=".415" stop-color="#C18E00"></stop>
          <stop offset="1" stop-color="#C18E00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-j)"
          d="M57.475 17.957c.507.205 1.003.612 1.946 1.239 1.436 1.128 3.724 1.489 5.137 1.566 3.324.436 9.118-2.657 10.636-3.711 1.234-.908 2.936-2.301 3.596-2.38.352.441-.386.515-1.419 1.32-1.213.828-2.005 1.429-3.734 2.408-1.923 1.006-5.191 2.843-9.187 2.729-2.162-.272-2.853-.451-3.814-.979-.951-.62-2.488-1.435-3.161-2.192z"
        ></path>
        <linearGradient
          id="linux-original-k"
          gradientUnits="userSpaceOnUse"
          x1="-257.68"
          y1="-130.866"
          x2="-240.336"
          y2="-130.866"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#D79F00"></stop>
          <stop offset=".415" stop-color="#BA8700"></stop>
          <stop offset="1" stop-color="#BA8700"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-k)"
          d="M57.46 17.95c.491.175 1.047.624 1.989 1.252 1.43 1.117 3.67 1.49 5.097 1.571 3.367.431 9.22-2.7 10.663-3.726 1.257-.922 2.925-2.284 3.574-2.37.34.437-.407.506-1.451 1.332-1.208.819-1.962 1.4-3.669 2.365-1.908.999-5.19 2.843-9.183 2.746-2.167-.268-2.944-.466-3.863-.977-.974-.626-2.481-1.427-3.157-2.193z"
        ></path>
        <linearGradient
          id="linux-original-l"
          gradientUnits="userSpaceOnUse"
          x1="-257.693"
          y1="-130.867"
          x2="-240.346"
          y2="-130.867"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#D39B00"></stop>
          <stop offset=".415" stop-color="#B27F00"></stop>
          <stop offset="1" stop-color="#B27F00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-l)"
          d="M57.443 17.944c.475.146 1.091.636 2.033 1.266 1.422 1.106 3.617 1.489 5.058 1.575 3.409.425 9.32-2.744 10.69-3.742 1.277-.936 2.912-2.267 3.552-2.359.327.432-.429.499-1.484 1.345-1.202.811-1.921 1.37-3.605 2.322-1.892.991-5.19 2.844-9.179 2.761-2.173-.263-3.037-.48-3.912-.975-.994-.633-2.472-1.42-3.153-2.193z"
        ></path>
        <linearGradient
          id="linux-original-m"
          gradientUnits="userSpaceOnUse"
          x1="-257.705"
          y1="-130.868"
          x2="-240.357"
          y2="-130.868"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#CF9600"></stop>
          <stop offset=".415" stop-color="#a70"></stop>
          <stop offset="1" stop-color="#a70"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-m)"
          d="M57.428 17.938c.458.116 1.134.647 2.077 1.278 1.414 1.095 3.562 1.489 5.016 1.579 3.452.421 9.421-2.786 10.717-3.757 1.299-.95 2.901-2.25 3.532-2.349.314.427-.45.491-1.517 1.357-1.196.802-1.878 1.34-3.54 2.28-1.877.982-5.19 2.844-9.175 2.778-2.18-.259-3.128-.496-3.961-.973-1.017-.64-2.464-1.412-3.149-2.193z"
        ></path>
        <linearGradient
          id="linux-original-n"
          gradientUnits="userSpaceOnUse"
          x1="-257.718"
          y1="-130.869"
          x2="-240.367"
          y2="-130.869"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#CA9100"></stop>
          <stop offset=".415" stop-color="#A37000"></stop>
          <stop offset="1" stop-color="#A37000"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-n)"
          d="M57.413 17.932c.442.086 1.176.659 2.12 1.291 1.407 1.084 3.507 1.49 4.976 1.583 3.495.416 9.522-2.829 10.744-3.773 1.321-.964 2.889-2.231 3.51-2.337.302.422-.471.483-1.549 1.371-1.189.793-1.836 1.311-3.475 2.237-1.862.974-5.19 2.844-9.171 2.794-2.186-.255-3.22-.511-4.009-.971-1.041-.648-2.458-1.407-3.146-2.195z"
        ></path>
        <linearGradient
          id="linux-original-o"
          gradientUnits="userSpaceOnUse"
          x1="-257.731"
          y1="-130.869"
          x2="-240.377"
          y2="-130.869"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#C68C00"></stop>
          <stop offset=".415" stop-color="#9B6800"></stop>
          <stop offset="1" stop-color="#9B6800"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-o)"
          d="M57.397 17.926c.426.057 1.221.67 2.164 1.305 1.399 1.073 3.454 1.489 4.935 1.587 3.538.412 9.623-2.873 10.772-3.788 1.342-.979 2.877-2.215 3.488-2.327.289.417-.493.475-1.582 1.383-1.184.785-1.794 1.281-3.41 2.194-1.847.966-5.191 2.845-9.168 2.81-2.194-.25-3.312-.525-4.059-.968-1.061-.657-2.448-1.401-3.14-2.196z"
        ></path>
        <linearGradient
          id="linux-original-p"
          gradientUnits="userSpaceOnUse"
          x1="-257.744"
          y1="-130.87"
          x2="-240.387"
          y2="-130.87"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#C28700"></stop>
          <stop offset=".415" stop-color="#936000"></stop>
          <stop offset="1" stop-color="#936000"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-p)"
          d="M57.381 17.92c.409.027 1.263.682 2.207 1.318 1.392 1.062 3.399 1.489 4.894 1.592 3.581.406 9.725-2.916 10.798-3.804 1.364-.992 2.866-2.198 3.468-2.316.275.413-.516.467-1.615 1.396-1.177.776-1.752 1.252-3.345 2.151-1.832.959-5.191 2.846-9.164 2.826-2.2-.245-3.403-.541-4.106-.966-1.083-.664-2.441-1.394-3.137-2.197z"
        ></path>
        <linearGradient
          id="linux-original-q"
          gradientUnits="userSpaceOnUse"
          x1="-257.756"
          y1="-130.871"
          x2="-240.396"
          y2="-130.871"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#BD8200"></stop>
          <stop offset=".415" stop-color="#8C5900"></stop>
          <stop offset="1" stop-color="#8C5900"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-q)"
          d="M57.366 17.914c.393-.002 1.306.694 2.25 1.331 1.384 1.051 3.345 1.489 4.853 1.596 3.624.402 9.826-2.958 10.826-3.819 1.385-1.006 2.855-2.181 3.447-2.306.262.408-.537.458-1.647 1.408-1.172.768-1.71 1.222-3.28 2.109-1.816.95-5.19 2.845-9.16 2.842-2.204-.241-3.495-.556-4.155-.964-1.106-.671-2.435-1.386-3.134-2.197z"
        ></path>
        <linearGradient
          id="linux-original-r"
          gradientUnits="userSpaceOnUse"
          x1="-257.769"
          y1="-130.871"
          x2="-240.406"
          y2="-130.871"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#B97D00"></stop>
          <stop offset=".415" stop-color="#845100"></stop>
          <stop offset="1" stop-color="#845100"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-r)"
          d="M57.351 17.908c.376-.032 1.349.706 2.293 1.344 1.376 1.04 3.29 1.489 4.812 1.6 3.666.397 9.926-3.002 10.853-3.834 1.406-1.021 2.842-2.163 3.424-2.295.25.403-.558.451-1.68 1.421-1.166.759-1.668 1.193-3.215 2.066-1.8.942-5.19 2.846-9.156 2.858-2.211-.235-3.586-.571-4.204-.962-1.126-.679-2.425-1.38-3.127-2.198z"
        ></path>
        <linearGradient
          id="linux-original-s"
          gradientUnits="userSpaceOnUse"
          x1="-257.782"
          y1="-130.872"
          x2="-240.415"
          y2="-130.872"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#B57800"></stop>
          <stop offset=".415" stop-color="#7C4900"></stop>
          <stop offset="1" stop-color="#7C4900"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-s)"
          d="M57.335 17.901c.36-.061 1.393.718 2.337 1.357 1.368 1.029 3.235 1.489 4.772 1.604 3.709.392 10.027-3.045 10.879-3.851 1.428-1.034 2.831-2.146 3.404-2.284.238.398-.58.443-1.712 1.434-1.16.75-1.626 1.163-3.15 2.023-1.785.935-5.191 2.847-9.153 2.875-2.217-.231-3.679-.586-4.253-.959-1.148-.685-2.417-1.373-3.124-2.199z"
        ></path>
        <linearGradient
          id="linux-original-t"
          gradientUnits="userSpaceOnUse"
          x1="-257.794"
          y1="-130.872"
          x2="-240.424"
          y2="-130.872"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#B07300"></stop>
          <stop offset=".415" stop-color="#754200"></stop>
          <stop offset="1" stop-color="#754200"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-t)"
          d="M57.319 17.896c.343-.091 1.437.729 2.381 1.37 1.361 1.018 3.181 1.489 4.731 1.608 3.752.387 10.128-3.089 10.907-3.866 1.45-1.048 2.819-2.128 3.383-2.273.225.393-.601.435-1.745 1.446-1.153.742-1.584 1.134-3.086 1.98-1.769.926-5.19 2.847-9.149 2.891-2.223-.227-3.769-.602-4.301-.958-1.171-.693-2.41-1.365-3.121-2.198z"
        ></path>
        <linearGradient
          id="linux-original-u"
          gradientUnits="userSpaceOnUse"
          x1="-257.807"
          y1="-130.872"
          x2="-240.433"
          y2="-130.872"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#AC6E00"></stop>
          <stop offset=".415" stop-color="#6D3A00"></stop>
          <stop offset="1" stop-color="#6D3A00"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-u)"
          d="M57.303 17.89c.327-.12 1.481.74 2.425 1.383 1.354 1.006 3.126 1.488 4.69 1.612 3.795.382 10.229-3.132 10.934-3.881 1.471-1.062 2.807-2.112 3.361-2.263.212.389-.623.427-1.777 1.459-1.149.732-1.542 1.104-3.021 1.938-1.755.918-5.191 2.847-9.145 2.906-2.23-.222-3.862-.616-4.351-.956-1.192-.699-2.401-1.358-3.116-2.198z"
        ></path>
        <linearGradient
          id="linux-original-v"
          gradientUnits="userSpaceOnUse"
          x1="-257.82"
          y1="-130.873"
          x2="-240.441"
          y2="-130.873"
          gradientTransform="translate(375.489 179.416) scale(1.234)"
        >
          <stop offset="0" stop-color="#A86A00"></stop>
          <stop offset=".415" stop-color="#663200"></stop>
          <stop offset="1" stop-color="#663200"></stop>
        </linearGradient>
        <path
          fill="url(#linux-original-v)"
          d="M57.288 17.884c.311-.15 1.523.752 2.468 1.396 1.345.996 3.073 1.489 4.649 1.617 3.838.377 10.331-3.175 10.961-3.896 1.493-1.076 2.796-2.095 3.34-2.252.2.384-.645.419-1.809 1.472-1.143.724-1.501 1.075-2.957 1.895-1.738.91-5.19 2.848-9.141 2.922-2.236-.217-3.953-.631-4.399-.953-1.215-.709-2.394-1.354-3.112-2.201z"
        ></path>
      </g>
    </svg>
  );
};

const FlutterIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#3FB6D3">
        <path d="M12.3 64.2L76.3 0h39.4L32.1 83.6zM76.3 128h39.4L81.6 93.9l34.1-34.8H76.3L42.2 93.5z"></path>
      </g>
      <path fill="#27AACD" d="M81.6 93.9l-20-20-19.4 19.6 19.4 19.6z"></path>
      <path fill="#19599A" d="M115.7 128L81.6 93.9l-20 19.2L76.3 128z"></path>
      <linearGradient
        id="flutter-original-a"
        gradientUnits="userSpaceOnUse"
        x1="59.365"
        y1="116.36"
        x2="86.825"
        y2="99.399"
      >
        <stop offset="0" stopColor="#1b4e94"></stop>
        <stop offset=".63" stopColor="#1a5497"></stop>
        <stop offset="1" stopColor="#195a9b"></stop>
      </linearGradient>
      <path
        fill="url(#flutter-original-a)"
        d="M61.6 113.1l30.8-8.4-10.8-10.8z"
      ></path>
    </svg>
  );
};

const LaravelIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD4F31"
        d="M16.934 1.719c-1.127.088-2.234.074-3.325.373-2.387.655-4.508 1.702-6.379 3.316-1.1.948-2.06 1.97-2.875 3.174-1.258 1.859-2.115 3.857-2.545 6.106.172.301.353.617.545.938 1.219 2.038 2.439 4.062 3.661 6.098l3.212 5.341c.988 1.646 1.974 3.293 2.96 4.939l4.608 7.688 3.143 5.244c1.527 2.545 3.058 5.088 4.583 7.634l5.609 9.371c1.617 2.699 3.237 5.396 4.857 8.093l.216.314c.235.075.422.011.616-.035 2.134-.512 4.268-1.021 6.402-1.531 3.461-.827 6.922-1.651 10.383-2.479l5.421-1.297c3.499-.836 6.999-1.67 10.498-2.508 3.537-.846 7.073-1.696 10.611-2.543 1.788-.429 3.576-.856 5.365-1.283 3.461-.826 6.922-1.65 10.383-2.474l11.308-2.693.611-.165-.167-.331-3.086-4.362-3.048-4.315-3.26-4.604-3.116-4.413-3.088-4.361-3.188-4.507c-1.041-1.47-2.084-2.938-3.126-4.407l-1.647-2.326a4.275 4.275 0 01-.587-1.159c-.326-1.011.046-1.684.636-2.181.382-.323.822-.56 1.298-.7a20.898 20.898 0 012.01-.51c1.359-.257 2.727-.475 4.091-.702l4.624-.754c.975-.161 1.949-.33 2.924-.495 1.325-.224 2.65-.449 3.976-.67 1.287-.216 2.574-.43 3.861-.642l4.213-.689 2.924-.491c1.112-.186 2.223-.371 3.334-.553 1.386-.226 2.771-.454 4.157-.671.826-.129 1.652-.174 2.472.062a5.63 5.63 0 011.696.833l.721.503c.072-.166-.032-.256-.08-.351a16.543 16.543 0 00-4.26-5.422 16.399 16.399 0 00-5.636-3.09c-1.229-.389-2.492-.208-3.778-.305M55.689 127c-.062 0-.117-.45-.187-.569-1.5-2.56-3.016-5.308-4.498-7.877a1335.74 1335.74 0 01-5.557-9.74c-1.965-3.478-3.913-6.966-5.863-10.452a5709.989 5709.989 0 01-5.549-9.948c-1.115-2.005-2.223-4.014-3.337-6.02l-.296-.459-.542.107c-1.072.277-2.142.556-3.212.838-1.49.392-2.979.791-4.47 1.18-3.347.871-6.694 1.737-10.041 2.605-3.404.884-6.951 1.77-10.356 2.65-.207.053.219.071-.781.106v21.145c.412.656.373.347.399.563.079.626.207 1.257.317 1.877.412 2.31 1.339 4.425 2.679 6.351 1.965 2.826 4.582 4.846 7.788 6.082 1.145.44 2.34.75 3.562.9l1.241.328"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD4F31"
        d="M4.976 77.742c3.939-.937 7.879-1.873 11.818-2.808 1.73-.41 3.461-.815 5.191-1.227.865-.206 1.732-.402 2.59-.634.764-.206.858-.459.465-1.148-.568-.996-1.146-1.986-1.721-2.979l-5.064-8.72-5.062-8.721c-1.717-2.958-3.436-5.916-5.154-8.873l-4.412-7.59c-.636-1.094-1.408-2.191-2.047-3.284-.119-.199.42-.437-.58-.543v47.396c0-.032.453-.059.606-.096l3.37-.773zm121.248 33.878c-1.544.549-3.089 1.102-4.632 1.655l-10.545 3.781c-1.953.701-3.902 1.41-5.856 2.108-3.982 1.421-7.966 2.837-11.949 4.255-2.308.822-4.617 1.838-6.924 2.664-.632.227-1.255.917-1.881.917h26.49l.57-.327c.674-.029 1.337-.229 1.999-.35 2.719-.497 5.154-1.673 7.311-3.392 1.657-1.321 3.005-2.936 4.061-4.778 1.086-1.896 1.731-3.947 2.041-6.101.027-.186.085-.397-.071-.589-.22-.017-.414.086-.614.157zm-2.275-35.571c-1.168-1.598-2.339-3.193-3.505-4.792-1.609-2.207-3.215-4.416-4.822-6.624-.653-.896-1.315-1.785-1.952-2.691-.192-.273-.411-.346-.71-.265l-.171.049c-2.958.719-5.917 1.436-8.876 2.153l-5.302 1.287-10.372 2.519c-3.419.831-6.838 1.663-10.258 2.492l-10.662 2.582c-3.497.849-6.992 1.701-10.488 2.551l-10.142 2.462c-1.787.434-3.574.866-5.359 1.302-.263.064-.546.08-.826.292l.239.455a5999.968 5999.968 0 009.598 16.529c1.874 3.213 3.753 6.424 5.63 9.636 1.079 1.845 2.151 3.692 3.239 5.532a661.851 661.851 0 003.653 6.115c.369.607.788 1.187 1.21 1.759a3.64 3.64 0 001.046.957c.426.257.885.338 1.369.229.25-.057.495-.139.737-.223l.89-.33c3.237-1.107 6.473-2.214 9.711-3.317 2.526-.86 5.055-1.716 7.583-2.571 2.509-.851 5.02-1.698 7.53-2.545l7.474-2.524c2.548-.861 5.095-1.722 7.642-2.585 3.126-1.061 6.251-2.126 9.379-3.185 3.015-1.02 6.033-2.034 9.049-3.052.185-.062.389-.088.542-.291l.019-.439c.001-6.255-.001-12.511.006-18.766a1.38 1.38 0 00-.289-.873c-.948-1.269-1.877-2.551-2.812-3.828zm-.519-58.938c-.702-.889-1.596-1.171-2.692-.885-.477.125-.967.204-1.453.293-1.594.292-3.19.579-4.784.868-2.334.424-4.667.852-7.001 1.272-1.848.332-3.697.659-5.546.983l-7.418 1.298c-.311.054-.625.108-.925.204-.437.14-.563.414-.363.825.163.336.366.657.586.959 1.534 2.114 3.075 4.223 4.616 6.333 2.124 2.909 4.249 5.817 6.374 8.724 1.798 2.46 3.598 4.92 5.397 7.379 1.414 1.932 2.828 3.864 4.244 5.795l.279.338 12.271-3.033.029-.636c.001-8.511-.001-17.022.006-25.534 0-.376-.091-.678-.328-.976-1.032-1.303-2.045-2.621-3.066-3.933l-.226-.274zm3.301 41.241c-1.856.446-3.719.87-5.62 1.373.201.357 5.415 7.395 5.718 7.729l.19.105.021-.429.001-2.963c.001-1.719.005-3.438.001-5.157 0-.209.059-.434-.085-.646l-.226-.012z"
      ></path>
    </svg>
  );
};

const JQueryIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#0868AC"
        d="M9.625 32.181C-1.404 48.032-.031 68.657 8.394 85.501c.2.404.41.801.617 1.198l.394.759.246.437.439.786c.262.461.53.92.804 1.379l.459.756c.304.491.615.976.933 1.46l.398.614c.439.655.888 1.309 1.352 1.951l.039.05.228.308c.401.553.814 1.099 1.232 1.639l.464.59c.373.469.752.935 1.138 1.399l.435.52a75.27 75.27 0 001.586 1.812l.033.033.061.068a80.44 80.44 0 001.612 1.699l.517.521c.423.426.853.845 1.287 1.262l.527.5c.58.547 1.166 1.083 1.764 1.607l.028.022.307.262c.527.456 1.063.909 1.603 1.353l.664.529c.441.354.887.702 1.336 1.044l.714.543c.496.365.995.724 1.499 1.075l.546.387.15.107c.478.329.967.646 1.456.963l.63.42c.75.474 1.51.943 2.279 1.396l.63.355c.565.326 1.134.646 1.71.959.312.168.632.327.946.488.407.213.811.429 1.225.636l.283.137.501.242c.641.306 1.287.607 1.94.897l.41.184a66.92 66.92 0 002.263.941l.551.217c.704.271 1.418.539 2.135.791l.268.093c.787.275 1.581.53 2.381.779l.575.172c.814.245 1.619.538 2.458.693 53.339 9.727 68.833-32.053 68.833-32.053-13.013 16.953-36.111 21.425-57.996 16.446-.829-.187-1.633-.446-2.442-.685l-.609-.185a72.498 72.498 0 01-2.352-.765l-.323-.117a72.245 72.245 0 01-2.074-.769l-.582-.229c-.752-.297-1.5-.607-2.239-.931l-.447-.198a92.857 92.857 0 01-1.889-.879l-.546-.262c-.491-.239-.977-.493-1.461-.743-.324-.171-.654-.332-.975-.51a58.591 58.591 0 01-1.751-.982l-.591-.33a81.221 81.221 0 01-2.28-1.397l-.615-.41a59.283 59.283 0 01-1.623-1.079l-.522-.367a89.287 89.287 0 01-1.534-1.109l-.679-.514a64.473 64.473 0 01-1.384-1.082l-.617-.495a82.693 82.693 0 01-1.724-1.453l-.189-.159a83.466 83.466 0 01-1.812-1.647l-.511-.491c-.441-.42-.875-.843-1.302-1.277l-.51-.509a70.541 70.541 0 01-1.598-1.69l-.079-.084a67.39 67.39 0 01-1.621-1.844l-.424-.504a70.602 70.602 0 01-1.167-1.442l-.427-.532a78.406 78.406 0 01-1.347-1.794c-12.15-16.574-16.516-39.432-6.805-58.204m25.629-2.434c-7.977 11.478-7.543 26.844-1.321 38.983a50.581 50.581 0 003.528 5.889c1.195 1.713 2.52 3.751 4.106 5.127a48.111 48.111 0 001.79 1.858l.472.465a51.69 51.69 0 001.828 1.698l.074.064.018.018a55.268 55.268 0 002.135 1.767l.485.378a54.08 54.08 0 002.233 1.631l.065.049c.336.232.678.448 1.019.672l.483.319c.544.349 1.095.689 1.655 1.015l.235.136c.483.278.972.552 1.463.818l.521.271c.339.177.678.358 1.023.53l.155.07c.703.346 1.412.68 2.136.995l.472.194c.579.246 1.164.486 1.75.71l.75.275c.533.198 1.068.378 1.607.559l.727.233c.767.238 1.525.539 2.324.672 41.183 6.823 50.691-24.886 50.691-24.886-8.57 12.343-25.168 18.233-42.879 13.635a50.376 50.376 0 01-2.333-.674l-.701-.227a45.423 45.423 0 01-1.631-.562l-.736-.274a56.418 56.418 0 01-1.756-.708l-.473-.2a47.728 47.728 0 01-2.148-.999c-.363-.177-.72-.364-1.078-.548l-.622-.32a44.502 44.502 0 01-1.363-.77l-.326-.185a47.844 47.844 0 01-1.651-1.008l-.498-.332a61.759 61.759 0 01-1.069-.707 57.456 57.456 0 01-2.226-1.628l-.501-.395c-7.752-6.12-13.898-14.486-16.819-23.971-3.062-9.836-2.402-20.878 2.903-29.84m22.278-.775c-4.702 6.92-5.164 15.514-1.901 23.156 3.441 8.113 10.491 14.476 18.72 17.495.339.125.679.237 1.022.354l.451.143c.485.152.966.329 1.467.424 22.74 4.394 28.908-11.669 30.549-14.034-5.402 7.779-14.482 9.646-25.623 6.942-.88-.213-1.847-.531-2.695-.832a33.242 33.242 0 01-3.201-1.329 33.215 33.215 0 01-5.612-3.424c-9.969-7.565-16.162-21.994-9.657-33.745"
      ></path>
    </svg>
  );
};

const CordovaIcon = () => {
  return (
    <svg viewBox="0 0 32 32">
      <defs>
        <linearGradient id="A">
          <stop offset="0" stopColor="#24303a" />
          <stop offset="1" stopColor="#394958" />
        </linearGradient>
        <linearGradient
          id="B"
          x1="371.822"
          y1="391.787"
          x2="55.227"
          y2="187.815"
        >
          <stop offset="0" stopColor="#acacac" />
          <stop offset="1" stopColor="#e9e9e9" />
        </linearGradient>
        <filter id="C" x="-.201" width="1.402" y="-.054" height="1.107">
          <feGaussianBlur stdDeviation="1.11" />
        </filter>
        <filter id="D" x="-.415" width="1.83" y="-.111" height="1.222">
          <feGaussianBlur stdDeviation="2.293" />
        </filter>
        <radialGradient
          id="E"
          gradientTransform="matrix(0.92307901,-11.507692,-5.8964407,-0.47303508,-2165.6993,4248.2015)"
          cx="355.75"
          cy="-334.763"
          fx="355.75"
          fy="-334.763"
          r="16.25"
        >
          <stop offset="0" stopColor="#25303b" />
          <stop offset="1" stopColor="#25303b" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="F"
          x1="327.184"
          y1="311.239"
          x2="311.598"
          y2="126.1"
        />
        <linearGradient
          id="G"
          x1="135.705"
          y1="311.239"
          x2="151.291"
          y2="126.1"
        />
        <linearGradient id="H" x1="352.926" y1="107.19" x2="92.151" y2="133.35">
          <stop offset="0" stopColor="#e5e5e5" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="I"
          x1="182.228"
          y1="190.194"
          x2="182.228"
          y2="317.94"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".532" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="J"
          x1="193.994"
          y1="190.194"
          x2="193.994"
          y2="126.35"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <filter id="K" x="-.131" width="1.262" y="-.358" height="1.715">
          <feGaussianBlur stdDeviation="19.201" />
        </filter>
        <linearGradient id="L" gradientUnits="userSpaceOnUse" />
      </defs>
      <g transform="matrix(.347687 0 0 .347687 14.775537 5.277087)">
        <path
          transform="matrix(.180496 0 0 .15991 -38.18906 .215531)"
          d="M407.2 433.212l-80.56-128.86h-191.5L54.985 433.194z"
          fillOpacity=".57"
          filter="url(#K)"
        />
        <g transform="matrix(.232441 0 0 .232441 -50.19348 -29.321829)">
          <g>
            <path
              d="M341.153 349.75l-23.105 48.268-15.9-60.104zm-212.746 0l15.73 48.268 15.9-60.104z"
              fill="#7f8082"
            />
            <path
              d="M54.985 190.194l-.012.018 32.8 207.807h56.373l-4.605-48.268h28.924l3.684 48.268h118.1l3.684-48.268h28.74l-4.605 48.268h56.74L407.2 190.194H54.985z"
              fill="url(#B)"
            />
            <path
              d="M135.558 317.94l16.956-63.528-1.192-128.3-31.8 64.093z"
              fill="url(#E)"
            />
            <path
              d="M257.328 113.532h70.27l-1.443 155.314H251.9zm-50.828.098l-68.445.042 1.622 154.622h69.684z"
              fill="#293441"
            />
            <path
              d="M145.14 254.4l-9.58 63.53h191.625l-11.4-63.076z"
              fill="#2d3948"
            />
            <path
              d="M327.184 317.94l-16.64-63.077.625-129.17 32.195 64.496z"
              fill="url(#F)"
            />
            <path
              d="M135.705 317.94l16.8-63.53-1.192-128.3-31.797 64.1z"
              fill="url(#G)"
            />
            <path
              d="M199.316 149.428l6.327 134.88h49.285l7.94-134.88z"
              fill="#2d3b48"
            />
            <path
              d="M407.2 190.194L326.65 61.35h-191.5L54.985 190.194h64.54l31.625-63.844h52l-3.835 23.077h63.55l-3.36-23.776H311.3l32.06 64.543z"
              fill="url(#H)"
            />
            <path
              d="M259.508 125.65l52.235.043 31.62 64.5-16.18 127.746h-121.54l62.822-127.746z"
              opacity=".45"
              fill="#363f49"
            />
            <path
              d="M268.465 190.194L205.643 317.94H135.56l-16.035-127.745z"
              opacity=".3"
              fill="url(#I)"
            />
            <path
              d="M151.15 126.35h52l-3.835 23.077h63.55l5.598 40.767H119.523z"
              opacity=".2"
              fill="url(#J)"
            />
          </g>
          <g transform="translate(-14.849 -10.607)">
            <g transform="matrix(.899979 0 0 .977746 -1.495231 573.7235)">
              <ellipse
                ry="24.805"
                rx="6.63"
                cy="-325.399"
                cx="272.593"
                transform="matrix(1.499289 0 0 1.307739 -75.688852 99.470993)"
                opacity=".8"
                fill="#05f0ff"
                filter="url(#D)"
              />
              <g stroke="#06effe" filter="url(#C)">
                <ellipse
                  transform="matrix(1.165326 0 0 1.157833 -3.956438 51.930291)"
                  ry="24.805"
                  rx="6.63"
                  cy="-326.054"
                  cx="289.158"
                  opacity=".9"
                  fill="#fff"
                />
                <ellipse
                  cx="289.158"
                  cy="-326.054"
                  rx="6.63"
                  ry="24.805"
                  transform="matrix(1.165326 0 0 1.070709 -3.956438 23.603105)"
                  opacity=".9"
                  fill="#feffff"
                />
              </g>
            </g>
            <g transform="matrix(.899979 0 0 .977746 -102.68784 578.19963)">
              <ellipse
                transform="matrix(1.499289 0 0 1.307739 -75.688852 99.470993)"
                cx="272.593"
                cy="-325.399"
                rx="6.63"
                ry="24.805"
                opacity=".8"
                fill="#05f0ff"
                filter="url(#D)"
              />
              <g stroke="#06effe" filter="url(#C)">
                <ellipse
                  cx="289.158"
                  cy="-326.054"
                  rx="6.63"
                  ry="24.805"
                  transform="matrix(1.165326 0 0 1.157833 -3.956438 51.930291)"
                  opacity=".9"
                  fill="#fff"
                />
                <ellipse
                  transform="matrix(1.165326 0 0 1.070709 -3.956438 23.603105)"
                  ry="24.805"
                  rx="6.63"
                  cy="-326.054"
                  cx="289.158"
                  opacity=".9"
                  fill="#feffff"
                />
              </g>
            </g>
          </g>
          <path
            d="M151.15 126.35h52l-3.835 23.077h63.55l-3.36-23.776 52.235.043 31.62 64.5-16.18 127.746H135.558l-16.035-127.745z"
            fill="none"
          />
          <path
            d="M342.836 190.194h-223.47"
            opacity=".343"
            fill="#fff"
            stroke="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

const XCodeIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <linearGradient
        id="xcode-original-a"
        gradientUnits="userSpaceOnUse"
        x1="63.947"
        y1="114.165"
        x2="63.947"
        y2="13.784"
      >
        <stop offset="0" stopColor="#1578e4"></stop>
        <stop offset="1" stopColor="#00c3f2"></stop>
      </linearGradient>
      <path
        d="M35.7 13.8h56.5c12.1 0 21.9 9.8 21.9 21.9v56.5c0 12.1-9.8 21.9-21.9 21.9H35.7c-12.1 0-21.9-9.8-21.9-21.9V35.7c0-12.1 9.8-21.9 21.9-21.9z"
        fill="url(#xcode-original-a)"
      ></path>
      <path
        fill="#FFF"
        d="M90.5 19.2H37.4c-10.1 0-18.3 8.2-18.3 18.3v53.1c0 10.1 8.2 18.3 18.3 18.3h53.1c10.1 0 18.3-8.2 18.3-18.3V37.4c0-10.1-8.2-18.2-18.3-18.2zm16.8 71.6c0 9.2-7.4 16.6-16.6 16.6H37.2c-9.1 0-16.6-7.4-16.6-16.6V37.2c0-9.2 7.4-16.6 16.6-16.6h53.6c9.1 0 16.6 7.4 16.6 16.6v53.6z"
      ></path>
      <path
        d="M64.1 22.8c-22.6 0-41 18.4-41 41s18.4 41 41 41c22.7 0 41-18.4 41-41s-18.4-41-41-41zm0 81.4c-22.3 0-40.4-18.1-40.4-40.4s18.1-40.4 40.4-40.4c22.3 0 40.4 18.1 40.4 40.4s-18.1 40.4-40.4 40.4z"
        fill="#69c5f3"
      ></path>
      <path
        d="M64.1 31.2c-18.1 0-32.7 14.6-32.7 32.7S46 96.5 64.1 96.5s32.7-14.6 32.7-32.7-14.7-32.6-32.7-32.6zm0 64.6c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.4 32-32 32z"
        fill="#68c5f4"
      ></path>
      <path
        fill="#FFF"
        d="M32.8 71.3h62.4c2.6 0 4.6 2.1 4.6 4.6 0 2.6-2.1 4.6-4.6 4.6H32.8c-2.6 0-4.6-2.1-4.6-4.6-.1-2.5 2-4.6 4.6-4.6z"
      ></path>
      <path
        d="M32.6 72.2h62.6c2 0 3.7 1.6 3.7 3.7v.1c0 2-1.6 3.7-3.7 3.7H32.6c-2 0-3.7-1.6-3.7-3.7v-.2c.1-2 1.7-3.6 3.7-3.6z"
        fill="#0a93e9"
      ></path>
      <path d="M31.1 79.3h65.7l.5-.3H30.6l.5.3z" fill="#1694ea"></path>
      <path d="M29.6 78.1h68.6l.2-.3h-69l.2.3z" fill="#319dec"></path>
      <path d="M29 76.2h69.9v-.4H29v.4z" fill="#65b1ee"></path>
      <path d="M29.7 73.7h68.6l.1.2.1.2h-69l.1-.2.1-.2z" fill="#8ec6f3"></path>
      <path d="M31.2 72.5h65.6l.3.1.3.2H30.6l.3-.2.3-.1z" fill="#95caf3"></path>
      <linearGradient
        id="xcode-original-b"
        gradientUnits="userSpaceOnUse"
        x1="94.037"
        y1="79.666"
        x2="94.037"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M93.4 72.2h-.5s1.7 1.2 1.7 3.9c0 2.5-1.7 3.6-1.7 3.6h.5s1.7-.8 1.7-3.6c0-3-1.7-3.9-1.7-3.9z"
        fill="url(#xcode-original-b)"
      ></path>
      <linearGradient
        id="xcode-original-c"
        gradientUnits="userSpaceOnUse"
        x1="89.042"
        y1="79.666"
        x2="89.042"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M88.6 72.2h-.5s1.5 1.4 1.5 3.9c0 2.2-1.5 3.6-1.5 3.6h.5s1.5-1.1 1.5-3.6c-.1-2.7-1.5-3.9-1.5-3.9z"
        fill="url(#xcode-original-c)"
      ></path>
      <linearGradient
        id="xcode-original-d"
        gradientUnits="userSpaceOnUse"
        x1="63.947"
        y1="79.666"
        x2="63.947"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M63.7 72.2h.5v7.5h-.5v-7.5z"
        fill="url(#xcode-original-d)"
      ></path>
      <linearGradient
        id="xcode-original-e"
        gradientUnits="userSpaceOnUse"
        x1="58.952"
        y1="79.666"
        x2="58.952"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M58.8 72.2h.5s-.2 1.9-.2 3.9c0 1.8.2 3.6.2 3.6h-.5s-.2-1.8-.2-3.6c0-2 .2-3.9.2-3.9z"
        fill="url(#xcode-original-e)"
      ></path>
      <linearGradient
        id="xcode-original-f"
        gradientUnits="userSpaceOnUse"
        x1="53.958"
        y1="79.666"
        x2="53.958"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M54 72.2h.5s-.5 1.9-.5 3.9c0 1.8.5 3.6.5 3.6H54s-.5-1.8-.5-3.6c0-2 .5-3.9.5-3.9z"
        fill="url(#xcode-original-f)"
      ></path>
      <linearGradient
        id="xcode-original-g"
        gradientUnits="userSpaceOnUse"
        x1="48.963"
        y1="79.666"
        x2="48.963"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M49.1 72.2h.5s-.7 1.9-.7 3.9c0 1.8.7 3.6.7 3.6h-.5s-.7-1.8-.7-3.6c0-2 .7-3.9.7-3.9z"
        fill="url(#xcode-original-g)"
      ></path>
      <linearGradient
        id="xcode-original-h"
        gradientUnits="userSpaceOnUse"
        x1="43.968"
        y1="79.666"
        x2="43.968"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M44.2 72.2h.5s-1 1.6-1 3.9c0 2 1 3.6 1 3.6h-.5s-1-1.6-1-3.6c0-2.3 1-3.9 1-3.9z"
        fill="url(#xcode-original-h)"
      ></path>
      <linearGradient
        id="xcode-original-i"
        gradientUnits="userSpaceOnUse"
        x1="38.852"
        y1="79.666"
        x2="38.852"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M39.3 72.2h.5s-1.5 1.4-1.5 3.9c0 2.2 1.5 3.6 1.5 3.6h-.5s-1.5-1.1-1.5-3.6c.1-2.7 1.5-3.9 1.5-3.9z"
        fill="url(#xcode-original-i)"
      ></path>
      <linearGradient
        id="xcode-original-j"
        gradientUnits="userSpaceOnUse"
        x1="33.857"
        y1="79.666"
        x2="33.857"
        y2="72.184"
      >
        <stop offset="0" stopColor="#1492e7"></stop>
        <stop offset="1" stopColor="#dbedfb"></stop>
      </linearGradient>
      <path
        d="M34.5 72.2h.5s-1.7 1.2-1.7 3.9c0 2.5 1.7 3.6 1.7 3.6h-.5s-1.7-.8-1.7-3.6c0-3 1.7-3.9 1.7-3.9z"
        fill="url(#xcode-original-j)"
      ></path>
      <path
        fill="#FFF"
        d="M62 34.1l31.2 54c1.3 2.2.5 5-1.7 6.3-2.2 1.3-5 .5-6.3-1.7L54 38.7c-1.3-2.2-.5-5 1.7-6.3 2.2-1.3 5-.5 6.3 1.7z"
      ></path>
      <linearGradient
        id="xcode-original-k"
        gradientUnits="userSpaceOnUse"
        x1="73.58"
        y1="94.25"
        x2="73.58"
        y2="32.642"
      >
        <stop offset="0" stopColor="#1285e7"></stop>
        <stop offset="1" stopColor="#00b5ef"></stop>
      </linearGradient>
      <path
        d="M61.2 34.5l31.3 54.2c1 1.7.4 4-1.3 5l-.2.1c-1.7 1-4 .4-5-1.3L54.7 38.2c-1-1.7-.4-4 1.3-5l.1-.1c1.8-1 4.1-.4 5.1 1.4z"
        fill="url(#xcode-original-k)"
      ></path>
      <linearGradient
        id="xcode-original-l"
        gradientUnits="userSpaceOnUse"
        x1="87.464"
        y1="93.978"
        x2="54.081"
        y2="36.156"
      >
        <stop offset="0" stopColor="#2b90e7"></stop>
        <stop offset="1" stopColor="#00b6ef"></stop>
      </linearGradient>
      <path
        d="M54.2 36.7L87 93.6l.2.1.2.1.2.1-33.4-57.8v.6z"
        fill="url(#xcode-original-l)"
      ></path>
      <linearGradient
        id="xcode-original-m"
        gradientUnits="userSpaceOnUse"
        x1="89.073"
        y1="94.327"
        x2="54.583"
        y2="34.589"
      >
        <stop offset="0" stopColor="#3795ea"></stop>
        <stop offset="1" stopColor="#49c4f2"></stop>
      </linearGradient>
      <path
        d="M54.5 34.8l34.3 59.4h.4L54.7 34.5l-.1.2-.1.1z"
        fill="url(#xcode-original-m)"
      ></path>
      <linearGradient
        id="xcode-original-n"
        gradientUnits="userSpaceOnUse"
        x1="91.026"
        y1="93.735"
        x2="56.072"
        y2="33.193"
      >
        <stop offset="0" stopColor="#3696ea"></stop>
        <stop offset="1" stopColor="#90d9f6"></stop>
      </linearGradient>
      <path
        d="M55.9 33.3l35 60.5.3-.2-35-60.5-.3.2z"
        fill="url(#xcode-original-n)"
      ></path>
      <linearGradient
        id="xcode-original-o"
        gradientUnits="userSpaceOnUse"
        x1="92.582"
        y1="92.332"
        x2="58.065"
        y2="32.547"
      >
        <stop offset="0" stopColor="#3097ea"></stop>
        <stop offset="1" stopColor="#b5e5f9"></stop>
      </linearGradient>
      <path
        d="M58.4 32.7L92.6 92l-.1.2-.1.2-34.5-59.8h.2l.3.1z"
        fill="url(#xcode-original-o)"
      ></path>
      <linearGradient
        id="xcode-original-p"
        gradientUnits="userSpaceOnUse"
        x1="93.083"
        y1="90.686"
        x2="59.741"
        y2="32.936"
      >
        <stop offset="0" stopColor="#3a98ea"></stop>
        <stop offset="1" stopColor="#bce7fa"></stop>
      </linearGradient>
      <path
        d="M60.2 33.3L93 90.1v.6L59.6 33l.2.1.2.1.2.1z"
        fill="url(#xcode-original-p)"
      ></path>
      <path
        fill="#3c98ea"
        d="M91.5 86.9l-.2-.4s-.2 2-2.4 3.4c-2.1 1.3-4 .4-4 .4l.2.4s1.6 1.1 4-.4c2.4-1.4 2.4-3.4 2.4-3.4zM89 82.7l-.2-.4s-.5 2-2.6 3.2c-1.9 1.2-3.8.6-3.8.6l.2.4s1.7.7 3.9-.6c2.2-1.3 2.5-3.2 2.5-3.2z"
      ></path>
      <path
        d="M86.6 78.5l-.2-.4s-.9 1.7-2.8 2.8c-1.7 1-3.6 1-3.6 1l.2.4s1.8 0 3.6-1c1.9-1.1 2.8-2.8 2.8-2.8z"
        fill="#4ca4ed"
      ></path>
      <path
        d="M84.2 74.3l-.2-.4s-1.3 1.7-3 2.6c-1.6.9-3.5 1.2-3.5 1.2l.2.4s1.9-.3 3.5-1.2c1.6-.9 3-2.6 3-2.6z"
        fill="#4da7ee"
      ></path>
      <linearGradient
        id="xcode-original-q"
        gradientUnits="userSpaceOnUse"
        x1="67.981"
        y1="61.226"
        x2="74.457"
        y2="57.487"
      >
        <stop offset="0" stopColor="#00a4ec"></stop>
        <stop offset="1" stopColor="#b9dff6"></stop>
      </linearGradient>
      <path
        d="M74.3 57.3l.2.4s-1.7.8-3.4 1.7c-1.6.9-3 2.1-3 2.1l-.2-.4s1.5-1.2 3-2.1c1.7-.9 3.4-1.7 3.4-1.7z"
        fill="url(#xcode-original-q)"
      ></path>
      <linearGradient
        id="xcode-original-r"
        gradientUnits="userSpaceOnUse"
        x1="65.487"
        y1="56.906"
        x2="71.962"
        y2="53.167"
      >
        <stop offset="0" stopColor="#00a4ec"></stop>
        <stop offset="1" stopColor="#b9dff6"></stop>
      </linearGradient>
      <path
        d="M71.9 53.1l.2.4s-1.9.6-3.5 1.6c-1.6.9-2.9 2.3-2.9 2.3l-.2-.4s1.3-1.4 2.9-2.3c1.6-1.1 3.5-1.6 3.5-1.6z"
        fill="url(#xcode-original-r)"
      ></path>
      <path
        d="M67.4 49.8c1.3-.4 2.3-.6 2.3-.6l-.2-.4s-.9.1-1.9.5c-.6.2-.7.7-.2.5z"
        fill="#9dd4f7"
      ></path>
      <linearGradient
        id="xcode-original-s"
        gradientUnits="userSpaceOnUse"
        x1="57.93"
        y1="43.819"
        x2="64.364"
        y2="40.105"
      >
        <stop offset="0" stopColor="#00b4ef"></stop>
        <stop offset="1" stopColor="#c3e9fa"></stop>
      </linearGradient>
      <path
        d="M64.6 40.5l.2.4s-1.9-.5-4.1.7c-1.9 1.2-2.3 3.1-2.3 3.1l-.2-.4s.2-1.7 2.3-3c2.2-1.4 4.1-.8 4.1-.8z"
        fill="url(#xcode-original-s)"
      ></path>
      <linearGradient
        id="xcode-original-t"
        gradientUnits="userSpaceOnUse"
        x1="55.424"
        y1="39.477"
        x2="61.9"
        y2="35.738"
      >
        <stop offset="0" stopColor="#00b4ef"></stop>
        <stop offset="1" stopColor="#c3e9fa"></stop>
      </linearGradient>
      <path
        d="M62.2 36.2l.3.4s-2-.8-4.3.5C56 38.5 56 40.4 56 40.4l-.3-.4s-.2-1.7 2.2-3.2c2.5-1.5 4.3-.6 4.3-.6z"
        fill="url(#xcode-original-t)"
      ></path>
      <path
        fill="#FFF"
        d="M55.5 71.3c8.7-15 18.7-32.4 18.7-32.4 1.3-2.2.5-5-1.7-6.3-2.2-1.3-5-.5-6.3 1.7 0 0-12.2 21.2-21.4 37h10.7zm-5.4 9.2C45.9 87.7 43 92.9 43 92.9c-1.3 2.2-4.1 3-6.3 1.7s-3-4.1-1.7-6.3c0 0 1.7-3.1 4.4-7.7 3.4-.1 9.6-.1 10.7-.1z"
      ></path>
      <linearGradient
        id="xcode-original-u"
        gradientUnits="userSpaceOnUse"
        x1="54.566"
        y1="94.401"
        x2="54.566"
        y2="32.794"
      >
        <stop offset="0" stopColor="#1285e7"></stop>
        <stop offset="1" stopColor="#00b5ef"></stop>
      </linearGradient>
      <path
        d="M54.4 71.3c8.8-15.2 19-32.9 19-32.9 1-1.7.4-4-1.3-5l-.1-.1c-1.7-1-4-.4-5 1.3 0 0-12 20.8-21.2 36.7h8.6zm-5.3 9.2c-4 7-6.9 12-6.9 12-1 1.7-3.2 2.3-5 1.3H37c-1.7-1-2.3-3.2-1.3-5 0 0 1.9-3.3 4.8-8.3h8.6z"
        fill="url(#xcode-original-u)"
      ></path>
      <linearGradient
        id="xcode-original-v"
        gradientUnits="userSpaceOnUse"
        x1="40.681"
        y1="94.131"
        x2="74.064"
        y2="36.311"
      >
        <stop offset="0" stopColor="#3194e9"></stop>
        <stop offset="1" stopColor="#71cff4"></stop>
      </linearGradient>
      <path
        d="M54.1 71.3L74 36.9v-.6s-11 19.1-20.2 35h.3zm-5.4 9.2l-7.6 13.2-.3.2-.3.1s3.4-5.9 7.8-13.5h.4z"
        fill="url(#xcode-original-v)"
      ></path>
      <linearGradient
        id="xcode-original-w"
        gradientUnits="userSpaceOnUse"
        x1="39.063"
        y1="94.482"
        x2="73.557"
        y2="34.736"
      >
        <stop offset="0" stopColor="#5aa6ec"></stop>
        <stop offset="1" stopColor="#a2def8"></stop>
      </linearGradient>
      <path
        d="M52.6 71.3l21-36.3-.1-.2-.1-.2S61.9 54.5 52.3 71.2l.3.1zm-5.3 9.2l-8 13.8h-.4s3.4-5.9 8-13.9c.2.1.4.1.4.1z"
        fill="url(#xcode-original-w)"
      ></path>
      <linearGradient
        id="xcode-original-x"
        gradientUnits="userSpaceOnUse"
        x1="37.118"
        y1="93.885"
        x2="72.072"
        y2="33.343"
      >
        <stop offset="0" stopColor="#66abee"></stop>
        <stop offset="1" stopColor="#bee8fa"></stop>
      </linearGradient>
      <path
        d="M50.4 71.3c9.9-17.1 21.8-37.8 21.8-37.8l-.3-.2-22 38h.5zM45 80.6C40.6 88.3 37.3 94 37.3 94l-.3-.2s3.2-5.6 7.6-13.2c.2-.1.1-.1.4 0z"
        fill="url(#xcode-original-x)"
      ></path>
      <linearGradient
        id="xcode-original-y"
        gradientUnits="userSpaceOnUse"
        x1="35.568"
        y1="92.482"
        x2="70.085"
        y2="32.697"
      >
        <stop offset="0" stopColor="#7bb6f0"></stop>
        <stop offset="1" stopColor="#b1e3f9"></stop>
      </linearGradient>
      <path
        d="M48 71.3c9.9-17.1 22.2-38.5 22.2-38.5h-.4S57.5 54.1 47.6 71.3h.4zm-5.8 9.2c-4 6.9-6.7 11.6-6.7 11.6l.1.2.1.2s2.9-5 7-12h-.5z"
        fill="url(#xcode-original-y)"
      ></path>
      <linearGradient
        id="xcode-original-z"
        gradientUnits="userSpaceOnUse"
        x1="35.056"
        y1="90.872"
        x2="68.415"
        y2="33.092"
      >
        <stop offset="0" stopColor="#5aa6ec"></stop>
        <stop offset="1" stopColor="#afe3f9"></stop>
      </linearGradient>
      <path
        d="M46.5 71.3l22-38.1-.2.1-.2.1-.1.1S55.8 54.6 46.2 71.3h.3zm-5.3 9.2c-3.5 6.1-6 10.4-6 10.4v-.8s2.2-3.8 5.6-9.7c.2.1.2.1.4.1z"
        fill="url(#xcode-original-z)"
      ></path>
      <linearGradient
        id="xcode-original-A"
        gradientUnits="userSpaceOnUse"
        x1="66.362"
        y1="35.689"
        x2="72.838"
        y2="39.428"
      >
        <stop offset="0" stopColor="#c1e7fa"></stop>
        <stop offset="1" stopColor="#89d4f5"></stop>
      </linearGradient>
      <path
        d="M66 36.2l-.2.4s1.8-.9 4.2.4c2.2 1.2 2.3 3.3 2.3 3.3l.2-.4s.2-1.9-2.3-3.3-4.2-.4-4.2-.4z"
        fill="url(#xcode-original-A)"
      ></path>
      <linearGradient
        id="xcode-original-B"
        gradientUnits="userSpaceOnUse"
        x1="63.856"
        y1="40.03"
        x2="70.332"
        y2="43.768"
      >
        <stop offset="0" stopColor="#c1e7fa"></stop>
        <stop offset="1" stopColor="#89d4f5"></stop>
      </linearGradient>
      <path
        d="M63.6 40.5l-.2.4s2-.6 4.1.6c2 1.1 2.4 3 2.4 3l.2-.4s-.2-1.8-2.4-3c-2.3-1.3-4.1-.6-4.1-.6z"
        fill="url(#xcode-original-B)"
      ></path>
      <linearGradient
        id="xcode-original-C"
        gradientUnits="userSpaceOnUse"
        x1="61.273"
        y1="44.505"
        x2="67.748"
        y2="48.243"
      >
        <stop offset="0" stopColor="#c1e7fa"></stop>
        <stop offset="1" stopColor="#89d4f5"></stop>
      </linearGradient>
      <path
        d="M61.1 44.7l-.2.4s1.8-.1 3.8 1.1c1.8 1 2.7 2.6 2.7 2.6l.2-.4s-.9-1.6-2.7-2.6c-1.9-1.1-3.8-1.1-3.8-1.1z"
        fill="url(#xcode-original-C)"
      ></path>
      <linearGradient
        id="xcode-original-D"
        gradientUnits="userSpaceOnUse"
        x1="58.761"
        y1="48.855"
        x2="65.236"
        y2="52.594"
      >
        <stop offset="0" stopColor="#b0dff8"></stop>
        <stop offset="1" stopColor="#52bdf2"></stop>
      </linearGradient>
      <path
        d="M58.7 49l-.2.4s2 .3 3.7 1.3c1.6.9 2.8 2.4 2.8 2.4l.2-.4s-1.2-1.5-2.8-2.4c-1.7-1-3.7-1.3-3.7-1.3z"
        fill="url(#xcode-original-D)"
      ></path>
      <linearGradient
        id="xcode-original-E"
        gradientUnits="userSpaceOnUse"
        x1="56.25"
        y1="53.204"
        x2="62.727"
        y2="56.943"
      >
        <stop offset="0" stopColor="#b4def8"></stop>
        <stop offset="1" stopColor="#4eb5f0"></stop>
      </linearGradient>
      <path
        d="M56.2 53.2l-.2.4s1.9.5 3.6 1.5c1.6.9 2.9 2.2 2.9 2.2l.2-.4s-1.3-1.3-2.9-2.2c-1.6-.9-3.6-1.5-3.6-1.5z"
        fill="url(#xcode-original-E)"
      ></path>
      <linearGradient
        id="xcode-original-F"
        gradientUnits="userSpaceOnUse"
        x1="53.74"
        y1="57.553"
        x2="60.215"
        y2="61.291"
      >
        <stop offset="0" stopColor="#b4def8"></stop>
        <stop offset="1" stopColor="#4eb5f0"></stop>
      </linearGradient>
      <path
        d="M53.8 57.4l-.3.4s1.8.7 3.5 1.7c1.6.9 3 2 3 2l.2-.4s-1.4-1.1-3-2c-1.6-.9-3.4-1.7-3.4-1.7z"
        fill="url(#xcode-original-F)"
      ></path>
      <linearGradient
        id="xcode-original-G"
        gradientUnits="userSpaceOnUse"
        x1="51.239"
        y1="61.886"
        x2="57.713"
        y2="65.624"
      >
        <stop offset="0" stopColor="#b5ddf8"></stop>
        <stop offset="1" stopColor="#46aeee"></stop>
      </linearGradient>
      <path
        d="M51.1 62.1l.2-.4 6.5 3.7-.2.4-6.5-3.7z"
        fill="url(#xcode-original-G)"
      ></path>
      <linearGradient
        id="xcode-original-H"
        gradientUnits="userSpaceOnUse"
        x1="48.735"
        y1="66.22"
        x2="55.211"
        y2="69.959"
      >
        <stop offset="0" stopColor="#96cef4"></stop>
        <stop offset="1" stopColor="#46aaee"></stop>
      </linearGradient>
      <path
        d="M48.7 66.4l.2-.4s1.6 1.2 3.3 2.1c1.6.9 3.2 1.6 3.2 1.6l-.2.3s-1.7-.7-3.3-1.6c-1.7-.9-3.2-2-3.2-2z"
        fill="url(#xcode-original-H)"
      ></path>
      <path
        d="M47.1 71.3c-.5-.4-.8-.7-.8-.7l.2-.4s.6.5 1.4 1.1h-.8z"
        fill="#73b9f1"
      ></path>
      <linearGradient
        id="xcode-original-I"
        gradientUnits="userSpaceOnUse"
        x1="42.719"
        y1="80.135"
        x2="47.681"
        y2="83"
      >
        <stop offset="0" stopColor="#8fc1f2"></stop>
        <stop offset="1" stopColor="#3193ea"></stop>
      </linearGradient>
      <path
        d="M43.2 80.5c.4.3.8.6 1.3.9 1.8 1 3.6.9 3.6.9l-.2.4s-1.8.1-3.6-.9c-.7-.4-1.3-.9-1.7-1.3h.6z"
        fill="url(#xcode-original-I)"
      ></path>
      <linearGradient
        id="xcode-original-J"
        gradientUnits="userSpaceOnUse"
        x1="38.634"
        y1="83.717"
        x2="45.11"
        y2="87.456"
      >
        <stop offset="0" stopColor="#8fc1f2"></stop>
        <stop offset="1" stopColor="#3193ea"></stop>
      </linearGradient>
      <path
        d="M38.9 83.3l.2-.4s.5 2 2.7 3.2c2 1.1 3.8.5 3.8.5l-.2.4s-1.6.7-3.8-.5c-2.3-1.3-2.7-3.2-2.7-3.2z"
        fill="url(#xcode-original-J)"
      ></path>
      <linearGradient
        id="xcode-original-K"
        gradientUnits="userSpaceOnUse"
        x1="36.124"
        y1="88.063"
        x2="42.599"
        y2="91.802"
      >
        <stop offset="0" stopColor="#8fc1f2"></stop>
        <stop offset="1" stopColor="#3193ea"></stop>
      </linearGradient>
      <path
        d="M36.4 87.6l.2-.4s.2 2.1 2.6 3.4c2.2 1.2 3.9.3 3.9.3l-.3.4s-1.5 1.1-3.9-.3c-2.5-1.4-2.5-3.4-2.5-3.4z"
        fill="url(#xcode-original-K)"
      ></path>
      <linearGradient
        id="xcode-original-L"
        gradientUnits="userSpaceOnUse"
        x1="76.722"
        y1="64.933"
        x2="89.179"
        y2="71.008"
      >
        <stop offset=".001"></stop>
        <stop offset="1" stopOpacity="0"></stop>
      </linearGradient>
      <path
        d="M68.8 114.2l42.8-89.9-10.8-5.1-44.6 93.5s1.4.7 3.2 1.5h9.4z"
        fill="url(#xcode-original-L)"
      ></path>
      <radialGradient
        id="xcode-original-M"
        cx="95.237"
        cy="25.132"
        r="16.181"
        fx="79.585"
        fy="25.974"
        gradientTransform="matrix(-.4494 .8933 -1.5457 -.7777 176.886 -40.4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0"></stop>
        <stop offset="1" stopOpacity="0"></stop>
      </radialGradient>
      <path
        d="M94.1 13.8l20 9.5V52C107.2 48.7 61 26.7 61 26.7s3.2-6.7 6.2-12.9h26.9z"
        fill="url(#xcode-original-M)"
      ></path>
      <radialGradient
        id="xcode-original-N"
        cx="51.211"
        cy="114.953"
        r="7.901"
        fx="51.196"
        fy="117.292"
        gradientTransform="matrix(.8979 .4402 -.2506 .5111 34.032 33.662)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".417" stopColor="#0c0c12"></stop>
        <stop offset="1" stopColor="#3d4651"></stop>
      </radialGradient>
      <path
        d="M44.5 110.2c-.3.6-.8 1.3-.7 2.4.1 4.1 6.8 7.9 10.7 7.9 2.7 0 3.6-1.1 4.6-3.1s-13.5-9.6-14.6-7.2z"
        fill="url(#xcode-original-N)"
      ></path>
      <linearGradient
        id="xcode-original-O"
        gradientUnits="userSpaceOnUse"
        x1="84.758"
        y1="39.174"
        x2="94.522"
        y2="44.149"
      >
        <stop offset="0" stopColor="#344351"></stop>
        <stop offset=".1" stopColor="#9697a0"></stop>
        <stop offset=".181" stopColor="#8b8c95"></stop>
        <stop offset=".351" stopColor="#787a83"></stop>
        <stop offset=".47" stopColor="#71747d"></stop>
        <stop offset=".591" stopColor="#777982"></stop>
        <stop offset=".749" stopColor="#87898f"></stop>
        <stop offset=".8" stopColor="#8e8f94"></stop>
        <stop offset=".849" stopColor="#3d3b42"></stop>
        <stop offset=".9" stopColor="#606e84"></stop>
      </linearGradient>
      <path
        d="M90.6 25.1s10.3 2.5 11.1 3.2-1.3 4.7-1.7 5.3c-3.3 4-13.6 26.1-13.6 26.1l-9.5-5.4s8.5-15.8 11.5-21.4c1.9-3.8 2.2-7.8 2.2-7.8z"
        fill="url(#xcode-original-O)"
      ></path>
      <linearGradient
        id="xcode-original-P"
        gradientUnits="userSpaceOnUse"
        x1="117.884"
        y1="29.257"
        x2="106.863"
        y2="14.364"
      >
        <stop offset=".27" stopColor="#262b33"></stop>
        <stop offset=".45" stopColor="#74747e"></stop>
        <stop offset=".54" stopColor="#b0b0bc"></stop>
        <stop offset=".73" stopColor="#74747e"></stop>
      </linearGradient>
      <path
        d="M114.4 19.9c1.8 1.3 4.2 1 6.1.7 1.3-.2-.7 1.7-2.9 6.1s-2.1 4.7-2.4 4.4c-.3-.3-10.2-5.9-9.9-6.4.4-.5 2-11.4 2.8-11.1 2.9.7 3.4 4.2 6.3 6.3z"
        fill="url(#xcode-original-P)"
      ></path>
      <linearGradient
        id="xcode-original-Q"
        gradientUnits="userSpaceOnUse"
        x1="98.542"
        y1="30.424"
        x2="114.815"
        y2="28.322"
      >
        <stop offset=".14" stopColor="#606e84"></stop>
        <stop offset=".4" stopColor="#9899a5"></stop>
        <stop offset=".73" stopColor="#475768"></stop>
        <stop offset=".92" stopColor="#262b33"></stop>
      </linearGradient>
      <path
        d="M99 32.2c.7-1.1 3.9-7.9 9-7.9 2.3 0 6.7 5.8 7.1 6.6.3.7-.7 3.5-1.2 2.2-.6-1.5-3.1-4.7-5.8-4.7s-6.4 3.1-7.3 4.2c-.9 1-2.5.7-1.8-.4z"
        fill="url(#xcode-original-Q)"
      ></path>
      <linearGradient
        id="xcode-original-R"
        gradientUnits="userSpaceOnUse"
        x1="106.128"
        y1="31.808"
        x2="104.549"
        y2="22.854"
      >
        <stop offset="0" stopColor="#101215" stopOpacity=".1"></stop>
        <stop offset=".46" stopColor="#101215" stopOpacity=".7"></stop>
        <stop offset=".7" stopColor="#474951"></stop>
        <stop offset=".91" stopColor="#7b7d88"></stop>
      </linearGradient>
      <path
        d="M98.8 31.8c.5-.8 2.8-4.3 3.9-5.4s3.9-4 6.3-4.4c2.4-.4 4.9 4.5 4.1 5.5-.6.7-1.6-.1-2.8-1.1-1.2-.9-2-2.7-5.8.2-1.3 1-2.6 1.8-5.6 6.1-.8 1.1-.6-.1-.1-.9z"
        fill="url(#xcode-original-R)"
      ></path>
      <linearGradient
        id="xcode-original-S"
        gradientUnits="userSpaceOnUse"
        x1="58.131"
        y1="81.721"
        x2="73.237"
        y2="89.154"
      >
        <stop offset=".115" stopColor="#2c3952"></stop>
        <stop offset=".374" stopColor="#3d414e"></stop>
        <stop offset=".55" stopColor="#474a54"></stop>
        <stop offset=".754" stopColor="#4e5057"></stop>
        <stop offset=".892" stopColor="#323945"></stop>
        <stop offset="1" stopColor="#143052"></stop>
      </linearGradient>
      <path
        d="M86.4 61c.4-.8.9-2-.2-2.9-1.2-.9-6.8-3.9-7.8-4.1-1-.2-1.8 0-2.2.7-.4.7-31.1 53.3-31.7 54.8-.6 1.5-.7 2.6.2 2.9.9.3 11.2 5.2 12.2 6.3 1 1.1 1.5-.1 1.9-.7 1.9-2.4 27.1-56.2 27.6-57z"
        fill="url(#xcode-original-S)"
      ></path>
      <linearGradient
        id="xcode-original-T"
        gradientUnits="userSpaceOnUse"
        x1="81.508"
        y1="31.679"
        x2="93.19"
        y2="6.047"
      >
        <stop offset=".118" stopColor="#6d7078" stopOpacity="0"></stop>
        <stop offset=".2" stopColor="#6d7078" stopOpacity=".7"></stop>
        <stop offset=".34" stopColor="#35363a"></stop>
        <stop offset=".374" stopColor="#1d1f22"></stop>
        <stop offset=".4" stopColor="#101215"></stop>
        <stop offset=".5" stopColor="#16171a"></stop>
        <stop offset=".56" stopColor="#292a2e"></stop>
        <stop offset=".688" stopColor="#4b4d51"></stop>
        <stop offset=".807" stopColor="#63666b"></stop>
        <stop offset=".915" stopColor="#72757b"></stop>
        <stop offset="1" stopColor="#777a80"></stop>
      </linearGradient>
      <path
        d="M99.5 31.6c.5-.7 1.7-2.7 3.2-4.5 1-1.2 6.4-3.8 7.6-8 .7-2.3-.4-4.6-1.9-5.6-5.1-3.1-13.9-8-26.8-8-8.7 0-12.4 2.9-12.4 2.9h4.4l15.3 6 1.9 8s.2 2.7-.7 5.8c-.6 2.5-.8 4-1.7 6.5.7.3 2.3-.8 4.1-.3 1.6.4 2.6 2.6 3.7 1.3 1.9-2.5 2.5-3 3.3-4.1z"
        fill="url(#xcode-original-T)"
      ></path>
      <linearGradient
        id="xcode-original-U"
        gradientUnits="userSpaceOnUse"
        x1="69.064"
        y1="16.837"
        x2="91.026"
        y2="16.837"
      >
        <stop offset="0" stopColor="#4a4d56"></stop>
        <stop offset="1" stopColor="#29292d"></stop>
      </linearGradient>
      <path
        d="M90.5 25.4C89.7 18 87.9 11 69.1 11.1c1.2-1.2 4.1-2.4 4.1-2.4l-4.1-.3s.6-.5 1.8-.6c11-.9 20.8 1.4 20.1 15.7-.1 2.3-.3 3.3-.5 1.9z"
        fill="url(#xcode-original-U)"
      ></path>
      <linearGradient
        id="xcode-original-V"
        gradientUnits="userSpaceOnUse"
        x1="69.064"
        y1="11.697"
        x2="88.054"
        y2="11.697"
      >
        <stop offset="0" stopColor="#767880"></stop>
        <stop offset=".41" stopColor="#0c0a0b"></stop>
      </linearGradient>
      <path
        d="M69.1 11.1c1.3-.5 3.1-.8 6.5-.6 4.2.2 9.5 1.8 11.7 3.8 1.1 1 1 .2-.2-1.1-3.1-3.6-7.8-4.4-13.9-4.5-.7-.1-3 1.2-4.1 2.4z"
        fill="url(#xcode-original-V)"
      ></path>
      <linearGradient
        id="xcode-original-W"
        gradientUnits="userSpaceOnUse"
        x1="116.332"
        y1="34.756"
        x2="123.707"
        y2="21.982"
      >
        <stop offset="0" stopColor="#858997"></stop>
        <stop offset=".23" stopColor="#244668"></stop>
        <stop offset=".282" stopColor="#1a3249"></stop>
        <stop offset=".4" stopColor="#040506"></stop>
        <stop offset=".464" stopColor="#313236"></stop>
        <stop offset=".546" stopColor="#65656e"></stop>
        <stop offset=".607" stopColor="#868691"></stop>
        <stop offset=".64" stopColor="#92929e"></stop>
      </linearGradient>
      <path
        d="M120.7 20.6l5.5 2.8s-2.1 2.8-3.8 6c-1.8 3.4-3 7.1-3 7.1l-5.3-3.2s1.3-3.6 3.2-7.1c1.5-2.9 3.4-5.6 3.4-5.6z"
        fill="url(#xcode-original-W)"
      ></path>
      <path
        d="M126.2 23.4c.4.2-.9 3.3-2.8 6.9-1.9 3.6-3.7 6.4-4 6.2-.4-.2.9-3.3 2.8-6.9 1.8-3.6 3.6-6.4 4-6.2z"
        fill="#bfc0d0"
      ></path>
    </svg>
  );
};

const ApplePayIcon = () => {
  return (
    <svg
      viewBox="0 0 165.52107 105.9651"
      enableBackground="new 0 0 165.52107 105.9651"
    >
      <g>
        <path
          id="XMLID_4_"
          d="M150.69807,0H14.82318c-0.5659,0-1.1328,0-1.69769,0.0033c-0.47751,0.0034-0.95391,0.0087-1.43031,0.0217c-1.039,0.0281-2.0869,0.0894-3.1129,0.2738c-1.0424,0.1876-2.0124,0.4936-2.9587,0.9754c-0.9303,0.4731-1.782,1.0919-2.52009,1.8303c-0.73841,0.7384-1.35721,1.5887-1.83021,2.52c-0.4819,0.9463-0.7881,1.9166-0.9744,2.9598c-0.18539,1.0263-0.2471,2.074-0.2751,3.1119c-0.0128,0.4764-0.01829,0.9528-0.0214,1.4291c-0.0033,0.5661-0.0022,1.1318-0.0022,1.6989V91.142c0,0.5671-0.0011,1.13181,0.0022,1.69901c0.00311,0.4763,0.0086,0.9527,0.0214,1.4291c0.028,1.03699,0.08971,2.08469,0.2751,3.11069c0.1863,1.0436,0.4925,2.0135,0.9744,2.9599c0.473,0.9313,1.0918,1.7827,1.83021,2.52c0.73809,0.7396,1.58979,1.3583,2.52009,1.8302c0.9463,0.4831,1.9163,0.7892,2.9587,0.9767c1.026,0.1832,2.0739,0.2456,3.1129,0.2737c0.4764,0.0108,0.9528,0.0172,1.43031,0.0194c0.56489,0.0044,1.13179,0.0044,1.69769,0.0044h135.87489c0.5649,0,1.13181,0,1.69659-0.0044c0.47641-0.0022,0.95282-0.0086,1.4314-0.0194c1.0368-0.0281,2.0845-0.0905,3.11301-0.2737c1.041-0.1875,2.0112-0.4936,2.9576-0.9767c0.9313-0.4719,1.7805-1.0906,2.52011-1.8302c0.7372-0.7373,1.35599-1.5887,1.8302-2.52c0.48299-0.9464,0.78889-1.9163,0.97429-2.9599c0.1855-1.026,0.2457-2.0737,0.2738-3.11069c0.013-0.4764,0.01941-0.9528,0.02161-1.4291c0.00439-0.5672,0.00439-1.1319,0.00439-1.69901V14.8242c0-0.5671,0-1.1328-0.00439-1.6989c-0.0022-0.4763-0.00861-0.9527-0.02161-1.4291c-0.02811-1.0379-0.0883-2.0856-0.2738-3.1119c-0.18539-1.0432-0.4913-2.0135-0.97429-2.9598c-0.47421-0.9313-1.093-1.7816-1.8302-2.52c-0.73961-0.7384-1.58881-1.3572-2.52011-1.8303c-0.9464-0.4818-1.9166-0.7878-2.9576-0.9754c-1.0285-0.1844-2.0762-0.2457-3.11301-0.2738c-0.47858-0.013-0.95499-0.0183-1.4314-0.0217C151.82988,0,151.26297,0,150.69807,0L150.69807,0z"
        />
        <path
          id="XMLID_3_"
          fill="#FFFFFF"
          d="M150.69807,3.532l1.67149,0.0032c0.4528,0.0032,0.90561,0.0081,1.36092,0.0205c0.79201,0.0214,1.71849,0.0643,2.58209,0.2191c0.7507,0.1352,1.38029,0.3408,1.9845,0.6484c0.5965,0.3031,1.14301,0.7003,1.62019,1.1768c0.479,0.4797,0.87671,1.0271,1.18381,1.6302c0.30589,0.5995,0.51019,1.2261,0.64459,1.9823c0.1544,0.8542,0.1971,1.7832,0.21881,2.5801c0.01219,0.4498,0.01819,0.8996,0.0204,1.3601c0.00429,0.5569,0.0042,1.1135,0.0042,1.6715V91.142c0,0.558,0.00009,1.1136-0.0043,1.6824c-0.00211,0.4497-0.0081,0.8995-0.0204,1.3501c-0.02161,0.7957-0.0643,1.7242-0.2206,2.5885c-0.13251,0.7458-0.3367,1.3725-0.64429,1.975c-0.30621,0.6016-0.70331,1.1484-1.18022,1.6251c-0.47989,0.48-1.0246,0.876-1.62819,1.1819c-0.5997,0.3061-1.22821,0.51151-1.97151,0.6453c-0.88109,0.157-1.84639,0.2002-2.57339,0.2199c-0.4574,0.0103-0.9126,0.01649-1.37889,0.0187c-0.55571,0.0043-1.1134,0.0042-1.6692,0.0042H14.82318c-0.0074,0-0.0146,0-0.0221,0c-0.5494,0-1.0999,0-1.6593-0.0043c-0.4561-0.00211-0.9112-0.0082-1.3512-0.0182c-0.7436-0.0201-1.7095-0.0632-2.5834-0.2193c-0.74969-0.1348-1.3782-0.3402-1.9858-0.6503c-0.59789-0.3032-1.1422-0.6988-1.6223-1.1797c-0.4764-0.4756-0.8723-1.0207-1.1784-1.6232c-0.3064-0.6019-0.5114-1.2305-0.64619-1.9852c-0.15581-0.8626-0.19861-1.7874-0.22-2.5777c-0.01221-0.4525-0.01731-0.9049-0.02021-1.3547l-0.0022-1.3279l0.0001-0.3506V14.8242l-0.0001-0.3506l0.0021-1.3251c0.003-0.4525,0.0081-0.9049,0.02031-1.357c0.02139-0.7911,0.06419-1.7163,0.22129-2.5861c0.1336-0.7479,0.3385-1.3765,0.6465-1.9814c0.3037-0.5979,0.7003-1.1437,1.17921-1.6225c0.477-0.4772,1.02309-0.8739,1.62479-1.1799c0.6011-0.3061,1.2308-0.5116,1.9805-0.6465c0.8638-0.1552,1.7909-0.198,2.5849-0.2195c0.4526-0.0123,0.9052-0.0172,1.3544-0.0203l1.6771-0.0033H150.69807"
        />
        <g>
          <g>
            <path
              d="M45.1862,35.64053c1.41724-1.77266,2.37897-4.15282,2.12532-6.58506c-2.07464,0.10316-4.60634,1.36871-6.07207,3.14276
				c-1.31607,1.5192-2.4809,3.99902-2.17723,6.3293C41.39111,38.72954,43.71785,37.36345,45.1862,35.64053"
            />
            <path
              d="M47.28506,38.98252c-3.38211-0.20146-6.25773,1.91951-7.87286,1.91951c-1.61602,0-4.08931-1.81799-6.76438-1.76899
				c-3.48177,0.05114-6.71245,2.01976-8.4793,5.15079c-3.63411,6.2636-0.95904,15.55471,2.57494,20.65606
				c1.71618,2.5238,3.78447,5.30269,6.50976,5.20287c2.57494-0.10104,3.58421-1.66732,6.71416-1.66732
				c3.12765,0,4.03679,1.66732,6.76252,1.61681c2.82665-0.05054,4.59381-2.52506,6.30997-5.05132
				c1.96878-2.877,2.77473-5.65498,2.82542-5.80748c-0.0507-0.05051-5.45058-2.12204-5.50065-8.33358
				c-0.05098-5.20101,4.23951-7.6749,4.44144-7.82832C52.3832,39.4881,48.5975,39.08404,47.28506,38.98252"
            />
          </g>
          <g>
            <path
              d="M76.73385,31.94381c7.35096,0,12.4697,5.06708,12.4697,12.44437c0,7.40363-5.22407,12.49704-12.65403,12.49704h-8.13892
				v12.94318h-5.88037v-37.8846H76.73385z M68.41059,51.9493h6.74732c5.11975,0,8.0336-2.75636,8.0336-7.53479
				c0-4.77792-2.91385-7.50845-8.00727-7.50845h-6.77365V51.9493z"
            />
            <path
              d="M90.73997,61.97864c0-4.8311,3.70182-7.79761,10.26583-8.16526l7.56061-0.44614v-2.12639
				c0-3.07185-2.07423-4.90959-5.53905-4.90959c-3.28251,0-5.33041,1.57492-5.82871,4.04313h-5.35574
				c0.31499-4.98859,4.56777-8.66407,11.3941-8.66407c6.69466,0,10.97377,3.54432,10.97377,9.08388v19.03421h-5.43472v-4.54194
				h-0.13065c-1.60125,3.07185-5.09341,5.01441-8.71623,5.01441C94.52078,70.30088,90.73997,66.94038,90.73997,61.97864z
				 M108.56641,59.4846v-2.17905l-6.8,0.41981c-3.38683,0.23649-5.30306,1.73291-5.30306,4.09579
				c0,2.41504,1.99523,3.99046,5.04075,3.99046C105.46823,65.81161,108.56641,63.08108,108.56641,59.4846z"
            />
            <path
              d="M119.34167,79.9889v-4.5946c0.4193,0.10483,1.36425,0.10483,1.83723,0.10483c2.6252,0,4.04313-1.10245,4.90908-3.9378
				c0-0.05267,0.49931-1.68025,0.49931-1.70658l-9.97616-27.64562h6.14268l6.98432,22.47371h0.10432l6.98433-22.47371h5.9857
				l-10.34483,29.06304c-2.36186,6.69517-5.0924,8.84789-10.81577,8.84789C121.17891,80.12006,119.76098,80.06739,119.34167,79.9889
				z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

const KubernetesIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#326ce5"
        d="M63.556 1.912a8.51 8.44 0 0 0-3.26.826L15.795 24a8.51 8.44 0 0 0-4.604 5.725L.214 77.485a8.51 8.44 0 0 0 1.155 6.47 8.51 8.44 0 0 0 .484.672l30.8 38.296a8.51 8.44 0 0 0 6.653 3.176l49.394-.012a8.51 8.44 0 0 0 6.653-3.17l30.789-38.301a8.51 8.44 0 0 0 1.645-7.142l-10.996-47.76a8.51 8.44 0 0 0-4.604-5.726L67.682 2.738a8.51 8.44 0 0 0-4.126-.826z"
      ></path>
      <path
        fill="#fff"
        d="M63.975 18.143v.01c-1.472.014-2.664 1.336-2.664 2.972 0 .028.005.052.005.074-.002.222-.012.49-.005.684.035.946.24 1.668.365 2.535.17 1.42.215 2.547.224 3.687l.036-.164a40.909 40.909 0 0 0-.118-2.394c.139 1.228.24 2.364.186 3.392-.015-.325-.061-.677-.066-.982l-.036.164c.003.347.096.79.069 1.123-.061.29-.291.495-.467.742l-.025.121c.173-.227.354-.444.46-.699-.134.423-.42.796-.707 1.094.08-.124.146-.262.24-.385l.026-.12c-.145.203-.227.457-.385.61l-.006.006-.064 1.12a34.702 34.702 0 0 0-4.797.736 34.279 34.279 0 0 0-17.398 9.935c-.296-.202-.8-.56-.95-.672l-.005-.005-.01.002c-.478.064-.95.207-1.57-.153-1.187-.8-2.271-1.907-3.584-3.24-.601-.637-1.037-1.246-1.754-1.861-.163-.141-.41-.33-.592-.473a3.193 3.193 0 0 0-1.87-.705c-.825-.028-1.62.294-2.14.947-.925 1.16-.628 2.933.658 3.96l.04.026c.174.143.39.326.552.446.762.561 1.457.849 2.21 1.293 1.594.984 2.91 1.798 3.956 2.779.402.427.474 1.19.53 1.525v.008l.847.754c-4.561 6.874-6.675 15.36-5.432 24.006l-1.103.324-.004.006c-.295.381-.712.972-1.135 1.147-1.366.43-2.908.588-4.77.783-.872.073-1.626.031-2.556.207-.205.04-.49.112-.713.164l-.023.006-.04.011c-1.58.383-2.6 1.837-2.27 3.272.327 1.435 1.873 2.306 3.464 1.963l.039-.006h.002c.02-.005.038-.015.05-.018.22-.048.496-.101.69-.154.913-.245 1.574-.603 2.393-.916 1.76-.632 3.218-1.16 4.637-1.365.582-.046 1.204.362 1.517.537l.008.004 1.152-.197c2.674 8.274 8.266 14.96 15.346 19.162l-.48 1.152.003.01c.174.45.364 1.057.237 1.492-.516 1.336-1.4 2.749-2.408 4.326-.488.728-.99 1.295-1.43 2.131-.107.201-.24.507-.342.717-.69 1.475-.184 3.177 1.143 3.816 1.335.643 2.99-.036 3.707-1.513l.007-.008v-.01c.1-.207.242-.478.329-.674.378-.866.505-1.607.77-2.441h-.003c.706-1.773 1.094-3.627 2.059-4.778.26-.31.688-.432 1.136-.552l.01-.004.6-1.084a34.436 34.436 0 0 0 24.556.062c.172.303.478.865.563 1.01l.004.006.008.004c.458.149.948.223 1.35.816.722 1.237 1.218 2.703 1.822 4.475.265.832.397 1.575.775 2.441.087.2.23.475.33.684.715 1.482 2.375 2.163 3.713 1.52 1.326-.64 1.832-2.34 1.143-3.815-.102-.21-.243-.518-.348-.719-.441-.836-.943-1.397-1.43-2.125-1.01-1.577-1.843-2.885-2.36-4.222-.213-.685.036-1.104.206-1.555l.006-.014-.01-.01a.834.834 0 0 1-.09-.168 6.23 6.23 0 0 1-.12-.29c-.08-.21-.16-.442-.224-.596 7.358-4.35 12.786-11.285 15.34-19.295.347.054.93.155 1.12.193l.01.002.009-.004c.402-.265.76-.606 1.475-.549 1.419.205 2.876.734 4.638 1.366.817.312 1.479.677 2.393.921.194.052.47.101.69.149.012.003.029.012.05.017h.002l.04.004c1.59.341 3.137-.528 3.464-1.963.327-1.435-.691-2.888-2.272-3.269-.227-.052-.551-.141-.775-.184-.93-.176-1.683-.132-2.557-.205-1.86-.195-3.402-.353-4.77-.783-.547-.213-.942-.872-1.138-1.148l-.006-.006-1.066-.31a34.42 34.42 0 0 0-.56-12.425 34.497 34.497 0 0 0-4.983-11.525c.278-.252.785-.701.932-.836l.007-.006v-.01c.044-.48.006-.97.495-1.494 1.045-.98 2.364-1.797 3.957-2.779.754-.444 1.454-.731 2.214-1.293.174-.128.408-.328.588-.473 1.286-1.026 1.584-2.798.658-3.959-.925-1.16-2.718-1.267-4.003-.242-.182.145-.43.332-.594.473-.717.618-1.16 1.226-1.76 1.863-1.313 1.335-2.398 2.446-3.586 3.246-.507.294-1.258.193-1.603.172h-.008l-1.004.719c-5.775-6.048-13.63-9.916-22.09-10.672a63.543 63.543 0 0 1-.064-1.174v-.008l-.006-.006c-.35-.333-.76-.61-.864-1.318v-.002c-.115-1.428.077-2.967.3-4.824.125-.867.332-1.59.366-2.535.009-.216-.005-.527-.005-.758 0-1.645-1.203-2.982-2.688-2.982zm-3.514 13.7a34.663 34.663 0 0 0-3.59.552 34.618 34.618 0 0 1 3.59-.551zm-4.781.823a34.262 34.262 0 0 0-3.711 1.133 34.208 34.208 0 0 1 3.71-1.133zm-4.825 1.564a34.262 34.262 0 0 0-3.496 1.666 34.216 34.216 0 0 1 3.496-1.666zM28.8 35.377c.142.02.28.048.418.086a3.168 3.168 0 0 0-.418-.086zm.943.283c.132.064.259.137.38.219a3.168 3.168 0 0 0-.38-.219zm16.549.848a34.262 34.262 0 0 0-3.176 2.14 34.228 34.228 0 0 1 3.176-2.14zm14.346 2.344-.787 13.93-.057.029-.002.013c-.002.05-.014.095-.02.143a2.348 2.348 0 0 1-.263.857c-.038.07-.076.141-.121.207a2.348 2.348 0 0 1-.69.662c-.07.045-.147.08-.222.118a2.348 2.348 0 0 1-.873.226c-.045.003-.088.014-.133.014-.05 0-.094-.022-.143-.026a2.334 2.334 0 0 1-.943-.304c-.045-.026-.094-.041-.137-.069l-.006.022.004-.022c-.044-.027-.102-.016-.144-.047l-.012-.01-.022.014-11.421-8.097c.093-.091.192-.174.287-.264a27.438 27.438 0 0 1 3.23-2.635c.237-.165.473-.332.715-.49a27.438 27.438 0 0 1 3.816-2.078c.24-.107.487-.204.73-.305a27.438 27.438 0 0 1 4.044-1.312c.12-.03.238-.067.36-.094.576-.13 1.162-.206 1.745-.299l.006-.025a28.076 28.076 0 0 1 .004 0l-.006.025c.355-.056.704-.14 1.06-.183zm6.726.002c.197.024.39.068.586.097a27.668 27.668 0 0 1 3.16.656c.412.111.82.23 1.225.36a27.668 27.668 0 0 1 3.033 1.168c.375.17.745.348 1.112.535a27.668 27.668 0 0 1 2.83 1.662c.344.23.68.47 1.015.717a27.668 27.668 0 0 1 2.496 2.074c.144.134.297.257.438.395l-11.346 8.044-.04-.015-.01.008c-.045.032-.094.045-.14.074a2.35 2.35 0 0 1-.882.334c-.077.012-.153.03-.23.033a2.35 2.35 0 0 1-.99-.176 2.34 2.34 0 0 1-.265-.127 2.35 2.35 0 0 1-.746-.65c-.05-.069-.088-.146-.13-.22a2.35 2.35 0 0 1-.288-.887c-.006-.055-.026-.103-.03-.159v-.011l-.011-.006zm-25.238.576a34.262 34.262 0 0 0-2.81 2.576 34.228 34.228 0 0 1 2.81-2.576zm50.916 8.14a34.483 34.483 0 0 1 1.522 2.594 34.478 34.478 0 0 0-1.522-2.594zm1.994 3.508c.488.993.927 2.01 1.317 3.045a34.478 34.478 0 0 0-1.317-3.045zm-54.576.69 10.43 9.328-.012.056.01.008c.94.817 1.07 2.23.293 3.203-.028.035-.068.057-.098.09a2.348 2.348 0 0 1-.986.65c-.043.015-.078.043-.121.055l-.014.002-.012.047-13.367 3.86c-.02-.185-.02-.37-.037-.555a27.432 27.432 0 0 1-.092-3.344c.013-.387.033-.773.063-1.158a27.432 27.432 0 0 1 .457-3.307c.08-.407.173-.812.273-1.215a27.432 27.432 0 0 1 .99-3.162c.14-.37.29-.734.448-1.097a27.432 27.432 0 0 1 1.51-2.987c.09-.156.17-.32.265-.474zm47.002.007c.097.158.176.324.27.483a27.774 27.774 0 0 1 1.53 3.01c.15.346.298.694.434 1.046a27.774 27.774 0 0 1 1.04 3.288c.045.175.104.346.144.523.69 3.002.86 5.999.578 8.896l-13.434-3.87-.011-.057-.014-.004c-.045-.012-.084-.034-.127-.049a2.35 2.35 0 0 1-.79-.455c-.058-.052-.116-.103-.17-.16a2.35 2.35 0 0 1-.491-.824c-.027-.078-.044-.158-.063-.239a2.35 2.35 0 0 1-.03-.892c.009-.049.01-.096.02-.145.01-.045.038-.084.05-.129a2.329 2.329 0 0 1 .599-.996c.034-.033.054-.076.09-.107l.01-.01-.006-.03 10.37-9.279zm9.228 3.305c.332.965.619 1.945.864 2.938a34.478 34.478 0 0 0-.864-2.938zm-34.824 6.752h4.262l2.65 3.314-.95 4.133-3.83 1.84-3.837-1.848-.953-4.132zm13.727 11.395c.18-.01.357.008.533.04l.014.003.023-.03 13.828 2.338c-.064.18-.147.351-.215.53a27.466 27.466 0 0 1-1.36 3.011c-.19.363-.386.721-.593 1.074a27.466 27.466 0 0 1-1.853 2.768c-.243.32-.492.633-.748.941a27.466 27.466 0 0 1-2.29 2.432c-.29.274-.588.54-.892.8a27.466 27.466 0 0 1-2.64 2.012c-.16.107-.31.225-.471.329l-5.365-12.967.015-.022-.004-.011c-.02-.045-.026-.092-.043-.137a2.351 2.351 0 0 1-.135-.889c.004-.081.006-.162.018-.242a2.351 2.351 0 0 1 .334-.89c.045-.072.098-.137.15-.204a2.351 2.351 0 0 1 .68-.578c.043-.024.079-.055.123-.076.289-.139.59-.218.89-.232zm-23.31.056.013.002c.03 0 .06.008.092.01a2.349 2.349 0 0 1 1.226.445c.07.05.133.101.196.158a2.349 2.349 0 0 1 .689 1.106c.008.03.022.059.03.09.11.479.065.98-.13 1.431l-.005.012.04.05-5.31 12.837c-.155-.1-.3-.212-.451-.315a27.58 27.58 0 0 1-2.64-2.011 27.508 27.508 0 0 1-.891-.803 27.58 27.58 0 0 1-2.272-2.408c-.26-.312-.513-.629-.76-.951a27.58 27.58 0 0 1-1.82-2.704 27.294 27.294 0 0 1-.627-1.123 27.58 27.58 0 0 1-1.346-2.947c-.07-.181-.154-.356-.22-.539l13.707-2.326.023.03.014-.005c.147-.027.294-.04.443-.039zm2.304 1.994a2.326 2.326 0 0 1 .02.344 2.286 2.286 0 0 0-.02-.344zm-.008.703a2.326 2.326 0 0 1-.1.4c.046-.13.077-.264.1-.4zm9.334 2.944c.058-.002.114.013.172.015a2.32 2.32 0 0 1 .752.159c.054.021.112.03.164.056v.002a2.31 2.31 0 0 1 1.043.99l.006.012h.053l6.757 12.213c-.276.092-.557.173-.836.256a28.056 28.056 0 0 1-.996.277c-.283.074-.564.15-.85.215-.124.029-.25.046-.376.072a27.542 27.542 0 0 1-4.18.561c-.28.016-.558.035-.838.043a27.542 27.542 0 0 1-4.32-.223c-.28-.036-.56-.085-.838-.13a27.542 27.542 0 0 1-4.055-.975c-.127-.041-.257-.072-.384-.115l6.742-12.188h.01l.007-.012c.026-.048.065-.085.094-.13a2.351 2.351 0 0 1 .606-.647c.083-.06.168-.115.26-.164a2.351 2.351 0 0 1 .85-.262c.054-.005.103-.023.157-.025zM52.297 98.69a34.413 34.413 0 0 0 3.758 1.137 34.352 34.352 0 0 1-3.758-1.137zm23.385.09c-1.07.381-2.156.709-3.258.983a34.56 34.56 0 0 0 3.258-.983zm-4.575 1.281a34.399 34.399 0 0 1-3.718.563 34.413 34.413 0 0 0 3.718-.563zm-13.937.016a34.413 34.413 0 0 0 3.898.572 34.358 34.358 0 0 1-3.898-.572zm8.91.649a34.36 34.36 0 0 1-3.851.005 34.413 34.413 0 0 0 3.85-.005z"
      ></path>
    </svg>
  );
};

const SparkIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#e15919"
        d="M117.085 64.337c-.109-.237-.16-.357-.22-.47-1.604-3.049-3.203-6.102-4.826-9.152-.16-.308-.14-.489.08-.753 2.553-2.978 5.074-5.98 7.63-8.944a.777.777 0 0 0 .205-.405 839.8 839.8 0 0 0-2.232.58c-3.078.818-6.184 1.632-9.233 2.461-.289.076-.417-.008-.561-.248a1047.83 1047.83 0 0 0-5.278-8.74 1.222 1.222 0 0 0-.384-.425c-.14.782-.285 1.555-.425 2.332-.49 2.753-.982 5.486-1.467 8.247-.052.297-.124.598-.152.894-.024.28-.168.389-.429.469-3.63 1.142-7.257 2.292-10.884 3.442-.16.052-.316.116-.489.273 2.97 1.178 5.94 2.356 8.949 3.558-.109.084-.18.152-.26.204-1.856 1.199-3.716 2.4-5.567 3.603-.224.148-.4.168-.65.056-2.22-.998-4.451-1.98-6.68-2.97-.997-.444-1.89-1.037-2.588-1.895-1.579-1.927-1.266-4.123.838-5.482.689-.44 1.47-.765 2.252-1.022 3.558-1.158 7.133-2.276 10.68-3.398.296-.096.436-.228.492-.553.477-2.753.97-5.526 1.467-8.247.268-1.47.408-2.977 1.122-4.328.276-.52.6-1.03.997-1.462 1.42-1.575 3.395-1.631 4.91-.132.504.504.937 1.098 1.314 1.715a976.243 976.243 0 0 1 4.905 8.122c.192.321.364.385.717.293 3.98-1.07 7.959-2.12 11.958-3.174.825-.216 1.655-.296 2.5-.136 1.836.34 2.637 1.74 2.016 3.518-.28.806-.77 1.487-1.318 2.132-2.781 3.27-5.567 6.56-8.332 9.814-.224.269-.228.46-.072.761 1.667 3.138 3.314 6.268 4.99 9.442.396.749.7 1.534.709 2.396.02 1.964-1.419 3.57-3.37 3.859-1.09.16-2.108-.072-3.134-.389a824.96 824.96 0 0 0-7.506-2.284c-.228-.072-.32-.164-.36-.413-.289-1.759-.602-3.514-.906-5.277-.008-.048.004-.1.012-.209 2.85.79 5.69 1.563 8.62 2.377"
      ></path>
      <path
        fill="#3a383d"
        d="M57.648 54.455c-2.095 0-3.855 1.764-3.855 3.856 0 1.639 1.094 2.945 2.838 2.945a3.62 3.62 0 0 0 1.49-.342h.004l.186-1.566c-.381.305-.944.529-1.526.529-.949 0-1.549-.75-1.549-1.707 0-1.254 1.07-2.342 2.268-2.342.577 0 1.047.226 1.336.547l.195-1.58a2.891 2.891 0 0 0-1.387-.34zm15.245.068-1.16 6.59h3.652l.232-1.33h-2.275l.23-1.326h2.092l.23-1.324h-2.087l.23-1.28h2.277l.233-1.33h-3.654zm-1.16 6.59h-.003v.01l.002-.01zm-4.247-6.58-.465 2.612h-2.865l.461-2.61h-1.379l-1.162 6.6h1.375l.465-2.653h2.869l-.46 2.653h1.378l1.162-6.602h-1.379zm-35.515.002-3.528 6.6h1.6l.717-1.406h2.256l.216 1.406h1.479l-1.201-6.6h-1.54zm16.365 0-3.527 6.6h1.6l.716-1.406h2.256l.213 1.406h1.482l-1.203-6.6h-1.537zm-9.197.012-1.162 6.596h1.378l.428-2.413h.91c1.434 0 2.442-.957 2.442-2.384 0-1.13-.77-1.787-1.875-1.787h-2.114l-.007-.012zm1.15 1.338h.805l-.004.002c.36 0 .601.203.601.6 0 .601-.38.921-.869.921h-.802l.27-1.523zm-7.81.46.32 2.057h-1.354l1.034-2.056zm16.37 0 .32 2.057h-1.355l1.036-2.056zm-33.07.887c-4.048.123-7.145 2.042-9.32 5.565-.933 1.5-1.293 3.19-1.041 4.99.229 1.631.949 3.057 2.012 4.287 1.522 1.795 3.165 3.488 4.74 5.239.66.73 1.335 1.462 1.877 2.279.94 1.419.7 2.995-.57 4.125a5.678 5.678 0 0 1-1.415.916c-1.955.886-3.905.342-5.115-1.45-.4-.604-.673-1.302-1.002-1.96-.06-.128-.108-.26-.172-.42C3.85 81.829 1.951 82.85 0 83.893c.316.782.588 1.554.941 2.283.997 2.044 2.55 3.51 4.782 4.164 1.675.497 3.39.548 5.113.271 3.92-.62 6.863-2.66 8.738-6.142 1.014-1.9 1.443-3.919 1.09-6.063-.296-1.823-1.257-3.299-2.455-4.617-1.319-1.463-2.71-2.844-4.045-4.287-.8-.874-1.585-1.763-2.303-2.701-.649-.853-.558-1.932.135-2.686.782-.845 1.765-1.22 2.91-1.14 1.38.092 2.325.889 3.09 1.955.297.416.55.865.83 1.31 1.744-1.301 3.484-2.597 5.287-3.937-.469-.628-.903-1.228-1.369-1.809-1.567-1.98-3.598-3.17-6.142-3.262a14.075 14.075 0 0 0-.823 0zm8.334 5.07.01.014.025-.039c-.011.01-.023.017-.035.026zm74.782-4.064c-.104.032-.148.031-.176.051-2.036 1.31-4.072 2.62-6.104 3.947-.1.064-.185.226-.2.35-.562 4.205-1.11 8.41-1.663 12.613-.577 4.412-1.158 8.785-1.732 13.197-.072.553-.132 1.11-.2 1.682h5.897c.565-4.288 1.13-8.574 1.703-12.947.152.217.24.343.324.47 2.64 4.044 5.337 8.107 8.002 12.167.164.252.333.336.629.336 2.262-.008 4.501 0 6.748.003v-.048c-.077-.08-.172-.153-.236-.24l-10.635-14.967c-.069-.095-.124-.197-.19-.301.102-.112.19-.213.278-.309 2.063-2.184 4.117-4.352 6.181-6.512.181-.193.254-.357.206-.625-.244-1.33-.465-2.668-.694-4.003-.08-.465-.164-.929-.256-1.475-3.258 3.587-6.452 7.142-9.65 10.68l-.072-.051c.613-4.657 1.227-9.318 1.84-14.018zm13.228 31.87v.03l.018-.03h-.018zm-48.42-24.583c-.471.011-.95.046-1.437.106-6.676.825-12.25 6.72-12.536 13.44-.117 2.89.693 5.51 2.633 7.714 3.586 4.096 9.362 4.38 13.774 2.344.092-.04.175-.189.191-.3.29-2.145.568-4.292.865-6.556l.018-.033c-.914.95-1.874 1.66-3.004 2.11-2.228.878-4.39.872-6.43-.487-2.096-1.402-2.994-3.921-2.425-6.554.826-3.967 4.693-6.776 8.74-6.348 1.96.205 3.442 1.158 4.332 2.95.834 1.686.967 3.496.758 5.32-.332 2.925-.754 5.86-1.135 8.78-.076.57-.14 1.138-.207 1.72h5.236c.02-.114.04-.206.053-.293.332-2.512.682-5.053.998-7.586.221-1.78.504-3.563.584-5.362.125-2.72-.708-5.193-2.508-7.256-2.307-2.65-5.2-3.786-8.5-3.709zm-26.678.153c-.957.004-1.932.12-2.92.334-5.442 1.194-10.11 5.895-11.046 11.38-.533 3.095-.859 6.204-1.276 9.317-.364 2.725-.72 5.448-1.078 8.168-.1.774-.197 1.553-.297 2.326.088.024.124.045.164.045 1.623.004 3.246.004 4.866.008.204.005.265-.084.289-.272a553.527 553.527 0 0 1 .636-4.949c.164-1.238.328-2.473.504-3.783l.037.064c.16.1.265.16.358.223 2.556 1.792 5.414 2.299 8.45 1.842 2.93-.445 5.495-1.756 7.63-3.824 3.238-3.174 4.925-6.97 4.412-11.545-.372-3.214-1.946-5.815-4.7-7.586-1.897-1.226-3.922-1.758-6.029-1.748zm48.965.582c-.378.004-.756.011-1.133.027-3.154.124-6.27 2.932-6.763 6.065-.365 2.349-.645 4.704-.953 7.048-.361 2.681-.718 5.41-1.075 8.123-.1.781-.195 1.559-.3 2.364h5.486c.137-1.07.271-2.128.408-3.182l1.65-12.533c.045-.341.084-.688.184-1.008.27-.826 1.075-1.398 1.957-1.402 1.09-.008 2.175-.004 3.29-.004l.716-5.442-.023-.037c-1.167 0-2.31-.03-3.444-.02zm-49.736 4.752c2.655-.012 5.006 1.567 5.842 4.136.205.633.27 1.307.357 1.768h.027c-.176 3.233-1.562 5.515-4.123 7.049-1.935 1.158-4.023 1.486-6.183.705-2.681-.95-4.124-3.548-3.852-6.229.33-3.638 2.884-6.43 6.434-7.255a6.867 6.867 0 0 1 1.498-.174zm77.142 16.33v.369h.87v2.396h.453v-2.396l.004.002h.867v-.371h-2.194zm2.754.002v2.763h.454v-2.306h.015l.904 2.306h.29l.91-2.306h.011v2.306h.461v-2.763h-.7l-.813 2.103-.827-2.103h-.705z"
      ></path>
    </svg>
  );
};

const TerraformIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill-rule="evenodd">
        <path
          d="M77.941 44.5v36.836L46.324 62.918V26.082zm0 0"
          fill="#5c4ee5"
        ></path>
        <path
          d="M81.41 81.336l31.633-18.418V26.082L81.41 44.5zm0 0"
          fill="#4040b2"
        ></path>
        <path
          d="M11.242 42.36L42.86 60.776V23.941L11.242 5.523zm0 0M77.941 85.375L46.324 66.957v36.82l31.617 18.418zm0 0"
          fill="#5c4ee5"
        ></path>
      </g>
    </svg>
  );
};

const VueIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M0 8.934l49.854.158 14.167 24.47 14.432-24.47L128 8.935l-63.834 110.14zm126.98.637l-24.36.02-38.476 66.053L25.691 9.592.942 9.572l63.211 107.89zm-25.149-.008l-22.745.168-15.053 24.647L49.216 9.73l-22.794-.168 37.731 64.476zm-75.834-.17l23.002.009m-23.002-.01l23.002.01"
        fill="none"
      ></path>
      <path
        d="M25.997 9.393l23.002.009L64.035 34.36 79.018 9.404 102 9.398 64.15 75.053z"
        fill="#35495e"
      ></path>
      <path
        d="M.91 9.569l25.067-.172 38.15 65.659L101.98 9.401l25.11.026-62.966 108.06z"
        fill="#41b883"
      ></path>
    </svg>
  );
};

const DynamoDBIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="prefix__a"
          x1="-15.53"
          y1="90.53"
          x2="90.53"
          y2="-15.53"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.70667 0 0 1.70667 0 0)"
        >
          <stop offset="0" stop-color="#2e27ad"></stop>
          <stop offset="1" stop-color="#527fff"></stop>
        </linearGradient>
      </defs>
      <path
        data-name="Blue Gradient"
        className="prefix__cls-1"
        fill="url(#prefix__a)"
        d="M0 0h128v128H0z"
      ></path>
      <path
        className="prefix__cls-2"
        d="M56.745 21.266c-14.062 0-29.013 4.164-29.013 11.947v13.736a6.93 6.93 0 002.577 5.037 6.946 6.946 0 00-2.577 5.12v13.653a6.93 6.93 0 002.577 5.12A6.946 6.946 0 0027.732 81v13.654a2.133 2.133 0 000 .356c.46 7.493 15.138 11.52 29.013 11.52 13.876 0 28.553-4.027 29.014-11.553a1.28 1.28 0 000-.36V80.963a6.827 6.827 0 00-2.577-5.12 6.93 6.93 0 002.577-5.12v-1.637l-11.28 11.263a27.7 27.7 0 005.836-2.373 4.403 4.403 0 012.03 3.073c0 3.124-6.62 6.521-16.45 7.904a72.073 72.073 0 01-9.15.646H55.04c-13.79-.324-23.894-4.676-23.894-8.533a4.403 4.403 0 012.034-3.07c5.359 2.987 14.043 4.76 23.566 4.76h.19l.954-3.413h-1.144c-9.386 0-18.088-1.862-22.713-4.797-1.843-1.212-2.87-2.523-2.887-3.667v-7.903c5.223 3.994 15.634 6.077 25.6 6.077 1.349 0 2.7 0 4.014-.12l.97-3.414c-1.707.12-3.294.17-4.984.17-14.643 0-25.6-4.488-25.6-8.533a4.403 4.403 0 012.034-3.073c4.71 2.645 11.944 4.3 20.153 4.676l.087-3.413c-8.073-.393-15.36-2.133-19.387-4.71-1.826-1.178-2.852-2.51-2.887-3.67v-7.883c5.223 3.993 15.634 6.076 25.6 6.076h.377l1.81-3.413h-2.187c-14.643 0-25.6-4.489-25.6-8.533 0-4.045 10.957-8.534 25.6-8.534a61.44 61.44 0 0114.644 1.707h9.37c-5.12-3.123-13.961-5.12-24.014-5.12zm12.8 8.517a1.707 1.707 0 00-1.516.936L57.789 51.2a1.707 1.707 0 001.516 2.527h9.66l-9.59 31.93a1.707 1.707 0 00.784 1.963 1.707 1.707 0 00.853.24 1.707 1.707 0 001.317-.58l37.546-39.253a1.707 1.707 0 00-1.23-2.883h-9.573l4.367-13.127a1.707 1.707 0 00-1.707-2.233zm.957 3.43h18.773l-4.37 13.106a1.707 1.707 0 001.707 2.254h7.953l-29.883 31.23 8.21-27.307a1.707 1.707 0 00-.273-1.5 1.707 1.707 0 00-1.367-.683h-9.18zm-34.237 11.62a2.133 2.133 0 00-2.133 2.133 2.133 2.133 0 002.133 2.133 2.133 2.133 0 002.134-2.133 2.133 2.133 0 00-2.134-2.133zm0 23.893a2.133 2.133 0 00-2.133 2.133 2.133 2.133 0 002.133 2.134 2.133 2.133 0 002.134-2.134 2.133 2.133 0 00-2.134-2.133zm-5.12 18.11c5.223 3.96 15.634 6.04 25.6 6.04 9.967 0 20.378-2.08 25.6-6.04v7.85c0 4.028-10.956 8.533-25.6 8.533-14.643 0-25.6-4.454-25.6-8.533zm5.12 5.783a2.133 2.133 0 00-2.133 2.134 2.133 2.133 0 002.133 2.133 2.133 2.133 0 002.134-2.133 2.133 2.133 0 00-2.134-2.134z"
        fill="#fff"
      ></path>
    </svg>
  );
};

const ViteJSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          x1="6"
          x2="235"
          y1="33"
          y2="344"
          gradientTransform="translate(0 .937) scale(.3122)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#41d1ff"></stop>
          <stop offset="1" stop-color="#bd34fe"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="194.651"
          x2="236.076"
          y1="8.818"
          y2="292.989"
          gradientTransform="translate(0 .937) scale(.3122)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ffea83"></stop>
          <stop offset=".083" stop-color="#ffdd35"></stop>
          <stop offset="1" stop-color="#ffa800"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#a)"
        d="M124.766 19.52 67.324 122.238c-1.187 2.121-4.234 2.133-5.437.024L3.305 19.532c-1.313-2.302.652-5.087 3.261-4.622L64.07 25.187a3.09 3.09 0 0 0 1.11 0l56.3-10.261c2.598-.473 4.575 2.289 3.286 4.594Zm0 0"
      ></path>
      <path
        fill="url(#b)"
        d="M91.46 1.43 48.954 9.758a1.56 1.56 0 0 0-1.258 1.437l-2.617 44.168a1.563 1.563 0 0 0 1.91 1.614l11.836-2.735a1.562 1.562 0 0 1 1.88 1.836l-3.517 17.219a1.562 1.562 0 0 0 1.985 1.805l7.308-2.223c1.133-.344 2.223.652 1.985 1.812l-5.59 27.047c-.348 1.692 1.902 2.614 2.84 1.164l.625-.968 34.64-69.13c.582-1.16-.421-2.48-1.69-2.234l-12.185 2.352a1.558 1.558 0 0 1-1.793-1.965l7.95-27.562A1.56 1.56 0 0 0 91.46 1.43Zm0 0"
      ></path>
    </svg>
  );
};

const HTMLIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#E44D26"
        d="M19.037 113.876L9.032 1.661h109.936l-10.016 112.198-45.019 12.48z"
      ></path>
      <path fill="#F16529" d="M64 116.8l36.378-10.086 8.559-95.878H64z"></path>
      <path
        fill="#EBEBEB"
        d="M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692 3.382 37.927H64zm0 35.743l-.061.017-15.327-4.14-.979-10.975H33.816l1.928 21.609 28.193 7.826.063-.017z"
      ></path>
      <path
        fill="#fff"
        d="M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092.628-6.978.329-3.692z"
      ></path>
    </svg>
  );
};

const KotlinIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          x1="500.003"
          x2="-.097"
          y1="579.106"
          y2="1079.206"
          gradientTransform="translate(15.534 -96.774) scale(.1939)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".003" stop-color="#e44857"></stop>
          <stop offset=".469" stop-color="#c711e1"></stop>
          <stop offset="1" stop-color="#7f52ff"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#a)"
        d="M112.484 112.484H15.516V15.516h96.968L64 64Zm0 0"
      ></path>
    </svg>
  );
};

const CSSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#131313"
        d="M89.234 5.856H81.85l7.679 8.333v3.967H73.713v-4.645h7.678l-7.678-8.333V1.207h15.521v4.649zm-18.657 0h-7.384l7.679 8.333v3.967H55.055v-4.645h7.679l-7.679-8.333V1.207h15.522v4.649zm-18.474.19h-7.968v7.271h7.968v4.839H38.471V1.207h13.632v4.839z"
      ></path>
      <path
        fill="#1572B6"
        d="M27.613 116.706l-8.097-90.813h88.967l-8.104 90.798-36.434 10.102-36.332-10.087z"
      ></path>
      <path
        fill="#33A9DC"
        d="M64.001 119.072l29.439-8.162 6.926-77.591H64.001v85.753z"
      ></path>
      <path
        fill="#fff"
        d="M64 66.22h14.738l1.019-11.405H64V43.677h27.929l-.267 2.988-2.737 30.692H64V66.22z"
      ></path>
      <path
        fill="#EBEBEB"
        d="M64.067 95.146l-.049.014-12.404-3.35-.794-8.883H39.641l1.561 17.488 22.814 6.333.052-.015V95.146z"
      ></path>
      <path
        fill="#fff"
        d="M77.792 76.886L76.45 91.802l-12.422 3.353v11.588l22.833-6.328.168-1.882 1.938-21.647H77.792z"
      ></path>
      <path
        fill="#EBEBEB"
        d="M64.039 43.677v11.137H37.136l-.224-2.503-.507-5.646-.267-2.988h27.901zM64 66.221v11.138H51.753l-.223-2.503-.508-5.647-.267-2.988H64z"
      ></path>
    </svg>
  );
};

const PrometheusIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#e75225"
        d="M64.125.51C99.229.517 128.045 29.133 128 63.951c-.045 35.342-28.742 63.564-64.608 63.539C28.325 127.466-.025 98.818 0 63.434.023 28.834 28.898.503 64.125.51ZM44.72 22.793c.803 3.96.025 7.655-1.167 11.289-.823 2.515-1.962 4.94-2.642 7.492-1.122 4.203-2.391 8.43-2.859 12.726-.671 6.181 1.758 11.625 5.914 17.04L24.86 67.318c.033.602 0 .83.065 1.024 1.811 5.32 4.998 9.802 8.57 14.03.377.446 1.237.674 1.877.674 19.05.038 38.101.034 57.152.009.59 0 1.381-.11 1.741-.49 4.084-4.294 7.205-9.185 9.16-15.342l-20.228 3.962c1.336-2.618 2.855-4.916 3.733-7.443 2.994-8.643 1.752-16.998-2.545-24.88-3.449-6.324-6.631-12.62-4.91-20.243-3.642 3.6-5.043 8.179-5.932 12.898-.872 4.65-1.389 9.364-2.065 14.083-.098-.143-.22-.25-.242-.373a13.964 13.964 0 0 1-.176-1.49c-.413-7.726-1.92-15.17-5.106-22.28-1.873-4.182-3.941-8.462-2.008-13.456-1.307.693-2.49 1.377-3.338 2.356-2.527 2.92-3.573 6.428-3.842 10.269-.231 3.282-.546 6.579-1.156 9.806-.64 3.392-1.65 6.714-3.932 9.831-.918-6.656-1.02-13.244-6.956-17.47ZM93.842 88.88H34.088v10.38h59.754Zm-47.904 15.746c-.049 8.642 8.753 15.081 19.633 14.614 9.02-.389 16.999-7.484 16.315-14.614zm0 0"
      ></path>
    </svg>
  );
};

const KibanaIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path d="m51.648 66.016 1.457-1.82 3.684-3.9h2.922L54.836 65.5l5.184 6.914h-3.008l-3.887-5.312-1.414 1.168v4.152h-2.54V55.355h2.556v8.325l-.133 2.34Zm10.188-8.907c-.023-.39.113-.777.383-1.066a1.478 1.478 0 0 1 1.082-.367c.386-.024.765.11 1.054.367.266.289.403.676.375 1.066.024.383-.113.754-.375 1.036a1.412 1.412 0 0 1-1.058.378 1.452 1.452 0 0 1-1.082-.378 1.405 1.405 0 0 1-.38-1.036Zm2.734 15.336h-2.574v-12.16h2.57Zm9.88-12.37a4.25 4.25 0 0 1 3.519 1.644c.851 1.097 1.277 2.636 1.277 4.617 0 1.988-.426 3.52-1.285 4.64a4.662 4.662 0 0 1-3.566 1.653 4.687 4.687 0 0 1-3.567-1.652h-.172l-.476 1.433h-1.918V55.344h2.59v4.093l-.047 1.333-.063 1.128h.11a4.096 4.096 0 0 1 3.628-1.836Zm-.673 2.105a2.604 2.604 0 0 0-2.242.918c-.457.582-.695 1.632-.707 3.062v.176c0 1.473.234 2.539.703 3.203a2.598 2.598 0 0 0 2.293.996 2.33 2.33 0 0 0 2.074-1.09 5.689 5.689 0 0 0 .707-3.132c0-2.754-.94-4.133-2.828-4.133Zm16.035 10.246-.511-1.684h-.09a4.935 4.935 0 0 1-1.754 1.504c-.723.293-1.5.43-2.281.402a3.85 3.85 0 0 1-2.785-.964 3.63 3.63 0 0 1-1.008-2.73 3.214 3.214 0 0 1 1.398-2.833c.926-.633 2.336-.98 4.239-1.039l2.093-.062v-.653a2.468 2.468 0 0 0-.539-1.75 2.196 2.196 0 0 0-1.683-.586 5.794 5.794 0 0 0-1.79.27c-.562.187-1.117.41-1.652.664l-.84-1.84a9.147 9.147 0 0 1 2.164-.785 9.84 9.84 0 0 1 2.215-.266c1.54 0 2.711.336 3.524 1.008.8.676 1.191 1.73 1.168 3.164v8.184Zm-3.835-1.754a3.16 3.16 0 0 0 2.25-.781 2.844 2.844 0 0 0 .855-2.2v-1.05l-1.562.07a5.265 5.265 0 0 0-2.641.586 1.84 1.84 0 0 0-.828 1.66 1.62 1.62 0 0 0 .476 1.25c.414.34.946.508 1.48.469Zm19.945 1.754h-2.59V64.96a3.295 3.295 0 0 0-.586-2.094 2.189 2.189 0 0 0-1.797-.691 2.865 2.865 0 0 0-2.39.965c-.504.644-.754 1.722-.754 3.234v6.04h-2.578V60.296h2.027l.363 1.582h.133a3.554 3.554 0 0 1 1.555-1.332 5.13 5.13 0 0 1 2.234-.473c2.91 0 4.367 1.477 4.367 4.438Zm11.168 0-.516-1.684h-.086a4.968 4.968 0 0 1-1.754 1.504 5.577 5.577 0 0 1-2.28.402 3.865 3.865 0 0 1-2.79-.964 3.63 3.63 0 0 1-1.008-2.73 3.223 3.223 0 0 1 1.399-2.833c.925-.633 2.34-.98 4.238-1.039l2.094-.062v-.653a2.468 2.468 0 0 0-.54-1.75 2.191 2.191 0 0 0-1.683-.586 5.812 5.812 0 0 0-1.789.27c-.563.187-1.113.41-1.652.664l-.836-1.84a9.024 9.024 0 0 1 2.164-.785 9.814 9.814 0 0 1 2.215-.266c1.535 0 2.707.336 3.52 1.008.804.676 1.19 1.73 1.167 3.164v8.184Zm-3.836-1.754a3.172 3.172 0 0 0 2.25-.781 2.84 2.84 0 0 0 .851-2.2v-1.05l-1.558.07a5.27 5.27 0 0 0-2.645.586 1.84 1.84 0 0 0-.828 1.66 1.64 1.64 0 0 0 .477 1.25c.406.336.926.5 1.453.469Zm0 0"></path>
      <path
        fill="#343741"
        d="M9.047 58.133v24.672l17.535-20.196a36.49 36.49 0 0 0-17.535-4.476Zm0 0"
      ></path>
      <path
        fill="#f04e98"
        d="M9.047 40.492v17.64a36.63 36.63 0 0 1 17.535 4.473l19.195-22.113Zm0 0"
      ></path>
      <path
        fill="#00bfb3"
        d="M30.352 64.96 10.789 87.509h34.258a36.73 36.73 0 0 0-14.695-22.543Zm0 0"
      ></path>
    </svg>
  );
};

const GoogleCloudIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#ea4535"
        d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"
      ></path>
      <path
        fill="#557ebf"
        d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"
      ></path>
      <path
        fill="#36a852"
        d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"
      ></path>
      <path
        fill="#f9bc15"
        d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"
      ></path>
    </svg>
  );
};

const ElasticSearchIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#343741"
        d="M4 64c0 5.535.777 10.879 2.098 16H84c8.836 0 16-7.164 16-16s-7.164-16-16-16H6.098A63.738 63.738 0 0 0 4 64"
      ></path>
      <path
        fill="#fec514"
        d="M111.695 30.648A61.485 61.485 0 0 0 117.922 24C106.188 9.379 88.199 0 68 0 42.715 0 20.957 14.71 10.574 36H98.04a20.123 20.123 0 0 0 13.652-5.352"
      ></path>
      <path
        fill="#00bfb3"
        d="M98.04 92H10.577C20.961 113.29 42.715 128 68 128c20.2 0 38.188-9.383 49.922-24a61.1 61.1 0 0 0-6.227-6.648A20.133 20.133 0 0 0 98.04 92"
      ></path>
    </svg>
  );
};

const SQLIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <radialGradient
          id="b"
          cx="9.36"
          cy="10.57"
          fx="9.36"
          fy="10.57"
          r="7.07"
          gradientTransform="matrix(73.03125 0 0 37.1875 29.797 56.535)"
        >
          <stop offset="0" stop-color="#f2f2f2" stop-opacity="1"></stop>
          <stop offset=".58" stop-color="#eee" stop-opacity="1"></stop>
          <stop offset="1" stop-color="#e6e6e6" stop-opacity="1"></stop>
        </radialGradient>
        <linearGradient
          id="a"
          gradientUnits="userSpaceOnUse"
          x1="2.59"
          y1="10.16"
          x2="15.41"
          y2="10.16"
          gradientTransform="scale(7.11111)"
        >
          <stop offset="0" stop-color="#005ba1" stop-opacity="1"></stop>
          <stop offset=".07" stop-color="#0060a9" stop-opacity="1"></stop>
          <stop offset=".36" stop-color="#0071c8" stop-opacity="1"></stop>
          <stop offset=".52" stop-color="#0078d4" stop-opacity="1"></stop>
          <stop offset=".64" stop-color="#0074cd" stop-opacity="1"></stop>
          <stop offset=".82" stop-color="#006abb" stop-opacity="1"></stop>
          <stop offset="1" stop-color="#005ba1" stop-opacity="1"></stop>
        </linearGradient>
      </defs>
      <path
        stroke="none"
        fill-rule="nonzero"
        fill="url(#a)"
        d="M64 36.55c-25.172 0-45.582-7.109-45.582-16.495v87.89c0 9.032 20.055 16.356 44.941 16.5H64c25.172 0 45.582-7.113 45.582-16.5v-87.89c0 9.172-20.41 16.496-45.582 16.496Zm0 0"
      ></path>
      <path
        stroke="none"
        fill-rule="nonzero"
        fill="#e8e8e8"
        fill-opacity="1"
        d="M109.582 20.055c0 9.172-20.41 16.496-45.582 16.496s-45.582-7.11-45.582-16.496c0-9.387 20.41-16.5 45.582-16.5s45.582 7.113 45.582 16.5"
      ></path>
      <path
        stroke="none"
        fill-rule="nonzero"
        fill="#50e6ff"
        fill-opacity="1"
        d="M98.988 18.703c0 5.832-15.718 10.524-34.988 10.524s-34.988-4.692-34.988-10.524C29.012 12.871 44.73 8.25 64 8.25s34.988 4.691 34.988 10.453"
      ></path>
      <path
        stroke="none"
        fill-rule="nonzero"
        fill="#198ab3"
        fill-opacity="1"
        d="M64 21.332a82.193 82.193 0 0 0-27.664 4.055A81.213 81.213 0 0 0 64 29.227a79.334 79.334 0 0 0 27.664-4.125A84.332 84.332 0 0 0 64 21.332Zm0 0"
      ></path>
      <path
        stroke="none"
        fill-rule="nonzero"
        fill="url(#b)"
        d="M91.734 81.066V56.891h-6.402v29.367h17.496v-5.192ZM40.961 69.191a13.064 13.064 0 0 1-3.629-2.203 3.13 3.13 0 0 1-.852-2.277 2.418 2.418 0 0 1 1.067-2.133 4.847 4.847 0 0 1 2.988-.855 11.533 11.533 0 0 1 7.11 2.062v-6.113a18.236 18.236 0 0 0-7.11-1.137 11.67 11.67 0 0 0-7.754 2.414 7.68 7.68 0 0 0-2.984 6.332c0 3.625 2.273 6.469 7.11 8.602 1.57.668 3.05 1.527 4.41 2.562a2.982 2.982 0 0 1 1.066 2.274c0 .879-.426 1.699-1.137 2.207a5.786 5.786 0 0 1-3.203.781 11.801 11.801 0 0 1-7.75-2.988v6.613a15.411 15.411 0 0 0 7.61 1.707c2.98.176 5.933-.648 8.39-2.348a7.681 7.681 0 0 0 2.348-6.468 7.458 7.458 0 0 0-1.778-4.977 17.225 17.225 0 0 0-5.902-4.055Zm37.262 11.305a16.634 16.634 0 0 0 2.347-8.957A16.509 16.509 0 0 0 78.223 64a12.87 12.87 0 0 0-4.977-5.332 14.228 14.228 0 0 0-7.113-1.852 15.015 15.015 0 0 0-7.68 1.922A13.217 13.217 0 0 0 53.262 64a17.48 17.48 0 0 0-1.848 8.105 16.06 16.06 0 0 0 1.707 7.114 12.526 12.526 0 0 0 4.906 5.261 14.679 14.679 0 0 0 7.11 2.133l6.117 7.11h8.605l-8.75-7.82a12.736 12.736 0 0 0 7.114-5.407Zm-7.114-1.777a6.673 6.673 0 0 1-5.402 2.488 6.538 6.538 0 0 1-5.406-2.559 10.842 10.842 0 0 1-2.063-7.109 10.903 10.903 0 0 1 2.063-7.113 7.104 7.104 0 0 1 5.547-2.63 6.181 6.181 0 0 1 5.336 2.63 11.533 11.533 0 0 1 1.918 7.113 10.353 10.353 0 0 1-1.993 7.18Zm0 0"
      ></path>
    </svg>
  );
};

const JiraIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="jira-original-a"
          gradientUnits="userSpaceOnUse"
          x1="22.034"
          y1="9.773"
          x2="17.118"
          y2="14.842"
          gradientTransform="scale(4)"
        >
          <stop offset=".176" stop-color="#0052cc"></stop>
          <stop offset="1" stop-color="#2684ff"></stop>
        </linearGradient>
        <linearGradient
          id="jira-original-b"
          gradientUnits="userSpaceOnUse"
          x1="16.641"
          y1="15.564"
          x2="10.957"
          y2="21.094"
          gradientTransform="scale(4)"
        >
          <stop offset=".176" stop-color="#0052cc"></stop>
          <stop offset="1" stop-color="#2684ff"></stop>
        </linearGradient>
      </defs>
      <path
        d="M108.023 16H61.805c0 11.52 9.324 20.848 20.847 20.848h8.5v8.226c0 11.52 9.328 20.848 20.848 20.848V19.977A3.98 3.98 0 00108.023 16zm0 0"
        fill="#2684ff"
      ></path>
      <path
        d="M85.121 39.04H38.902c0 11.519 9.325 20.847 20.844 20.847h8.504v8.226c0 11.52 9.328 20.848 20.848 20.848V43.016a3.983 3.983 0 00-3.977-3.977zm0 0"
        fill="url(#jira-original-a)"
      ></path>
      <path
        d="M62.219 62.078H16c0 11.524 9.324 20.848 20.848 20.848h8.5v8.23c0 11.52 9.328 20.844 20.847 20.844V66.059a3.984 3.984 0 00-3.976-3.98zm0 0"
        fill="url(#jira-original-b)"
      ></path>
    </svg>
  );
};

const GithubIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#181616">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"
        ></path>
        <path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"></path>
      </g>
    </svg>
  );
};

const NotionIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="m76.25.25 13.059.086c.246.191.445.316.656.41 2.367 1.07 4.933 1.836 7.066 3.258 6.184 4.11 12.223 8.441 18.258 12.77 2.805 2.007 5.57 4.097 8.156 6.37 1.922 1.688 2.785 4.083 2.79 6.637l-.005 80.371c-.003 1.121-.195 2.274-.507 3.352-1.418 4.914-4.563 8.277-9.512 9.59-2.61.691-5.367.906-8.074 1.129-4.223.351-8.461.523-12.692.777l-8.004.5-12.816.754-7.879.492-12.941.75-6.688.274c-.215.011-.414.312-.617.48-5.09 0-10.176 0-15.309-.082-.246-.195-.433-.352-.652-.414-3.102-.899-5.703-2.613-7.703-5.102-2.77-3.441-5.402-6.988-8.066-10.511-3.274-4.329-6.633-8.594-9.727-13.047a15.47 15.47 0 0 1-2.79-8.875 72122.4 72122.4 0 0 1 .009-71.211c0-.684.12-1.375.238-2.055C3.742 9.645 9.152 5.746 15.586 5.023c3.34-.375 6.703-.543 10.059-.765l8.87-.512 3.813-.25 11.5-.992 6.375-.5 10.559-.75 8.87-.524c.216-.015.415-.312.618-.48M25.945 114.184c.532.691 1.125 1.347 1.59 2.082 2.254 3.527 5.485 4.808 9.59 4.535l27.809-1.656 31.296-1.891 15.582-1.004c4.618-.371 6.848-2.867 6.938-7.5v-1l.035-75.863c.004-2.285-.785-3.883-2.613-5.16l-22.024-15.52c-3.543-2.578-7.304-3.781-11.66-3.437L57.824 9.594l-25.789 1.902-16.187 1.262c-3.27.3-5.297 2.3-5.883 5.508a13.868 13.868 0 0 0-.207 2.48l-.067 66.242c-.023 4.34 1.305 7.95 3.903 11.27l12.351 15.926zm0 0"
        fill="#fff"
      ></path>
      <path d="m25.887 114.117-12.293-15.86c-2.598-3.32-3.926-6.929-3.903-11.269l.067-66.242c0-.828.062-1.668.207-2.48.586-3.207 2.613-5.207 5.883-5.508l16.187-1.262 25.79-1.902L82.488 7.77c4.356-.344 8.117.859 11.66 3.437 7.262 5.285 14.66 10.383 22.024 15.52 1.828 1.277 2.617 2.875 2.613 5.16l-.035 75.867v1c-.09 4.629-2.32 7.125-6.938 7.496-5.187.418-10.386.688-15.582 1.004l-31.296 1.89-27.809 1.657c-4.105.273-7.336-1.008-9.59-4.535-.465-.735-1.058-1.391-1.648-2.149m6.406-45.992v33.488l.008 6.246c.054 2.801 1.426 4.196 4.226 4.356.703.039 1.414.015 2.121-.028l23.442-1.382 44.765-2.559c2.79-.156 4.079-1.379 4.34-4.144.051-.497.035-1 .035-1.5l.004-64.477c0-.375.012-.75-.011-1.125-.168-2.566-1.27-3.613-3.82-3.477l-23.071 1.329a43791.29 43791.29 0 0 0-32.418 1.898l-16.207.973c-2.066.132-3 1.023-3.312 3.043a10.64 10.64 0 0 0-.098 1.617l-.004 25.742m57.172-52.727c-1.957-1.062-4.082-1.414-6.27-1.293-3.363.184-6.726.461-10.09.704l-47.949 3.484c-1.449.105-2.906.21-4.336.469-.48.086-1.086.57-1.234 1.008-.11.308.375.93.73 1.27.657.628 1.414 1.155 2.13 1.722 1.699 1.34 3.507 2.562 5.066 4.043 2.957 2.808 6.398 3.457 10.34 3.172l31.035-1.946 33.41-2.004c.305-.015.61-.109 1.281-.234-.613-.637-.969-1.125-1.433-1.469a233.798 233.798 0 0 0-4.957-3.562 697.555 697.555 0 0 0-7.723-5.364zm0 0"></path>
      <path
        d="m32.293 68 .004-25.617c0-.54.016-1.086.098-1.617.312-2.02 1.246-2.91 3.312-3.043l16.207-.973 32.418-1.898 23.07-1.329c2.551-.136 3.653.914 3.82 3.477.024.375.012.75.012 1.125l-.004 64.477-.035 1.5c-.261 2.765-1.55 3.988-4.34 4.144l-44.765 2.559-23.442 1.382-2.12.028c-2.801-.16-4.173-1.555-4.227-4.352l-.008-6.25V68m45.766.066L65.191 48.461c-.449-.684-.89-.91-1.718-.82l-5.485.37-10.09.739c-2.48.227-3.98 2.559-3.293 4.977l5.344.457v43.293l-3.64 1.027c-1.614.476-2.305 1.836-1.762 3.574l12.308-.707 4.848-.398c2.09-.344 3.215-1.625 3.496-3.715l-6.73-1.535V63.16l.5.7 15.468 24.152a361.224 361.224 0 0 0 7.004 10.46c1.707 2.45 4.223 3.2 7.051 2.59 1.77-.378 3.469-1.097 5.203-1.656.903-.293 1.211-.832 1.207-1.844l-.03-44.5c0-2.601 0-2.601 2.573-3.12 2.602-.524 3.254-1.563 2.66-4.344l-15.55.945c-1.692.121-2.973 1.535-3.23 3.18-.126.793.038 1.23.987 1.285l4.708.52v30.179a7434.52 7434.52 0 0 0-8.961-13.637zM89.55 15.441a1122.8 1122.8 0 0 1 7.636 5.32 233.798 233.798 0 0 1 4.958 3.563c.464.344.82.832 1.433 1.469l-1.281.234-33.41 2.004-31.035 1.946c-3.942.285-7.383-.364-10.34-3.172-1.559-1.48-3.367-2.703-5.067-4.043-.715-.567-1.472-1.094-2.129-1.723-.355-.34-.84-.96-.73-1.27.148-.437.758-.921 1.234-1.007 1.43-.258 2.887-.364 4.336-.469l47.95-3.484 10.09-.704c2.187-.12 4.312.23 6.355 1.336zm0 0"
        fill="#fff"
      ></path>
      <path d="m78.113 68.14 8.907 13.567v-30.18l-4.707-.52c-.95-.054-1.114-.491-.989-1.284.258-1.645 1.54-3.059 3.23-3.18l15.551-.945c.594 2.78-.058 3.82-2.66 4.343-2.574.516-2.574.516-2.574 3.121l.031 44.5c.004 1.012-.304 1.551-1.207 1.844l-5.203 1.656c-2.828.606-5.344-.14-7.05-2.59a366.671 366.671 0 0 1-7.004-10.46l-15.47-24.153c-.109-.172-.234-.332-.5-.699v32.563l6.731 1.535c-.281 2.09-1.406 3.37-3.496 3.715-1.594.261-3.23.3-4.848.398l-12.308.707c-.543-1.738.148-3.098 1.762-3.574l3.64-1.027V54.184l-5.344-.457c-.687-2.418.813-4.75 3.293-4.977 3.356-.313 6.727-.504 10.09-.738 1.828-.125 3.664-.172 5.485-.371.828-.09 1.27.136 1.718.82l12.922 19.68zm0 0"></path>
    </svg>
  );
};
const SpringIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M116.452 6.643a59.104 59.104 0 01-6.837 12.136A64.249 64.249 0 0064.205-.026C28.984-.026 0 28.982 0 64.242a64.316 64.316 0 0019.945 46.562l2.368 2.1a64.22 64.22 0 0041.358 15.122c33.487 0 61.637-26.24 64.021-59.683 1.751-16.371-3.051-37.077-11.24-61.7zM29.067 111.17a5.5 5.5 0 01-4.269 2.034c-3.018 0-5.487-2.484-5.487-5.502 0-3.017 2.485-5.501 5.487-5.501 1.25 0 2.485.433 3.452 1.234 2.351 1.9 2.718 5.384.817 7.735zm87.119-19.238c-15.843 21.122-49.68 14.003-71.376 15.02 0 0-3.852.234-7.721.867 0 0 1.45-.617 3.335-1.334 15.226-5.301 22.43-6.335 31.685-11.086 17.427-8.869 34.654-28.274 38.24-48.463-6.637 19.422-26.75 36.11-45.077 42.895-12.557 4.635-35.238 9.136-35.238 9.136l-.917-.484c-15.442-7.518-15.91-40.977 12.157-51.78 12.291-4.735 24.048-2.134 37.323-5.302 14.175-3.367 30.568-14.004 37.238-27.874 7.471 22.19 16.46 56.932.35 78.405z"
        fill="#77bc1f"
      ></path>
    </svg>
  );
};

const ConfluenceIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          x1="26.791"
          x2="11.792"
          y1="28.467"
          y2="19.855"
          gradientTransform="translate(-21.334 -18.666) scale(5.33331)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#0052cc"></stop>
          <stop offset=".918" stop-color="#2380fb"></stop>
          <stop offset="1" stop-color="#2684ff"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="5.209"
          x2="20.208"
          y1="2.523"
          y2="11.136"
          gradientTransform="translate(-21.334 -18.666) scale(5.33331)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#0052cc"></stop>
          <stop offset=".918" stop-color="#2380fb"></stop>
          <stop offset="1" stop-color="#2684ff"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#a)"
        d="M4.655 96.303a332.061 332.061 0 0 0-4.062 6.577c-1.156 1.933-.578 4.448 1.354 5.61l26.484 16.25c1.934 1.16 4.443.577 5.604-1.355a185.798 185.798 0 0 1 3.866-6.579c10.442-17.213 21.071-15.28 40.014-6.186l26.293 12.374c2.124.97 4.447 0 5.41-1.933l12.569-28.43c.963-1.938 0-4.448-1.939-5.418-5.604-2.516-16.618-7.74-26.285-12.573-35.76-17.219-66.114-16.057-89.306 21.663Zm0 0"
      ></path>
      <path
        fill="url(#b)"
        d="M123.343 31.697a332.061 332.061 0 0 0 4.063-6.577c1.16-1.933.577-4.448-1.355-5.61L99.567 3.26c-1.933-1.16-4.443-.577-5.604 1.355a178.066 178.066 0 0 1-3.865 6.579c-10.443 17.213-21.072 15.28-40.015 6.186L23.79 5.006c-2.124-.97-4.441 0-5.41 1.933L5.816 35.369c-.968 1.938 0 4.454 1.933 5.418 5.604 2.516 16.624 7.74 26.285 12.573 35.767 17.027 66.115 16.056 89.307-21.663zm0 0"
      ></path>
    </svg>
  );
};

const KafkaIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M86.758 70.89c-4.992 0-9.465 2.208-12.528 5.68l-7.851-5.547a21.275 21.275 0 001.312-7.32c0-2.531-.46-4.95-1.27-7.203l7.837-5.488c3.062 3.457 7.523 5.652 12.5 5.652 9.207 0 16.703-7.48 16.703-16.672 0-9.195-7.496-16.672-16.703-16.672-9.211 0-16.707 7.477-16.707 16.672 0 1.645.25 3.23.699 4.735l-7.84 5.488a21.578 21.578 0 00-13.36-7.746v-9.43c7.567-1.586 13.27-8.293 13.27-16.312C62.82 7.53 55.324.055 46.117.055c-9.21 0-16.707 7.476-16.707 16.672 0 7.91 5.555 14.539 12.969 16.238v9.547c-10.117 1.773-17.84 10.59-17.84 21.191 0 10.652 7.797 19.5 17.992 21.211V95c-7.492 1.64-13.12 8.309-13.12 16.273 0 9.196 7.495 16.672 16.706 16.672 9.207 0 16.703-7.476 16.703-16.672 0-7.964-5.629-14.632-13.117-16.273V84.914a21.592 21.592 0 0013.133-7.625l7.902 5.586a16.45 16.45 0 00-.687 4.688c0 9.195 7.496 16.671 16.707 16.671 9.207 0 16.703-7.476 16.703-16.671 0-9.196-7.496-16.672-16.703-16.672zm0-38.984c4.465 0 8.097 3.63 8.097 8.086 0 4.453-3.632 8.082-8.097 8.082-4.469 0-8.102-3.629-8.102-8.082 0-4.457 3.633-8.086 8.102-8.086zm-48.742-15.18c0-4.456 3.632-8.081 8.101-8.081 4.465 0 8.098 3.625 8.098 8.082 0 4.457-3.633 8.082-8.098 8.082-4.469 0-8.101-3.625-8.101-8.082zm16.199 94.547c0 4.457-3.633 8.082-8.098 8.082-4.469 0-8.101-3.625-8.101-8.082 0-4.457 3.632-8.082 8.101-8.082 4.465 0 8.098 3.625 8.098 8.082zm-8.102-36.296c-6.226 0-11.293-5.059-11.293-11.274 0-6.219 5.067-11.277 11.293-11.277 6.23 0 11.297 5.058 11.297 11.277 0 6.215-5.066 11.274-11.297 11.274zm40.645 20.668c-4.469 0-8.102-3.625-8.102-8.082 0-4.458 3.633-8.083 8.102-8.083 4.465 0 8.097 3.625 8.097 8.082 0 4.458-3.632 8.083-8.097 8.083zm0 0"
        fill="#231f20"
      ></path>
    </svg>
  );
};

const AdobeXDIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#470137"
        d="M22.667 1.6h82.666C117.867 1.6 128 11.733 128 24.267v79.466c0 12.534-10.133 22.667-22.667 22.667H22.667C10.133 126.4 0 116.267 0 103.733V24.267C0 11.733 10.133 1.6 22.667 1.6Z"
      ></path>
      <path
        fill="#ff61f6"
        d="m67.307 34.4-16 26.4 17.066 28c.107.213.16.427.107.64s-.267.053-.587.107H55.68c-.853 0-1.44-.054-1.813-.587-1.12-2.24-2.294-4.427-3.414-6.667-1.12-2.186-2.346-4.426-3.626-6.72-1.28-2.293-2.56-4.586-3.84-6.933h-.107c-1.12 2.293-2.347 4.587-3.573 6.88a899.142 899.142 0 0 0-3.627 6.827c-1.227 2.24-2.453 4.533-3.68 6.72-.213.533-.64.586-1.227.586H19.04c-.213 0-.373.107-.373-.16a.74.74 0 0 1 .106-.586l16.587-27.2-16.16-27.36c-.16-.214-.213-.427-.107-.534.107-.16.32-.213.534-.213h12.106c.267 0 .534.053.747.107.213.106.373.266.533.48 1.014 2.293 2.187 4.586 3.414 6.88 1.28 2.293 2.506 4.533 3.84 6.773 1.28 2.24 2.453 4.48 3.573 6.773h.107c1.12-2.346 2.293-4.64 3.466-6.88 1.174-2.24 2.4-4.48 3.627-6.72 1.227-2.24 2.4-4.533 3.573-6.72.054-.213.16-.426.32-.533.214-.107.427-.16.694-.107H66.88a.491.491 0 0 1 .587.374c.053.053-.054.266-.16.373Zm24.64 56.267c-3.947.053-7.894-.747-11.467-2.4-3.36-1.547-6.133-4.107-8.053-7.254-1.974-3.253-2.934-7.306-2.934-12.16-.053-3.946.96-7.84 2.934-11.253 2.026-3.467 4.96-6.347 8.48-8.267 3.733-2.08 8.213-3.093 13.493-3.093.267 0 .64 0 1.12.053.48.054 1.013.054 1.653.107V29.547c0-.374.16-.587.534-.587h10.826c.267-.053.48.16.534.373v50.88c0 .96.053 2.027.106 3.2.107 1.12.16 2.187.214 3.094 0 .373-.16.693-.534.853a40.73 40.73 0 0 1-8.693 2.56c-2.72.48-5.44.747-8.213.747zM97.173 80V56.533c-.48-.106-.96-.213-1.44-.266a19.216 19.216 0 0 0-1.76-.107c-2.08 0-4.16.427-6.026 1.387a11.956 11.956 0 0 0-4.534 3.946c-1.173 1.707-1.76 4-1.76 6.774a14.863 14.863 0 0 0 .907 5.493c.533 1.44 1.333 2.72 2.4 3.787a9.214 9.214 0 0 0 3.627 2.133c1.44.48 2.933.693 4.426.693.8 0 1.547-.053 2.24-.106.694.053 1.28-.054 1.92-.267z"
      ></path>
    </svg>
  );
};

const PerlIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M121.172 62.878c0-34.048-26.473-61.648-59.135-61.648C29.379 1.23 2.9 28.83 2.9 62.878s26.478 61.651 59.136 61.651c32.662 0 59.135-27.603 59.135-61.651z"
        fill="#fff"
      ></path>
      <path
        d="M53.34 127.516c-13.91-2.461-25.842-8.812-35.703-19.006C9.25 99.842 3.477 88.928.853 76.763c-1.137-5.256-1.137-20.287 0-25.54C2.629 43 6.075 34.835 10.776 27.714 13.89 23 23.004 13.888 27.716 10.773c7.123-4.7 15.293-8.15 23.514-9.921 5.253-1.137 20.286-1.137 25.543 0C89.58 3.617 100.225 9.4 109.41 18.585c9.187 9.186 14.97 19.828 17.739 32.639 1.133 5.252 1.133 20.283 0 25.54-2.769 12.806-8.552 23.448-17.739 32.634-9.038 9.041-19.55 14.812-32.147 17.65-4.467 1.009-19.238 1.297-23.923.468zm11.567-12.772c0-4.194-.062-4.497-.907-4.497-.838 0-.904.288-.869 3.897.043 4.264.343 5.572 1.211 5.284.401-.132.565-1.491.565-4.684zm-6.757 1.445c1.192-1.196 1.542-1.92 1.542-3.209 0-1.316-.16-1.635-.763-1.519-.417.078-.919.76-1.114 1.507-.194.748-1 1.904-1.783 2.57-1.418 1.196-1.472 2.192-.125 2.192.386 0 1.394-.697 2.243-1.541zm14.943 1.047c.167-.269-.339-1.036-1.122-1.698-.786-.666-1.589-1.822-1.783-2.57-.199-.747-.701-1.429-1.118-1.507-.6-.116-.76.203-.76 1.519 0 2.609 3.743 5.942 4.783 4.256zm-20.66-8.146c0-.261-.634-.822-1.41-1.246-5.054-2.769-10.985-7.176-14.28-10.61-6.433-6.71-9.33-13.388-9.4-21.678-.048-5.54.665-8.43 3.364-13.605 2.609-5.004 5.631-8.78 13.95-17.421 9.287-9.653 11.425-12.2 13.038-15.533 1.148-2.367 1.3-3.231 1.46-8.235.199-6.215-.18-10.506-.927-10.506-.339 0-.401 1.612-.21 5.234.623 11.592-1.53 15.19-14.892 24.881-9.202 6.674-13.424 10.3-16.613 14.264-4.518 5.61-6.52 10.466-7.018 17.05-1.207 15.868 8.848 29.629 26.59 36.385 3.914 1.487 6.348 1.881 6.348 1.02zm30.7-1.285c6.098-2.543 10.736-5.615 15.11-10.007 6.667-6.701 9.439-12.967 9.856-22.242.362-8.134-1.402-13.515-6.437-19.61-3.45-4.173-7.162-7.16-17.174-13.81-13.47-8.953-16.633-12.516-16.633-18.746 0-1.658.3-4.006.662-5.217.623-2.068.608-3.493-.02-1.862-.591 1.546-1.947.837-2.675-1.41l-.7-2.152.264 2.04c.942 7.242 1.06 10.276.642 16.615-.564 8.57-1.616 14.427-4.51 25.076-2.87 10.572-3.387 14.404-3.029 22.476.3 6.825 1.254 11.93 3.474 18.593 2.06 6.183 2.445 6.654 6.235 7.624 2.083.533 4.058 1.433 5.627 2.566 1.476 1.067 2.952 1.76 3.781 1.775.748.012 3.237-.755 5.526-1.709zm-1.371-3.076c-.565-.565-.3-1.048 1.912-3.493 6.97-7.694 10.094-15.641 10.183-25.906.063-6.993-1.483-11.627-6.2-18.593-2.13-3.15-9.634-11.008-13.263-13.893-2.66-2.114-5.398-5.72-5.885-7.76-.494-2.068.892-1.523 2.496.98.787 1.227 2.493 3.03 3.79 4.004 1.296.977 5.132 3.835 8.524 6.355 11.664 8.671 16.859 16.066 18.023 25.672.678 5.556-.397 11.3-3.107 16.634-2.812 5.525-7.937 11.545-12.326 14.477-2.703 1.803-3.556 2.115-4.147 1.523zm-22.837.584c.133-.343-1.036-2.535-2.593-4.875-4.128-6.191-5.924-9.606-7.598-14.454-1.414-4.085-1.492-4.641-1.504-10.883-.015-9.431 1.005-12.422 8.49-24.85 7.057-11.718 8.015-16.258 7.22-34.286-.288-6.46-.611-11.838-.72-11.95-.744-.744-.904 1.172-.627 7.67.545 12.94-.292 20.147-3.018 26.062-1.858 4.026-3.938 7.075-9.53 14.002-7.788 9.637-9.985 14.75-9.946 23.126.031 5.743.806 9.275 3.127 14.185 2.512 5.32 7.135 10.689 12.93 15.011 2.667 1.994 3.391 2.231 3.77 1.242z"
        fill="#212178"
      ></path>
    </svg>
  );
};

const GitIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#31251C"
        d="M76.397 55.676c-2.737 0-4.775 1.344-4.775 4.579 0 2.437 1.343 4.129 4.628 4.129 2.784 0 4.676-1.641 4.676-4.23 0-2.934-1.693-4.478-4.529-4.478zm-5.471 22.84c-.648.795-1.294 1.64-1.294 2.637 0 1.989 2.536 2.587 6.021 2.587 2.885 0 6.816-.202 6.816-2.885 0-1.595-1.892-1.693-4.281-1.843l-7.262-.496zm14.725-22.69c.895 1.145 1.842 2.737 1.842 5.026 0 5.522-4.329 8.756-10.597 8.756-1.594 0-3.037-.198-3.932-.447l-1.642 2.637 4.875.297c8.608.549 13.682.798 13.682 7.413 0 5.723-5.024 8.955-13.682 8.955-9.006 0-12.438-2.289-12.438-6.218 0-2.24.996-3.431 2.737-5.076-1.643-.694-2.189-1.937-2.189-3.281 0-1.095.547-2.09 1.443-3.036.896-.944 1.891-1.891 3.084-2.985-2.438-1.194-4.278-3.781-4.278-7.464 0-5.721 3.781-9.65 11.393-9.65 2.14 0 3.435.197 4.578.498h9.703v4.228l-4.579.347zm13.332-9.04c-2.837 0-4.479-1.643-4.479-4.48 0-2.833 1.642-4.377 4.479-4.377 2.886 0 4.527 1.543 4.527 4.377.001 2.837-1.641 4.48-4.527 4.48zm-6.42 29.9v-3.929l2.539-.348c.696-.1.795-.249.795-.997V56.785c0-.546-.148-.896-.647-1.044l-2.687-.946.547-4.028h10.301v20.646c0 .798.048.896.796.997l2.538.348v3.929H92.563v-.001zm33.857-1.93c-2.141 1.043-5.274 1.99-8.112 1.99-5.92 0-8.158-2.386-8.158-8.011V55.7c0-.297 0-.497-.399-.497h-3.482v-4.428c4.38-.499 6.12-2.688 6.667-8.111h4.728v7.067c0 .347 0 .498.398.498h7.015v4.975h-7.413v11.89c0 2.935.697 4.079 3.383 4.079 1.395 0 2.836-.347 4.03-.795l1.343 4.378z"
      ></path>
      <path
        fill="#F34F29"
        d="M52.7 61.7L29.951 38.952a3.355 3.355 0 00-4.744 0l-4.724 4.724 5.991 5.992a3.983 3.983 0 014.1.956 3.988 3.988 0 01.947 4.125l5.775 5.775a3.988 3.988 0 014.125 6.593 3.992 3.992 0 01-6.516-4.342l-5.386-5.386-.001 14.174a3.992 3.992 0 011.056 6.401 3.993 3.993 0 11-4.339-6.518V57.141a3.99 3.99 0 01-2.167-5.236l-5.906-5.908L2.563 61.595a3.356 3.356 0 000 4.747L25.312 89.09a3.357 3.357 0 004.746 0L52.7 66.446a3.355 3.355 0 000-4.746z"
      ></path>
      <path fill="none" d="M1.58 37.928h124.84v52.143H1.58z"></path>
    </svg>
  );
};

const MagnetoIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#f26322"
        d="M119.82 31.97v64.01l-15.85 9.12V41.17l-39.62-22.9-39.64 22.9.1 63.96-15.82-9.15V32.02L64.45 0l55.37 31.97zM72.3 105.1l-7.9 4.6-7.95-4.55V41.17l-15.82 9.15.03 63.96L64.38 128l23.77-13.72V50.29L72.3 41.14v63.96z"
      ></path>
    </svg>
  );
};

const DesignSprintIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352L32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z" />
    </svg>
  );
};

const AdobeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Adobe"
      role="img"
      viewBox="0 0 512 512"
    >
      <path d="m0 0H512V512H0" fill="#ed2224" />
      <path
        fill="#fff"
        d="M296 120h114v272zm-80 0H102v272zm39 99-48 118h52l23 55h46"
      />
    </svg>
  );
};

const AxureIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118 29">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#272727"
          d="M72.602.36h-1.66c-.85 0-1.443.593-1.443 1.442V23.68h-6.904c-4.27 0-6.002-.271-6.002-7.09V1.8c0-.848-.593-1.44-1.442-1.44h-1.613c-.849 0-1.49.618-1.49 1.44v14.79c0 9.69 3.508 11.395 10.88 11.395 2.651 0 6.283 0 9.746-.488l.08-.016c.855-.214 1.29-.705 1.29-1.458V1.802c0-.85-.593-1.442-1.442-1.442M92.53.412l-.113-.03c-.973-.205-3.632-.354-4.952-.354-4.666 0-7.133 1.957-7.133 5.66v20.62c0 .849.593 1.442 1.443 1.442h1.66c.85 0 1.443-.593 1.443-1.443V6.067c0-.913.23-1.734 3.015-1.734l4.122-.004c.404.049.79-.063 1.086-.314.324-.274.502-.673.502-1.123V1.849c0-.685-.391-1.209-1.073-1.437"
        />
        <path
          fill="#272727"
          d="M106.291.013c-4.778 0-7.479.924-9.03 3.09-1.617 2.264-1.943 5.837-1.943 10.867 0 9.875 1.525 14.004 10.974 14.004 1.135 0 5.014-.023 7.28-.299.88-.147 1.276-.823 1.276-1.428v-1.09c0-.85-.641-1.49-1.49-1.49h-7.066c-5.332 0-6.292-1.259-6.43-8.418v-2.315c.046-7.326 1.007-8.614 6.43-8.614 5.001 0 5.959 1.143 6.125 7.592h-7.946v4.352h10.45c2.058 0 2.058-1.441 2.058-1.914v-1.391C116.831 2.917 114.433.013 106.291.013"
        />
        <path
          fill="#74BB11"
          d="M46.929 1.037c-.214-.454-.67-.725-1.223-.725h-2.134c-.62 0-1.082.25-1.326.7l-3.163 4.63 2.769 3.793 4.833-6.946c.531-.647.347-1.23.244-1.452"
        />
        <path
          fill="#009CD9"
          d="M30.257.96l-.003-.004C29.772.313 29.131.313 28.92.313h-2.087c-.535 0-.972.245-1.202.674-.235.438-.185.966.14 1.455l7.732 10.738-8.89 12.423c-.311.467-.355.987-.12 1.425.23.429.668.674 1.202.674h2.134c.548 0 1.03-.285 1.271-.735l9.951-13.738L30.257.96z"
        />
        <path
          fill="#EB2084"
          d="M48.013 25.975l-5.386-7.4-2.37 3.27 4.26 5.69.11.05c.184.079.36.117.538.117h1.811c.438 0 .81-.195 1.02-.534.216-.35.221-.783.017-1.193"
        />
        <path
          fill="#272727"
          d="M16.407 16.074v7.243c-2.112.325-5.332.397-6.43.397-4.854 0-5.385-1.33-5.385-4.151 0-2.64.986-3.489 4.058-3.489h7.757zM9.741.014c-1.5 0-3.546.038-6.09.345l-.115.025c-.742.212-1.118.7-1.118 1.45v1.043c0 .89.553 1.442 1.442 1.442h5.88c4.736 0 6.667 1.285 6.667 4.436v3.062H8.65c-6.063 0-8.65 2.315-8.65 7.746 0 6.051 2.677 8.41 9.55 8.41 2.785 0 7.91-.217 9.804-.795 1.598-.445 1.598-1.667 1.598-2.07V8.47c0-5.692-3.667-8.458-11.211-8.458z"
        />
      </g>
    </svg>
  );
};

const UIDesignIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
      <path d="M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z" />
    </svg>
  );
};

const JUnitIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#dc514a"
        d="M107.546 44.254c-4.508.077-8.85 1.429-12.57 4.866-8.293 7.674-8.54 20.821-.528 28.78 1.309 1.298 2.86 2.48 4.568 3.306v.055l.263.139c10.558 5.599 23.97-.366 27.753-11.349 1.596-4.63 1.169-10.155-.918-14.87-2.033-4.591-5.69-8.389-10.622-9.78v-.184l-.386-.09c-2.23-.509-4.46-.83-6.657-.871a25.172 25.172 0 0 0-.903-.002zm.016.992c.287-.005.577-.004.868.002 1.986.037 4.024.352 6.07.798v.074l.374.093c4.785 1.205 8.343 4.874 10.333 9.37 1.99 4.496 2.386 9.8.887 14.147-3.554 10.314-16.135 15.962-26.086 10.895v-.018l-.293-.131c-1.682-.759-3.243-1.966-4.57-3.281-7.617-7.567-7.38-20.049.506-27.347 3.533-3.265 7.588-4.528 11.91-4.602zm-42.404 4.263a1.843 1.843 0 0 0-.444.115c-.519.202-.828.667-.986 1.153a3.302 3.302 0 0 0-.103 1.533c.082.51.27 1 .643 1.358.374.358.984.508 1.566.295.517-.19.865-.616 1.049-1.078a3.01 3.01 0 0 0 .17-1.465c-.059-.49-.221-.965-.529-1.341-.308-.376-.813-.638-1.366-.57zm-58.125.368v21.618c0 1.297.179 2.885.15 4.39-.03 1.504-.278 2.892-1 3.796-.698.875-1.487 1.123-2.448 1.172-.962.05-2.062-.15-3.176-.197l-.518-.022v.518c0 .167-.038.486-.04.822-.004.335.005.72.269 1.073.431.58 1.14.663 1.775.694.635.03 1.276-.031 1.599-.031 2.588-.004 5.125-1.26 5.895-3.965.94-3.322.426-7.084.426-10.312V49.877Zm8.802 0v14.277c0 2.791-.267 5.84 1.14 8.595 1.682 3.297 5.415 4.877 9.116 4.88 3.7.003 7.46-1.56 9.234-4.737h.002c1.53-2.744 1.31-5.906 1.31-8.738V49.878h-3.062v14.406c0 2.553.282 5.114-.885 7.227-1.246 2.256-3.895 3.378-6.57 3.327-2.674-.05-5.29-1.273-6.461-3.568-1.127-2.207-.89-4.894-.89-7.503v-13.89Zm84.94 0v.496c0 2.735-.363 5.526-.59 8.32l-.078.777v.002c-.038.39-.195 1.125-.28 1.863-.083.737-.15 1.5.256 2.12.529.814 1.357 1.121 2.119 1.159.762.037 1.505-.131 2.106-.204 2.105-.254 4.642-.388 6.238.847 1.33 1.03 1.67 2.601 1.305 4.081-.365 1.48-1.454 2.808-2.954 3.256-1.622.483-3.028.312-4.48-.064-1.453-.376-2.933-.97-4.615-1.267l-.583-.103v.591c0 .385-.092 1.131-.124 1.87-.032.739-.057 1.484.343 2.08v.001l.002.004c.012.017.016.017.027.031l.014.189.197.133c.511.347 1.134.493 1.512.599v.002h.002a18.843 18.843 0 0 0 5.052.68c.386 0 .771-.013 1.155-.033a11.197 11.197 0 0 0 3.29-.504c1.205-.339 2.362-.87 3.377-1.693 1.815-1.471 2.846-3.797 3.056-6.177.21-2.38-.402-4.843-1.985-6.589h-.002c-1.135-1.25-2.65-2.007-4.244-2.38h-.002c-2.122-.5-4.067-.205-6.042-.019l.432-5.399h10.01v-4.668zm-35.497.617c.217-.027.332.034.479.213.146.179.27.49.312.831.04.341 0 .706-.109.979-.108.273-.26.44-.467.515-.298.11-.393.059-.539-.081-.146-.14-.292-.442-.35-.8a2.404 2.404 0 0 1 .067-1.066c.1-.304.249-.479.403-.539a.828.828 0 0 1 .204-.052zm-57.253.376h.948v18.563c0 3.327.472 7.005-.387 10.04-.638 2.24-2.659 3.241-4.942 3.245-.427 0-1.015.057-1.55.03-.536-.025-.94-.174-1.03-.294v-.002c-.016-.022-.074-.21-.071-.469 0-.095.008-.204.015-.306.89.071 1.822.216 2.78.167 1.126-.058 2.288-.436 3.17-1.543.952-1.192 1.185-2.803 1.217-4.397.03-1.595-.15-3.207-.15-4.409zm8.803 0h.95v12.897c0 2.54-.3 5.413.997 7.953 1.376 2.696 4.36 4.054 7.326 4.11 2.964.057 5.993-1.187 7.457-3.839 1.36-2.46 1.01-5.238 1.01-7.707V50.87h1.077v13.284c0 2.877.164 5.833-1.186 8.254h.002c-1.548 2.77-4.95 4.231-8.37 4.229-3.42-.003-6.764-1.459-8.232-4.338-1.246-2.441-1.031-5.297-1.031-8.145zm84.905 0h12.563v2.684h-9.932l-.598 7.476.579-.046c2.246-.177 4.228-.548 6.318-.055h.002c1.438.336 2.762 1.01 3.736 2.082 1.354 1.492 1.922 3.684 1.733 5.835-.19 2.15-1.135 4.23-2.692 5.492-.894.724-1.92 1.203-3.025 1.514h-.008l-.006.004a10.21 10.21 0 0 1-3.008.459h-.023c-.379.02-.757.033-1.128.033a17.867 17.867 0 0 1-4.789-.646 5.83 5.83 0 0 1-1.048-.4l-.093-.1c-.045-.048-.058-.065-.055-.06-.112-.169-.203-.8-.174-1.478.02-.454.053-.86.083-1.275 1.35.3 2.647.752 4 1.102 1.536.398 3.174.6 5.012.053 1.883-.563 3.192-2.18 3.633-3.97.442-1.79-.003-3.816-1.659-5.1-2.006-1.553-4.821-1.308-6.966-1.048-.672.08-1.364.224-1.938.195-.574-.028-.984-.165-1.336-.707v-.002h-.002c-.116-.177-.175-.796-.098-1.465.076-.668.23-1.365.28-1.88v-.002l.078-.787v-.004c.212-2.598.52-5.25.56-7.905zm-26.511 1.067-.498.002c-.653.003-1.188.276-1.485.694-.296.418-.386.904-.444 1.38-.116.951-.15 1.9-.486 2.3-.36.427-.844.435-1.479.578-.317.071-.687.188-.97.504-.284.315-.418.77-.42 1.349l-.001.498h2.85v11.09c0 1.875-.092 4.287 1.586 5.884.992.945 2.276 1.281 3.542 1.326 1.267.044 2.542-.19 3.624-.413l.396-.082v-2.465l-.518.022c-.808.034-1.63.208-2.387.255-.758.048-1.42-.022-1.975-.389-.654-.434-.974-1.049-1.151-1.804-.177-.756-.184-1.633-.184-2.458V59.241h5.697v-2.666h-5.697zm-.993 1.198v4.432h5.698v.682h-5.698v11.96c0 .825-.004 1.77.21 2.681.213.911.67 1.808 1.567 2.405h.002c.81.537 1.73.609 2.586.555.668-.042 1.27-.136 1.85-.198v.55c-.965.19-2.003.382-2.992.347-1.119-.039-2.124-.318-2.893-1.05h-.002c-1.292-1.23-1.275-3.273-1.275-5.167V58.25h-2.729c.02-.04.024-.166.044-.19.077-.085.205-.146.45-.201.49-.11 1.381-.144 2.021-.905.706-.837.61-1.983.712-2.82.05-.418.142-.748.267-.924.034-.047.143-.038.182-.074zM50.904 56.14c-2.316.041-4.598.875-5.957 2.496l-.198-2.06h-2.63V77.14h2.935v-9.637c0-2.15-.05-4.288.947-6.068h.002c.751-1.346 2.508-2.285 4.34-2.49 1.83-.205 3.654.311 4.608 1.638.932 1.301.893 3.464.893 5.246V77.14h2.804V65.83c0-2.077.207-4.473-.953-6.552h-.002c-1.235-2.208-4.05-3.187-6.789-3.138zm15.407.434-2.44.002V77.14h2.936V56.573Zm-15.387.558c2.484-.044 4.931.89 5.905 2.63h-.002c.972 1.744.829 3.936.829 6.068v10.32h-.82V65.83c0-1.748.144-4.117-1.08-5.824-1.226-1.706-3.438-2.28-5.524-2.046-2.086.233-4.128 1.259-5.095 2.992-1.166 2.081-1.076 4.423-1.076 6.552v8.645h-.95v-18.58h.735l.26 2.705h.89l.137-.274c.903-1.805 3.307-2.823 5.79-2.868zm14.89.434v18.583h-.95v-18.58Z"
      ></path>
    </svg>
  );
};

const CassandraIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#bae6fa"
        d="M63.797 38.701c-12.142.273-24.5 4.01-38.479 11.752-2.538 2.933-3.848 6.112-3.57 9.34.94 10.97 19.725 18.315 41.956 16.408 22.235-1.908 39.495-12.346 38.554-23.313-.177-2.058-.982-3.99-2.32-5.755-12.72-5.7-24.335-8.699-36.14-8.432Z"
      ></path>
      <path
        fill="#fff"
        d="M65.369 38.684c-9.877-.018-19.85 2.232-30.689 7.062-.455 1.74-.7 3.55-.7 5.415 0 13.01 11.748 23.559 26.24 23.559 14.49 0 26.239-10.548 26.239-23.559 0-3.506-.862-6.83-2.393-9.82-6.32-1.722-12.49-2.645-18.697-2.657Z"
        opacity=".35"
      ></path>
      <path
        fill="#fff"
        d="M60.22 37.763c-4.697-.287-12.79 2.163-19.537 4.607a20.031 20.031 0 0 0-1.594 7.846c0 11.4 10.335 20.642 21.268 20.642 10.86 0 20.47-9.258 21.268-20.64.26-3.709-1.017-7.2-2.787-10.214-6.997-1.23-14.42-1.984-18.619-2.24"
      ></path>
      <path
        fill="#353333"
        d="M48.17 48.72c.576-1.276 1.448-1.9 2.293-2.969-.093-.253-.3-1.082-.3-1.37a2.322 2.322 0 0 1 3.178-2.155 16.913 16.913 0 0 1 13.986-3.07c.466.105.92.231 1.367.371-5.025-.697-10.688 1.083-14.54 4.192.117.277.443 1.07.443 1.391 0 1.282-.829 1.593-2.11 1.593-.293 0-.57-.056-.828-.153-.87 1.168-1.937 3.394-2.459 4.786 2.13 1.906 4.056 2.595 6.563 3.534-.005-.12.086-.23.086-.352 0-3.866 3.403-7.007 7.27-7.007a6.993 6.993 0 0 1 6.892 5.824c1.73-1.1 3.4-1.943 4.674-3.573-.296-.362-.618-1.39-.618-1.895 0-1.162.944-2.105 2.109-2.105.164 0 .322.023.477.06a18.418 18.418 0 0 0 1.445-4.192c-6.045-4.474-17.74-3.863-17.74-3.863s-9.308-.486-15.608 2.584c.42 3.038 1.632 5.925 3.42 8.37"
      ></path>
      <path
        fill="#353333"
        d="M77.062 46.977c.429.384.662.723.844 1.052.567 1.016-.568 1.947-1.73 1.947a2.12 2.12 0 0 1-.347-.035c-1.311 2.047-3.606 4.674-5.646 5.996 3.128.513 6.077 1.764 8.424 3.7 1.708-3.063 3.02-7.483 3.02-11.237 0-2.86-1.264-4.955-3.167-6.492-.101 1.531-.92 3.674-1.398 5.07m-25.384 19.39c1.041-2.877 3.605-5.107 6.03-7.068-.356-.486-.887-1.688-1.108-2.258a16.965 16.965 0 0 1-7.605-4.812c-.013.065-.03.13-.048.194a15.34 15.34 0 0 0-.26 5.102 3.047 3.047 0 0 1 2.486 2.998c0 .885-.777 2.166-1.378 2.725.655 1.413 1.1 2.095 1.883 3.12"
      ></path>
      <path
        fill="#353333"
        d="M51.495 68.785c-1.244-1.237-2.103-3.702-2.91-5.25a2.93 2.93 0 0 1-.463.04c-1.686 0-3.452-1.416-3.052-3.053.222-.906.846-1.498 1.865-1.992-.233-1.877-.296-4.575.14-6.525.125-.557.39-.82.566-1.35-1.86-2.723-3.063-6.296-3.063-9.839 0-.13.008-.257.01-.385-3.143 1.576-5.5 4.06-5.5 7.967 0 8.648 4.98 17.132 12.39 20.456.006-.023.01-.047.017-.07M69.717 56.83a6.997 6.997 0 0 1-6.599 4.68 6.95 6.95 0 0 1-4.318-1.5c-2.454 1.91-4.68 5.267-5.81 8.179.506.545.86.996 1.43 1.48 1.716.448 4.08 0 5.937 0 7.473 0 14.09-3.325 17.883-9.153-2.523-1.747-5.498-3.409-8.523-3.686"
      ></path>
      <path
        fill="#1185b0"
        d="M47.978 49.73a16.908 16.908 0 0 1 2.143-3.524 2.323 2.323 0 0 1 2.174-3.135c.301 0 .59.06.855.165a16.922 16.922 0 0 1 15.353-2.698c-5.026-.696-10.217.843-14.07 3.952a2.322 2.322 0 0 1-2.966 3.07 15.664 15.664 0 0 0-2.103 3.852c1.83 1.971 4.074 3.53 6.582 4.468-.006-.12-.017-.237-.017-.36a6.997 6.997 0 0 1 6.997-6.999c3.466 0 6.335 2.52 6.895 5.824a18.132 18.132 0 0 0 4.537-4.142 2.086 2.086 0 0 1-.481-1.324c0-1.164.943-2.107 2.107-2.107.164 0 .322.024.477.06a18.403 18.403 0 0 0 1.445-4.19c-6.043-4.477-17.74-3.866-17.74-3.866s-9.308-.486-15.608 2.586c.421 3.037 1.632 5.926 3.42 8.368"
      ></path>
      <path
        fill="#1185b0"
        d="M77.388 47.321c.429.384.703.937.703 1.558a2.108 2.108 0 0 1-2.107 2.107c-.118 0-.233-.017-.347-.036a17.043 17.043 0 0 1-5.087 5.118 17.025 17.025 0 0 1 8.198 3.684 21.158 21.158 0 0 0 2.687-10.342c0-2.86-1.263-4.954-3.167-6.49-.1 1.53-.4 3.006-.88 4.401M52 67.06a16.978 16.978 0 0 1 5.278-7.42 6.971 6.971 0 0 1-.87-1.586 16.965 16.965 0 0 1-7.603-4.812c-.015.065-.033.128-.048.192a15.295 15.295 0 0 0-.263 5.102A3.05 3.05 0 0 1 50 63.773a18.331 18.331 0 0 0 2 3.287"
      ></path>
      <path
        fill="#1185b0"
        d="M51.486 68.749a16.96 16.96 0 0 1-3.09-4.202 3 3 0 0 1-.466.039 3.053 3.053 0 0 1-3.052-3.053c0-1.209.705-2.25 1.724-2.744a16.884 16.884 0 0 1 .283-5.773 17.13 17.13 0 0 1 .45-1.633 16.885 16.885 0 0 1-2.948-9.557c0-.129.007-.257.01-.386-3.144 1.576-5.5 4.061-5.5 7.97 0 8.647 5.164 16.085 12.574 19.41l.015-.071m18.039-10.91a6.997 6.997 0 0 1-6.599 4.68 6.96 6.96 0 0 1-4.318-1.498c-2.454 1.911-4.305 4.515-5.436 7.426a18.67 18.67 0 0 0 1.62 1.547 21.38 21.38 0 0 0 5.373.685c7.473 0 14.04-3.858 17.834-9.686-2.522-1.747-5.448-2.876-8.474-3.154"
      ></path>
      <path
        fill="#fff"
        d="m60.95 49.56-3.663-6.55 1.982 6.953-5.942-4.32 4.655 5.848-7.377-2.713 5.821 4.307-7.464.23 7.632 1.97-7.64 1.653 7.541.545-6.36 4.073 6.55-2.374-4.545 5.756 5.741-4.632-2.066 7.722 4.432-6.284-.622 7.423 2.517-6.73 2.143 7.072.52-7.093 3.18 6.052-1.878-6.92 5.82 4.508-3.758-5.75 6.386 2.49-4.883-4.8 6.548.514-6.45-2.474 6.467-1.542-6.49-.332 5.28-4.037-5.992 2.148 4.073-5.645-5.626 3.74 1.967-6.608-3.864 5.447-.087-6.884-2.544 6.131-2.118-6.203zm0 0"
      ></path>
      <path
        fill="#353333"
        d="M.93 68.41C20.982 48.354 37 42.164 51.535 39.337c1.925-.374 2.288-4.577 2.288-4.577s.268 3.096 1.615 3.5c1.345.403 3.096-4.847 3.096-4.847s-1.615 4.711 0 4.982c1.615.268 4.575-4.578 4.575-4.578s-1.21 4.173-.402 4.442c.807.27 4.844-6.057 4.844-6.057s-2.421 4.173-.134 4.577c2.29.405 5.628-2.848 5.628-2.848s-2.625 2.975-1.455 3.387c4.98 1.75 9.01-4.723 9.01-4.723s-.934 2.838-3.356 5.934c5.248 1.347 9.147-6.56 9.147-6.56l-3.9 7.907c2.02 1.076 10.096-8.21 10.096-8.21s-4.173 7.267-6.595 8.746c1.345 1.08 6.19-3.228 6.19-3.228s-3.902 4.843-2.421 5.113c2.153 1.75 10.093-9.018 10.093-9.018s-3.094 6.326-7.672 11.306c3.825 1.913 13.326-10.363 13.326-10.363s-.27 3.902-7.133 10.095c5.113-.673 11.71-10.364 11.71-10.364s-2.424 7.268-8.212 12.381c5.022-.52 13.055-12.92 13.055-12.92s-3.096 8.613-9.42 13.594c6.998 1.55 17.093-8.884 17.093-8.884s-3.971 7.404-9.152 10.433c5.788 2.22 13.728-6.932 13.728-6.932s-7.94 12.248-20.593 11.71c-4.15-.177-16.706-12.595-43.609-11.576C27.445 43.106 19.906 58.18.93 68.41"
        opacity=".35"
      ></path>
      <path
        fill="#353333"
        d="M93.409 30.142s-8.075 9.287-10.095 8.21l3.899-7.908s-3.9 7.907-9.146 6.562c2.42-3.096 3.355-5.935 3.355-5.935s-4.03 6.474-9.01 4.723c-1.17-.41 1.455-3.385 1.455-3.385s-3.34 3.251-5.627 2.847c-2.288-.403.134-4.576.134-4.576s-4.037 6.327-4.847 6.057c-.806-.268.405-4.442.405-4.442s-2.96 4.846-4.575 4.577c-1.615-.27 0-4.98 0-4.98s-1.75 5.25-3.096 4.845c-1.347-.403-1.615-3.499-1.615-3.499s-.364 4.203-2.288 4.575c-14.536 2.828-30.553 9.02-50.608 29.073 18.977-10.23 26.514-25.304 62.047-26.649 26.903-1.02 39.458 11.397 43.609 11.574 12.653.54 20.594-11.71 20.594-11.71s-7.941 9.152-13.73 6.931c5.183-3.027 9.153-10.43 9.153-10.43s-10.095 10.43-17.092 8.882c6.324-4.979 9.419-13.59 9.419-13.59s-8.033 12.397-13.055 12.92c5.788-5.115 8.21-12.385 8.21-12.385s-6.595 9.692-11.71 10.366c6.866-6.192 7.136-10.095 7.136-10.095s-9.5 12.276-13.325 10.363c4.573-4.98 7.67-11.306 7.67-11.306s-7.94 10.768-10.094 9.018c-1.481-.27 2.424-5.115 2.424-5.115s-4.845 4.307-6.192 3.23c2.422-1.48 6.594-8.748 6.594-8.748zm12.916 22.638c-1.354-.092-2.548.414-3.158 2.075C96.907 66.767 83.785 73.43 68.44 75.65c-15.344 2.22-26.65-1.006-35.937-3.623C20.29 68.583 10.6 74.709 0 69.392c2.452 1.94 5.25 3.836 13.325 3.86 2.738.01 11.507-.43 13.122.983 1.615 1.414-5.45 8.076-5.45 8.076s11.955-10.108 13.122-6.662c.726 2.145-3.432 7.875-3.432 7.875s4.17-5.658 7.27-6.865c2.126-.83 3.92-.73 5.45 1.414 1.01 1.412-4.845 8.277-4.845 8.277s7.872-7.671 9.286-7.267c1.414.402 0 7.267 0 7.267s2.896-6.956 4.44-7.47c2.12-.706-4.845 16.15-4.845 16.15s8.507-15.595 10.095-15.946c2.726-.606 4.544 10.9 4.544 10.9s-1.328-10.052.1-10.7c9.04-4.09 3.838 17.363 3.838 17.363s5.912-14.558 2.28-17.787c9.588 6.358 8.42 17.787 8.42 17.787s2.52-5.442-4.552-18.823c3.838-.2 9.596 9.94 9.596 9.94s-6.257-11.104-2.017-11.305c8.424-.4 9.287 14.737 9.287 14.737s2.523-2.12-4.24-16.96c4.306-2.758 14.738 13.73 14.738 13.73s-9.623-16.084-8.075-17.161c1.546-1.077 7.202 5.116 7.202 5.116s-4.307-5.922-3.165-6.528c1.144-.607 12.586 11.777 12.586 11.777s-10.096-12.115-8.346-13.596c1.035-.877 4.035.745 6.325 2.216-3.21-2.296-7.821-5.889-6.325-6.666 3.096-1.607 11.913 3.844 11.913 3.844s-5.317-4.374-4.443-5.45c.875-1.078 11.305 6.864 11.305 6.864s-9.22-7.27-9.69-9.086c-.472-1.816 7.27.606 7.27.606s-8.548-3.97-8.682-5.114c-.136-1.146 5.652 1.278 5.652 1.278s-3.754-3.086-6.734-3.286zm-.266 17.01a109.786 109.786 0 0 0 2.827 1.956s-1.25-.942-2.827-1.956z"
      ></path>
      <path
        fill="#353333"
        d="M.404 70.603c10.598 5.317 20.29-.807 32.504 2.634 9.286 2.617 20.592 5.846 35.935 3.623 15.345-2.218 28.467-8.882 34.728-20.794 1.95-5.317 9.892 1.21 9.892 1.21s-5.788-2.42-5.654-1.277c.136 1.144 8.68 5.113 8.68 5.113s-7.737-2.42-7.266-.605c.472 1.818 9.689 9.086 9.689 9.086s-10.428-7.942-11.304-6.866c-.875 1.077 4.44 5.454 4.44 5.454s-8.814-5.454-11.91-3.845c-2.226 1.155 9.152 8.623 9.152 8.623s-7.403-5.653-9.152-4.172c-1.75 1.48 8.346 13.593 8.346 13.593S97.04 69.997 95.898 70.603c-1.146.605 3.163 6.527 3.163 6.527s-5.654-6.19-7.2-5.113c-1.548 1.077 8.076 17.159 8.076 17.159s-10.432-16.487-14.74-13.728c6.765 14.838 4.24 16.96 4.24 16.96s-.862-15.14-9.286-14.74c-4.24.202 2.018 11.307 2.018 11.307s-5.76-10.142-9.596-9.94c7.07 13.38 4.55 18.82 4.55 18.82S78.29 86.432 68.7 80.072c3.634 3.23-2.28 17.787-2.28 17.787s5.204-21.453-3.836-17.363c-1.429.646-.1 10.7-.1 10.7s-1.819-11.51-4.542-10.901c-1.59.352-10.095 15.948-10.095 15.948s6.965-16.858 4.845-16.15c-1.544.515-4.44 7.47-4.44 7.47s1.411-6.864 0-7.268c-1.415-.405-9.289 7.268-9.289 7.268s5.857-6.864 4.845-8.278c-1.53-2.142-3.323-2.243-5.45-1.414-3.097 1.207-7.268 6.865-7.268 6.865s4.158-5.73 3.432-7.875C33.356 73.415 21.4 83.525 21.4 83.525s7.065-6.664 5.45-8.076c-1.615-1.414-10.385-.976-13.122-.983C5.653 74.44 2.855 72.545.403 70.604"
        opacity=".35"
      ></path>
    </svg>
  );
};

const GrafanaIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <linearGradient
        id="a"
        x1="45.842"
        x2="45.842"
        y1="89.57"
        y2="8.802"
        gradientTransform="translate(-2.405 27.316) scale(1.4463)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fcee1f"></stop>
        <stop offset="1" stop-color="#f15b2a"></stop>
      </linearGradient>
      <path
        fill="url(#a)"
        d="M69.162 0c-9.91 6.4-11.77 14.865-11.77 14.865s.002.206-.101.412c-.62.104-1.033.31-1.549.413-.722.206-1.445.413-2.168.826l-2.168.93c-1.445.722-2.89 1.341-4.336 2.167-1.342.826-2.683 1.548-4.025 2.477a1.266 1.266 0 0 1-.309-.205c-13.316-5.161-25.084 1.031-25.084 1.031-1.032 14.245 5.367 23.02 6.606 24.672-.31.929-.62 1.754-.93 2.58a52.973 52.973 0 0 0-2.166 9.91c-.103.413-.104 1.033-.207 1.445C8.671 67.613 5.06 80.103 5.06 80.103c10.219 11.768 22.193 12.49 22.193 12.49 1.445 2.685 3.302 5.369 5.264 7.743.825 1.032 1.756 1.96 2.582 2.992-3.716 10.632.619 19.613.619 19.613 11.458.413 18.992-4.955 20.54-6.297 1.136.31 2.272.724 3.407 1.034a47.25 47.25 0 0 0 10.633 1.549h4.644C80.31 126.969 89.807 128 89.807 128c6.71-7.123 7.123-14.038 7.123-15.69v-.62c1.342-1.033 2.683-2.064 4.129-3.2 2.684-2.374 4.955-5.264 7.02-8.154.206-.207.309-.62.618-.826 7.639.413 12.903-4.748 12.903-4.748-1.24-7.949-5.78-11.768-6.71-12.49l-.103-.104-.103-.104-.104-.103c0-.413.104-.93.104-1.445.103-.93.103-1.755.103-2.58v-3.407c0-.206 0-.413-.103-.722l-.104-.723-.103-.723c-.104-.929-.31-1.754-.413-2.58-.825-3.406-2.166-6.71-3.818-9.498-1.858-2.993-4.026-5.471-6.504-7.742-2.477-2.168-5.264-4.025-8.154-5.264-2.994-1.342-5.884-2.167-8.98-2.476-1.446-.207-3.098-.207-4.544-.207H79.69c-.825.103-1.546.205-2.27.308-3.096.62-5.883 1.756-8.36 3.201-2.478 1.446-4.646 3.407-6.504 5.575-1.858 2.167-3.2 4.438-4.13 6.916a23.313 23.313 0 0 0-1.548 7.431v2.684c0 .31 0 .62.104.93.103 1.238.31 2.374.722 3.51.723 2.27 1.756 4.334 3.098 6.09a19.973 19.973 0 0 0 4.54 4.335c1.756 1.136 3.408 1.96 5.266 2.477 1.858.516 3.509.826 5.16.722h2.376c.206 0 .412-.101.619-.101.206 0 .31-.104.619-.104.31-.103.825-.207 1.135-.31.722-.207 1.342-.62 2.064-.826.723-.31 1.24-.722 1.756-1.032.103-.103.309-.207.412-.31.62-.413.723-1.238.207-1.858-.413-.413-1.136-.62-1.756-.31-.103.103-.205.104-.412.207-.413.206-1.032.413-1.445.619-.62.103-1.135.31-1.754.414-.31 0-.62.102-.93.102h-2.58c-.103 0-.31.001-.414-.102-1.239-.206-2.58-.62-3.818-1.137-1.239-.619-2.478-1.34-3.51-2.373a15.894 15.894 0 0 1-2.89-3.51c-.826-1.341-1.24-2.89-1.446-4.335-.103-.826-.207-1.55-.103-2.375v-1.239c0-.413.103-.825.207-1.238.619-3.406 2.27-6.71 4.851-9.187.723-.723 1.342-1.238 2.168-1.754.826-.62 1.547-1.032 2.373-1.342.826-.31 1.756-.723 2.582-.93.93-.206 1.858-.414 2.684-.414.413 0 .929-.101 1.342-.101h1.238c1.032.103 2.065.205 2.994.412 1.961.413 3.82 1.135 5.678 2.168 3.613 2.064 6.708 5.16 8.566 8.877.93 1.858 1.548 3.82 1.961 5.988.103.62.104 1.03.207 1.547v2.787c0 .62-.103 1.136-.103 1.756-.104.62-.102 1.134-.205 1.754-.104.619-.208 1.136-.311 1.755-.206 1.136-.722 2.168-1.031 3.303-.826 2.168-1.963 4.232-3.305 5.986-2.684 3.717-6.502 6.815-10.63 8.776-2.169.929-4.337 1.755-6.608 2.064a19.003 19.003 0 0 1-3.407.309h-1.755c-.62 0-1.238.002-1.858-.102-2.477-.206-4.85-.724-7.224-1.343-2.375-.723-4.647-1.548-6.815-2.684-4.335-2.27-8.153-5.573-11.25-9.289-1.445-1.961-2.892-4.027-4.027-6.092-1.136-2.064-1.961-4.438-2.58-6.709-.723-2.27-1.032-4.645-1.135-7.02v-3.613c0-1.135.102-2.372.309-3.61.103-1.24.309-2.376.619-3.614.206-1.239.62-2.375.93-3.614.722-2.374 1.444-4.644 2.476-6.812 2.064-4.335 4.645-8.155 7.742-11.252a24.86 24.86 0 0 1 2.479-2.168c.31-.31 1.135-1.033 2.064-1.549s1.858-1.136 2.89-1.549c.414-.206.93-.413 1.446-.722.206-.103.411-.206.824-.309.207-.103.414-.207.826-.31 1.033-.413 2.066-.825 3.098-1.135.207-.103.62-.104.826-.207.207-.103.618-.102.824-.205.62-.103 1.033-.208 1.55-.414.206-.104.619-.104.825-.207.207 0 .62-.102.827-.102.206 0 .62-.103.826-.103l.412-.104.412-.103c.206 0 .62-.104.826-.104.31 0 .62-.104.93-.104.206 0 .721-.101.928-.101.206 0 .311 0 .62-.104h.723c.31 0 .618 0 .928-.103h4.647c2.064.103 4.128.31 5.986.723 3.82.722 7.638 1.961 10.941 3.613 3.304 1.548 6.4 3.611 8.877 5.78.104.102.311.207.414.413.104.103.31.206.412.412.31.207.62.62.93.826.31.207.62.62.93.827.206.31.618.618.824.927 1.136 1.136 2.169 2.375 3.098 3.51a41.422 41.422 0 0 1 4.44 7.02c.102.103.1.207.204.414.103.103.104.205.207.412.103.206.206.62.412.826.104.206.208.62.31.826.104.207.208.62.311.826.413 1.033.826 2.064 1.135 3.096.62 1.548.929 2.993 1.239 4.13.103.412.62.825 1.033.825.619 0 .927-.414.927-1.033-.31-1.755-.308-3.198-.412-4.953-.206-2.168-.619-4.647-1.238-7.434-.62-2.787-1.86-5.677-3.305-8.877-1.548-3.096-3.509-6.4-6.09-9.394-1.032-1.239-2.167-2.373-3.302-3.612 1.858-7.122-2.168-13.42-2.168-13.42-6.916-.412-11.253 2.168-12.801 3.303-.206-.103-.618-.205-.824-.308-1.136-.413-2.375-.93-3.613-1.342-1.24-.31-2.478-.827-3.717-1.033-1.239-.31-2.58-.62-4.026-.827-.206 0-.413-.103-.722-.103C77.833 4.128 69.162 0 69.162 0z"
      ></path>
    </svg>
  );
};

const CucumberIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#00A818"
        d="M92.2 8.3c-1-.6-2-1.2-3-1.7l-3.3-1.5c-.4-.1-.7-.3-1.1-.4-1-.4-1.9-.8-2.9-1.1C76.5 1.8 70.8.9 64.8.9 34.3.9 9.7 25.6 9.7 56.1c0 26.9 19.2 49.2 44.5 54.2v15.8c32.9-5 62.1-31.2 64.3-65.6 1.3-20.8-9-42-26.3-52.2zM51.6 21.6c1.8-.2 3.8.5 5.1 2.1 1 1 1.6 2.3 2.3 3.7 2 4.7 1.3 9.8-1.4 13.5-4.7-1-9-4-11-8.7-.7-1.3-1.1-3.1-1.1-4.4.1-3.4 3-5.9 6.1-6.2zM35.1 37.9h1.1c1.7 0 3 .4 4.7 1.1 4.7 2 8.1 6 9.1 10.4-4 2.7-9.5 3.4-14.2 1.4-1.3-.7-2.6-1.4-4-2.4-4.4-3.6-2-10.3 3.3-10.5zm1.1 34.7c-6.1.3-9-6.7-4.6-10.4 1-1 2.3-1.7 4-2.4 1.8-.8 3.6-1.1 5.5-1.2 3.1-.1 6.1.8 8.6 2.5-.7 4.4-4 8.4-8.7 10.4-1.5.8-3.2 1.1-4.8 1.1zm23.2 9.8c-.7 1.3-1.3 2.7-2.3 4-3.4 4.4-11.2 1.3-10.8-4.4 0-1.3.4-3 1.1-4.3 2-4.7 6-7.7 10.7-8.7 2.6 4 3.3 9.1 1.3 13.4zm9.1-55c.7-1.3 1.3-2.7 2.3-4 1.4-1.6 3.4-2.3 5.3-2.1 3.1.3 6.1 2.8 5.9 6.4 0 1.3-.4 3.1-1.1 4.4-2 4.7-6 7.7-10.7 8.7-3-3.6-3.7-8.6-1.7-13.4zm3 59c-1-1-1.6-2.3-2.3-3.7-2-4.7-1.3-9.8 1.4-13.5 4.7 1 9 4 11 8.7.7 1.3 1.1 3.1 1.1 4.4.2 5.2-7.5 8.2-11.2 4.1zm20.6-14.1c-1.7 0-3-.4-4.7-1.1-4.7-2-8.1-6-9.1-10.4 2.5-1.7 5.6-2.6 8.7-2.5 1.8 0 3.7.4 5.5 1.2 1.3.7 2.6 1.3 4 2.3 4.6 3.4 1.6 10.9-4.4 10.5z"
      ></path>
    </svg>
  );
};

const TomcatIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#d1a41a"
        d="M22.148 78.306a80.73 80.73 0 004.857 5.446c-5.186 1.56-8.586 4.458-10.706 7.017-3.356 4.05-5.132 9.398-4.723 13.988h-8.93c1.79-3.887 8.94-15.115 19.503-26.45zm103.45 28.886M125.597 107.192H114.74c-24.91-12.999-46.78-22.165-70.012-24.167.049-3.233.624-6.893 1.731-10.972l-2.14-.576c-1.136 4.192-1.732 7.985-1.8 11.38-2.421-.162-4.857-.24-7.317-.24-2.081 0-3.98.191-5.712.526-2.258-2.254-4.182-4.408-5.815-6.45C34.389 65.534 52.038 55.438 67.398 51.64c4.325 14.376 13.609 24.226 24.876 30.853a47.543 47.543 0 002.435-1.485l19.656 21.16.86-.073c5.368-.462 8.419 2.45 9.226 3.356.595.659.95 1.264 1.146 1.741z"
      ></path>
      <path
        fill="#ffdc76"
        d="M116.008 36.412c.399 19.528-9.564 35.07-23.513 43.04C68.82 67.66 64.362 37.776 68.397 21.747c1.122 6.13 3.164 9.973 7.572 11.857 9.614-2.75 22.844-2.967 32.59-.28 4.06-2.952 5.634-7.464 6.495-11.405 1.072 4.585.95 14.494.954 14.494z"
      ></path>
      <path d="M49.096 58.246l7.36-3.345 3.611 10.702zM41.604 62.126l4.284-2.542 3.877 6.688zM33.309 67.61l3.746-2.81 1.873 6.692zM99.536 85.273l-2.677-2.543-3.478 5.353zM104.49 91.158l-2.145-2.274-5.618 4.28zM95.526 30.684l-6.824.134 4.148 9.098zM68.362 47.943l-.669-3.88 6.559 3.479zM69.966 53.696l-.669-2.541 4.015 1.605zM115.191 49.55l.94-2.944-5.353 2.274zM113.184 55.57l.802-2.408-4.148 1.204z"></path>
      <g>
        <path d="M65.538 63.203h12.913v1.594H65.538zM65.538 59.377h12.913v1.594H65.538zM104.968 63.203h12.912v1.594h-12.912zM104.968 59.377h12.912v1.594h-12.912zM100.417 49.926H79.374V48.49h6.548c.807-3.453.966-6.753-.006-8.426-.416-.71-.99-1.043-1.808-1.043-3.744 0-5.29 3.959-5.355 4.127l.001-.001-1.343-.504c.077-.207 1.95-5.057 6.697-5.057 1.325 0 2.378.608 3.046 1.757 1.186 2.037 1.047 5.562.243 9.147h11.49c1.527-4.485 4.714-6.6 10.04-6.6v1.435c-5.772 0-7.39 2.447-8.544 5.165h6.27l-.015 1.428-6.222.007zm.944 7.085l.01-.001m-.01.001l.01-.001"></path>
        <path d="M101.361 57.011l.01-.001c-1.702-2.51-2.242-4.652-1.53-7.091l-1.462.007c-.509 1.624-.305 4.07.95 6.17h-14.6c.888-1.78 1.711-3.949 2.313-6.17h-1.486c-.664 2.355-1.595 4.686-2.644 6.532l-.339.597 8.193 5.157-4.612 3.04.79 1.198 5.155-3.399 5.566 3.632.764-1.214-5.16-3.192s7.716-5.012 8.099-5.257c-.003-.003-.004-.006-.006-.01zm-9.279 4.334l-6.06-3.815 11.843.003-5.783 3.812z"></path>
      </g>
      <g>
        <path d="M118.414 34.682c-.009-2.495-.786-13.038-2.214-15.941-3.872 1.471-10.917 6.239-12.512 11.113-7.642-1.14-16.257-1.006-23.804.3-1.26-5.245-7.588-9.258-12.362-11.52-2.014 3.398-2.906 11.277-2.68 16.866l-.026.018c.886 23.468 12.399 38.08 27.453 46.936 15.49-8.85 26.555-26.104 26.126-47.783l.02.01zm-12.888-4.525l.169.031-.17-.03zm-.964-.166c.136.022.273.046.409.07l-.409-.07zm11.443 6.384c.398 19.528-9.565 35.07-23.513 43.04C68.818 67.62 64.358 37.739 68.395 21.71c1.123 6.127 3.16 9.971 7.574 11.856 9.61-2.75 22.84-2.967 32.586-.28 4.061-2.953 5.636-7.463 6.496-11.404 1.075 4.586.95 14.492.954 14.494zm10.1 67.56"></path>
        <path d="M126.104 103.935c-2.431-2.72-7.194-4.007-11.172-3.912-2.823-3.36-19.19-20.596-19.19-20.596l-1.134 1.429 19.76 21.273.857-.074c5.369-.46 8.42 2.452 9.229 3.355.592.663.95 1.267 1.144 1.742h-10.86c-24.911-13-46.78-22.165-70.013-24.163.05-3.233.626-6.893 1.73-10.97l-2.136-.58c-1.135 4.192-1.734 7.988-1.801 11.382-2.42-.16-4.857-.244-7.315-.244-2.085 0-3.983.194-5.714.53-2.259-2.257-4.182-4.408-5.817-6.45 10.79-11.241 28.61-21.402 44.048-25.138l-.501-2.163c-16.625 4.01-34.823 14.923-44.963 25.467-4.706-6.352-6.573-11.564-7.128-15.514-.7-4.989.49-9.565 3.444-13.235 4.623-5.743 11.192-6.148 17.946-5.012-.131 1.067.009 2.087.436 2.717 1.786 2.639 11.387 3.566 17.117 1.009-4.229-5.926-12.795-8.82-15.168-7.66-.786.384-1.38 1.09-1.786 1.912-2.335-.418-4.654-.729-6.348-.716-5.957.044-10.511 2.125-13.922 6.363-3.347 4.157-4.7 9.32-3.912 14.93.746 5.314 3.377 10.966 7.786 16.826-.732.786-1.44 1.562-2.122 2.324C7.853 90.792-.003 103.687-.003 105.824v1.107h14.177l-.248-1.313c-.8-4.232.798-9.52 4.073-13.474 2.057-2.481 5.462-5.314 10.809-6.62 4.754 4.64 10.812 9.567 17.554 14.321h10.536v-1.107c0-1.249-.62-2.342-1.744-3.078-1.665-1.088-4.234-1.238-6.594-.433-2.25-2.506-3.512-5.853-3.784-10.011 22.865 2.024 44.736 11.258 69.412 24.15h13.578l.178-.89c.254-1.267-.437-2.965-1.846-4.541zM16.3 90.729c-3.354 4.048-5.132 9.395-4.724 13.985H2.643c1.795-3.883 8.943-15.11 19.505-26.45a80.408 80.408 0 004.858 5.448c-5.186 1.559-8.586 4.457-10.707 7.017z"></path>
      </g>
    </svg>
  );
};

const HibernateIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#59666c"
        d="m29.246 3.766 23.168 40.129-23.18 40.19-23.156-40.19Zm69.508 120.468L75.586 84.105l23.18-40.19 23.156 40.19Zm0 0"
      ></path>
      <path
        fill="#bcae79"
        d="M75.594 3.766H29.258L52.43 43.898h46.35ZM52.406 124.23H98.75L75.594 84.102H29.219Zm0 0"
      ></path>
    </svg>
  );
};

const OracleDatabaseIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#EA1B22"
        d="M55.387 66.469h8.333l-4.407-7.09-8.088 12.819h-3.681L57.382 56.8a2.324 2.324 0 011.931-.998c.765 0 1.478.363 1.892.972l9.876 15.424H67.4l-1.736-2.865h-8.438l-1.839-2.864zm38.235 2.864V55.958h-3.123v14.685c0 .402.156.791.454 1.089.298.298.7.466 1.141.466h14.244l1.841-2.865H93.622zm-51.677-2.397c3.033 0 5.496-2.449 5.496-5.482s-2.462-5.496-5.496-5.496H28.28v16.241h3.123V58.822h10.335c1.452 0 2.618 1.18 2.618 2.631s-1.167 2.631-2.618 2.631l-8.806-.013 9.324 8.127h4.538l-6.274-5.263h1.425zM9.059 72.198c-4.483 0-8.122-3.629-8.122-8.114s3.638-8.127 8.122-8.127h9.439c4.485 0 8.121 3.643 8.121 8.127s-3.636 8.114-8.121 8.114H9.059zm9.229-2.865a5.25 5.25 0 005.258-5.249 5.262 5.262 0 00-5.258-5.263H9.267a5.262 5.262 0 00-5.256 5.263 5.25 5.25 0 005.256 5.249h9.021zm59.314 2.865c-4.484 0-8.126-3.629-8.126-8.114s3.642-8.127 8.126-8.127h11.212l-1.829 2.864H77.81a5.267 5.267 0 00-5.264 5.263c0 2.903 2.36 5.249 5.264 5.249h11.263l-1.84 2.865h-9.631zm38.197-2.865a5.25 5.25 0 01-5.055-3.824h13.35l1.84-2.864h-15.19a5.266 5.266 0 015.055-3.824h9.163l1.854-2.864h-11.225c-4.484 0-8.126 3.643-8.126 8.127s3.642 8.114 8.126 8.114h9.631l1.841-2.865h-11.264"
      ></path>
    </svg>
  );
};

const EclipseIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          gradientUnits="userSpaceOnUse"
          x1=".5"
          y1="10.894"
          x2=".5"
          y2="-1.595"
          gradientTransform="matrix(76.53125 0 0 6.78125 32.176 54.11)"
        >
          <stop offset=".303" stop-color="#473788"></stop>
          <stop offset=".872" stop-color="#2c2255"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          gradientUnits="userSpaceOnUse"
          x1=".5"
          y1="8.965"
          x2=".5"
          y2="-3.524"
          gradientTransform="matrix(76.53125 0 0 6.78125 32.176 67.191)"
        >
          <stop offset=".303" stop-color="#473788"></stop>
          <stop offset=".872" stop-color="#2c2255"></stop>
        </linearGradient>
        <linearGradient
          id="c"
          gradientUnits="userSpaceOnUse"
          x1=".5"
          y1="2.152"
          x2=".5"
          y2="-1.667"
          gradientTransform="matrix(69.61719 0 0 22.17969 35.633 80.27)"
        >
          <stop offset=".303" stop-color="#473788"></stop>
          <stop offset=".863" stop-color="#2c2255"></stop>
        </linearGradient>
      </defs>
      <path
        fill="#2c2255"
        d="M35.633 80.27H16.375c2.55 8.75 7.281 16.59 14.21 23.515 11.044 11.047 24.325 16.563 39.852 16.563 3.106 0 6.114-.23 9.036-.672 11.699-1.766 21.941-7.055 30.715-15.89 6.972-6.927 11.738-14.766 14.308-23.516ZM25.016 54.113H14.953a58.89 58.89 0 0 0-.734 6.782h112.445a58.833 58.833 0 0 0-.738-6.782M14.219 67.191a59.14 59.14 0 0 0 .734 6.782H125.93c.375-2.246.62-4.508.738-6.782M124.5 47.812c-2.57-8.769-7.336-16.648-14.313-23.624-8.75-8.754-18.964-14.004-30.624-15.77a60.963 60.963 0 0 0-9.122-.684c-15.53 0-28.812 5.489-39.855 16.453-6.93 6.977-11.668 14.856-14.215 23.625"
      ></path>
      <path
        fill="#f7941e"
        d="M10.875 64.043c0-29.703 22.309-54.383 51.332-58.723-.719-.027-1.445-.058-2.172-.058-32.566.004-58.969 26.32-58.969 58.781 0 32.465 26.403 58.781 58.97 58.781.73 0 1.452-.027 2.175-.054-29.027-4.34-51.336-29.02-51.336-58.727Zm0 0"
      ></path>
      <path
        fill="url(#a)"
        d="M108.707 60.89a38.413 38.413 0 0 0-1.164-6.78H33.34a38.413 38.413 0 0 0-1.164 6.78Zm0 0"
      ></path>
      <path
        fill="url(#b)"
        d="M108.707 67.191H32.176c.183 2.29.574 4.559 1.164 6.782h74.203a38.45 38.45 0 0 0 1.164-6.782Zm0 0"
      ></path>
      <path
        fill="url(#c)"
        d="M70.441 102.45c15.41 0 28.696-9.083 34.809-22.18H35.633c6.117 13.097 19.398 22.18 34.808 22.18Zm0 0"
      ></path>
      <path
        fill="#fff"
        d="M26.504 67.191h100.082a55.61 55.61 0 0 0 .082-3.027c0-1.098-.04-2.187-.102-3.273H14.22a60.68 60.68 0 0 0-.102 3.273c0 1.016.031 2.023.082 3.027Zm8.906-19.379H16.371c-.625 2.051-1.031 4.157-1.418 6.301H125.57a55.385 55.385 0 0 0-1.515-6.3m-5.72 26.16H14.954c.375 2.14.805 4.246 1.422 6.297h108.05a56.053 56.053 0 0 0 1.49-6.297Zm0 0"
      ></path>
    </svg>
  );
};

const NetBeansIcon = () => {
  return (
    <svg viewBox="0 0 512 512">
      <g id="logo" stroke-width="0" fill="none" fill-rule="evenodd">
        <path d="M222,0 L222,99 L86,178 L0,128 L222,0 Z" fill="#A1C535" />
        <path
          d="M444,128 L358,178 L222,99 L222,0 L444,128 L444,128 Z"
          fill="#ADD439"
        />
        <path
          d="M444,384 L358,334 L358,178 L444,128 L444,384 L444,384 Z"
          fill="#1B6AC6"
        />
        <path
          d="M222,512 L222,413 L358,334 L444,384 L222,512 L222,512 Z"
          fill="#2E90E8"
        />
        <path
          d="M0,384 L86,334 L222,413 L222,512 L0,384 L0,384 Z"
          fill="#EA205E"
        />
        <path
          d="M0,128 L86,178 L86,334 L0,384 L0,128 L0,128 Z"
          fill="#A5073E"
        />
        <path d="M86,178 L222,99 L358,178 L222,256 L86,178 Z" fill="#F1F6E2" />
        <path
          d="M222,256 L358,178 L358,334 L222,413 L222,256 Z"
          fill="#CEDBE6"
        />
        <path d="M86,178 L222,256 L222,413 L86,334 L86,178 Z" fill="#FFFFFF" />
      </g>
    </svg>
  );
};

const JBuilderIcon = () => {
  return (
    <svg viewBox="0 0 32 32">
      <path
        d="M2.5,24.186V7.91H6.809V9.824H4.8V22.271H6.809v1.915Z"
        fill="#735a00"
        stroke="#735a00"
      />
      <path
        d="M12.84,7.814h2.585v8.043a7.731,7.731,0,0,1-.287,2.394,3.645,3.645,0,0,1-1.34,1.819,4.334,4.334,0,0,1-2.585.67A3.908,3.908,0,0,1,8.34,19.686a4.233,4.233,0,0,1-1.053-3.064l2.394-.287a2.857,2.857,0,0,0,.287,1.532,1.3,1.3,0,0,0,1.245.67,1.654,1.654,0,0,0,1.245-.479,4.288,4.288,0,0,0,.383-2.011Z"
        fill="#735a00"
        stroke="#735a00"
      />
      <path
        d="M15.521,20.644V7.814h2.394v4.6A3.394,3.394,0,0,1,20.6,11.165a3.45,3.45,0,0,1,2.777,1.245,5.088,5.088,0,0,1,1.149,3.543,5.349,5.349,0,0,1-1.149,3.638A3.45,3.45,0,0,1,20.6,20.835a2.81,2.81,0,0,1-1.532-.383,5.039,5.039,0,0,1-1.34-1.149v1.34Zm2.394-4.883a4.024,4.024,0,0,0,.479,2.106,1.823,1.823,0,0,0,1.723.957,1.553,1.553,0,0,0,1.34-.67,3.373,3.373,0,0,0,.574-2.2,3.681,3.681,0,0,0-.574-2.3,1.874,1.874,0,0,0-2.872,0A3.453,3.453,0,0,0,17.915,15.761Z"
        fill="#735a00"
        stroke="#735a00"
      />
      <path
        d="M29.5,7.814V24.09H25.191V22.176H27.2V9.729H25.191V7.814Z"
        fill="#735a00"
        stroke="#735a00"
      />
    </svg>
  );
};

const MongoDBIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#439934"
        d="M88.038 42.812c1.605 4.643 2.761 9.383 3.141 14.296.472 6.095.256 12.147-1.029 18.142-.035.165-.109.32-.164.48-.403.001-.814-.049-1.208.012-3.329.523-6.655 1.065-9.981 1.604-3.438.557-6.881 1.092-10.313 1.687-1.216.21-2.721-.041-3.212 1.641-.014.046-.154.054-.235.08l.166-10.051-.169-24.252 1.602-.275c2.62-.429 5.24-.864 7.862-1.281 3.129-.497 6.261-.98 9.392-1.465 1.381-.215 2.764-.412 4.148-.618z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#45A538"
        d="M61.729 110.054c-1.69-1.453-3.439-2.842-5.059-4.37-8.717-8.222-15.093-17.899-18.233-29.566-.865-3.211-1.442-6.474-1.627-9.792-.13-2.322-.318-4.665-.154-6.975.437-6.144 1.325-12.229 3.127-18.147l.099-.138c.175.233.427.439.516.702 1.759 5.18 3.505 10.364 5.242 15.551 5.458 16.3 10.909 32.604 16.376 48.9.107.318.384.579.583.866l-.87 2.969z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#46A037"
        d="M88.038 42.812c-1.384.206-2.768.403-4.149.616-3.131.485-6.263.968-9.392 1.465-2.622.417-5.242.852-7.862 1.281l-1.602.275-.012-1.045c-.053-.859-.144-1.717-.154-2.576-.069-5.478-.112-10.956-.18-16.434-.042-3.429-.105-6.857-.175-10.285-.043-2.13-.089-4.261-.185-6.388-.052-1.143-.236-2.28-.311-3.423-.042-.657.016-1.319.029-1.979.817 1.583 1.616 3.178 2.456 4.749 1.327 2.484 3.441 4.314 5.344 6.311 7.523 7.892 12.864 17.068 16.193 27.433z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#409433"
        d="M65.036 80.753c.081-.026.222-.034.235-.08.491-1.682 1.996-1.431 3.212-1.641 3.432-.594 6.875-1.13 10.313-1.687 3.326-.539 6.652-1.081 9.981-1.604.394-.062.805-.011 1.208-.012-.622 2.22-1.112 4.488-1.901 6.647-.896 2.449-1.98 4.839-3.131 7.182a49.142 49.142 0 01-6.353 9.763c-1.919 2.308-4.058 4.441-6.202 6.548-1.185 1.165-2.582 2.114-3.882 3.161l-.337-.23-1.214-1.038-1.256-2.753a41.402 41.402 0 01-1.394-9.838l.023-.561.171-2.426c.057-.828.133-1.655.168-2.485.129-2.982.241-5.964.359-8.946z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4FAA41"
        d="M65.036 80.753c-.118 2.982-.23 5.964-.357 8.947-.035.83-.111 1.657-.168 2.485l-.765.289c-1.699-5.002-3.399-9.951-5.062-14.913-2.75-8.209-5.467-16.431-8.213-24.642a4498.887 4498.887 0 00-6.7-19.867c-.105-.31-.407-.552-.617-.826l4.896-9.002c.168.292.39.565.496.879a6167.476 6167.476 0 016.768 20.118c2.916 8.73 5.814 17.467 8.728 26.198.116.349.308.671.491 1.062l.67-.78-.167 10.052z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4AA73C"
        d="M43.155 32.227c.21.274.511.516.617.826a4498.887 4498.887 0 016.7 19.867c2.746 8.211 5.463 16.433 8.213 24.642 1.662 4.961 3.362 9.911 5.062 14.913l.765-.289-.171 2.426-.155.559c-.266 2.656-.49 5.318-.814 7.968-.163 1.328-.509 2.632-.772 3.947-.198-.287-.476-.548-.583-.866-5.467-16.297-10.918-32.6-16.376-48.9a3888.972 3888.972 0 00-5.242-15.551c-.089-.263-.34-.469-.516-.702l3.272-8.84z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#57AE47"
        d="M65.202 70.702l-.67.78c-.183-.391-.375-.714-.491-1.062-2.913-8.731-5.812-17.468-8.728-26.198a6167.476 6167.476 0 00-6.768-20.118c-.105-.314-.327-.588-.496-.879l6.055-7.965c.191.255.463.482.562.769 1.681 4.921 3.347 9.848 5.003 14.778 1.547 4.604 3.071 9.215 4.636 13.813.105.308.47.526.714.786l.012 1.045c.058 8.082.115 16.167.171 24.251z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#60B24F"
        d="M65.021 45.404c-.244-.26-.609-.478-.714-.786-1.565-4.598-3.089-9.209-4.636-13.813-1.656-4.93-3.322-9.856-5.003-14.778-.099-.287-.371-.514-.562-.769 1.969-1.928 3.877-3.925 5.925-5.764 1.821-1.634 3.285-3.386 3.352-5.968.003-.107.059-.214.145-.514l.519 1.306c-.013.661-.072 1.322-.029 1.979.075 1.143.259 2.28.311 3.423.096 2.127.142 4.258.185 6.388.069 3.428.132 6.856.175 10.285.067 5.478.111 10.956.18 16.434.008.861.098 1.718.152 2.577z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#A9AA88"
        d="M62.598 107.085c.263-1.315.609-2.62.772-3.947.325-2.649.548-5.312.814-7.968l.066-.01.066.011a41.402 41.402 0 001.394 9.838c-.176.232-.425.439-.518.701-.727 2.05-1.412 4.116-2.143 6.166-.1.28-.378.498-.574.744l-.747-2.566.87-2.969z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B6B598"
        d="M62.476 112.621c.196-.246.475-.464.574-.744.731-2.05 1.417-4.115 2.143-6.166.093-.262.341-.469.518-.701l1.255 2.754c-.248.352-.59.669-.728 1.061l-2.404 7.059c-.099.283-.437.483-.663.722l-.695-3.985z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#C2C1A7"
        d="M63.171 116.605c.227-.238.564-.439.663-.722l2.404-7.059c.137-.391.48-.709.728-1.061l1.215 1.037c-.587.58-.913 1.25-.717 2.097l-.369 1.208c-.168.207-.411.387-.494.624-.839 2.403-1.64 4.819-2.485 7.222-.107.305-.404.544-.614.812-.109-1.387-.22-2.771-.331-4.158z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#CECDB7"
        d="M63.503 120.763c.209-.269.506-.508.614-.812.845-2.402 1.646-4.818 2.485-7.222.083-.236.325-.417.494-.624l-.509 5.545c-.136.157-.333.294-.398.477-.575 1.614-1.117 3.24-1.694 4.854-.119.333-.347.627-.525.938-.158-.207-.441-.407-.454-.623-.051-.841-.016-1.688-.013-2.533z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#DBDAC7"
        d="M63.969 123.919c.178-.312.406-.606.525-.938.578-1.613 1.119-3.239 1.694-4.854.065-.183.263-.319.398-.477l.012 3.64-1.218 3.124-1.411-.495z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#EBE9DC"
        d="M65.38 124.415l1.218-3.124.251 3.696-1.469-.572z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#CECDB7"
        d="M67.464 110.898c-.196-.847.129-1.518.717-2.097l.337.23-1.054 1.867z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4FAA41"
        d="M64.316 95.172l-.066-.011-.066.01.155-.559-.023.56z"
      ></path>
    </svg>
  );
};

const MariaDBIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#003545"
        d="M127.403 22.767a1.824 1.824 0 0 0-1.24-.414c-1.236 0-2.833.838-3.693 1.287l-.34.175a11.721 11.721 0 0 1-4.612 1.16 64.756 64.756 0 0 0-4.896.34c-10.91 1.121-15.777 9.484-20.464 17.57-2.552 4.399-5.188 8.969-8.802 12.46-.747.724-1.541 1.4-2.378 2.02-3.74 2.78-8.435 4.765-12.088 6.17-3.518 1.345-7.359 2.553-11.066 3.722-3.4 1.07-6.609 2.082-9.56 3.178-1.144.422-2.299.823-3.459 1.205-2.688.872-4.626 1.54-7.458 3.49a47.949 47.949 0 0 0-2.963 2.183 31.255 31.255 0 0 0-5.913 6.227 36.767 36.767 0 0 1-4.966 5.961c-.598.584-1.659.872-3.248.872-1.86 0-4.115-.384-6.501-.79-2.462-.435-5.006-.85-7.188-.85-1.771 0-3.13.29-4.141.873 0 0-1.708.995-2.427 2.282l.707.32a14.493 14.493 0 0 1 3.02 2.181 15.153 15.153 0 0 0 3.141 2.234c.365.134.695.344.97.616-.296.436-.734.999-1.193 1.6-2.517 3.296-3.987 5.377-3.145 6.511.404.21.855.312 1.31.297 5.49 0 8.44-1.426 12.17-3.233 1.082-.522 2.182-1.06 3.491-1.615 2.182-.946 4.531-2.456 7.022-4.054 3.26-2.124 6.668-4.306 9.976-5.358a27.188 27.188 0 0 1 8.391-1.179c3.492 0 7.167.466 10.71.92 2.641.342 5.377.69 8.06.852a50.27 50.27 0 0 0 2.946.092 34.127 34.127 0 0 0 3.757-.196l.3-.105c1.883-1.158 2.765-3.64 3.618-6.04.551-1.546 1.014-2.933 1.747-3.814.043-.043.09-.082.14-.117a.175.175 0 0 1 .213.034v.07c-.435 9.387-4.215 15.348-8.038 20.646l-2.552 2.736s3.573 0 5.607-.786c7.42-2.217 13.018-7.104 17.093-14.899a63.583 63.583 0 0 0 2.693-6.15c.07-.172.712-.496.65.407-.021.267-.04.563-.061.874 0 .182 0 .37-.035.558-.104 1.31-.414 4.076-.414 4.076l2.29-1.227c5.525-3.49 9.784-10.533 13.015-21.491 1.344-4.566 2.33-9.1 3.197-13.093 1.039-4.801 1.935-8.915 2.96-10.512 1.61-2.506 4.067-4.2 6.445-5.844.323-.222.65-.437.97-.673 2.988-2.098 5.96-4.52 6.616-9.037v-.1c.474-3.37.073-4.228-.384-4.621z"
      ></path>
    </svg>
  );
};

const RedHatIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#fff"
        d="M116.4 97.9c-2.4-.5-5-.9-7.5-.9-4.4 0-8.4.8-11.4 2-.3.2-.6.5-.6.9 0 .1 0 .3.1.4.3 1-.2 2.1-3.1 2.7-4.3.9-6.9 5.3-8.5 6.8-1.8 1.7-6.9 2.8-6.1 1.7.6-.8 2.9-3.3 4.3-6 1.3-2.4 2.4-3.1 3.9-5.4.5-.7 2.2-3 2.7-4.9.6-1.8.4-4.1.6-5.1.3-1.4 1.6-4.3 1.7-6 .1-.9-3.9 1.4-5.8 1.4s-3.7-1.1-5.4-1.2c-2.1-.1-3.4 1.6-5.3 1.3-1.1-.2-2-1.1-3.9-1.2-2.7-.1-6 1.5-12.2 1.3-6.1-.2-11.7-7.7-12.5-8.9-.9-1.4-2-1.4-3.2-.3-1.2 1.1-2.7.2-3.1-.5-.8-1.4-2.9-5.5-6.2-6.3-4.6-1.2-6.9 2.5-6.6 5.5.3 3 2.2 3.8 3.1 5.4.9 1.6 1.4 2.6 3 3.3 1.2.5 1.6 1.2 1.3 2.2-.3.9-1.6 1.1-2.4 1.1-1.7.1-3-.4-3.8-1-1-.7-1.9-1.6-2.8-3.1-1-1.7-2.7-2.5-4.6-2.5-.9 0-1.8.2-2.5.6-3 1.6-6.6 2.5-10.4 2.5H4.9c8.3 24.7 31.7 42.4 59.2 42.4 21.9.3 41.2-11 52.3-28.2"
      ></path>
      <path d="M116.4 97.9c-2.4-.6-5-.9-7.5-.9-4.4 0-8.4.8-11.4 2-.3.2-.6.5-.6.9 0 .1 0 .3.1.4.3 1-.2 2.1-3.1 2.8-4.3.9-6.9 5.3-8.5 6.8-1.8 1.7-6.9 2.8-6.1 1.7.6-.8 2.9-3.3 4.3-6 1.3-2.4 2.4-3.1 3.9-5.4.5-.7 2.2-3 2.7-4.9.6-1.8.4-4.1.6-5.1.3-1.4 1.6-4.3 1.7-6 .1-.9-3.9 1.3-5.8 1.3s-3.7-1.1-5.4-1.2c-2.1-.1-3.4 1.6-5.3 1.3-1.1-.2-2-1.1-3.9-1.2-2.7-.1-6 1.5-12.2 1.3-6.1-.2-11.7-7.7-12.5-8.9-.9-1.4-2-1.4-3.2-.3-1.2 1.1-2.7.2-3.1-.5-.8-1.4-2.9-5.5-6.2-6.3-4.6-1.2-6.9 2.5-6.6 5.5.3 3 2.2 3.8 3.1 5.4.9 1.6 1.4 2.6 3 3.3 1.2.5 1.6 1.2 1.3 2.2-.3.9-1.6 1.1-2.4 1.1-1.7.1-3-.4-3.8-1-1-.7-1.9-1.6-2.8-3.1-1-1.7-2.7-2.5-4.6-2.5-.9 0-1.8.2-2.5.6-3 1.6-6.6 2.5-10.4 2.5H4.8C2.7 77.7 1.6 71 1.6 64 1.6 29.5 29.5 1.6 64 1.6s62.4 27.9 62.4 62.4c0 12.5-3.7 24.1-10 33.9m-38.7-5.7c.3.3.9 1.4.2 2.7-.4.7-.8 1.2-1.5 1.8-.9.7-2.6 1.5-4.9 0-1.3-.8-1.3-1.1-3.1-.8-1.2.2-1.7-1.1-1.3-2.1.5-1 2.3-1.9 4.6-.5 1 .6 2.6 1.9 4 .7.6-.5.9-.8 1.7-1.7l.1-.1c.2-.1.2 0 .2 0"></path>
      <path
        fill="#E93442"
        d="M59.1 31.3c-7.2.5-8 1.3-9.3 2.7-1.9 2-4.4-2.6-4.4-2.6-1.5-.3-3.3-2.7-2.3-5 1-2.2 2.8-1.6 3.3-.9.7.8 2.1 2.2 4 2.2 1.9-.1 4.1-.4 7.1-.4 3.1 0 5.2 1.1 5.3 2.1.1.9-.2 1.7-3.7 1.9m7.6-11.9c-.1 0-.2-.1-.2-.2s0-.1.1-.2c1.4-.7 3.5-1.3 5.9-1.6.7-.1 1.4-.1 2.1-.1h.4c4 .1 7.2 1.7 7.2 3.6-.1 1.9-3.3 3.3-7.3 3.2-1.3 0-2.5-.2-3.6-.5-.1 0-.2-.1-.2-.3 0-.1.1-.2.2-.3 2.5-.6 4.2-1.5 4.1-2.4-.2-1.2-3.4-1.8-7.3-1.4-.6.1-1 .2-1.4.2m32.5 28c-.6 2.1-1.5 4.7-5.4 6.7-.6.3-.8-.2-.5-.6 1.5-2.5 1.7-3.1 2.2-4.1.6-1.4.9-3.5-.3-7.8-2.3-8.4-7.2-19.7-10.8-23.4-3.4-3.5-9.7-4.5-15.3-3.1-2.1.5-6.1 2.6-13.6.9-13-2.9-14.9 3.6-15.7 6.4-.8 2.8-2.5 10.9-2.5 10.9-.6 3.3-1.4 9 18.8 12.8 9.4 1.8 9.9 4.2 10.3 6 .7 3.1 1.9 4.9 3.3 5.8 1.3.9 0 1.6-1.5 1.8-4 .4-18.8-3.8-27.6-8.8-7.2-4.4-7.3-8.3-5.6-11.7-10.8-1.2-19 1-20.4 6.1-2.6 9 19.2 24 44.1 31.5 26.1 7.9 53 2.4 56-14 1.4-7.5-4.9-13-15.5-15.4"
      ></path>
    </svg>
  );
};

const AnsibleIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#1A1918"
        d="M126 64c0 34.2-27.8 62-62 62S2 98.2 2 64 29.8 2 64 2s62 27.8 62 62"
      ></path>
      <path
        fill="#FFF"
        d="M65 39.9l16 39.6-24.1-19.1L65 39.9zm28.5 48.7L68.9 29.2c-.7-1.7-2.1-2.6-3.8-2.6-1.7 0-3.2.9-3.9 2.6L34 94.3h9.3L54 67.5l32 25.9c1.3 1 2.2 1.5 3.4 1.5 2.4 0 4.5-1.8 4.5-4.4.1-.5-.1-1.2-.4-1.9z"
      ></path>
    </svg>
  );
};

const VaultIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#ffd814"
        d="m0 1.953 63.76 124.094L128 1.953Zm53.841 49.254H43.684V41.06H53.84zm0-15.227H43.684V25.822H53.84ZM69.08 66.444H58.97V56.286h10.108zm0-15.237H58.97V41.06h10.108zm0-15.227H58.97V25.822h10.108Zm15.147 15.227H74.027V41.06h10.159ZM74.027 35.98V25.822h10.159V35.98z"
      ></path>
    </svg>
  );
};

const OracleIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#EA1B22"
        d="M55.387 66.469h8.333l-4.407-7.09-8.088 12.819h-3.681L57.382 56.8a2.324 2.324 0 011.931-.998c.765 0 1.478.363 1.892.972l9.876 15.424H67.4l-1.736-2.865h-8.438l-1.839-2.864zm38.235 2.864V55.958h-3.123v14.685c0 .402.156.791.454 1.089.298.298.7.466 1.141.466h14.244l1.841-2.865H93.622zm-51.677-2.397c3.033 0 5.496-2.449 5.496-5.482s-2.462-5.496-5.496-5.496H28.28v16.241h3.123V58.822h10.335c1.452 0 2.618 1.18 2.618 2.631s-1.167 2.631-2.618 2.631l-8.806-.013 9.324 8.127h4.538l-6.274-5.263h1.425zM9.059 72.198c-4.483 0-8.122-3.629-8.122-8.114s3.638-8.127 8.122-8.127h9.439c4.485 0 8.121 3.643 8.121 8.127s-3.636 8.114-8.121 8.114H9.059zm9.229-2.865a5.25 5.25 0 005.258-5.249 5.262 5.262 0 00-5.258-5.263H9.267a5.262 5.262 0 00-5.256 5.263 5.25 5.25 0 005.256 5.249h9.021zm59.314 2.865c-4.484 0-8.126-3.629-8.126-8.114s3.642-8.127 8.126-8.127h11.212l-1.829 2.864H77.81a5.267 5.267 0 00-5.264 5.263c0 2.903 2.36 5.249 5.264 5.249h11.263l-1.84 2.865h-9.631zm38.197-2.865a5.25 5.25 0 01-5.055-3.824h13.35l1.84-2.864h-15.19a5.266 5.266 0 015.055-3.824h9.163l1.854-2.864h-11.225c-4.484 0-8.126 3.643-8.126 8.127s3.642 8.114 8.126 8.114h9.631l1.841-2.865h-11.264"
      ></path>
    </svg>
  );
};

const SassIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#CB6699"
        d="M1.219 56.156c0 .703.207 1.167.323 1.618.756 2.933 2.381 5.45 4.309 7.746 2.746 3.272 6.109 5.906 9.554 8.383 2.988 2.148 6.037 4.248 9.037 6.38.515.366 1.002.787 1.561 1.236-.481.26-.881.489-1.297.7-3.959 2.008-7.768 4.259-11.279 6.986-2.116 1.644-4.162 3.391-5.607 5.674-2.325 3.672-3.148 7.584-1.415 11.761.506 1.22 1.278 2.274 2.367 3.053.353.252.749.502 1.162.6 1.058.249 2.136.412 3.207.609l3.033-.002c3.354-.299 6.407-1.448 9.166-3.352 4.312-2.976 7.217-6.966 8.466-12.087.908-3.722.945-7.448-.125-11.153a11.696 11.696 0 00-.354-1.014c-.13-.333-.283-.657-.463-1.072l6.876-3.954.103.088c-.125.409-.258.817-.371 1.23-.817 2.984-1.36 6.02-1.165 9.117.208 3.3 1.129 6.389 3.061 9.146 1.562 2.23 5.284 2.313 6.944.075.589-.795 1.16-1.626 1.589-2.513 1.121-2.315 2.159-4.671 3.23-7.011l.187-.428c-.077 1.108-.167 2.081-.208 3.055-.064 1.521.025 3.033.545 4.48.445 1.238 1.202 2.163 2.62 2.326.97.111 1.743-.333 2.456-.896a10.384 10.384 0 002.691-3.199c1.901-3.491 3.853-6.961 5.576-10.54 1.864-3.871 3.494-7.855 5.225-11.792l.286-.698c.409 1.607.694 3.181 1.219 4.671.61 1.729 1.365 3.417 2.187 5.058.389.775.344 1.278-.195 1.928-2.256 2.72-4.473 5.473-6.692 8.223-.491.607-.98 1.225-1.389 1.888a3.701 3.701 0 00-.48 1.364 1.737 1.737 0 001.383 1.971 9.661 9.661 0 002.708.193c3.097-.228 5.909-1.315 8.395-3.157 3.221-2.386 4.255-5.642 3.475-9.501-.211-1.047-.584-2.065-.947-3.074-.163-.455-.174-.774.123-1.198 2.575-3.677 4.775-7.578 6.821-11.569.081-.157.164-.314.306-.482.663 3.45 1.661 6.775 3.449 9.792-.912.879-1.815 1.676-2.632 2.554-1.799 1.934-3.359 4.034-4.173 6.595-.35 1.104-.619 2.226-.463 3.405.242 1.831 1.742 3.021 3.543 2.604 3.854-.892 7.181-2.708 9.612-5.925 1.636-2.166 1.785-4.582 1.1-7.113-.188-.688-.411-1.365-.651-2.154.951-.295 1.878-.649 2.837-.868 4.979-1.136 9.904-.938 14.702.86 2.801 1.05 5.064 2.807 6.406 5.571 1.639 3.379.733 6.585-2.452 8.721-.297.199-.637.356-.883.605a.869.869 0 00-.205.67c.021.123.346.277.533.275 1.047-.008 1.896-.557 2.711-1.121 2.042-1.413 3.532-3.314 3.853-5.817l.063-.188-.077-1.63c-.031-.094.023-.187.016-.258-.434-3.645-2.381-6.472-5.213-8.688-3.28-2.565-7.153-3.621-11.249-3.788a25.401 25.401 0 00-9.765 1.503c-.897.325-1.786.71-2.688 1.073-.121-.219-.251-.429-.358-.646-.926-1.896-2.048-3.708-2.296-5.882-.176-1.544-.392-3.086-.025-4.613.353-1.469.813-2.913 1.246-4.362.223-.746.066-1.164-.646-1.5a2.854 2.854 0 00-.786-.258c-1.75-.254-3.476-.109-5.171.384-.6.175-1.036.511-1.169 1.175-.076.381-.231.746-.339 1.122-.443 1.563-.757 3.156-1.473 4.645-1.794 3.735-3.842 7.329-5.938 10.897-.227.385-.466.763-.752 1.23-.736-1.54-1.521-2.922-1.759-4.542-.269-1.832-.481-3.661-.025-5.479.339-1.356.782-2.687 1.19-4.025.193-.636.104-.97-.472-1.305-.291-.169-.62-.319-.948-.368a11.643 11.643 0 00-5.354.438c-.543.176-.828.527-.994 1.087-.488 1.652-.904 3.344-1.589 4.915-2.774 6.36-5.628 12.687-8.479 19.013-.595 1.321-1.292 2.596-1.963 3.882-.17.326-.418.613-.63.919-.17-.201-.236-.339-.235-.477.005-.813-.092-1.65.063-2.436a172.189 172.189 0 011.578-7.099c.47-1.946 1.017-3.874 1.538-5.807.175-.647.178-1.252-.287-1.796-.781-.911-2.413-1.111-3.381-.409l-.428.242.083-.69c.204-1.479.245-2.953-.161-4.41-.506-1.816-1.802-2.861-3.686-2.803-.878.027-1.8.177-2.613.497-3.419 1.34-6.048 3.713-8.286 6.568a2.592 2.592 0 01-.757.654c-2.893 1.604-5.795 3.188-8.696 4.778l-3.229 1.769c-.866-.826-1.653-1.683-2.546-2.41-2.727-2.224-5.498-4.393-8.244-6.592-2.434-1.949-4.792-3.979-6.596-6.56-1.342-1.92-2.207-4.021-2.29-6.395-.105-3.025.753-5.789 2.293-8.362 1.97-3.292 4.657-5.934 7.611-8.327 3.125-2.53 6.505-4.678 10.008-6.639 4.901-2.743 9.942-5.171 15.347-6.774 5.542-1.644 11.165-2.585 16.965-1.929 2.28.258 4.494.78 6.527 1.895 1.557.853 2.834 1.97 3.428 3.716.586 1.718.568 3.459.162 5.204-.825 3.534-2.76 6.447-5.195 9.05-3.994 4.267-8.866 7.172-14.351 9.091a39.478 39.478 0 01-9.765 2.083c-2.729.229-5.401-.013-7.985-.962-1.711-.629-3.201-1.591-4.399-2.987-.214-.25-.488-.521-.887-.287-.391.23-.46.602-.329.979.219.626.421 1.278.762 1.838.857 1.405 2.107 2.424 3.483 3.298 2.643 1.681 5.597 2.246 8.66 2.377 4.648.201 9.183-.493 13.654-1.74 6.383-1.78 11.933-4.924 16.384-9.884 3.706-4.13 6.353-8.791 6.92-14.419.277-2.747-.018-5.438-1.304-7.944-1.395-2.715-3.613-4.734-6.265-6.125C68.756 18.179 64.588 17 60.286 17h-4.31c-5.21 0-10.247 1.493-15.143 3.274-3.706 1.349-7.34 2.941-10.868 4.703-7.683 3.839-14.838 8.468-20.715 14.833-2.928 3.171-5.407 6.67-6.833 10.79a40.494 40.494 0 00-1.111 3.746m27.839 36.013c-.333 4.459-2.354 8.074-5.657 11.002-1.858 1.646-3.989 2.818-6.471 3.23-.9.149-1.821.185-2.694-.188-1.245-.532-1.524-1.637-1.548-2.814-.037-1.876.62-3.572 1.521-5.186 1.176-2.104 2.9-3.708 4.741-5.206 2.9-2.361 6.046-4.359 9.268-6.245l.243-.1c.498 1.84.735 3.657.597 5.507zM54.303 70.98c-.235 1.424-.529 2.849-.945 4.229-1.438 4.777-3.285 9.406-5.282 13.973-.369.845-.906 1.616-1.373 2.417a1.689 1.689 0 01-.283.334c-.578.571-1.126.541-1.418-.206-.34-.868-.549-1.797-.729-2.716-.121-.617-.092-1.265-.13-1.897.039-4.494 1.41-8.578 3.736-12.38.959-1.568 2.003-3.062 3.598-4.054a6.27 6.27 0 011.595-.706c.85-.239 1.372.154 1.231 1.006zm17.164 21.868l6.169-7.203c.257 2.675-4.29 8.015-6.169 7.203zm19.703-4.847c-.436.25-.911.43-1.358.661-.409.212-.544-.002-.556-.354a2.385 2.385 0 01.093-.721c.833-2.938 2.366-5.446 4.647-7.486l.16-.082c1.085 3.035-.169 6.368-2.986 7.982z"
      ></path>
    </svg>
  );
};

const SvelteIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M 110.43093,16.935847 C 98.552474,-0.076153 75.089104,-5.118154 58.130818,5.695846 l -29.793,19.000001 c -4.030441,2.529 -7.488786,5.871 -10.15468,9.814 -2.665895,3.943 -4.479469,8.399 -5.325138,13.083 a 25.478172,30.64 0 0 0 -0.572094,6.396 c 0.0183,5.831 1.446866,11.571 4.163485,16.729995 -2.546986,3.87201 -4.285721,8.22 -5.110602,12.78201 a 25.347621,30.483 0 0 0 0.345086,14.41199 c 1.072679,4.732998 3.078336,9.203998 5.900559,13.151998 11.877618,17.011 35.393374,22.053 52.299272,11.24 l 29.762238,-19.001 c 4.027946,-2.532 7.482126,-5.877998 10.141386,-9.824998 2.65841,-3.947 4.46282,-8.40699 5.29686,-13.093 0.3825,-2.107 0.57458,-4.244 0.5721,-6.386 -0.007,-5.81999 -1.41778,-11.550995 -4.11194,-16.708995 2.54616,-3.869 4.28489,-8.213 5.11143,-12.771 0.36921,-2.109 0.55713,-4.245 0.56212,-6.386 0.002,-7.595 -2.37152,-15 -6.78697,-21.178 z"
        fill="#ff3e00"
        id="path598"
        strokeWidth="0.911885"
      ></path>
      <path
        d="m 55.218941,112.66204 a 28.463375,34.23 0 0 1 -5.953776,0.76 c -3.820895,0.001 -7.585244,-0.925 -10.970416,-2.7 -3.384341,-1.774 -6.288887,-4.343 -8.464177,-7.487 -2.655917,-3.716 -4.082827,-8.171 -4.080332,-12.74 a 15.657767,18.83 0 0 1 0.332613,-3.833 15.424937,18.55 0 0 1 0.719276,-2.782 l 0.562116,-1.708 1.51921,1.156 c 3.528195,2.591 7.470493,4.564 11.658097,5.834 l 1.104275,0.333 -0.103941,1.104 v 0.573 c -0.0025,1.381 0.427408,2.73 1.228174,3.854 0.646933,0.958 1.51838,1.744 2.537839,2.288 a 8.2621121,9.936 0 0 0 3.311997,0.837 8.2513022,9.923 0 0 0 1.79029,-0.229 7.2717563,8.745 0 0 0 1.832699,-0.802 l 29.760566,-19.094 c 0.892236,-0.566 1.627311,-1.349 2.135377,-2.276 0.507236,-0.927 0.771662,-1.968 0.768337,-3.026 -0.0084,-1.381 -0.449027,-2.725 -1.259773,-3.844 -0.656912,-0.946 -1.533347,-1.718 -2.553637,-2.252 a 8.3128357,9.997 0 0 0 -3.307008,-0.81 8.246313,9.917 0 0 0 -1.79029,0.23 6.9383115,8.344 0 0 0 -1.821058,0.801 l -11.346268,7.25 a 24.375558,29.314 0 0 1 -6.04774,2.656 c -1.945787,0.502 -3.945624,0.758 -5.954608,0.76 -3.820063,0 -7.582749,-0.926 -10.967089,-2.698 -3.384341,-1.772 -6.289718,-4.338 -8.467502,-7.478 -2.652591,-3.718 -4.079502,-8.172 -4.080334,-12.74 0.0016,-1.285 0.113089,-2.567 0.332615,-3.833 0.509728,-2.816 1.597374,-5.495 3.196411,-7.867 1.598207,-2.373 3.67205,-4.387 6.089317,-5.914 l 29.792168,-18.99 c 1.869286,-1.19 3.908205,-2.09 6.04774,-2.667 1.945787,-0.499 3.945625,-0.75 5.953776,-0.75 3.82921,-0.01 7.603538,0.91 10.999519,2.681 3.395981,1.77 6.311338,4.34 8.497439,7.486 2.636787,3.727 4.045417,8.184 4.028777,12.75 a 15.748404,18.939 0 0 1 -0.33344,3.844 15.407475,18.529 0 0 1 -0.71845,2.781 l -0.56211,1.708 -1.519216,-1.114 c -3.525699,-2.595 -7.468833,-4.568 -11.658096,-5.834 l -1.104275,-0.343 0.103941,-1.105 v -0.572 c 0,-1.385 -0.429072,-2.735 -1.228174,-3.865 -0.65608,-0.945 -1.530022,-1.716 -2.549481,-2.25 a 8.3086779,9.992 0 0 0 -3.301186,-0.813 8.2213671,9.887 0 0 0 -1.768671,0.271 6.8185708,8.2 0 0 0 -1.831867,0.802 l -29.792165,18.99 a 5.8797701,7.071 0 0 0 -1.836857,1.79 4.7505482,5.713 0 0 0 -0.962914,2.377 5.0365955,6.057 0 0 0 -0.135541,1.104 c -8.31e-4,1.378 0.42824,2.722 1.228174,3.844 0.655248,0.945 1.530021,1.717 2.548649,2.25 a 8.2986996,9.98 0 0 0 3.301186,0.812 8.2471446,9.918 0 0 0 1.79029,-0.23 6.9433007,8.35 0 0 0 1.832699,-0.801 l 11.367057,-7.292 a 24.218399,29.125 0 0 1 6.04774,-2.656 28.52574,34.305 0 0 1 5.953776,-0.76 c 3.821727,0 7.586076,0.925 10.972078,2.697 3.386003,1.772 6.293877,4.339 8.473325,7.48 2.652591,3.717 4.079498,8.171 4.080338,12.74 0.003,1.299 -0.11226,2.596 -0.34343,3.874 -0.506403,2.817 -1.594046,5.497 -3.192254,7.87 -1.599037,2.372 -3.673715,4.385 -6.093476,5.911 l -29.739779,18.99 a 24.308205,29.233 0 0 1 -6.057719,2.667 z"
        fill="#ffffff"
        id="path600"
        strokeWidth="0.911885"
      ></path>
    </svg>
  );
};

const TailwindIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M64.004 25.602c-17.067 0-27.73 8.53-32 25.597 6.398-8.531 13.867-11.73 22.398-9.597 4.871 1.214 8.352 4.746 12.207 8.66C72.883 56.629 80.145 64 96.004 64c17.066 0 27.73-8.531 32-25.602-6.399 8.536-13.867 11.735-22.399 9.602-4.87-1.215-8.347-4.746-12.207-8.66-6.27-6.367-13.53-13.738-29.394-13.738zM32.004 64c-17.066 0-27.73 8.531-32 25.602C6.402 81.066 13.87 77.867 22.402 80c4.871 1.215 8.352 4.746 12.207 8.66 6.274 6.367 13.536 13.738 29.395 13.738 17.066 0 27.73-8.53 32-25.597-6.399 8.531-13.867 11.73-22.399 9.597-4.87-1.214-8.347-4.746-12.207-8.66C55.128 71.371 47.868 64 32.004 64zm0 0"
        fill="#38bdf8"
      ></path>
    </svg>
  );
};

const SplunkIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M41.172 47.891v25.477h4.594V47.891h-4.594m47.063 0v25.477h4.621V64.18c.703.813 1.285 1.766 1.914 2.633l3.156 4.379 1.324 1.84c.121.164.32.594.527.648.109.027.266-.055.367-.09l.824-.293 3.063-1.062-1.457-1.836-2.934-3.645-1.695-2.113-.895-1.07v-.031c.547-.418 1.016-1.051 1.477-1.562l2.629-2.816 1.262-1.348c.176-.199.402-.367.512-.613-.852-.242-1.695-.715-2.512-1.066-.203-.086-.727-.43-.945-.359-.152.051-.297.297-.398.418l-.926 1.07-3.488 4.043-.949 1.102c-.117.133-.258.371-.43.441-.121.047-.293.016-.426.016V47.891h-4.621m20.879 3.813a1.56 1.56 0 0 0-.641.242c-1.309.883-.531 3.105 1.07 2.852.242-.035.473-.113.676-.254 1.301-.898.492-3.09-1.105-2.84m.031.238c1.641-.234 1.988 2.406.367 2.617-1.605.211-1.953-2.387-.367-2.617m-.367 2.195h.277v-.734c.168 0 .352-.012.469.129.227.277.016.605.48.605-.059-.273-.059-.719-.367-.824.094-.062.188-.121.254-.215.391-.578-.687-.973-1.062-.672-.094.074-.051.32-.051.426v1.285m.277-.949c0-.137-.059-.445.031-.559.258-.316.965.422.305.551-.109.02-.227.008-.336.008M6.699 71.805c.996.66 1.918 1.328 3.09 1.648 2.969.813 7.176.34 8.703-2.719a4.38 4.38 0 0 0 .418-1.227c.105-.59.105-1.184.027-1.773-.336-2.473-3.035-3.949-4.832-5.34-.605-.469-1.332-.977-1.73-1.645-.68-1.141.266-2.285 1.426-2.488.809-.145 1.711.051 2.449.387.34.156.645.383.98.543.301-.547.66-1.062.984-1.594.082-.129.336-.418.305-.574-.035-.168-.445-.312-.586-.383-.629-.316-1.273-.582-1.957-.754-2.594-.652-6.059-.328-7.625 2.141a4.35 4.35 0 0 0-.555 1.316 4.85 4.85 0 0 0-.121 1.164c.031 2.602 2.473 4.039 4.32 5.422 1.148.863 2.578 1.797 2.348 3.426-.035.25-.129.492-.262.703-.961 1.547-3.148 1.102-4.445.336-.363-.215-.707-.465-1.039-.727-.09-.07-.27-.27-.395-.254-.152.023-.332.461-.41.586-.359.594-.801 1.176-1.094 1.805m18.859-13.289l-.031-2.508H21.09v26.055h4.438V71.07c.98.98 1.891 1.977 3.246 2.43.871.289 1.816.332 2.727.266a7.84 7.84 0 0 0 2.172-.461c4.152-1.523 5.895-6.207 5.457-10.316-.289-2.668-1.629-5.316-4.109-6.562-.684-.34-1.387-.594-2.145-.719a8.46 8.46 0 0 0-3.43.133c-1.66.43-2.727 1.492-3.887 2.676m47.578-.184h-.027V56.68l-.031-.625-.309-.047h-4.285v17.359h4.625v-7.992c0-1.477-.184-3.105.398-4.5.891-2.156 4.363-3.012 6.027-1.227 1.07 1.152.953 2.895.953 4.348v9.371h4.59v-9.461c0-1.922.117-4.031-.867-5.758-1.77-3.09-6.582-3.215-9.297-1.406-.586.391-1.445.953-1.777 1.59m-24.371-2.355v9.063c0 1.691-.187 3.617.402 5.234.266.738.648 1.473 1.223 2.02 1.832 1.75 5.047 1.898 7.316 1 1.203-.48 2.129-1.32 3.031-2.223v2.297h4.594V56.281l-.051-.273-.348-.031h-4.195v7.961c0 1.5.168 3.152-.453 4.563-.293.656-.77 1.238-1.383 1.617-1.391.859-3.684.809-4.746-.547-.832-1.062-.797-2.457-.797-3.734v-8.941c0-.172.094-.773-.051-.887-.078-.062-.25-.031-.348-.031h-4.195m59.215.215v2.266l.031.836.828.426 2.172 1.059 4.289 2.094 3.43 1.676-3.094 1.523-4.777 2.359-2.051 1.012-.797.414-.031.848v2.172c.375-.066.766-.34 1.105-.512l2.141-1.07 6.922-3.43 2.57-1.285c.313-.156.883-.316 1.113-.578.121-.137.051-.516.051-.687v-1.437c0-.203.047-.473-.012-.668-.062-.211-.656-.395-.848-.488l-2.539-1.27-7.133-3.582-2.238-1.133c-.363-.184-.742-.434-1.133-.543m-78.227 2.152c1.758-.211 3.199.953 3.91 2.469 1.027 2.188.914 5.23.02 7.441-.547 1.352-1.594 2.656-3.133 2.813-2.203.223-3.891-1.066-4.605-3.121-.27-.773-.383-1.602-.418-2.418-.105-2.43.301-5.695 2.816-6.848.453-.207.922-.281 1.41-.336zm0 0"
        fill="#0C1724"
      ></path>
    </svg>
  );
};

const TensorflowIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="m61.55 128-21.84-12.68V40.55L6.81 59.56l.08-28.32L61.55 0zM66.46 0v128l21.84-12.68V79.31l16.49 9.53-.1-24.63-16.39-9.36v-14.3l32.89 19.01-.08-28.32z"
        fill="#ff6f00"
      ></path>
    </svg>
  );
};

const PyTorchIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#EE4C2C"
        d="M100.1 38.3l-9.2 9.2c15.1 15.1 15.1 39.4 0 54.3-15.1 15.1-39.4 15.1-54.3 0-15.1-15.1-15.1-39.4 0-54.3l24-24 3.4-3.4V2L27.8 38.2C7.7 58.3 7.7 90.8 27.8 111s52.6 20.1 72.4 0c20.1-20.2 20.1-52.5-.1-72.7z"
      ></path>
      <circle
        fill="#EE4C2C"
        transform="rotate(-88.939 82.069 29.398) scale(.99997)"
        cx="82.1"
        cy="29.4"
        r="6.7"
      ></circle>
    </svg>
  );
};

const RedisIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#A41E11"
        d="M121.8 93.1c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1S13 98.1 6.3 94.9c-3.3-1.6-5-2.9-5-4.2V78s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9v12.5c0 1.3-1.5 2.7-4.9 4.4z"
      ></path>
      <path
        fill="#D82C20"
        d="M121.8 80.5C115.1 84 80.4 98.2 73 102.1c-7.4 3.9-11.5 3.8-17.3 1-5.8-2.8-42.7-17.7-49.4-20.9C-.3 79-.5 76.8 6 74.3c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.9z"
      ></path>
      <path
        fill="#A41E11"
        d="M121.8 72.5C115.1 76 80.4 90.2 73 94.1c-7.4 3.8-11.5 3.8-17.3 1C49.9 92.3 13 77.4 6.3 74.2c-3.3-1.6-5-2.9-5-4.2V57.3s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9V68c0 1.3-1.5 2.7-4.9 4.5z"
      ></path>
      <path
        fill="#D82C20"
        d="M121.8 59.8c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.8-11.5 3.8-17.3 1C49.9 79.6 13 64.7 6.3 61.5s-6.8-5.4-.3-7.9c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.9z"
      ></path>
      <path
        fill="#A41E11"
        d="M121.8 51c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.8-11.5 3.8-17.3 1C49.9 70.9 13 56 6.3 52.8c-3.3-1.6-5.1-2.9-5.1-4.2V35.9s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9v12.5c.1 1.3-1.4 2.6-4.8 4.4z"
      ></path>
      <path
        fill="#D82C20"
        d="M121.8 38.3C115.1 41.8 80.4 56 73 59.9c-7.4 3.8-11.5 3.8-17.3 1S13 43.3 6.3 40.1s-6.8-5.4-.3-7.9c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.8z"
      ></path>
      <path
        fill="#fff"
        d="M80.4 26.1l-10.8 1.2-2.5 5.8-3.9-6.5-12.5-1.1 9.3-3.4-2.8-5.2 8.8 3.4 8.2-2.7L72 23zM66.5 54.5l-20.3-8.4 29.1-4.4z"
      ></path>
      <ellipse fill="#fff" cx="38.4" cy="35.4" rx="15.5" ry="6"></ellipse>
      <path fill="#7A0C00" d="M93.3 27.7l17.2 6.8-17.2 6.8z"></path>
      <path fill="#AD2115" d="M74.3 35.3l19-7.6v13.6l-1.9.8z"></path>
    </svg>
  );
};

const SlackIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M27.255 80.719c0 7.33-5.978 13.317-13.309 13.317C6.616 94.036.63 88.049.63 80.719s5.987-13.317 13.317-13.317h13.309zm6.709 0c0-7.33 5.987-13.317 13.317-13.317s13.317 5.986 13.317 13.317v33.335c0 7.33-5.986 13.317-13.317 13.317-7.33 0-13.317-5.987-13.317-13.317zm0 0"
        fill="#de1c59"
      ></path>
      <path
        d="M47.281 27.255c-7.33 0-13.317-5.978-13.317-13.309C33.964 6.616 39.951.63 47.281.63s13.317 5.987 13.317 13.317v13.309zm0 6.709c7.33 0 13.317 5.987 13.317 13.317s-5.986 13.317-13.317 13.317H13.946C6.616 60.598.63 54.612.63 47.281c0-7.33 5.987-13.317 13.317-13.317zm0 0"
        fill="#35c5f0"
      ></path>
      <path
        d="M100.745 47.281c0-7.33 5.978-13.317 13.309-13.317 7.33 0 13.317 5.987 13.317 13.317s-5.987 13.317-13.317 13.317h-13.309zm-6.709 0c0 7.33-5.987 13.317-13.317 13.317s-13.317-5.986-13.317-13.317V13.946C67.402 6.616 73.388.63 80.719.63c7.33 0 13.317 5.987 13.317 13.317zm0 0"
        fill="#2eb57d"
      ></path>
      <path
        d="M80.719 100.745c7.33 0 13.317 5.978 13.317 13.309 0 7.33-5.987 13.317-13.317 13.317s-13.317-5.987-13.317-13.317v-13.309zm0-6.709c-7.33 0-13.317-5.987-13.317-13.317s5.986-13.317 13.317-13.317h33.335c7.33 0 13.317 5.986 13.317 13.317 0 7.33-5.987 13.317-13.317 13.317zm0 0"
        fill="#ebb02e"
      ></path>
    </svg>
  );
};

const MavenIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="i"
          gradientUnits="userSpaceOnUse"
          x1="-7274.8"
          y1="2082.507"
          x2="-7243.872"
          y2="2046.343"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset="0" stopColor="#f69923" stopOpacity="1"></stop>
          <stop offset=".312" stopColor="#f79a23" stopOpacity="1"></stop>
          <stop offset=".838" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="n"
          gradientUnits="userSpaceOnUse"
          x1="-7503.689"
          y1="2086.595"
          x2="-7283.036"
          y2="2086.595"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="o"
          gradientUnits="userSpaceOnUse"
          x1="-7477.053"
          y1="2064.42"
          x2="-7345.566"
          y2="2064.42"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset="0" stopColor="#282662" stopOpacity="1"></stop>
          <stop offset=".095" stopColor="#662e8d" stopOpacity="1"></stop>
          <stop offset=".788" stopColor="#9f2064" stopOpacity="1"></stop>
          <stop offset=".949" stopColor="#cd2032" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="p"
          gradientUnits="userSpaceOnUse"
          x1="-7491.296"
          y1="2088.633"
          x2="-7270.643"
          y2="2088.633"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="q"
          gradientUnits="userSpaceOnUse"
          x1="-7475.203"
          y1="2085.61"
          x2="-7359.244"
          y2="2085.61"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset="0" stopColor="#282662" stopOpacity="1"></stop>
          <stop offset=".095" stopColor="#662e8d" stopOpacity="1"></stop>
          <stop offset=".788" stopColor="#9f2064" stopOpacity="1"></stop>
          <stop offset=".949" stopColor="#cd2032" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="r"
          gradientUnits="userSpaceOnUse"
          x1="-7491.296"
          y1="2065.799"
          x2="-7270.643"
          y2="2065.799"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="s"
          gradientUnits="userSpaceOnUse"
          x1="-7504.984"
          y1="2066.905"
          x2="-7284.331"
          y2="2066.905"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="v"
          gradientUnits="userSpaceOnUse"
          x1="-7491.296"
          y1="2058.959"
          x2="-7270.643"
          y2="2058.959"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="y"
          gradientUnits="userSpaceOnUse"
          x1="-7491.296"
          y1="2059.762"
          x2="-7270.643"
          y2="2059.762"
          gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="z"
          gradientUnits="userSpaceOnUse"
          x1="-8307.632"
          y1="2040.008"
          x2="-8276.704"
          y2="2003.844"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset="0" stopColor="#f69923" stopOpacity="1"></stop>
          <stop offset=".312" stopColor="#f79a23" stopOpacity="1"></stop>
          <stop offset=".838" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="E"
          gradientUnits="userSpaceOnUse"
          x1="-8536.521"
          y1="2044.096"
          x2="-8315.868"
          y2="2044.096"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="F"
          gradientUnits="userSpaceOnUse"
          x1="-8509.885"
          y1="2021.921"
          x2="-8378.397"
          y2="2021.921"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset="0" stopColor="#282662" stopOpacity="1"></stop>
          <stop offset=".095" stopColor="#662e8d" stopOpacity="1"></stop>
          <stop offset=".788" stopColor="#9f2064" stopOpacity="1"></stop>
          <stop offset=".949" stopColor="#cd2032" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="G"
          gradientUnits="userSpaceOnUse"
          x1="-8524.128"
          y1="2046.134"
          x2="-8303.475"
          y2="2046.134"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="H"
          gradientUnits="userSpaceOnUse"
          x1="-8508.035"
          y1="2043.111"
          x2="-8392.076"
          y2="2043.111"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset="0" stopColor="#282662" stopOpacity="1"></stop>
          <stop offset=".095" stopColor="#662e8d" stopOpacity="1"></stop>
          <stop offset=".788" stopColor="#9f2064" stopOpacity="1"></stop>
          <stop offset=".949" stopColor="#cd2032" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="I"
          gradientUnits="userSpaceOnUse"
          x1="-8524.128"
          y1="2023.3"
          x2="-8303.475"
          y2="2023.3"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="J"
          gradientUnits="userSpaceOnUse"
          x1="-8537.816"
          y1="2024.407"
          x2="-8317.163"
          y2="2024.407"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient
          id="M"
          gradientUnits="userSpaceOnUse"
          x1="-8524.128"
          y1="2016.46"
          x2="-8303.475"
          y2="2016.46"
          gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)"
        >
          <stop offset=".323" stopColor="#9e2064" stopOpacity="1"></stop>
          <stop offset=".63" stopColor="#c92037" stopOpacity="1"></stop>
          <stop offset=".751" stopColor="#cd2335" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#e97826" stopOpacity="1"></stop>
        </linearGradient>
        <clipPath id="b">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="c">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="d">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="e">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="f">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="g">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <clipPath id="h">
          <path d="M0 0h128v128H0z"></path>
        </clipPath>
        <mask id="k">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="m">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="u">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="x">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="B">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="D">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <mask id="L">
          <g filter="url(#a)">
            <path
              fill="#000"
              fillOpacity=".34902"
              stroke="none"
              d="M0 0h128v128H0z"
            ></path>
          </g>
        </mask>
        <g id="j" clip-path="url(#b)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M43.695 53.98c-.265.293-.543.567-.824.844.145-.133.293-.289.43-.433.14-.13.27-.266.394-.41Zm0 0"
          ></path>
        </g>
        <g id="l" clip-path="url(#c)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M41.602 49.426c.046-.04.082-.086.125-.121.18-.18.363-.36.511-.543-.199.218-.425.43-.64.664Zm0 0"
          ></path>
        </g>
        <g id="t" clip-path="url(#d)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M43.309 54.398c-.133.149-.282.278-.43.434a5.68 5.68 0 0 1 .43-.434Zm0 0"
          ></path>
        </g>
        <g id="w" clip-path="url(#e)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M41.602 49.438c.046-.04.082-.086.14-.133-.047.035-.082.082-.14.133Zm0 0"
          ></path>
        </g>
        <g id="A" clip-path="url(#f)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M79.602 62.586c-.45.023-.895.023-1.336.023h.687c.215.004.43-.004.649-.023Zm0 0"
          ></path>
        </g>
        <g id="C" clip-path="url(#g)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M81.535 57.258h.2c.288 0 .578 0 .85-.035-.339 0-.69 0-1.046.023Zm0 0"
          ></path>
        </g>
        <g id="K" clip-path="url(#h)">
          <path
            stroke="none"
            fillRule="nonzero"
            fill="#be202e"
            fillOpacity="1"
            d="M78.953 62.621h-.687a6.56 6.56 0 0 1 .687 0Zm0 0"
          ></path>
        </g>
        <filter
          id="a"
          filterUnits="objectBoundingBox"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
        >
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#i)"
        d="M23.902 10.133a38.039 38.039 0 0 0-1.597 10.62l5.707 2.763a72.4 72.4 0 0 1 .398-10.164c.024-.23.047-.368.047-.368 0 .125-.035.243-.047.368a64.129 64.129 0 0 0-.012 10.027 110.54 110.54 0 0 0 8.457-8 12.174 12.174 0 0 0-6.37-6.805s-5.055-2.039-6.583 1.559Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M43.695 53.98c-.265.293-.543.567-.824.844.145-.133.293-.289.43-.433.14-.13.27-.266.394-.41Zm0 0"
      ></path>
      <use xlinkHref="#j" mask="url(#k)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M41.602 49.426c.046-.04.082-.086.125-.121.18-.18.363-.36.511-.543-.199.218-.425.43-.64.664Zm0 0"
      ></path>
      <use xlinkHref="#l" mask="url(#m)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#n)"
        d="M29.52 40.367a231.874 231.874 0 0 1-.72-5.597 112.17 112.17 0 0 1-.523-5.633c0-.114-.02-.227 0-.325a89.502 89.502 0 0 1-.277-5.3l-5.7-2.746c0 .343-.038.699-.054 1.074-.055 1.363-.098 2.8-.11 4.34 0 1.718 0 3.511.032 5.386.039 1.73.113 3.532.203 5.364.094 1.566.195 3.148.324 4.765v.184l7.625 3.86c-.254-1.801-.53-3.594-.8-5.372Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#o)"
        d="M40.8 85.45c.4 1.421.848 2.89 1.313 4.378v.059c.063.218.114.422.196.629.304 1.004.593 1.894 1.226 3.937A7.694 7.694 0 0 1 47.91 95.5a6.244 6.244 0 0 0-4.164-2.266 13.38 13.38 0 0 0 7.309-11.906 15.897 15.897 0 0 0-.188-1.305 5.387 5.387 0 0 1-3.062 4.61 15.057 15.057 0 0 0 2.437-9.492 29.88 29.88 0 0 0-.297-2.477 12.23 12.23 0 0 1-7.09 9.848l-2.312 2.129c.086.265.156.53.258.808Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#p)"
        d="M37.813 78.941c-.485-1.808-.97-3.644-1.461-5.496A361.37 361.37 0 0 1 35 68.06c-.445-1.817-.871-3.645-1.297-5.47-.422-1.827-.84-3.737-1.23-5.6-.395-1.864-.762-3.723-1.13-5.575-.132-.672-.25-1.324-.37-2-.211-1.14-.403-2.293-.61-3.45a.618.618 0 0 0-.039-.187l-7.582-3.87c.02.12.028.241.031.366.153 1.715.297 3.457.504 5.2.203 1.738.422 3.558.688 5.363.223 1.52.465 3.027.715 4.55.05.301.113.618.164.915a109.705 109.705 0 0 0 2.555 10.828c.328 1.101.652 2.168.984 3.176.289.847.601 1.699.902 2.539a73.593 73.593 0 0 0 2.399 5.754l7.66 3.879c-.399-1.41-.801-2.84-1.2-4.293-.113-.418-.214-.825-.331-1.243Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#q)"
        d="M31.79 80.832a59.387 59.387 0 0 0 3.523 6.508c.042.062.085.152.132.215a15.505 15.505 0 0 0-5.84-.45 21.445 21.445 0 0 1 9.41 5.485 9.865 9.865 0 0 1-4.449 2.23 9.838 9.838 0 0 0 4.883-.433 12.014 12.014 0 0 0-2.969 5.789 12.343 12.343 0 0 1 4.82-5.106c2.302 7.625 5.067 15.89 8.138 24.563.476-.617.609-1.43.359-2.164-.567-1.559-4.219-11.871-8.383-25.871-.117-.403-.223-.801-.355-1.203-.036-.114-.063-.215-.098-.336a749.886 749.886 0 0 1-1.305-4.528c-.097-.36-.199-.695-.297-1.058l-7.66-3.88c.024.083.051.16.09.239Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#r)"
        d="M31.223 45.902c.047.258.093.485.136.746.149.758.282 1.528.438 2.301.16.844.336 1.703.504 2.586.082.445.168.89.261 1.344.278 1.36.579 2.754.887 4.187.399 1.766.797 3.579 1.242 5.465.403 1.785.871 3.645 1.344 5.535.461 1.805.926 3.653 1.438 5.567.449 1.691.93 3.43 1.418 5.199 0 .082.058.176.074.262a632.38 632.38 0 0 0 1.543 5.41.305.305 0 0 0 .035.117l2.312-2.129c-.058 0-.101.051-.18.082a22.18 22.18 0 0 0 5.634-12.453 29.749 29.749 0 0 0-.075-6.95 47.27 47.27 0 0 0-1.109-5.944 78.476 78.476 0 0 0-1.7-5.825 11.615 11.615 0 0 1-1.765 2.551l-.398.438c-.133.148-.282.277-.43.433a13.5 13.5 0 0 0 1.664-10.027 12.698 12.698 0 0 1-2.289 3.965c-.152.183-.332.363-.512.543-.047.035-.082.082-.144.133a13.94 13.94 0 0 0 1.484-3.258c.07-.223.13-.45.172-.68.082-.348.137-.7.188-1.05.02-.235.058-.45.078-.684a9.725 9.725 0 0 0 0-1.653c0-.183 0-.347-.043-.52-.047-.257-.078-.495-.125-.73a41.03 41.03 0 0 0-.598-2.8c-.102-.399-.2-.766-.305-1.098-.047-.133-.07-.262-.117-.403-.125-.363-.226-.699-.336-.976a10.217 10.217 0 0 0-.422-.969 2.14 2.14 0 0 1-.168.457 15.014 15.014 0 0 1-2.597 3.739l2.129-1.95-2.145 1.938a.08.08 0 0 0-.035.05 4.49 4.49 0 0 0-.313.348c0-.027.04-.05.043-.074l-7.28 6.66c.058.05.066.09.062.117Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#s)"
        d="M28.398 23.379c.09 1.601.23 3.394.403 5.379.004.101.015.207.035.308.164 1.735.375 3.602.648 5.637.23 1.758.489 3.602.801 5.602.258 1.73.578 3.543.906 5.468l7.282-6.668a11.974 11.974 0 0 0 1.828-6.59c0-.57-.043-1.171-.09-1.788A56.41 56.41 0 0 0 39.578 25a49.186 49.186 0 0 0-1.082-5.148 28.214 28.214 0 0 0-.836-2.614 32.462 32.462 0 0 0-.8-1.812 115.46 115.46 0 0 1-8.462 7.953Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M43.309 54.398c-.133.149-.282.278-.43.434a5.68 5.68 0 0 1 .43-.434Zm0 0"
      ></path>
      <use xlinkHref="#t" mask="url(#u)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#v)"
        d="M43.309 54.398c-.133.149-.282.278-.43.434a5.68 5.68 0 0 1 .43-.434Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M41.602 49.438c.046-.04.082-.086.14-.133-.047.035-.082.082-.14.133Zm0 0"
      ></path>
      <use xlinkHref="#w" mask="url(#x)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#y)"
        d="M41.602 49.438c.046-.04.082-.086.14-.133-.047.035-.082.082-.14.133Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#z)"
        d="M98.508 11.563a43.16 43.16 0 0 0-9.707 7.289l2.398 6.761a80.326 80.326 0 0 1 8.403-7.86c.203-.167.328-.265.328-.265-.106.098-.227.168-.328.266a71.75 71.75 0 0 0-8 8.05c4.375.325 8.765.423 13.152.29a13.78 13.78 0 0 0 .281-10.559s-2.445-5.656-6.527-3.973Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M79.602 62.586c-.45.023-.895.023-1.336.023h.687c.215.004.43-.004.649-.023Zm0 0"
      ></path>
      <use xlinkHref="#A" mask="url(#B)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M81.535 57.258h.2c.288 0 .578 0 .85-.035-.339 0-.69 0-1.046.023Zm0 0"
      ></path>
      <use xlinkHref="#C" mask="url(#D)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#E)"
        d="M79.004 40.363a318.718 318.718 0 0 1 3.871-5.086 138.623 138.623 0 0 1 4.055-4.949c.078-.101.164-.195.238-.277a135.156 135.156 0 0 1 4-4.465l-2.398-6.742c-.286.27-.59.535-.899.82a136.81 136.81 0 0 0-3.535 3.402 222.161 222.161 0 0 0-4.258 4.368 220.475 220.475 0 0 0-4.09 4.472 260.517 260.517 0 0 0-3.527 4.098l-.137.156 3.067 9.164c1.222-1.652 2.418-3.324 3.613-4.96Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#F)"
        d="M52.254 85.602c-.8 1.476-1.602 3-2.422 4.566 0 .02-.027.039-.031.059-.121.23-.242.433-.34.66-.555 1.05-1.023 2-2.137 4.144a8.72 8.72 0 0 1 2.692 4.32 7.08 7.08 0 0 0-1.551-5.128c6.23 1.203 11.89.402 15.344-3.778.3-.379.597-.777.882-1.203a6.088 6.088 0 0 1-6.129 1.274 17.043 17.043 0 0 0 9.504-5.715 35.594 35.594 0 0 0 1.727-2.235 13.818 13.818 0 0 1-13.531 2.297l-3.555-.125c-.152.305-.309.575-.453.864Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#G)"
        d="M55.031 78c1.047-1.844 2.117-3.703 3.2-5.602a296.203 296.203 0 0 1 3.203-5.406c1.097-1.808 2.195-3.625 3.3-5.437a282.35 282.35 0 0 1 3.47-5.5c1.175-1.825 2.347-3.598 3.515-5.383a86.9 86.9 0 0 1 1.3-1.914c.739-1.09 1.497-2.18 2.254-3.262.032-.059.082-.121.114-.184l-3.028-9.136a2.994 2.994 0 0 1-.265.316c-1.242 1.504-2.504 3.024-3.739 4.598-1.23 1.57-2.488 3.2-3.707 4.867a265.274 265.274 0 0 0-3.039 4.23c-.199.282-.402.586-.593.868-1.2 1.797-2.364 3.558-3.387 5.25a113.286 113.286 0 0 0-3.156 5.5 134.34 134.34 0 0 0-1.735 3.34c-.441.91-.867 1.843-1.289 2.757a85.328 85.328 0 0 0-2.644 6.535l3.082 9.2c.8-1.461 1.625-2.914 2.445-4.403.219-.394.469-.8.7-1.234Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#H)"
        d="M48.68 74.742a67.607 67.607 0 0 0-2.332 8.043c0 .086-.051.192-.063.278a17.542 17.542 0 0 0-4.344-5.004 24.348 24.348 0 0 1 3.22 11.894 11.167 11.167 0 0 1-5.356-1.742 11.088 11.088 0 0 0 4.27 3.531 13.604 13.604 0 0 0-6.985 2.301 13.928 13.928 0 0 1 7.933-.273c-4.222 7.957-8.543 16.808-12.964 26.23a2.598 2.598 0 0 0 2-1.457c.8-1.703 6.043-12.902 13.812-27.488.219-.399.453-.82.672-1.254l.184-.348c.824-1.52 1.671-3.082 2.55-4.68.207-.37.399-.722.602-1.09v-.019l-3.082-9.2c-.047.09-.086.184-.117.278Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#I)"
        d="M75.977 46.176c-.168.238-.313.465-.48.703-.485.73-.99 1.453-1.477 2.2a208.44 208.44 0 0 1-1.653 2.483c-.281.426-.566.848-.855 1.293-.86 1.317-1.723 2.676-2.617 4.075a347.967 347.967 0 0 0-3.34 5.383 502.867 502.867 0 0 0-3.317 5.523c-1.062 1.816-2.152 3.676-3.261 5.602-.985 1.718-1.977 3.5-3 5.324-.055.078-.094.183-.149.265a529.846 529.846 0 0 0-3.058 5.602.298.298 0 0 0-.067.125l3.555.121c-.063-.031-.13-.04-.215-.074a25.118 25.118 0 0 0 14.43-5.559 33.84 33.84 0 0 0 5.472-5.64 55.376 55.376 0 0 0 3.825-5.668 86.801 86.801 0 0 0 3.257-6.043c-1.113.37-2.27.59-3.441.648l-.676.035h-.687a15.28 15.28 0 0 0 9.304-6.75 14.342 14.342 0 0 1-4.992 1.375c-.27.028-.558.028-.847.031h-.22a15.9 15.9 0 0 0 3.778-1.437c.234-.121.465-.254.684-.402.343-.215.664-.453.984-.696.207-.168.402-.32.606-.488.472-.41.906-.855 1.304-1.34.137-.156.266-.293.375-.457.168-.238.332-.457.477-.683a40.85 40.85 0 0 0 1.758-2.735c.234-.398.445-.777.629-1.129.066-.144.148-.265.218-.398.192-.403.375-.746.508-1.059.16-.36.305-.73.426-1.11a2.336 2.336 0 0 1-.5.235 16.92 16.92 0 0 1-5.059.946l3.266.125-3.266-.125c-.023-.012-.047-.012-.066 0a5.675 5.675 0 0 0-.516 0c.028 0 .07 0 .094-.032l-11.16-.402c.02.074-.008.113-.031.133Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#J)"
        d="M91.602 25.809a161.424 161.424 0 0 0-3.946 4.656c-.082.086-.156.18-.219.277a178.511 178.511 0 0 0-3.957 5.055c-1.199 1.598-2.48 3.297-3.816 5.16-1.168 1.598-2.348 3.316-3.602 5.121l11.16.402a13.554 13.554 0 0 0 6.712-3.847 45.42 45.42 0 0 0 1.351-1.508A66.175 66.175 0 0 0 99.313 36a56.266 56.266 0 0 0 3.199-5.004 29.64 29.64 0 0 0 1.402-2.766c.309-.73.566-1.421.8-2.097-4.374.113-8.75.004-13.112-.324Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#be202e"
        fillOpacity="1"
        d="M78.953 62.621h-.687a6.56 6.56 0 0 1 .687 0Zm0 0"
      ></path>
      <use xlinkHref="#K" mask="url(#L)"></use>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="url(#M)"
        d="M78.953 62.621h-.687a6.56 6.56 0 0 1 .687 0Zm0 0"
      ></path>
    </svg>
  );
};

const NestJsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#df234f"
        d="M75.323.4c-.898 0-1.796.199-2.594.498 1.696 1.098 2.594 2.594 3.093 4.29 0 .2.1.4.1.599 0 .2.1.399.1.598.1 2.894-.799 3.293-1.397 4.989-.998 2.194-.698 4.589.499 6.484.1.2.2.5.399.699-1.297-8.38 5.686-9.578 6.983-12.172.1-2.294-1.795-3.79-3.292-4.888C77.718.599 76.52.399 75.324.399ZM85.8 2.194c-.1.798 0 .599-.1.998 0 .299 0 .598-.1.898-.1.299-.1.499-.2.798-.1.3-.199.499-.299.798-.1.2-.2.399-.3.698-.099.1-.199.3-.298.4-.1.1-.1.199-.2.299-.2.2-.3.498-.499.698l-.598.599c-.2.2-.4.399-.599.498-.698.5-1.496.898-2.195 1.397-.2.2-.499.3-.698.499-.2.2-.4.3-.599.499l-.598.598c-.2.2-.4.4-.5.699-.199.2-.299.499-.498.698-.1.3-.2.499-.399.798-.1.3-.2.5-.3.798-.1.3-.199.599-.199.798 0 .1 0 .3-.1.4 0 .1 0 .299-.1.399v1.396c0 .3 0 .5.1.798 0 .3.1.5.2.799s.2.498.3.798c.099.2.199.299.199.499l-7.583-2.894a53.157 53.157 0 0 0-3.79-.997c-.699-.2-1.397-.3-2.096-.5a61.927 61.927 0 0 0-5.986-.897h-.2c-1.995-.2-3.89-.3-5.885-.3-1.497 0-2.894.1-4.29.2-1.996.1-3.99.4-5.986.699l-1.497.299c-.997.2-1.995.399-2.993.698-.499.1-.997.3-1.496.4-.499.199-.998.398-1.397.598-.399.2-.698.3-1.097.499-.1 0-.1 0-.2.1-.3.199-.598.299-.898.498-.1 0-.2.1-.2.1-.398.2-.698.4-.997.499-.2.1-.499.2-.698.3-.1.099-.2.099-.3.199-.299.2-.598.299-.898.498-.299.2-.598.3-.798.5-.2.199-.499.299-.698.498 0 0-.1 0-.1.1-.2.1-.399.3-.598.499l-.1.1c-.2.1-.3.299-.499.399-.1 0-.1.1-.2.1-.199.1-.299.299-.498.398 0 .1-.1.1-.1.1l-.599.599-.1.1-.598.598s0 .1-.1.1l-.499.499c-.1.1-.2.1-.2.2l-.598.598c0 .1-.1.1-.1.2l-.798.797-.1.1c-.498.599-1.097 1.098-1.695 1.597-.599.498-1.198.997-1.896 1.496s-1.297.898-1.995 1.297c-.699.399-1.397.698-2.095.998-.699.299-1.397.598-2.095.798-1.397.3-2.794.898-3.991.997 0-.498-.3-.399-.599-.399-.299.1-.598.1-.798.2-.3.1-.499.2-.798.3a2.96 2.96 0 0 0-.798.398c-.2.2-.499.3-.698.5-.2.199-.5.398-.699.598-.2.2-.499.399-.698.598-.2.2-.4.4-.599.699-.2.299-.399.498-.499.798-.199.2-.299.499-.498.798-.1.3-.3.598-.4.898l-.299.898c-.1.299-.1.498-.2.798v.1c-.1.3-.1.698-.1.898.1-.1.1.1.1.299v.399c0 .2.1.399.1.598.1.2.1.4.2.599.099.2.199.399.398.599.1.2.3.399.4.598.199.2.398.4.598.499.2.2.399.4.598.499.798.698.998.898 1.996 1.496.2.1.299.2.499.3h.1v.2c0 .298.1.498.199.797.1.3.2.599.3.798l.298.599c0 .1.1.1.1.2.1.299.3.498.4.698.199.2.299.499.498.698l.599.599.598.598h.1c.2.2.399.3.599.5s.499.299.698.398c.2.1.499.3.798.4.2.1.4.199.698.199 0 0 .1 0 .1.1.1 0 .3.1.4.1-.1 1.795-.1 3.491.1 4.09.298.698 1.795-1.397 3.192-3.691-.2 2.294-.3 4.988 0 5.786.399.798 2.294-1.796 4.09-4.59 23.345-5.387 44.695 10.775 46.99 33.622-.4-3.592-4.79-5.587-6.884-5.088-.998 2.394-2.694 5.587-5.387 7.482.199-2.195.1-4.39-.3-6.584-.698 2.993-2.095 5.886-4.09 8.28-3.093.2-6.285-1.297-7.882-3.591-.1-.1-.2-.3-.299-.4-.1-.199-.2-.498-.3-.698-.1-.2-.199-.499-.199-.698v-1.197c0-.2.1-.5.2-.699s.1-.499.2-.698c.099-.2.199-.499.398-.698.599-1.597.599-2.894-.499-3.592l-.598-.3c-.1 0-.3-.099-.4-.099s-.199-.1-.299-.1c-.199-.1-.498-.1-.698-.2-.2-.1-.499-.1-.698-.1-.2 0-.5-.099-.699-.099h-.498c-.3 0-.5 0-.699.1-.2 0-.499.1-.698.1-.2.1-.499.1-.699.2-.199.099-.399.199-.698.298l-.599.3c-7.682 4.988-3.092 16.76 2.096 20.152-1.996.4-3.991.798-4.59 1.198l-.1.1c1.397.897 2.894 1.596 4.49 2.194 2.095.699 4.39 1.297 5.387 1.597 2.694.598 5.488.798 8.281.598 14.566-.998 26.538-12.171 28.732-26.737.1.3.1.598.2.898.1.598.2 1.197.3 1.895.1.3.1.599.1.898v.1c0 .3.099.599.099.898 0 .399.1.698.1 1.097v4.19c0 .3-.1.5-.1.799v.299c0 .3-.1.599-.1.998-.1.299-.1.598-.2.898v.1c-.1.299-.1.598-.199.897v.1c-.1.3-.1.599-.2.898v.1l-.299.898v.1c-.1.299-.2.698-.299.997-.1.3-.2.599-.4.998-.099.299-.199.698-.398.997-.1.3-.3.599-.4.998-.099.3-.299.599-.398.898 0 .1-.1.2-.1.2s0 .1-.1.1c-2.095 4.289-5.287 8.08-9.278 11.073-.3.2-.499.4-.798.599-.1.1-.2.1-.2.2-.2.199-.499.299-.698.498l.1.2c.498-.1.898-.1 1.396-.2.898-.1 1.696-.3 2.594-.499.2 0 .5-.1.699-.2.2 0 .299-.1.498-.1s.5-.099.699-.099c.2-.1.399-.1.598-.2 3.293-.797 6.485-1.895 9.578-3.192-5.288 7.183-12.271 12.97-20.452 16.76 3.791-.299 7.582-.897 11.273-1.995a52.469 52.469 0 0 0 31.127-24.941c-1.396 7.582-4.39 14.865-8.879 21.25 3.193-2.095 6.086-4.59 8.78-7.283 7.382-7.682 12.27-17.559 13.867-28.034 1.098 5.188 1.497 10.575.998 15.863 23.844-33.222 1.995-67.641-7.183-76.72 0-.1-.1-.1-.1-.2 0 .4 0 .798-.1 1.198-.1.798-.2 1.496-.3 2.194-.199.699-.398 1.497-.598 2.195-.2.699-.499 1.397-.798 2.095-.3.699-.599 1.397-.998 1.996s-.798 1.297-1.197 1.895c-.399.599-.898 1.197-1.397 1.796-.498.599-.997 1.097-1.596 1.696-.3.3-.598.599-.997.798-.3.2-.5.4-.799.698-.598.5-1.197.898-1.895 1.297-.599.4-1.297.799-1.995 1.098l-2.096.898c-.698.299-1.396.499-2.095.698-.698.2-1.496.4-2.195.499-.798.1-1.496.2-2.194.3-.5 0-1.098.099-1.597.099-.798 0-1.496-.1-2.194-.1-.799-.1-1.497-.2-2.195-.3a7.874 7.874 0 0 1-2.195-.598c.698-.1 1.496-.1 2.195-.299.798-.1 1.496-.3 2.195-.499.698-.2 1.496-.399 2.095-.698l2.095-.898c.698-.3 1.297-.698 1.995-1.097.599-.4 1.297-.898 1.896-1.297.598-.5 1.197-.998 1.696-1.497.598-.499 1.097-1.097 1.596-1.596.499-.599.998-1.197 1.397-1.796.1-.1.1-.2.2-.3.298-.498.697-1.097.997-1.595a18.56 18.56 0 0 0 .997-1.996c.3-.698.6-1.397.799-2.095l.598-2.095c.1-.798.3-1.496.3-2.195.1-.798.1-1.496.1-2.195 0-.498 0-1.097-.1-1.596-.1-.798-.2-1.496-.3-2.195-.1-.798-.3-1.496-.499-2.195-.2-.698-.499-1.396-.698-2.095-.3-.698-.599-1.396-.898-1.995-.399-.698-.698-1.297-1.097-1.995-.4-.599-.898-1.198-1.297-1.796-.499-.599-.998-1.098-1.497-1.696-.299-.3-.598-.599-.898-.798-1.496-1.197-2.993-2.195-4.589-3.193-.2-.1-.399-.2-.698-.3-1.297-1.096-2.295-1.396-3.292-1.795Z"
      ></path>
    </svg>
  );
};

const ElectronIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g fill="#47848f">
        <path d="M49.07 32.66c-14.37-2.62-25.72.12-30.25 8-3.38 5.85-2.41 13.61 2.34 21.9a1.47 1.47 0 002.56-1.47c-4.28-7.47-5.12-14.17-2.35-19 3.76-6.51 13.89-9 27.17-6.54a1.47 1.47 0 10.53-2.9zM28.63 72.61a92.2 92.2 0 0022 17.34c20.84 12 43 15.25 54 7.79a1.47 1.47 0 00-1.66-2.43C93.11 102 72 98.92 52.07 87.39a89.27 89.27 0 01-21.26-16.77 1.47 1.47 0 00-2.18 2z"></path>
        <path d="M101.06 70.81c9.41-11.11 12.69-22.29 8.17-30.11-3.32-5.76-10.35-8.8-19.69-8.92a1.47 1.47 0 000 2.95c8.4.11 14.45 2.73 17.18 7.45 3.75 6.5.82 16.47-7.87 26.74a1.47 1.47 0 102.25 1.9zM76.89 33.15a92 92 0 00-26.25 10.4C29.13 56 15.09 74.29 17 87.57a1.47 1.47 0 003-.43C18.23 75.35 31.53 58 52.11 46.11A89.07 89.07 0 0177.51 36a1.47 1.47 0 10-.62-2.88z"></path>
        <path d="M42 96.78C47 110.51 55 119 64.05 119c6.6 0 12.7-4.5 17.46-12.42A1.47 1.47 0 1079 105c-4.28 7.12-9.53 11-14.94 11-7.52 0-14.69-7.54-19.24-20.24a1.47 1.47 0 00-2.77 1zm45-2.69a92.5 92.5 0 003.91-27.3c0-24.41-8.54-45.44-20.71-50.85a1.47 1.47 0 00-1.2 2.7c10.85 4.82 19 24.78 19 48.15a89.57 89.57 0 01-3.78 26.42 1.47 1.47 0 002.81.88zM114.71 92.65a7.05 7.05 0 10-7.05 7.05 7.05 7.05 0 007.05-7.05zm-2.95 0a4.1 4.1 0 11-4.1-4.1 4.1 4.1 0 014.1 4.1zM20.34 99.7a7.05 7.05 0 10-7.05-7.05 7.05 7.05 0 007.05 7.05zm0-2.95a4.1 4.1 0 114.1-4.1 4.1 4.1 0 01-4.1 4.1z"></path>
        <path d="M64.05 23.13A7.05 7.05 0 1057 16.08a7.05 7.05 0 007.05 7.05zm0-2.95a4.1 4.1 0 114.1-4.1 4.1 4.1 0 01-4.1 4.1zM65.13 71.77A5.1 5.1 0 1169 65.71a5.1 5.1 0 01-3.87 6.06z"></path>
      </g>
    </svg>
  );
};

const NextJSIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <circle cx="64" cy="64" r="64"></circle>
      <path
        fill="url(#a)"
        d="M106.317 112.014 49.167 38.4H38.4v51.179h8.614v-40.24l52.54 67.884a64.216 64.216 0 0 0 6.763-5.209z"
      ></path>
      <path fill="url(#b)" d="M81.778 38.4h8.533v51.2h-8.533z"></path>
      <defs>
        <linearGradient
          id="a"
          x1="109"
          x2="144.5"
          y1="116.5"
          y2="160.5"
          gradientTransform="scale(.71111)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff"></stop>
          <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="121"
          x2="120.799"
          y1="54"
          y2="106.875"
          gradientTransform="scale(.71111)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff"></stop>
          <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

const YAMLIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <polygon
        transform="matrix(.24805 0 0 .24805 .5 5.6287)"
        points="87.702 137.67 0 0 63.25 0 119.02 88.646 175.24 0 235.79 0 143.98 137.67 143.98 224.95 87.702 224.95"
      ></polygon>
      <path
        d="m82.428 49.149h-25.266l-5.1388 12.408h-11.188l23.659-55.798h11.444l22.699 55.798h-11.956l-4.2525-12.408zm-4.197-11.14-7.7455-20.476-8.6412 20.476z"
        fill="#cb171e"
      ></path>
      <polygon
        transform="matrix(.24805 0 0 .24805 .5 5.6287)"
        points="87.701 250.18 87.701 470.65 135 470.65 135 318.57 184.51 420.79 221.74 420.79 272.94 314.98 272.94 470.6 318.32 470.6 318.32 250.18 256.36 250.18 201.38 349.88 149.02 250.18"
      ></polygon>
      <polygon
        transform="matrix(.24805 0 0 .24805 .5 5.6287)"
        points="512 422.74 512 422.74 395.64 422.74 395.64 250.12 347.44 250.12 347.44 469.65 512 469.65"
      ></polygon>
    </svg>
  );
};

const DefaultTechIcon = () => {
  return (
    <svg
      width="20" // Set to match other icons' size
      height="20" // Set to match other icons' size
      viewBox="0 0 454 526" // Keep original viewBox to maintain proportions
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M423 497H91C57.8629 497 31 470.131 31 436.994C31 434.579 31 432.236 31 430M31 430C31 321.678 31 171.346 31 88.9506C31 55.8135 57.8629 29 91 29H363C396.137 29 423 55.8629 423 89V319.502C423 352.639 396.137 379.502 363 379.502H103.188C101.637 379.502 100.112 379.454 98.5617 379.456C87.4569 379.471 39.5661 382.327 31 430Z"
        stroke="#202124"
        stroke-width="52"
        stroke-linecap="round"
      />
      <path d="M387 380V498" stroke="#202124" stroke-width="52" />
      <path
        d="M197 192.036V28H347V192.729C347 209.439 327.723 218.781 314.607 208.427L271 174L229.596 207.571C216.522 218.171 197 208.867 197 192.036Z"
        fill="#202124"
      />
    </svg>
  );
};

const BootstrapIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          x1="76.079"
          x2="523.48"
          y1="10.798"
          y2="365.95"
          gradientTransform="translate(1.11 14.613) scale(.24566)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9013fe"></stop>
          <stop offset="1" stop-color="#6610f2"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="193.51"
          x2="293.51"
          y1="109.74"
          y2="278.87"
          gradientTransform="translate(0 52)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#fff"></stop>
          <stop offset="1" stop-color="#f1e5fc"></stop>
        </linearGradient>
        <filter
          id="c"
          width="197"
          height="249"
          x="161.9"
          y="135.46"
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
      <path
        fill="url(#a)"
        d="M14.985 27.712c-.237-6.815 5.072-13.099 12.249-13.099h73.54c7.177 0 12.486 6.284 12.249 13.099-.228 6.546.068 15.026 2.202 21.94 2.141 6.936 5.751 11.319 11.664 11.883v6.387c-5.913.564-9.523 4.947-11.664 11.883-2.134 6.914-2.43 15.394-2.202 21.94.237 6.815-5.072 13.098-12.249 13.098h-73.54c-7.177 0-12.486-6.284-12.249-13.098.228-6.546-.068-15.026-2.203-21.94-2.14-6.935-5.76-11.319-11.673-11.883v-6.387c5.913-.563 9.533-4.947 11.673-11.883 2.135-6.914 2.43-15.394 2.203-21.94z"
      ></path>
      <path
        fill="url(#b)"
        d="M267.1 364.46c47.297 0 75.798-23.158 75.798-61.355 0-28.873-20.336-49.776-50.532-53.085v-1.203c22.185-3.609 39.594-24.211 39.594-47.219 0-32.783-25.882-54.138-65.322-54.138h-88.74v217zm-54.692-189.48h45.911c24.958 0 39.131 11.128 39.131 31.279 0 21.505-16.484 33.535-46.372 33.535h-38.67zm0 161.96v-71.431h45.602c32.661 0 49.608 12.03 49.608 35.49 0 23.459-16.484 35.941-47.605 35.941z"
        filter="url(#c)"
        transform="translate(1.494 2.203) scale(.24566)"
      ></path>
    </svg>
  );
};

const AngularMaterialIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#ffa726"
        d="M63.934.656 5.25 21.66l8.863 77.719 49.82 27.77 49.887-27.77 9.059-77.719Zm0 0"
      ></path>
      <path
        fill="#fb8c00"
        d="M63.934.656v126.492l49.886-27.77 9.059-77.718Zm0 0"
      ></path>
      <path
        fill="#ffe0b2"
        d="m72.797 96.688-41.55-20.02 23.827-14.703L96.887 82.05Zm0 0"
      ></path>
      <path
        fill="#fff3e0"
        d="m72.797 81.262-41.55-20.086 23.827-14.637 41.813 20.086Zm0 0"
      ></path>
      <path
        fill="#fff"
        d="m72.797 65.84-41.55-20.09 23.827-14.703 41.813 20.086Zm0 0"
      ></path>
    </svg>
  );
};

const MaterialUIIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#1FA6CA"
        d="M.2 68.6V13.4L48 41v18.4L16.1 41v36.8L.2 68.6z"
      ></path>
      <path
        fill="#1C7FB6"
        d="M48 41l47.9-27.6v55.3L64 87l-16-9.2 32-18.4V41L48 59.4V41z"
      ></path>
      <path fill="#1FA6CA" d="M48 77.8v18.4l32 18.4V96.2L48 77.8z"></path>
      <path
        fill="#1C7FB6"
        d="M80 114.6L127.8 87V50.2l-16 9.2v18.4L80 96.2v18.4zM111.9 41V22.6l16-9.2v18.4l-16 9.2z"
      ></path>
    </svg>
  );
};

const AzureDevOpsIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="a"
          gradientUnits="userSpaceOnUse"
          x1="9"
          y1="16.97"
          x2="9"
          y2="1.03"
          gradientTransform="scale(7.11111)"
        >
          <stop offset="0" stop-color="#0078d4"></stop>
          <stop offset=".16" stop-color="#1380da"></stop>
          <stop offset=".53" stop-color="#3c91e5"></stop>
          <stop offset=".82" stop-color="#559cec"></stop>
          <stop offset="1" stop-color="#5ea0ef"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#a)"
        d="M120.89 28.445v69.262l-28.445 23.324-44.09-16.07v15.93L23.395 88.25l72.746 5.688V31.574ZM96.64 31.93 55.82 7.11v16.285L18.348 34.418 7.109 48.852v32.785l16.075 7.11V46.718Zm0 0"
      ></path>
    </svg>
  );
};

const AzureCosmosDBIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.825 58.635c5.491 22.449-8.458 45.049-31.156 50.48-22.695 5.429-45.547-8.365-51.036-30.815-5.492-22.449 8.458-45.049 31.153-50.48l.078-.018c22.588-5.46 45.374 8.223 50.896 30.565l.065.268Z"
        fill="#59B3D8"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.747 85.194c-.013-6.137-5.055-11.1-11.259-11.085h-1.701c1.442-5.932-2.248-11.895-8.246-13.322a11.182 11.182 0 0 0-2.703-.306H23.162c-2.525 12.851 1.246 26.127 10.174 35.796h14.149c6.205.015 11.247-4.948 11.262-11.083ZM72.69 39.233c0 .649.085 1.296.255 1.925h-4.861c-6.445 0-11.667 5.168-11.667 11.543 0 6.372 5.222 11.54 11.667 11.54h38.645c-1.258-13.787-9.486-26.01-21.862-32.477h-4.605c-4.177-.002-7.562 3.339-7.572 7.469Zm34.043 33.587H83.679c-5.259-.013-9.531 4.187-9.552 9.385a9.241 9.241 0 0 0 1.148 4.471c-5.003 1.546-7.792 6.814-6.228 11.765 1.242 3.934 4.938 6.607 9.106 6.589h6.427c12.314-6.454 20.607-18.51 22.153-32.21Z"
        fill="#B6DEEC"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.382 40.624a1.286 1.286 0 0 1-1.3-1.275v-.003c-.021-8.064-6.637-14.587-14.79-14.579A1.286 1.286 0 0 1 0 23.489c0-.703.579-1.275 1.292-1.275 8.143.007 14.756-6.503 14.79-14.554a1.29 1.29 0 0 1 1.356-1.227c.672.028 1.21.56 1.241 1.227.021 8.061 6.639 14.584 14.792 14.577.713 0 1.292.572 1.292 1.277 0 .706-.579 1.279-1.292 1.279-8.148-.011-14.766 6.507-14.792 14.566-.01.7-.589 1.265-1.297 1.265Z"
        fill="#B7D332"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.6 122.793a.764.764 0 0 1-.768-.759c-.018-4.821-3.98-8.719-8.854-8.709a.762.762 0 0 1-.77-.756c0-.419.342-.759.765-.759h.005c4.872.002 8.826-3.893 8.844-8.711a.77.77 0 0 1 .778-.767.77.77 0 0 1 .775.767c.018 4.818 3.972 8.713 8.843 8.711a.761.761 0 0 1 .77.756.759.759 0 0 1-.765.759h-.005c-4.871-.002-8.828 3.893-8.843 8.714a.764.764 0 0 1-.773.754h-.002Z"
        fill="#0072C5"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M126.317 30.84c-4.035-6.539-14.175-8.049-29.306-4.384a121.688 121.688 0 0 0-13.893 4.384 42.829 42.829 0 0 1 8.187 5.173c2.574-.836 5.101-1.59 7.512-2.173a53.33 53.33 0 0 1 12.335-1.727c4.957 0 7.691 1.211 8.606 2.686 1.496 2.423.119 8.816-8.681 18.871-1.566 1.789-3.326 3.601-5.179 5.423a175.936 175.936 0 0 1-31.843 24.149 176.032 176.032 0 0 1-36.329 17.105c-15.317 4.936-25.773 4.836-28.119 1.048-2.342-3.788 2.344-13.048 13.776-24.29a41.005 41.005 0 0 1-.938-9.735c-18.2 16.271-24.09 30.365-19.387 37.981 2.463 3.985 7.844 6.229 15.705 6.229a80.772 80.772 0 0 0 27.183-5.932 194.648 194.648 0 0 0 32.11-15.926 193.405 193.405 0 0 0 28.884-21.148 118.565 118.565 0 0 0 9.947-9.941c10.207-11.655 13.466-21.268 9.43-27.793Z"
        fill="#000"
      ></path>
    </svg>
  );
};

const GulpIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#EB4A4B"
        d="M36.965 35.459c.877 9.232 1.747 18.412 2.637 27.798 1.451-2.495 2.501-4.888 4.085-6.848 1.475-1.826 3.334-3.511 5.357-4.678 2.641-1.524 6.104-.089 6.96 2.614.23.725-.319 1.697-.511 2.556-.646-.341-1.479-.529-1.901-1.051-1.793-2.217-2.873-2.479-4.856-.563-3.699 3.576-5.779 8.056-6.573 13.091-.153.974.456 2.067.713 3.105 1.011-.348 2.185-.476 3.002-1.084 2.656-1.977 4.302-4.666 5.21-7.88.197-.696 1.265-1.145 1.933-1.708.32.658 1.05 1.433.897 1.954a373.814 373.814 0 01-4.536 14.429c-.162.484-1.051.725-1.604 1.079-.223-.636-.692-1.302-.617-1.901.168-1.358.605-2.683.91-3.927l-7.24 3.333c.405 4.622.825 9.807 1.323 14.985.382 3.954 1.029 4.978 4.923 5.728 4.544.875 9.173 1.434 13.792 1.774a60.391 60.391 0 0020.23-1.904c2.472-.664 3.458-2.29 3.635-4.717.162-2.235.524-4.456.775-6.685.493-4.391.972-8.783 1.476-13.358-1.667 1.056-2.978 2.238-4.511 2.739-1.116.365-2.524-.169-3.803-.303.245-1.174.23-2.497.796-3.487.922-1.618 2.224-3.021 3.364-4.515l-.491-.591c-.817.483-1.832.8-2.413 1.485-1.182 1.394-2.339 2.886-3.13 4.52-1.324 2.735-2.333 5.622-3.518 8.426-.515 1.216-.959 3.076-2.684 2.366-1.845-.761-.547-2.386-.114-3.542.689-1.844 1.599-3.606 2.215-4.962-1.746.208-3.516.459-5.294.614-.752.064-1.646-.348-2.261-.07-2.045.924-3.341.553-3.766-1.711-.947.615-1.749 1.448-2.694 1.672-1.147.273-2.703.452-3.543-.121-.673-.459-.918-2.184-.688-3.196.457-2.012 1.311-3.946 2.122-5.859.502-1.185 1.007-3.077 2.701-2.253 1.674.813.154 2.185-.232 3.286-.599 1.702-1.209 3.401-1.813 5.101l.96.58c.914-.794 2.053-1.441 2.693-2.415 1.048-1.592 1.681-3.452 2.673-5.086.411-.677 1.296-1.065 1.967-1.584.136.862.462 1.748.354 2.58-.107.841-.698 1.61-.981 2.442-.425 1.246-.768 2.52-1.2 3.969 2.043.078 2.918-.782 3.495-2.299 1.826-4.793 3.672-9.581 5.679-14.3.343-.808 1.509-1.264 2.296-1.884.091.974.525 2.078.216 2.899-1.645 4.349-3.492 8.62-5.228 12.935-.293.727-.387 1.534-.572 2.304 3.059-1.375 5.612-2.895 6.544-6.146.228-.79 1.162-1.377 1.771-2.058l1.416 1.5c.43-.362.824-.774 1.291-1.075 1.47-.947 3.053-1.782 4.603-.315 1.604 1.517.39 2.995-.448 4.307-.912 1.431-2.029 2.73-3.057 4.086 2.312-1.49 5.469-2.158 5.889-5.378 1.024-7.865 1.924-15.746 2.837-23.625.271-2.332.416-4.679.627-7.109-18.21 4.409-36.029 4.436-54.088-.069zm7.816 61.369c.877 2.317 2.209 4.593 2.558 7.011.737 5.147.924 10.372 1.446 15.554.076.755.565 1.792 1.175 2.124 8.98 4.88 18.047 5.726 27.209.389 1.367-.796 1.62-1.847 1.797-3.325.857-7.181-1.051-14.798 3.54-21.56-12.856 3.189-25.403 3.288-37.725-.193zm30.991-60.08c4.362-.421 8.671-1.445 12.985-2.291.813-.159 1.535-.778 2.299-1.185-1.007-.885-1.878-1.311-2.788-1.418-4.53-.535-9.076-.947-13.603-1.508-.684-.085-1.905-.929-1.854-1.083 1.321-3.98 1.256-8.485 4.254-11.839 3.789-4.24 7.617-8.443 11.416-12.648-2.826-3.04-2.864-3.044-5.425-.383-1.448 1.504-2.771 3.15-4.342 4.512-5.813 5.038-9.896 11.005-10.692 18.872-.183 1.805-1.174 2.457-3.069 2.485-6.256.091-12.519.263-18.761.674-3.093.203-6.148.997-9.221 1.523l-.028 1.149c1.923.593 3.809 1.372 5.773 1.749 10.944 2.098 21.991 2.458 33.056 1.391zM72.276 34c-2.477 2-4.524 2-6.501 0h6.501z"
      ></path>
    </svg>
  );
};

const LeafletIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.43 78.31c-1.55-.72-4.45-2.95-9.4-7.28-5.62-4.88-8.74-7.1-11.41-8.11-2.16-.81-7.06-.85-10.95-.11-1.57.29-1.53.31-2.21-.85l-.41-.66.77-.13c.44-.06 3.48-.17 6.78-.22 4.96-.09 6.38-.07 8.24.18 3.15.42 3.21.44 2.36 1.59-.26.35-.46.79-.46 1.01 0 .29 1.14 1.27 4.55 3.89 2.51 1.92 5.79 4.46 7.28 5.66 1.51 1.18 2.89 2.16 3.08 2.16.18 0 .7.13 1.12.28.42.15 1.01.28 1.29.28.28 0 .61-.13.74-.28.13-.15.39-.28.57-.28.29 0 .35.15.35 1.01 0 .55.09 1.22.22 1.47.18.41.17.52-.06.66-.46.29-1.51.18-2.47-.28z"
        fill="#000000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.77 102.55c-.18-.09-.92-.61-1.64-1.14-1.29-.96-5.7-3.78-5.9-3.78-.06 0-.87-.48-1.81-1.07-.94-.59-2.76-1.68-4.09-2.41-1.31-.76-2.86-1.62-3.41-1.95-2.12-1.25-9.29-5.03-13.36-7.02l-4.24-2.08 4.31-.02 4.31 0 5.46 3.63c3 1.99 6.3 4.15 7.35 4.79 4.06 2.51 9.68 5.03 14.87 6.67 1.33.42 2.51.81 2.65.85.33.13-.7 1.23-2.19 2.38-1.66 1.25-1.92 1.38-2.32 1.16z"
        fill="#000000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.95 119.82c0-.11-.2-.53-.46-.94l-.46-.74h.44c.39 0 .44.11.53.87.06.5.06.92.02.96-.04.04-.07-.02-.07-.15z"
        fill="#000000"
      />
    </svg>
  );
};

const WordpressIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#494949"
        d="M64.094 126.224c34.275-.052 62.021-27.933 62.021-62.325 0-33.833-27.618-61.697-60.613-62.286C30.85.995 1.894 29.113 1.885 63.21c-.01 35.079 27.612 63.064 62.209 63.014zM63.993 4.63c32.907-.011 59.126 26.725 59.116 60.28-.011 31.679-26.925 58.18-59.092 58.187-32.771.007-59.125-26.563-59.124-59.608.002-32.193 26.766-58.848 59.1-58.859zM39.157 35.896c.538 1.793-.968 2.417-2.569 2.542-1.685.13-3.369.257-5.325.406 6.456 19.234 12.815 38.183 19.325 57.573.464-.759.655-.973.739-1.223 3.574-10.682 7.168-21.357 10.651-32.069.318-.977.16-2.271-.188-3.275-1.843-5.32-4.051-10.524-5.667-15.908-1.105-3.686-2.571-6.071-6.928-5.644-.742.073-1.648-1.524-2.479-2.349 1.005-.6 2.003-1.704 3.017-1.719a849.593 849.593 0 0126.618.008c1.018.017 2.016 1.15 3.021 1.765-.88.804-1.639 2.01-2.668 2.321-1.651.498-3.482.404-5.458.58l19.349 57.56c2.931-9.736 5.658-18.676 8.31-27.639 2.366-8.001.956-15.473-3.322-22.52-1.286-2.119-2.866-4.175-3.595-6.486-.828-2.629-1.516-5.622-1.077-8.259.745-4.469 4.174-6.688 8.814-7.113C74.333.881 34.431 9.317 19.728 34.922c5.66-.261 11.064-.604 16.472-.678 1.022-.013 2.717.851 2.957 1.652zm10.117 77.971c-.118.345-.125.729-.218 1.302 10.943 3.034 21.675 2.815 32.659-.886l-16.78-45.96c-5.37 15.611-10.52 30.575-15.661 45.544zm-8.456-2.078l-25.281-69.35c-11.405 22.278-2.729 56.268 25.281 69.35zm76.428-44.562c.802-10.534-2.832-25.119-5.97-27.125-.35 3.875-.106 8.186-1.218 12.114-2.617 9.255-5.817 18.349-8.899 27.468-3.35 9.912-6.832 19.779-10.257 29.666 16.092-9.539 24.935-23.618 26.344-42.123z"
      ></path>
    </svg>
  );
};

const GitLabIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#E24329"
        d="m124.755 51.382-.177-.452L107.47 6.282a4.459 4.459 0 0 0-1.761-2.121 4.581 4.581 0 0 0-5.236.281 4.578 4.578 0 0 0-1.518 2.304L87.404 42.088H40.629L29.077 6.746a4.492 4.492 0 0 0-1.518-2.31 4.581 4.581 0 0 0-5.236-.281 4.502 4.502 0 0 0-1.761 2.121L3.422 50.904l-.17.452c-5.059 13.219-.763 28.192 10.537 36.716l.059.046.157.111 26.061 19.516 12.893 9.758 7.854 5.93a5.283 5.283 0 0 0 6.388 0l7.854-5.93 12.893-9.758 26.218-19.634.065-.052c11.273-8.526 15.562-23.472 10.524-36.677z"
      ></path>
      <path
        fill="#FC6D26"
        d="m124.755 51.382-.177-.452a57.79 57.79 0 0 0-23.005 10.341L64 89.682c12.795 9.68 23.934 18.09 23.934 18.09l26.218-19.634.065-.052c11.291-8.527 15.586-23.488 10.538-36.704z"
      ></path>
      <path
        fill="#FCA326"
        d="m40.066 107.771 12.893 9.758 7.854 5.93a5.283 5.283 0 0 0 6.388 0l7.854-5.93 12.893-9.758s-11.152-8.436-23.947-18.09a18379.202 18379.202 0 0 0-23.935 18.09z"
      ></path>
      <path
        fill="#FC6D26"
        d="M26.42 61.271A57.73 57.73 0 0 0 3.422 50.904l-.17.452c-5.059 13.219-.763 28.192 10.537 36.716l.059.046.157.111 26.061 19.516L64 89.655 26.42 61.271z"
      ></path>
    </svg>
  );
};

const BlazorIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#5c2d91"
        d="M127.352 43.199c-5.727 35.891-36.562 62.379-72.902 62.633-3.566.137-7.137-.082-10.656-.648-15.18-2.574-26.496-15.402-27.16-30.785.125-17.336 14.148-31.359 31.488-31.484S79.68 56.617 80.047 73.953c.129 5.254-2.145 9.871-6.824 10-5 0-7.344-3.57-7.344-8.379V62.215c.004-4.496-3.621-8.156-8.117-8.191H46.559c-8.977-.062-16.832 6.012-19.035 14.715s1.824 17.781 9.75 21.996a19.5 19.5 0 0 0 23.688-4.223l.391-.582.391.645c2.738 3.719 7.152 5.82 11.762 5.602A15.54 15.54 0 0 0 87.902 75.93c.039-3.48-.348-6.949-1.16-10.328a39.57 39.57 0 0 0-42.969-30.926C23.645 36.879 8.43 53.922 8.512 74.168c.262 21.543 17.512 39.023 39.047 39.566 0 0 2.93.266 6.242.195a84.49 84.49 0 0 0 45.289-13.516c.191-.125.383.129.254.328a66.49 66.49 0 0 1-51.785 21.18c-12.75.23-25.039-4.762-34.02-13.812S-.332 86.723 0 73.977a48.37 48.37 0 0 1 19.426-38.73 47.38 47.38 0 0 1 27.941-9.223h15.031a42.29 42.29 0 0 0 31.203-13.777.59.59 0 0 1 .68-.141c.238.102.379.344.359.598-.637 6.758-2.887 13.262-6.562 18.969-.109.203-.09.453.051.633a.58.58 0 0 0 .598.215 45.45 45.45 0 0 0 31.602-26.055.8.8 0 0 1 1.367 0 57.58 57.58 0 0 1 5.656 36.734zM46.52 61.824c-6.422 0-11.633 5.207-11.633 11.633A11.64 11.64 0 0 0 46.52 85.09c6.426 0 11.633-5.211 11.633-11.633V62.602a.84.84 0 0 0-.801-.801zm0 0"
      ></path>
    </svg>
  );
};

const NpmIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#cb3837"
        d="M2 38.5h124v43.71H64v7.29H36.44v-7.29H2zm6.89 36.43h13.78V53.07h6.89v21.86h6.89V45.79H8.89zm34.44-29.14v36.42h13.78v-7.28h13.78V45.79zm13.78 7.29H64v14.56h-6.89zm20.67-7.29v29.14h13.78V53.07h6.89v21.86h6.89V53.07h6.89v21.86h6.89V45.79z"
      ></path>
    </svg>
  );
};

const YarnIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#2c8ebb"
        d="M64 0a64 64 0 1 0 64 64A64 64 0 0 0 64 0Zm4.685 21.948a5.037 5.037 0 0 1 2.21.802c.671.444 1.528 1.032 4.026 6.194a4.841 4.841 0 0 1 2.942-.103 3.933 3.933 0 0 1 2.468 2.004c2.55 4.893 2.889 13.614 1.774 19.22a34.89 34.89 0 0 1-6.028 13.74 26.56 26.56 0 0 1 5.957 9.733 26.24 26.24 0 0 1 1.456 10.746 29.626 29.626 0 0 0 3.22-1.796c3.158-1.951 7.927-4.894 13.615-4.966a6.834 6.834 0 0 1 7.225 5.885 6.555 6.555 0 0 1-5.046 7.256c-3.458.836-5.069 1.486-9.714 4.5a69.161 69.161 0 0 1-16.062 7.412 8.991 8.991 0 0 1-3.758 1.828c-3.933.96-17.425 1.682-18.488 1.682h-.248c-4.13 0-6.47-1.28-7.73-2.621-3.51 1.755-8.052 1.03-11.355-.714a5.729 5.729 0 0 1-3.097-4.024 6.194 6.194 0 0 1 0-2.127 6.875 6.875 0 0 1-.816-1.032 16.908 16.908 0 0 1-2.333-10.386c.3-3.85 2.964-7.287 4.698-9.114A29.481 29.481 0 0 1 35.726 64a27.685 27.685 0 0 1 7.04-9.29c-1.703-2.87-3.436-7.288-1.754-11.789 1.208-3.21 2.199-4.996 4.377-5.76a7.06 7.06 0 0 0 2.59-1.383 18.22 18.22 0 0 1 12.243-5.843c.196-.495.423-1.033.671-1.508 1.652-3.51 3.406-5.48 5.46-6.193a5.037 5.037 0 0 1 2.332-.286zm-.558 3.697c-2.703.089-5.355 8.099-5.355 8.099a14.452 14.452 0 0 0-12.089 4.645 9.951 9.951 0 0 1-3.973 2.345c-.424.144-.94.122-2.22 3.58-1.961 5.234 3.345 11.16 3.345 11.16s-6.328 4.47-8.672 10.034a25.58 25.58 0 0 0-1.806 12.057s-4.5 3.901-4.788 7.927a13.285 13.285 0 0 0 1.826 8.083 2.003 2.003 0 0 0 2.714.94s-2.993 3.487-.196 4.963c2.55 1.331 6.844 2.065 9.115-.196 1.652-1.651 1.982-5.335 2.591-6.842.144-.351.64.588 1.115 1.032a10.323 10.323 0 0 0 1.403 1.032s-4.024 1.734-2.373 5.688c.547 1.31 2.498 2.145 5.688 2.125 1.187 0 14.203-.743 17.671-1.58a4.47 4.47 0 0 0 2.696-1.505 65.032 65.032 0 0 0 15.99-7.226c4.892-3.19 6.895-4.059 10.848-4.998 3.262-.774 3.045-5.83-1.28-5.758-4.48.052-8.402 2.363-11.716 4.427-6.193 3.83-9.29 3.583-9.29 3.583l-.105-.175c-.423-.692 1.983-6.896-.712-14.287-2.91-8.082-7.534-10.033-7.163-10.653 1.58-2.673 5.534-6.917 7.113-14.824.94-4.79.691-12.676-1.435-16.805-.393-.764-3.902 1.28-3.902 1.28s-3.283-7.319-4.201-7.907a1.442 1.442 0 0 0-.839-.244z"
      ></path>
    </svg>
  );
};

const BunIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path d="M113.744 41.999a18.558 18.558 0 0 0-.8-.772c-.272-.246-.528-.524-.8-.771s-.528-.525-.8-.771c-.272-.247-.528-.525-.8-.772s-.528-.524-.8-.771-.528-.525-.8-.772-.528-.524-.8-.771c7.936 7.52 12.483 17.752 12.656 28.481 0 25.565-26.912 46.363-60 46.363-18.528 0-35.104-6.526-46.128-16.756l.8.772.8.771.8.772.8.771.8.772.8.771.8.771c11.008 10.662 27.952 17.527 46.928 17.527 33.088 0 60-20.797 60-46.285 0-10.893-4.864-21.215-13.456-29.33z"></path>
      <path
        fill="#fbf0df"
        d="M116.8 65.08c0 23.467-25.072 42.49-56 42.49s-56-19.023-56-42.49c0-14.55 9.6-27.401 24.352-35.023C43.904 22.435 53.088 14.628 60.8 14.628S75.104 21 92.448 30.058C107.2 37.677 116.8 50.53 116.8 65.08Z"
      ></path>
      <path
        fill="#f6dece"
        d="M116.8 65.08a32.314 32.314 0 0 0-1.28-8.918c-4.368 51.377-69.36 53.846-94.912 38.48 11.486 8.584 25.66 13.144 40.192 12.928 30.88 0 56-19.054 56-42.49z"
      ></path>
      <path
        fill="#fffefc"
        d="M39.248 27.234c7.152-4.135 16.656-11.896 26-11.911a15.372 15.372 0 0 0-4.448-.695c-3.872 0-8 1.93-13.2 4.83-1.808 1.018-3.68 2.144-5.664 3.317-3.728 2.222-8 4.736-12.8 7.251C13.904 37.972 4.8 51.071 4.8 65.08v1.836c9.696-33.033 27.312-35.547 34.448-39.682z"
      ></path>
      <path
        fill="#ccbea7"
        d="M56.192 18.532A24.553 24.553 0 0 1 53.867 29.1a25.407 25.407 0 0 1-6.683 8.671c-.448.386-.096 1.127.48.91 5.392-2.02 12.672-8.068 9.6-20.272-.128-.695-1.072-.51-1.072.123zm3.632 0a24.474 24.474 0 0 1 3.646 10.12c.445 3.587.08 7.224-1.07 10.662-.192.54.496 1.003.88.556 3.504-4.32 6.56-12.899-2.592-22.156-.464-.4-1.184.216-.864.756zm4.416-.262a25.702 25.702 0 0 1 7.521 7.925A24.71 24.71 0 0 1 75.2 36.414c-.016.13.02.26.101.365a.543.543 0 0 0 .718.117.509.509 0 0 0 .221-.313c1.472-5.384.64-14.564-11.472-19.332-.64-.246-1.056.587-.528.957zM34.704 34.315a27.418 27.418 0 0 0 9.91-5.222 26.262 26.262 0 0 0 6.842-8.663c.288-.556 1.2-.34 1.056.277-2.768 12.343-12.032 14.92-17.792 14.58-.608.016-.592-.802-.016-.972z"
      ></path>
      <path d="M60.8 111.443c-33.088 0-60-20.798-60-46.363 0-15.429 9.888-29.823 26.448-38.448 4.8-2.469 8.912-4.953 12.576-7.128 2.016-1.203 3.92-2.33 5.76-3.379C51.2 12.916 56 10.771 60.8 10.771c4.8 0 8.992 1.852 14.24 4.845 1.6.88 3.2 1.836 4.912 2.885 3.984 2.376 8.48 5.06 14.4 8.131 16.56 8.625 26.448 23.004 26.448 38.448 0 25.565-26.912 46.363-60 46.363zm0-96.814c-3.872 0-8 1.928-13.2 4.829-1.808 1.018-3.68 2.144-5.664 3.317-3.728 2.222-8 4.736-12.8 7.251C13.904 37.972 4.8 51.071 4.8 65.08c0 23.436 25.12 42.506 56 42.506s56-19.07 56-42.506c0-14.01-9.104-27.108-24.352-35.023-6.048-3.086-10.768-5.986-14.592-8.27-1.744-1.033-3.344-1.99-4.8-2.838-4.848-2.778-8.384-4.32-12.256-4.32z"></path>
      <path
        fill="#b71422"
        d="M72.08 76.343c-.719 2.839-2.355 5.383-4.672 7.267a11.07 11.07 0 0 1-6.4 2.9 11.13 11.13 0 0 1-6.608-2.9c-2.293-1.892-3.906-4.436-4.608-7.267a1.073 1.073 0 0 1 .05-.5 1.11 1.11 0 0 1 .272-.428 1.19 1.19 0 0 1 .958-.322h19.744a1.185 1.185 0 0 1 .947.33 1.073 1.073 0 0 1 .317.92z"
      ></path>
      <path
        fill="#ff6164"
        d="M54.4 83.733a11.24 11.24 0 0 0 6.592 2.932 11.239 11.239 0 0 0 6.576-2.932 16.652 16.652 0 0 0 1.6-1.65 10.904 10.904 0 0 0-3.538-2.564 11.26 11.26 0 0 0-4.302-1 10.121 10.121 0 0 0-4.549 1.192 9.71 9.71 0 0 0-3.451 3.097c.368.323.688.632 1.072.925z"
      ></path>
      <path d="M54.656 82.514a8.518 8.518 0 0 1 2.97-2.347 8.836 8.836 0 0 1 3.734-.862 9.78 9.78 0 0 1 6.4 2.608c.368-.386.72-.787 1.056-1.188-2.035-1.87-4.726-2.933-7.536-2.978a10.487 10.487 0 0 0-4.335.975 10.125 10.125 0 0 0-3.489 2.666c.378.396.779.772 1.2 1.126z"></path>
      <path d="M60.944 87.436a12.078 12.078 0 0 1-7.12-3.086c-2.477-2.02-4.22-4.75-4.976-7.791-.054-.27-.045-.55.027-.817a1.83 1.83 0 0 1 .389-.726 2.25 2.25 0 0 1 .81-.595 2.32 2.32 0 0 1 .998-.192h19.744c.343-.007.683.06.996.196a2.3 2.3 0 0 1 .812.591c.182.212.313.46.382.728.07.267.076.545.018.815-.756 3.042-2.5 5.771-4.976 7.791a12.078 12.078 0 0 1-7.104 3.086zm-9.872-11.417c-.256 0-.32.108-.336.139.676 2.638 2.206 4.999 4.368 6.742a10.122 10.122 0 0 0 5.84 2.7 10.207 10.207 0 0 0 5.84-2.67c2.155-1.745 3.679-4.106 4.352-6.741a.333.333 0 0 0-.14-.113.348.348 0 0 0-.18-.026z"></path>
      <path
        fill="#febbd0"
        d="M85.152 77.3c5.17 0 9.36-2.377 9.36-5.308s-4.19-5.307-9.36-5.307c-5.17 0-9.36 2.376-9.36 5.307 0 2.931 4.19 5.307 9.36 5.307zm-48.432 0c5.17 0 9.36-2.377 9.36-5.308s-4.19-5.307-9.36-5.307c-5.17 0-9.36 2.376-9.36 5.307 0 2.931 4.19 5.307 9.36 5.307z"
      ></path>
      <path d="M41.12 69.863a9.052 9.052 0 0 0 4.902-1.425 8.578 8.578 0 0 0 3.254-3.812 8.22 8.22 0 0 0 .508-4.913 8.41 8.41 0 0 0-2.408-4.357 8.92 8.92 0 0 0-4.514-2.33 9.12 9.12 0 0 0-5.096.48 8.755 8.755 0 0 0-3.96 3.131 8.287 8.287 0 0 0-1.486 4.725c0 2.252.927 4.412 2.577 6.005 1.65 1.594 3.888 2.492 6.223 2.496zm39.632 0a9.054 9.054 0 0 0 4.915-1.403 8.582 8.582 0 0 0 3.275-3.802 8.22 8.22 0 0 0 .528-4.917 8.408 8.408 0 0 0-2.398-4.368 8.92 8.92 0 0 0-4.512-2.344 9.12 9.12 0 0 0-5.103.473 8.756 8.756 0 0 0-3.967 3.13 8.287 8.287 0 0 0-1.49 4.73c-.004 2.245.914 4.4 2.555 5.994 1.64 1.593 3.869 2.495 6.197 2.507z"></path>
      <path
        fill="#fff"
        d="M38.4 61.902a3.4 3.4 0 0 0 1.844-.531c.547-.35.974-.847 1.227-1.43a3.088 3.088 0 0 0 .195-1.847 3.16 3.16 0 0 0-.902-1.639 3.351 3.351 0 0 0-1.696-.878 3.426 3.426 0 0 0-1.916.179 3.29 3.29 0 0 0-1.489 1.176 3.113 3.113 0 0 0-.559 1.776c0 .844.347 1.654.964 2.253a3.374 3.374 0 0 0 2.332.94zm39.632 0a3.4 3.4 0 0 0 1.844-.531c.547-.35.974-.847 1.227-1.43a3.088 3.088 0 0 0 .195-1.847 3.16 3.16 0 0 0-.902-1.639 3.351 3.351 0 0 0-1.696-.878 3.426 3.426 0 0 0-1.916.179 3.29 3.29 0 0 0-1.489 1.176 3.113 3.113 0 0 0-.559 1.776c0 .84.342 1.644.953 2.242.61.598 1.44.94 2.311.952z"
      ></path>
    </svg>
  );
};

const OpenshiftIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="scale(0.5) translate(0,25)">
        <path
          d="M74.8392681,106.892926 L33.9714147,121.763314 C34.4958336,128.315376 35.6233978,134.787442 37.211892,141.128721 L76.0290516,126.992265 C74.7846677,120.440203 74.3402448,113.672278 74.8481566,106.891656"
          fill="#DA2430"
        ></path>
        <path
          d="M255.444071,61.7023618 C252.593416,55.8232827 249.297068,50.1410194 245.477572,44.7863591 L204.621146,59.656747 C209.37647,64.5200025 213.363578,69.9864033 216.628181,75.8324681 L255.445341,61.6998222 L255.444071,61.7023618 L255.444071,61.7023618 Z"
          fill="#DA2430"
        ></path>
        <path
          d="M182.950275,61.4614413 C177.809695,57.0005792 172.004032,53.1510662 165.54165,50.1365752 L165.53911,50.1365752 C127.598099,32.4485466 82.3304594,48.904889 64.6424308,86.8585985 C63.6454901,89.0001513 62.7625611,91.1647155 61.9886006,93.3462151 C59.7809164,99.7692657 58.4912936,106.33609 57.9978533,112.89241 L57.8539295,112.9456 C57.8501633,112.993635 57.8464406,113.04167 57.8427616,113.089704 L33.2472215,122.039512 L17.4207366,127.888513 C17.418462,127.859314 17.416198,127.830115 17.4139447,127.800914 L16.9799873,127.958822 C15.443554,108.523577 18.7195851,88.4470927 27.5331247,69.5476944 C28.6870135,67.0724846 29.9171924,64.6566205 31.2195686,62.3015921 C60.2738161,8.1856616 126.383568,-14.4341613 182.138317,11.9725342 C193.678037,17.4404824 203.911047,24.6094357 212.694536,33.045511 C218.60401,38.5121214 223.878405,44.5334969 228.475731,50.9860576 L187.616767,65.858985 C187.406509,65.6440827 187.194925,65.4302535 186.982018,65.2175172 L186.868906,65.2593348 C185.610426,63.9523602 184.30416,62.6849771 182.950275,61.4614413 Z"
          fill="#DA2430"
        ></path>
        <path
          d="M19.2613217,193.896477 L19.1968952,193.91993 C10.6957214,181.949719 4.50808591,168.501485 0.938735714,154.347253 L39.7635139,140.206988 L39.7660535,140.209528 C39.7740514,140.251306 39.7820838,140.293077 39.7901508,140.334841 L40.04226,140.241601 L40.0481026,140.257181 C42.0422662,150.817822 46.1933636,160.892394 52.2458245,169.750695 C54.5535333,173.043912 57.1321413,176.165653 59.9682455,179.077478 L59.8140535,179.133611 C59.9116663,179.236598 60.0095901,179.33933 60.1078243,179.441803 L19.6202948,194.412587 C19.500171,194.240851 19.380513,194.068813 19.2613217,193.896477 Z"
          fill="#E82429"
        ></path>
        <path
          d="M173.465486,183.446858 C152.413934,196.46429 125.412387,198.979252 101.351883,187.758961 C92.8405513,183.78963 85.425039,178.421002 79.2335941,172.064486 L38.4622439,186.908208 C38.5659908,187.054117 38.6700845,187.199805 38.7745245,187.345272 L38.754348,187.352733 C49.9644215,203.36935 65.2565512,216.75678 84.0211549,225.651222 C124.490455,244.814382 170.407927,238.152298 203.655476,212.3668 C218.543486,201.215294 230.971995,186.351361 239.368027,168.347841 C248.186646,149.452252 251.443631,129.383387 249.883072,109.963379 L248.747464,110.376585 C248.73211,110.168574 248.716217,109.960636 248.699785,109.752771 L208.210308,124.709923 L208.212255,124.713818 C207.567618,133.637473 205.349363,142.590341 201.405583,151.173176 C195.091199,164.926539 185.242012,175.882135 173.465486,183.446858 Z"
          fill="#DA2430"
        ></path>
        <path
          d="M218.552379,75.1291912 L219.159486,74.9081957 L219.159486,74.9069259 C225.546477,88.0491438 229.444701,102.334163 230.612897,116.962023 L189.840277,131.795587 C189.847816,131.694429 189.855149,131.593274 189.862274,131.492123 L189.091251,131.776983 C190.201352,116.689345 186.816517,101.683505 179.657339,88.6544234 L218.205113,74.4042308 L218.20706,74.4003358 C218.32299,74.6428972 218.438097,74.8858507 218.552379,75.1291912 Z"
          fill="#E82429"
        ></path>
        <path
          d="M74.8906707,106.654031 L34.309659,121.650133 C34.8296537,128.260104 35.9494925,134.786331 37.5289522,141.182071 L76.0747786,126.924088 C74.8283493,120.302432 74.3804137,113.486022 74.9062511,106.650136"
          fill="#C22035"
        ></path>
        <path
          d="M254.22692,61.0828228 C251.397136,55.1544934 248.121364,49.4248137 244.329492,44.0242691 L203.758218,59.0203718 C208.479069,63.9262397 212.43843,69.4377942 215.679146,75.334963 L254.221077,61.0789277 L254.22692,61.0828228 L254.22692,61.0828228 Z"
          fill="#C22035"
        ></path>
        <path
          d="M34.3084904,121.652665 L74.7901774,106.824052 L74.624636,114.957003 L35.5685526,129.705767 L34.3026478,121.642928 L34.3084904,121.652665 L34.3084904,121.652665 Z"
          fill="#AC223B"
        ></path>
        <path
          d="M203.766009,58.8974817 L244.8787,44.7894599 L249.151615,51.2377841 L209.205504,65.3594386 L203.771851,58.8935866 L203.766009,58.8974817 L203.766009,58.8974817 Z"
          fill="#AC223B"
        ></path>
        <path
          d="M38.7638909,187.20102 L79.2942665,172.452256 L91.5521198,184.016782 L49.0488803,199.973025 L38.7658385,187.197125 L38.7638909,187.20102 L38.7638909,187.20102 Z"
          fill="#B92135"
        ></path>
        <path
          d="M249.380647,109.861639 L208.215371,124.705833 L205.183043,141.184018 L249.074882,125.54133 L249.38649,109.863587 L249.380647,109.861639 L249.380647,109.861639 Z"
          fill="#B92135"
        ></path>
      </g>
    </svg>
  );
};

const HelmIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#0F1689"
        d="M35.5 30.5c-.2-.1-.3-.3-.5-.4-3.2-3.1-5.7-6.8-7.2-11.1-.4-1.2-.7-2.4-.7-3.7v-.4c.1-1.7 1.2-2.5 2.8-2.1.5.1 1 .3 1.4.6 1.8.9 3.2 2.2 4.5 3.7 2.3 2.5 4.2 5.5 5.5 8.7 0 .1.1.2.1.2s.1.1.2.1c6.2-3.8 13.3-6.1 20.6-6.5-.1-.2-.1-.4-.1-.6-.7-3.1-1-6.4-.7-9.6.1-1.9.5-3.8 1.1-5.7.3-1 .8-1.8 1.4-2.6.2-.3.5-.5.8-.7.6-.4 1.4-.4 2 0 .6.4 1.1 1 1.5 1.7.6 1.2 1.1 2.5 1.3 3.8.6 2.8.8 5.7.5 8.6-.1 1.7-.4 3.5-.9 5.2 1.8.3 3.6.6 5.4 1 1.8.4 3.5.9 5.2 1.6 1.7.6 3.4 1.4 5 2.2 1.6.8 3.1 1.8 4.7 2.7.1-.1.1-.2.2-.4 1.7-4.7 4.6-8.9 8.4-12.2.9-.8 1.9-1.4 3-1.8.3-.1.6-.2.9-.2 1.6-.2 2.3.8 2.4 2.1.1.9 0 1.8-.2 2.7-.6 2.3-1.5 4.4-2.7 6.4-1.7 2.9-3.8 5.4-6.4 7.5-.1.1-.2.1-.3.3 2.5 2.4 4.8 5.1 6.8 8-.2 0-.3.1-.4.1H93c-.3 0-.6-.2-.8-.4-5.9-6.6-13.8-10.8-22.4-12.1-2.5-.4-5.1-.5-7.7-.3-7.6.5-15 3.4-20.9 8.3-1.5 1.2-3 2.6-4.3 4.1-.2.3-.6.5-1 .5h-8.3c.2-.6 1.7-2.8 3.5-4.8 1.5-1.6 2.9-3 4.4-4.5zm65.4 58.9c-1.8 2.6-3.8 4.9-6.1 7.1.2.2.3.3.5.4 3.9 3.3 6.9 7.6 8.6 12.5.4 1.2.6 2.5.6 3.7 0 .3-.1.6-.2 1-.3.9-1.2 1.5-2.1 1.3-.6-.1-1.2-.3-1.7-.5-.8-.4-1.6-.9-2.3-1.5-3.8-3.2-6.7-7.4-8.4-12.1-.1-.1-.1-.3-.2-.5-2 1.4-4.1 2.6-6.3 3.6s-4.5 1.9-6.8 2.5c-2.4.6-4.7 1.1-7.2 1.4.1.2.1.4.1.6.8 3.1 1 6.3.8 9.5-.1 2-.5 3.9-1.1 5.8-.3.8-.7 1.5-1.1 2.3-.2.3-.4.5-.6.8-1 1.1-2.2 1.1-3.2 0-.4-.4-.7-.9-1-1.5-.8-1.5-1.2-3.1-1.5-4.8-.4-2.3-.5-4.6-.4-6.9.1-1.7.3-3.4.7-5 0-.1.1-.3.1-.4 0 0 0-.1-.1-.2-7.3-.4-14.3-2.6-20.6-6.5l-.3.6c-1.8 4.2-4.4 7.9-7.8 10.8-.9.8-1.9 1.4-3 1.8-.5.2-1.1.3-1.6.2-.6-.1-1.1-.5-1.4-1.2-.4-.9-.3-1.8-.2-2.7.2-1.3.6-2.5 1.1-3.7 1.5-3.7 3.9-7 6.7-9.8.1-.1.2-.2.4-.3 0-.1.1-.1.1-.2-2.7-2.4-5.2-5.1-7.2-8.1.3 0 .4-.1.6-.1h8c.4 0 .7.2.9.4 2.9 3.1 6.3 5.6 10 7.5 3.9 2.1 8.2 3.4 12.6 3.8 12 1.2 22.3-2.5 30.9-11.1.4-.4.9-.7 1.5-.6h8.1l.1.1zm-11.1-39c.7 0 1.4.1 2.1 0 .8-.1 1.3.2 1.9.7 3.2 3 6.4 6 9.7 9l.5.5c.2-.2.4-.3.6-.5 3.3-3.1 6.7-6.2 9.9-9.3.3-.3.7-.4 1.1-.4h2.5v27.4c-.4.1-6.3.2-7 0V63.9l-.1-.1c-2.3 2.1-4.6 4.3-6.9 6.4-2.3-2.2-4.6-4.3-7-6.4l-.1.1v14h-7c-.2-.5-.3-25.9-.2-27.5zm-64.2 0h6.9c.2.5.2 26.8 0 27.4h-6.9c-.1-1.7 0-3.5 0-5.2v-5.2H17v10.3c-.5.2-6.4.2-7 0V50.4h7v9.7c.5.2 7.8.2 8.6 0v-9.7zm15.2 27.4V50.5c.4-.1 15.6-.2 16.6-.1v5.8c-.2 0-.5.1-.7.1h-8.9v4.5h8.5v6h-8.4c-.2.5-.2 4.1-.1 5.1.2 0 .5.1.7.1h8.9v5.8H40.8zm24.6 0c-.1-.7-.1-26.9 0-27.4h6.9v20.2c.3 0 .5 0 .8.1H82v7.2l-16.6-.1z"
      ></path>
    </svg>
  );
};

const XUnitIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="matrix(0.046,0,0,-0.046,4,124)">
        <path
          d="M460 2335 l-225 -225 355 -355 355 -355 -353 -353 -352 -352 225
    -225 225 -225 354 354 353 353 349 -345 c192 -190 353 -349 357 -353 4 -4 109
    93 232 216 l225 225 -356 356 -355 355 354 351 355 350 -227 227 -226 226
    -350 -350 c-192 -193 -353 -350 -357 -350 -6 0 -595 577 -708 694 -3 3 -107
    -96 -230 -219z m552 -482 l388 -388 388 388 387 387 33 -32 32 -33 -387 -387
    -388 -388 388 -388 388 -388 -29 -27 c-15 -15 -32 -27 -38 -27 -5 0 -180 171
    -389 380 -209 209 -384 380 -390 380 -5 0 -182 -172 -392 -382 l-383 -383 -32
    33 -33 34 390 384 389 385 -389 389 -389 389 29 31 c16 16 31 30 34 30 3 0
    180 -174 393 -387z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

const MoqIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="matrix(0.064,0,0,-0.064,0,128)">
        <path
          d="M855 1991 c-220 -36 -405 -130 -560 -286 -133 -132 -219 -283 -267
    -467 -32 -120 -31 -357 0 -474 78 -289 258 -518 512 -648 574 -295 1267 17
    1426 641 31 124 40 255 24 368 -58 416 -353 746 -755 846 -89 22 -298 33 -380
    20z m-408 -692 c21 -8 42 -7 79 1 43 11 56 10 85 -4 61 -29 64 -40 67 -264 3
    -147 0 -207 -8 -218 -15 -18 -74 -18 -89 -1 -6 9 -12 84 -13 203 -3 160 -5
    189 -18 189 -13 0 -16 -31 -20 -200 l-5 -200 -40 0 -40 0 -5 200 c-5 180 -7
    200 -22 203 -17 3 -18 -11 -18 -190 0 -208 -2 -218 -51 -218 -61 0 -59 -6 -59
    211 0 227 7 260 62 284 40 17 58 18 95 4z m629 -15 c20 -9 48 -35 62 -57 25
    -37 27 -50 30 -164 3 -110 1 -128 -18 -168 -31 -64 -92 -99 -174 -99 -70 1
    -111 18 -150 64 -36 43 -41 68 -41 200 1 123 9 153 58 198 56 52 154 63 233
    26z m529 -18 c61 -47 75 -89 75 -219 0 -77 -5 -126 -14 -149 -14 -33 -87 -108
    -105 -108 -35 0 -11 -84 30 -106 25 -13 29 -20 29 -59 0 -42 -2 -45 -27 -45
    -69 0 -143 79 -158 170 -4 25 -15 41 -37 55 -17 11 -45 37 -62 58 -30 38 -31
    43 -34 154 -2 63 -1 130 3 149 8 44 49 92 100 116 58 27 153 20 200 -16z"
          fill="#000000"
        />
        <path
          d="M944 1196 c-17 -8 -34 -21 -38 -31 -10 -26 -7 -214 4 -235 12 -22 64
    -42 88 -33 47 17 52 30 52 153 0 99 -3 119 -17 132 -28 24 -55 28 -89 14z"
          fill="#000000"
        />
        <path
          d="M1435 1175 c-23 -22 -25 -31 -25 -128 0 -90 3 -108 21 -131 16 -20
    29 -26 59 -26 30 0 43 6 59 26 18 23 21 41 21 131 0 97 -2 106 -25 128 -15 16
    -36 25 -55 25 -19 0 -40 -9 -55 -25z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

const CypressIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <defs>
        <linearGradient
          id="b"
          x1="323.384"
          x2="56.936"
          y1="12.396"
          y2="577.503"
          gradientTransform="translate(-.876 -.754) scale(.13472)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#69d3a7"></stop>
          <stop offset=".823" stop-color="#2ab586"></stop>
          <stop offset="1" stop-color="#1cae7f"></stop>
        </linearGradient>
        <linearGradient
          id="a"
          x1="992.991"
          x2="568.87"
          y1="483.702"
          y2="758.304"
          gradientTransform="translate(-.876 -.754) scale(.13472)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".081" stop-color="#69d3a7"></stop>
          <stop offset="1" stop-color="#69d3a7" stop-opacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="c"
          x1="5.828"
          x2="704.494"
          y1="697.848"
          y2="917.116"
          gradientTransform="translate(-.876 -.754) scale(.13472)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".077" stop-color="#1cae7f"></stop>
          <stop offset=".164" stop-color="#1ca379"></stop>
          <stop offset=".316" stop-color="#1c8568"></stop>
          <stop offset=".516" stop-color="#1b554d"></stop>
          <stop offset=".719" stop-color="#1b1e2e"></stop>
        </linearGradient>
      </defs>
      <path
        d="M44.984 50.817c5.173 0 9.377 2.762 11.532 7.558l.162.378 8.676-2.95-.175-.445c-3.355-8.192-11.101-13.27-20.195-13.27-6.4 0-11.6 2.047-15.897 6.264-4.271 4.19-6.427 9.458-6.427 15.655 0 6.157 2.17 11.397 6.427 15.574 4.297 4.217 9.498 6.264 15.897 6.264 9.094 0 16.827-5.092 20.195-13.27l.175-.444-8.69-2.95-.148.39c-1.94 4.729-6.251 7.544-11.532 7.544-3.597 0-6.642-1.253-9.04-3.732-2.439-2.505-3.665-5.671-3.665-9.376 0-3.732 1.2-6.83 3.665-9.458 2.411-2.479 5.443-3.732 9.04-3.732z"
        className="st0"
      ></path>
      <path
        fill="url(#a)"
        d="m82.652 125.13-2.586-8.528c23.334-7.086 39.015-28.224 39.015-52.595 0-6.723-1.199-13.297-3.57-19.522l8.326-3.166A63.468 63.468 0 0 1 128 64.02c-.013 28.305-18.228 52.865-45.348 61.11Z"
      ></path>
      <path
        fill="#69d3a7"
        d="M116.67 47.894C109.543 24.641 88.378 9.026 63.993 9.026a56.039 56.039 0 0 0-9.861.876l-1.577-8.77A64.836 64.836 0 0 1 63.993.108c28.319 0 52.906 18.147 61.191 45.159z"
      ></path>
      <path
        fill="url(#b)"
        d="M4.096 86.532C1.374 79.338 0 71.753 0 64.007 0 31 24.776 3.664 57.634.43l.876 8.865C30.232 12.085 8.905 35.607 8.905 64.006a54.82 54.82 0 0 0 3.516 19.387z"
      ></path>
      <path
        d="M64.33 42.896 81.79 85.63l-12.718 30.85 8.905 1.779 30.96-75.364h-9.62l-12.353 31.31-12.449-31.31z"
        className="st0"
      ></path>
      <path
        fill="url(#c)"
        d="m70.675 112.601-1.872 4.54c-.431 1.038-1.415 1.752-2.52 1.792-.767.027-1.522.054-2.303.054-24.452 0-46.224-16.369-52.946-39.81l-8.569 2.451c7.814 27.228 33.102 46.25 61.501 46.264h.014c.889 0 1.778-.013 2.667-.054 4.567-.188 8.65-3.058 10.4-7.302l2.534-6.156z"
      ></path>
    </svg>
  );
};

const SeleniumIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#CF0A2C"
        d="M83.1 80.5c-4.7-.1-8.8 3.4-9.3 8.1 0 .2.1.3.3.3h18c.2 0 .3-.1.3-.3-.4-4.8-4.5-8.4-9.3-8.1z"
      ></path>
      <path
        fill="#CF0A2C"
        d="M121.7 19.9l-38.4 43c-.4.5-1.2.5-1.7.1l-.1-.1-19.4-20.1c-.4-.4-.4-1-.1-1.5l6.5-8.3c.4-.5 1.1-.7 1.6-.3.1.1.2.1.2.2l11 12.1c.4.5 1.2.5 1.7.1l.1-.1 30.7-41.7c.3-.4.2-.9-.2-1.2-.1-.1-.3-.1-.5-.2H5.7c-.5.1-.9.5-.9 1v122.2c0 .5.4.9.9.9h116.6c.5 0 .9-.4.9-.9V20.5c0-.5-.4-.8-.8-.8-.3-.1-.5 0-.7.2zm-83.8 92.5c-7.7.3-15.2-2.3-20.9-7.4-.4-.4-.5-1-.1-1.5l4.5-6.4c.4-.5 1.1-.6 1.6-.3l.1.1c4.2 3.9 9.6 6 15.3 6 6 0 8.9-2.8 8.9-5.7 0-9.1-29.5-2.8-29.5-22.1 0-8.5 7.4-15.6 19.4-15.6 6.9-.2 13.7 2.1 19.1 6.5.4.4.5 1.1.1 1.5l-4.7 6.2c-.4.5-1.1.6-1.6.2-4-3.2-8.9-4.9-14-4.8-4.7 0-7.3 2.1-7.3 5.1 0 8.1 29.4 2.7 29.4 21.8.1 9.3-6.6 16.4-20.3 16.4zm64.3-17.8c0 .6-.5 1-1 1H74.3c-.2 0-.3.1-.3.3.9 5.2 5.6 8.8 10.9 8.5 3.4-.1 6.6-1.1 9.3-3.1.4-.3 1.1-.3 1.4.2l.1.1 3.3 4.8c.3.4.2 1-.2 1.4-4.3 3.2-9.6 4.8-14.9 4.6-11.6 0-20.3-7.8-20.3-20-.3-10.7 8.1-19.6 18.8-19.9h.9c11.3 0 19.1 8.5 19.1 20.9l-.2 1.2z"
      ></path>
    </svg>
  );
};

const ReduxIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#764abc"
        d="M88.69 88.11c-9 18.4-24.76 30.78-45.61 34.85a39.73 39.73 0 0 1-9.77 1.14c-12 0-23-5-28.34-13.19C-2.2 100-4.64 76.87 19 59.76c.48 2.61 1.46 6.19 2.11 8.31A38.24 38.24 0 0 0 10 81.1c-4.4 8.64-3.91 17.27 1.3 25.25 3.6 5.38 9.3 8.65 16.63 9.65a44 44 0 0 0 26.55-5c12.71-6.68 21.18-14.66 26.72-25.57a9.32 9.32 0 0 1-2.61-6A9.12 9.12 0 0 1 87.37 70h.34a9.15 9.15 0 0 1 1 18.25zm28.67-20.2c12.21 13.84 12.54 30.13 7.82 39.58-4.4 8.63-16 17.27-31.6 17.27a50.48 50.48 0 0 1-21-5.05c2.29-1.63 5.54-4.24 7.33-5.87a41.54 41.54 0 0 0 16 3.42c10.1 0 17.75-4.72 22.31-13.35 2.93-5.7 3.1-12.38.33-19.22a43.61 43.61 0 0 0-17.27-20.85 62 62 0 0 0-34.74-10.59h-2.93a9.21 9.21 0 0 1-8 5.54h-.31a9.13 9.13 0 0 1-.3-18.25h.33a9 9 0 0 1 8 4.89h2.61c20.8 0 39.06 7.98 51.42 22.48zm-82.75 23a7.31 7.31 0 0 1 1.14-4.73c-9.12-15.8-14-35.83-6.51-56.68C34.61 13.83 48.13 3.24 62.79 3.24c15.64 0 31.93 13.69 33.88 40.07-2.44-.81-6-2-8.14-2.44-.53-8.63-7.82-30.13-25.09-29.81-6.19.17-15.31 3.1-20 9.12a43.69 43.69 0 0 0-9.64 25.25 59.61 59.61 0 0 0 8.47 36.16 2.75 2.75 0 0 1 1.14-.16h.32a9.121 9.121 0 0 1 .33 18.24h-.33a9.16 9.16 0 0 1-9.12-8.79z"
      ></path>
    </svg>
  );
};

const MobXIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#ea6618"
        fillOpacity="1"
        d="M128 118.195V9.805c0-4.45-2.96-8.2-7.02-9.403l-4.605 2.758-51.133 54.52-1.605 5.011-.934 4.809 15.945 59.59 2.465.91h37.082c5.414 0 9.805-4.39 9.805-9.805"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#d65813"
        fillOpacity="1"
        d="M0 9.805v108.39a9.79 9.79 0 0 0 4.25 8.078l3.145-1.503 54.12-57.95 2.122-4.129.082-3.996-14.73-56.043L46.757 0H9.805C4.39 0 0 4.39 0 9.805"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#e05e11"
        fillOpacity="1"
        d="M63.637 62.691 120.98.402A9.778 9.778 0 0 0 118.195 0H46.758Zm0 0"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#de5c16"
        fillOpacity="1"
        d="M9.805 128h71.308L63.637 62.691 4.25 126.273A9.74 9.74 0 0 0 9.805 128"
      ></path>
      <path
        stroke="none"
        fillRule="nonzero"
        fill="#fff"
        fillOpacity="1"
        d="M47.46 48.516h7.11c2.836 10.691 6.063 20.074 9.66 28.543 4.075-9.528 7.063-18.918 9.59-28.543h6.723c-3.012 11.96-7.934 24.02-13.566 36.464H61.03c-5.41-11.793-10.015-23.918-13.57-36.464ZM24 29.988h15.813v67.817H23.93v-5.227h9.734V35.074H24Zm80.082 5.086h-9.664v57.504h9.734v5.227H88.27V29.988h15.812Zm0 0"
      ></path>
    </svg>
  );
};

const NgRx = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path fill="#412846" d="M64.1 1.4L5.6 21.7 14 99.3l50.1 27.3z"></path>
      <path fill="#4b314f" d="M63.9 1.4l58.5 20.3-8.4 77.6-50.1 27.3z"></path>
      <path
        fill="#ba2bd2"
        d="M93.2 44.3l-.1-.1q4 4.5 4.2 10.6.1 6.1-4.2 12.9 3.2-2.5 7.4-10.6 1.8 16.5-13.5 25.1 4.9-.4 12.9-6.4-8.5 20.6-31.4 21.7c-14.8 0-24.3-8.8-24.3-8.8q-9.1-7.1-12.5-17.9c-3.7-3.9-3.7-4.3-4.1-5.9-.3-1.6.3-2.1 1.3-3.6q1.1-1.6.5-4.4-1.3-1.9-1.5-5.9 0-2 2.6-4.1 2.6-2.2 3.1-3.3.5-.6.4-5.4-.1-4.7 5.2-5.1c5.2-.4 8.1-4.3 9.8-6.1 1.1-1.2 2.7-1.8 4.7-1.8 2.9-.1 5.5 1 7.8 3.3 5.6-.3 11.3 1.2 17.1 4.5Q91 40.3 92.2 48.9q-1.4 11.3-30.2-.6-15.1 4.3-14.9 18.5 0 13.1 12.7 19c-4.1-4-5.9-7.4-5.3-10.2Q67.3 90.8 83.6 87q-7.1.2-11.4-4.7Q83.2 82 93 72q-5.6 4.5-11.9 3.4 17-13.3 12.1-31.1zm-19-3.1c0-.9-.7-1.6-1.6-1.6-.9 0-1.7.7-1.7 1.6 0 .9.8 1.7 1.7 1.7.9 0 1.6-.8 1.6-1.7z"
      ></path>
    </svg>
  );
};

const PostmanIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#f37036"
        d="M113.117 26.066C92.168-1.062 53.191-6.07 26.062 14.883c-27.125 20.953-32.128 59.93-11.175 87.055 20.957 27.124 59.937 32.124 87.058 11.167 27.114-20.953 32.118-59.918 11.172-87.039Zm0 0"
      ></path>
      <path
        fill="#fff"
        d="M91.078 24.164a10.038 10.038 0 0 0-5.781 2.426 10.028 10.028 0 0 0-1.54 13.465 10.028 10.028 0 0 0 13.276 2.715h.002v.001l.156.155a10.63 10.63 0 0 0 1.965-1.45A10.341 10.341 0 0 0 99 27.107v-.002l-8.844 8.789-.156-.155 8.844-8.793a10.038 10.038 0 0 0-7.766-2.78zM79.434 38.551c-4.24-.007-11.163 4.799-28.067 21.703l.084.086c-.092-.032-.185-.035-.185-.035l-6.364 6.308a1.035 1.035 0 0 0 .93 1.762l10.914-2.328a.307.307 0 0 0 .092-.17l.242.25-3.72 3.69h-.18l-22.086 22.26 7.086 6.824a1.254 1.254 0 0 0 1.476.149 1.327 1.327 0 0 0 .645-1.356l-1.035-4.5a.534.534 0 0 1 0-.62 117.285 117.285 0 0 0 26.738-17.583l-4.535-4.537.086-.014-2.69-2.689.172-.174.182.186-.094.091 7.137 7.293v-.003c13.68-12.954 23.39-23.367 20.865-30.375a3.83 3.83 0 0 0-1.107-2.208v.004a3.778 3.778 0 0 0-.483-.306c-.083-.088-.156-.178-.244-.264l-.066.066a3.778 3.778 0 0 0-.582-.29l.289-.292c-1.796-1.6-3.28-2.924-5.5-2.93zM30.94 92.21l-5.171 5.172v.004a1.03 1.03 0 0 0-.457 1.125 1.035 1.035 0 0 0 .921.789l12.672.875-7.965-7.965z"
      ></path>
      <path
        fill="#f37036"
        d="M91.95 23.31a11.047 11.047 0 0 0-7.759 3.17 10.988 10.988 0 0 0-2.39 11.641c-4.741-2.03-11.155 1.51-31.106 21.457a.932.932 0 0 0-.037.094 1.242 1.242 0 0 0-.119.062l-6.309 6.364a1.97 1.97 0 0 0-.363 2.324 2.012 2.012 0 0 0 1.707.984l.313-.203 8.424-1.797-4.03 4.067a.873.873 0 0 0-.054.166l-19.75 19.799a.798.798 0 0 0-.192.238l-5.086 5.09a1.967 1.967 0 0 0-.414 2.043 1.995 1.995 0 0 0 1.656 1.265l12.618.88a1.01 1.01 0 0 0 .52-.415.886.886 0 0 0 0-1.035l-.026-.025a2.243 2.243 0 0 0 .705-.58 2.237 2.237 0 0 0 .406-1.876l-.984-4.187a126.725 126.725 0 0 0 26.334-16.861 1.091 1.091 0 0 0 .248.103c.254-.019.492-.128.672-.308 13.55-12.83 21.515-21.622 21.515-28.602a8.03 8.03 0 0 0-.431-2.85 10.957 10.957 0 0 0 3.845.83l-.015.004a11.219 11.219 0 0 0 5.183-1.45.775.775 0 0 0 .004.001.835.835 0 0 0 .617-.055 9.398 9.398 0 0 0 2.07-1.652 10.873 10.873 0 0 0 3.258-7.758 10.873 10.873 0 0 0-3.257-7.758.93.93 0 0 0-.118-.091 11.045 11.045 0 0 0-7.656-3.078zm-.087 1.772a9.27 9.27 0 0 1 5.586 1.914l-8.068 8.117a.84.84 0 0 0-.076.098.83.83 0 0 0-.239.55.832.832 0 0 0 .313.65h.002l6.1 6.1a9.044 9.044 0 0 1-10.028-1.913c-2.586-2.6-3.336-6.504-1.953-9.891 1.383-3.39 4.68-5.605 8.363-5.625zm7.12 3.432a8.87 8.87 0 0 1 2.033 5.674 9.15 9.15 0 0 1-2.688 6.464 9.989 9.989 0 0 1-1.098.895L92.307 36.7l-.963-.963.265-.265 7.373-6.96zm-.366 4.193a.777.777 0 0 0-.55.031.731.731 0 0 0-.36.426.73.73 0 0 0 .05.559 2.226 2.226 0 0 1-.257 2.328.64.64 0 0 0-.195.488c.004.184.07.36.195.492a.58.58 0 0 0 .414 0 .68.68 0 0 0 .672-.207 3.573 3.573 0 0 0 .465-3.777v.004a.777.777 0 0 0-.434-.344zM79.34 39.43a5.584 5.584 0 0 1 3.31 1.226 4.756 4.756 0 0 0-2.681 1.34L57.162 64.701l-4.476-4.476c11.828-11.772 19.06-17.921 23.556-19.936a5.584 5.584 0 0 1 3.098-.86zm3.965 2.96a2.895 2.895 0 0 1 2.043.844 2.786 2.786 0 0 1 .879 2.121 2.869 2.869 0 0 1-.985 2.07l-24.25 21.106-2.617-2.617 22.887-22.68a2.895 2.895 0 0 1 2.043-.843zm2.994 6.698c-1.69 6.702-10.647 15.783-19.987 24.607l-3.777-3.773L86.3 49.088zM51.367 61.547l.274.27 3.513 3.513-9.63 2.06 5.843-5.843zm5.793 5.84.004.004 1.168 1.195a1.086 1.086 0 0 0 .018.084l.078.012.248.254.82.84-5.385.66 3.05-3.05zm3.867 4.076 3.578 3.576A126.992 126.992 0 0 1 38.75 91.695a1.44 1.44 0 0 0-.777 1.653l1.035 4.5a.31.31 0 0 1 0 .363.31.31 0 0 1-.414 0l-6.102-6.152L51.3 72.975l9.728-1.512zm-29.933 21.94.869.814 4.492 4.492-10.016-.648 4.655-4.659z"
      ></path>
    </svg>
  );
};

const StorybookIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        d="M107.346 2.012l-6.914.431.539 14.377c.028.795-.889 1.259-1.514.766l-4.63-3.65-5.485 4.162a.934.934 0 01-1.498-.784l.617-14.123L19.873 7.48a6.264 6.264 0 00-5.87 6.488l3.86 102.838a6.264 6.264 0 005.98 6.023l83.612 3.754a6.273 6.273 0 004.609-1.73 6.255 6.255 0 001.936-4.526V8.264a6.258 6.258 0 00-1.975-4.566 6.257 6.257 0 00-4.679-1.686zm-41.46 21.187c16.308 0 25.214 8.723 25.214 25.319-2.204 1.713-18.62 2.88-18.62.443.346-9.3-3.817-9.707-6.13-9.707-2.198 0-5.899.662-5.899 5.644 0 12.288 31.69 11.625 31.69 36.424 0 13.95-11.335 21.655-25.791 21.655-14.92 0-27.957-6.036-26.485-26.963.578-2.457 19.545-1.873 19.545 0-.23 8.635 1.735 11.175 6.707 11.175 3.817 0 5.553-2.103 5.553-5.646 0-12.621-31.227-13.063-31.227-36.201 0-13.285 9.138-22.143 25.444-22.143z"
        fill="#FF4785"
      ></path>
    </svg>
  );
};

const WebflowIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#4353ff"
        d="M.994.994v126.012h126.012V.994H.994zm71.92 41.715s3.988 30.056 3.988 31.443l5.785-18.12h-.04c2.552-6.86 7.579-13.323 17.152-13.323l-13.563 32.75a18.428 18.318 0 01-17.549 12.809s-3.99-28.153-3.99-28.788l-5.982 15.465c-2.673 6.86-7.857 13.323-17.43 13.323l-7.5-45.518a14.918 14.829 0 0114.479 13.44s.998 16.693.998 18.001l7.06-18.16c2.553-6.86 7.418-13.322 16.592-13.322z"
      ></path>
    </svg>
  );
};

const NginxIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="scale(4)">
        <path
          d="M15.948,2h.065a10.418,10.418,0,0,1,.972.528Q22.414,5.65,27.843,8.774a.792.792,0,0,1,.414.788c-.008,4.389,0,8.777-.005,13.164a.813.813,0,0,1-.356.507q-5.773,3.324-11.547,6.644a.587.587,0,0,1-.657.037Q9.912,26.6,4.143,23.274a.7.7,0,0,1-.4-.666q0-6.582,0-13.163a.693.693,0,0,1,.387-.67Q9.552,5.657,14.974,2.535c.322-.184.638-.379.974-.535"
          fill="#019639"
        />
        <path
          d="M8.767,10.538q0,5.429,0,10.859a1.509,1.509,0,0,0,.427,1.087,1.647,1.647,0,0,0,2.06.206,1.564,1.564,0,0,0,.685-1.293c0-2.62-.005-5.24,0-7.86q3.583,4.29,7.181,8.568a2.833,2.833,0,0,0,2.6.782,1.561,1.561,0,0,0,1.251-1.371q.008-5.541,0-11.081a1.582,1.582,0,0,0-3.152,0c0,2.662-.016,5.321,0,7.982-2.346-2.766-4.663-5.556-7-8.332A2.817,2.817,0,0,0,10.17,9.033,1.579,1.579,0,0,0,8.767,10.538Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

const Dynamics365Icon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="scale(5.333)">
        <path d="M15.805 11.322v4.889a2.536 2.536 0 0 1-1.643 2.374l-1.732.652a.507.507 0 0 1-.686-.475v-5.956l-3.392 1.239a1.015 1.015 0 0 0-.664.953v7.986c0 .705.7 1.195 1.363.953l10.161-3.713a2.535 2.535 0 0 0 1.666-2.382V7.696a2.537 2.537 0 0 1-1.666 2.381l-3.407 1.245Zm0-.532V9.323a2.537 2.537 0 0 0-1.645-2.375l-1.728-.65a.508.508 0 0 0-.686.475v4.59c0 .701-.695 1.191-1.355.956L3.795 9.963a1.015 1.015 0 0 1-.674-.956V1.015c0-.701.695-1.191 1.356-.955l14.718 5.256A2.538 2.538 0 0 1 20.83 7.21c-.136.861-1.05 2.128-1.79 2.398l-3.235 1.182Z" />
      </g>
    </svg>
  );
};

const HubSpotIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="scale(5.333)">
        <path d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z" />
      </g>
    </svg>
  );
};

const InfluxDbIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fillRule="evenodd"
        fill="#020a47"
        fillOpacity={1}
        d="m94.543 87.625 29.379-6.75a3.35 3.35 0 0 0 1.258-.543 3.358 3.358 0 0 0 1.383-2.305c.058-.46.019-.925-.114-1.37L113.957 22.34a3.499 3.499 0 0 0-1.59-2.14 3.49 3.49 0 0 0-2.633-.391l-29.37 6.75c-.887.23-1.65.8-2.118 1.593a3.452 3.452 0 0 0-.383 2.625L90.32 85.094a3.499 3.499 0 0 0 1.59 2.14c.79.477 1.738.618 2.633.391Zm-10.125 33.566 35.621-33.054c1.344-1.36 1.004-2.196-.844-1.528l-24.484 5.575a6.222 6.222 0 0 0-2.715 1.46 6.221 6.221 0 0 0-1.676 2.586l-7.425 23.954c-.508 1.855.168 2.363 1.523 1.007Zm-64.992-10.789 53.344 16.52c.91.172 1.851.012 2.656-.45a3.947 3.947 0 0 0 1.734-2.07l8.938-28.68a3.48 3.48 0 0 0 .117-1.378 3.492 3.492 0 0 0-.418-1.317 3.473 3.473 0 0 0-.89-1.058 3.562 3.562 0 0 0-1.227-.633L30.336 74.973a3.545 3.545 0 0 0-2.695.304 3.57 3.57 0 0 0-1.696 2.118l-8.879 28.62a3.556 3.556 0 0 0 .278 2.68 3.547 3.547 0 0 0 2.082 1.707ZM2.2 51.7l10.816 47.452c.336 1.856 1.207 1.856 1.68 0l7.425-23.949a6.709 6.709 0 0 0 .031-3.113 6.783 6.783 0 0 0-1.37-2.793L3.721 50.852c-1.183-1.395-2.066-1.008-1.523.847ZM43.906.973 3.046 38.875a3.47 3.47 0 0 0-.168 4.848l20.43 22.144a3.483 3.483 0 0 0 2.415 1.098 3.48 3.48 0 0 0 2.484-.926l40.848-37.965a3.446 3.446 0 0 0 .172-4.847L48.832 1.094A3.48 3.48 0 0 0 47.722.3a3.467 3.467 0 0 0-1.326-.3 3.419 3.419 0 0 0-1.34.238 3.435 3.435 0 0 0-1.149.735Zm39.496 85.804c1.864.508 3.035-.496 2.54-2.422L74.124 33.082c-.508-1.855-2.035-2.363-3.375-1.02L32.258 67.895c-1.352 1.343-1.016 2.859.836 3.367Zm20.09-71.515L56.898.972c-1.851-.511-2.187.169-.675 1.684l17.054 18.387a6.549 6.549 0 0 0 2.7 1.527 6.58 6.58 0 0 0 3.093.11l24.485-5.563c1.8-.508 1.8-1.355-.063-1.855Zm0 0"
      ></path>
    </svg>
  );
};

const JBossIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <g transform="matrix(0.014,0,0,-0.014,0,128)">
        <path d="M3222 7044 c-96 -48 -152 -151 -138 -257 24 -174 212 -276 367 -196 52 26 114 101 129 154 60 215 -159 398 -358 299z" />
        <path d="M2163 6939 c-64 -25 -131 -88 -163 -154 -34 -68 -34 -177 -2 -251 86 -193 338 -240 489 -92 61 60 88 126 87 218 -1 91 -25 150 -90 215 -81 81 -210 106 -321 64z" />
        <path d="M1154 6470 c-75 -30 -137 -89 -176 -168 -29 -59 -33 -76 -33 -147 1 -97 30 -170 95 -235 67 -67 138 -95 240 -95 74 0 92 4 143 30 74 37 139 109 167 183 29 76 25 195 -9 262 -31 61 -96 126 -156 158 -70 36 -197 41 -271 12z" />
        <path d="M2790 5205 c0 -414 -4 -651 -11 -684 -21 -101 -73 -145 -169 -145 -74 -1 -128 28 -159 83 -20 37 -23 57 -25 157 l-1 114 -222 0 -223 0 0 -84 c0 -186 41 -348 114 -455 105 -154 267 -223 526 -223 372 -1 577 150 630 460 5 30 8 -38 9 -190 l1 -238 468 0 c588 0 690 11 852 87 127 61 219 171 254 306 52 200 12 388 -108 505 -46 46 -137 102 -165 102 -19 0 -12 19 12 31 126 65 207 208 207 364 0 238 -160 394 -445 435 -41 6 -372 10 -807 10 l-738 0 0 -635z m1428 246 c125 -64 118 -253 -12 -312 -36 -16 -68 -19 -253 -19 l-213 0 0 178 0 178 218 -1 c202 -2 220 -3 260 -24z m55 -670 c70 -34 101 -85 105 -175 5 -101 -21 -150 -103 -191 l-60 -30 -237 -4 -238 -3 0 217 0 216 243 -3 c231 -3 244 -4 290 -27z" />
        <path d="M8632 5819 c-52 -26 -89 -72 -108 -134 -58 -196 189 -357 342 -223 108 95 101 262 -14 343 -58 40 -156 47 -220 14z m165 -24 c48 -20 71 -41 94 -87 61 -119 -28 -261 -162 -260 -61 1 -115 30 -149 79 -20 30 -25 49 -25 103 0 58 4 71 29 104 51 67 138 92 213 61z" />
        <path d="M8660 5631 c0 -92 3 -111 15 -111 11 0 15 12 15 49 0 42 3 49 18 46 9 -2 19 -4 22 -4 3 -1 16 -21 30 -46 15 -28 32 -45 43 -45 16 0 14 6 -13 44 -36 53 -36 52 -10 59 23 6 41 46 33 75 -6 26 -36 38 -100 41 l-53 2 0 -110z m121 63 c21 -25 -1 -49 -50 -52 -41 -3 -41 -3 -41 32 0 35 1 36 39 36 23 0 44 -6 52 -16z" />
        <path d="M555 5416 c-221 -54 -353 -285 -286 -504 34 -112 100 -189 211 -244 61 -31 71 -33 170 -33 99 0 110 2 172 33 329 162 290 634 -60 742 -72 22 -133 24 -207 6z" />
        <path d="M5375 5370 c-169 -27 -316 -108 -423 -234 -46 -55 -122 -196 -122 -228 0 -11 11 -38 24 -61 13 -23 34 -75 46 -115 19 -63 22 -90 18 -190 -3 -69 -12 -141 -22 -175 l-18 -59 37 -54 c97 -140 253 -240 430 -275 85 -17 251 -12 337 10 172 44 326 158 408 301 37 63 50 73 50 39 0 -38 59 -145 104 -192 113 -114 283 -168 531 -168 291 0 512 102 593 274 l19 41 21 -47 c28 -63 115 -148 188 -185 122 -60 228 -83 402 -83 369 -2 599 139 643 394 31 185 -67 346 -251 412 -25 9 -114 30 -199 46 -185 35 -220 44 -289 71 -112 44 -137 138 -49 185 45 25 209 25 254 0 39 -21 73 -63 80 -99 l6 -28 198 0 199 0 -6 43 c-17 107 -50 172 -124 241 -103 97 -256 140 -485 139 -319 -1 -539 -110 -588 -290 -11 -42 -27 -58 -27 -27 0 33 -52 122 -97 168 -93 92 -248 144 -453 151 -375 12 -637 -130 -658 -357 -2 -32 -8 -58 -11 -57 -3 0 -18 26 -33 57 -75 157 -250 295 -431 337 -81 19 -227 26 -302 15z m1531 -298 c40 -20 74 -69 74 -106 0 -14 23 -16 194 -16 l193 0 7 -47 c14 -106 80 -194 183 -246 75 -38 133 -55 346 -102 114 -26 216 -54 240 -67 106 -58 91 -173 -28 -224 -53 -23 -158 -23 -218 0 -60 23 -115 83 -123 136 l-7 40 -177 0 -177 0 -7 48 c-8 65 -49 143 -100 195 -68 68 -138 95 -351 138 -210 43 -276 62 -320 93 -43 29 -54 47 -55 84 0 42 36 78 94 91 67 16 185 8 232 -17z m-1340 -37 c120 -35 194 -175 194 -365 0 -232 -102 -372 -272 -372 -141 0 -231 101 -258 289 -27 187 35 373 145 431 64 33 120 38 191 17z m700 -341 c77 -56 153 -82 403 -139 213 -49 268 -70 294 -114 66 -113 -72 -220 -248 -191 -97 16 -171 83 -177 163 l-2 27 -189 0 c-175 0 -188 1 -183 18 18 61 26 120 26 217 l0 110 24 -35 c13 -19 37 -44 52 -56z" />
        <path d="M705 4206 c-222 -55 -374 -281 -337 -502 37 -222 223 -384 442 -384 221 0 407 162 442 384 48 312 -242 578 -547 502z" />
        <path d="M1730 3337 c-128 -46 -225 -131 -284 -248 -165 -330 75 -719 444 -719 134 0 247 47 346 145 100 99 147 212 146 355 0 224 -150 418 -367 476 -81 22 -209 18 -285 -9z" />
        <path d="M3186 3235 c-295 -75 -480 -379 -411 -674 47 -199 208 -366 400 -416 76 -19 211 -19 289 1 191 49 350 211 401 409 56 221 -40 471 -233 598 -37 25 -96 55 -132 67 -84 29 -231 36 -314 15z" />
        <path d="M4460 2955 l-35 -22 0 -277 0 -276 37 0 c27 0 38 4 38 15 0 19 3 19 47 -5 78 -42 168 -11 211 72 41 79 31 239 -20 303 -45 58 -131 71 -192 30 -20 -14 -39 -25 -42 -25 -3 0 -4 45 -3 100 2 55 1 101 -2 104 -2 2 -20 -6 -39 -19z m178 -216 c41 -14 64 -66 65 -144 1 -76 -17 -121 -55 -141 -37 -19 -78 -11 -118 23 -29 24 -30 27 -30 117 0 84 2 94 24 115 13 12 36 26 52 31 16 4 29 9 30 9 1 1 15 -4 32 -10z" />
        <path d="M6918 2957 l-37 -21 2 -78 c1 -43 1 -78 0 -78 -1 0 -21 10 -43 21 -81 42 -168 9 -211 -79 -34 -68 -33 -188 2 -258 29 -59 77 -94 130 -94 40 0 109 27 109 42 0 5 4 7 10 3 5 -3 7 -12 3 -20 -4 -12 5 -15 41 -15 l46 0 0 300 c0 165 -3 300 -7 299 -5 -1 -25 -11 -45 -22z m-103 -217 c7 0 27 -12 44 -26 30 -25 31 -27 31 -118 0 -83 -2 -95 -22 -114 -51 -47 -108 -50 -147 -8 -37 40 -45 158 -16 230 9 21 63 48 83 41 8 -3 20 -5 27 -5z" />
        <path d="M8438 2959 c-38 -19 -38 -19 -38 -84 l0 -65 -33 0 c-32 0 -33 -1 -29 -35 4 -31 8 -35 33 -35 l29 0 0 -156 0 -156 29 -29 c21 -21 39 -29 65 -29 60 0 83 14 88 54 2 20 3 36 2 36 0 0 -15 -5 -32 -11 -22 -7 -36 -7 -51 1 -20 10 -21 19 -21 150 l0 140 55 0 55 0 0 35 0 35 -55 0 -54 0 -3 84 -3 84 -37 -19z" />
        <path d="M5600 2671 l0 -291 40 0 40 0 0 115 0 116 68 -3 67 -3 56 -110 56 -110 46 -3 c26 -2 47 -1 47 3 0 3 -25 55 -55 115 -30 60 -55 112 -55 114 0 2 10 6 23 10 40 10 86 67 96 119 16 85 -12 152 -80 192 -29 17 -56 20 -191 23 l-158 4 0 -291z m326 176 c33 -38 33 -95 -1 -131 -23 -25 -28 -26 -135 -26 l-110 0 0 96 0 96 111 -4 c107 -3 112 -4 135 -31z" />
        <path d="M7330 2670 l0 -290 45 0 45 0 0 130 0 130 135 0 135 0 0 -130 0 -130 40 0 40 0 0 290 0 290 -40 0 -40 0 0 -120 0 -120 -135 0 -135 0 0 120 0 120 -45 0 -45 0 0 -290z" />
        <path d="M6254 2806 c-135 -61 -153 -307 -30 -401 60 -46 171 -46 224 0 l27 24 -22 22 c-21 21 -22 22 -64 5 -52 -21 -97 -15 -127 17 -20 21 -42 67 -42 88 0 5 62 9 146 9 l146 0 -4 58 c-9 117 -68 183 -166 189 -34 2 -69 -2 -88 -11z m110 -66 c28 -10 66 -64 66 -92 0 -16 -12 -18 -105 -18 l-105 0 6 28 c17 75 72 107 138 82z" />
        <path d="M7985 2805 c-22 -8 -41 -15 -42 -15 -8 0 0 -28 12 -43 12 -17 18 -18 68 -7 88 20 137 -3 137 -63 l0 -32 -79 3 c-68 4 -85 1 -120 -19 -101 -56 -85 -213 25 -249 42 -14 105 -8 137 13 26 17 43 17 39 -1 -2 -10 8 -12 39 -10 l42 3 0 166 c0 180 -6 206 -56 243 -36 27 -145 33 -202 11z m165 -235 c21 -13 19 -61 -3 -87 -59 -67 -177 -44 -177 34 0 43 33 63 103 63 34 0 69 -4 77 -10z" />
        <path d="M4869 2792 c14 -26 151 -397 151 -409 0 -6 -13 -43 -30 -83 -16 -40 -30 -74 -30 -76 0 -2 19 -4 43 -4 l42 0 104 283 c57 155 106 288 109 295 3 10 -6 12 -39 10 l-43 -3 -56 -168 -56 -168 -54 168 -55 168 -48 3 c-45 3 -48 2 -38 -16z" />
      </g>
    </svg>
  );
};

const AxiosIcon = () => {
  return (
    <svg viewBox="0 0 128 128">
      <path
        fill="#5a29e4"
        d="m 34,43.977569 27.379067,-22.912155 0.0385,91.494586 -9.3189,7.74007 -0.15403,-76.091455 z"
      ></path>
      <path
        fill="#5a29e4"
        d="M 96.961687,82.322502 69.582627,105.23466 69.544127,13.74007 78.863017,6 l 0.15403,76.091452 z"
      ></path>
    </svg>
  );
};

const ClaudeColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Claude</title>
      <path
        d="M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z"
        fill="#D97757"
        fillRule="nonzero"
      />
    </svg>
  );
};

const OpenAIIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd">
      <title>OpenAI</title>
      <path d="M9.205 8.658v-2.26c0-.19.072-.333.238-.428l4.543-2.616c.619-.357 1.356-.523 2.117-.523 2.854 0 4.662 2.212 4.662 4.566 0 .167 0 .357-.024.547l-4.71-2.759a.797.797 0 00-.856 0l-5.97 3.473zm10.609 8.8V12.06c0-.333-.143-.57-.429-.737l-5.97-3.473 1.95-1.118a.433.433 0 01.476 0l4.543 2.617c1.309.76 2.189 2.378 2.189 3.948 0 1.808-1.07 3.473-2.76 4.163zM7.802 12.703l-1.95-1.142c-.167-.095-.239-.238-.239-.428V5.899c0-2.545 1.95-4.472 4.591-4.472 1 0 1.927.333 2.712.928L8.23 5.067c-.285.166-.428.404-.428.737v6.898zM12 15.128l-2.795-1.57v-3.33L12 8.658l2.795 1.57v3.33L12 15.128zm1.796 7.23c-1 0-1.927-.332-2.712-.927l4.686-2.712c.285-.166.428-.404.428-.737v-6.898l1.974 1.142c.167.095.238.238.238.428v5.233c0 2.545-1.974 4.472-4.614 4.472zm-5.637-5.303l-4.544-2.617c-1.308-.761-2.188-2.378-2.188-3.948A4.482 4.482 0 014.21 6.327v5.423c0 .333.143.571.428.738l5.947 3.449-1.95 1.118a.432.432 0 01-.476 0zm-.262 3.9c-2.688 0-4.662-2.021-4.662-4.519 0-.19.024-.38.047-.57l4.686 2.71c.286.167.571.167.856 0l5.97-3.448v2.26c0 .19-.07.333-.237.428l-4.543 2.616c-.619.357-1.356.523-2.117.523zm5.899 2.83a5.947 5.947 0 005.827-4.756C22.287 18.339 24 15.84 24 13.296c0-1.665-.713-3.282-1.998-4.448.119-.5.19-.999.19-1.498 0-3.401-2.759-5.947-5.946-5.947-.642 0-1.26.095-1.88.31A5.962 5.962 0 0010.205 0a5.947 5.947 0 00-5.827 4.757C1.713 5.447 0 7.945 0 10.49c0 1.666.713 3.283 1.998 4.448-.119.5-.19 1-.19 1.499 0 3.401 2.759 5.946 5.946 5.946.642 0 1.26-.095 1.88-.309a5.96 5.96 0 004.162 1.713z" />
    </svg>
  );
};

const GeminiColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Gemini</title>
      <path
        d="M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z"
        fill="#3186FF"
      />
      <path
        d="M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z"
        fill="url(#gemini-color-grad-0)"
      />
      <path
        d="M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z"
        fill="url(#gemini-color-grad-1)"
      />
      <path
        d="M20.616 10.835a14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678z"
        fill="url(#gemini-color-grad-2)"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="gemini-color-grad-0" x1="7" x2="11" y1="15.5" y2="12">
          <stop stopColor="#08B962" />
          <stop offset="1" stopColor="#08B962" stopOpacity="0" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="gemini-color-grad-1" x1="8" x2="11.5" y1="5.5" y2="11">
          <stop stopColor="#F94543" />
          <stop offset="1" stopColor="#F94543" stopOpacity="0" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="gemini-color-grad-2" x1="3.5" x2="17.5" y1="13.5" y2="12">
          <stop stopColor="#FABC12" />
          <stop offset=".46" stopColor="#FABC12" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const GrokIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd">
      <title>Grok</title>
      <path d="M9.27 15.29l7.978-5.897c.391-.29.95-.177 1.137.272.98 2.369.542 5.215-1.41 7.169-1.951 1.954-4.667 2.382-7.149 1.406l-2.711 1.257c3.889 2.661 8.611 2.003 11.562-.953 2.341-2.344 3.066-5.539 2.388-8.42l.006.007c-.983-4.232.242-5.924 2.75-9.383.06-.082.12-.164.179-.248l-3.301 3.305v-.01L9.267 15.292M7.623 16.723c-2.792-2.67-2.31-6.801.071-9.184 1.761-1.763 4.647-2.483 7.166-1.425l2.705-1.25a7.808 7.808 0 00-1.829-1A8.975 8.975 0 005.984 5.83c-2.533 2.536-3.33 6.436-1.962 9.764 1.022 2.487-.653 4.246-2.34 6.022-.599.63-1.199 1.259-1.682 1.925l7.62-6.815" />
    </svg>
  );
};

const AmplitudeIcon = () => {
  return (
    <svg viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
      <title>Amplitude</title>
      <path fill="none" d="M0,0h150v150H0V0z" />
      <path
        fill="#377FC1"
        d="M74.9,7.3c-36.5,0-66,29.6-66,66s29.6,66,66,66s66-29.6,66-66S111.3,7.3,74.9,7.3z M120.3,74.5
        c-0.5,0-0.9,0.1-1.4,0.1c-10,0-20,0.1-30,0.1c-0.3,0-0.6,0-1,0c0.1,0,0.1,0.7,0.2,1c1.3,5.3,2.6,10.6,4,15.8c0.9,3.3,2,6.4,3.4,9.5
        c0.5,1.1,1.2,2.1,1.9,3.2c0.2,0.4,0.6,0.7,0.8,1c1.5,1.6,3.5,1.4,4.9,0.5c0.8-0.5,1.4-1.2,1.9-1.9c1-1.4,1.8-3,2.4-4.6
        c1.6-4.3,3.2-8.6,4.8-12.9c0.5-1.3,0.9-2.6,1.4-3.9c0.3-0.9,0.7-1.1,1.3-1c0.6,0.2,0.7,0.6,0.5,1.5c-1,3.9-1.9,7.8-3,11.6
        c-1,3.7-2.1,7.3-3.8,10.8c-1.1,2.2-2.3,4.3-4.1,6c-1,0.9-2,1.7-3.3,2.1c-2.6,1-5,0.5-7.1-1.4c-1.5-1.3-2.6-2.9-3.5-4.6
        c-1.4-2.5-2.5-5.2-3.5-7.9c-2.5-6.7-4.4-13.4-6.2-20.3c-0.4-1.5-0.8-3.3-1.2-4.5c-9.9,0-19.8,0-29.7,0c-0.1,0-0.2,0.5-0.3,0.7
        c-1.9,5.9-3.7,11.8-5.5,17.7c-0.4,1.2-1.3,1.9-2.4,1.9c-1,0-2-0.7-2.3-1.7c-0.1-0.3-0.1-0.7-0.1-1.1c0.9-5,1.9-10.2,2.8-15.2
        c0.2-0.9,0.4-1.7,0.6-2.9c-0.4,0-0.7,0-1,0c-3.8,0-7.5,0.2-11.3,0.2c-1.6,0-3.6-1-4-3.2c-0.4-2.2,1.2-4.3,3.4-4.5
        c0.5,0,0.9,0,1.4,0c3.8,0.1,7.7,0.1,11.5,0.2c0.5,0,1.1,0,1.7,0c0.3-1.1,0.6-2.3,0.9-3.4c1.6-6,3.3-11.9,5.6-17.7
        c1.5-3.8,3.2-7.5,5.5-10.9c1.2-1.8,2.5-3.4,4.2-4.7c1.4-1.1,2.9-1.9,4.7-2c1.4-0.1,2.7,0.3,3.9,1.1c1.2,0.8,2.1,1.8,3,2.9
        c1.9,2.5,3.3,5.2,4.6,8c2.6,5.7,4.5,11.6,6.2,17.5c0.9,3.1,1.8,6.2,2.6,9.3c0,0.2,0.1,0.3,0.1,0.5c0.2,0,0.3,0.1,0.4,0.1
        c2.3,0.1,4.5,0.1,6.8,0.2c5.3,0.2,10.6,0.3,16,0.5c3.6,0.2,7.2,0.4,10.8,0.6c1.6,0.1,2.6,0.9,2.9,2.3
        C123.1,72.7,122,74.4,120.3,74.5z"
      />
      <path
        fill="#377FC1"
        d="M71.3,47.4c-0.8-2.3-1.7-4.5-2.9-6.6c-0.2-0.4-0.5-0.7-0.7-1c-0.5-0.6-1.2-0.7-1.9-0.4
        c-0.3,0.1-0.7,0.4-0.9,0.6c-0.7,0.9-1.5,1.8-2.1,2.7c-1.3,2.1-2.3,4.3-3.2,6.6C57.3,55.1,55.5,61,54,67c0,0.2-0.1,0.4-0.1,0.6
        c7.9,0.1,15.7,0.2,23.6,0.3c-0.2-0.7-0.3-1.2-0.5-1.8C75.3,59.8,73.5,53.5,71.3,47.4z"
      />
    </svg>
  );
};

const AdobeFireflyColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Adobe Firefly</title>
      <path
        d="M20.098 22.227c.216 0 .39.173.39.387a.389.389 0 01-.39.386.389.389 0 01-.39-.386c0-.214.175-.387.39-.387zM5.367 9.53c.198 0 .376.088.497.226a.633.633 0 01.71.226.561.561 0 01.73.334.504.504 0 01.749.352.46.46 0 01.511.302.417.417 0 01.416-.363c.23 0 .418.185.418.414a.416.416 0 01-.418.414.418.418 0 01-.393-.271.459.459 0 01-.458.41.46.46 0 01-.447-.348.508.508 0 01-.584-.279.56.56 0 01-.72-.064.63.63 0 01-.762-.104.66.66 0 01-.444.02.67.67 0 01.164.125.633.633 0 01.72.196.561.561 0 01.717.262.518.518 0 01.815.243.463.463 0 01.559.221.417.417 0 01.414-.356c.231 0 .419.186.419.414a.42.42 0 01-.784.202.453.453 0 01-.166.303.42.42 0 01.587.379.41.41 0 01-.085.25.364.364 0 01.56.302.36.36 0 01-.363.359.36.36 0 01-.363-.36c0-.078.025-.15.069-.21a.42.42 0 01-.655-.341c0-.128.058-.241.15-.317a.463.463 0 01-.612-.23.519.519 0 01-.668-.205.56.56 0 01-.757-.004.63.63 0 01-.743-.06.673.673 0 01-.415.06.68.68 0 01.085.073.603.603 0 01.706.126.56.56 0 01.788.133.517.517 0 01.795.24.463.463 0 01.643.418.45.45 0 01-.08.257.416.416 0 01.509.58.364.364 0 01.548.309.36.36 0 01-.363.359.36.36 0 01-.33-.509.42.42 0 01-.647-.347c0-.082.024-.158.066-.223a.463.463 0 01-.579-.23.518.518 0 01-.656-.124.56.56 0 01-.74-.009.601.601 0 01-.53.129c.052.036.1.08.14.13a.601.601 0 01.815.034.518.518 0 01.766.201.462.462 0 01.663.41.45.45 0 01-.021.136.444.444 0 01.53.565.364.364 0 01.55.306.36.36 0 01-.362.359.36.36 0 01-.361-.387.42.42 0 01-.658-.435.464.464 0 01-.513-.17.517.517 0 01-.728-.026.609.609 0 01-.053.075c.171.049.311.169.386.326a.461.461 0 01.717.501.416.416 0 01.52.46.364.364 0 01.561.3.36.36 0 01-.363.359.36.36 0 01-.361-.387.42.42 0 01-.658-.435.464.464 0 01-.513-.17.517.517 0 01-.728-.026.609.609 0 01-.053.075c.18.008.337.11.422.256a.461.461 0 01.717.501.416.416 0 01.52.46.364.364 0 01.561.3.36.36 0 01-.363.359.36.36 0 01-.361-.387.42.42 0 01-.658-.435.464.464 0 01-.509-.203.518.518 0 01-.575-.014.6.6 0 01-.122.095c.18.008.337.11.422.256a.461.461 0 01.717.501.416.416 0 01.52.46.364.364 0 01.561.3.36.36 0 01-.363.359.36.36 0 01-.361-.387.42.42 0 01-.658-.435.464.464 0 01-.509-.203.518.518 0 01-.575-.014.6.6 0 01-.063.977.569.569 0 01.683.695.574.574 0 01.854.472v.01l.004-.01a.572.572 0 01.52-.38.491.491 0 01-.105-.304.5.5 0 01.503-.497.5.5 0 01.502.497.499.499 0 01-.451.494.56.56 0 01.005.745.602.602 0 01.08.728.738.738 0 01.248.263.662.662 0 01.07-.106.563.563 0 01-.058-.86.534.534 0 01-.173-.395c0-.28.216-.51.493-.536a.492.492 0 01.076-.735.429.429 0 01-.318-.413.43.43 0 01.432-.427.43.43 0 01.433.427c0 .131-.06.249-.154.327.231.045.405.246.405.488 0 .251-.19.46-.435.492a.533.533 0 01.009.745.562.562 0 01.126.717.661.661 0 01.352.66l.007.004a.588.588 0 01.152-.463.54.54 0 01-.379-.513c0-.142.056-.271.147-.367a.508.508 0 01.3-.916.453.453 0 010-.746H9.19a.43.43 0 01-.433-.428.43.43 0 01.433-.427.426.426 0 01.255.774l.024-.002c.254 0 .46.204.46.456 0 .242-.19.44-.43.454a.509.509 0 01.112.76.536.536 0 01.116.777.595.595 0 01.45.646.69.69 0 01.422.634c0 .381-.312.69-.698.69a.698.698 0 01-.641-.42.767.767 0 01-.712.475.769.769 0 01-.6-.286.797.797 0 01-.655.341.797.797 0 01-.663-.35.825.825 0 01-.677.35.825.825 0 01-.655-.322.825.825 0 01-.656.322.824.824 0 01-.75-.477.839.839 0 01-.547.201.833.833 0 01-.836-.78.833.833 0 01-.95-.82c0-.163.048-.315.13-.443A.721.721 0 011 19.936c0-.298.183-.553.444-.662a.717.717 0 01.388-1.351.685.685 0 01-.246-.527.694.694 0 01.749-.688.685.685 0 01-.247-.526.694.694 0 01.745-.689.685.685 0 01-.215-.498.694.694 0 01.86-.671.66.66 0 01.413-1.23.672.672 0 01-.24-.514.68.68 0 01.804-.666.66.66 0 01-.274-.535.666.666 0 01.87-.633.647.647 0 01.316-1.217zm13.63 12.588c.207 0 .376.167.376.372a.375.375 0 01-.377.373.375.375 0 01-.376-.373c0-.205.168-.372.376-.372zm-8.483-3.644c.247 0 .447.198.447.442a.443.443 0 01-.38.436.468.468 0 01.077.72.511.511 0 01.264.78.526.526 0 01.428.691c.3.04.531.295.531.602a.61.61 0 01-.613.608.61.61 0 01-.553-.873.526.526 0 01-.294-.817.513.513 0 01-.437-.505c0-.148.064-.282.167-.375a.47.47 0 01-.306-.44c0-.238.18-.436.414-.465a.44.44 0 01.255-.804zm10.645 3.506c.184 0 .334.148.334.33 0 .184-.15.332-.334.332a.333.333 0 01-.335-.331c0-.183.15-.331.335-.331zM15.732 2.71c.308 0 .558.248.558.552a.555.555 0 01-.681.54.541.541 0 01-.681.628.541.541 0 01-.6.755.532.532 0 01.092.3.541.541 0 01-.657.526.504.504 0 01-.003.607.546.546 0 01.335-.067.527.527 0 01.59-.738.527.527 0 01.573-.748.527.527 0 01.635-.63.51.51 0 01.508-.593c.285 0 .517.229.517.51a.513.513 0 01-.623.5.527.527 0 01-.62.61.527.527 0 01-.627.632c.036.07.056.15.056.232a.527.527 0 01-.586.522.53.53 0 01.056.227.545.545 0 01.554-.244.541.541 0 01.591-.693.513.513 0 011.212-1.054c.286 0 .517.229.517.511a.513.513 0 01-.698.478v.019a.513.513 0 01-.563.508.537.537 0 01-.539.61.553.553 0 01-.094-.008.541.541 0 01-.51.698h-.005l.003.016a.537.537 0 01.005.114.545.545 0 01.509-.208.536.536 0 01.538-.612c.044 0 .086.005.126.014a.513.513 0 01.699-.478.514.514 0 01.515-.475c.285 0 .516.229.516.51a.513.513 0 01-.699.479.514.514 0 01-.613.465v.023a.541.541 0 01-.618.533.536.536 0 01-.302.559.576.576 0 01.253-.025.556.556 0 01.78-.455.514.514 0 01.705-.452.487.487 0 01.48-.395c.27 0 .488.217.488.483a.486.486 0 01-.646.458.514.514 0 01-.693.407v.005a.555.555 0 01-.615.55.564.564 0 01-.246.426.564.564 0 01.278.016.528.528 0 01.756-.416.487.487 0 01.753-.33.487.487 0 01.483-.412c.27 0 .488.217.488.483a.49.49 0 01-.759.402.487.487 0 01-.666.377.528.528 0 01-.669.459.556.556 0 01-.64.51.588.588 0 01-.157.392h.003a.55.55 0 01.132.016.542.542 0 01.752-.415.5.5 0 01.763-.354.501.501 0 01.791-.278.474.474 0 01.45-.322c.262 0 .475.21.475.47a.476.476 0 01-.745.386.502.502 0 01-.749.284.501.501 0 01-.656.35.542.542 0 01-.675.482.534.534 0 01-.146.293.587.587 0 01.204.052.516.516 0 01.764-.281.49.49 0 01.795-.295.474.474 0 01.805-.18.474.474 0 01.458-.346c.262 0 .475.21.475.469a.475.475 0 01-.825.316.474.474 0 01-.756.243.488.488 0 01-.71.29.514.514 0 01-.678.422.578.578 0 01-.195.33h.01a.56.56 0 01.32.1.487.487 0 01.75-.292.49.49 0 01.845-.223.46.46 0 01.854-.078.445.445 0 01.44-.363c.247 0 .447.198.447.442s-.2.442-.447.442a.447.447 0 01-.397-.24.461.461 0 01-.79.234.487.487 0 01-.747.28.487.487 0 01-.721.325.556.556 0 01-.553.477c.025.034.047.07.064.109a.517.517 0 01.712-.132.488.488 0 01.783-.22.46.46 0 01.848-.057.445.445 0 01.439-.362c.193 0 .358.121.42.292a.445.445 0 01.445-.403c.246 0 .446.198.446.442s-.2.442-.446.442a.446.446 0 01-.42-.293.447.447 0 01-.842.163.46.46 0 01-.74.28.488.488 0 01-.723.275.516.516 0 01-.603.364.577.577 0 01-.312.61.492.492 0 01.326.018.472.472 0 01.44-.644c.149 0 .282.067.369.174a.447.447 0 01.836-.13.445.445 0 01.441-.376c.196 0 .363.125.423.3a.445.445 0 01.442-.383c.244 0 .442.193.446.433v.006-.007a.416.416 0 01.419-.404c.231 0 .418.185.418.414a.416.416 0 01-.418.414.417.417 0 01-.418-.397v-.016.009a.444.444 0 01-.447.432.446.446 0 01-.423-.3.447.447 0 01-.838.145.447.447 0 01-.78.22.473.473 0 01-.647.37.482.482 0 01-.208.605.479.479 0 01.374.045.444.444 0 01.43-.561c.17 0 .317.094.392.232a.445.445 0 01.444-.397c.193 0 .358.12.42.29l.003.009.002-.009a.417.417 0 01.412-.346c.232 0 .419.186.419.414a.416.416 0 01-.419.414.418.418 0 01-.394-.274.447.447 0 01-.836.153.445.445 0 01-.66.342.472.472 0 01-.453.607.475.475 0 01-.394-.208.525.525 0 01-.142.21.474.474 0 01.49.338.431.431 0 01.704-.237.43.43 0 01.416-.545c.187 0 .345.118.406.281a.43.43 0 01.431-.39.43.43 0 01.432.427.43.43 0 01-.432.428.432.432 0 01-.406-.28.434.434 0 01-.712.288.43.43 0 01-.416.545.432.432 0 01-.413-.3.468.468 0 01-.164.274.46.46 0 01.507.453.461.461 0 01-.758.347.53.53 0 01-.057.177.545.545 0 01.289.17.433.433 0 01.4-.266.43.43 0 01.433.428.434.434 0 01-.714.325.531.531 0 01-.061.144.5.5 0 01.275.3.39.39 0 01.388-.341c.216 0 .39.173.39.386a.389.389 0 01-.39.387.39.39 0 01-.364-.246.49.49 0 01-.087.251.486.486 0 01.529.655.421.421 0 01.564.388.416.416 0 01-.419.415.416.416 0 01-.399-.54.49.49 0 01-.689-.44c0-.1.03-.192.083-.27a.5.5 0 01-.53-.715.539.539 0 01-.301-.754.54.54 0 01-.354-.788.58.58 0 01-.383-.708.58.58 0 01-.265-.844.54.54 0 01-.39-.785.54.54 0 01-.33-.78.539.539 0 01-.308-.773.539.539 0 01-.307-.773.539.539 0 01-.31-.768.538.538 0 01-.248-.75.539.539 0 01-.25-.856.54.54 0 01-.27-.83.416.416 0 01-.385-.413.42.42 0 01.777-.214.541.541 0 01.152-.192l.01-.008a.474.474 0 01-.439-.316l-.003-.009v.006a.39.39 0 01-.385.319.389.389 0 01-.39-.387.39.39 0 01.756-.136.464.464 0 01.092-.229.464.464 0 01-.011-.08.471.471 0 01-.42-.466c0-.132.057-.252.146-.338a.448.448 0 01-.62-.407c0-.244.2-.442.447-.442.246 0 .446.198.446.442a.438.438 0 01-.133.315.476.476 0 01.291-.028.531.531 0 01.06-.538.513.513 0 01-.529-.701.475.475 0 01-.847-.29c0-.26.213-.47.475-.47a.472.472 0 01.44.642.517.517 0 01.665-.133c.01-.1.05-.193.108-.27a.518.518 0 01-.767-.445.513.513 0 01.614-.502.532.532 0 01-.112-.326.541.541 0 01.65-.528.532.532 0 01-.092-.3.541.541 0 01.693-.519.541.541 0 01.605-.754.555.555 0 01.544-.674zM11.63 19.936a.472.472 0 01.403.718h.016c.25 0 .455.191.473.434a.54.54 0 01.462.532.541.541 0 01-.545.538.541.541 0 01-.541-.59.47.47 0 01-.251-.694h-.017a.472.472 0 01-.474-.469c0-.259.212-.469.474-.469zm7.66 1.463c.184 0 .334.148.334.331 0 .183-.15.331-.335.331a.333.333 0 01-.335-.33c0-.184.15-.332.335-.332zm1.506-.11c.185 0 .335.148.335.33 0 .184-.15.332-.335.332a.333.333 0 01-.335-.331c0-.183.15-.331.335-.331zm1.27-.249c.192 0 .348.155.348.345 0 .19-.156.345-.349.345a.347.347 0 01-.348-.345c0-.19.156-.345.348-.345zm-2.024.028c.185 0 .335.148.335.331 0 .183-.15.331-.335.331a.333.333 0 01-.334-.331c0-.183.15-.331.334-.331zm-1.506-.166c.216 0 .39.173.39.387a.389.389 0 01-.39.386.389.389 0 01-.39-.386c0-.214.174-.387.39-.387zm2.943-.359c.193 0 .35.155.35.345 0 .19-.157.345-.35.345a.347.347 0 01-.348-.345c0-.19.156-.345.348-.345zm-15.133.17a.6.6 0 01-.08.204c.069.053.128.118.175.192a.734.734 0 01.076-.1.605.605 0 01-.171-.296zm12.748-.39c.216 0 .39.172.39.386a.389.389 0 01-.39.386.389.389 0 01-.39-.386c0-.214.174-.387.39-.387zm-6.64-1.243c.207 0 .376.167.376.373a.37.37 0 01-.14.29.389.389 0 01.374.5.434.434 0 01.673.355.43.43 0 01-.433.428.43.43 0 01-.408-.568.392.392 0 01-.596-.329c0-.123.058-.233.149-.303a.375.375 0 01-.372-.373c0-.206.168-.373.376-.373zm-7.321 1.456l-.002.002a.683.683 0 01-.183.188c.13.064.236.168.302.296a.738.738 0 01.026-.03.6.6 0 01-.143-.456zm15.593-.241c.193 0 .349.154.349.345 0 .19-.156.345-.349.345a.347.347 0 01-.349-.345c0-.19.156-.345.35-.345zm-.767-.138c.216 0 .39.173.39.386a.389.389 0 01-.39.387.389.389 0 01-.39-.387c0-.213.174-.386.39-.386zm1.98-.58a.36.36 0 01.361.399.391.391 0 01.7.236.389.389 0 01-.39.386.389.389 0 01-.388-.437.363.363 0 01-.645-.225.36.36 0 01.363-.359zm-15.554.216a.569.569 0 01-.27.322c.11.084.192.203.225.341a.604.604 0 01.171-.317.56.56 0 01-.126-.329v-.017zm12.15-.299c.217 0 .391.173.391.387a.389.389 0 01-.39.386.389.389 0 01-.39-.386c0-.214.174-.387.39-.387zM4.544 19.32v.001a.681.681 0 01-.017.175h.031a.68.68 0 01.678.762.614.614 0 01.239-.204.562.562 0 01-.187-.578.574.574 0 01-.744-.156zm16.56.01c.215 0 .39.173.39.386a.389.389 0 01-.39.387.389.389 0 01-.39-.387c0-.213.174-.386.39-.386zm-.893-.11c.216 0 .39.172.39.386a.389.389 0 01-.39.386.389.389 0 01-.39-.386c0-.214.174-.387.39-.387zm-.92-.056c.215 0 .39.173.39.387a.389.389 0 01-.39.386.389.389 0 01-.391-.386c0-.214.174-.387.39-.387zm-7.827-.11c.246 0 .446.197.446.441s-.2.442-.446.442a.444.444 0 01-.447-.442c0-.244.2-.441.447-.441zm2.148.055a.32.32 0 01.321.317.32.32 0 01-.32.318.32.32 0 01-.322-.318.32.32 0 01.321-.317zm5.274-.883c.223 0 .404.179.404.4a.405.405 0 01-.708.265.43.43 0 01-.422.522.43.43 0 01-.432-.428.433.433 0 01.762-.277.402.402 0 01.396-.482zm3.683.303c.208 0 .376.167.376.373a.375.375 0 01-.376.373.375.375 0 01-.377-.373c0-.206.169-.373.377-.373zM6.329 18.17a.5.5 0 01.502.497.5.5 0 01-.502.497.5.5 0 01-.502-.497.5.5 0 01.502-.497zm6.543.332a.32.32 0 01.32.317.32.32 0 01-.32.318.32.32 0 01-.321-.318.32.32 0 01.32-.317zm8.747-.166c.208 0 .377.167.377.373a.375.375 0 01-.377.372.375.375 0 01-.377-.372c0-.206.169-.373.377-.373zm-9.793-.11c.215 0 .39.173.39.386a.389.389 0 01-.39.386.389.389 0 01-.391-.386c0-.213.175-.386.39-.386zm-7.61.21a.678.678 0 01-.181.254.684.684 0 01.397.283.564.564 0 01.257-.461.62.62 0 01-.473-.077zm16.454-.21c.208 0 .377.166.377.372a.375.375 0 01-.377.373.375.375 0 01-.376-.373c0-.206.168-.372.376-.372zm-.92-.056c.223 0 .404.18.404.4 0 .222-.181.4-.404.4a.402.402 0 01-.405-.4c0-.22.181-.4.405-.4zm-3.046.392l-.001.006a.574.574 0 01-.074.164c.072.028.136.07.188.124a.454.454 0 01.152-.247.48.48 0 01-.265-.047zm-3.218-.364c.17 0 .307.136.307.304a.305.305 0 01-.307.303.305.305 0 01-.307-.303c0-.168.137-.304.307-.304zm-3.32-.497c.223 0 .404.18.404.4 0 .221-.181.4-.404.4a.402.402 0 01-.405-.4c0-.22.181-.4.405-.4zm.99.028c.216 0 .39.173.39.386a.389.389 0 01-.39.387.389.389 0 01-.39-.387c0-.213.174-.386.39-.386zm1.283-.055c.2 0 .363.16.363.358a.36.36 0 01-.363.36.36.36 0 01-.362-.36.36.36 0 01.362-.358zm-5.175-.138a.43.43 0 01.432.427.43.43 0 01-.432.428.43.43 0 01-.433-.428.43.43 0 01.433-.427zm-1.577-.139a.5.5 0 01.503.497.5.5 0 01-.503.497.5.5 0 01-.502-.497.5.5 0 01.502-.497zm16.406-.11c.224 0 .405.18.405.4 0 .221-.181.4-.405.4a.402.402 0 01-.404-.4c0-.22.18-.4.404-.4zm-8.97.193c.154 0 .279.124.279.276a.278.278 0 01-.279.276.278.278 0 01-.279-.276c0-.152.125-.276.279-.276zm8.022-.276c.223 0 .404.18.404.4 0 .222-.181.4-.404.4a.402.402 0 01-.405-.4c0-.22.181-.4.405-.4zm-4.761.588a.569.569 0 01-.018.093c.042.018.082.04.118.067a.47.47 0 01.1-.144.535.535 0 01-.2-.016zm3.84-.67c.223 0 .404.179.404.4 0 .22-.18.4-.404.4a.402.402 0 01-.405-.4c0-.221.181-.4.405-.4zm-8.343 0c.2 0 .363.16.363.358a.36.36 0 01-.363.36.36.36 0 01-.362-.36.36.36 0 01.362-.359zm-5.259-.277a.43.43 0 01.433.428.43.43 0 01-.433.428.43.43 0 01-.432-.428.43.43 0 01.432-.428zm4.394.083c.2 0 .363.16.363.36a.36.36 0 01-.363.358.36.36 0 01-.362-.359.36.36 0 01.362-.359zm-.948-.027c.2 0 .363.16.363.358a.36.36 0 01-.363.36.36.36 0 01-.363-.36.36.36 0 01.363-.358zm-.893 0c.2 0 .363.16.363.358a.36.36 0 01-.363.36.36.36 0 01-.363-.36.36.36 0 01.363-.358zm-.92-.028c.2 0 .362.16.362.359a.36.36 0 01-.363.359.36.36 0 01-.362-.36.36.36 0 01.362-.358zm4.31-.028c.154 0 .279.124.279.276a.278.278 0 01-.279.276.278.278 0 01-.279-.276c0-.152.125-.276.279-.276zm-4.98-.524c.2 0 .362.16.362.359a.36.36 0 01-.362.359.36.36 0 01-.363-.36.36.36 0 01.363-.358zm9.126.368l-.003.005a.485.485 0 01-.062.082.53.53 0 01.337.244.473.473 0 01.2-.222.493.493 0 01-.472-.109zm-4.871-.285c.154 0 .279.123.279.276a.278.278 0 01-.28.276.278.278 0 01-.278-.276c0-.153.124-.276.279-.276zm9.737-.331c.231 0 .419.185.419.414a.416.416 0 01-.419.414.416.416 0 01-.418-.414c0-.23.187-.414.418-.414zm-.92-.056c.23 0 .418.186.418.414a.416.416 0 01-.419.414.416.416 0 01-.418-.414c0-.228.187-.414.418-.414zm-11.329.166c.155 0 .28.124.28.276a.278.278 0 01-.28.276.278.278 0 01-.279-.276c0-.152.125-.276.28-.276zm1.675 0c.154 0 .279.124.279.276a.278.278 0 01-.28.276.278.278 0 01-.278-.276c0-.152.124-.276.279-.276zm-.837 0c.154 0 .279.124.279.276a.278.278 0 01-.28.276.278.278 0 01-.279-.276c0-.152.125-.276.28-.276zm-1.59-.304c.153 0 .278.124.278.276a.278.278 0 01-.279.276.278.278 0 01-.279-.276c0-.152.125-.276.28-.276zm7.833.01v.003a.476.476 0 01-.022.08c.09.018.17.06.235.119a.488.488 0 01.192-.183.591.591 0 01-.405-.02zm-7.778-.81c.154 0 .279.123.279.276a.278.278 0 01-.28.276.278.278 0 01-.278-.276c0-.153.125-.276.279-.276zm.335-.773c.154 0 .279.123.279.276a.278.278 0 01-.28.276.278.278 0 01-.278-.276c0-.153.125-.276.279-.276zm-3.903-.083a.684.684 0 01-.05.05c.137.036.255.12.336.23a.517.517 0 01.126-.114.601.601 0 01-.412-.166zm4.238-.69c.154 0 .279.124.279.276a.278.278 0 01-.28.276.278.278 0 01-.278-.276c0-.152.124-.276.279-.276zm.348-.773c.162 0 .293.13.293.29 0 .16-.13.29-.293.29a.291.291 0 01-.293-.29c0-.16.132-.29.293-.29zm-.558-.58c.2 0 .363.161.363.36a.36.36 0 01-.363.358.36.36 0 01-.362-.359.36.36 0 01.362-.359zm.935-.193c.17 0 .307.136.307.304a.305.305 0 01-.307.303.305.305 0 01-.307-.303c0-.168.137-.304.307-.304zm-.572-.635c.2 0 .363.161.363.36a.36.36 0 01-.363.358.36.36 0 01-.363-.359.36.36 0 01.363-.359zm.893-.138a.32.32 0 01.32.318.32.32 0 01-.32.317.32.32 0 01-.321-.317.32.32 0 01.32-.318zm-.544-.69c.208 0 .376.167.376.373a.375.375 0 01-.376.373.375.375 0 01-.377-.373c0-.206.169-.373.377-.373zm.879-.083a.32.32 0 01.32.318.32.32 0 01-.32.317.32.32 0 01-.321-.317.32.32 0 01.32-.318zM5.84 8.343c.217 0 .408.108.52.274a.605.605 0 01.72.313.561.561 0 01.72.326.506.506 0 01.676.444.46.46 0 01.488.258.419.419 0 01.796.179.419.419 0 01-.79.191.46.46 0 01-.424.278.459.459 0 01-.457-.4.51.51 0 01-.566-.264.56.56 0 01-.73-.22.603.603 0 01-.732-.177.624.624 0 01-.849-.581c0-.343.281-.621.628-.621zm4.352 1.352c.208 0 .377.167.377.373a.375.375 0 01-.377.372.375.375 0 01-.376-.372c0-.206.168-.373.376-.373zm5.82.237l-.008.002a.581.581 0 01-.157.007.607.607 0 01-.255.391.605.605 0 01.182.011.55.55 0 01.237-.41zm-4.983-.264c.185 0 .335.148.335.33 0 .184-.15.332-.335.332a.333.333 0 01-.334-.331c0-.183.15-.331.334-.331zM6.4 7.1c.242 0 .452.136.557.334a.6.6 0 01.624.397.529.529 0 01.636.406.505.505 0 01.68.464c0 .021-.001.041-.004.061a.46.46 0 01.504.288.42.42 0 01.783.203.419.419 0 01-.803.164.46.46 0 01-.87-.231.501.501 0 01-.6-.362.533.533 0 01-.682-.243.604.604 0 01-.723-.247.624.624 0 01-.73-.613c0-.343.281-.62.628-.62zm4.185 1.767c.208 0 .377.167.377.373a.375.375 0 01-.377.372.375.375 0 01-.377-.372c0-.206.169-.373.377-.373zm.851.028c.193 0 .349.154.349.345 0 .19-.156.345-.349.345a.347.347 0 01-.349-.345c0-.19.156-.345.349-.345zm.781-.056c.193 0 .349.155.349.345 0 .191-.156.345-.349.345a.347.347 0 01-.349-.345c0-.19.157-.345.35-.345zm3.435.029l-.005.001a.548.548 0 01-.153.025.557.557 0 01-.017.103.573.573 0 01.175-.13zm-4.676-.83c.208 0 .376.168.376.374a.375.375 0 01-.376.372.375.375 0 01-.377-.372c0-.206.169-.373.377-.373zM6.873 5.914a.6.6 0 01.556.37.599.599 0 01.701.46.528.528 0 01.566.453.5.5 0 01.61.573h.008a.46.46 0 01.503.293.42.42 0 01.725.28.419.419 0 01-.802.165.461.461 0 01-.813-.343.5.5 0 01-.609-.394.535.535 0 01-.646-.325.6.6 0 01-.685-.356.597.597 0 01-.714-.583c0-.327.269-.593.6-.593zm4.883 1.74c.208 0 .377.166.377.372a.375.375 0 01-.377.373.375.375 0 01-.377-.373c0-.206.169-.373.377-.373zM7.403 4.725a.6.6 0 01.573.416.572.572 0 01.613.557.528.528 0 01.611.464l.03-.001a.5.5 0 01.472.668.458.458 0 01.528.513.419.419 0 01.786.199.416.416 0 01-.418.414.416.416 0 01-.415-.464.46.46 0 01-.848-.347.507.507 0 01-.6-.407.528.528 0 01-.59-.48.578.578 0 01-.662-.35.597.597 0 01-.68-.588c0-.328.269-.594.6-.594zm7.13 2.647l-.007.006a.805.805 0 01-.078.06l.061.034h.04a.371.371 0 01-.017-.1zm-3.112-.797a.43.43 0 01.433.428.43.43 0 01-.433.428.43.43 0 01-.432-.428.43.43 0 01.432-.428zM7.933 3.54c.29 0 .53.202.588.471a.569.569 0 01.622.638.513.513 0 01.585.582.5.5 0 01.592.489.491.491 0 01-.095.29.462.462 0 01.652.414.458.458 0 01-.46.456.458.458 0 01-.46-.456.45.45 0 01.08-.257.504.504 0 01-.718-.512.513.513 0 01-.617-.528.577.577 0 01-.68-.407.597.597 0 01-.689-.587c0-.328.27-.593.6-.593zm3.39 1.932c.262 0 .475.21.475.469 0 .26-.213.47-.475.47a.472.472 0 01-.474-.47c0-.26.212-.47.474-.47zm1.033-.083a.5.5 0 01.502.497.5.5 0 01-.502.497.5.5 0 01-.502-.497.5.5 0 01.502-.497zm-3.67-2.954a.597.597 0 01.599.64.569.569 0 01.607.762.527.527 0 01.679.504.518.518 0 01-.09.29.504.504 0 01.759.427.5.5 0 01-.503.497.5.5 0 01-.502-.497c0-.1.03-.192.08-.27a.532.532 0 01-.805-.448c0-.058.01-.114.027-.167a.569.569 0 01-.752-.559.597.597 0 01-.698-.586c0-.327.268-.593.6-.593zm6.07-.607c.307 0 .557.247.557.552a.555.555 0 01-.815.49c.057.085.09.187.09.297a.541.541 0 01-.711.512.533.533 0 01.125.344.541.541 0 01-.707.513c.109.099.177.24.177.398a.541.541 0 01-.544.538.541.541 0 01-.544-.538.541.541 0 01.707-.514.534.534 0 01-.177-.397.541.541 0 01.71-.513.533.533 0 01-.124-.343.541.541 0 01.792-.48.545.545 0 01-.095-.307c0-.305.25-.552.558-.552zm-2.944 2.457c.285 0 .516.228.516.51 0 .283-.231.511-.516.511a.513.513 0 01-.517-.51c0-.283.232-.511.517-.511zm-2.065-2.65a.569.569 0 01.51.823.569.569 0 01.732.543.56.56 0 01-.122.348.546.546 0 01.791.48.541.541 0 01-.544.539.541.541 0 01-.544-.539c0-.122.042-.236.112-.326A.574.574 0 019.845 3c0-.092.022-.18.062-.257a.569.569 0 01-.732-.543c0-.313.256-.566.572-.566zm2.567 1.546c.3 0 .544.24.544.538a.541.541 0 01-.544.538.541.541 0 01-.544-.538c0-.297.243-.538.544-.538zm.572-1.022c.308 0 .558.248.558.552 0 .305-.25.552-.558.552a.555.555 0 01-.558-.552c0-.304.25-.552.558-.552zm-1.256-.055c.308 0 .558.247.558.552 0 .305-.25.552-.558.552a.555.555 0 01-.558-.552c0-.305.25-.552.558-.552zm1.925-.883c.309 0 .559.247.559.552 0 .305-.25.552-.559.552a.555.555 0 01-.558-.552c0-.305.25-.552.558-.552zm-2.608-.083c.316 0 .572.253.572.566a.569.569 0 01-.572.566.569.569 0 01-.572-.566c0-.313.256-.566.572-.566zM12.272 1c.308 0 .558.247.558.552 0 .305-.25.552-.558.552a.555.555 0 01-.558-.552c0-.305.25-.552.558-.552z"
        fill="#EB1000"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ClaudeCodeColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Claude Code</title>
      <path
        clipRule="evenodd"
        d="M20.998 10.949H24v3.102h-3v3.028h-1.487V20H18v-2.921h-1.487V20H15v-2.921H9V20H7.488v-2.921H6V20H4.487v-2.921H3V14.05H0V10.95h3V5h17.998v5.949zM6 10.949h1.488V8.102H6v2.847zm10.51 0H18V8.102h-1.49v2.847z"
        fill="#D97757"
        fillRule="evenodd"
      />
    </svg>
  );
};

const CodexColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Codex</title>
      <path d="M19.503 0H4.496A4.496 4.496 0 000 4.496v15.007A4.496 4.496 0 004.496 24h15.007A4.496 4.496 0 0024 19.503V4.496A4.496 4.496 0 0019.503 0z" fill="#fff" />
      <path
        d="M9.064 3.344a4.578 4.578 0 012.285-.312c1 .115 1.891.54 2.673 1.275.01.01.024.017.037.021a.09.09 0 00.043 0 4.55 4.55 0 013.046.275l.047.022.116.057a4.581 4.581 0 012.188 2.399c.209.51.313 1.041.315 1.595a4.24 4.24 0 01-.134 1.223.123.123 0 00.03.115c.594.607.988 1.33 1.183 2.17.289 1.425-.007 2.71-.887 3.854l-.136.166a4.548 4.548 0 01-2.201 1.388.123.123 0 00-.081.076c-.191.551-.383 1.023-.74 1.494-.9 1.187-2.222 1.846-3.711 1.838-1.187-.006-2.239-.44-3.157-1.302a.107.107 0 00-.105-.024c-.388.125-.78.143-1.204.138a4.441 4.441 0 01-1.945-.466 4.544 4.544 0 01-1.61-1.335c-.152-.202-.303-.392-.414-.617a5.81 5.81 0 01-.37-.961 4.582 4.582 0 01-.014-2.298.124.124 0 00.006-.056.085.085 0 00-.027-.048 4.467 4.467 0 01-1.034-1.651 3.896 3.896 0 01-.251-1.192 5.189 5.189 0 01.141-1.6c.337-1.112.982-1.985 1.933-2.618.212-.141.413-.251.601-.33.215-.089.43-.164.646-.227a.098.098 0 00.065-.066 4.51 4.51 0 01.829-1.615 4.535 4.535 0 011.837-1.388zm3.482 10.565a.637.637 0 000 1.272h3.636a.637.637 0 100-1.272h-3.636zM8.462 9.23a.637.637 0 00-1.106.631l1.272 2.224-1.266 2.136a.636.636 0 101.095.649l1.454-2.455a.636.636 0 00.005-.64L8.462 9.23z"
        fill="url(#codex-color-grad)"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="codex-color-grad" x1="12" x2="12" y1="3" y2="21">
          <stop stopColor="#B1A7FF" />
          <stop offset=".5" stopColor="#7A9DFF" />
          <stop offset="1" stopColor="#3941FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const CursorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd">
      <title>Cursor</title>
      <path d="M22.106 5.68L12.5.135a.998.998 0 00-.998 0L1.893 5.68a.84.84 0 00-.419.726v11.186c0 .3.16.577.42.727l9.607 5.547a.999.999 0 00.998 0l9.608-5.547a.84.84 0 00.42-.727V6.407a.84.84 0 00-.42-.726zm-.603 1.176L12.228 22.92c-.063.108-.228.064-.228-.061V12.34a.59.59 0 00-.295-.51l-9.11-5.26c-.107-.062-.063-.228.062-.228h18.55c.264 0 .428.286.296.514z" />
    </svg>
  );
};

const DeepSeekColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>DeepSeek</title>
      <path
        d="M23.748 4.482c-.254-.124-.364.113-.512.234-.051.039-.094.09-.137.136-.372.397-.806.657-1.373.626-.829-.046-1.537.214-2.163.848-.133-.782-.575-1.248-1.247-1.548-.352-.156-.708-.311-.955-.65-.172-.241-.219-.51-.305-.774-.055-.16-.11-.323-.293-.35-.2-.031-.278.136-.356.276-.313.572-.434 1.202-.422 1.84.027 1.436.633 2.58 1.838 3.393.137.093.172.187.129.323-.082.28-.18.552-.266.833-.055.179-.137.217-.329.14a5.526 5.526 0 01-1.736-1.18c-.857-.828-1.631-1.742-2.597-2.458a11.365 11.365 0 00-.689-.471c-.985-.957.13-1.743.388-1.836.27-.098.093-.432-.779-.428-.872.004-1.67.295-2.687.684a3.055 3.055 0 01-.465.137 9.597 9.597 0 00-2.883-.102c-1.885.21-3.39 1.102-4.497 2.623C.082 8.606-.231 10.684.152 12.85c.403 2.284 1.569 4.175 3.36 5.653 1.858 1.533 3.997 2.284 6.438 2.14 1.482-.085 3.133-.284 4.994-1.86.47.234.962.327 1.78.397.63.059 1.236-.03 1.705-.128.735-.156.684-.837.419-.961-2.155-1.004-1.682-.595-2.113-.926 1.096-1.296 2.746-2.642 3.392-7.003.05-.347.007-.565 0-.845-.004-.17.035-.237.23-.256a4.173 4.173 0 001.545-.475c1.396-.763 1.96-2.015 2.093-3.517.02-.23-.004-.467-.247-.588zM11.581 18c-2.089-1.642-3.102-2.183-3.52-2.16-.392.024-.321.471-.235.763.09.288.207.486.371.739.114.167.192.416-.113.603-.673.416-1.842-.14-1.897-.167-1.361-.802-2.5-1.86-3.301-3.307-.774-1.393-1.224-2.887-1.298-4.482-.02-.386.093-.522.477-.592a4.696 4.696 0 011.529-.039c2.132.312 3.946 1.265 5.468 2.774.868.86 1.525 1.887 2.202 2.891.72 1.066 1.494 2.082 2.48 2.914.348.292.625.514.891.677-.802.09-2.14.11-3.054-.614zm1-6.44a.306.306 0 01.415-.287.302.302 0 01.2.288.306.306 0 01-.31.307.303.303 0 01-.304-.308zm3.11 1.596c-.2.081-.399.151-.59.16a1.245 1.245 0 01-.798-.254c-.274-.23-.47-.358-.552-.758a1.73 1.73 0 01.016-.588c.07-.327-.008-.537-.239-.727-.187-.156-.426-.199-.688-.199a.559.559 0 01-.254-.078c-.11-.054-.2-.19-.114-.358.028-.054.16-.186.192-.21.356-.202.767-.136 1.146.016.352.144.618.408 1.001.782.391.451.462.576.685.914.176.265.336.537.445.848.067.195-.019.354-.25.452z"
        fill="#4D6BFE"
      />
    </svg>
  );
};

const GeminiCLIColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Gemini CLI</title>
      <path d="M0 4.391A4.391 4.391 0 014.391 0h15.217A4.391 4.391 0 0124 4.391v15.217A4.391 4.391 0 0119.608 24H4.391A4.391 4.391 0 010 19.608V4.391z" fill="url(#gemini-cli-color-grad)" />
      <path
        clipRule="evenodd"
        d="M19.74 1.444a2.816 2.816 0 012.816 2.816v15.48a2.816 2.816 0 01-2.816 2.816H4.26a2.816 2.816 0 01-2.816-2.816V4.26A2.816 2.816 0 014.26 1.444h15.48zM7.236 8.564l7.752 3.728-7.752 3.727v2.802l9.557-4.596v-3.866L7.236 5.763v2.801z"
        fill="#1E1E2E"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="gemini-cli-color-grad" x1="24" x2="0" y1="6.587" y2="16.494">
          <stop stopColor="#EE4D5D" />
          <stop offset=".328" stopColor="#B381DD" />
          <stop offset=".476" stopColor="#207CFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const GitHubCopilotIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd">
      <title>GitHub Copilot</title>
      <path d="M19.245 5.364c1.322 1.36 1.877 3.216 2.11 5.817.622 0 1.2.135 1.592.654l.73.964c.21.278.323.61.323.955v2.62c0 .339-.173.669-.453.868C20.239 19.602 16.157 21.5 12 21.5c-4.6 0-9.205-2.583-11.547-4.258-.28-.2-.452-.53-.453-.868v-2.62c0-.345.113-.679.321-.956l.73-.963c.392-.517.974-.654 1.593-.654l.029-.297c.25-2.446.81-4.213 2.082-5.52 2.461-2.54 5.71-2.851 7.146-2.864h.198c1.436.013 4.685.323 7.146 2.864zm-7.244 4.328c-.284 0-.613.016-.962.05-.123.447-.305.85-.57 1.108-1.05 1.023-2.316 1.18-2.994 1.18-.638 0-1.306-.13-1.851-.464-.516.165-1.012.403-1.044.996a65.882 65.882 0 00-.063 2.884l-.002.48c-.002.563-.005 1.126-.013 1.69.002.326.204.63.51.765 2.482 1.102 4.83 1.657 6.99 1.657 2.156 0 4.504-.555 6.985-1.657a.854.854 0 00.51-.766c.03-1.682.006-3.372-.076-5.053-.031-.596-.528-.83-1.046-.996-.546.333-1.212.464-1.85.464-.677 0-1.942-.157-2.993-1.18-.266-.258-.447-.661-.57-1.108-.32-.032-.64-.049-.96-.05zm-2.525 4.013c.539 0 .976.426.976.95v1.753c0 .525-.437.95-.976.95a.964.964 0 01-.976-.95v-1.752c0-.525.437-.951.976-.951zm5 0c.539 0 .976.426.976.95v1.753c0 .525-.437.95-.976.95a.964.964 0 01-.976-.95v-1.752c0-.525.437-.951.976-.951zM7.635 5.087c-1.05.102-1.935.438-2.385.906-.975 1.037-.765 3.668-.21 4.224.405.394 1.17.657 1.995.657h.09c.649-.013 1.785-.176 2.73-1.11.435-.41.705-1.433.675-2.47-.03-.834-.27-1.52-.63-1.813-.39-.336-1.275-.482-2.265-.394zm6.465.394c-.36.292-.6.98-.63 1.813-.03 1.037.24 2.06.675 2.47.968.957 2.136 1.104 2.776 1.11h.044c.825 0 1.59-.263 1.995-.657.555-.556.765-3.187-.21-4.224-.45-.468-1.335-.804-2.385-.906-.99-.088-1.875.058-2.265.394zM12 7.615c-.24 0-.525.015-.84.044.03.16.045.336.06.526l-.001.159a2.94 2.94 0 01-.014.25c.225-.022.425-.027.612-.028h.366c.187 0 .387.006.612.028-.015-.146-.015-.277-.015-.409.015-.19.03-.365.06-.526a9.29 9.29 0 00-.84-.044z" />
    </svg>
  );
};

const OllamaIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd">
      <title>Ollama</title>
      <path d="M7.905 1.09c.216.085.411.225.588.41.295.306.544.744.734 1.263.191.522.315 1.1.362 1.68a5.054 5.054 0 012.049-.636l.051-.004c.87-.07 1.73.087 2.48.474.101.053.2.11.297.17.05-.569.172-1.134.36-1.644.19-.52.439-.957.733-1.264a1.67 1.67 0 01.589-.41c.257-.1.53-.118.796-.042.401.114.745.368 1.016.737.248.337.434.769.561 1.287.23.934.27 2.163.115 3.645l.053.04.026.019c.757.576 1.284 1.397 1.563 2.35.435 1.487.216 3.155-.534 4.088l-.018.021.002.003c.417.762.67 1.567.724 2.4l.002.03c.064 1.065-.2 2.137-.814 3.19l-.007.01.01.024c.472 1.157.62 2.322.438 3.486l-.006.039a.651.651 0 01-.747.536.648.648 0 01-.54-.742c.167-1.033.01-2.069-.48-3.123a.643.643 0 01.04-.617l.004-.006c.604-.924.854-1.83.8-2.72-.046-.779-.325-1.544-.8-2.273a.644.644 0 01.18-.886l.009-.006c.243-.159.467-.565.58-1.12a4.229 4.229 0 00-.095-1.974c-.205-.7-.58-1.284-1.105-1.683-.595-.454-1.383-.673-2.38-.61a.653.653 0 01-.632-.371c-.314-.665-.772-1.141-1.343-1.436a3.288 3.288 0 00-1.772-.332c-1.245.099-2.343.801-2.67 1.686a.652.652 0 01-.61.425c-1.067.002-1.893.252-2.497.703-.522.39-.878.935-1.066 1.588a4.07 4.07 0 00-.068 1.886c.112.558.331 1.02.582 1.269l.008.007c.212.207.257.53.109.785-.36.622-.629 1.549-.673 2.44-.05 1.018.186 1.902.719 2.536l.016.019a.643.643 0 01.095.69c-.576 1.236-.753 2.252-.562 3.052a.652.652 0 01-1.269.298c-.243-1.018-.078-2.184.473-3.498l.014-.035-.008-.012a4.339 4.339 0 01-.598-1.309l-.005-.019a5.764 5.764 0 01-.177-1.785c.044-.91.278-1.842.622-2.59l.012-.026-.002-.002c-.293-.418-.51-.953-.63-1.545l-.005-.024a5.352 5.352 0 01.093-2.49c.262-.915.777-1.701 1.536-2.269.06-.045.123-.09.186-.132-.159-1.493-.119-2.73.112-3.67.127-.518.314-.95.562-1.287.27-.368.614-.622 1.015-.737.266-.076.54-.059.797.042zm4.116 9.09c.936 0 1.8.313 2.446.855.63.527 1.005 1.235 1.005 1.94 0 .888-.406 1.58-1.133 2.022-.62.375-1.451.557-2.403.557-1.009 0-1.871-.259-2.493-.734-.617-.47-.963-1.13-.963-1.845 0-.707.398-1.417 1.056-1.946.668-.537 1.55-.849 2.485-.849zm0 .896a3.07 3.07 0 00-1.916.65c-.461.37-.722.835-.722 1.25 0 .428.21.829.61 1.134.455.347 1.124.548 1.943.548.799 0 1.473-.147 1.932-.426.463-.28.7-.686.7-1.257 0-.423-.246-.89-.683-1.256-.484-.405-1.14-.643-1.864-.643zm.662 1.21l.004.004c.12.151.095.37-.056.49l-.292.23v.446a.375.375 0 01-.376.373.375.375 0 01-.376-.373v-.46l-.271-.218a.347.347 0 01-.052-.49.353.353 0 01.494-.051l.215.172.22-.174a.353.353 0 01.49.051zm-5.04-1.919c.478 0 .867.39.867.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zm8.706 0c.48 0 .868.39.868.871a.87.87 0 01-.868.871.87.87 0 01-.867-.87.87.87 0 01.867-.872zM7.44 2.3l-.003.002a.659.659 0 00-.285.238l-.005.006c-.138.189-.258.467-.348.832-.17.692-.216 1.631-.124 2.782.43-.128.899-.208 1.404-.237l.01-.001.019-.034c.046-.082.095-.161.148-.239.123-.771.022-1.692-.253-2.444-.134-.364-.297-.65-.453-.813a.628.628 0 00-.107-.09L7.44 2.3zm9.174.04l-.002.001a.628.628 0 00-.107.09c-.156.163-.32.45-.453.814-.29.794-.387 1.776-.23 2.572l.058.097.008.014h.03a5.184 5.184 0 011.466.212c.086-1.124.038-2.043-.128-2.722-.09-.365-.21-.643-.349-.832l-.004-.006a.659.659 0 00-.285-.239h-.004z" />
    </svg>
  );
};

const SnowflakeColorIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Snowflake</title>
      <path
        clipRule="evenodd"
        d="M23.252 10.365l-2.843 1.636 2.843 1.631a1.47 1.47 0 01.697.903 1.492 1.492 0 01-.15 1.135c-.202.342-.53.591-.912.693a1.498 1.498 0 01-1.132-.15l-5.09-2.924a1.473 1.473 0 01-.68-.851 1.446 1.446 0 01-.068-.485 1.5 1.5 0 01.745-1.248l5.09-2.921a1.496 1.496 0 012.044.547 1.479 1.479 0 01-.544 2.034zm-2.692 7.927l-5.087-2.92a1.477 1.477 0 00-.867-.195 1.478 1.478 0 00-.982.468c-.257.276-.4.639-.403 1.017v5.847A1.49 1.49 0 0014.718 24c.828 0 1.497-.668 1.497-1.491v-3.27l2.849 1.636a1.493 1.493 0 002.044-.544 1.49 1.49 0 00-.548-2.04zm-5.87-5.719l-2.116 2.102a.42.42 0 01-.265.112h-.621a.427.427 0 01-.265-.112l-2.115-2.102a.42.42 0 01-.11-.262v-.62a.43.43 0 01.11-.265l2.114-2.102a.426.426 0 01.264-.11h.623a.422.422 0 01.265.11l2.116 2.102a.43.43 0 01.109.265v.62a.428.428 0 01-.11.262zM13 11.99a.442.442 0 00-.113-.266l-.612-.607a.431.431 0 00-.266-.11h-.024a.426.426 0 00-.264.11l-.612.607a.436.436 0 00-.107.266v.024c0 .085.047.202.107.262l.612.61c.061.06.179.11.264.11h.024a.434.434 0 00.266-.11l.612-.61a.429.429 0 00.112-.262v-.024zM3.436 5.704l5.089 2.924c.274.157.578.219.868.195.375-.026.726-.194.983-.47.256-.275.4-.64.403-1.017V1.489C10.78.667 10.11 0 9.284 0c-.829 0-1.498.667-1.498 1.49v3.27l-2.85-1.639a1.496 1.496 0 00-2.045.546 1.489 1.489 0 00.546 2.037zm11.17 3.119c.29.024.594-.038.866-.195l5.087-2.923a1.474 1.474 0 00.697-.903 1.496 1.496 0 00-.149-1.135 1.496 1.496 0 00-2.044-.545L16.215 4.76V1.489C16.215.667 15.546 0 14.718 0c-.83 0-1.497.667-1.497 1.49v5.845a1.491 1.491 0 001.385 1.487zm-5.213 6.354a1.479 1.479 0 00-.868.194l-5.089 2.92a1.476 1.476 0 00-.696.905 1.498 1.498 0 00.148 1.135 1.496 1.496 0 002.044.543l2.851-1.636v3.27c0 .825.67 1.491 1.498 1.491.826 0 1.496-.667 1.496-1.49v-5.847a1.5 1.5 0 00-.401-1.017 1.477 1.477 0 00-.982-.468zm-1.38-2.74c.05-.156.072-.32.068-.484a1.497 1.497 0 00-.751-1.248l-5.084-2.92a1.499 1.499 0 00-2.045.547 1.481 1.481 0 00.549 2.034l2.841 1.636L.75 13.633a1.47 1.47 0 00-.698.903 1.492 1.492 0 00.15 1.135c.202.343.53.592.912.693.382.102.789.048 1.132-.15l5.086-2.924c.345-.195.577-.505.684-.852z"
        fill="#249EDC"
        fillRule="evenodd"
      />
    </svg>
  );
};

interface AvailableSkill {
  name: string;
  category: string;
  icon: React.ReactNode;
}

const LANGUAGES = "languages";
const FRAMEWORKS = "frameworks";
const PLATFORMS = "platforms";
const TOOLS = "tools";
const DATABASES = "databases";
const availableSkills: AvailableSkill[] = [
  { name: "Java", category: LANGUAGES, icon: <JavaIcon /> },
  { name: "Postman", category: LANGUAGES, icon: <PostmanIcon /> },
  { name: "Axios", category: LANGUAGES, icon: <AxiosIcon /> },
  { name: "Storybook", category: LANGUAGES, icon: <StorybookIcon /> },
  { name: "Webflow", category: LANGUAGES, icon: <WebflowIcon /> },
  { name: "Nginx", category: LANGUAGES, icon: <NginxIcon /> },
  { name: "JavaScript", category: LANGUAGES, icon: <JSIcon /> },
  { name: "TypeScript", category: LANGUAGES, icon: <TSIcon /> },
  { name: "Swift", category: LANGUAGES, icon: <SwiftIcon /> },
  { name: "Objective-C", category: LANGUAGES, icon: <ObjCIcon /> },
  { name: "AngularJS", category: FRAMEWORKS, icon: <AngularIcon /> },
  { name: "Angular", category: FRAMEWORKS, icon: <AngularIcon /> },
  { name: "Android", category: PLATFORMS, icon: <AndroidIcon /> },
  { name: "iOS", category: PLATFORMS, icon: <IOSIcon /> },
  { name: "iOS-light", category: PLATFORMS, icon: <IOSIconLight /> },
  { name: "Scala", category: LANGUAGES, icon: <ScalaIcon /> },
  { name: "C#", category: LANGUAGES, icon: <CSharpIcon /> },
  { name: "JBoss", category: LANGUAGES, icon: <JBossIcon /> },
  { name: "F#", category: LANGUAGES, icon: <FSharpIcon /> },
  { name: "Dart", category: LANGUAGES, icon: <DartIcon /> },
  { name: "C++", category: LANGUAGES, icon: <CPlusPlusIcon /> },
  { name: "C", category: LANGUAGES, icon: <CIcon /> },
  { name: "Go", category: LANGUAGES, icon: <GoIcon /> },
  { name: "Rust", category: LANGUAGES, icon: <RustIcon /> },
  { name: "MobX", category: LANGUAGES, icon: <MobXIcon /> },
  { name: "MacOS", category: PLATFORMS, icon: <IOSIcon /> },
  { name: "MacOS", category: PLATFORMS, icon: <IOSIconLight /> },
  { name: "Windows", category: PLATFORMS, icon: <WindowsIcon /> },
  { name: "React", category: FRAMEWORKS, icon: <ReactIcon /> },
  { name: "ReactJS", category: FRAMEWORKS, icon: <ReactIcon /> },
  { name: "React Native", category: FRAMEWORKS, icon: <ReactIcon /> },
  { name: ".NET", category: FRAMEWORKS, icon: <DotNetIcon /> },
  { name: "Grails", category: FRAMEWORKS, icon: <GrailsIcon /> },
  { name: "Jenkins", category: TOOLS, icon: <JenkinsIcon /> },
  { name: "Django", category: FRAMEWORKS, icon: <DjangoIcon /> },
  { name: "Groovy", category: LANGUAGES, icon: <GroovyIcon /> },
  { name: "GraphQL", category: LANGUAGES, icon: <GraphQLIcon /> },
  { name: "AWS", category: PLATFORMS, icon: <AWSIcon /> },
  { name: "Azure", category: PLATFORMS, icon: <AzureIcon /> },
  { name: "MS Azure", category: PLATFORMS, icon: <AzureIcon /> },
  { name: "Heroku", category: PLATFORMS, icon: <HerokuIcon /> },
  { name: "PostgreSQL", category: DATABASES, icon: <PostgresIcon /> },
  { name: "Postgres", category: DATABASES, icon: <PostgresIcon /> },
  { name: "MySQL", category: DATABASES, icon: <MySQLIcon /> },
  { name: "Photoshop", category: TOOLS, icon: <PSIcon /> },
  { name: "Sketch", category: TOOLS, icon: <SketchIcon /> },
  { name: "Figma", category: TOOLS, icon: <FigmaIcon /> },
  { name: "Illustrator", category: TOOLS, icon: <IllustratorIcon /> },
  { name: "After Effects", category: TOOLS, icon: <AfterEffectsIcon /> },
  { name: "Python", category: LANGUAGES, icon: <PythonIcon /> },
  { name: "D3.js", category: FRAMEWORKS, icon: <D3Icon /> },
  { name: "Node.js", category: LANGUAGES, icon: <NodeIcon /> },
  { name: "RabbitMQ", category: FRAMEWORKS, icon: <RabbitMQIcon /> },
  { name: "PHP", category: LANGUAGES, icon: <PHPIcon /> },
  { name: "Laravel", category: LANGUAGES, icon: <LaravelIcon /> },
  { name: "jQuery", category: FRAMEWORKS, icon: <JQueryIcon /> },
  { name: "XCode", category: TOOLS, icon: <XCodeIcon /> },
  { name: "Flutter", category: TOOLS, icon: <FlutterIcon /> },
  { name: "Cordova", category: FRAMEWORKS, icon: <CordovaIcon /> },
  { name: "Apple Pay", category: PLATFORMS, icon: <ApplePayIcon /> },
  { name: "Moq", category: PLATFORMS, icon: <MoqIcon /> },
  { name: "Selenium", category: PLATFORMS, icon: <SeleniumIcon /> },
  { name: "Docker", category: PLATFORMS, icon: <DockerIcon /> },
  { name: "Cypress", category: PLATFORMS, icon: <CypressIcon /> },
  { name: "Spark", category: PLATFORMS, icon: <SparkIcon /> },
  { name: "Apache Spark", category: PLATFORMS, icon: <SparkIcon /> },
  { name: "SQL", category: LANGUAGES, icon: <SQLIcon /> },
  { name: "Kubernetes", category: LANGUAGES, icon: <KubernetesIcon /> },
  { name: "Terraform", category: LANGUAGES, icon: <TerraformIcon /> },
  { name: "Redux", category: LANGUAGES, icon: <ReduxIcon /> },
  { name: "DynamoDB", category: LANGUAGES, icon: <DynamoDBIcon /> },
  { name: "Dynamo DB", category: LANGUAGES, icon: <DynamoDBIcon /> },
  { name: "Golang", category: LANGUAGES, icon: <GoIcon /> },
  { name: "ViteJS", category: LANGUAGES, icon: <ViteJSIcon /> },
  { name: "Vite JS", category: LANGUAGES, icon: <ViteJSIcon /> },
  { name: "VueJS", category: LANGUAGES, icon: <VueIcon /> },
  { name: "Vue JS", category: LANGUAGES, icon: <VueIcon /> },
  { name: "Vue", category: LANGUAGES, icon: <VueIcon /> },
  { name: "HTML", category: LANGUAGES, icon: <HTMLIcon /> },
  { name: "CSS", category: LANGUAGES, icon: <CSSIcon /> },
  { name: "CSS/SASS", category: LANGUAGES, icon: <CSSIcon /> },
  { name: "Prometheus", category: LANGUAGES, icon: <PrometheusIcon /> },
  { name: "Kibana", category: LANGUAGES, icon: <KibanaIcon /> },
  { name: "Kotlin", category: LANGUAGES, icon: <KotlinIcon /> },
  { name: "Google Cloud", category: LANGUAGES, icon: <GoogleCloudIcon /> },
  { name: "Jira", category: TOOLS, icon: <JiraIcon /> },
  { name: "GitHub", category: TOOLS, icon: <GithubIcon /> },
  { name: "Notion", category: TOOLS, icon: <NotionIcon /> },
  { name: "Spring", category: FRAMEWORKS, icon: <SpringIcon /> },
  { name: "Java Spring", category: FRAMEWORKS, icon: <SpringIcon /> },
  { name: "Confluence", category: TOOLS, icon: <ConfluenceIcon /> },
  { name: "Kafka", category: FRAMEWORKS, icon: <KafkaIcon /> },
  { name: "Apache Kafka", category: FRAMEWORKS, icon: <KafkaIcon /> },
  { name: "Adobe XD", category: TOOLS, icon: <AdobeXDIcon /> },
  { name: "Perl", category: LANGUAGES, icon: <PerlIcon /> },
  { name: "Git", category: TOOLS, icon: <GitIcon /> },
  { name: "NgRx", category: TOOLS, icon: <NgRx /> },
  { name: "Design Sprint", category: FRAMEWORKS, icon: <DesignSprintIcon /> },
  {
    name: "Google Cloud Platform",
    category: PLATFORMS,
    icon: <GoogleCloudIcon />,
  },
  { name: "GCP", category: PLATFORMS, icon: <GoogleCloudIcon /> },
  { name: "Elastic Search", category: TOOLS, icon: <ElasticSearchIcon /> },
  { name: "Magneto", category: FRAMEWORKS, icon: <MagnetoIcon /> },
  { name: "Adobe", category: TOOLS, icon: <AdobeIcon /> },
  { name: "Adobe Create Suite", category: TOOLS, icon: <AdobeIcon /> },
  { name: "Axure", category: TOOLS, icon: <AxureIcon /> },
  { name: "UI Design", category: TOOLS, icon: <UIDesignIcon /> },
  { name: "Graphic Design", category: TOOLS, icon: <UIDesignIcon /> },
  { name: "JUnit", category: FRAMEWORKS, icon: <JUnitIcon /> },
  { name: "Cassandra", category: TOOLS, icon: <CassandraIcon /> },
  { name: "Grafana", category: TOOLS, icon: <GrafanaIcon /> },
  { name: "Cucumber", category: FRAMEWORKS, icon: <CucumberIcon /> },
  { name: "Tomcat", category: FRAMEWORKS, icon: <TomcatIcon /> },
  { name: "Hibernate", category: FRAMEWORKS, icon: <HibernateIcon /> },
  { name: "Oracle Database", category: TOOLS, icon: <OracleDatabaseIcon /> },
  { name: "Spring Boot", category: FRAMEWORKS, icon: <SpringIcon /> },
  { name: "Eclipse", category: TOOLS, icon: <EclipseIcon /> },
  { name: "NetBeans", category: TOOLS, icon: <NetBeansIcon /> },
  { name: "JBuilder", category: TOOLS, icon: <JBuilderIcon /> },
  { name: "MongoDB", category: TOOLS, icon: <MongoDBIcon /> },
  { name: "Elastic", category: TOOLS, icon: <ElasticSearchIcon /> },
  { name: "MariaDB", category: TOOLS, icon: <MariaDBIcon /> },
  { name: "RedHat", category: TOOLS, icon: <RedHatIcon /> },
  { name: "Red Hat Enterprise Linux", category: TOOLS, icon: <RedHatIcon /> },
  { name: "ASP.NET", category: FRAMEWORKS, icon: <DotNetIcon /> },
  { name: ".NET Core", category: FRAMEWORKS, icon: <DotNetCoreIcon /> },
  { name: ".NETCore", category: FRAMEWORKS, icon: <DotNetCoreIcon /> },
  { name: "Linux", category: FRAMEWORKS, icon: <LinuxIcon /> },
  { name: "Ansible", category: TOOLS, icon: <AnsibleIcon /> },
  { name: "Hashicorp Vault", category: TOOLS, icon: <VaultIcon /> },
  { name: "Vault", category: TOOLS, icon: <VaultIcon /> },
  { name: "Oracle", category: TOOLS, icon: <OracleIcon /> },
  { name: "SASS", category: FRAMEWORKS, icon: <SassIcon /> },
  { name: "Svelte", category: FRAMEWORKS, icon: <SvelteIcon /> },
  { name: "Tailwind", category: FRAMEWORKS, icon: <TailwindIcon /> },
  { name: "Splunk", category: TOOLS, icon: <SplunkIcon /> },
  { name: "Tensorflow", category: FRAMEWORKS, icon: <TensorflowIcon /> },
  { name: "PyTorch", category: FRAMEWORKS, icon: <PyTorchIcon /> },
  { name: "Redis", category: FRAMEWORKS, icon: <RedisIcon /> },
  { name: "Slack", category: TOOLS, icon: <SlackIcon /> },
  { name: "Maven", category: FRAMEWORKS, icon: <MavenIcon /> },
  { name: "NestJS", category: FRAMEWORKS, icon: <NestJsIcon /> },
  { name: "Electron", category: FRAMEWORKS, icon: <ElectronIcon /> },
  { name: "NextJS", category: FRAMEWORKS, icon: <NextJSIcon /> },
  { name: "YAML", category: TOOLS, icon: <YAMLIcon /> },
  { name: "Bootstrap", category: FRAMEWORKS, icon: <BootstrapIcon /> },
  { name: "Openshift", category: TOOLS, icon: <OpenshiftIcon /> },
  { name: "InfluxDb", category: TOOLS, icon: <InfluxDbIcon /> },
  { name: "XUnit", category: TOOLS, icon: <XUnitIcon /> },
  { name: "Helm", category: TOOLS, icon: <HelmIcon /> },
  { name: "HubSpot", category: TOOLS, icon: <HubSpotIcon /> },

  {
    name: "Angular Material",
    category: FRAMEWORKS,
    icon: <AngularMaterialIcon />,
  },
  {
    name: "Material UI",
    category: FRAMEWORKS,
    icon: <MaterialUIIcon />,
  },
  {
    name: "Azure DevOps",
    category: FRAMEWORKS,
    icon: <AzureDevOpsIcon />,
  },
  {
    name: "Azure Cosmos DB",
    category: FRAMEWORKS,
    icon: <AzureCosmosDBIcon />,
  },
  {
    name: "Azure SQL Server",
    category: TOOLS,
    icon: <SQLIcon />,
  },
  {
    name: "SQL Server",
    category: TOOLS,
    icon: <SQLIcon />,
  },
  {
    name: "Gulp",
    category: TOOLS,
    icon: <GulpIcon />,
  },
  {
    name: "Leaflet",
    category: TOOLS,
    icon: <LeafletIcon />,
  },
  {
    name: "Wordpress",
    category: TOOLS,
    icon: <WordpressIcon />,
  },
  {
    name: "GitLab",
    category: TOOLS,
    icon: <GitLabIcon />,
  },
  {
    name: "Blazor",
    category: TOOLS,
    icon: <BlazorIcon />,
  },
  {
    name: "Npm",
    category: TOOLS,
    icon: <NpmIcon />,
  },
  {
    name: "Yarn",
    category: TOOLS,
    icon: <YarnIcon />,
  },
  {
    name: "Bun",
    category: TOOLS,
    icon: <BunIcon />,
  },
  {
    name: "Dynamics 365",
    category: TOOLS,
    icon: <Dynamics365Icon />,
  },

  { name: "DefaultTechIcon", category: FRAMEWORKS, icon: <DefaultTechIcon /> },
  { name: "Claude", category: TOOLS, icon: <ClaudeColorIcon /> },
  { name: "OpenAI", category: TOOLS, icon: <OpenAIIcon /> },
  { name: "ChatGPT", category: TOOLS, icon: <OpenAIIcon /> },
  { name: "Gemini", category: TOOLS, icon: <GeminiColorIcon /> },
  { name: "Grok", category: TOOLS, icon: <GrokIcon /> },
  { name: "Adobe Firefly", category: TOOLS, icon: <AdobeFireflyColorIcon /> },
  { name: "Claude Code", category: TOOLS, icon: <ClaudeCodeColorIcon /> },
  { name: "Codex", category: TOOLS, icon: <CodexColorIcon /> },
  { name: "Cursor", category: TOOLS, icon: <CursorIcon /> },
  { name: "DeepSeek", category: TOOLS, icon: <DeepSeekColorIcon /> },
  { name: "Gemini CLI", category: TOOLS, icon: <GeminiCLIColorIcon /> },
  { name: "GitHub Copilot", category: TOOLS, icon: <GitHubCopilotIcon /> },
  { name: "Ollama", category: TOOLS, icon: <OllamaIcon /> },
  { name: "Snowflake", category: DATABASES, icon: <SnowflakeColorIcon /> },
  { name: "Amplitude", category: TOOLS, icon: <AmplitudeIcon /> },
];

export const AvailableSkillTags = [
  "Java",
  "JavaScript",
  "TypeScript",
  "Swift",
  "Objective-C",
  "AngularJS",
  "Angular",
  "Android",
  "iOS",
  "Scala",
  "C#",
  "F#",
  "Dart",
  "C++",
  "C",
  "Go",
  "Rust",
  "MacOS",
  "Windows",
  "React",
  "React Native",
  ".NET",
  "Grails",
  "Jenkins",
  "Django",
  "Groovy",
  "GraphQL",
  "AWS",
  "Google Cloud",
  "Azure",
  "MS Azure",
  "Heroku",
  "PostgreSQL",
  "MySQL",
  "Photoshop",
  "Sketch",
  "Figma",
  "Illustrator",
  "After Effects",
  "Python",
  "Node.js",
  "D3.js",
  "RabbitMQ",
  "PHP",
  "Laravel",
  "jQuery",
  "XCode",
  "Flutter",
  "Cordova",
  "Apple Pay",
  "Docker",
  "Kubernetes",
  "Terraform",
  "DynamoDB",
  "Dynamo DB",
  "Golang",
  "ViteJS",
  "Vite JS",
  "Vue JS",
  "Vue",
  "VueJS",
  "ReactJS",
  "HTML",
  "CSS",
  "Prometheus",
  "Kibana",
  "Kotlin",
  "Google Cloud",
  "Google Cloud Platform",
  "GCP",
  "Elastic Search",
  "Elastic",
  "Postgres",
  "Jira",
  "GitHub",
  "Notion",
  "Spring",
  "Java Spring",
  "Confluence",
  "Kafka",
  "Apache Kafka",
  "Adobe XD",
  "Perl",
  "Git",
  "SQL",
  "Magneto",
  "Design Sprint",
  "Adobe",
  "Adobe Creative Suite",
  "Axure",
  "UI Design",
  "Graphic Design",
  "JUnit",
  "Cassandra",
  "Grafana",
  "Cucumber",
  "Tomcat",
  "Hibernate",
  "Oracle Database",
  "Spring Boot",
  "Eclipse",
  "NetBeans",
  "JBuilder",
  "MongoDB",
  "MariaDB",
  "RedHat",
  "Red Hat Enterprise Linux",
  "ASP.NET",
  ".NET Core",
  ".NETCore",
  "SASS",
  "Linux",
  "Ansible",
  "Oracle",
  "Svelte",
  "Tailwind",
  "Splunk",
  "Tensorflow",
  "PyTorch",
  "YAML",
  "Bootstrap",
  "Material UI",
  "Angular Material",
  "NextJS",
  "DefaultTechIcon",
  "Claude",
  "OpenAI",
  "ChatGPT",
  "Gemini",
  "Grok",
  "Adobe Firefly",
  "Claude Code",
  "Codex",
  "Cursor",
  "DeepSeek",
  "Gemini CLI",
  "GitHub Copilot",
  "Ollama",
  "Snowflake",
  "Amplitude",
];

const stripAndLowercase = (name: string) => {
  return name.trim().toLowerCase().replace(/\./g, "");
};

const icons: IconItem[] = [
  { name: "rainbow", icon: faRainbow },
  { name: "cubes", icon: faCubes },
  { name: "pen-nib", icon: faPenNib },
  { name: "wand-magic-sparkles", icon: faWandMagicSparkles },
  { name: "object-ungroup", icon: faObjectUngroup },
  { name: "otter", icon: faOtter },
  { name: "laptop-code", icon: faLaptopCode },
  { name: "magnifying-glass-chart", icon: faMagnifyingGlassChart },
  { name: "chart-pie", icon: faChartPie },
  { name: "code-branch", icon: faCodeBranch },
  { name: "site-map", icon: faSitemap },
  { name: "layer-group", icon: faLayerGroup },
  { name: "people-arrows", icon: faPeopleArrows },
  { name: "house-laptop", icon: faLaptopHouse },
  { name: "comments", icon: faComments },
  { name: "clipboard-question", icon: faClipboardQuestion },
  { name: "person-circle-question", icon: faPersonCircleQuestion },
  { name: "users-viewfinder", icon: faUsersViewfinder },
  { name: "handshake", icon: faHandshake },
  { name: "mail-bulk", icon: faMailBulk },
  { name: "bug", icon: faBug },
  { name: "cloud", icon: faCloud },
  { name: "file-lines", icon: faFileLines },
  { name: "server", icon: faServer },
  { name: "people-group", icon: faPeopleGroup },
  { name: "network-wired", icon: faNetworkWired },
  { name: "shield-halved", icon: faShieldHalved },
  { name: "tree", icon: faTree },
  { name: "infinity", icon: faInfinity },
  { name: "rectangle-list", icon: faRectangleList },
  { name: "handshake-angle", icon: faHandshakeAngle },
  { name: "database", icon: faDatabase },
  { name: "map", icon: faMap },
  { name: "sticky-note", icon: faStickyNote },
];

export const getIconByName = (name: string): IconDefinition | undefined => {
  const iconItem = icons.find((item) => item.name === name);
  return iconItem ? iconItem.icon : undefined;
};

export const iconForName = (name: string) => {
  if (
    availableSkills.filter(
      (s) => stripAndLowercase(s.name) === stripAndLowercase(name),
    ).length > 0
  ) {
    return availableSkills.filter(
      (s) => stripAndLowercase(s.name) === stripAndLowercase(name),
    )[0].icon;
  }

  return null;
};

export const categoryForName = (name: string) => {
  if (availableSkills.filter((s) => s.name === name).length > 0) {
    return availableSkills.filter((s) => s.name === name)[0].category;
  }
  return null;
};

export const categoryTitleForCategory = (categoryName: string | null) => {
  if (categoryName === null) {
    return "Other";
  }

  switch (categoryName) {
    case LANGUAGES:
      return "Languages";
    case PLATFORMS:
      return "Platforms";
    case TOOLS:
      return "Tools";
    case DATABASES:
      return "Databases";
    case FRAMEWORKS:
      return "Frameworks & Libraries";
  }
  return "Other";
};

export const availableSkillsForCategory = (categoryName: string): string[] => {
  return availableSkills
    .filter((s) => s.category === categoryName)
    .map((s) => s.name);
};
